const SS = (e, t) => e === t, Qr = /* @__PURE__ */ Symbol("solid-proxy"), _8 = typeof Proxy == "function", Bc = /* @__PURE__ */ Symbol("solid-track"), C1 = {
  equals: SS
};
let x8 = O8;
const Ia = 1, E1 = 2, S8 = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
}, qf = {};
var Et = null;
let Bf = null, CS = null, Bt = null, un = null, $a = null, Rh = 0;
function so(e, t) {
  const r = Bt, n = Et, i = e.length === 0, a = t === void 0 ? n : t, o = i ? S8 : {
    owned: null,
    cleanups: null,
    context: a ? a.context : null,
    owner: a
  }, s = i ? e : () => e(() => Qe(() => Hc(o)));
  Et = o, Bt = null;
  try {
    return Ji(s, !0);
  } finally {
    Bt = r, Et = n;
  }
}
function V(e, t) {
  t = t ? Object.assign({}, C1, t) : C1;
  const r = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, n = (i) => (typeof i == "function" && (i = i(r.value)), T8(r, i));
  return [A8.bind(r), n];
}
function bg(e, t, r) {
  const n = Lh(e, t, !0, Ia);
  yd(n);
}
function se(e, t, r) {
  const n = Lh(e, t, !1, Ia);
  yd(n);
}
function fe(e, t, r) {
  x8 = DS;
  const n = Lh(e, t, !1, Ia);
  (!r || !r.render) && (n.user = !0), $a ? $a.push(n) : yd(n);
}
function K(e, t, r) {
  r = r ? Object.assign({}, C1, r) : C1;
  const n = Lh(e, t, !0, 0);
  return n.observers = null, n.observerSlots = null, n.comparator = r.equals || void 0, yd(n), A8.bind(n);
}
function ES(e) {
  return e && typeof e == "object" && "then" in e;
}
function C8(e, t, r) {
  let n, i, a;
  typeof t == "function" ? (n = e, i = t, a = {}) : (n = !0, i = e, a = t || {});
  let o = null, s = qf, l = !1, d = "initialValue" in a, c = typeof n == "function" && K(n);
  const u = /* @__PURE__ */ new Set(), [h, f] = (a.storage || V)(a.initialValue), [p, m] = V(void 0), [y, v] = V(void 0, {
    equals: !1
  }), [b, $] = V(d ? "ready" : "unresolved");
  function _(P, D, T, I) {
    return o === P && (o = null, I !== void 0 && (d = !0), (P === s || D === s) && a.onHydrated && queueMicrotask(() => a.onHydrated(I, {
      value: D
    })), s = qf, x(D, T)), D;
  }
  function x(P, D) {
    Ji(() => {
      D === void 0 && f(() => P), $(D !== void 0 ? "errored" : d ? "ready" : "unresolved"), m(D);
      for (const T of u.keys()) T.decrement();
      u.clear();
    }, !1);
  }
  function S() {
    const P = IS, D = h(), T = p();
    if (T !== void 0 && !o) throw T;
    return Bt && Bt.user, D;
  }
  function A(P = !0) {
    if (P !== !1 && l) return;
    l = !1;
    const D = c ? c() : n;
    if (D == null || D === !1) {
      _(o, Qe(h));
      return;
    }
    let T;
    const I = s !== qf ? s : Qe(() => {
      try {
        return i(D, {
          value: h(),
          refetching: P
        });
      } catch (j) {
        T = j;
      }
    });
    if (T !== void 0) {
      _(o, void 0, e1(T), D);
      return;
    } else if (!ES(I))
      return _(o, I, void 0, D), I;
    return o = I, "v" in I ? (I.s === 1 ? _(o, I.v, void 0, D) : _(o, void 0, e1(I.v), D), I) : (l = !0, queueMicrotask(() => l = !1), Ji(() => {
      $(d ? "refreshing" : "pending"), v();
    }, !1), I.then((j) => _(I, j, void 0, D), (j) => _(I, void 0, e1(j), D)));
  }
  Object.defineProperties(S, {
    state: {
      get: () => b()
    },
    error: {
      get: () => p()
    },
    loading: {
      get() {
        const P = b();
        return P === "pending" || P === "refreshing";
      }
    },
    latest: {
      get() {
        if (!d) return S();
        const P = p();
        if (P && !o) throw P;
        return h();
      }
    }
  });
  let N = Et;
  return c ? bg(() => (N = Et, A(!1))) : A(!1), [S, {
    refetch: (P) => E8(N, () => A(P)),
    mutate: f
  }];
}
function A1(e) {
  return Ji(e, !1);
}
function Qe(e) {
  if (Bt === null) return e();
  const t = Bt;
  Bt = null;
  try {
    return e();
  } finally {
    Bt = t;
  }
}
function lr(e) {
  fe(() => Qe(e));
}
function sr(e) {
  return Et === null || (Et.cleanups === null ? Et.cleanups = [e] : Et.cleanups.push(e)), e;
}
function Ql() {
  return Bt;
}
function Ve() {
  return Et;
}
function E8(e, t) {
  const r = Et, n = Bt;
  Et = e, Bt = null;
  try {
    return Ji(t, !0);
  } catch (i) {
    $g(i);
  } finally {
    Et = r, Bt = n;
  }
}
function AS(e) {
  const t = Bt, r = Et;
  return Promise.resolve().then(() => {
    Bt = t, Et = r;
    let n;
    return Ji(e, !1), Bt = Et = null, n ? n.done : void 0;
  });
}
const [TS, _fe] = /* @__PURE__ */ V(!1);
function OS() {
  return [TS, AS];
}
function Gr(e, t) {
  const r = /* @__PURE__ */ Symbol("context");
  return {
    id: r,
    Provider: MS(r),
    defaultValue: e
  };
}
function wr(e) {
  let t;
  return Et && Et.context && (t = Et.context[e.id]) !== void 0 ? t : e.defaultValue;
}
function wg(e) {
  const t = K(e), r = K(() => Np(t()));
  return r.toArray = () => {
    const n = r();
    return Array.isArray(n) ? n : n != null ? [n] : [];
  }, r;
}
let IS;
function A8() {
  if (this.sources && this.state)
    if (this.state === Ia) yd(this);
    else {
      const e = un;
      un = null, Ji(() => O1(this), !1), un = e;
    }
  if (Bt) {
    const e = this.observers ? this.observers.length : 0;
    Bt.sources ? (Bt.sources.push(this), Bt.sourceSlots.push(e)) : (Bt.sources = [this], Bt.sourceSlots = [e]), this.observers ? (this.observers.push(Bt), this.observerSlots.push(Bt.sources.length - 1)) : (this.observers = [Bt], this.observerSlots = [Bt.sources.length - 1]);
  }
  return this.value;
}
function T8(e, t, r) {
  let n = e.value;
  return (!e.comparator || !e.comparator(n, t)) && (e.value = t, e.observers && e.observers.length && Ji(() => {
    for (let i = 0; i < e.observers.length; i += 1) {
      const a = e.observers[i], o = Bf && Bf.running;
      o && Bf.disposed.has(a), (o ? !a.tState : !a.state) && (a.pure ? un.push(a) : $a.push(a), a.observers && I8(a)), o || (a.state = Ia);
    }
    if (un.length > 1e6)
      throw un = [], new Error();
  }, !1)), t;
}
function yd(e) {
  if (!e.fn) return;
  Hc(e);
  const t = Rh;
  PS(e, e.value, t);
}
function PS(e, t, r) {
  let n;
  const i = Et, a = Bt;
  Bt = Et = e;
  try {
    n = e.fn(t);
  } catch (o) {
    return e.pure && (e.state = Ia, e.owned && e.owned.forEach(Hc), e.owned = null), e.updatedAt = r + 1, $g(o);
  } finally {
    Bt = a, Et = i;
  }
  (!e.updatedAt || e.updatedAt <= r) && (e.updatedAt != null && "observers" in e ? T8(e, n) : e.value = n, e.updatedAt = r);
}
function Lh(e, t, r, n = Ia, i) {
  const a = {
    fn: e,
    state: n,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: Et,
    context: Et ? Et.context : null,
    pure: r
  };
  return Et === null || Et !== S8 && (Et.owned ? Et.owned.push(a) : Et.owned = [a]), a;
}
function T1(e) {
  if (e.state === 0) return;
  if (e.state === E1) return O1(e);
  if (e.suspense && Qe(e.suspense.inFallback)) return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < Rh); )
    e.state && t.push(e);
  for (let r = t.length - 1; r >= 0; r--)
    if (e = t[r], e.state === Ia)
      yd(e);
    else if (e.state === E1) {
      const n = un;
      un = null, Ji(() => O1(e, t[0]), !1), un = n;
    }
}
function Ji(e, t) {
  if (un) return e();
  let r = !1;
  t || (un = []), $a ? r = !0 : $a = [], Rh++;
  try {
    const n = e();
    return NS(r), n;
  } catch (n) {
    r || ($a = null), un = null, $g(n);
  }
}
function NS(e) {
  if (un && (O8(un), un = null), e) return;
  const t = $a;
  $a = null, t.length && Ji(() => x8(t), !1);
}
function O8(e) {
  for (let t = 0; t < e.length; t++) T1(e[t]);
}
function DS(e) {
  let t, r = 0;
  for (t = 0; t < e.length; t++) {
    const n = e[t];
    n.user ? e[r++] = n : T1(n);
  }
  for (t = 0; t < r; t++) T1(e[t]);
}
function O1(e, t) {
  e.state = 0;
  for (let r = 0; r < e.sources.length; r += 1) {
    const n = e.sources[r];
    if (n.sources) {
      const i = n.state;
      i === Ia ? n !== t && (!n.updatedAt || n.updatedAt < Rh) && T1(n) : i === E1 && O1(n, t);
    }
  }
}
function I8(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const r = e.observers[t];
    r.state || (r.state = E1, r.pure ? un.push(r) : $a.push(r), r.observers && I8(r));
  }
}
function Hc(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const r = e.sources.pop(), n = e.sourceSlots.pop(), i = r.observers;
      if (i && i.length) {
        const a = i.pop(), o = r.observerSlots.pop();
        n < i.length && (a.sourceSlots[o] = n, i[n] = a, r.observerSlots[n] = o);
      }
    }
  if (e.tOwned) {
    for (t = e.tOwned.length - 1; t >= 0; t--) Hc(e.tOwned[t]);
    delete e.tOwned;
  }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--) Hc(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--) e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function e1(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function $g(e, t = Et) {
  throw e1(e);
}
function Np(e) {
  if (typeof e == "function" && !e.length) return Np(e());
  if (Array.isArray(e)) {
    const t = [];
    for (let r = 0; r < e.length; r++) {
      const n = Np(e[r]);
      Array.isArray(n) ? t.push.apply(t, n) : t.push(n);
    }
    return t;
  }
  return e;
}
function MS(e, t) {
  return function(n) {
    let i;
    return se(() => i = Qe(() => (Et.context = {
      ...Et.context,
      [e]: n.value
    }, wg(() => n.children))), void 0), i;
  };
}
const RS = /* @__PURE__ */ Symbol("fallback");
function Pv(e) {
  for (let t = 0; t < e.length; t++) e[t]();
}
function LS(e, t, r = {}) {
  let n = [], i = [], a = [], o = 0, s = t.length > 1 ? [] : null;
  return sr(() => Pv(a)), () => {
    let l = e() || [], d = l.length, c, u;
    return l[Bc], Qe(() => {
      let f, p, m, y, v, b, $, _, x;
      if (d === 0)
        o !== 0 && (Pv(a), a = [], n = [], i = [], o = 0, s && (s = [])), r.fallback && (n = [RS], i[0] = so((S) => (a[0] = S, r.fallback())), o = 1);
      else if (o === 0) {
        for (i = new Array(d), u = 0; u < d; u++)
          n[u] = l[u], i[u] = so(h);
        o = d;
      } else {
        for (m = new Array(d), y = new Array(d), s && (v = new Array(d)), b = 0, $ = Math.min(o, d); b < $ && n[b] === l[b]; b++) ;
        for ($ = o - 1, _ = d - 1; $ >= b && _ >= b && n[$] === l[_]; $--, _--)
          m[_] = i[$], y[_] = a[$], s && (v[_] = s[$]);
        for (f = /* @__PURE__ */ new Map(), p = new Array(_ + 1), u = _; u >= b; u--)
          x = l[u], c = f.get(x), p[u] = c === void 0 ? -1 : c, f.set(x, u);
        for (c = b; c <= $; c++)
          x = n[c], u = f.get(x), u !== void 0 && u !== -1 ? (m[u] = i[c], y[u] = a[c], s && (v[u] = s[c]), u = p[u], f.set(x, u)) : a[c]();
        for (u = b; u < d; u++)
          u in m ? (i[u] = m[u], a[u] = y[u], s && (s[u] = v[u], s[u](u))) : i[u] = so(h);
        i = i.slice(0, o = d), n = l.slice(0);
      }
      return i;
    });
    function h(f) {
      if (a[u] = f, s) {
        const [p, m] = V(u);
        return s[u] = m, t(l[u], p);
      }
      return t(l[u]);
    }
  };
}
function g(e, t) {
  return Qe(() => e(t || {}));
}
function c0() {
  return !0;
}
const Dp = {
  get(e, t, r) {
    return t === Qr ? r : e.get(t);
  },
  has(e, t) {
    return t === Qr ? !0 : e.has(t);
  },
  set: c0,
  deleteProperty: c0,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: c0,
      deleteProperty: c0
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function Hf(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function FS() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const r = this[e]();
    if (r !== void 0) return r;
  }
}
function it(...e) {
  let t = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    t = t || !!s && Qr in s, e[o] = typeof s == "function" ? (t = !0, K(s)) : s;
  }
  if (_8 && t)
    return new Proxy({
      get(o) {
        for (let s = e.length - 1; s >= 0; s--) {
          const l = Hf(e[s])[o];
          if (l !== void 0) return l;
        }
      },
      has(o) {
        for (let s = e.length - 1; s >= 0; s--)
          if (o in Hf(e[s])) return !0;
        return !1;
      },
      keys() {
        const o = [];
        for (let s = 0; s < e.length; s++) o.push(...Object.keys(Hf(e[s])));
        return [...new Set(o)];
      }
    }, Dp);
  const r = {}, n = /* @__PURE__ */ Object.create(null);
  for (let o = e.length - 1; o >= 0; o--) {
    const s = e[o];
    if (!s) continue;
    const l = Object.getOwnPropertyNames(s);
    for (let d = l.length - 1; d >= 0; d--) {
      const c = l[d];
      if (c === "__proto__" || c === "constructor") continue;
      const u = Object.getOwnPropertyDescriptor(s, c);
      if (!n[c])
        n[c] = u.get ? {
          enumerable: !0,
          configurable: !0,
          get: FS.bind(r[c] = [u.get.bind(s)])
        } : u.value !== void 0 ? u : void 0;
      else {
        const h = r[c];
        h && (u.get ? h.push(u.get.bind(s)) : u.value !== void 0 && h.push(() => u.value));
      }
    }
  }
  const i = {}, a = Object.keys(n);
  for (let o = a.length - 1; o >= 0; o--) {
    const s = a[o], l = n[s];
    l && l.get ? Object.defineProperty(i, s, l) : i[s] = l ? l.value : void 0;
  }
  return i;
}
function go(e, ...t) {
  const r = t.length;
  if (_8 && Qr in e) {
    const i = r > 1 ? t.flat() : t[0], a = t.map((o) => new Proxy({
      get(s) {
        return o.includes(s) ? e[s] : void 0;
      },
      has(s) {
        return o.includes(s) && s in e;
      },
      keys() {
        return o.filter((s) => s in e);
      }
    }, Dp));
    return a.push(new Proxy({
      get(o) {
        return i.includes(o) ? void 0 : e[o];
      },
      has(o) {
        return i.includes(o) ? !1 : o in e;
      },
      keys() {
        return Object.keys(e).filter((o) => !i.includes(o));
      }
    }, Dp)), a;
  }
  const n = [];
  for (let i = 0; i <= r; i++)
    n[i] = {};
  for (const i of Object.getOwnPropertyNames(e)) {
    let a = r;
    for (let l = 0; l < t.length; l++)
      if (t[l].includes(i)) {
        a = l;
        break;
      }
    const o = Object.getOwnPropertyDescriptor(e, i);
    !o.get && !o.set && o.enumerable && o.writable && o.configurable ? n[a][i] = o.value : Object.defineProperty(n[a], i, o);
  }
  return n;
}
let jS = 0;
function va() {
  return `cl-${jS++}`;
}
const P8 = (e) => `Stale read from <${e}>.`;
function yt(e) {
  const t = "fallback" in e && {
    fallback: () => e.fallback
  };
  return K(LS(() => e.each, e.children, t || void 0));
}
function H(e) {
  const t = e.keyed, r = K(() => e.when, void 0, void 0), n = t ? r : K(r, void 0, {
    equals: (i, a) => !i == !a
  });
  return K(() => {
    const i = n();
    if (i) {
      const a = e.children;
      return typeof a == "function" && a.length > 0 ? Qe(() => a(t ? i : () => {
        if (!Qe(n)) throw P8("Show");
        return r();
      })) : a;
    }
    return e.fallback;
  }, void 0, void 0);
}
function Fh(e) {
  const t = wg(() => e.children), r = K(() => {
    const n = t(), i = Array.isArray(n) ? n : [n];
    let a = () => {
    };
    for (let o = 0; o < i.length; o++) {
      const s = o, l = i[o], d = a, c = K(() => d() ? void 0 : l.when, void 0, void 0), u = l.keyed ? c : K(c, void 0, {
        equals: (h, f) => !h == !f
      });
      a = () => d() || (u() ? [s, c, l] : void 0);
    }
    return a;
  });
  return K(() => {
    const n = r()();
    if (!n) return e.fallback;
    const [i, a, o] = n, s = o.children;
    return typeof s == "function" && s.length > 0 ? Qe(() => s(o.keyed ? a() : () => {
      if (Qe(r)()?.[0] !== i) throw P8("Match");
      return a();
    })) : s;
  }, void 0, void 0);
}
function ri(e) {
  return e;
}
const zS = [
  "allowfullscreen",
  "async",
  "alpha",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected",
  "adauctionheaders",
  "browsingtopics",
  "credentialless",
  "defaultchecked",
  "defaultmuted",
  "defaultselected",
  "defer",
  "disablepictureinpicture",
  "disableremoteplayback",
  "preservespitch",
  "shadowrootclonable",
  "shadowrootcustomelementregistry",
  "shadowrootdelegatesfocus",
  "shadowrootserializable",
  "sharedstoragewritable"
], VS = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "noValidate",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  "adAuctionHeaders",
  "allowFullscreen",
  "browsingTopics",
  "defaultChecked",
  "defaultMuted",
  "defaultSelected",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "preservesPitch",
  "shadowRootClonable",
  "shadowRootCustomElementRegistry",
  "shadowRootDelegatesFocus",
  "shadowRootSerializable",
  "sharedStorageWritable",
  ...zS
]), US = /* @__PURE__ */ new Set(["innerHTML", "textContent", "innerText", "children"]), qS = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), BS = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  novalidate: {
    $: "noValidate",
    FORM: 1
  },
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  },
  adauctionheaders: {
    $: "adAuctionHeaders",
    IFRAME: 1
  },
  allowfullscreen: {
    $: "allowFullscreen",
    IFRAME: 1
  },
  browsingtopics: {
    $: "browsingTopics",
    IMG: 1
  },
  defaultchecked: {
    $: "defaultChecked",
    INPUT: 1
  },
  defaultmuted: {
    $: "defaultMuted",
    AUDIO: 1,
    VIDEO: 1
  },
  defaultselected: {
    $: "defaultSelected",
    OPTION: 1
  },
  disablepictureinpicture: {
    $: "disablePictureInPicture",
    VIDEO: 1
  },
  disableremoteplayback: {
    $: "disableRemotePlayback",
    AUDIO: 1,
    VIDEO: 1
  },
  preservespitch: {
    $: "preservesPitch",
    AUDIO: 1,
    VIDEO: 1
  },
  shadowrootclonable: {
    $: "shadowRootClonable",
    TEMPLATE: 1
  },
  shadowrootdelegatesfocus: {
    $: "shadowRootDelegatesFocus",
    TEMPLATE: 1
  },
  shadowrootserializable: {
    $: "shadowRootSerializable",
    TEMPLATE: 1
  },
  sharedstoragewritable: {
    $: "sharedStorageWritable",
    IFRAME: 1,
    IMG: 1
  }
});
function HS(e, t) {
  const r = BS[e];
  return typeof r == "object" ? r[t] ? r.$ : void 0 : r;
}
const WS = /* @__PURE__ */ new Set(["beforeinput", "click", "dblclick", "contextmenu", "focusin", "focusout", "input", "keydown", "keyup", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "pointerdown", "pointermove", "pointerout", "pointerover", "pointerup", "touchend", "touchmove", "touchstart"]), QS = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), KS = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
}, At = (e) => K(() => e());
function GS(e, t, r) {
  let n = r.length, i = t.length, a = n, o = 0, s = 0, l = t[i - 1].nextSibling, d = null;
  for (; o < i || s < a; ) {
    if (t[o] === r[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === r[a - 1]; )
      i--, a--;
    if (i === o) {
      const c = a < n ? s ? r[s - 1].nextSibling : r[a - s] : l;
      for (; s < a; ) e.insertBefore(r[s++], c);
    } else if (a === s)
      for (; o < i; )
        (!d || !d.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === r[a - 1] && r[s] === t[i - 1]) {
      const c = t[--i].nextSibling;
      e.insertBefore(r[s++], t[o++].nextSibling), e.insertBefore(r[--a], c), t[i] = r[a];
    } else {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        let u = s;
        for (; u < a; ) d.set(r[u], u++);
      }
      const c = d.get(t[o]);
      if (c != null)
        if (s < c && c < a) {
          let u = o, h = 1, f;
          for (; ++u < i && u < a && !((f = d.get(t[u])) == null || f !== c + h); )
            h++;
          if (h > c - s) {
            const p = t[o];
            for (; s < c; ) e.insertBefore(r[s++], p);
          } else e.replaceChild(r[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const Nv = "_$DX_DELEGATE";
function ae(e, t, r, n) {
  let i;
  const a = () => {
    const s = n ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, r ? s.content.firstChild.firstChild : n ? s.firstChild : s.content.firstChild;
  }, o = t ? () => Qe(() => document.importNode(i || (i = a()), !0)) : () => (i || (i = a())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function Rs(e, t = window.document) {
  const r = t[Nv] || (t[Nv] = /* @__PURE__ */ new Set());
  for (let n = 0, i = e.length; n < i; n++) {
    const a = e[n];
    r.has(a) || (r.add(a), t.addEventListener(a, rC));
  }
}
function Wc(e, t, r) {
  r == null ? e.removeAttribute(t) : e.setAttribute(t, r);
}
function ZS(e, t, r, n) {
  n == null ? e.removeAttributeNS(t, r) : e.setAttributeNS(t, r, n);
}
function YS(e, t, r) {
  r ? e.setAttribute(t, "") : e.removeAttribute(t);
}
function ka(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Ue(e, t, r, n) {
  if (n)
    Array.isArray(r) ? (e[`$$${t}`] = r[0], e[`$$${t}Data`] = r[1]) : e[`$$${t}`] = r;
  else if (Array.isArray(r)) {
    const i = r[0];
    e.addEventListener(t, r[0] = (a) => i.call(e, r[1], a));
  } else e.addEventListener(t, r, typeof r != "function" && r);
}
function JS(e, t, r = {}) {
  const n = Object.keys(t || {}), i = Object.keys(r);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || t[s] || (Dv(e, s, !1), delete r[s]);
  }
  for (a = 0, o = n.length; a < o; a++) {
    const s = n[a], l = !!t[s];
    !s || s === "undefined" || r[s] === l || !l || (Dv(e, s, !0), r[s] = l);
  }
  return r;
}
function N8(e, t, r) {
  if (!t) return r ? Wc(e, "style") : t;
  const n = e.style;
  if (typeof t == "string") return n.cssText = t;
  typeof r == "string" && (n.cssText = r = void 0), r || (r = {}), t || (t = {});
  let i, a;
  for (a in r)
    t[a] == null && n.removeProperty(a), delete r[a];
  for (a in t)
    i = t[a], i !== r[a] && (n.setProperty(a, i), r[a] = i);
  return r;
}
function XS(e, t = {}, r, n) {
  const i = {};
  return se(() => i.children = Qc(e, t.children, i.children)), se(() => typeof t.ref == "function" && Zt(t.ref, e)), se(() => eC(e, t, r, !0, i, !0)), i;
}
function Zt(e, t, r) {
  return Qe(() => e(t, r));
}
function L(e, t, r, n) {
  if (r !== void 0 && !n && (n = []), typeof t != "function") return Qc(e, t, n, r);
  se((i) => Qc(e, t(), i, r), n);
}
function eC(e, t, r, n, i = {}, a = !1) {
  t || (t = {});
  for (const o in i)
    if (!(o in t)) {
      if (o === "children") continue;
      i[o] = Mv(e, o, null, i[o], r, a, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    i[o] = Mv(e, o, s, i[o], r, a, t);
  }
}
function tC(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, r) => r.toUpperCase());
}
function Dv(e, t, r) {
  const n = t.trim().split(/\s+/);
  for (let i = 0, a = n.length; i < a; i++) e.classList.toggle(n[i], r);
}
function Mv(e, t, r, n, i, a, o) {
  let s, l, d, c, u;
  if (t === "style") return N8(e, r, n);
  if (t === "classList") return JS(e, r, n);
  if (r === n) return n;
  if (t === "ref")
    a || r(e);
  else if (t.slice(0, 3) === "on:") {
    const h = t.slice(3);
    n && e.removeEventListener(h, n, typeof n != "function" && n), r && e.addEventListener(h, r, typeof r != "function" && r);
  } else if (t.slice(0, 10) === "oncapture:") {
    const h = t.slice(10);
    n && e.removeEventListener(h, n, !0), r && e.addEventListener(h, r, !0);
  } else if (t.slice(0, 2) === "on") {
    const h = t.slice(2).toLowerCase(), f = WS.has(h);
    if (!f && n) {
      const p = Array.isArray(n) ? n[0] : n;
      e.removeEventListener(h, p);
    }
    (f || r) && (Ue(e, h, r, f), f && Rs([h]));
  } else if (t.slice(0, 5) === "attr:")
    Wc(e, t.slice(5), r);
  else if (t.slice(0, 5) === "bool:")
    YS(e, t.slice(5), r);
  else if ((u = t.slice(0, 5) === "prop:") || (d = US.has(t)) || !i && ((c = HS(t, e.tagName)) || (l = VS.has(t))) || (s = e.nodeName.includes("-") || "is" in o))
    u && (t = t.slice(5), l = !0), t === "class" || t === "className" ? ka(e, r) : s && !l && !d ? e[tC(t)] = r : e[c || t] = r;
  else {
    const h = i && t.indexOf(":") > -1 && KS[t.split(":")[0]];
    h ? ZS(e, h, t, r) : Wc(e, qS[t] || t, r);
  }
  return r;
}
function rC(e) {
  let t = e.target;
  const r = `$$${e.type}`, n = e.target, i = e.currentTarget, a = (l) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: l
  }), o = () => {
    const l = t[r];
    if (l && !t.disabled) {
      const d = t[`${r}Data`];
      if (d !== void 0 ? l.call(t, d, e) : l.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && a(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), e.composedPath) {
    const l = e.composedPath();
    a(l[0]);
    for (let d = 0; d < l.length - 2 && (t = l[d], !!o()); d++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === i)
        break;
    }
  } else s();
  a(n);
}
function Qc(e, t, r, n, i) {
  for (; typeof r == "function"; ) r = r();
  if (t === r) return r;
  const a = typeof t, o = n !== void 0;
  if (e = o && r[0] && r[0].parentNode || e, a === "string" || a === "number") {
    if (a === "number" && (t = t.toString(), t === r))
      return r;
    if (o) {
      let s = r[0];
      s && s.nodeType === 3 ? s.data !== t && (s.data = t) : s = document.createTextNode(t), r = Hs(e, r, n, s);
    } else
      r !== "" && typeof r == "string" ? r = e.firstChild.data = t : r = e.textContent = t;
  } else if (t == null || a === "boolean")
    r = Hs(e, r, n);
  else {
    if (a === "function")
      return se(() => {
        let s = t();
        for (; typeof s == "function"; ) s = s();
        r = Qc(e, s, r, n);
      }), () => r;
    if (Array.isArray(t)) {
      const s = [], l = r && Array.isArray(r);
      if (Mp(s, t, r, i))
        return se(() => r = Qc(e, s, r, n, !0)), () => r;
      if (s.length === 0) {
        if (r = Hs(e, r, n), o) return r;
      } else l ? r.length === 0 ? Rv(e, s, n) : GS(e, r, s) : (r && Hs(e), Rv(e, s));
      r = s;
    } else if (t.nodeType) {
      if (Array.isArray(r)) {
        if (o) return r = Hs(e, r, n, t);
        Hs(e, r, null, t);
      } else r == null || r === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      r = t;
    }
  }
  return r;
}
function Mp(e, t, r, n) {
  let i = !1;
  for (let a = 0, o = t.length; a < o; a++) {
    let s = t[a], l = r && r[e.length], d;
    if (!(s == null || s === !0 || s === !1)) if ((d = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      i = Mp(e, s, l) || i;
    else if (d === "function")
      if (n) {
        for (; typeof s == "function"; ) s = s();
        i = Mp(e, Array.isArray(s) ? s : [s], Array.isArray(l) ? l : [l]) || i;
      } else
        e.push(s), i = !0;
    else {
      const c = String(s);
      l && l.nodeType === 3 && l.data === c ? e.push(l) : e.push(document.createTextNode(c));
    }
  }
  return i;
}
function Rv(e, t, r = null) {
  for (let n = 0, i = t.length; n < i; n++) e.insertBefore(t[n], r);
}
function Hs(e, t, r, n) {
  if (r === void 0) return e.textContent = "";
  const i = n || document.createTextNode("");
  if (t.length) {
    let a = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const l = s.parentNode === e;
        !a && !o ? l ? e.replaceChild(i, s) : e.insertBefore(i, r) : l && s.remove();
      } else a = !0;
    }
  } else e.insertBefore(i, r);
  return [i];
}
const nC = "http://www.w3.org/2000/svg";
function D8(e, t = !1, r = void 0) {
  return t ? document.createElementNS(nC, e) : document.createElement(e, {
    is: r
  });
}
function iC(e) {
  const {
    useShadow: t
  } = e, r = document.createTextNode(""), n = () => e.mount || document.body, i = Ve();
  let a;
  return fe(() => {
    a || (a = E8(i, () => K(() => e.children)));
    const o = n();
    if (o instanceof HTMLHeadElement) {
      const [s, l] = V(!1), d = () => l(!0);
      so((c) => L(o, () => s() ? c() : a(), null)), sr(d);
    } else {
      const s = D8(e.isSVG ? "g" : "div", e.isSVG), l = t && s.attachShadow ? s.attachShadow({
        mode: "open"
      }) : s;
      Object.defineProperty(s, "_$host", {
        get() {
          return r.parentNode;
        },
        configurable: !0
      }), L(l, a), o.appendChild(s), e.ref && e.ref(s), sr(() => o.removeChild(s));
    }
  }, void 0, {
    render: !0
  }), r;
}
function aC(e, t) {
  const r = K(e);
  return K(() => {
    const n = r();
    switch (typeof n) {
      case "function":
        return Qe(() => n(t));
      case "string":
        const i = QS.has(n), a = D8(n, i, Qe(() => t.is));
        return XS(a, t, i), a;
    }
  });
}
function oC(e) {
  const [, t] = go(e, ["component"]);
  return aC(() => e.component, t);
}
function sC(e) {
  return Object.keys(e).reduce((r, n) => {
    const i = e[n];
    return r[n] = Object.assign({}, i), R8(i.value) && !hC(i.value) && !Array.isArray(i.value) && (r[n].value = Object.assign({}, i.value)), Array.isArray(i.value) && (r[n].value = i.value.slice(0)), r;
  }, {});
}
function lC(e) {
  return e ? Object.keys(e).reduce((r, n) => {
    const i = e[n];
    return r[n] = R8(i) && "value" in i ? i : {
      value: i
    }, r[n].attribute || (r[n].attribute = uC(n)), r[n].parse = "parse" in r[n] ? r[n].parse : typeof r[n].value != "string", r;
  }, {}) : {};
}
function dC(e) {
  return Object.keys(e).reduce((r, n) => (r[n] = e[n].value, r), {});
}
function cC(e, t) {
  const r = sC(t);
  return Object.keys(t).forEach((i) => {
    const a = r[i], o = e.getAttribute(a.attribute), s = e[i];
    o != null && (a.value = a.parse ? M8(o) : o), s != null && (a.value = Array.isArray(s) ? s.slice(0) : s), a.reflect && Lv(e, a.attribute, a.value, !!a.parse), Object.defineProperty(e, i, {
      get() {
        return a.value;
      },
      set(l) {
        const d = a.value;
        a.value = l, a.reflect && Lv(this, a.attribute, a.value, !!a.parse);
        for (let c = 0, u = this.__propertyChangedCallbacks.length; c < u; c++)
          this.__propertyChangedCallbacks[c](i, l, d);
      },
      enumerable: !0,
      configurable: !0
    });
  }), r;
}
function M8(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function Lv(e, t, r, n) {
  if (r == null || r === !1) return e.removeAttribute(t);
  let i = n ? JSON.stringify(r) : r;
  e.__updating[t] = !0, i === "true" && (i = ""), e.setAttribute(t, i), Promise.resolve().then(() => delete e.__updating[t]);
}
function uC(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, r) => "-" + r.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function R8(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function hC(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function fC(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let Wf;
function pC(e, t) {
  const r = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return r.map((i) => t[i].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized) return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = cC(this, t);
      const i = dC(this.props), a = this.Component, o = Wf;
      try {
        Wf = this, this.__initialized = !0, fC(a) ? new a(i, {
          element: this
        }) : a(i, {
          element: this
        });
      } finally {
        Wf = o;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected) return;
      this.__propertyChangedCallbacks.length = 0;
      let i = null;
      for (; i = this.__releaseCallbacks.pop(); ) i(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(i, a, o) {
      if (this.__initialized && !this.__updating[i] && (i = this.lookupProp(i), i in t)) {
        if (o == null && !this[i]) return;
        this[i] = t[i].parse ? M8(o) : o;
      }
    }
    lookupProp(i) {
      if (t)
        return r.find((a) => i === a || i === t[a].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(i) {
      this.__releaseCallbacks.push(i);
    }
    addPropertyChangedCallback(i) {
      this.__propertyChangedCallbacks.push(i);
    }
  };
}
function mC(e, t = {}, r = {}) {
  const {
    BaseElement: n = HTMLElement,
    extension: i,
    customElements: a = window.customElements
  } = r;
  return (o) => {
    if (!e) throw new Error("tag is required to register a Component");
    let s = a.get(e);
    return s ? (s.prototype.Component = o, s) : (s = pC(n, lC(t)), s.prototype.Component = o, s.prototype.registeredTag = e, a.define(e, s, i), s);
  };
}
function gC(e) {
  const t = Object.keys(e), r = {};
  for (let n = 0; n < t.length; n++) {
    const [i, a] = V(e[t[n]]);
    Object.defineProperty(r, t[n], {
      get: i,
      set(o) {
        a(() => o);
      }
    });
  }
  return r;
}
function vC(e) {
  if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function yC(e) {
  return (t, r) => {
    const { element: n } = r;
    return so((i) => {
      const a = gC(t);
      n.addPropertyChangedCallback((s, l) => a[s] = l), n.addReleaseCallback(() => {
        n.renderRoot.textContent = "", i();
      });
      const o = e(a, r);
      return L(n.renderRoot, o);
    }, vC(n));
  };
}
function Dn(e, t, r) {
  return arguments.length === 2 && (r = t, t = {}), mC(e, t)(yC(r));
}
var Rp = function(e, t) {
  return Rp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Rp(e, t);
};
function ia(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Rp(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var z = function() {
  return z = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, z.apply(this, arguments);
};
function xi(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Xe(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(c) {
      try {
        d(n.next(c));
      } catch (u) {
        o(u);
      }
    }
    function l(c) {
      try {
        d(n.throw(c));
      } catch (u) {
        o(u);
      }
    }
    function d(c) {
      c.done ? a(c.value) : i(c.value).then(s, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function Ka(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(d) {
    return function(c) {
      return l([d, c]);
    };
  }
  function l(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, d[0] && (r = 0)), r; ) try {
      if (n = 1, i && (a = d[0] & 2 ? i.return : d[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, d[1])).done) return a;
      switch (i = 0, a && (d = [d[0] & 2, a.value]), d[0]) {
        case 0:
        case 1:
          a = d;
          break;
        case 4:
          return r.label++, { value: d[1], done: !1 };
        case 5:
          r.label++, i = d[1], d = [0];
          continue;
        case 7:
          d = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            r = 0;
            continue;
          }
          if (d[0] === 3 && (!a || d[1] > a[0] && d[1] < a[3])) {
            r.label = d[1];
            break;
          }
          if (d[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = d;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(d);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      d = t.call(e, r);
    } catch (c) {
      d = [6, c], i = 0;
    } finally {
      n = a = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function rn(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, a; n < i; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function fi(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (n = Object.getOwnPropertySymbols(e); i < n.length; i++) t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  }
  return r;
}
const bC = { timeoutInSeconds: 60 }, L8 = { name: "auth0-spa-js", version: "2.17.0" }, F8 = () => Date.now();
let ur = class Lp extends Error {
  constructor(t, r) {
    super(r), this.error = t, this.error_description = r, Object.setPrototypeOf(this, Lp.prototype);
  }
  static fromPayload(t) {
    let { error: r, error_description: n } = t;
    return new Lp(r, n);
  }
}, wC = class j8 extends ur {
  constructor(t, r, n) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    super(t, r), this.state = n, this.appState = i, Object.setPrototypeOf(this, j8.prototype);
  }
}, $C = class z8 extends ur {
  constructor(t, r, n, i) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    super(t, r), this.connection = n, this.state = i, this.appState = a, Object.setPrototypeOf(this, z8.prototype);
  }
}, jh = class V8 extends ur {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, V8.prototype);
  }
}, kC = class U8 extends jh {
  constructor(t) {
    super(), this.popup = t, Object.setPrototypeOf(this, U8.prototype);
  }
}, _C = class q8 extends ur {
  constructor(t) {
    super("cancelled", "Popup closed"), this.popup = t, Object.setPrototypeOf(this, q8.prototype);
  }
}, xC = class B8 extends ur {
  constructor() {
    super("popup_open", "Unable to open a popup for loginWithPopup - window.open returned `null`"), Object.setPrototypeOf(this, B8.prototype);
  }
}, I1 = class H8 extends ur {
  constructor(t, r, n, i) {
    super(t, r), this.mfa_token = n, this.mfa_requirements = i, Object.setPrototypeOf(this, H8.prototype);
  }
}, W8 = class Q8 extends ur {
  constructor(t, r) {
    super("missing_refresh_token", "Missing Refresh Token (audience: '".concat(P1(t, ["default"]), "', scope: '").concat(P1(r), "')")), this.audience = t, this.scope = r, Object.setPrototypeOf(this, Q8.prototype);
  }
}, SC = class K8 extends ur {
  constructor(t, r) {
    super("missing_scopes", "Missing requested scopes after refresh (audience: '".concat(P1(t, ["default"]), "', missing scope: '").concat(P1(r), "')")), this.audience = t, this.scope = r, Object.setPrototypeOf(this, K8.prototype);
  }
}, G8 = class Z8 extends ur {
  constructor(t) {
    super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = t, Object.setPrototypeOf(this, Z8.prototype);
  }
};
function P1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e && !t.includes(e) ? e : "";
}
const N1 = () => window.crypto, Vd = () => {
  const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t = "";
  return Array.from(N1().getRandomValues(new Uint8Array(43))).forEach(((r) => t += e[r % e.length])), t;
}, Qf = (e) => btoa(e), CC = [{ key: "name", type: ["string"] }, { key: "version", type: ["string", "number"] }, { key: "env", type: ["object"] }], Y8 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  return Object.keys(e).reduce(((r, n) => {
    if (t && n === "env") return r;
    const i = CC.find(((a) => a.key === n));
    return i && i.type.includes(typeof e[n]) && (r[n] = e[n]), r;
  }), {});
}, Fp = (e) => {
  var { clientId: t } = e, r = fi(e, ["clientId"]);
  return new URLSearchParams(((n) => Object.keys(n).filter(((i) => n[i] !== void 0)).reduce(((i, a) => Object.assign(Object.assign({}, i), { [a]: n[a] })), {}))(Object.assign({ client_id: t }, r))).toString();
}, Fv = async (e) => await N1().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(e)), jv = (e) => ((t) => decodeURIComponent(atob(t).split("").map(((r) => "%" + ("00" + r.charCodeAt(0).toString(16)).slice(-2))).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), zv = (e) => {
  const t = new Uint8Array(e);
  return ((r) => {
    const n = { "+": "-", "/": "_", "=": "" };
    return r.replace(/[+/=]/g, ((i) => n[i]));
  })(window.btoa(String.fromCharCode(...Array.from(t))));
};
var bs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, J8 = {}, kg = {};
Object.defineProperty(kg, "__esModule", { value: !0 });
var EC = (function() {
  function e() {
    var t = this;
    this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(r, n) {
      var i = t.locked.get(r);
      i === void 0 ? n === void 0 ? t.locked.set(r, []) : t.locked.set(r, [n]) : n !== void 0 && (i.unshift(n), t.locked.set(r, i));
    }, this.isLocked = function(r) {
      return t.locked.has(r);
    }, this.lock = function(r) {
      return new Promise((function(n, i) {
        t.isLocked(r) ? t.addToLocked(r, n) : (t.addToLocked(r), n());
      }));
    }, this.unlock = function(r) {
      var n = t.locked.get(r);
      if (n !== void 0 && n.length !== 0) {
        var i = n.pop();
        t.locked.set(r, n), i !== void 0 && setTimeout(i, 0);
      } else t.locked.delete(r);
    };
  }
  return e.getInstance = function() {
    return e.instance === void 0 && (e.instance = new e()), e.instance;
  }, e;
})();
kg.default = function() {
  return EC.getInstance();
};
var pi = bs && bs.__awaiter || function(e, t, r, n) {
  return new (r || (r = Promise))((function(i, a) {
    function o(d) {
      try {
        l(n.next(d));
      } catch (c) {
        a(c);
      }
    }
    function s(d) {
      try {
        l(n.throw(d));
      } catch (c) {
        a(c);
      }
    }
    function l(d) {
      d.done ? i(d.value) : new r((function(c) {
        c(d.value);
      })).then(o, s);
    }
    l((n = n.apply(e, t || [])).next());
  }));
}, mi = bs && bs.__generator || function(e, t) {
  var r, n, i, a, o = { label: 0, sent: function() {
    if (1 & i[0]) throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(d) {
      return (function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; o; ) try {
          if (r = 1, n && (i = 2 & c[0] ? n.return : c[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, c[1])).done) return i;
          switch (n = 0, i && (c = [2 & c[0], i.value]), c[0]) {
            case 0:
            case 1:
              i = c;
              break;
            case 4:
              return o.label++, { value: c[1], done: !1 };
            case 5:
              o.label++, n = c[1], c = [0];
              continue;
            case 7:
              c = o.ops.pop(), o.trys.pop();
              continue;
            default:
              if (i = o.trys, !((i = i.length > 0 && i[i.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                o = 0;
                continue;
              }
              if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
                o.label = c[1];
                break;
              }
              if (c[0] === 6 && o.label < i[1]) {
                o.label = i[1], i = c;
                break;
              }
              if (i && o.label < i[2]) {
                o.label = i[2], o.ops.push(c);
                break;
              }
              i[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          c = t.call(e, o);
        } catch (u) {
          c = [6, u], n = 0;
        } finally {
          r = i = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      })([l, d]);
    };
  }
}, Ud = bs;
Object.defineProperty(J8, "__esModule", { value: !0 });
var Ws = kg, u0 = { key: function(e) {
  return pi(Ud, void 0, void 0, (function() {
    return mi(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, getItem: function(e) {
  return pi(Ud, void 0, void 0, (function() {
    return mi(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, clear: function() {
  return pi(Ud, void 0, void 0, (function() {
    return mi(this, (function(e) {
      return [2, window.localStorage.clear()];
    }));
  }));
}, removeItem: function(e) {
  return pi(Ud, void 0, void 0, (function() {
    return mi(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, setItem: function(e, t) {
  return pi(Ud, void 0, void 0, (function() {
    return mi(this, (function(r) {
      throw new Error("Unsupported");
    }));
  }));
}, keySync: function(e) {
  return window.localStorage.key(e);
}, getItemSync: function(e) {
  return window.localStorage.getItem(e);
}, clearSync: function() {
  return window.localStorage.clear();
}, removeItemSync: function(e) {
  return window.localStorage.removeItem(e);
}, setItemSync: function(e, t) {
  return window.localStorage.setItem(e, t);
} };
function Kf(e) {
  return new Promise((function(t) {
    return setTimeout(t, e);
  }));
}
function Gf(e) {
  for (var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", r = "", n = 0; n < e; n++)
    r += t[Math.floor(Math.random() * t.length)];
  return r;
}
var AC = (function() {
  function e(t) {
    this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + Gf(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, e.waiters === void 0 && (e.waiters = []);
  }
  return e.prototype.acquireLock = function(t, r) {
    return r === void 0 && (r = 5e3), pi(this, void 0, void 0, (function() {
      var n, i, a, o, s, l, d;
      return mi(this, (function(c) {
        switch (c.label) {
          case 0:
            n = Date.now() + Gf(4), i = Date.now() + r, a = "browser-tabs-lock-key-" + t, o = this.storageHandler === void 0 ? u0 : this.storageHandler, c.label = 1;
          case 1:
            return Date.now() < i ? [4, Kf(30)] : [3, 8];
          case 2:
            return c.sent(), o.getItemSync(a) !== null ? [3, 5] : (s = this.id + "-" + t + "-" + n, [4, Kf(Math.floor(25 * Math.random()))]);
          case 3:
            return c.sent(), o.setItemSync(a, JSON.stringify({ id: this.id, iat: n, timeoutKey: s, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, Kf(30)];
          case 4:
            return c.sent(), (l = o.getItemSync(a)) !== null && (d = JSON.parse(l)).id === this.id && d.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(a, n), [2, !0]) : [3, 7];
          case 5:
            return e.lockCorrector(this.storageHandler === void 0 ? u0 : this.storageHandler), [4, this.waitForSomethingToChange(i)];
          case 6:
            c.sent(), c.label = 7;
          case 7:
            return n = Date.now() + Gf(4), [3, 1];
          case 8:
            return [2, !1];
        }
      }));
    }));
  }, e.prototype.refreshLockWhileAcquired = function(t, r) {
    return pi(this, void 0, void 0, (function() {
      var n = this;
      return mi(this, (function(i) {
        return setTimeout((function() {
          return pi(n, void 0, void 0, (function() {
            var a, o, s;
            return mi(this, (function(l) {
              switch (l.label) {
                case 0:
                  return [4, Ws.default().lock(r)];
                case 1:
                  return l.sent(), this.acquiredIatSet.has(r) ? (a = this.storageHandler === void 0 ? u0 : this.storageHandler, (o = a.getItemSync(t)) === null ? (Ws.default().unlock(r), [2]) : ((s = JSON.parse(o)).timeRefreshed = Date.now(), a.setItemSync(t, JSON.stringify(s)), Ws.default().unlock(r), this.refreshLockWhileAcquired(t, r), [2])) : (Ws.default().unlock(r), [2]);
              }
            }));
          }));
        }), 1e3), [2];
      }));
    }));
  }, e.prototype.waitForSomethingToChange = function(t) {
    return pi(this, void 0, void 0, (function() {
      return mi(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, new Promise((function(n) {
              var i = !1, a = Date.now(), o = !1;
              function s() {
                if (o || (window.removeEventListener("storage", s), e.removeFromWaiting(s), clearTimeout(l), o = !0), !i) {
                  i = !0;
                  var d = 50 - (Date.now() - a);
                  d > 0 ? setTimeout(n, d) : n(null);
                }
              }
              window.addEventListener("storage", s), e.addToWaiting(s);
              var l = setTimeout(s, Math.max(0, t - Date.now()));
            }))];
          case 1:
            return r.sent(), [2];
        }
      }));
    }));
  }, e.addToWaiting = function(t) {
    this.removeFromWaiting(t), e.waiters !== void 0 && e.waiters.push(t);
  }, e.removeFromWaiting = function(t) {
    e.waiters !== void 0 && (e.waiters = e.waiters.filter((function(r) {
      return r !== t;
    })));
  }, e.notifyWaiters = function() {
    e.waiters !== void 0 && e.waiters.slice().forEach((function(t) {
      return t();
    }));
  }, e.prototype.releaseLock = function(t) {
    return pi(this, void 0, void 0, (function() {
      return mi(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, this.releaseLock__private__(t)];
          case 1:
            return [2, r.sent()];
        }
      }));
    }));
  }, e.prototype.releaseLock__private__ = function(t) {
    return pi(this, void 0, void 0, (function() {
      var r, n, i, a;
      return mi(this, (function(o) {
        switch (o.label) {
          case 0:
            return r = this.storageHandler === void 0 ? u0 : this.storageHandler, n = "browser-tabs-lock-key-" + t, (i = r.getItemSync(n)) === null ? [2] : (a = JSON.parse(i)).id !== this.id ? [3, 2] : [4, Ws.default().lock(a.iat)];
          case 1:
            o.sent(), this.acquiredIatSet.delete(a.iat), r.removeItemSync(n), Ws.default().unlock(a.iat), e.notifyWaiters(), o.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, e.lockCorrector = function(t) {
    for (var r = Date.now() - 5e3, n = t, i = [], a = 0; ; ) {
      var o = n.keySync(a);
      if (o === null) break;
      i.push(o), a++;
    }
    for (var s = !1, l = 0; l < i.length; l++) {
      var d = i[l];
      if (d.includes("browser-tabs-lock-key")) {
        var c = n.getItemSync(d);
        if (c !== null) {
          var u = JSON.parse(c);
          (u.timeRefreshed === void 0 && u.timeAcquired < r || u.timeRefreshed !== void 0 && u.timeRefreshed < r) && (n.removeItemSync(d), s = !0);
        }
      }
    }
    s && e.notifyWaiters();
  }, e.waiters = void 0, e;
})(), TC = J8.default = AC;
let OC = class {
  async runWithLock(t, r, n) {
    const i = new AbortController(), a = setTimeout((() => i.abort()), r);
    try {
      return await navigator.locks.request(t, { mode: "exclusive", signal: i.signal }, (async (o) => {
        if (clearTimeout(a), !o) throw new Error("Lock not available");
        return await n();
      }));
    } catch (o) {
      throw clearTimeout(a), o?.name === "AbortError" ? new jh() : o;
    }
  }
};
class IC {
  constructor() {
    this.activeLocks = /* @__PURE__ */ new Set(), this.lock = new TC(), this.pagehideHandler = () => {
      this.activeLocks.forEach(((t) => this.lock.releaseLock(t))), this.activeLocks.clear();
    };
  }
  async runWithLock(t, r, n) {
    let i = !1;
    for (let a = 0; a < 10 && !i; a++) i = await this.lock.acquireLock(t, r);
    if (!i) throw new jh();
    this.activeLocks.add(t), this.activeLocks.size === 1 && typeof window < "u" && window.addEventListener("pagehide", this.pagehideHandler);
    try {
      return await n();
    } finally {
      this.activeLocks.delete(t), await this.lock.releaseLock(t), this.activeLocks.size === 0 && typeof window < "u" && window.removeEventListener("pagehide", this.pagehideHandler);
    }
  }
}
function PC() {
  return typeof navigator < "u" && typeof ((e = navigator.locks) === null || e === void 0 ? void 0 : e.request) == "function" ? new OC() : new IC();
  var e;
}
let Zf = null;
const NC = new TextEncoder(), DC = new TextDecoder();
function Ac(e) {
  return typeof e == "string" ? NC.encode(e) : DC.decode(e);
}
function Vv(e) {
  if (typeof e.modulusLength != "number" || e.modulusLength < 2048) throw new RC(`${e.name} modulusLength must be at least 2048 bits`);
}
async function MC(e, t, r) {
  if (r.usages.includes("sign") === !1) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
  const n = `${Tc(Ac(JSON.stringify(e)))}.${Tc(Ac(JSON.stringify(t)))}`;
  return `${n}.${Tc(await crypto.subtle.sign((function(i) {
    switch (i.algorithm.name) {
      case "ECDSA":
        return { name: i.algorithm.name, hash: "SHA-256" };
      case "RSA-PSS":
        return Vv(i.algorithm), { name: i.algorithm.name, saltLength: 32 };
      case "RSASSA-PKCS1-v1_5":
        return Vv(i.algorithm), { name: i.algorithm.name };
      case "Ed25519":
        return { name: i.algorithm.name };
    }
    throw new us();
  })(r), r, Ac(n)))}`;
}
let jp;
Uint8Array.prototype.toBase64 ? jp = (e) => (e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({ alphabet: "base64url", omitPadding: !0 })) : jp = (t) => {
  t instanceof ArrayBuffer && (t = new Uint8Array(t));
  const r = [];
  for (let n = 0; n < t.byteLength; n += 32768) r.push(String.fromCharCode.apply(null, t.subarray(n, n + 32768)));
  return btoa(r.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
function Tc(e) {
  return jp(e);
}
let us = class extends Error {
  constructor(t) {
    var r;
    super(t ?? "operation not supported"), this.name = this.constructor.name, (r = Error.captureStackTrace) === null || r === void 0 || r.call(Error, this, this.constructor);
  }
};
class RC extends Error {
  constructor(t) {
    var r;
    super(t), this.name = this.constructor.name, (r = Error.captureStackTrace) === null || r === void 0 || r.call(Error, this, this.constructor);
  }
}
function LC(e) {
  switch (e.algorithm.name) {
    case "RSA-PSS":
      return (function(t) {
        if (t.algorithm.hash.name === "SHA-256") return "PS256";
        throw new us("unsupported RsaHashedKeyAlgorithm hash name");
      })(e);
    case "RSASSA-PKCS1-v1_5":
      return (function(t) {
        if (t.algorithm.hash.name === "SHA-256") return "RS256";
        throw new us("unsupported RsaHashedKeyAlgorithm hash name");
      })(e);
    case "ECDSA":
      return (function(t) {
        if (t.algorithm.namedCurve === "P-256") return "ES256";
        throw new us("unsupported EcKeyAlgorithm namedCurve");
      })(e);
    case "Ed25519":
      return "Ed25519";
    default:
      throw new us("unsupported CryptoKey algorithm name");
  }
}
function X8(e) {
  return e instanceof CryptoKey;
}
function eb(e) {
  return X8(e) && e.type === "public";
}
async function FC(e, t, r, n, i, a) {
  const o = e?.privateKey, s = e?.publicKey;
  if (!X8(l = o) || l.type !== "private") throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
  var l;
  if (!eb(s)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
  if (s.extractable !== !0) throw new TypeError('"keypair.publicKey.extractable" must be true');
  if (typeof t != "string") throw new TypeError('"htu" must be a string');
  if (typeof r != "string") throw new TypeError('"htm" must be a string');
  if (n !== void 0 && typeof n != "string") throw new TypeError('"nonce" must be a string or undefined');
  if (i !== void 0 && typeof i != "string") throw new TypeError('"accessToken" must be a string or undefined');
  return MC({ alg: LC(o), typ: "dpop+jwt", jwk: await tb(s) }, Object.assign(Object.assign({}, a), { iat: Math.floor(Date.now() / 1e3), jti: crypto.randomUUID(), htm: r, nonce: n, htu: t, ath: i ? Tc(await crypto.subtle.digest("SHA-256", Ac(i))) : void 0 }), o);
}
async function tb(e) {
  const { kty: t, e: r, n, x: i, y: a, crv: o } = await crypto.subtle.exportKey("jwk", e);
  return { kty: t, crv: o, e: r, n, x: i, y: a };
}
const jC = ["authorization_code", "refresh_token", "urn:ietf:params:oauth:grant-type:token-exchange", "http://auth0.com/oauth/grant-type/mfa-oob", "http://auth0.com/oauth/grant-type/mfa-otp", "http://auth0.com/oauth/grant-type/mfa-recovery-code"];
function zC() {
  return (async function(e, t) {
    var r;
    let n;
    if (e.length === 0) throw new TypeError('"alg" must be a non-empty string');
    switch (e) {
      case "PS256":
        n = { name: "RSA-PSS", hash: "SHA-256", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) };
        break;
      case "RS256":
        n = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-256", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) };
        break;
      case "ES256":
        n = { name: "ECDSA", namedCurve: "P-256" };
        break;
      case "Ed25519":
        n = { name: "Ed25519" };
        break;
      default:
        throw new us();
    }
    return crypto.subtle.generateKey(n, (r = t?.extractable) !== null && r !== void 0 && r, ["sign", "verify"]);
  })("ES256", { extractable: !1 });
}
function VC(e) {
  return (async function(t) {
    if (!eb(t)) throw new TypeError('"publicKey" must be a public CryptoKey');
    if (t.extractable !== !0) throw new TypeError('"publicKey.extractable" must be true');
    const r = await tb(t);
    let n;
    switch (r.kty) {
      case "EC":
        n = { crv: r.crv, kty: r.kty, x: r.x, y: r.y };
        break;
      case "OKP":
        n = { crv: r.crv, kty: r.kty, x: r.x };
        break;
      case "RSA":
        n = { e: r.e, kty: r.kty, n: r.n };
        break;
      default:
        throw new us("unsupported JWK kty");
    }
    return Tc(await crypto.subtle.digest({ name: "SHA-256" }, Ac(JSON.stringify(n))));
  })(e.publicKey);
}
function UC(e) {
  let { keyPair: t, url: r, method: n, nonce: i, accessToken: a } = e;
  const o = (function(s) {
    const l = new URL(s);
    return l.search = "", l.hash = "", l.href;
  })(r);
  return FC(t, o, n, i, a);
}
const qC = async (e, t) => {
  const r = await fetch(e, t);
  return { ok: r.ok, json: await r.json(), headers: (n = r.headers, [...n].reduce(((i, a) => {
    let [o, s] = a;
    return i[o] = s, i;
  }), {})) };
  var n;
}, BC = async (e, t, r) => {
  const n = new AbortController();
  let i;
  return t.signal = n.signal, Promise.race([qC(e, t), new Promise(((a, o) => {
    i = setTimeout((() => {
      n.abort(), o(new Error("Timeout when executing 'fetch'"));
    }), r);
  }))]).finally((() => {
    clearTimeout(i);
  }));
}, HC = async (e, t, r, n, i, a, o, s) => ((l, d) => new Promise((function(c, u) {
  const h = new MessageChannel();
  h.port1.onmessage = function(f) {
    f.data.error ? u(new Error(f.data.error)) : c(f.data), h.port1.close();
  }, d.postMessage(l, [h.port2]);
})))({ auth: { audience: t, scope: r }, timeout: i, fetchUrl: e, fetchOptions: n, useFormData: o, useMrrt: s }, a), WC = async function(e, t, r, n, i, a) {
  let o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1e4, s = arguments.length > 7 ? arguments[7] : void 0;
  return i ? HC(e, t, r, n, o, i, a, s) : BC(e, n, o);
};
async function rb(e, t, r, n, i, a, o, s, l, d) {
  if (l) {
    const $ = await l.generateProof({ url: e, method: i.method || "GET", nonce: await l.getNonce() });
    i.headers = Object.assign(Object.assign({}, i.headers), { dpop: $ });
  }
  let c, u = null;
  for (let $ = 0; $ < 3; $++) try {
    c = await WC(e, r, n, i, a, o, t, s), u = null;
    break;
  } catch (_) {
    u = _;
  }
  if (u) throw u;
  const h = c.json, { error: f, error_description: p } = h, m = fi(h, ["error", "error_description"]), { headers: y, ok: v } = c;
  let b;
  if (l && (b = y["dpop-nonce"], b && await l.setNonce(b)), !v) {
    const $ = p || "HTTP error. Unable to fetch ".concat(e);
    if (f === "mfa_required") throw new I1(f, $, m.mfa_token, m.mfa_requirements);
    if (f === "missing_refresh_token") throw new W8(r, n);
    if (f === "use_dpop_nonce") {
      if (!l || !b || d) throw new G8(b);
      return rb(e, t, r, n, i, a, o, s, l, !0);
    }
    throw new ur(f || "request_error", $);
  }
  return m;
}
async function QC(e, t) {
  var { baseUrl: r, timeout: n, audience: i, scope: a, auth0Client: o, useFormData: s, useMrrt: l, dpop: d } = e, c = fi(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData", "useMrrt", "dpop"]);
  const u = c.grant_type === "urn:ietf:params:oauth:grant-type:token-exchange", h = c.grant_type === "refresh_token" && l, f = Object.assign(Object.assign(Object.assign(Object.assign({}, c), u && i && { audience: i }), u && a && { scope: a }), h && { audience: i, scope: a }), p = s ? Fp(f) : JSON.stringify(f), m = (y = c.grant_type, jC.includes(y));
  var y;
  return await rb("".concat(r, "/oauth/token"), n, i || "default", a, { method: "POST", body: p, headers: { "Content-Type": s ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(Y8(o || L8))) } }, t, s, l, m ? d : void 0);
}
const KC = (e) => Array.from(new Set(e)), t1 = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return KC(t.filter(Boolean).join(" ").trim().split(/\s+/)).join(" ");
}, h0 = (e, t, r) => {
  let n;
  return r && (n = e[r]), n || (n = e.default), t1(n, t);
};
let ga = class zp {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "@@auth0spajs@@", n = arguments.length > 2 ? arguments[2] : void 0;
    this.prefix = r, this.suffix = n, this.clientId = t.clientId, this.scope = t.scope, this.audience = t.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(t) {
    const [r, n, i, a] = t.split("::");
    return new zp({ clientId: n, scope: a, audience: i }, r);
  }
  static fromCacheEntry(t) {
    const { scope: r, audience: n, client_id: i } = t;
    return new zp({ scope: r, audience: n, clientId: i });
  }
}, GC = class {
  set(t, r) {
    localStorage.setItem(t, JSON.stringify(r));
  }
  get(t) {
    const r = window.localStorage.getItem(t);
    if (r) try {
      return JSON.parse(r);
    } catch {
      return;
    }
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter(((t) => t.startsWith("@@auth0spajs@@")));
  }
}, nb = class {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ (function() {
      let t = {};
      return { set(r, n) {
        t[r] = n;
      }, get(r) {
        const n = t[r];
        if (n) return n;
      }, remove(r) {
        delete t[r];
      }, allKeys: () => Object.keys(t) };
    })();
  }
};
class ZC {
  constructor(t, r, n) {
    this.cache = t, this.keyManifest = r, this.nowProvider = n || F8;
  }
  async setIdToken(t, r, n) {
    var i;
    const a = this.getIdTokenCacheKey(t);
    await this.cache.set(a, { id_token: r, decodedToken: n }), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.add(a));
  }
  async getIdToken(t) {
    const r = await this.cache.get(this.getIdTokenCacheKey(t.clientId));
    if (!r && t.scope && t.audience) {
      const n = await this.get(t);
      return !n || !n.id_token || !n.decodedToken ? void 0 : { id_token: n.id_token, decodedToken: n.decodedToken };
    }
    if (r) return { id_token: r.id_token, decodedToken: r.decodedToken };
  }
  async get(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], i = arguments.length > 3 ? arguments[3] : void 0;
    var a;
    let o = await this.cache.get(t.toKey());
    if (!o) {
      const d = await this.getCacheKeys();
      if (!d) return;
      const c = this.matchExistingCacheKey(t, d);
      if (c && (o = await this.cache.get(c)), !o && n && i !== "cache-only") return this.getEntryWithRefreshToken(t, d);
    }
    if (!o) return;
    const s = await this.nowProvider(), l = Math.floor(s / 1e3);
    return o.expiresAt - r < l ? o.body.refresh_token ? this.modifiedCachedEntry(o, t) : (await this.cache.remove(t.toKey()), void await ((a = this.keyManifest) === null || a === void 0 ? void 0 : a.remove(t.toKey()))) : o.body;
  }
  async modifiedCachedEntry(t, r) {
    return t.body = { refresh_token: t.body.refresh_token, audience: t.body.audience, scope: t.body.scope }, await this.cache.set(r.toKey(), t), { refresh_token: t.body.refresh_token, audience: t.body.audience, scope: t.body.scope };
  }
  async set(t) {
    var r;
    const n = new ga({ clientId: t.client_id, scope: t.scope, audience: t.audience }), i = await this.wrapCacheEntry(t);
    await this.cache.set(n.toKey(), i), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.add(n.toKey()));
  }
  async remove(t, r, n) {
    const i = new ga({ clientId: t, scope: n, audience: r });
    await this.cache.remove(i.toKey());
  }
  async clear(t) {
    var r;
    const n = await this.getCacheKeys();
    n && (await n.filter(((i) => !t || i.includes(t))).reduce((async (i, a) => {
      await i, await this.cache.remove(a);
    }), Promise.resolve()), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.clear()));
  }
  async wrapCacheEntry(t) {
    const r = await this.nowProvider();
    return { body: t, expiresAt: Math.floor(r / 1e3) + t.expires_in };
  }
  async getCacheKeys() {
    var t;
    return this.keyManifest ? (t = await this.keyManifest.get()) === null || t === void 0 ? void 0 : t.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(t) {
    return new ga({ clientId: t }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(t, r) {
    return r.filter(((n) => {
      var i;
      const a = ga.fromKey(n), o = new Set(a.scope && a.scope.split(" ")), s = ((i = t.scope) === null || i === void 0 ? void 0 : i.split(" ")) || [], l = a.scope && s.reduce(((d, c) => d && o.has(c)), !0);
      return a.prefix === "@@auth0spajs@@" && a.clientId === t.clientId && a.audience === t.audience && l;
    }))[0];
  }
  async getEntryWithRefreshToken(t, r) {
    var n;
    for (const i of r) {
      const a = ga.fromKey(i);
      if (a.prefix === "@@auth0spajs@@" && a.clientId === t.clientId) {
        const o = await this.cache.get(i);
        if (!((n = o?.body) === null || n === void 0) && n.refresh_token) return this.modifiedCachedEntry(o, t);
      }
    }
  }
  async updateEntry(t, r) {
    var n;
    const i = await this.getCacheKeys();
    if (i) for (const a of i) {
      const o = await this.cache.get(a);
      ((n = o?.body) === null || n === void 0 ? void 0 : n.refresh_token) === t && (o.body.refresh_token = r, await this.cache.set(a, o));
    }
  }
}
class YC {
  constructor(t, r, n) {
    this.storage = t, this.clientId = r, this.cookieDomain = n, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId);
  }
  create(t) {
    this.storage.save(this.storageKey, t, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
}
const qd = (e) => typeof e == "number", JC = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], XC = (e) => {
  if (!e.id_token) throw new Error("ID token is required but missing");
  const t = ((a) => {
    const o = a.split("."), [s, l, d] = o;
    if (o.length !== 3 || !s || !l || !d) throw new Error("ID token could not be decoded");
    const c = JSON.parse(jv(l)), u = { __raw: a }, h = {};
    return Object.keys(c).forEach(((f) => {
      u[f] = c[f], JC.includes(f) || (h[f] = c[f]);
    })), { encoded: { header: s, payload: l, signature: d }, header: JSON.parse(jv(s)), claims: u, user: h };
  })(e.id_token);
  if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
  if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (t.header.alg !== "RS256") throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
  if (!t.claims.aud || typeof t.claims.aud != "string" && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
    if (t.claims.aud.length > 1) {
      if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
    }
  } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
  if (e.nonce) {
    if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
  }
  if (e.max_age && !qd(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (t.claims.exp == null || !qd(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!qd(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const r = e.leeway || 60, n = new Date(e.now || Date.now()), i = /* @__PURE__ */ new Date(0);
  if (i.setUTCSeconds(t.claims.exp + r), n > i) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(n, ") is after expiration time (").concat(i, ")"));
  if (t.claims.nbf != null && qd(t.claims.nbf)) {
    const a = /* @__PURE__ */ new Date(0);
    if (a.setUTCSeconds(t.claims.nbf - r), n < a) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(n, ") is before ").concat(a));
  }
  if (t.claims.auth_time != null && qd(t.claims.auth_time)) {
    const a = /* @__PURE__ */ new Date(0);
    if (a.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + r), n > a) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(n, ") is after last auth at ").concat(a));
  }
  if (e.organization) {
    const a = e.organization.trim();
    if (a.startsWith("org_")) {
      const o = a;
      if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (o !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(o, '", found "').concat(t.claims.org_id, '"'));
    } else {
      const o = a.toLowerCase();
      if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (o !== t.claims.org_name) throw new Error('Organization Name (org_name) claim mismatch in the ID token; expected "'.concat(o, '", found "').concat(t.claims.org_name, '"'));
    }
  }
  return t;
};
var Kc = bs && bs.__assign || function() {
  return Kc = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, Kc.apply(this, arguments);
};
function Bd(e, t) {
  if (!t) return "";
  var r = "; " + e;
  return t === !0 ? r : r + "=" + t;
}
function eE(e, t, r) {
  return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + (function(n) {
    if (typeof n.expires == "number") {
      var i = /* @__PURE__ */ new Date();
      i.setMilliseconds(i.getMilliseconds() + 864e5 * n.expires), n.expires = i;
    }
    return Bd("Expires", n.expires ? n.expires.toUTCString() : "") + Bd("Domain", n.domain) + Bd("Path", n.path) + Bd("Secure", n.secure) + Bd("SameSite", n.sameSite);
  })(r);
}
function tE() {
  return (function(e) {
    for (var t = {}, r = e ? e.split("; ") : [], n = /(%[\dA-F]{2})+/gi, i = 0; i < r.length; i++) {
      var a = r[i].split("="), o = a.slice(1).join("=");
      o.charAt(0) === '"' && (o = o.slice(1, -1));
      try {
        t[a[0].replace(n, decodeURIComponent)] = o.replace(n, decodeURIComponent);
      } catch {
      }
    }
    return t;
  })(document.cookie);
}
var rE = function(e) {
  return tE()[e];
};
function ib(e, t, r) {
  document.cookie = eE(e, t, Kc({ path: "/" }, r));
}
var ab = ib, ob = function(e, t) {
  ib(e, "", Kc(Kc({}, t), { expires: -1 }));
};
const rl = { get(e) {
  const t = rE(e);
  if (t !== void 0) return JSON.parse(t);
}, save(e, t, r) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0, sameSite: "none" }), r?.daysUntilExpire && (n.expires = r.daysUntilExpire), r?.cookieDomain && (n.domain = r.cookieDomain), ab(e, JSON.stringify(t), n);
}, remove(e, t) {
  let r = {};
  t?.cookieDomain && (r.domain = t.cookieDomain), ob(e, r);
} }, nE = { get(e) {
  return rl.get(e) || rl.get("".concat("_legacy_").concat(e));
}, save(e, t, r) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0 }), r?.daysUntilExpire && (n.expires = r.daysUntilExpire), r?.cookieDomain && (n.domain = r.cookieDomain), ab("".concat("_legacy_").concat(e), JSON.stringify(t), n), rl.save(e, t, r);
}, remove(e, t) {
  let r = {};
  t?.cookieDomain && (r.domain = t.cookieDomain), ob(e, r), rl.remove(e, t), rl.remove("".concat("_legacy_").concat(e), t);
} }, iE = { get(e) {
  if (typeof sessionStorage > "u") return;
  const t = sessionStorage.getItem(e);
  return t != null ? JSON.parse(t) : void 0;
}, save(e, t) {
  sessionStorage.setItem(e, JSON.stringify(t));
}, remove(e) {
  sessionStorage.removeItem(e);
} };
var is;
(function(e) {
  e.Code = "code", e.ConnectCode = "connect_code";
})(is || (is = {}));
function aE(e, t, r) {
  var n = t === void 0 ? null : t, i = (function(l, d) {
    var c = atob(l);
    if (d) {
      for (var u = new Uint8Array(c.length), h = 0, f = c.length; h < f; ++h) u[h] = c.charCodeAt(h);
      return String.fromCharCode.apply(null, new Uint16Array(u.buffer));
    }
    return c;
  })(e, r !== void 0 && r), a = i.indexOf(`
`, 10) + 1, o = i.substring(a) + (n ? "//# sourceMappingURL=" + n : ""), s = new Blob([o], { type: "application/javascript" });
  return URL.createObjectURL(s);
}
var Uv, qv, Bv, Yf, oE = (Uv = "Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwohZnVuY3Rpb24oKXsidXNlIHN0cmljdCI7Y2xhc3MgZSBleHRlbmRzIEVycm9ye2NvbnN0cnVjdG9yKHQscil7c3VwZXIociksdGhpcy5lcnJvcj10LHRoaXMuZXJyb3JfZGVzY3JpcHRpb249cixPYmplY3Quc2V0UHJvdG90eXBlT2YodGhpcyxlLnByb3RvdHlwZSl9c3RhdGljIGZyb21QYXlsb2FkKHQpe2xldHtlcnJvcjpyLGVycm9yX2Rlc2NyaXB0aW9uOnN9PXQ7cmV0dXJuIG5ldyBlKHIscyl9fWNsYXNzIHQgZXh0ZW5kcyBle2NvbnN0cnVjdG9yKGUscyl7c3VwZXIoIm1pc3NpbmdfcmVmcmVzaF90b2tlbiIsIk1pc3NpbmcgUmVmcmVzaCBUb2tlbiAoYXVkaWVuY2U6ICciLmNvbmNhdChyKGUsWyJkZWZhdWx0Il0pLCInLCBzY29wZTogJyIpLmNvbmNhdChyKHMpLCInKSIpKSx0aGlzLmF1ZGllbmNlPWUsdGhpcy5zY29wZT1zLE9iamVjdC5zZXRQcm90b3R5cGVPZih0aGlzLHQucHJvdG90eXBlKX19ZnVuY3Rpb24gcihlKXtsZXQgdD1hcmd1bWVudHMubGVuZ3RoPjEmJnZvaWQgMCE9PWFyZ3VtZW50c1sxXT9hcmd1bWVudHNbMV06W107cmV0dXJuIGUmJiF0LmluY2x1ZGVzKGUpP2U6IiJ9ImZ1bmN0aW9uIj09dHlwZW9mIFN1cHByZXNzZWRFcnJvciYmU3VwcHJlc3NlZEVycm9yO2NvbnN0IHM9ZT0+e3ZhcntjbGllbnRJZDp0fT1lLHI9ZnVuY3Rpb24oZSx0KXt2YXIgcj17fTtmb3IodmFyIHMgaW4gZSlPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoZSxzKSYmdC5pbmRleE9mKHMpPDAmJihyW3NdPWVbc10pO2lmKG51bGwhPWUmJiJmdW5jdGlvbiI9PXR5cGVvZiBPYmplY3QuZ2V0T3duUHJvcGVydHlTeW1ib2xzKXt2YXIgbz0wO2ZvcihzPU9iamVjdC5nZXRPd25Qcm9wZXJ0eVN5bWJvbHMoZSk7bzxzLmxlbmd0aDtvKyspdC5pbmRleE9mKHNbb10pPDAmJk9iamVjdC5wcm90b3R5cGUucHJvcGVydHlJc0VudW1lcmFibGUuY2FsbChlLHNbb10pJiYocltzW29dXT1lW3Nbb11dKX1yZXR1cm4gcn0oZSxbImNsaWVudElkIl0pO3JldHVybiBuZXcgVVJMU2VhcmNoUGFyYW1zKChlPT5PYmplY3Qua2V5cyhlKS5maWx0ZXIoKHQ9PnZvaWQgMCE9PWVbdF0pKS5yZWR1Y2UoKCh0LHIpPT5PYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30sdCkse1tyXTplW3JdfSkpLHt9KSkoT2JqZWN0LmFzc2lnbih7Y2xpZW50X2lkOnR9LHIpKSkudG9TdHJpbmcoKX07bGV0IG89e307Y29uc3Qgbj0oZSx0KT0+IiIuY29uY2F0KGUsInwiKS5jb25jYXQodCk7YWRkRXZlbnRMaXN0ZW5lcigibWVzc2FnZSIsKGFzeW5jIGU9PntsZXQgcixjLHtkYXRhOnt0aW1lb3V0OmksYXV0aDphLGZldGNoVXJsOmYsZmV0Y2hPcHRpb25zOmwsdXNlRm9ybURhdGE6cCx1c2VNcnJ0Omh9LHBvcnRzOlt1XX09ZSxkPXt9O2NvbnN0e2F1ZGllbmNlOmcsc2NvcGU6eX09YXx8e307dHJ5e2NvbnN0IGU9cD8oZT0+e2NvbnN0IHQ9bmV3IFVSTFNlYXJjaFBhcmFtcyhlKSxyPXt9O3JldHVybiB0LmZvckVhY2goKChlLHQpPT57clt0XT1lfSkpLHJ9KShsLmJvZHkpOkpTT04ucGFyc2UobC5ib2R5KTtpZighZS5yZWZyZXNoX3Rva2VuJiYicmVmcmVzaF90b2tlbiI9PT1lLmdyYW50X3R5cGUpe2lmKGM9KChlLHQpPT5vW24oZSx0KV0pKGcseSksIWMmJmgpe2NvbnN0IGU9by5sYXRlc3RfcmVmcmVzaF90b2tlbix0PSgoZSx0KT0+e2NvbnN0IHI9T2JqZWN0LmtleXMobykuZmluZCgocj0+e2lmKCJsYXRlc3RfcmVmcmVzaF90b2tlbiIhPT1yKXtjb25zdCBzPSgoZSx0KT0+dC5zdGFydHNXaXRoKCIiLmNvbmNhdChlLCJ8IikpKSh0LHIpLG89ci5zcGxpdCgifCIpWzFdLnNwbGl0KCIgIiksbj1lLnNwbGl0KCIgIikuZXZlcnkoKGU9Pm8uaW5jbHVkZXMoZSkpKTtyZXR1cm4gcyYmbn19KSk7cmV0dXJuISFyfSkoeSxnKTtlJiYhdCYmKGM9ZSl9aWYoIWMpdGhyb3cgbmV3IHQoZyx5KTtsLmJvZHk9cD9zKE9iamVjdC5hc3NpZ24oT2JqZWN0LmFzc2lnbih7fSxlKSx7cmVmcmVzaF90b2tlbjpjfSkpOkpTT04uc3RyaW5naWZ5KE9iamVjdC5hc3NpZ24oT2JqZWN0LmFzc2lnbih7fSxlKSx7cmVmcmVzaF90b2tlbjpjfSkpfWxldCBhLGs7ImZ1bmN0aW9uIj09dHlwZW9mIEFib3J0Q29udHJvbGxlciYmKGE9bmV3IEFib3J0Q29udHJvbGxlcixsLnNpZ25hbD1hLnNpZ25hbCk7dHJ5e2s9YXdhaXQgUHJvbWlzZS5yYWNlKFsoaj1pLG5ldyBQcm9taXNlKChlPT5zZXRUaW1lb3V0KGUsaikpKSksZmV0Y2goZixPYmplY3QuYXNzaWduKHt9LGwpKV0pfWNhdGNoKGUpe3JldHVybiB2b2lkIHUucG9zdE1lc3NhZ2Uoe2Vycm9yOmUubWVzc2FnZX0pfWlmKCFrKXJldHVybiBhJiZhLmFib3J0KCksdm9pZCB1LnBvc3RNZXNzYWdlKHtlcnJvcjoiVGltZW91dCB3aGVuIGV4ZWN1dGluZyAnZmV0Y2gnIn0pO189ay5oZWFkZXJzLGQ9Wy4uLl9dLnJlZHVjZSgoKGUsdCk9PntsZXRbcixzXT10O3JldHVybiBlW3JdPXMsZX0pLHt9KSxyPWF3YWl0IGsuanNvbigpLHIucmVmcmVzaF90b2tlbj8oaCYmKG8ubGF0ZXN0X3JlZnJlc2hfdG9rZW49ci5yZWZyZXNoX3Rva2VuLE89YyxiPXIucmVmcmVzaF90b2tlbixPYmplY3QuZW50cmllcyhvKS5mb3JFYWNoKChlPT57bGV0W3Qscl09ZTtyPT09TyYmKG9bdF09Yil9KSkpLCgoZSx0LHIpPT57b1tuKHQscildPWV9KShyLnJlZnJlc2hfdG9rZW4sZyx5KSxkZWxldGUgci5yZWZyZXNoX3Rva2VuKTooKGUsdCk9PntkZWxldGUgb1tuKGUsdCldfSkoZyx5KSx1LnBvc3RNZXNzYWdlKHtvazprLm9rLGpzb246cixoZWFkZXJzOmR9KX1jYXRjaChlKXt1LnBvc3RNZXNzYWdlKHtvazohMSxqc29uOntlcnJvcjplLmVycm9yLGVycm9yX2Rlc2NyaXB0aW9uOmUubWVzc2FnZX0saGVhZGVyczpkfSl9dmFyIE8sYixfLGp9KSl9KCk7Cgo=", qv = null, Bv = !1, function(e) {
  return Yf = Yf || aE(Uv, qv, Bv), new Worker(Yf, e);
});
const Jf = {};
let sE = class {
  constructor(t, r) {
    this.cache = t, this.clientId = r, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(t) {
    var r;
    const n = new Set(((r = await this.cache.get(this.manifestKey)) === null || r === void 0 ? void 0 : r.keys) || []);
    n.add(t), await this.cache.set(this.manifestKey, { keys: [...n] });
  }
  async remove(t) {
    const r = await this.cache.get(this.manifestKey);
    if (r) {
      const n = new Set(r.keys);
      return n.delete(t), n.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...n] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(t) {
    return "".concat("@@auth0spajs@@", "::").concat(t);
  }
};
const lE = { memory: () => new nb().enclosedCache, localstorage: () => new GC() }, Hv = (e) => lE[e], Wv = (e) => {
  const { openUrl: t, onRedirect: r } = e, n = fi(e, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, n), { openUrl: t === !1 || t ? t : r });
}, Qv = (e, t) => {
  const r = t?.split(" ") || [];
  return (e?.split(" ") || []).every(((n) => r.includes(n)));
}, zo = { NONCE: "nonce", KEYPAIR: "keypair" };
class dE {
  constructor(t) {
    this.clientId = t;
  }
  getVersion() {
    return 1;
  }
  createDbHandle() {
    const t = window.indexedDB.open("auth0-spa-js", this.getVersion());
    return new Promise(((r, n) => {
      t.onupgradeneeded = () => Object.values(zo).forEach(((i) => t.result.createObjectStore(i))), t.onerror = () => n(t.error), t.onsuccess = () => r(t.result);
    }));
  }
  async getDbHandle() {
    return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
  }
  async executeDbRequest(t, r, n) {
    const i = n((await this.getDbHandle()).transaction(t, r).objectStore(t));
    return new Promise(((a, o) => {
      i.onsuccess = () => a(i.result), i.onerror = () => o(i.error);
    }));
  }
  buildKey(t) {
    const r = t ? "_".concat(t) : "auth0";
    return "".concat(this.clientId, "::").concat(r);
  }
  setNonce(t, r) {
    return this.save(zo.NONCE, this.buildKey(r), t);
  }
  setKeyPair(t) {
    return this.save(zo.KEYPAIR, this.buildKey(), t);
  }
  async save(t, r, n) {
    await this.executeDbRequest(t, "readwrite", ((i) => i.put(n, r)));
  }
  findNonce(t) {
    return this.find(zo.NONCE, this.buildKey(t));
  }
  findKeyPair() {
    return this.find(zo.KEYPAIR, this.buildKey());
  }
  find(t, r) {
    return this.executeDbRequest(t, "readonly", ((n) => n.get(r)));
  }
  async deleteBy(t, r) {
    const n = await this.executeDbRequest(t, "readonly", ((i) => i.getAllKeys()));
    n?.filter(r).map(((i) => this.executeDbRequest(t, "readwrite", ((a) => a.delete(i)))));
  }
  deleteByClientId(t, r) {
    return this.deleteBy(t, ((n) => typeof n == "string" && n.startsWith("".concat(r, "::"))));
  }
  clearNonces() {
    return this.deleteByClientId(zo.NONCE, this.clientId);
  }
  clearKeyPairs() {
    return this.deleteByClientId(zo.KEYPAIR, this.clientId);
  }
}
class cE {
  constructor(t) {
    this.storage = new dE(t);
  }
  getNonce(t) {
    return this.storage.findNonce(t);
  }
  setNonce(t, r) {
    return this.storage.setNonce(t, r);
  }
  async getOrGenerateKeyPair() {
    let t = await this.storage.findKeyPair();
    return t || (t = await zC(), await this.storage.setKeyPair(t)), t;
  }
  async generateProof(t) {
    const r = await this.getOrGenerateKeyPair();
    return UC(Object.assign({ keyPair: r }, t));
  }
  async calculateThumbprint() {
    return VC(await this.getOrGenerateKeyPair());
  }
  async clear() {
    await Promise.all([this.storage.clearNonces(), this.storage.clearKeyPairs()]);
  }
}
var gl;
(function(e) {
  e.Bearer = "Bearer", e.DPoP = "DPoP";
})(gl || (gl = {}));
class uE {
  constructor(t, r) {
    this.hooks = r, this.config = Object.assign(Object.assign({}, t), { fetch: t.fetch || (typeof window > "u" ? fetch : window.fetch.bind(window)) });
  }
  isAbsoluteUrl(t) {
    return /^(https?:)?\/\//i.test(t);
  }
  buildUrl(t, r) {
    if (r) {
      if (this.isAbsoluteUrl(r)) return r;
      if (t) return "".concat(t.replace(/\/?\/$/, ""), "/").concat(r.replace(/^\/+/, ""));
    }
    throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
  }
  getAccessToken(t) {
    return this.config.getAccessToken ? this.config.getAccessToken(t) : this.hooks.getAccessToken(t);
  }
  extractUrl(t) {
    return typeof t == "string" ? t : t instanceof URL ? t.href : t.url;
  }
  buildBaseRequest(t, r) {
    if (!this.config.baseUrl) return new Request(t, r);
    const n = this.buildUrl(this.config.baseUrl, this.extractUrl(t)), i = t instanceof Request ? new Request(n, t) : n;
    return new Request(i, r);
  }
  setAuthorizationHeader(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : gl.Bearer;
    t.headers.set("authorization", "".concat(n, " ").concat(r));
  }
  async setDpopProofHeader(t, r) {
    if (!this.config.dpopNonceId) return;
    const n = await this.hooks.getDpopNonce(), i = await this.hooks.generateDpopProof({ accessToken: r, method: t.method, nonce: n, url: t.url });
    t.headers.set("dpop", i);
  }
  async prepareRequest(t, r) {
    const n = await this.getAccessToken(r);
    let i, a;
    typeof n == "string" ? (i = this.config.dpopNonceId ? gl.DPoP : gl.Bearer, a = n) : (i = n.token_type, a = n.access_token), this.setAuthorizationHeader(t, a, i), i === gl.DPoP && await this.setDpopProofHeader(t, a);
  }
  getHeader(t, r) {
    return Array.isArray(t) ? new Headers(t).get(r) || "" : typeof t.get == "function" ? t.get(r) || "" : t[r] || "";
  }
  hasUseDpopNonceError(t) {
    if (t.status !== 401) return !1;
    const r = this.getHeader(t.headers, "www-authenticate");
    return r.includes("invalid_dpop_nonce") || r.includes("use_dpop_nonce");
  }
  async handleResponse(t, r) {
    const n = this.getHeader(t.headers, "dpop-nonce");
    if (n && await this.hooks.setDpopNonce(n), !this.hasUseDpopNonceError(t)) return t;
    if (!n || !r.onUseDpopNonceError) throw new G8(n);
    return r.onUseDpopNonceError();
  }
  async internalFetchWithAuth(t, r, n, i) {
    const a = this.buildBaseRequest(t, r);
    await this.prepareRequest(a, i);
    const o = await this.config.fetch(a);
    return this.handleResponse(o, n);
  }
  fetchWithAuth(t, r, n) {
    const i = { onUseDpopNonceError: () => this.internalFetchWithAuth(t, r, Object.assign(Object.assign({}, i), { onUseDpopNonceError: void 0 }), n) };
    return this.internalFetchWithAuth(t, r, i, n);
  }
}
let hE = class {
  constructor(t, r) {
    this.myAccountFetcher = t, this.apiBase = r;
  }
  async connectAccount(t) {
    const r = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/connect"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) });
    return this._handleResponse(r);
  }
  async completeAccount(t) {
    const r = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/complete"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) });
    return this._handleResponse(r);
  }
  async _handleResponse(t) {
    let r;
    try {
      r = await t.text(), r = JSON.parse(r);
    } catch (n) {
      throw new Kv({ type: "invalid_json", status: t.status, title: "Invalid JSON response", detail: r || String(n) });
    }
    if (t.ok) return r;
    throw new Kv(r);
  }
}, Kv = class sb extends Error {
  constructor(t) {
    let { type: r, status: n, title: i, detail: a, validation_errors: o } = t;
    super(a), this.name = "MyAccountApiError", this.type = r, this.status = n, this.title = i, this.detail = a, this.validation_errors = o, Object.setPrototypeOf(this, sb.prototype);
  }
};
const fE = { otp: { authenticatorTypes: ["otp"] }, sms: { authenticatorTypes: ["oob"], oobChannels: ["sms"] }, email: { authenticatorTypes: ["oob"], oobChannels: ["email"] }, push: { authenticatorTypes: ["oob"], oobChannels: ["auth0"] }, voice: { authenticatorTypes: ["oob"], oobChannels: ["voice"] } }, pE = "http://auth0.com/oauth/grant-type/mfa-otp", mE = "http://auth0.com/oauth/grant-type/mfa-oob", gE = "http://auth0.com/oauth/grant-type/mfa-recovery-code";
function lb(e, t) {
  this.v = e, this.k = t;
}
function Ir(e, t, r) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : r;
  throw new TypeError("Private element is not present on this object");
}
function vE(e) {
  return new lb(e, 0);
}
function db(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function be(e, t) {
  return e.get(Ir(e, t));
}
function Lr(e, t, r) {
  db(e, t), t.set(e, r);
}
function cr(e, t, r) {
  return e.set(Ir(e, t), r), r;
}
function $e(e, t, r) {
  return (t = (function(n) {
    var i = (function(a, o) {
      if (typeof a != "object" || !a) return a;
      var s = a[Symbol.toPrimitive];
      if (s !== void 0) {
        var l = s.call(a, o);
        if (typeof l != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(a);
    })(n, "string");
    return typeof i == "symbol" ? i : i + "";
  })(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Gv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter((function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function qe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gv(Object(r), !0).forEach((function(n) {
      $e(e, n, r[n]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gv(Object(r)).forEach((function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    }));
  }
  return e;
}
function Zv(e, t) {
  if (e == null) return {};
  var r, n, i = (function(o, s) {
    if (o == null) return {};
    var l = {};
    for (var d in o) if ({}.hasOwnProperty.call(o, d)) {
      if (s.indexOf(d) !== -1) continue;
      l[d] = o[d];
    }
    return l;
  })(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function yE(e) {
  return function() {
    return new gc(e.apply(this, arguments));
  };
}
function gc(e) {
  var t, r;
  function n(a, o) {
    try {
      var s = e[a](o), l = s.value, d = l instanceof lb;
      Promise.resolve(d ? l.v : l).then((function(c) {
        if (d) {
          var u = a === "return" ? "return" : "next";
          if (!l.k || c.done) return n(u, c);
          c = e[u](c).value;
        }
        i(s.done ? "return" : "normal", c);
      }), (function(c) {
        n("throw", c);
      }));
    } catch (c) {
      i("throw", c);
    }
  }
  function i(a, o) {
    switch (a) {
      case "return":
        t.resolve({ value: o, done: !0 });
        break;
      case "throw":
        t.reject(o);
        break;
      default:
        t.resolve({ value: o, done: !1 });
    }
    (t = t.next) ? n(t.key, t.arg) : r = null;
  }
  this._invoke = function(a, o) {
    return new Promise((function(s, l) {
      var d = { key: a, arg: o, resolve: s, reject: l, next: null };
      r ? r = r.next = d : (t = r = d, n(a, o));
    }));
  }, typeof e.return != "function" && (this.return = void 0);
}
var f0, Xf;
let Vp;
gc.prototype[typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
  return this;
}, gc.prototype.next = function(e) {
  return this._invoke("next", e);
}, gc.prototype.throw = function(e) {
  return this._invoke("throw", e);
}, gc.prototype.return = function(e) {
  return this._invoke("return", e);
}, (typeof navigator > "u" || (f0 = navigator.userAgent) === null || f0 === void 0 || (Xf = f0.startsWith) === null || Xf === void 0 || !Xf.call(f0, "Mozilla/5.0 ")) && (Vp = "".concat("oauth4webapi", "/").concat("v3.8.3"));
function bd(e, t) {
  if (e == null) return !1;
  try {
    return e instanceof t || Object.getPrototypeOf(e)[Symbol.toStringTag] === t.prototype[Symbol.toStringTag];
  } catch {
    return !1;
  }
}
function Vt(e, t, r) {
  const n = new TypeError(e, { cause: r });
  return Object.assign(n, { code: t }), n;
}
const ni = /* @__PURE__ */ Symbol(), Up = /* @__PURE__ */ Symbol(), qp = /* @__PURE__ */ Symbol(), Di = /* @__PURE__ */ Symbol(), xa = /* @__PURE__ */ Symbol(), bE = new TextEncoder(), wE = new TextDecoder();
function Ol(e) {
  return typeof e == "string" ? bE.encode(e) : wE.decode(e);
}
let Bp, cb;
Uint8Array.prototype.toBase64 ? Bp = (e) => (e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({ alphabet: "base64url", omitPadding: !0 })) : Bp = (t) => {
  t instanceof ArrayBuffer && (t = new Uint8Array(t));
  const r = [];
  for (let n = 0; n < t.byteLength; n += 32768) r.push(String.fromCharCode.apply(null, t.subarray(n, n + 32768)));
  return btoa(r.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
function ms(e) {
  return typeof e == "string" ? cb(e) : Bp(e);
}
cb = Uint8Array.fromBase64 ? (e) => {
  try {
    return Uint8Array.fromBase64(e, { alphabet: "base64url" });
  } catch (t) {
    throw Vt("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", t);
  }
} : (e) => {
  try {
    const t = atob(e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "")), r = new Uint8Array(t.length);
    for (let n = 0; n < t.length; n++) r[n] = t.charCodeAt(n);
    return r;
  } catch (t) {
    throw Vt("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", t);
  }
};
let Un = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), $e(this, "code", void 0), this.name = this.constructor.name, this.code = Qp, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}, _g = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), $e(this, "code", void 0), this.name = this.constructor.name, r != null && r.code && (this.code = r?.code), (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
function Ke(e, t, r) {
  return new _g(e, { code: t, cause: r });
}
function $E(e, t) {
  if ((function(r, n) {
    if (!(r instanceof CryptoKey)) throw Vt("".concat(n, " must be a CryptoKey"), "ERR_INVALID_ARG_TYPE");
  })(e, t), e.type !== "private") throw Vt("".concat(t, " must be a private CryptoKey"), "ERR_INVALID_ARG_VALUE");
}
function D1(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function zh(e) {
  bd(e, Headers) && (e = Object.fromEntries(e.entries()));
  const t = new Headers(e ?? {});
  if (Vp && !t.has("user-agent") && t.set("user-agent", Vp), t.has("authorization")) throw Vt('"options.headers" must not include the "authorization" header name', "ERR_INVALID_ARG_VALUE");
  return t;
}
function ub(e, t) {
  if (t !== void 0) {
    if (typeof t == "function" && (t = t(e.href)), !(t instanceof AbortSignal)) throw Vt('"options.signal" must return or be an instance of AbortSignal', "ERR_INVALID_ARG_TYPE");
    return t;
  }
}
function Yv(e) {
  return e.includes("//") ? e.replace("//", "/") : e;
}
async function kE(e, t) {
  return (async function(r, n, i, a) {
    if (!(r instanceof URL)) throw Vt('"'.concat(n, '" must be an instance of URL'), "ERR_INVALID_ARG_TYPE");
    xg(r, a?.[ni] !== !0);
    const o = i(new URL(r.href)), s = zh(a?.headers);
    return s.set("accept", "application/json"), (a?.[Di] || fetch)(o.href, { body: void 0, headers: Object.fromEntries(s.entries()), method: "GET", redirect: "manual", signal: ub(o, a?.signal) });
  })(e, "issuerIdentifier", ((r) => {
    switch (t?.algorithm) {
      case void 0:
      case "oidc":
        (function(n, i) {
          n.pathname = Yv("".concat(n.pathname, "/").concat(i));
        })(r, ".well-known/openid-configuration");
        break;
      case "oauth2":
        (function(n, i) {
          let a = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
          n.pathname === "/" ? n.pathname = i : n.pathname = Yv("".concat(i, "/").concat(a ? n.pathname : n.pathname.replace(/(\/)$/, "")));
        })(r, ".well-known/oauth-authorization-server");
        break;
      default:
        throw Vt('"options.algorithm" must be "oidc" (default), or "oauth2"', "ERR_INVALID_ARG_VALUE");
    }
    return r;
  }), t);
}
function lo(e, t, r, n, i) {
  try {
    if (typeof e != "number" || !Number.isFinite(e)) throw Vt("".concat(r, " must be a number"), "ERR_INVALID_ARG_TYPE", i);
    if (e > 0) return;
    if (t) {
      if (e !== 0) throw Vt("".concat(r, " must be a non-negative number"), "ERR_INVALID_ARG_VALUE", i);
      return;
    }
    throw Vt("".concat(r, " must be a positive number"), "ERR_INVALID_ARG_VALUE", i);
  } catch (a) {
    throw n ? Ke(a.message, n, i) : a;
  }
}
function Mr(e, t, r, n) {
  try {
    if (typeof e != "string") throw Vt("".concat(t, " must be a string"), "ERR_INVALID_ARG_TYPE", n);
    if (e.length === 0) throw Vt("".concat(t, " must not be empty"), "ERR_INVALID_ARG_VALUE", n);
  } catch (i) {
    throw r ? Ke(i.message, r, n) : i;
  }
}
function hb(e) {
  (function(t, r) {
    if (gb(t) !== r) throw (function(n) {
      let i = '"response" content-type must be ';
      for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++) o[s - 1] = arguments[s];
      if (o.length > 2) {
        const l = o.pop();
        i += "".concat(o.join(", "), ", or ").concat(l);
      } else o.length === 2 ? i += "".concat(o[0], " or ").concat(o[1]) : i += o[0];
      return Ke(i, yb, n);
    })(t, r);
  })(e, "application/json");
}
function fb() {
  return ms(crypto.getRandomValues(new Uint8Array(32)));
}
function _E(e) {
  switch (e.algorithm.name) {
    case "RSA-PSS":
      return (function(t) {
        switch (t.algorithm.hash.name) {
          case "SHA-256":
            return "PS256";
          case "SHA-384":
            return "PS384";
          case "SHA-512":
            return "PS512";
          default:
            throw new Un("unsupported RsaHashedKeyAlgorithm hash name", { cause: t });
        }
      })(e);
    case "RSASSA-PKCS1-v1_5":
      return (function(t) {
        switch (t.algorithm.hash.name) {
          case "SHA-256":
            return "RS256";
          case "SHA-384":
            return "RS384";
          case "SHA-512":
            return "RS512";
          default:
            throw new Un("unsupported RsaHashedKeyAlgorithm hash name", { cause: t });
        }
      })(e);
    case "ECDSA":
      return (function(t) {
        switch (t.algorithm.namedCurve) {
          case "P-256":
            return "ES256";
          case "P-384":
            return "ES384";
          case "P-521":
            return "ES512";
          default:
            throw new Un("unsupported EcKeyAlgorithm namedCurve", { cause: t });
        }
      })(e);
    case "Ed25519":
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      return e.algorithm.name;
    case "EdDSA":
      return "Ed25519";
    default:
      throw new Un("unsupported CryptoKey algorithm name", { cause: e });
  }
}
function M1(e) {
  const t = e?.[Up];
  return typeof t == "number" && Number.isFinite(t) ? t : 0;
}
function Hp(e) {
  const t = e?.[qp];
  return typeof t == "number" && Number.isFinite(t) && Math.sign(t) !== -1 ? t : 30;
}
function R1() {
  return Math.floor(Date.now() / 1e3);
}
function Ci(e) {
  if (typeof e != "object" || e === null) throw Vt('"as" must be an object', "ERR_INVALID_ARG_TYPE");
  Mr(e.issuer, '"as.issuer"');
}
function Ei(e) {
  if (typeof e != "object" || e === null) throw Vt('"client" must be an object', "ERR_INVALID_ARG_TYPE");
  Mr(e.client_id, '"client.client_id"');
}
function Jv(e) {
  return Mr(e, '"clientSecret"'), (t, r, n, i) => {
    n.set("client_id", r.client_id), n.set("client_secret", e);
  };
}
function xE(e, t) {
  const { key: r, kid: n } = (i = e) instanceof CryptoKey ? { key: i } : i?.key instanceof CryptoKey ? (i.kid !== void 0 && Mr(i.kid, '"kid"'), { key: i.key, kid: i.kid }) : {};
  var i;
  return $E(r, '"clientPrivateKey.key"'), async (a, o, s, l) => {
    const d = { alg: _E(r), kid: n }, c = (function(u, h) {
      const f = R1() + M1(h);
      return { jti: fb(), aud: u.issuer, exp: f + 60, iat: f, nbf: f, iss: h.client_id, sub: h.client_id };
    })(a, o);
    s.set("client_id", o.client_id), s.set("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), s.set("client_assertion", await (async function(u, h, f) {
      if (!f.usages.includes("sign")) throw Vt('CryptoKey instances used for signing assertions must include "sign" in their "usages"', "ERR_INVALID_ARG_VALUE");
      const p = "".concat(ms(Ol(JSON.stringify(u))), ".").concat(ms(Ol(JSON.stringify(h)))), m = ms(await crypto.subtle.sign((function(y) {
        switch (y.algorithm.name) {
          case "ECDSA":
            return { name: y.algorithm.name, hash: UE(y) };
          case "RSA-PSS":
            switch (t4(y), y.algorithm.hash.name) {
              case "SHA-256":
              case "SHA-384":
              case "SHA-512":
                return { name: y.algorithm.name, saltLength: parseInt(y.algorithm.hash.name.slice(-3), 10) >> 3 };
              default:
                throw new Un("unsupported RSA-PSS hash name", { cause: y });
            }
          case "RSASSA-PKCS1-v1_5":
            return t4(y), y.algorithm.name;
          case "ML-DSA-44":
          case "ML-DSA-65":
          case "ML-DSA-87":
          case "Ed25519":
            return y.algorithm.name;
        }
        throw new Un("unsupported CryptoKey algorithm name", { cause: y });
      })(f), f, Ol(p)));
      return "".concat(p, ".").concat(m);
    })(d, c, r));
  };
}
const SE = URL.parse ? (e, t) => URL.parse(e, t) : (e, t) => {
  try {
    return new URL(e, t);
  } catch {
    return null;
  }
};
function xg(e, t) {
  if (t && e.protocol !== "https:") throw Ke("only requests to HTTPS are allowed", bb, e);
  if (e.protocol !== "https:" && e.protocol !== "http:") throw Ke("only HTTP and HTTPS requests are allowed", wb, e);
}
function Xv(e, t, r, n) {
  let i;
  if (typeof e != "string" || !(i = SE(e))) throw Ke("authorization server metadata does not contain a valid ".concat(r ? '"as.mtls_endpoint_aliases.'.concat(t, '"') : '"as.'.concat(t, '"')), e === void 0 ? zE : VE, { attribute: r ? "mtls_endpoint_aliases.".concat(t) : t });
  return xg(i, n), i;
}
function Iu(e, t, r, n) {
  return r && e.mtls_endpoint_aliases && t in e.mtls_endpoint_aliases ? Xv(e.mtls_endpoint_aliases[t], t, r, n) : Xv(e[t], t, r, n);
}
let Vh = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), $e(this, "cause", void 0), $e(this, "code", void 0), $e(this, "error", void 0), $e(this, "status", void 0), $e(this, "error_description", void 0), $e(this, "response", void 0), this.name = this.constructor.name, this.code = FE, this.cause = r.cause, this.error = r.cause.error, this.status = r.response.status, this.error_description = r.cause.error_description, Object.defineProperty(this, "response", { enumerable: !1, value: r.response }), (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}, pb = class extends Error {
  constructor(t, r) {
    var n, i;
    super(t, r), $e(this, "cause", void 0), $e(this, "code", void 0), $e(this, "error", void 0), $e(this, "error_description", void 0), this.name = this.constructor.name, this.code = jE, this.cause = r.cause, this.error = r.cause.get("error"), this.error_description = (n = r.cause.get("error_description")) !== null && n !== void 0 ? n : void 0, (i = Error.captureStackTrace) === null || i === void 0 || i.call(Error, this, this.constructor);
  }
}, Sg = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), $e(this, "cause", void 0), $e(this, "code", void 0), $e(this, "response", void 0), $e(this, "status", void 0), this.name = this.constructor.name, this.code = LE, this.cause = r.cause, this.status = r.response.status, this.response = r.response, Object.defineProperty(this, "response", { enumerable: !1 }), (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
const CE = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+", EE = new RegExp("^[,\\s]*(" + CE + ")"), AE = new RegExp('^[,\\s]*([a-zA-Z0-9!#$%&\\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*"((?:[^"\\\\]|\\\\[\\s\\S])*)"[,\\s]*(.*)'), TE = new RegExp("^[,\\s]*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)[,\\s]*(.*)"), OE = new RegExp("^([a-zA-Z0-9\\-\\._\\~\\+\\/]+={0,2})(?:$|[,\\s])(.*)");
async function Cg(e, t, r) {
  if (e.status !== t) {
    let i;
    var n;
    throw (function(a) {
      let o;
      if (o = (function(s) {
        if (!bd(s, Response)) throw Vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
        const l = s.headers.get("www-authenticate");
        if (l === null) return;
        const d = [];
        let c = l;
        for (; c; ) {
          var u;
          let h = c.match(EE);
          const f = (u = h) === null || u === void 0 ? void 0 : u[1].toLowerCase();
          if (!f) return;
          const p = c.substring(h[0].length);
          if (p && !p.match(/^[\s,]/)) return;
          const m = p.match(/^\s+(.*)$/), y = !!m;
          c = m ? m[1] : void 0;
          const v = {};
          let b;
          if (y) for (; c; ) {
            let _, x;
            if (h = c.match(AE)) {
              if ([, _, x, c] = h, x.includes("\\")) try {
                x = JSON.parse('"'.concat(x, '"'));
              } catch {
              }
              v[_.toLowerCase()] = x;
            } else {
              if (!(h = c.match(TE))) {
                if (h = c.match(OE)) {
                  if (Object.keys(v).length) break;
                  [, b, c] = h;
                  break;
                }
                return;
              }
              [, _, x, c] = h, v[_.toLowerCase()] = x;
            }
          }
          else c = p || void 0;
          const $ = { scheme: f, parameters: v };
          b && ($.token68 = b), d.push($);
        }
        return d.length ? d : void 0;
      })(a)) throw new Sg("server responded with a challenge in the WWW-Authenticate HTTP Header", { cause: o, response: a });
    })(e), (i = await (async function(a) {
      if (a.status > 399 && a.status < 500) {
        Nu(a), hb(a);
        try {
          const o = await a.clone().json();
          if (D1(o) && typeof o.error == "string" && o.error.length) return o;
        } catch {
        }
      }
    })(e)) ? (await ((n = e.body) === null || n === void 0 ? void 0 : n.cancel()), new Vh("server responded with an error in the response body", { cause: i, response: e })) : Ke('"response" is not a conform '.concat(r, " response (unexpected HTTP status code)"), Tg, e);
  }
}
function mb(e) {
  if (!Ag.has(e)) throw Vt('"options.DPoP" is not a valid DPoPHandle', "ERR_INVALID_ARG_VALUE");
}
function gb(e) {
  var t;
  return (t = e.headers.get("content-type")) === null || t === void 0 ? void 0 : t.split(";")[0];
}
async function Eg(e, t, r, n, i, a, o) {
  return await r(e, t, i, a), a.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), (o?.[Di] || fetch)(n.href, { body: i, headers: Object.fromEntries(a.entries()), method: "POST", redirect: "manual", signal: ub(n, o?.signal) });
}
async function Pu(e, t, r, n, i, a) {
  var o;
  const s = Iu(e, "token_endpoint", t.use_mtls_endpoint_aliases, a?.[ni] !== !0);
  i.set("grant_type", n);
  const l = zh(a?.headers);
  l.set("accept", "application/json"), a?.DPoP !== void 0 && (mb(a.DPoP), await a.DPoP.addProof(s, l, "POST"));
  const d = await Eg(e, t, r, s, i, l, a);
  return a == null || (o = a.DPoP) === null || o === void 0 || o.cacheNonce(d, s), d;
}
const vb = /* @__PURE__ */ new WeakMap(), IE = /* @__PURE__ */ new WeakMap();
function Wp(e) {
  if (!e.id_token) return;
  const t = vb.get(e);
  if (!t) throw Vt('"ref" was already garbage collected or did not resolve from the proper sources', "ERR_INVALID_ARG_VALUE");
  return t;
}
async function Kl(e, t, r, n, i, a) {
  if (Ci(e), Ei(t), !bd(r, Response)) throw Vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
  await Cg(r, 200, "Token Endpoint"), Nu(r);
  const o = await Uh(r);
  if (Mr(o.access_token, '"response" body "access_token" property', wt, { body: o }), Mr(o.token_type, '"response" body "token_type" property', wt, { body: o }), o.token_type = o.token_type.toLowerCase(), o.expires_in !== void 0) {
    let s = typeof o.expires_in != "number" ? parseFloat(o.expires_in) : o.expires_in;
    lo(s, !0, '"response" body "expires_in" property', wt, { body: o }), o.expires_in = s;
  }
  if (o.refresh_token !== void 0 && Mr(o.refresh_token, '"response" body "refresh_token" property', wt, { body: o }), o.scope !== void 0 && typeof o.scope != "string") throw Ke('"response" body "scope" property must be a string', wt, { body: o });
  if (o.id_token !== void 0) {
    Mr(o.id_token, '"response" body "id_token" property', wt, { body: o });
    const s = ["aud", "exp", "iat", "iss", "sub"];
    t.require_auth_time === !0 && s.push("auth_time"), t.default_max_age !== void 0 && (lo(t.default_max_age, !0, '"client.default_max_age"'), s.push("auth_time")), n != null && n.length && s.push(...n);
    const { claims: l, jwt: d } = await (async function(c, u, h, f, p) {
      let m, y, { 0: v, 1: b, length: $ } = c.split(".");
      if ($ === 5) {
        if (p === void 0) throw new Un("JWE decryption is not configured", { cause: c });
        c = await p(c), { 0: v, 1: b, length: $ } = c.split(".");
      }
      if ($ !== 3) throw Ke("Invalid JWT", wt, c);
      try {
        m = JSON.parse(Ol(ms(v)));
      } catch (x) {
        throw Ke("failed to parse JWT Header body as base64url encoded JSON", L1, x);
      }
      if (!D1(m)) throw Ke("JWT Header must be a top level object", wt, c);
      if (u(m), m.crit !== void 0) throw new Un('no JWT "crit" header parameter extensions are supported', { cause: { header: m } });
      try {
        y = JSON.parse(Ol(ms(b)));
      } catch (x) {
        throw Ke("failed to parse JWT Payload body as base64url encoded JSON", L1, x);
      }
      if (!D1(y)) throw Ke("JWT Payload must be a top level object", wt, c);
      const _ = R1() + h;
      if (y.exp !== void 0) {
        if (typeof y.exp != "number") throw Ke('unexpected JWT "exp" (expiration time) claim type', wt, { claims: y });
        if (y.exp <= _ - f) throw Ke('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', Gc, { claims: y, now: _, tolerance: f, claim: "exp" });
      }
      if (y.iat !== void 0 && typeof y.iat != "number") throw Ke('unexpected JWT "iat" (issued at) claim type', wt, { claims: y });
      if (y.iss !== void 0 && typeof y.iss != "string") throw Ke('unexpected JWT "iss" (issuer) claim type', wt, { claims: y });
      if (y.nbf !== void 0) {
        if (typeof y.nbf != "number") throw Ke('unexpected JWT "nbf" (not before) claim type', wt, { claims: y });
        if (y.nbf > _ + f) throw Ke('unexpected JWT "nbf" (not before) claim value', Gc, { claims: y, now: _, tolerance: f, claim: "nbf" });
      }
      if (y.aud !== void 0 && typeof y.aud != "string" && !Array.isArray(y.aud)) throw Ke('unexpected JWT "aud" (audience) claim type', wt, { claims: y });
      return { header: m, claims: y, jwt: c };
    })(o.id_token, BE.bind(void 0, t.id_token_signed_response_alg, e.id_token_signing_alg_values_supported, "RS256"), M1(t), Hp(t), i).then(ME.bind(void 0, s)).then(NE.bind(void 0, e)).then(PE.bind(void 0, t.client_id));
    if (Array.isArray(l.aud) && l.aud.length !== 1) {
      if (l.azp === void 0) throw Ke('ID Token "aud" (audience) claim includes additional untrusted audiences', _a, { claims: l, claim: "aud" });
      if (l.azp !== t.client_id) throw Ke('unexpected ID Token "azp" (authorized party) claim value', _a, { expected: t.client_id, claims: l, claim: "azp" });
    }
    l.auth_time !== void 0 && lo(l.auth_time, !0, 'ID Token "auth_time" (authentication time)', wt, { claims: l }), IE.set(r, d), vb.set(o, l);
  }
  if (a?.[o.token_type] !== void 0) a[o.token_type](r, o);
  else if (o.token_type !== "dpop" && o.token_type !== "bearer") throw new Un("unsupported `token_type` value", { cause: { body: o } });
  return o;
}
function PE(e, t) {
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e)) throw Ke('unexpected JWT "aud" (audience) claim value', _a, { expected: e, claims: t.claims, claim: "aud" });
  } else if (t.claims.aud !== e) throw Ke('unexpected JWT "aud" (audience) claim value', _a, { expected: e, claims: t.claims, claim: "aud" });
  return t;
}
function NE(e, t) {
  var r, n;
  const i = (r = (n = e[$b]) === null || n === void 0 ? void 0 : n.call(e, t)) !== null && r !== void 0 ? r : e.issuer;
  if (t.claims.iss !== i) throw Ke('unexpected JWT "iss" (issuer) claim value', _a, { expected: i, claims: t.claims, claim: "iss" });
  return t;
}
const Ag = /* @__PURE__ */ new WeakSet(), e4 = /* @__PURE__ */ Symbol(), DE = { aud: "audience", c_hash: "code hash", client_id: "client id", exp: "expiration time", iat: "issued at", iss: "issuer", jti: "jwt id", nonce: "nonce", s_hash: "state hash", sub: "subject", ath: "access token hash", htm: "http method", htu: "http uri", cnf: "confirmation", auth_time: "authentication time" };
function ME(e, t) {
  for (const r of e) if (t.claims[r] === void 0) throw Ke('JWT "'.concat(r, '" (').concat(DE[r], ") claim missing"), wt, { claims: t.claims });
  return t;
}
const e2 = /* @__PURE__ */ Symbol(), t2 = /* @__PURE__ */ Symbol();
async function RE(e, t, r, n) {
  return typeof n?.expectedNonce == "string" || typeof n?.maxAge == "number" || n != null && n.requireIdToken ? (async function(i, a, o, s, l, d, c) {
    const u = [];
    switch (s) {
      case void 0:
        s = e2;
        break;
      case e2:
        break;
      default:
        Mr(s, '"expectedNonce" argument'), u.push("nonce");
    }
    switch (l != null || (l = a.default_max_age), l) {
      case void 0:
        l = t2;
        break;
      case t2:
        break;
      default:
        lo(l, !0, '"maxAge" argument'), u.push("auth_time");
    }
    const h = await Kl(i, a, o, u, d, c);
    Mr(h.id_token, '"response" body "id_token" property', wt, { body: h });
    const f = Wp(h);
    if (l !== t2) {
      const p = R1() + M1(a), m = Hp(a);
      if (f.auth_time + l < p - m) throw Ke("too much time has elapsed since the last End-User authentication", Gc, { claims: f, now: p, tolerance: m, claim: "auth_time" });
    }
    if (s === e2) {
      if (f.nonce !== void 0) throw Ke('unexpected ID Token "nonce" claim value', _a, { expected: void 0, claims: f, claim: "nonce" });
    } else if (f.nonce !== s) throw Ke('unexpected ID Token "nonce" claim value', _a, { expected: s, claims: f, claim: "nonce" });
    return h;
  })(e, t, r, n.expectedNonce, n.maxAge, n[xa], n.recognizedTokenTypes) : (async function(i, a, o, s, l) {
    const d = await Kl(i, a, o, void 0, s, l), c = Wp(d);
    if (c) {
      if (a.default_max_age !== void 0) {
        lo(a.default_max_age, !0, '"client.default_max_age"');
        const u = R1() + M1(a), h = Hp(a);
        if (c.auth_time + a.default_max_age < u - h) throw Ke("too much time has elapsed since the last End-User authentication", Gc, { claims: c, now: u, tolerance: h, claim: "auth_time" });
      }
      if (c.nonce !== void 0) throw Ke('unexpected ID Token "nonce" claim value', _a, { expected: void 0, claims: c, claim: "nonce" });
    }
    return d;
  })(e, t, r, n?.[xa], n?.recognizedTokenTypes);
}
const LE = "OAUTH_WWW_AUTHENTICATE_CHALLENGE", FE = "OAUTH_RESPONSE_BODY_ERROR", Qp = "OAUTH_UNSUPPORTED_OPERATION", jE = "OAUTH_AUTHORIZATION_RESPONSE_ERROR", L1 = "OAUTH_PARSE_ERROR", wt = "OAUTH_INVALID_RESPONSE", yb = "OAUTH_RESPONSE_IS_NOT_JSON", Tg = "OAUTH_RESPONSE_IS_NOT_CONFORM", bb = "OAUTH_HTTP_REQUEST_FORBIDDEN", wb = "OAUTH_REQUEST_PROTOCOL_FORBIDDEN", Gc = "OAUTH_JWT_TIMESTAMP_CHECK_FAILED", _a = "OAUTH_JWT_CLAIM_COMPARISON_FAILED", Kp = "OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED", zE = "OAUTH_MISSING_SERVER_METADATA", VE = "OAUTH_INVALID_SERVER_METADATA";
function Nu(e) {
  if (e.bodyUsed) throw Vt('"response" body has been used already', "ERR_INVALID_ARG_VALUE");
}
function t4(e) {
  const { algorithm: t } = e;
  if (typeof t.modulusLength != "number" || t.modulusLength < 2048) throw new Un("unsupported ".concat(t.name, " modulusLength"), { cause: e });
}
function UE(e) {
  const { algorithm: t } = e;
  switch (t.namedCurve) {
    case "P-256":
      return "SHA-256";
    case "P-384":
      return "SHA-384";
    case "P-521":
      return "SHA-512";
    default:
      throw new Un("unsupported ECDSA namedCurve", { cause: e });
  }
}
async function qE(e) {
  if (e.method !== "POST") throw Vt("form_post responses are expected to use the POST method", "ERR_INVALID_ARG_VALUE", { cause: e });
  if (gb(e) !== "application/x-www-form-urlencoded") throw Vt("form_post responses are expected to use the application/x-www-form-urlencoded content-type", "ERR_INVALID_ARG_VALUE", { cause: e });
  return (async function(t) {
    if (t.bodyUsed) throw Vt("form_post Request instances must contain a readable body", "ERR_INVALID_ARG_VALUE", { cause: t });
    return t.text();
  })(e);
}
function BE(e, t, r, n) {
  if (e === void 0) if (Array.isArray(t)) {
    if (!t.includes(n.alg)) throw Ke('unexpected JWT "alg" header parameter', wt, { header: n, expected: t, reason: "authorization server metadata" });
  } else {
    if (r === void 0) throw Ke('missing client or server configuration to verify used JWT "alg" header parameter', void 0, { client: e, issuer: t, fallback: r });
    if (typeof r == "string" ? n.alg !== r : typeof r == "function" ? !r(n.alg) : !r.includes(n.alg)) throw Ke('unexpected JWT "alg" header parameter', wt, { header: n, expected: r, reason: "default value" });
  }
  else if (typeof e == "string" ? n.alg !== e : !e.includes(n.alg)) throw Ke('unexpected JWT "alg" header parameter', wt, { header: n, expected: e, reason: "client configuration" });
}
function Yo(e, t) {
  const { 0: r, length: n } = e.getAll(t);
  if (n > 1) throw Ke('"'.concat(t, '" parameter must be provided only once'), wt);
  return r;
}
const HE = /* @__PURE__ */ Symbol(), WE = /* @__PURE__ */ Symbol();
function QE(e, t, r, n) {
  if (Ci(e), Ei(t), r instanceof URL && (r = r.searchParams), !(r instanceof URLSearchParams)) throw Vt('"parameters" must be an instance of URLSearchParams, or URL', "ERR_INVALID_ARG_TYPE");
  if (Yo(r, "response")) throw Ke('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', wt, { parameters: r });
  const i = Yo(r, "iss"), a = Yo(r, "state");
  if (!i && e.authorization_response_iss_parameter_supported) throw Ke('response parameter "iss" (issuer) missing', wt, { parameters: r });
  if (i && i !== e.issuer) throw Ke('unexpected "iss" (issuer) response parameter value', wt, { expected: e.issuer, parameters: r });
  switch (n) {
    case void 0:
    case WE:
      if (a !== void 0) throw Ke('unexpected "state" response parameter encountered', wt, { expected: void 0, parameters: r });
      break;
    case HE:
      break;
    default:
      if (Mr(n, '"expectedState" argument'), a !== n) throw Ke(a === void 0 ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', wt, { expected: n, parameters: r });
  }
  if (Yo(r, "error")) throw new pb("authorization response from the server is an error", { cause: r });
  const o = Yo(r, "id_token"), s = Yo(r, "token");
  if (o !== void 0 || s !== void 0) throw new Un("implicit and hybrid flows are not supported");
  return l = new URLSearchParams(r), Ag.add(l), l;
  var l;
}
async function Uh(e) {
  let t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : hb;
  try {
    t = await e.json();
  } catch (n) {
    throw r(e), Ke('failed to parse "response" body as JSON', L1, n);
  }
  if (!D1(t)) throw Ke('"response" body must be a top level object', wt, { body: t });
  return t;
}
const r2 = /* @__PURE__ */ Symbol(), $b = /* @__PURE__ */ Symbol(), r4 = new TextEncoder(), Zc = new TextDecoder();
function n2(e) {
  const t = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    if (n > 127) throw new TypeError("non-ASCII string encountered in encode()");
    t[r] = n;
  }
  return t;
}
function kb(e) {
  if (Uint8Array.fromBase64) return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++) r[n] = t.charCodeAt(n);
  return r;
}
function Oc(e) {
  if (Uint8Array.fromBase64) return Uint8Array.fromBase64(typeof e == "string" ? e : Zc.decode(e), { alphabet: "base64url" });
  let t = e;
  t instanceof Uint8Array && (t = Zc.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return kb(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
let nn = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), $e(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
$e(nn, "code", "ERR_JOSE_GENERIC");
let ui = class extends nn {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), $e(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), $e(this, "claim", void 0), $e(this, "reason", void 0), $e(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
};
$e(ui, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
let Gp = class extends nn {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), $e(this, "code", "ERR_JWT_EXPIRED"), $e(this, "claim", void 0), $e(this, "reason", void 0), $e(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
};
$e(Gp, "code", "ERR_JWT_EXPIRED");
let _b = class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
  }
};
$e(_b, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
let Vn = class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
};
$e(Vn, "code", "ERR_JOSE_NOT_SUPPORTED");
$e(class extends nn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), $e(this, "code", "ERR_JWE_DECRYPTION_FAILED");
  }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
$e(class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JWE_INVALID");
  }
}, "code", "ERR_JWE_INVALID");
let Hr = class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JWS_INVALID");
  }
};
$e(Hr, "code", "ERR_JWS_INVALID");
let Zp = class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JWT_INVALID");
  }
};
$e(Zp, "code", "ERR_JWT_INVALID");
$e(class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JWK_INVALID");
  }
}, "code", "ERR_JWK_INVALID");
let Og = class extends nn {
  constructor() {
    super(...arguments), $e(this, "code", "ERR_JWKS_INVALID");
  }
};
$e(Og, "code", "ERR_JWKS_INVALID");
let Ig = class extends nn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $e(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
  }
};
$e(Ig, "code", "ERR_JWKS_NO_MATCHING_KEY");
let xb = class extends nn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $e(this, Symbol.asyncIterator, void 0), $e(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
  }
};
$e(xb, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
let Sb = class extends nn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), $e(this, "code", "ERR_JWKS_TIMEOUT");
  }
};
$e(Sb, "code", "ERR_JWKS_TIMEOUT");
let Cb = class extends nn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), $e(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
  }
};
$e(Cb, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
const ji = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "algorithm.name";
  return new TypeError("CryptoKey does not support this operation, its ".concat(t, " must be ").concat(e));
}, Qs = (e, t) => e.name === t;
function i2(e) {
  return parseInt(e.name.slice(4), 10);
}
function KE(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!Qs(e.algorithm, "HMAC")) throw ji("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (i2(e.algorithm.hash) !== n) throw ji("SHA-".concat(n), "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!Qs(e.algorithm, "RSASSA-PKCS1-v1_5")) throw ji("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (i2(e.algorithm.hash) !== n) throw ji("SHA-".concat(n), "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!Qs(e.algorithm, "RSA-PSS")) throw ji("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (i2(e.algorithm.hash) !== n) throw ji("SHA-".concat(n), "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA":
      if (!Qs(e.algorithm, "Ed25519")) throw ji("Ed25519");
      break;
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      if (!Qs(e.algorithm, t)) throw ji(t);
      break;
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!Qs(e.algorithm, "ECDSA")) throw ji("ECDSA");
      const n = (function(i) {
        switch (i) {
          case "ES256":
            return "P-256";
          case "ES384":
            return "P-384";
          case "ES512":
            return "P-521";
          default:
            throw new Error("unreachable");
        }
      })(t);
      if (e.algorithm.namedCurve !== n) throw ji(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  (function(n, i) {
    if (!n.usages.includes(i)) throw new TypeError("CryptoKey does not support this operation, its usages must include ".concat(i, "."));
  })(e, r);
}
function Eb(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) n[i - 2] = arguments[i];
  if ((n = n.filter(Boolean)).length > 2) {
    const o = n.pop();
    e += "one of type ".concat(n.join(", "), ", or ").concat(o, ".");
  } else n.length === 2 ? e += "one of type ".concat(n[0], " or ").concat(n[1], ".") : e += "of type ".concat(n[0], ".");
  if (t == null) e += " Received ".concat(t);
  else if (typeof t == "function" && t.name) e += " Received function ".concat(t.name);
  else if (typeof t == "object" && t != null) {
    var a;
    (a = t.constructor) !== null && a !== void 0 && a.name && (e += " Received an instance of ".concat(t.constructor.name));
  }
  return e;
}
const n4 = function(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) n[i - 2] = arguments[i];
  return Eb("Key for the ".concat(e, " algorithm must be "), t, ...n);
}, Ab = (e) => {
  if (e?.[Symbol.toStringTag] === "CryptoKey") return !0;
  try {
    return e instanceof CryptoKey;
  } catch {
    return !1;
  }
}, Tb = (e) => e?.[Symbol.toStringTag] === "KeyObject", i4 = (e) => Ab(e) || Tb(e);
function vo(e) {
  if (typeof (t = e) != "object" || t === null || Object.prototype.toString.call(e) !== "[object Object]") return !1;
  var t;
  if (Object.getPrototypeOf(e) === null) return !0;
  let r = e;
  for (; Object.getPrototypeOf(r) !== null; ) r = Object.getPrototypeOf(r);
  return Object.getPrototypeOf(e) === r;
}
const a2 = (e, t) => {
  if (e.byteLength !== t.length) return !1;
  for (let r = 0; r < e.byteLength; r++) if (e[r] !== t[r]) return !1;
  return !0;
}, Ic = (e) => {
  const t = e.data[e.pos++];
  if (128 & t) {
    const r = 127 & t;
    let n = 0;
    for (let i = 0; i < r; i++) n = n << 8 | e.data[e.pos++];
    return n;
  }
  return t;
}, Pc = (e, t, r) => {
  if (e.data[e.pos++] !== t) throw new Error(r);
}, a4 = (e, t) => {
  const r = e.data.subarray(e.pos, e.pos + t);
  return e.pos += t, r;
}, GE = (e) => {
  const t = ((i) => {
    Pc(i, 6, "Expected algorithm OID");
    const a = Ic(i);
    return a4(i, a);
  })(e);
  if (a2(t, [43, 101, 110])) return "X25519";
  if (!a2(t, [42, 134, 72, 206, 61, 2, 1])) throw new Error("Unsupported key algorithm");
  Pc(e, 6, "Expected curve OID");
  const r = Ic(e), n = a4(e, r);
  for (const { name: i, oid: a } of [{ name: "P-256", oid: [42, 134, 72, 206, 61, 3, 1, 7] }, { name: "P-384", oid: [43, 129, 4, 0, 34] }, { name: "P-521", oid: [43, 129, 4, 0, 35] }]) if (a2(n, a)) return i;
  throw new Error("Unsupported named curve");
}, ZE = async (e, t, r, n) => {
  var i;
  let a, o;
  const s = () => ["sign"];
  switch (r) {
    case "PS256":
    case "PS384":
    case "PS512":
      a = { name: "RSA-PSS", hash: "SHA-".concat(r.slice(-3)) }, o = s();
      break;
    case "RS256":
    case "RS384":
    case "RS512":
      a = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-".concat(r.slice(-3)) }, o = s();
      break;
    case "RSA-OAEP":
    case "RSA-OAEP-256":
    case "RSA-OAEP-384":
    case "RSA-OAEP-512":
      a = { name: "RSA-OAEP", hash: "SHA-".concat(parseInt(r.slice(-3), 10) || 1) }, o = ["decrypt", "unwrapKey"];
      break;
    case "ES256":
    case "ES384":
    case "ES512":
      a = { name: "ECDSA", namedCurve: { ES256: "P-256", ES384: "P-384", ES512: "P-521" }[r] }, o = s();
      break;
    case "ECDH-ES":
    case "ECDH-ES+A128KW":
    case "ECDH-ES+A192KW":
    case "ECDH-ES+A256KW":
      try {
        const l = n.getNamedCurve(t);
        a = l === "X25519" ? { name: "X25519" } : { name: "ECDH", namedCurve: l };
      } catch {
        throw new Vn("Invalid or unsupported key format");
      }
      o = ["deriveBits"];
      break;
    case "Ed25519":
    case "EdDSA":
      a = { name: "Ed25519" }, o = s();
      break;
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      a = { name: r }, o = s();
      break;
    default:
      throw new Vn('Invalid or unsupported "alg" (Algorithm) value');
  }
  return crypto.subtle.importKey(e, t, a, (i = n?.extractable) !== null && i !== void 0 ? i : !1, o);
}, YE = (e, t, r) => {
  var n;
  const i = ((o, s) => kb(o.replace(s, "")))(e, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
  let a = r;
  return t != null && (n = t.startsWith) !== null && n !== void 0 && n.call(t, "ECDH-ES") && (a || (a = {}), a.getNamedCurve = (o) => {
    const s = { data: o, pos: 0 };
    return (function(l) {
      Pc(l, 48, "Invalid PKCS#8 structure"), Ic(l), Pc(l, 2, "Expected version field");
      const d = Ic(l);
      l.pos += d, Pc(l, 48, "Expected algorithm identifier"), Ic(l);
    })(s), GE(s);
  }), ZE("pkcs8", i, t, a);
};
async function r1(e) {
  var t, r;
  if (!e.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: n, keyUsages: i } = (function(o) {
    let s, l;
    switch (o.kty) {
      case "AKP":
        switch (o.alg) {
          case "ML-DSA-44":
          case "ML-DSA-65":
          case "ML-DSA-87":
            s = { name: o.alg }, l = o.priv ? ["sign"] : ["verify"];
            break;
          default:
            throw new Vn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      case "RSA":
        switch (o.alg) {
          case "PS256":
          case "PS384":
          case "PS512":
            s = { name: "RSA-PSS", hash: "SHA-".concat(o.alg.slice(-3)) }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "RS256":
          case "RS384":
          case "RS512":
            s = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-".concat(o.alg.slice(-3)) }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "RSA-OAEP":
          case "RSA-OAEP-256":
          case "RSA-OAEP-384":
          case "RSA-OAEP-512":
            s = { name: "RSA-OAEP", hash: "SHA-".concat(parseInt(o.alg.slice(-3), 10) || 1) }, l = o.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
            break;
          default:
            throw new Vn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      case "EC":
        switch (o.alg) {
          case "ES256":
            s = { name: "ECDSA", namedCurve: "P-256" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ES384":
            s = { name: "ECDSA", namedCurve: "P-384" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ES512":
            s = { name: "ECDSA", namedCurve: "P-521" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ECDH-ES":
          case "ECDH-ES+A128KW":
          case "ECDH-ES+A192KW":
          case "ECDH-ES+A256KW":
            s = { name: "ECDH", namedCurve: o.crv }, l = o.d ? ["deriveBits"] : [];
            break;
          default:
            throw new Vn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      case "OKP":
        switch (o.alg) {
          case "Ed25519":
          case "EdDSA":
            s = { name: "Ed25519" }, l = o.d ? ["sign"] : ["verify"];
            break;
          case "ECDH-ES":
          case "ECDH-ES+A128KW":
          case "ECDH-ES+A192KW":
          case "ECDH-ES+A256KW":
            s = { name: o.crv }, l = o.d ? ["deriveBits"] : [];
            break;
          default:
            throw new Vn('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        }
        break;
      default:
        throw new Vn('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return { algorithm: s, keyUsages: l };
  })(e), a = qe({}, e);
  return a.kty !== "AKP" && delete a.alg, delete a.use, crypto.subtle.importKey("jwk", a, n, (t = e.ext) !== null && t !== void 0 ? t : !e.d && !e.priv, (r = e.key_ops) !== null && r !== void 0 ? r : i);
}
const Yp = (e) => vo(e) && typeof e.kty == "string";
let io;
const o4 = async function(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
  io || (io = /* @__PURE__ */ new WeakMap());
  let i = io.get(e);
  if (i != null && i[r]) return i[r];
  const a = await r1(qe(qe({}, t), {}, { alg: r }));
  return n && Object.freeze(e), i ? i[r] = a : io.set(e, { [r]: a }), a;
};
async function JE(e, t) {
  if (e instanceof Uint8Array || Ab(e)) return e;
  if (Tb(e)) {
    if (e.type === "secret") return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function") try {
      return ((n, i) => {
        io || (io = /* @__PURE__ */ new WeakMap());
        let a = io.get(n);
        if (a != null && a[i]) return a[i];
        const o = n.type === "public", s = !!o;
        let l;
        if (n.asymmetricKeyType === "x25519") {
          switch (i) {
            case "ECDH-ES":
            case "ECDH-ES+A128KW":
            case "ECDH-ES+A192KW":
            case "ECDH-ES+A256KW":
              break;
            default:
              throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          }
          l = n.toCryptoKey(n.asymmetricKeyType, s, o ? [] : ["deriveBits"]);
        }
        if (n.asymmetricKeyType === "ed25519") {
          if (i !== "EdDSA" && i !== "Ed25519") throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          l = n.toCryptoKey(n.asymmetricKeyType, s, [o ? "verify" : "sign"]);
        }
        switch (n.asymmetricKeyType) {
          case "ml-dsa-44":
          case "ml-dsa-65":
          case "ml-dsa-87":
            if (i !== n.asymmetricKeyType.toUpperCase()) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
            l = n.toCryptoKey(n.asymmetricKeyType, s, [o ? "verify" : "sign"]);
        }
        if (n.asymmetricKeyType === "rsa") {
          let c;
          switch (i) {
            case "RSA-OAEP":
              c = "SHA-1";
              break;
            case "RS256":
            case "PS256":
            case "RSA-OAEP-256":
              c = "SHA-256";
              break;
            case "RS384":
            case "PS384":
            case "RSA-OAEP-384":
              c = "SHA-384";
              break;
            case "RS512":
            case "PS512":
            case "RSA-OAEP-512":
              c = "SHA-512";
              break;
            default:
              throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          }
          if (i.startsWith("RSA-OAEP")) return n.toCryptoKey({ name: "RSA-OAEP", hash: c }, s, o ? ["encrypt"] : ["decrypt"]);
          l = n.toCryptoKey({ name: i.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5", hash: c }, s, [o ? "verify" : "sign"]);
        }
        if (n.asymmetricKeyType === "ec") {
          var d;
          const c = (/* @__PURE__ */ new Map([["prime256v1", "P-256"], ["secp384r1", "P-384"], ["secp521r1", "P-521"]])).get((d = n.asymmetricKeyDetails) === null || d === void 0 ? void 0 : d.namedCurve);
          if (!c) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
          i === "ES256" && c === "P-256" && (l = n.toCryptoKey({ name: "ECDSA", namedCurve: c }, s, [o ? "verify" : "sign"])), i === "ES384" && c === "P-384" && (l = n.toCryptoKey({ name: "ECDSA", namedCurve: c }, s, [o ? "verify" : "sign"])), i === "ES512" && c === "P-521" && (l = n.toCryptoKey({ name: "ECDSA", namedCurve: c }, s, [o ? "verify" : "sign"])), i.startsWith("ECDH-ES") && (l = n.toCryptoKey({ name: "ECDH", namedCurve: c }, s, o ? [] : ["deriveBits"]));
        }
        if (!l) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
        return a ? a[i] = l : io.set(n, { [i]: l }), l;
      })(e, t);
    } catch (n) {
      if (n instanceof TypeError) throw n;
    }
    let r = e.export({ format: "jwk" });
    return o4(e, r, t);
  }
  if (Yp(e)) return e.k ? Oc(e.k) : o4(e, e, t, !0);
  throw new Error("unreachable");
}
const Ks = (e) => e?.[Symbol.toStringTag], o2 = (e, t, r) => {
  if (t.use !== void 0) {
    let a;
    switch (r) {
      case "sign":
      case "verify":
        a = "sig";
        break;
      case "encrypt":
      case "decrypt":
        a = "enc";
    }
    if (t.use !== a) throw new TypeError('Invalid key for this operation, its "use" must be "'.concat(a, '" when present'));
  }
  if (t.alg !== void 0 && t.alg !== e) throw new TypeError('Invalid key for this operation, its "alg" must be "'.concat(e, '" when present'));
  if (Array.isArray(t.key_ops)) {
    var n, i;
    let a;
    switch (!0) {
      case r === "verify":
      case e === "dir":
      case e.includes("CBC-HS"):
        a = r;
        break;
      case e.startsWith("PBES2"):
        a = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        a = !e.includes("GCM") && e.endsWith("KW") ? "unwrapKey" : r;
        break;
      case r === "encrypt":
        a = "wrapKey";
        break;
      case r === "decrypt":
        a = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
    }
    if (a && ((n = t.key_ops) === null || n === void 0 || (i = n.includes) === null || i === void 0 ? void 0 : i.call(n, a)) === !1) throw new TypeError('Invalid key for this operation, its "key_ops" must include "'.concat(a, '" when present'));
  }
  return !0;
};
function XE(e, t, r) {
  switch (e.substring(0, 2)) {
    case "A1":
    case "A2":
    case "di":
    case "HS":
    case "PB":
      ((n, i, a) => {
        if (!(i instanceof Uint8Array)) {
          if (Yp(i)) {
            if (((o) => o.kty === "oct" && typeof o.k == "string")(i) && o2(n, i, a)) return;
            throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
          }
          if (!i4(i)) throw new TypeError(n4(n, i, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
          if (i.type !== "secret") throw new TypeError("".concat(Ks(i), ' instances for symmetric algorithms must be of type "secret"'));
        }
      })(e, t, r);
      break;
    default:
      ((n, i, a) => {
        if (Yp(i)) switch (a) {
          case "decrypt":
          case "sign":
            if (((o) => o.kty !== "oct" && (o.kty === "AKP" && typeof o.priv == "string" || typeof o.d == "string"))(i) && o2(n, i, a)) return;
            throw new TypeError("JSON Web Key for this operation must be a private JWK");
          case "encrypt":
          case "verify":
            if (((o) => o.kty !== "oct" && o.d === void 0 && o.priv === void 0)(i) && o2(n, i, a)) return;
            throw new TypeError("JSON Web Key for this operation must be a public JWK");
        }
        if (!i4(i)) throw new TypeError(n4(n, i, "CryptoKey", "KeyObject", "JSON Web Key"));
        if (i.type === "secret") throw new TypeError("".concat(Ks(i), ' instances for asymmetric algorithms must not be of type "secret"'));
        if (i.type === "public") switch (a) {
          case "sign":
            throw new TypeError("".concat(Ks(i), ' instances for asymmetric algorithm signing must be of type "private"'));
          case "decrypt":
            throw new TypeError("".concat(Ks(i), ' instances for asymmetric algorithm decryption must be of type "private"'));
        }
        if (i.type === "private") switch (a) {
          case "verify":
            throw new TypeError("".concat(Ks(i), ' instances for asymmetric algorithm verifying must be of type "public"'));
          case "encrypt":
            throw new TypeError("".concat(Ks(i), ' instances for asymmetric algorithm encryption must be of type "public"'));
        }
      })(e, t, r);
  }
}
var p0, s2;
let Xi, s4;
(typeof navigator > "u" || (p0 = navigator.userAgent) === null || p0 === void 0 || (s2 = p0.startsWith) === null || s2 === void 0 || !s2.call(p0, "Mozilla/5.0 ")) && (s4 = "".concat("openid-client", "/").concat("v6.8.1"), Xi = { "user-agent": s4 });
const tn = (e) => n1.get(e);
let n1, m0;
function Ob(e) {
  return e !== void 0 ? Jv(e) : (m0 || (m0 = /* @__PURE__ */ new WeakMap()), (t, r, n, i) => {
    let a;
    return (a = m0.get(r)) || ((function(o, s) {
      if (typeof o != "string") throw ea("".concat(s, " must be a string"), Mu);
      if (o.length === 0) throw ea("".concat(s, " must not be empty"), Du);
    })(r.client_secret, '"metadata.client_secret"'), a = Jv(r.client_secret), m0.set(r, a)), a(t, r, n, i);
  });
}
const ao = Di, Du = "ERR_INVALID_ARG_VALUE", Mu = "ERR_INVALID_ARG_TYPE";
function ea(e, t, r) {
  const n = new TypeError(e, { cause: r });
  return Object.assign(n, { code: t }), n;
}
function eA(e) {
  return (async function(t) {
    return Mr(t, "codeVerifier"), ms(await crypto.subtle.digest("SHA-256", Ol(t)));
  })(e);
}
function tA() {
  return fb();
}
let F1 = class extends Error {
  constructor(t, r) {
    var n;
    super(t, r), $e(this, "code", void 0), this.name = this.constructor.name, this.code = r?.code, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
function vn(e, t, r) {
  return new F1(e, { cause: t, code: r });
}
function bn(e) {
  if (e instanceof TypeError || e instanceof F1 || e instanceof Vh || e instanceof pb || e instanceof Sg) throw e;
  if (e instanceof _g) switch (e.code) {
    case bb:
      throw vn("only requests to HTTPS are allowed", e, e.code);
    case wb:
      throw vn("only requests to HTTP or HTTPS are allowed", e, e.code);
    case Tg:
      throw vn("unexpected HTTP response status code", e.cause, e.code);
    case yb:
      throw vn("unexpected response content-type", e.cause, e.code);
    case L1:
      throw vn("parsing error occured", e, e.code);
    case wt:
      throw vn("invalid response encountered", e, e.code);
    case _a:
      throw vn("unexpected JWT claim value encountered", e, e.code);
    case Kp:
      throw vn("unexpected JSON attribute value encountered", e, e.code);
    case Gc:
      throw vn("JWT timestamp claim value failed validation", e, e.code);
    default:
      throw vn(e.message, e, e.code);
  }
  if (e instanceof Un) throw vn("unsupported operation", e, e.code);
  if (e instanceof DOMException) switch (e.name) {
    case "OperationError":
      throw vn("runtime operation error", e, Qp);
    case "NotSupportedError":
      throw vn("runtime unsupported operation", e, Qp);
    case "TimeoutError":
      throw vn("operation timed out", e, "OAUTH_TIMEOUT");
    case "AbortError":
      throw vn("operation aborted", e, "OAUTH_ABORT");
  }
  throw new F1("something went wrong", { cause: e });
}
async function rA(e, t, r, n, i) {
  const a = await (async function(l, d) {
    var c, u;
    if (!(l instanceof URL)) throw ea('"server" must be an instance of URL', Mu);
    const h = !l.href.includes("/.well-known/"), f = (c = d?.timeout) !== null && c !== void 0 ? c : 30, p = AbortSignal.timeout(1e3 * f), m = await (h ? kE(l, { algorithm: d?.algorithm, [Di]: d?.[ao], [ni]: d == null || (u = d.execute) === null || u === void 0 ? void 0 : u.includes(c4), signal: p, headers: new Headers(Xi) }) : (d?.[ao] || fetch)((xg(l, d == null || (y = d.execute) === null || y === void 0 || !y.includes(c4)), l.href), { headers: Object.fromEntries(new Headers(qe({ accept: "application/json" }, Xi)).entries()), body: void 0, method: "GET", redirect: "manual", signal: p })).then(((v) => (async function(b, $) {
      const _ = b;
      if (!(_ instanceof URL) && _ !== r2) throw Vt('"expectedIssuerIdentifier" must be an instance of URL', "ERR_INVALID_ARG_TYPE");
      if (!bd($, Response)) throw Vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
      if ($.status !== 200) throw Ke('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', Tg, $);
      Nu($);
      const x = await Uh($);
      if (Mr(x.issuer, '"response" body "issuer" property', wt, { body: x }), _ !== r2 && new URL(x.issuer).href !== _.href) throw Ke('"response" body "issuer" property does not match the expected value', Kp, { expected: _.href, body: x, attribute: "issuer" });
      return x;
    })(r2, v))).catch(bn);
    var y;
    return h && new URL(m.issuer).href !== l.href && ((function(v, b, $) {
      return !(v.origin !== "https://login.microsoftonline.com" || $ != null && $.algorithm && $.algorithm !== "oidc" || (b[Ib] = !0, 0));
    })(l, m, d) || (function(v, b) {
      return !(!v.hostname.endsWith(".b2clogin.com") || b != null && b.algorithm && b.algorithm !== "oidc");
    })(l, d) || (() => {
      throw new F1("discovered metadata issuer does not match the expected issuer", { code: Kp, cause: { expected: l.href, body: m, attribute: "issuer" } });
    })()), m;
  })(e, i), o = new j1(a, t, r, n);
  let s = tn(o);
  if (i != null && i[ao] && (s.fetch = i[ao]), i != null && i.timeout && (s.timeout = i.timeout), i != null && i.execute) for (const l of i.execute) l(o);
  return o;
}
new TextDecoder();
const Ib = /* @__PURE__ */ Symbol();
let j1 = class {
  constructor(t, r, n, i) {
    var a, o, s, l, d;
    if (typeof r != "string" || !r.length) throw ea('"clientId" must be a non-empty string', Mu);
    if (typeof n == "string" && (n = { client_secret: n }), ((a = n) === null || a === void 0 ? void 0 : a.client_id) !== void 0 && r !== n.client_id) throw ea('"clientId" and "metadata.client_id" must be the same', Du);
    const c = qe(qe({}, structuredClone(n)), {}, { client_id: r });
    let u;
    c[Up] = (o = (s = n) === null || s === void 0 ? void 0 : s[Up]) !== null && o !== void 0 ? o : 0, c[qp] = (l = (d = n) === null || d === void 0 ? void 0 : d[qp]) !== null && l !== void 0 ? l : 30, u = i || (typeof c.client_secret == "string" && c.client_secret.length ? Ob(c.client_secret) : (m, y, v, b) => {
      v.set("client_id", y.client_id);
    });
    let h = Object.freeze(c);
    const f = structuredClone(t);
    Ib in t && (f[$b] = (m) => {
      let { claims: { tid: y } } = m;
      return t.issuer.replace("{tenantid}", y);
    });
    let p = Object.freeze(f);
    n1 || (n1 = /* @__PURE__ */ new WeakMap()), n1.set(this, { __proto__: null, as: p, c: h, auth: u, tlsOnly: !0, jwksCache: {} });
  }
  serverMetadata() {
    const t = structuredClone(tn(this).as);
    return (function(r) {
      Object.defineProperties(r, /* @__PURE__ */ (function(n) {
        return { supportsPKCE: { __proto__: null, value() {
          var i;
          let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "S256";
          return ((i = n.code_challenge_methods_supported) === null || i === void 0 ? void 0 : i.includes(a)) === !0;
        } } };
      })(r));
    })(t), t;
  }
  clientMetadata() {
    return structuredClone(tn(this).c);
  }
  get timeout() {
    return tn(this).timeout;
  }
  set timeout(t) {
    tn(this).timeout = t;
  }
  get [ao]() {
    return tn(this).fetch;
  }
  set [ao](t) {
    tn(this).fetch = t;
  }
};
function Ru(e) {
  Object.defineProperties(e, (function(t) {
    let r;
    if (t.expires_in !== void 0) {
      const n = /* @__PURE__ */ new Date();
      n.setSeconds(n.getSeconds() + t.expires_in), r = n.getTime();
    }
    return { expiresIn: { __proto__: null, value() {
      if (r) {
        const n = Date.now();
        return r > n ? Math.floor((r - n) / 1e3) : 0;
      }
    } }, claims: { __proto__: null, value() {
      try {
        return Wp(this);
      } catch {
        return;
      }
    } } };
  })(e));
}
async function l4(e, t, r) {
  var n;
  let i = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
  const a = (n = e.headers.get("retry-after")) === null || n === void 0 ? void 0 : n.trim();
  if (a === void 0) return;
  let o;
  if (/^\d+$/.test(a)) o = parseInt(a, 10);
  else {
    const s = new Date(a);
    if (Number.isFinite(s.getTime())) {
      const l = /* @__PURE__ */ new Date(), d = s.getTime() - l.getTime();
      d > 0 && (o = Math.ceil(d / 1e3));
    }
  }
  if (i && !Number.isFinite(o)) throw new _g("invalid Retry-After header value", { cause: e });
  o > t && await Pb(o - t, r);
}
function Pb(e, t) {
  return new Promise(((r, n) => {
    const i = (a) => {
      try {
        t.throwIfAborted();
      } catch (s) {
        return void n(s);
      }
      if (a <= 0) return void r();
      const o = Math.min(a, 5);
      setTimeout((() => i(a - o)), 1e3 * o);
    };
    i(e);
  }));
}
async function d4(e, t) {
  Pa(e);
  const { as: r, c: n, auth: i, fetch: a, tlsOnly: o, timeout: s } = tn(e);
  return (async function(l, d, c, u, h) {
    Ci(l), Ei(d);
    const f = Iu(l, "backchannel_authentication_endpoint", d.use_mtls_endpoint_aliases, h?.[ni] !== !0), p = new URLSearchParams(u);
    p.set("client_id", d.client_id);
    const m = zh(h?.headers);
    return m.set("accept", "application/json"), Eg(l, d, c, f, p, m, h);
  })(r, n, i, t, { [Di]: a, [ni]: !o, headers: new Headers(Xi), signal: Ls(s) }).then(((l) => (async function(d, c, u) {
    if (Ci(d), Ei(c), !bd(u, Response)) throw Vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
    await Cg(u, 200, "Backchannel Authentication Endpoint"), Nu(u);
    const h = await Uh(u);
    Mr(h.auth_req_id, '"response" body "auth_req_id" property', wt, { body: h });
    let f = typeof h.expires_in != "number" ? parseFloat(h.expires_in) : h.expires_in;
    return lo(f, !0, '"response" body "expires_in" property', wt, { body: h }), h.expires_in = f, h.interval !== void 0 && lo(h.interval, !1, '"response" body "interval" property', wt, { body: h }), h;
  })(r, n, l))).catch(bn);
}
async function Nb(e, t, r, n) {
  var i, a;
  Pa(e), r = new URLSearchParams(r);
  let o = (i = t.interval) !== null && i !== void 0 ? i : 5;
  const s = (a = n?.signal) !== null && a !== void 0 ? a : AbortSignal.timeout(1e3 * t.expires_in);
  try {
    await Pb(o, s);
  } catch (x) {
    bn(x);
  }
  const { as: l, c: d, auth: c, fetch: u, tlsOnly: h, nonRepudiation: f, timeout: p, decrypt: m } = tn(e), y = (x, S) => Nb(e, qe(qe({}, t), {}, { interval: x }), r, qe(qe({}, n), {}, { signal: s, flag: S })), v = await (async function(x, S, A, N, P) {
    Ci(x), Ei(S), Mr(N, '"authReqId"');
    const D = new URLSearchParams(P?.additionalParameters);
    return D.set("auth_req_id", N), Pu(x, S, A, "urn:openid:params:grant-type:ciba", D, P);
  })(l, d, c, t.auth_req_id, { [Di]: u, [ni]: !h, additionalParameters: r, DPoP: n?.DPoP, headers: new Headers(Xi), signal: s.aborted ? s : Ls(p) }).catch(bn);
  var b;
  if (v.status === 503 && v.headers.has("retry-after")) return await l4(v, o, s, !0), await ((b = v.body) === null || b === void 0 ? void 0 : b.cancel()), y(o);
  const $ = (async function(x, S, A, N) {
    return Kl(x, S, A, void 0, N?.[xa], N?.recognizedTokenTypes);
  })(l, d, v, { [xa]: m });
  let _;
  try {
    _ = await $;
  } catch (x) {
    if (Lu(x, n)) return y(o, co);
    if (x instanceof Vh) switch (x.error) {
      case "slow_down":
        o += 5;
      case "authorization_pending":
        return await l4(x.response, o, s), y(o);
    }
    bn(x);
  }
  return _.id_token && await f?.(v), Ru(_), _;
}
function c4(e) {
  tn(e).tlsOnly = !1;
}
async function Db(e, t, r, n, i) {
  if (Pa(e), !(i?.flag === co || t instanceof URL || (function(x, S) {
    try {
      return Object.getPrototypeOf(x)[Symbol.toStringTag] === S;
    } catch {
      return !1;
    }
  })(t, "Request"))) throw ea('"currentUrl" must be an instance of URL, or Request', Mu);
  let a, o;
  const { as: s, c: l, auth: d, fetch: c, tlsOnly: u, jarm: h, hybrid: f, nonRepudiation: p, timeout: m, decrypt: y, implicit: v } = tn(e);
  if (i?.flag === co) a = i.authResponse, o = i.redirectUri;
  else {
    if (!(t instanceof URL)) {
      const x = t;
      switch (t = new URL(t.url), x.method) {
        case "GET":
          break;
        case "POST":
          const S = new URLSearchParams(await qE(x));
          if (f) t.hash = S.toString();
          else for (const [A, N] of S.entries()) t.searchParams.append(A, N);
          break;
        default:
          throw ea("unexpected Request HTTP method", Du);
      }
    }
    switch (o = (function(x) {
      return (x = new URL(x)).search = "", x.hash = "", x.href;
    })(t), !0) {
      case !!h:
        a = await h(t, r?.expectedState);
        break;
      case !!f:
        a = await f(t, r?.expectedNonce, r?.expectedState, r?.maxAge);
        break;
      case !!v:
        throw new TypeError("authorizationCodeGrant() cannot be used by response_type=id_token clients");
      default:
        try {
          a = QE(s, l, t.searchParams, r?.expectedState);
        } catch (x) {
          bn(x);
        }
    }
  }
  const b = await (async function(x, S, A, N, P, D, T) {
    if (Ci(x), Ei(S), !Ag.has(N)) throw Vt('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', "ERR_INVALID_ARG_VALUE");
    Mr(P, '"redirectUri"');
    const I = Yo(N, "code");
    if (!I) throw Ke('no authorization code in "callbackParameters"', wt);
    const j = new URLSearchParams(T?.additionalParameters);
    return j.set("redirect_uri", P), j.set("code", I), D !== e4 && (Mr(D, '"codeVerifier"'), j.set("code_verifier", D)), Pu(x, S, A, "authorization_code", j, T);
  })(s, l, d, a, o, r?.pkceCodeVerifier || e4, { additionalParameters: n, [Di]: c, [ni]: !u, DPoP: i?.DPoP, headers: new Headers(Xi), signal: Ls(m) }).catch(bn);
  typeof r?.expectedNonce != "string" && typeof r?.maxAge != "number" || (r.idTokenExpected = !0);
  const $ = RE(s, l, b, { expectedNonce: r?.expectedNonce, maxAge: r?.maxAge, requireIdToken: r?.idTokenExpected, [xa]: y });
  let _;
  try {
    _ = await $;
  } catch (x) {
    if (Lu(x, i)) return Db(e, void 0, r, n, qe(qe({}, i), {}, { flag: co, authResponse: a, redirectUri: o }));
    bn(x);
  }
  return _.id_token && await p?.(b), Ru(_), _;
}
async function Mb(e, t, r, n) {
  Pa(e), r = new URLSearchParams(r);
  const { as: i, c: a, auth: o, fetch: s, tlsOnly: l, nonRepudiation: d, timeout: c, decrypt: u } = tn(e), h = await (async function(m, y, v, b, $) {
    Ci(m), Ei(y), Mr(b, '"refreshToken"');
    const _ = new URLSearchParams($?.additionalParameters);
    return _.set("refresh_token", b), Pu(m, y, v, "refresh_token", _, $);
  })(i, a, o, t, { [Di]: s, [ni]: !l, additionalParameters: r, DPoP: n?.DPoP, headers: new Headers(Xi), signal: Ls(c) }).catch(bn), f = (async function(m, y, v, b) {
    return Kl(m, y, v, void 0, b?.[xa], b?.recognizedTokenTypes);
  })(i, a, h, { [xa]: u });
  let p;
  try {
    p = await f;
  } catch (m) {
    if (Lu(m, n)) return Mb(e, t, r, qe(qe({}, n), {}, { flag: co }));
    bn(m);
  }
  return p.id_token && await d?.(h), Ru(p), p;
}
async function Rb(e, t, r) {
  Pa(e), t = new URLSearchParams(t);
  const { as: n, c: i, auth: a, fetch: o, tlsOnly: s, timeout: l } = tn(e), d = await (async function(h, f, p, m, y) {
    return Ci(h), Ei(f), Pu(h, f, p, "client_credentials", new URLSearchParams(m), y);
  })(n, i, a, t, { [Di]: o, [ni]: !s, DPoP: r?.DPoP, headers: new Headers(Xi), signal: Ls(l) }).catch(bn), c = (async function(h, f, p, m) {
    return Kl(h, f, p, void 0, void 0, void 0);
  })(n, i, d);
  let u;
  try {
    u = await c;
  } catch (h) {
    if (Lu(h, r)) return Rb(e, t, qe(qe({}, r), {}, { flag: co }));
    bn(h);
  }
  return Ru(u), u;
}
function Jp(e, t) {
  Pa(e);
  const { as: r, c: n, tlsOnly: i, hybrid: a, jarm: o, implicit: s } = tn(e), l = Iu(r, "authorization_endpoint", !1, i);
  if ((t = new URLSearchParams(t)).has("client_id") || t.set("client_id", n.client_id), !t.has("request_uri") && !t.has("request")) {
    if (t.has("response_type") || t.set("response_type", a ? "code id_token" : s ? "id_token" : "code"), s && !t.has("nonce")) throw ea("response_type=id_token clients must provide a nonce parameter in their authorization request parameters", Du);
    o && t.set("response_mode", "jwt");
  }
  for (const [d, c] of t.entries()) l.searchParams.append(d, c);
  return l;
}
async function Lb(e, t, r) {
  Pa(e);
  const n = Jp(e, t), { as: i, c: a, auth: o, fetch: s, tlsOnly: l, timeout: d } = tn(e), c = await (async function(f, p, m, y, v) {
    var b;
    Ci(f), Ei(p);
    const $ = Iu(f, "pushed_authorization_request_endpoint", p.use_mtls_endpoint_aliases, v?.[ni] !== !0), _ = new URLSearchParams(y);
    _.set("client_id", p.client_id);
    const x = zh(v?.headers);
    x.set("accept", "application/json"), v?.DPoP !== void 0 && (mb(v.DPoP), await v.DPoP.addProof($, x, "POST"));
    const S = await Eg(f, p, m, $, _, x, v);
    return v == null || (b = v.DPoP) === null || b === void 0 || b.cacheNonce(S, $), S;
  })(i, a, o, n.searchParams, { [Di]: s, [ni]: !l, DPoP: r?.DPoP, headers: new Headers(Xi), signal: Ls(d) }).catch(bn), u = (async function(f, p, m) {
    if (Ci(f), Ei(p), !bd(m, Response)) throw Vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
    await Cg(m, 201, "Pushed Authorization Request Endpoint"), Nu(m);
    const y = await Uh(m);
    Mr(y.request_uri, '"response" body "request_uri" property', wt, { body: y });
    let v = typeof y.expires_in != "number" ? parseFloat(y.expires_in) : y.expires_in;
    return lo(v, !0, '"response" body "expires_in" property', wt, { body: y }), y.expires_in = v, y;
  })(i, a, c);
  let h;
  try {
    h = await u;
  } catch (f) {
    if (Lu(f, r)) return Lb(e, t, qe(qe({}, r), {}, { flag: co }));
    bn(f);
  }
  return Jp(e, { request_uri: h.request_uri });
}
function Pa(e) {
  if (!(e instanceof j1)) throw ea('"config" must be an instance of Configuration', Mu);
  if (Object.getPrototypeOf(e) !== j1.prototype) throw ea("subclassing Configuration is not allowed", Du);
}
function Ls(e) {
  return e ? AbortSignal.timeout(1e3 * e) : void 0;
}
function Lu(e, t) {
  return !(t == null || !t.DPoP || t.flag === co) && (function(r) {
    if (r instanceof Sg) {
      const { 0: n, length: i } = r.cause;
      return i === 1 && n.scheme === "dpop" && n.parameters.error === "use_dpop_nonce";
    }
    return r instanceof Vh && r.error === "use_dpop_nonce";
  })(e);
}
Object.freeze(j1.prototype);
const co = /* @__PURE__ */ Symbol();
async function Pg(e, t, r, n) {
  Pa(e);
  const { as: i, c: a, auth: o, fetch: s, tlsOnly: l, timeout: d, decrypt: c } = tn(e), u = await (async function(h, f, p, m, y, v) {
    return Ci(h), Ei(f), Mr(m, '"grantType"'), Pu(h, f, p, m, new URLSearchParams(y), v);
  })(i, a, o, t, new URLSearchParams(r), { [Di]: s, [ni]: !l, DPoP: void 0, headers: new Headers(Xi), signal: Ls(d) }).then(((h) => {
    let f;
    return t === "urn:ietf:params:oauth:grant-type:token-exchange" && (f = { n_a: () => {
    } }), (async function(p, m, y, v) {
      return Kl(p, m, y, void 0, v?.[xa], v?.recognizedTokenTypes);
    })(i, a, h, { [xa]: c, recognizedTokenTypes: f });
  })).catch(bn);
  return Ru(u), u;
}
async function nA(e, t, r) {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS")) throw new TypeError((function(n) {
      for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) a[o - 1] = arguments[o];
      return Eb("Key must be ", n, ...a);
    })(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: "SHA-".concat(e.slice(-3)), name: "HMAC" }, !1, [r]);
  }
  return KE(t, e, r), t;
}
async function iA(e, t, r, n) {
  const i = await nA(e, t, "verify");
  (function(o, s) {
    if (o.startsWith("RS") || o.startsWith("PS")) {
      const { modulusLength: l } = s.algorithm;
      if (typeof l != "number" || l < 2048) throw new TypeError("".concat(o, " requires key modulusLength to be 2048 bits or larger"));
    }
  })(e, i);
  const a = (function(o, s) {
    const l = "SHA-".concat(o.slice(-3));
    switch (o) {
      case "HS256":
      case "HS384":
      case "HS512":
        return { hash: l, name: "HMAC" };
      case "PS256":
      case "PS384":
      case "PS512":
        return { hash: l, name: "RSA-PSS", saltLength: parseInt(o.slice(-3), 10) >> 3 };
      case "RS256":
      case "RS384":
      case "RS512":
        return { hash: l, name: "RSASSA-PKCS1-v1_5" };
      case "ES256":
      case "ES384":
      case "ES512":
        return { hash: l, name: "ECDSA", namedCurve: s.namedCurve };
      case "Ed25519":
      case "EdDSA":
        return { name: "Ed25519" };
      case "ML-DSA-44":
      case "ML-DSA-65":
      case "ML-DSA-87":
        return { name: o };
      default:
        throw new Vn("alg ".concat(o, " is not supported either by JOSE or your javascript runtime"));
    }
  })(e, i.algorithm);
  try {
    return await crypto.subtle.verify(a, i, r, n);
  } catch {
    return !1;
  }
}
async function aA(e, t, r) {
  if (!vo(e)) throw new Hr("Flattened JWS must be an object");
  if (e.protected === void 0 && e.header === void 0) throw new Hr('Flattened JWS must have either of the "protected" or "header" members');
  if (e.protected !== void 0 && typeof e.protected != "string") throw new Hr("JWS Protected Header incorrect type");
  if (e.payload === void 0) throw new Hr("JWS Payload missing");
  if (typeof e.signature != "string") throw new Hr("JWS Signature missing or incorrect type");
  if (e.header !== void 0 && !vo(e.header)) throw new Hr("JWS Unprotected Header incorrect type");
  let n = {};
  if (e.protected) try {
    const m = Oc(e.protected);
    n = JSON.parse(Zc.decode(m));
  } catch {
    throw new Hr("JWS Protected Header is invalid");
  }
  if (!(function() {
    for (var m = arguments.length, y = new Array(m), v = 0; v < m; v++) y[v] = arguments[v];
    const b = y.filter(Boolean);
    if (b.length === 0 || b.length === 1) return !0;
    let $;
    for (const _ of b) {
      const x = Object.keys(_);
      if ($ && $.size !== 0) for (const S of x) {
        if ($.has(S)) return !1;
        $.add(S);
      }
      else $ = new Set(x);
    }
    return !0;
  })(n, e.header)) throw new Hr("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
  const i = qe(qe({}, n), e.header), a = (function(m, y, v, b, $) {
    if ($.crit !== void 0 && b?.crit === void 0) throw new m('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!b || b.crit === void 0) return /* @__PURE__ */ new Set();
    if (!Array.isArray(b.crit) || b.crit.length === 0 || b.crit.some(((x) => typeof x != "string" || x.length === 0))) throw new m('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let _;
    _ = v !== void 0 ? new Map([...Object.entries(v), ...y.entries()]) : y;
    for (const x of b.crit) {
      if (!_.has(x)) throw new Vn('Extension Header Parameter "'.concat(x, '" is not recognized'));
      if ($[x] === void 0) throw new m('Extension Header Parameter "'.concat(x, '" is missing'));
      if (_.get(x) && b[x] === void 0) throw new m('Extension Header Parameter "'.concat(x, '" MUST be integrity protected'));
    }
    return new Set(b.crit);
  })(Hr, /* @__PURE__ */ new Map([["b64", !0]]), r?.crit, n, i);
  let o = !0;
  if (a.has("b64") && (o = n.b64, typeof o != "boolean")) throw new Hr('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
  const { alg: s } = i;
  if (typeof s != "string" || !s) throw new Hr('JWS "alg" (Algorithm) Header Parameter missing or invalid');
  const l = r && (function(m, y) {
    if (y !== void 0 && (!Array.isArray(y) || y.some(((v) => typeof v != "string")))) throw new TypeError('"'.concat(m, '" option must be an array of strings'));
    if (y) return new Set(y);
  })("algorithms", r.algorithms);
  if (l && !l.has(s)) throw new _b('"alg" (Algorithm) Header Parameter value not allowed');
  if (o) {
    if (typeof e.payload != "string") throw new Hr("JWS Payload must be a string");
  } else if (typeof e.payload != "string" && !(e.payload instanceof Uint8Array)) throw new Hr("JWS Payload must be a string or an Uint8Array instance");
  let d = !1;
  typeof t == "function" && (t = await t(n, e), d = !0), XE(s, t, "verify");
  const c = (function() {
    for (var m = arguments.length, y = new Array(m), v = 0; v < m; v++) y[v] = arguments[v];
    const b = y.reduce(((x, S) => {
      let { length: A } = S;
      return x + A;
    }), 0), $ = new Uint8Array(b);
    let _ = 0;
    for (const x of y) $.set(x, _), _ += x.length;
    return $;
  })(e.protected !== void 0 ? n2(e.protected) : new Uint8Array(), n2("."), typeof e.payload == "string" ? o ? n2(e.payload) : r4.encode(e.payload) : e.payload);
  let u;
  try {
    u = Oc(e.signature);
  } catch {
    throw new Hr("Failed to base64url decode the signature");
  }
  const h = await JE(t, s);
  if (!await iA(s, h, u, c)) throw new Cb();
  let f;
  if (o) try {
    f = Oc(e.payload);
  } catch {
    throw new Hr("Failed to base64url decode the payload");
  }
  else f = typeof e.payload == "string" ? r4.encode(e.payload) : e.payload;
  const p = { payload: f };
  return e.protected !== void 0 && (p.protectedHeader = n), e.header !== void 0 && (p.unprotectedHeader = e.header), d ? qe(qe({}, p), {}, { key: h }) : p;
}
const oA = (e) => Math.floor(e.getTime() / 1e3), sA = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function u4(e) {
  const t = sA.exec(e);
  if (!t || t[4] && t[1]) throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]);
  let n;
  switch (t[3].toLowerCase()) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      n = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      n = Math.round(60 * r);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      n = Math.round(3600 * r);
      break;
    case "day":
    case "days":
    case "d":
      n = Math.round(86400 * r);
      break;
    case "week":
    case "weeks":
    case "w":
      n = Math.round(604800 * r);
      break;
    default:
      n = Math.round(31557600 * r);
  }
  return t[1] === "-" || t[4] === "ago" ? -n : n;
}
const h4 = (e) => e.includes("/") ? e.toLowerCase() : "application/".concat(e.toLowerCase()), lA = (e, t) => typeof e == "string" ? t.includes(e) : !!Array.isArray(e) && t.some(Set.prototype.has.bind(new Set(e)));
async function dA(e, t, r) {
  var n;
  const i = await (async function(s, l, d) {
    if (s instanceof Uint8Array && (s = Zc.decode(s)), typeof s != "string") throw new Hr("Compact JWS must be a string or Uint8Array");
    const { 0: c, 1: u, 2: h, length: f } = s.split(".");
    if (f !== 3) throw new Hr("Invalid Compact JWS");
    const p = await aA({ payload: u, protected: c, signature: h }, l, d), m = { payload: p.payload, protectedHeader: p.protectedHeader };
    return typeof l == "function" ? qe(qe({}, m), {}, { key: p.key }) : m;
  })(e, t, r);
  if ((n = i.protectedHeader.crit) !== null && n !== void 0 && n.includes("b64") && i.protectedHeader.b64 === !1) throw new Zp("JWTs MUST NOT use unencoded payload");
  const a = (function(s, l) {
    let d, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    try {
      d = JSON.parse(Zc.decode(l));
    } catch {
    }
    if (!vo(d)) throw new Zp("JWT Claims Set must be a top-level JSON object");
    const { typ: u } = c;
    if (u && (typeof s.typ != "string" || h4(s.typ) !== h4(u))) throw new ui('unexpected "typ" JWT header value', d, "typ", "check_failed");
    const { requiredClaims: h = [], issuer: f, subject: p, audience: m, maxTokenAge: y } = c, v = [...h];
    y !== void 0 && v.push("iat"), m !== void 0 && v.push("aud"), p !== void 0 && v.push("sub"), f !== void 0 && v.push("iss");
    for (const x of new Set(v.reverse())) if (!(x in d)) throw new ui('missing required "'.concat(x, '" claim'), d, x, "missing");
    if (f && !(Array.isArray(f) ? f : [f]).includes(d.iss)) throw new ui('unexpected "iss" claim value', d, "iss", "check_failed");
    if (p && d.sub !== p) throw new ui('unexpected "sub" claim value', d, "sub", "check_failed");
    if (m && !lA(d.aud, typeof m == "string" ? [m] : m)) throw new ui('unexpected "aud" claim value', d, "aud", "check_failed");
    let b;
    switch (typeof c.clockTolerance) {
      case "string":
        b = u4(c.clockTolerance);
        break;
      case "number":
        b = c.clockTolerance;
        break;
      case "undefined":
        b = 0;
        break;
      default:
        throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: $ } = c, _ = oA($ || /* @__PURE__ */ new Date());
    if ((d.iat !== void 0 || y) && typeof d.iat != "number") throw new ui('"iat" claim must be a number', d, "iat", "invalid");
    if (d.nbf !== void 0) {
      if (typeof d.nbf != "number") throw new ui('"nbf" claim must be a number', d, "nbf", "invalid");
      if (d.nbf > _ + b) throw new ui('"nbf" claim timestamp check failed', d, "nbf", "check_failed");
    }
    if (d.exp !== void 0) {
      if (typeof d.exp != "number") throw new ui('"exp" claim must be a number', d, "exp", "invalid");
      if (d.exp <= _ - b) throw new Gp('"exp" claim timestamp check failed', d, "exp", "check_failed");
    }
    if (y) {
      const x = _ - d.iat;
      if (x - b > (typeof y == "number" ? y : u4(y))) throw new Gp('"iat" claim timestamp check failed (too far in the past)', d, "iat", "check_failed");
      if (x < 0 - b) throw new ui('"iat" claim timestamp check failed (it should be in the past)', d, "iat", "check_failed");
    }
    return d;
  })(i.protectedHeader, i.payload, r), o = { payload: a, protectedHeader: i.protectedHeader };
  return typeof t == "function" ? qe(qe({}, o), {}, { key: i.key }) : o;
}
function cA(e) {
  return vo(e);
}
var g0, l2, v0 = /* @__PURE__ */ new WeakMap(), d2 = /* @__PURE__ */ new WeakMap();
let uA = class {
  constructor(t) {
    if (Lr(this, v0, void 0), Lr(this, d2, /* @__PURE__ */ new WeakMap()), !(function(r) {
      return r && typeof r == "object" && Array.isArray(r.keys) && r.keys.every(cA);
    })(t)) throw new Og("JSON Web Key Set malformed");
    cr(v0, this, structuredClone(t));
  }
  jwks() {
    return be(v0, this);
  }
  async getKey(t, r) {
    const { alg: n, kid: i } = qe(qe({}, t), r?.header), a = (function(d) {
      switch (typeof d == "string" && d.slice(0, 2)) {
        case "RS":
        case "PS":
          return "RSA";
        case "ES":
          return "EC";
        case "Ed":
          return "OKP";
        case "ML":
          return "AKP";
        default:
          throw new Vn('Unsupported "alg" value for a JSON Web Key Set');
      }
    })(n), o = be(v0, this).keys.filter(((d) => {
      let c = a === d.kty;
      if (c && typeof i == "string" && (c = i === d.kid), !c || typeof d.alg != "string" && a !== "AKP" || (c = n === d.alg), c && typeof d.use == "string" && (c = d.use === "sig"), c && Array.isArray(d.key_ops) && (c = d.key_ops.includes("verify")), c) switch (n) {
        case "ES256":
          c = d.crv === "P-256";
          break;
        case "ES384":
          c = d.crv === "P-384";
          break;
        case "ES512":
          c = d.crv === "P-521";
          break;
        case "Ed25519":
        case "EdDSA":
          c = d.crv === "Ed25519";
      }
      return c;
    })), { 0: s, length: l } = o;
    if (l === 0) throw new Ig();
    if (l !== 1) {
      const d = new xb(), c = be(d2, this);
      throw d[Symbol.asyncIterator] = yE((function* () {
        for (const u of o) try {
          yield yield vE(f4(c, u, n));
        } catch {
        }
      })), d;
    }
    return f4(be(d2, this), s, n);
  }
};
async function f4(e, t, r) {
  const n = e.get(t) || e.set(t, {}).get(t);
  if (n[r] === void 0) {
    const i = await (async function(a, o, s) {
      var l;
      if (!vo(a)) throw new TypeError("JWK must be an object");
      let d;
      switch (o != null || (o = a.alg), d != null || (d = (l = void 0) !== null && l !== void 0 ? l : a.ext), a.kty) {
        case "oct":
          if (typeof a.k != "string" || !a.k) throw new TypeError('missing "k" (Key Value) Parameter value');
          return Oc(a.k);
        case "RSA":
          if ("oth" in a && a.oth !== void 0) throw new Vn('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
          return r1(qe(qe({}, a), {}, { alg: o, ext: d }));
        case "AKP":
          if (typeof a.alg != "string" || !a.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
          if (o !== void 0 && o !== a.alg) throw new TypeError("JWK alg and alg option value mismatch");
          return r1(qe(qe({}, a), {}, { ext: d }));
        case "EC":
        case "OKP":
          return r1(qe(qe({}, a), {}, { alg: o, ext: d }));
        default:
          throw new Vn('Unsupported "kty" (Key Type) Parameter value');
      }
    })(qe(qe({}, t), {}, { ext: !0 }), r);
    if (i instanceof Uint8Array || i.type !== "public") throw new Og("JSON Web Key Set members must be public keys");
    n[r] = i;
  }
  return n[r];
}
function p4(e) {
  const t = new uA(e), r = async (n, i) => t.getKey(n, i);
  return Object.defineProperties(r, { jwks: { value: () => structuredClone(t.jwks()), enumerable: !1, configurable: !1, writable: !1 } }), r;
}
let Xp;
(typeof navigator > "u" || (g0 = navigator.userAgent) === null || g0 === void 0 || (l2 = g0.startsWith) === null || l2 === void 0 || !l2.call(g0, "Mozilla/5.0 ")) && (Xp = "".concat("jose", "/").concat("v6.1.3"));
const Fb = /* @__PURE__ */ Symbol(), c2 = /* @__PURE__ */ Symbol();
var u2 = /* @__PURE__ */ new WeakMap(), h2 = /* @__PURE__ */ new WeakMap(), f2 = /* @__PURE__ */ new WeakMap(), y0 = /* @__PURE__ */ new WeakMap(), Vo = /* @__PURE__ */ new WeakMap(), la = /* @__PURE__ */ new WeakMap(), za = /* @__PURE__ */ new WeakMap(), p2 = /* @__PURE__ */ new WeakMap(), Uo = /* @__PURE__ */ new WeakMap(), qo = /* @__PURE__ */ new WeakMap();
let hA = class {
  constructor(t, r) {
    if (Lr(this, u2, void 0), Lr(this, h2, void 0), Lr(this, f2, void 0), Lr(this, y0, void 0), Lr(this, Vo, void 0), Lr(this, la, void 0), Lr(this, za, void 0), Lr(this, p2, void 0), Lr(this, Uo, void 0), Lr(this, qo, void 0), !(t instanceof URL)) throw new TypeError("url must be an instance of URL");
    var n, i;
    cr(u2, this, new URL(t.href)), cr(h2, this, typeof r?.timeoutDuration == "number" ? r?.timeoutDuration : 5e3), cr(f2, this, typeof r?.cooldownDuration == "number" ? r?.cooldownDuration : 3e4), cr(y0, this, typeof r?.cacheMaxAge == "number" ? r?.cacheMaxAge : 6e5), cr(za, this, new Headers(r?.headers)), Xp && !be(za, this).has("User-Agent") && be(za, this).set("User-Agent", Xp), be(za, this).has("accept") || (be(za, this).set("accept", "application/json"), be(za, this).append("accept", "application/jwk-set+json")), cr(p2, this, r?.[Fb]), r?.[c2] !== void 0 && (cr(qo, this, r?.[c2]), n = r?.[c2], i = be(y0, this), typeof n == "object" && n !== null && "uat" in n && typeof n.uat == "number" && !(Date.now() - n.uat >= i) && "jwks" in n && vo(n.jwks) && Array.isArray(n.jwks.keys) && Array.prototype.every.call(n.jwks.keys, vo) && (cr(Vo, this, be(qo, this).uat), cr(Uo, this, p4(be(qo, this).jwks))));
  }
  pendingFetch() {
    return !!be(la, this);
  }
  coolingDown() {
    return typeof be(Vo, this) == "number" && Date.now() < be(Vo, this) + be(f2, this);
  }
  fresh() {
    return typeof be(Vo, this) == "number" && Date.now() < be(Vo, this) + be(y0, this);
  }
  jwks() {
    var t;
    return (t = be(Uo, this)) === null || t === void 0 ? void 0 : t.jwks();
  }
  async getKey(t, r) {
    be(Uo, this) && this.fresh() || await this.reload();
    try {
      return await be(Uo, this).call(this, t, r);
    } catch (n) {
      if (n instanceof Ig && this.coolingDown() === !1) return await this.reload(), be(Uo, this).call(this, t, r);
      throw n;
    }
  }
  async reload() {
    be(la, this) && (typeof WebSocketPair < "u" || typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime < "u" && EdgeRuntime === "vercel") && cr(la, this, void 0), be(la, this) || cr(la, this, (async function(t, r, n) {
      const a = await (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : fetch)(t, { method: "GET", signal: n, redirect: "manual", headers: r }).catch(((o) => {
        throw o.name === "TimeoutError" ? new Sb() : o;
      }));
      if (a.status !== 200) throw new nn("Expected 200 OK from the JSON Web Key Set HTTP response");
      try {
        return await a.json();
      } catch {
        throw new nn("Failed to parse the JSON Web Key Set HTTP response as JSON");
      }
    })(be(u2, this).href, be(za, this), AbortSignal.timeout(be(h2, this)), be(p2, this)).then(((t) => {
      cr(Uo, this, p4(t)), be(qo, this) && (be(qo, this).uat = Date.now(), be(qo, this).jwks = t), cr(Vo, this, Date.now()), cr(la, this, void 0);
    })).catch(((t) => {
      throw cr(la, this, void 0), t;
    }))), await be(la, this);
  }
};
const fA = ["mfaToken"], pA = ["mfaToken"];
var Bo, b0, Ho, Ga, vl, Ht, Hd, Er, m4 = class extends Error {
  constructor(t, r) {
    super(r), $e(this, "code", void 0), this.name = "NotSupportedError", this.code = t;
  }
}, Na = class extends Error {
  constructor(t, r, n) {
    super(r), $e(this, "cause", void 0), $e(this, "code", void 0), this.code = t, this.cause = n && { error: n.error, error_description: n.error_description, message: n.message };
  }
}, mA = class extends Na {
  constructor(t, r) {
    super("token_by_code_error", t, r), this.name = "TokenByCodeError";
  }
}, gA = class extends Na {
  constructor(t, r) {
    super("token_by_client_credentials_error", t, r), this.name = "TokenByClientCredentialsError";
  }
}, vA = class extends Na {
  constructor(t, r) {
    super("token_by_refresh_token_error", t, r), this.name = "TokenByRefreshTokenError";
  }
}, m2 = class extends Na {
  constructor(t, r) {
    super("token_for_connection_error", t, r), this.name = "TokenForConnectionErrorCode";
  }
}, Vi = class extends Na {
  constructor(t, r) {
    super("token_exchange_error", t, r), this.name = "TokenExchangeError";
  }
}, Va = class extends Error {
  constructor(t) {
    super(t), $e(this, "code", "verify_logout_token_error"), this.name = "VerifyLogoutTokenError";
  }
}, g2 = class extends Na {
  constructor(t) {
    super("backchannel_authentication_error", "There was an error when trying to use Client-Initiated Backchannel Authentication.", t), $e(this, "code", "backchannel_authentication_error"), this.name = "BackchannelAuthenticationError";
  }
}, yA = class extends Na {
  constructor(t) {
    super("build_authorization_url_error", "There was an error when trying to build the authorization URL.", t), this.name = "BuildAuthorizationUrlError";
  }
}, bA = class extends Na {
  constructor(t) {
    super("build_link_user_url_error", "There was an error when trying to build the Link User URL.", t), this.name = "BuildLinkUserUrlError";
  }
}, wA = class extends Na {
  constructor(t) {
    super("build_unlink_user_url_error", "There was an error when trying to build the Unlink User URL.", t), this.name = "BuildUnlinkUserUrlError";
  }
}, $A = class extends Error {
  constructor() {
    super("The client secret or client assertion signing key must be provided."), $e(this, "code", "missing_client_auth_error"), this.name = "MissingClientAuthError";
  }
};
function e5(e) {
  return Object.entries(e).filter(((t) => {
    let [, r] = t;
    return r !== void 0;
  })).reduce(((t, r) => qe(qe({}, t), {}, { [r[0]]: r[1] })), {});
}
var qh = class extends Error {
  constructor(t, r, n) {
    super(r), $e(this, "cause", void 0), $e(this, "code", void 0), this.code = t, this.cause = n && { error: n.error, error_description: n.error_description, message: n.message };
  }
}, jb = class extends qh {
  constructor(t, r) {
    super("mfa_list_authenticators_error", t, r), this.name = "MfaListAuthenticatorsError";
  }
}, zb = class extends qh {
  constructor(t, r) {
    super("mfa_enrollment_error", t, r), this.name = "MfaEnrollmentError";
  }
}, kA = class extends qh {
  constructor(e, t) {
    super("mfa_delete_authenticator_error", e, t), this.name = "MfaDeleteAuthenticatorError";
  }
}, Vb = class extends qh {
  constructor(t, r) {
    super("mfa_challenge_error", t, r), this.name = "MfaChallengeError";
  }
};
function _A(e) {
  return { id: e.id, authenticatorType: e.authenticator_type, active: e.active, name: e.name, oobChannels: e.oob_channels, type: e.type };
}
var xA = (Bo = /* @__PURE__ */ new WeakMap(), b0 = /* @__PURE__ */ new WeakMap(), Ho = /* @__PURE__ */ new WeakMap(), class {
  constructor(e) {
    var t;
    Lr(this, Bo, void 0), Lr(this, b0, void 0), Lr(this, Ho, void 0), cr(Bo, this, "https://".concat(e.domain)), cr(b0, this, e.clientId), cr(Ho, this, (t = e.customFetch) !== null && t !== void 0 ? t : function() {
      return fetch(...arguments);
    });
  }
  async listAuthenticators(e) {
    const t = "".concat(be(Bo, this), "/mfa/authenticators"), { mfaToken: r } = e, n = await be(Ho, this).call(this, t, { method: "GET", headers: { Authorization: "Bearer ".concat(r), "Content-Type": "application/json" } });
    if (!n.ok) {
      const i = await n.json();
      throw new jb(i.error_description || "Failed to list authenticators", i);
    }
    return (await n.json()).map(_A);
  }
  async enrollAuthenticator(e) {
    const t = "".concat(be(Bo, this), "/mfa/associate"), { mfaToken: r } = e, n = Zv(e, fA), i = { authenticator_types: n.authenticatorTypes };
    "oobChannels" in n && (i.oob_channels = n.oobChannels), "phoneNumber" in n && n.phoneNumber && (i.phone_number = n.phoneNumber), "email" in n && n.email && (i.email = n.email);
    const a = await be(Ho, this).call(this, t, { method: "POST", headers: { Authorization: "Bearer ".concat(r), "Content-Type": "application/json" }, body: JSON.stringify(i) });
    if (!a.ok) {
      const o = await a.json();
      throw new zb(o.error_description || "Failed to enroll authenticator", o);
    }
    return (function(o) {
      if (o.authenticator_type === "otp") return { authenticatorType: "otp", secret: o.secret, barcodeUri: o.barcode_uri, recoveryCodes: o.recovery_codes, id: o.id };
      if (o.authenticator_type === "oob") return { authenticatorType: "oob", oobChannel: o.oob_channel, oobCode: o.oob_code, bindingMethod: o.binding_method, id: o.id };
      throw new Error("Unexpected authenticator type: ".concat(o.authenticator_type));
    })(await a.json());
  }
  async deleteAuthenticator(e) {
    const { authenticatorId: t, mfaToken: r } = e, n = "".concat(be(Bo, this), "/mfa/authenticators/").concat(encodeURIComponent(t)), i = await be(Ho, this).call(this, n, { method: "DELETE", headers: { Authorization: "Bearer ".concat(r), "Content-Type": "application/json" } });
    if (!i.ok) {
      const a = await i.json();
      throw new kA(a.error_description || "Failed to delete authenticator", a);
    }
  }
  async challengeAuthenticator(e) {
    const t = "".concat(be(Bo, this), "/mfa/challenge"), { mfaToken: r } = e, n = Zv(e, pA), i = { mfa_token: r, client_id: be(b0, this), challenge_type: n.challengeType };
    n.authenticatorId && (i.authenticator_id = n.authenticatorId);
    const a = await be(Ho, this).call(this, t, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(i) });
    if (!a.ok) {
      const o = await a.json();
      throw new Vb(o.error_description || "Failed to challenge authenticator", o);
    }
    return (function(o) {
      const s = { challengeType: o.challenge_type };
      return o.oob_code !== void 0 && (s.oobCode = o.oob_code), o.binding_method !== void 0 && (s.bindingMethod = o.binding_method), s;
    })(await a.json());
  }
}), as = class Ub {
  constructor(t, r, n, i, a, o, s) {
    $e(this, "accessToken", void 0), $e(this, "idToken", void 0), $e(this, "refreshToken", void 0), $e(this, "expiresAt", void 0), $e(this, "scope", void 0), $e(this, "claims", void 0), $e(this, "authorizationDetails", void 0), $e(this, "tokenType", void 0), $e(this, "issuedTokenType", void 0), this.accessToken = t, this.idToken = n, this.refreshToken = i, this.expiresAt = r, this.scope = a, this.claims = o, this.authorizationDetails = s;
  }
  static fromTokenEndpointResponse(t) {
    const r = t.id_token ? t.claims() : void 0, n = new Ub(t.access_token, Math.floor(Date.now() / 1e3) + Number(t.expires_in), t.id_token, t.refresh_token, t.scope, r, t.authorization_details);
    return n.tokenType = t.token_type, n.issuedTokenType = t.issued_token_type, n;
  }
}, t5 = "openid profile email offline_access", SA = Object.freeze(/* @__PURE__ */ new Set(["grant_type", "client_id", "client_secret", "client_assertion", "client_assertion_type", "subject_token", "subject_token_type", "requested_token_type", "actor_token", "actor_token_type", "audience", "aud", "resource", "resources", "resource_indicator", "scope", "connection", "login_hint", "organization", "assertion"]));
function qb(e) {
  if (e == null) throw new Vi("subject_token is required");
  if (typeof e != "string") throw new Vi("subject_token must be a string");
  if (e.trim().length === 0) throw new Vi("subject_token cannot be blank or whitespace");
  if (e !== e.trim()) throw new Vi("subject_token must not include leading or trailing whitespace");
  if (/^bearer\s+/i.test(e)) throw new Vi("subject_token must not include the 'Bearer ' prefix");
}
function Bb(e, t) {
  if (t) {
    for (const [r, n] of Object.entries(t)) if (!SA.has(r)) if (Array.isArray(n)) {
      if (n.length > 20) throw new Vi("Parameter '".concat(r, "' exceeds maximum array size of ").concat(20));
      n.forEach(((i) => {
        e.append(r, i);
      }));
    } else e.append(r, n);
  }
}
var CA = (Ga = /* @__PURE__ */ new WeakMap(), vl = /* @__PURE__ */ new WeakMap(), Ht = /* @__PURE__ */ new WeakMap(), Hd = /* @__PURE__ */ new WeakMap(), Er = /* @__PURE__ */ new WeakSet(), class {
  constructor(e) {
    if ((function(t, r) {
      db(t, r), r.add(t);
    })(this, Er), Lr(this, Ga, void 0), Lr(this, vl, void 0), Lr(this, Ht, void 0), Lr(this, Hd, void 0), $e(this, "mfa", void 0), cr(Ht, this, e), e.useMtls && !e.customFetch) throw new m4("mtls_without_custom_fetch_not_supported", "Using mTLS without a custom fetch implementation is not supported");
    this.mfa = new xA({ domain: be(Ht, this).domain, clientId: be(Ht, this).clientId, customFetch: be(Ht, this).customFetch });
  }
  async buildAuthorizationUrl(e) {
    const { serverMetadata: t } = await Ir(Er, this, ei).call(this);
    if (e != null && e.pushedAuthorizationRequests && !t.pushed_authorization_request_endpoint) throw new m4("par_not_supported_error", "The Auth0 tenant does not have pushed authorization requests enabled. Learn how to enable it here: https://auth0.com/docs/get-started/applications/configure-par");
    try {
      return await Ir(Er, this, v2).call(this, e);
    } catch (r) {
      throw new yA(r);
    }
  }
  async buildLinkUserUrl(e) {
    try {
      const t = await Ir(Er, this, v2).call(this, { authorizationParams: qe(qe({}, e.authorizationParams), {}, { requested_connection: e.connection, requested_connection_scope: e.connectionScope, scope: "openid link_account offline_access", id_token_hint: e.idToken }) });
      return { linkUserUrl: t.authorizationUrl, codeVerifier: t.codeVerifier };
    } catch (t) {
      throw new bA(t);
    }
  }
  async buildUnlinkUserUrl(e) {
    try {
      const t = await Ir(Er, this, v2).call(this, { authorizationParams: qe(qe({}, e.authorizationParams), {}, { requested_connection: e.connection, scope: "openid unlink_account", id_token_hint: e.idToken }) });
      return { unlinkUserUrl: t.authorizationUrl, codeVerifier: t.codeVerifier };
    } catch (t) {
      throw new wA(t);
    }
  }
  async backchannelAuthentication(e) {
    const { configuration: t, serverMetadata: r } = await Ir(Er, this, ei).call(this), n = e5(qe(qe({}, be(Ht, this).authorizationParams), e?.authorizationParams)), i = new URLSearchParams(qe(qe({ scope: t5 }, n), {}, { client_id: be(Ht, this).clientId, binding_message: e.bindingMessage, login_hint: JSON.stringify({ format: "iss_sub", iss: r.issuer, sub: e.loginHint.sub }) }));
    e.requestedExpiry && i.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && i.append("authorization_details", JSON.stringify(e.authorizationDetails));
    try {
      const a = await d4(t, i), o = await Nb(t, a);
      return as.fromTokenEndpointResponse(o);
    } catch (a) {
      throw new g2(a);
    }
  }
  async initiateBackchannelAuthentication(e) {
    const { configuration: t, serverMetadata: r } = await Ir(Er, this, ei).call(this), n = e5(qe(qe({}, be(Ht, this).authorizationParams), e?.authorizationParams)), i = new URLSearchParams(qe(qe({ scope: t5 }, n), {}, { client_id: be(Ht, this).clientId, binding_message: e.bindingMessage, login_hint: JSON.stringify({ format: "iss_sub", iss: r.issuer, sub: e.loginHint.sub }) }));
    e.requestedExpiry && i.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && i.append("authorization_details", JSON.stringify(e.authorizationDetails));
    try {
      const a = await d4(t, i);
      return { authReqId: a.auth_req_id, expiresIn: a.expires_in, interval: a.interval };
    } catch (a) {
      throw new g2(a);
    }
  }
  async backchannelAuthenticationGrant(e) {
    let { authReqId: t } = e;
    const { configuration: r } = await Ir(Er, this, ei).call(this), n = new URLSearchParams({ auth_req_id: t });
    try {
      const i = await Pg(r, "urn:openid:params:grant-type:ciba", n);
      return as.fromTokenEndpointResponse(i);
    } catch (i) {
      throw new g2(i);
    }
  }
  async getTokenForConnection(e) {
    var t;
    if (e.refreshToken && e.accessToken) throw new m2("Either a refresh or access token should be specified, but not both.");
    const r = (t = e.accessToken) !== null && t !== void 0 ? t : e.refreshToken;
    if (!r) throw new m2("Either a refresh or access token must be specified.");
    try {
      return await this.exchangeToken({ connection: e.connection, subjectToken: r, subjectTokenType: e.accessToken ? "urn:ietf:params:oauth:token-type:access_token" : "urn:ietf:params:oauth:token-type:refresh_token", loginHint: e.loginHint });
    } catch (n) {
      throw n instanceof Vi ? new m2(n.message, n.cause) : n;
    }
  }
  async exchangeToken(e) {
    return "connection" in e ? Ir(Er, this, EA).call(this, e) : Ir(Er, this, AA).call(this, e);
  }
  async getTokenByCode(e, t) {
    const { configuration: r } = await Ir(Er, this, ei).call(this);
    try {
      const n = await Db(r, e, { pkceCodeVerifier: t.codeVerifier });
      return as.fromTokenEndpointResponse(n);
    } catch (n) {
      throw new mA("There was an error while trying to request a token.", n);
    }
  }
  async getTokenByRefreshToken(e) {
    const { configuration: t } = await Ir(Er, this, ei).call(this);
    try {
      const r = await Mb(t, e.refreshToken);
      return as.fromTokenEndpointResponse(r);
    } catch (r) {
      throw new vA("The access token has expired and there was an error while trying to refresh it.", r);
    }
  }
  async getTokenByClientCredentials(e) {
    const { configuration: t } = await Ir(Er, this, ei).call(this);
    try {
      const r = new URLSearchParams({ audience: e.audience });
      e.organization && r.append("organization", e.organization);
      const n = await Rb(t, r);
      return as.fromTokenEndpointResponse(n);
    } catch (r) {
      throw new gA("There was an error while trying to request a token.", r);
    }
  }
  async buildLogoutUrl(e) {
    const { configuration: t, serverMetadata: r } = await Ir(Er, this, ei).call(this);
    if (!r.end_session_endpoint) {
      const n = new URL("https://".concat(be(Ht, this).domain, "/v2/logout"));
      return n.searchParams.set("returnTo", e.returnTo), n.searchParams.set("client_id", be(Ht, this).clientId), n;
    }
    return (function(n, i) {
      Pa(n);
      const { as: a, c: o, tlsOnly: s } = tn(n), l = Iu(a, "end_session_endpoint", !1, s);
      (i = new URLSearchParams(i)).has("client_id") || i.set("client_id", o.client_id);
      for (const [d, c] of i.entries()) l.searchParams.append(d, c);
      return l;
    })(t, { post_logout_redirect_uri: e.returnTo });
  }
  async verifyLogoutToken(e) {
    const { serverMetadata: t } = await Ir(Er, this, ei).call(this);
    be(Hd, this) || cr(Hd, this, (function(n, i) {
      const a = new hA(n, i), o = async (s, l) => a.getKey(s, l);
      return Object.defineProperties(o, { coolingDown: { get: () => a.coolingDown(), enumerable: !0, configurable: !1 }, fresh: { get: () => a.fresh(), enumerable: !0, configurable: !1 }, reload: { value: () => a.reload(), enumerable: !0, configurable: !1, writable: !1 }, reloading: { get: () => a.pendingFetch(), enumerable: !0, configurable: !1 }, jwks: { value: () => a.jwks(), enumerable: !0, configurable: !1, writable: !1 } }), o;
    })(new URL(t.jwks_uri), { [Fb]: be(Ht, this).customFetch }));
    const { payload: r } = await dA(e.logoutToken, be(Hd, this), { issuer: t.issuer, audience: be(Ht, this).clientId, algorithms: ["RS256"], requiredClaims: ["iat"] });
    if (!("sid" in r) && !("sub" in r)) throw new Va('either "sid" or "sub" (or both) claims must be present');
    if ("sid" in r && typeof r.sid != "string") throw new Va('"sid" claim must be a string');
    if ("sub" in r && typeof r.sub != "string") throw new Va('"sub" claim must be a string');
    if ("nonce" in r) throw new Va('"nonce" claim is prohibited');
    if (!("events" in r)) throw new Va('"events" claim is missing');
    if (typeof r.events != "object" || r.events === null) throw new Va('"events" claim must be an object');
    if (!("http://schemas.openid.net/event/backchannel-logout" in r.events)) throw new Va('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim');
    if (typeof r.events["http://schemas.openid.net/event/backchannel-logout"] != "object") throw new Va('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object');
    return { sid: r.sid, sub: r.sub };
  }
});
async function ei() {
  if (be(Ga, this) && be(vl, this)) return { configuration: be(Ga, this), serverMetadata: be(vl, this) };
  const e = await Ir(Er, this, TA).call(this);
  return cr(Ga, this, await rA(new URL("https://".concat(be(Ht, this).domain)), be(Ht, this).clientId, { use_mtls_endpoint_aliases: be(Ht, this).useMtls }, e, { [ao]: be(Ht, this).customFetch })), cr(vl, this, be(Ga, this).serverMetadata()), be(Ga, this)[ao] = be(Ht, this).customFetch || fetch, { configuration: be(Ga, this), serverMetadata: be(vl, this) };
}
async function EA(e) {
  var t, r;
  const { configuration: n } = await Ir(Er, this, ei).call(this);
  if ("audience" in e || "resource" in e) throw new Vi("audience and resource parameters are not supported for Token Vault exchanges");
  qb(e.subjectToken);
  const i = new URLSearchParams({ connection: e.connection, subject_token: e.subjectToken, subject_token_type: (t = e.subjectTokenType) !== null && t !== void 0 ? t : "urn:ietf:params:oauth:token-type:access_token", requested_token_type: (r = e.requestedTokenType) !== null && r !== void 0 ? r : "http://auth0.com/oauth/token-type/federated-connection-access-token" });
  e.loginHint && i.append("login_hint", e.loginHint), e.scope && i.append("scope", e.scope), Bb(i, e.extra);
  try {
    const a = await Pg(n, "urn:auth0:params:oauth:grant-type:token-exchange:federated-connection-access-token", i);
    return as.fromTokenEndpointResponse(a);
  } catch (a) {
    throw new Vi("Failed to exchange token for connection '".concat(e.connection, "'."), a);
  }
}
async function AA(e) {
  const { configuration: t } = await Ir(Er, this, ei).call(this);
  qb(e.subjectToken);
  const r = new URLSearchParams({ subject_token_type: e.subjectTokenType, subject_token: e.subjectToken });
  e.audience && r.append("audience", e.audience), e.scope && r.append("scope", e.scope), e.requestedTokenType && r.append("requested_token_type", e.requestedTokenType), e.organization && r.append("organization", e.organization), Bb(r, e.extra);
  try {
    const n = await Pg(t, "urn:ietf:params:oauth:grant-type:token-exchange", r);
    return as.fromTokenEndpointResponse(n);
  } catch (n) {
    throw new Vi("Failed to exchange token of type '".concat(e.subjectTokenType, "'").concat(e.audience ? " for audience '".concat(e.audience, "'") : "", "."), n);
  }
}
async function TA() {
  if (!be(Ht, this).clientSecret && !be(Ht, this).clientAssertionSigningKey && !be(Ht, this).useMtls) throw new $A();
  if (be(Ht, this).useMtls) return (t, r, n, i) => {
    n.set("client_id", r.client_id);
  };
  let e = be(Ht, this).clientAssertionSigningKey;
  return !e || e instanceof CryptoKey || (e = await (async function(t, r, n) {
    if (typeof t != "string" || t.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return YE(t, r, n);
  })(e, be(Ht, this).clientAssertionSigningAlg || "RS256")), e ? (function(t, r) {
    return xE(t);
  })(e) : Ob(be(Ht, this).clientSecret);
}
async function v2(e) {
  const { configuration: t } = await Ir(Er, this, ei).call(this), r = tA(), n = await eA(r), i = e5(qe(qe({}, be(Ht, this).authorizationParams), e?.authorizationParams)), a = new URLSearchParams(qe(qe({ scope: t5 }, i), {}, { client_id: be(Ht, this).clientId, code_challenge: n, code_challenge_method: "S256" }));
  return { authorizationUrl: e != null && e.pushedAuthorizationRequests ? await Lb(t, a) : await Jp(t, a), codeVerifier: r };
}
let Fu = class r5 extends ur {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, r5.prototype);
  }
  static fromPayload(t) {
    let { error: r, error_description: n } = t;
    return new r5(r, n);
  }
};
class z1 extends Fu {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, z1.prototype);
  }
}
let OA = class Hb extends Fu {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, Hb.prototype);
  }
}, IA = class Wb extends Fu {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, Wb.prototype);
  }
}, w0 = class Qb extends Fu {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, Qb.prototype);
  }
}, PA = class Kb extends Fu {
  constructor(t, r) {
    super(t, r), Object.setPrototypeOf(this, Kb.prototype);
  }
}, NA = class {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 6e5;
    this.contexts = /* @__PURE__ */ new Map(), this.ttlMs = t;
  }
  set(t, r) {
    this.cleanup(), this.contexts.set(t, Object.assign(Object.assign({}, r), { createdAt: Date.now() }));
  }
  get(t) {
    const r = this.contexts.get(t);
    if (r) {
      if (!(Date.now() - r.createdAt > this.ttlMs)) return r;
      this.contexts.delete(t);
    }
  }
  remove(t) {
    this.contexts.delete(t);
  }
  cleanup() {
    const t = Date.now();
    for (const [r, n] of this.contexts) t - n.createdAt > this.ttlMs && this.contexts.delete(r);
  }
  get size() {
    return this.contexts.size;
  }
}, DA = class {
  constructor(t, r) {
    this.authJsMfaClient = t, this.auth0Client = r, this.contextManager = new NA();
  }
  setMFAAuthDetails(t, r, n, i) {
    this.contextManager.set(t, { scope: r, audience: n, mfaRequirements: i });
  }
  async getAuthenticators(t) {
    var r, n;
    const i = this.contextManager.get(t);
    if (!(!((r = i?.mfaRequirements) === null || r === void 0) && r.challenge) || i.mfaRequirements.challenge.length === 0) throw new z1("invalid_request", "challengeType is required and must contain at least one challenge type, please check mfa_required error payload");
    const a = i.mfaRequirements.challenge.map(((o) => o.type));
    try {
      return (await this.authJsMfaClient.listAuthenticators({ mfaToken: t })).filter(((o) => !!o.type && a.includes(o.type)));
    } catch (o) {
      throw o instanceof jb ? new z1((n = o.cause) === null || n === void 0 ? void 0 : n.error, o.message) : o;
    }
  }
  async enroll(t) {
    var r;
    const n = (function(i) {
      const a = fE[i.factorType];
      return Object.assign(Object.assign(Object.assign({ mfaToken: i.mfaToken, authenticatorTypes: a.authenticatorTypes }, a.oobChannels && { oobChannels: a.oobChannels }), "phoneNumber" in i && { phoneNumber: i.phoneNumber }), "email" in i && { email: i.email });
    })(t);
    try {
      return await this.authJsMfaClient.enrollAuthenticator(n);
    } catch (i) {
      throw i instanceof zb ? new OA((r = i.cause) === null || r === void 0 ? void 0 : r.error, i.message) : i;
    }
  }
  async challenge(t) {
    var r;
    try {
      const n = { challengeType: t.challengeType, mfaToken: t.mfaToken };
      return t.authenticatorId && (n.authenticatorId = t.authenticatorId), await this.authJsMfaClient.challengeAuthenticator(n);
    } catch (n) {
      throw n instanceof Vb ? new IA((r = n.cause) === null || r === void 0 ? void 0 : r.error, n.message) : n;
    }
  }
  async getEnrollmentFactors(t) {
    const r = this.contextManager.get(t);
    if (!r || !r.mfaRequirements) throw new PA("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
    return r.mfaRequirements.enroll && r.mfaRequirements.enroll.length !== 0 ? r.mfaRequirements.enroll : [];
  }
  async verify(t) {
    const r = this.contextManager.get(t.mfaToken);
    if (!r) throw new w0("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
    const n = (function(o) {
      return "otp" in o && o.otp ? pE : "oobCode" in o && o.oobCode ? mE : "recoveryCode" in o && o.recoveryCode ? gE : void 0;
    })(t);
    if (!n) throw new w0("invalid_request", "Unable to determine grant type. Provide one of: otp, oobCode, or recoveryCode.");
    const i = r.scope, a = r.audience;
    try {
      const o = await this.auth0Client._requestTokenForMfa({ grant_type: n, mfaToken: t.mfaToken, scope: i, audience: a, otp: t.otp, oob_code: t.oobCode, binding_code: t.bindingCode, recovery_code: t.recoveryCode });
      return this.contextManager.remove(t.mfaToken), o;
    } catch (o) {
      if (o instanceof I1) this.setMFAAuthDetails(o.mfa_token, i, a, o.mfa_requirements);
      else if (o instanceof w0) throw new w0(o.error, o.error_description);
      throw o;
    }
  }
}, MA = class {
  constructor(t) {
    let r, n;
    if (this.userCache = new nb().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), t), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), t.authorizationParams) }), typeof window < "u" && (() => {
      if (!N1()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (N1().subtle === void 0) throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), this.lockManager = (Zf || (Zf = PC()), Zf), t.cache && t.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), t.cache) n = t.cache;
    else {
      if (r = t.cacheLocation || "memory", !Hv(r)) throw new Error('Invalid cache location "'.concat(r, '"'));
      n = Hv(r)();
    }
    var i;
    this.httpTimeoutMs = t.httpTimeoutInSeconds ? 1e3 * t.httpTimeoutInSeconds : 1e4, this.cookieStorage = t.legacySameSiteCookie === !1 ? rl : nE, this.orgHintCookieName = (i = this.options.clientId, "auth0.".concat(i, ".organization_hint")), this.isAuthenticatedCookieName = ((d) => "auth0.".concat(d, ".is.authenticated"))(this.options.clientId), this.sessionCheckExpiryDays = t.sessionCheckExpiryDays || 1;
    const a = t.useCookiesForTransactions ? this.cookieStorage : iE;
    var o;
    this.scope = (function(d, c) {
      for (var u = arguments.length, h = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++) h[f - 2] = arguments[f];
      if (typeof d != "object") return { default: t1(c, d, ...h) };
      let p = { default: t1(c, ...h) };
      return Object.keys(d).forEach(((m) => {
        const y = d[m];
        p[m] = t1(c, y, ...h);
      })), p;
    })(this.options.authorizationParams.scope, "openid", this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new YC(a, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || F8, this.cacheManager = new ZC(n, n.allKeys ? void 0 : new sE(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new cE(this.options.clientId) : void 0, this.domainUrl = (o = this.options.domain, /^https?:\/\//.test(o) ? o : "https://".concat(o)), this.tokenIssuer = ((d, c) => d ? d.startsWith("https://") ? d : "https://".concat(d, "/") : "".concat(c, "/"))(this.options.issuer, this.domainUrl);
    const s = "".concat(this.domainUrl, "/me/"), l = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && { dpopNonceId: "__auth0_my_account_api__" }), { getAccessToken: () => this.getTokenSilently({ authorizationParams: { scope: "create:me:connected_accounts", audience: s }, detailedResponse: !0 }) }));
    this.myAccountApi = new hE(l, s), this.authJsClient = new CA({ domain: this.options.domain, clientId: this.options.clientId }), this.mfa = new DA(this.authJsClient.mfa, this), typeof window < "u" && window.Worker && this.options.useRefreshTokens && r === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new oE());
  }
  getConfiguration() {
    return Object.freeze({ domain: this.options.domain, clientId: this.options.clientId });
  }
  _url(t) {
    const r = this.options.auth0Client || L8, n = Y8(r, !0), i = encodeURIComponent(btoa(JSON.stringify(n)));
    return "".concat(this.domainUrl).concat(t, "&auth0Client=").concat(i);
  }
  _authorizeUrl(t) {
    return this._url("/authorize?".concat(Fp(t)));
  }
  async _verifyIdToken(t, r, n) {
    const i = await this.nowProvider();
    return XC({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: t, nonce: r, organization: n, leeway: this.options.leeway, max_age: (a = this.options.authorizationParams.max_age, typeof a != "string" ? a : parseInt(a, 10) || void 0), now: i });
    var a;
  }
  _processOrgHint(t) {
    t ? this.cookieStorage.save(this.orgHintCookieName, t, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(t, r, n) {
    var i;
    const a = Qf(Vd()), o = Qf(Vd()), s = Vd(), l = await Fv(s), d = zv(l), c = await ((i = this.dpop) === null || i === void 0 ? void 0 : i.calculateThumbprint()), u = ((f, p, m, y, v, b, $, _, x) => Object.assign(Object.assign(Object.assign({ client_id: f.clientId }, f.authorizationParams), m), { scope: h0(p, m.scope, m.audience), response_type: "code", response_mode: _ || "query", state: y, nonce: v, redirect_uri: $ || f.authorizationParams.redirect_uri, code_challenge: b, code_challenge_method: "S256", dpop_jkt: x }))(this.options, this.scope, t, a, o, d, t.redirect_uri || this.options.authorizationParams.redirect_uri || n, r?.response_mode, c), h = this._authorizeUrl(u);
    return { nonce: o, code_verifier: s, scope: u.scope, audience: u.audience || "default", redirect_uri: u.redirect_uri, state: a, url: h };
  }
  async loginWithPopup(t, r) {
    var n;
    if (t = t || {}, !(r = r || {}).popup && (r.popup = ((s) => {
      const l = window.screenX + (window.innerWidth - 400) / 2, d = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(s, "auth0:authorize:popup", "left=".concat(l, ",top=").concat(d, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
    })(""), !r.popup)) throw new xC();
    const i = await this._prepareAuthorizeUrl(t.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    r.popup.location.href = i.url;
    const a = await ((s) => new Promise(((l, d) => {
      let c;
      const u = setInterval((() => {
        s.popup && s.popup.closed && (clearInterval(u), clearTimeout(h), window.removeEventListener("message", c, !1), d(new _C(s.popup)));
      }), 1e3), h = setTimeout((() => {
        clearInterval(u), d(new kC(s.popup)), window.removeEventListener("message", c, !1);
      }), 1e3 * (s.timeoutInSeconds || 60));
      c = function(f) {
        if (f.data && f.data.type === "authorization_response") {
          if (clearTimeout(h), clearInterval(u), window.removeEventListener("message", c, !1), s.closePopup !== !1 && s.popup.close(), f.data.response.error) return d(ur.fromPayload(f.data.response));
          l(f.data.response);
        }
      }, window.addEventListener("message", c);
    })))(Object.assign(Object.assign({}, r), { timeoutInSeconds: r.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (i.state !== a.state) throw new ur("state_mismatch", "Invalid state");
    const o = ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: i.audience, scope: i.scope, code_verifier: i.code_verifier, grant_type: "authorization_code", code: a.code, redirect_uri: i.redirect_uri }, { nonceIn: i.nonce, organization: o });
  }
  async getUser() {
    var t;
    const r = await this._getIdTokenFromCache();
    return (t = r?.decodedToken) === null || t === void 0 ? void 0 : t.user;
  }
  async getIdTokenClaims() {
    var t;
    const r = await this._getIdTokenFromCache();
    return (t = r?.decodedToken) === null || t === void 0 ? void 0 : t.claims;
  }
  async loginWithRedirect() {
    var t;
    const r = Wv(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), { openUrl: n, fragment: i, appState: a } = r, o = fi(r, ["openUrl", "fragment", "appState"]), s = ((t = o.authorizationParams) === null || t === void 0 ? void 0 : t.organization) || this.options.authorizationParams.organization, l = await this._prepareAuthorizeUrl(o.authorizationParams || {}), { url: d } = l, c = fi(l, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, c), { appState: a, response_type: is.Code }), s && { organization: s }));
    const u = i ? "".concat(d, "#").concat(i) : d;
    n ? await n(u) : window.location.assign(u);
  }
  async handleRedirectCallback() {
    const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.href).split("?").slice(1);
    if (t.length === 0) throw new Error("There are no query params available for parsing.");
    const r = this.transactionManager.get();
    if (!r) throw new ur("missing_transaction", "Invalid state");
    this.transactionManager.remove();
    const n = ((i) => {
      i.indexOf("#") > -1 && (i = i.substring(0, i.indexOf("#")));
      const a = new URLSearchParams(i);
      return { state: a.get("state"), code: a.get("code") || void 0, connect_code: a.get("connect_code") || void 0, error: a.get("error") || void 0, error_description: a.get("error_description") || void 0 };
    })(t.join(""));
    return r.response_type === is.ConnectCode ? this._handleConnectAccountRedirectCallback(n, r) : this._handleLoginRedirectCallback(n, r);
  }
  async _handleLoginRedirectCallback(t, r) {
    const { code: n, state: i, error: a, error_description: o } = t;
    if (a) throw new wC(a, o || a, i, r.appState);
    if (!r.code_verifier || r.state && r.state !== i) throw new ur("state_mismatch", "Invalid state");
    const s = r.organization, l = r.nonce, d = r.redirect_uri;
    return await this._requestToken(Object.assign({ audience: r.audience, scope: r.scope, code_verifier: r.code_verifier, grant_type: "authorization_code", code: n }, d ? { redirect_uri: d } : {}), { nonceIn: l, organization: s }), { appState: r.appState, response_type: is.Code };
  }
  async _handleConnectAccountRedirectCallback(t, r) {
    const { connect_code: n, state: i, error: a, error_description: o } = t;
    if (a) throw new $C(a, o || a, r.connection, i, r.appState);
    if (!n) throw new ur("missing_connect_code", "Missing connect code");
    if (!(r.code_verifier && r.state && r.auth_session && r.redirect_uri && r.state === i)) throw new ur("state_mismatch", "Invalid state");
    const s = await this.myAccountApi.completeAccount({ auth_session: r.auth_session, connect_code: n, redirect_uri: r.redirect_uri, code_verifier: r.code_verifier });
    return Object.assign(Object.assign({}, s), { appState: r.appState, response_type: is.ConnectCode });
  }
  async checkSession(t) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated")) return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(t);
    } catch {
    }
  }
  async getTokenSilently() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var r, n;
    const i = Object.assign(Object.assign({ cacheMode: "on" }, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: h0(this.scope, (r = t.authorizationParams) === null || r === void 0 ? void 0 : r.scope, ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.audience) || this.options.authorizationParams.audience) }) }), a = await ((o, s) => {
      let l = Jf[s];
      return l || (l = o().finally((() => {
        delete Jf[s], l = null;
      })), Jf[s] = l), l;
    })((() => this._getTokenSilently(i)), "".concat(this.options.clientId, "::").concat(i.authorizationParams.audience, "::").concat(i.authorizationParams.scope));
    return t.detailedResponse ? a : a?.access_token;
  }
  async _getTokenSilently(t) {
    const { cacheMode: r } = t, n = fi(t, ["cacheMode"]);
    if (r !== "off") {
      const s = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId, cacheMode: r });
      if (s) return s;
    }
    if (r === "cache-only") return;
    const i = (a = this.options.clientId, o = n.authorizationParams.audience || "default", "".concat("auth0.lock.getTokenSilently", ".").concat(a, ".").concat(o));
    var a, o;
    try {
      return await this.lockManager.runWithLock(i, 5e3, (async () => {
        if (r !== "off") {
          const f = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (f) return f;
        }
        const s = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(n) : await this._getTokenFromIFrame(n), { id_token: l, token_type: d, access_token: c, oauthTokenScope: u, expires_in: h } = s;
        return Object.assign(Object.assign({ id_token: l, token_type: d, access_token: c }, u ? { scope: u } : null), { expires_in: h });
      }));
    } catch (s) {
      if (this._isInteractiveError(s) && this.options.interactiveErrorHandler === "popup") return await this._handleInteractiveErrorWithPopup(n);
      throw s;
    }
  }
  _isInteractiveError(t) {
    return t instanceof I1 || t instanceof ur && this._isIframeMfaError(t);
  }
  _isIframeMfaError(t) {
    return t.error === "login_required" && t.error_description === "Multifactor authentication required";
  }
  async _handleInteractiveErrorWithPopup(t) {
    try {
      await this.loginWithPopup({ authorizationParams: t.authorizationParams });
      const r = await this._getEntryFromCache({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (!r) throw new ur("interactive_handler_cache_miss", "Token not found in cache after interactive authentication");
      return r;
    } catch (r) {
      throw r;
    }
  }
  async getTokenWithPopup() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var n, i;
    const a = Object.assign(Object.assign({}, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: h0(this.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.scope, ((i = t.authorizationParams) === null || i === void 0 ? void 0 : i.audience) || this.options.authorizationParams.audience) }) });
    return r = Object.assign(Object.assign({}, bC), r), await this.loginWithPopup(a, r), (await this.cacheManager.get(new ga({ scope: a.authorizationParams.scope, audience: a.authorizationParams.audience || "default", clientId: this.options.clientId }), void 0, this.options.useMrrt)).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t) {
    t.clientId !== null ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
    const r = t.logoutParams || {}, { federated: n } = r, i = fi(r, ["federated"]), a = n ? "&federated" : "";
    return this._url("/v2/logout?".concat(Fp(Object.assign({ clientId: t.clientId }, i)))) + a;
  }
  async logout() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var r;
    const n = Wv(t), { openUrl: i } = n, a = fi(n, ["openUrl"]);
    t.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@"), await ((r = this.dpop) === null || r === void 0 ? void 0 : r.clear());
    const o = this._buildLogoutUrl(a);
    i ? await i(o) : i !== !1 && window.location.assign(o);
  }
  async _getTokenFromIFrame(t) {
    const r = (n = this.options.clientId, "".concat("auth0.lock.getTokenFromIFrame", ".").concat(n));
    var n;
    try {
      return await this.lockManager.runWithLock(r, 5e3, (async () => {
        const i = Object.assign(Object.assign({}, t.authorizationParams), { prompt: "none" }), a = this.cookieStorage.get(this.orgHintCookieName);
        a && !i.organization && (i.organization = a);
        const { url: o, state: s, nonce: l, code_verifier: d, redirect_uri: c, scope: u, audience: h } = await this._prepareAuthorizeUrl(i, { response_mode: "web_message" }, window.location.origin);
        if (window.crossOriginIsolated) throw new ur("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
        const f = t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
        let p;
        try {
          p = new URL(this.domainUrl).origin;
        } catch {
          p = this.domainUrl;
        }
        const m = await (function(v, b) {
          let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 60;
          return new Promise(((_, x) => {
            const S = window.document.createElement("iframe");
            S.setAttribute("width", "0"), S.setAttribute("height", "0"), S.style.display = "none";
            const A = () => {
              window.document.body.contains(S) && (window.document.body.removeChild(S), window.removeEventListener("message", N, !1));
            };
            let N;
            const P = setTimeout((() => {
              x(new jh()), A();
            }), 1e3 * $);
            N = function(D) {
              if (D.origin != b || !D.data || D.data.type !== "authorization_response") return;
              const T = D.source;
              T && T.close(), D.data.response.error ? x(ur.fromPayload(D.data.response)) : _(D.data.response), clearTimeout(P), window.removeEventListener("message", N, !1), setTimeout(A, 2e3);
            }, window.addEventListener("message", N, !1), window.document.body.appendChild(S), S.setAttribute("src", v);
          }));
        })(o, p, f);
        if (s !== m.state) throw new ur("state_mismatch", "Invalid state");
        const y = await this._requestToken(Object.assign(Object.assign({}, t.authorizationParams), { code_verifier: d, code: m.code, grant_type: "authorization_code", redirect_uri: c, timeout: t.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: l, organization: i.organization });
        return Object.assign(Object.assign({}, y), { scope: u, oauthTokenScope: y.scope, audience: h });
      }));
    } catch (i) {
      throw i.error === "login_required" && (i instanceof ur && this._isIframeMfaError(i) && this.options.interactiveErrorHandler === "popup" || this.logout({ openUrl: !1 })), i;
    }
  }
  async _getTokenUsingRefreshToken(t) {
    var r, n;
    const i = await this.cacheManager.get(new ga({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId }), void 0, this.options.useMrrt);
    if (!(i && i.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      throw new W8(t.authorizationParams.audience || "default", t.authorizationParams.scope);
    }
    const a = t.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = typeof t.timeoutInSeconds == "number" ? 1e3 * t.timeoutInSeconds : null, s = ((h, f, p, m) => {
      var y;
      if (h && p && m) {
        if (f.audience !== p) return f.scope;
        const v = m.split(" "), b = ((y = f.scope) === null || y === void 0 ? void 0 : y.split(" ")) || [], $ = b.every(((_) => v.includes(_)));
        return v.length >= b.length && $ ? m : f.scope;
      }
      return f.scope;
    })(this.options.useMrrt, t.authorizationParams, i?.audience, i?.scope);
    try {
      const h = await this._requestToken(Object.assign(Object.assign(Object.assign({}, t.authorizationParams), { grant_type: "refresh_token", refresh_token: i && i.refresh_token, redirect_uri: a }), o && { timeout: o }), { scopesToRequest: s });
      if (h.refresh_token && i?.refresh_token && await this.cacheManager.updateEntry(i.refresh_token, h.refresh_token), this.options.useMrrt && (l = i?.audience, d = i?.scope, c = t.authorizationParams.audience, u = t.authorizationParams.scope, (l !== c || !Qv(u, d)) && !Qv(s, h.scope))) {
        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
        await this.cacheManager.remove(this.options.clientId, t.authorizationParams.audience, t.authorizationParams.scope);
        const f = ((p, m) => {
          const y = p?.split(" ") || [], v = m?.split(" ") || [];
          return y.filter(((b) => v.indexOf(b) == -1)).join(",");
        })(s, h.scope);
        throw new SC(t.authorizationParams.audience || "default", f);
      }
      return Object.assign(Object.assign({}, h), { scope: t.authorizationParams.scope, oauthTokenScope: h.scope, audience: t.authorizationParams.audience || "default" });
    } catch (h) {
      if (h.message) {
        if (h.message.includes("user is blocked")) throw await this.logout({ openUrl: !1 }), h;
        if ((h.message.includes("Missing Refresh Token") || h.message.includes("invalid refresh token")) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      }
      throw h instanceof I1 && this.mfa.setMFAAuthDetails(h.mfa_token, (r = t.authorizationParams) === null || r === void 0 ? void 0 : r.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.audience, h.mfa_requirements), h;
    }
    var l, d, c, u;
  }
  async _saveEntryInCache(t) {
    const { id_token: r, decodedToken: n } = t, i = fi(t, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: r, decodedToken: n }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(i);
  }
  async _getIdTokenFromCache() {
    const t = this.options.authorizationParams.audience || "default", r = this.scope[t], n = await this.cacheManager.getIdToken(new ga({ clientId: this.options.clientId, audience: t, scope: r })), i = this.userCache.get("@@user@@");
    return n && n.id_token === i?.id_token ? i : (this.userCache.set("@@user@@", n), n);
  }
  async _getEntryFromCache(t) {
    let { scope: r, audience: n, clientId: i, cacheMode: a } = t;
    const o = await this.cacheManager.get(new ga({ scope: r, audience: n, clientId: i }), 60, this.options.useMrrt, a);
    if (o && o.access_token) {
      const { token_type: s, access_token: l, oauthTokenScope: d, expires_in: c } = o, u = await this._getIdTokenFromCache();
      return u && Object.assign(Object.assign({ id_token: u.id_token, token_type: s || "Bearer", access_token: l }, d ? { scope: d } : null), { expires_in: c });
    }
  }
  async _requestToken(t, r) {
    var n, i;
    const { nonceIn: a, organization: o, scopesToRequest: s } = r || {}, l = await QC(Object.assign(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs, useMrrt: this.options.useMrrt, dpop: this.dpop }, t), { scope: s || t.scope }), this.worker), d = await this._verifyIdToken(l.id_token, a, o);
    if (t.grant_type === "authorization_code") {
      const c = await this._getIdTokenFromCache();
      !((i = (n = c?.decodedToken) === null || n === void 0 ? void 0 : n.claims) === null || i === void 0) && i.sub && c.decodedToken.claims.sub !== d.claims.sub && (await this.cacheManager.clear(this.options.clientId), this.userCache.remove("@@user@@"));
    }
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, l), { decodedToken: d, scope: t.scope, audience: t.audience || "default" }), l.scope ? { oauthTokenScope: l.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(o || d.claims.org_id), Object.assign(Object.assign({}, l), { decodedToken: d });
  }
  async loginWithCustomTokenExchange(t) {
    return this._requestToken(Object.assign(Object.assign({}, t), { grant_type: "urn:ietf:params:oauth:grant-type:token-exchange", subject_token: t.subject_token, subject_token_type: t.subject_token_type, scope: h0(this.scope, t.scope, t.audience || this.options.authorizationParams.audience), audience: t.audience || this.options.authorizationParams.audience, organization: t.organization || this.options.authorizationParams.organization }));
  }
  async exchangeToken(t) {
    return this.loginWithCustomTokenExchange(t);
  }
  _assertDpop(t) {
    if (!t) throw new Error("`useDpop` option must be enabled before using DPoP.");
  }
  getDpopNonce(t) {
    return this._assertDpop(this.dpop), this.dpop.getNonce(t);
  }
  setDpopNonce(t, r) {
    return this._assertDpop(this.dpop), this.dpop.setNonce(t, r);
  }
  generateDpopProof(t) {
    return this._assertDpop(this.dpop), this.dpop.generateProof(t);
  }
  createFetcher() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new uE(t, { isDpopEnabled: () => !!this.options.useDpop, getAccessToken: (r) => {
      var n;
      return this.getTokenSilently({ authorizationParams: { scope: (n = r?.scope) === null || n === void 0 ? void 0 : n.join(" "), audience: r?.audience }, detailedResponse: !0 });
    }, getDpopNonce: () => this.getDpopNonce(t.dpopNonceId), setDpopNonce: (r) => this.setDpopNonce(r, t.dpopNonceId), generateDpopProof: (r) => this.generateDpopProof(r) });
  }
  async connectAccountWithRedirect(t) {
    const { openUrl: r, appState: n, connection: i, scopes: a, authorization_params: o, redirectUri: s = this.options.authorizationParams.redirect_uri || window.location.origin } = t;
    if (!i) throw new Error("connection is required");
    const l = Qf(Vd()), d = Vd(), c = await Fv(d), u = zv(c), { connect_uri: h, connect_params: f, auth_session: p } = await this.myAccountApi.connectAccount({ connection: i, scopes: a, redirect_uri: s, state: l, code_challenge: u, code_challenge_method: "S256", authorization_params: o });
    this.transactionManager.create({ state: l, code_verifier: d, auth_session: p, redirect_uri: s, appState: n, connection: i, response_type: is.ConnectCode });
    const m = new URL(h);
    m.searchParams.set("ticket", f.ticket), r ? await r(m.toString()) : window.location.assign(m);
  }
  async _requestTokenForMfa(t, r) {
    const { mfaToken: n } = t, i = fi(t, ["mfaToken"]);
    return this._requestToken(Object.assign(Object.assign({}, i), { mfa_token: n }), r);
  }
};
var y2 = "Invariant Violation", g4 = Object.setPrototypeOf, RA = g4 === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : g4, Gb = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      r === void 0 && (r = y2);
      var n = e.call(this, typeof r == "number" ? y2 + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = y2, RA(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function os(e, t) {
  if (!e)
    throw new Gb(t);
}
var Zb = ["debug", "log", "warn", "error", "silent"], LA = Zb.indexOf("log");
function $0(e) {
  return function() {
    if (Zb.indexOf(e) >= LA) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = $0("debug"), e.log = $0("log"), e.warn = $0("warn"), e.error = $0("error");
})(os || (os = {}));
var Ng = "3.14.0";
function gi(e) {
  try {
    return e();
  } catch {
  }
}
const V1 = gi(function() {
  return globalThis;
}) || gi(function() {
  return window;
}) || gi(function() {
  return self;
}) || gi(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
gi(function() {
  return gi.constructor("return this")();
});
var v4 = /* @__PURE__ */ new Map();
function n5(e) {
  var t = v4.get(e) || 1;
  return v4.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function Yb(e, t) {
  t === void 0 && (t = 0);
  var r = n5("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function k0(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = Dg(i), t || (t = Mg(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var ke = Object.assign(function(t, r) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  t || os(t, Dg(r, n) || Mg(r, n));
}, {
  debug: k0(os.debug),
  log: k0(os.log),
  warn: k0(os.warn),
  error: k0(os.error)
});
function wn(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new Gb(Dg(e, t) || Mg(e, t));
}
var y4 = /* @__PURE__ */ Symbol.for("ApolloErrorMessageHandler_" + Ng);
function Jb(e) {
  if (typeof e == "string")
    return e;
  try {
    return Yb(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function Dg(e, t) {
  if (t === void 0 && (t = []), !!e)
    return V1[y4] && V1[y4](e, t.map(Jb));
}
function Mg(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Ng,
      message: e,
      args: t.map(Jb)
    })));
}
function i1(e, t) {
  if (!!!e)
    throw new Error(t);
}
function FA(e) {
  return typeof e == "object" && e !== null;
}
function jA(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const zA = /\r\n|[\n\r]/g;
function i5(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(zA)) {
    if (typeof i.index == "number" || jA(!1), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function VA(e) {
  return Xb(
    e.source,
    i5(e.source, e.start)
  );
}
function Xb(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, d = `${e.name}:${o}:${l}
`, c = n.split(/\r\n|[\n\r]/g), u = c[i];
  if (u.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, p = [];
    for (let m = 0; m < u.length; m += 80)
      p.push(u.slice(m, m + 80));
    return d + b4([
      [`${o} |`, p[0]],
      ...p.slice(1, h + 1).map((m) => ["|", m]),
      ["|", "^".padStart(f)],
      ["|", p[h + 1]]
    ]);
  }
  return d + b4([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, c[i - 1]],
    [`${o} |`, u],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, c[i + 1]]
  ]);
}
function b4(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function UA(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Rg extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, a;
    const { nodes: o, source: s, positions: l, path: d, originalError: c, extensions: u } = UA(r);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = c ?? void 0, this.nodes = w4(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = w4(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = s ?? (h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? h?.map((p) => p.start), this.locations = l && s ? l.map((p) => i5(s, p)) : h?.map((p) => i5(p.source, p.start));
    const f = FA(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (a = u ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Rg) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + VA(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + Xb(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function w4(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function jr(e, t, r) {
  return new Rg(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class qA {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class ew {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, a, o) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const tw = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, BA = new Set(Object.keys(tw));
function $4(e) {
  const t = e?.kind;
  return typeof t == "string" && BA.has(t);
}
var yl;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(yl || (yl = {}));
var a5;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(a5 || (a5 = {}));
var ye;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(ye || (ye = {}));
function o5(e) {
  return e === 9 || e === 32;
}
function Yc(e) {
  return e >= 48 && e <= 57;
}
function rw(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function nw(e) {
  return rw(e) || e === 95;
}
function HA(e) {
  return rw(e) || Yc(e) || e === 95;
}
function WA(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = QA(s);
    l !== s.length && (n = (a = n) !== null && a !== void 0 ? a : o, i = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function QA(e) {
  let t = 0;
  for (; t < e.length && o5(e.charCodeAt(t)); )
    ++t;
  return t;
}
function KA(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((f) => f.length === 0 || o5(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), d = s || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || a || o
  );
  let u = "";
  const h = i && o5(e.charCodeAt(0));
  return (c && !h || a) && (u += `
`), u += r, (c || d) && (u += `
`), '"""' + u + '"""';
}
var J;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(J || (J = {}));
class GA {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new ew(J.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== J.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = YA(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === J.COMMENT);
    return t;
  }
}
function ZA(e) {
  return e === J.BANG || e === J.DOLLAR || e === J.AMP || e === J.PAREN_L || e === J.PAREN_R || e === J.DOT || e === J.SPREAD || e === J.COLON || e === J.EQUALS || e === J.AT || e === J.BRACKET_L || e === J.BRACKET_R || e === J.BRACE_L || e === J.PIPE || e === J.BRACE_R;
}
function wd(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Bh(e, t) {
  return iw(e.charCodeAt(t)) && aw(e.charCodeAt(t + 1));
}
function iw(e) {
  return e >= 55296 && e <= 56319;
}
function aw(e) {
  return e >= 56320 && e <= 57343;
}
function ws(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return J.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function Tr(e, t, r, n, i) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new ew(t, r, n, a, o, i);
}
function YA(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    switch (a) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      // Comment
      case 35:
        return JA(e, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return Tr(e, J.BANG, i, i + 1);
      case 36:
        return Tr(e, J.DOLLAR, i, i + 1);
      case 38:
        return Tr(e, J.AMP, i, i + 1);
      case 40:
        return Tr(e, J.PAREN_L, i, i + 1);
      case 41:
        return Tr(e, J.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return Tr(e, J.SPREAD, i, i + 3);
        break;
      case 58:
        return Tr(e, J.COLON, i, i + 1);
      case 61:
        return Tr(e, J.EQUALS, i, i + 1);
      case 64:
        return Tr(e, J.AT, i, i + 1);
      case 91:
        return Tr(e, J.BRACKET_L, i, i + 1);
      case 93:
        return Tr(e, J.BRACKET_R, i, i + 1);
      case 123:
        return Tr(e, J.BRACE_L, i, i + 1);
      case 124:
        return Tr(e, J.PIPE, i, i + 1);
      case 125:
        return Tr(e, J.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? iT(e, i) : eT(e, i);
    }
    if (Yc(a) || a === 45)
      return XA(e, i, a);
    if (nw(a))
      return aT(e, i);
    throw jr(
      e.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : wd(a) || Bh(r, i) ? `Unexpected character: ${ws(e, i)}.` : `Invalid character: ${ws(e, i)}.`
    );
  }
  return Tr(e, J.EOF, n, n);
}
function JA(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (wd(a))
      ++i;
    else if (Bh(r, i))
      i += 2;
    else
      break;
  }
  return Tr(
    e,
    J.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function XA(e, t, r) {
  const n = e.source.body;
  let i = t, a = r, o = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), Yc(a))
      throw jr(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${ws(
          e,
          i
        )}.`
      );
  } else
    i = b2(e, i, a), a = n.charCodeAt(i);
  if (a === 46 && (o = !0, a = n.charCodeAt(++i), i = b2(e, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (o = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = b2(e, i, a), a = n.charCodeAt(i)), a === 46 || nw(a))
    throw jr(
      e.source,
      i,
      `Invalid number, expected digit but got: ${ws(
        e,
        i
      )}.`
    );
  return Tr(
    e,
    o ? J.FLOAT : J.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function b2(e, t, r) {
  if (!Yc(r))
    throw jr(
      e.source,
      t,
      `Invalid number, expected digit but got: ${ws(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; Yc(n.charCodeAt(i)); )
    ++i;
  return i;
}
function eT(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, a = i, o = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return o += r.slice(a, i), Tr(e, J.STRING, t, i + 1, o);
    if (s === 92) {
      o += r.slice(a, i);
      const l = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? tT(e, i) : rT(e, i) : nT(e, i);
      o += l.value, i += l.size, a = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (wd(s))
      ++i;
    else if (Bh(r, i))
      i += 2;
    else
      throw jr(
        e.source,
        i,
        `Invalid character within String: ${ws(
          e,
          i
        )}.`
      );
  }
  throw jr(e.source, i, "Unterminated string.");
}
function tT(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = r.charCodeAt(t + i++);
    if (a === 125) {
      if (i < 5 || !wd(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | vc(a), n < 0)
      break;
  }
  throw jr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function rT(e, t) {
  const r = e.source.body, n = k4(r, t + 2);
  if (wd(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (iw(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = k4(r, t + 8);
    if (aw(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw jr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function k4(e, t) {
  return vc(e.charCodeAt(t)) << 12 | vc(e.charCodeAt(t + 1)) << 8 | vc(e.charCodeAt(t + 2)) << 4 | vc(e.charCodeAt(t + 3));
}
function vc(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function nT(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw jr(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function iT(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < n; ) {
    const d = r.charCodeAt(a);
    if (d === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const c = Tr(
        e,
        J.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        WA(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = i, c;
    }
    if (d === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += r.slice(o, a), l.push(s), d === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, i = a;
      continue;
    }
    if (wd(d))
      ++a;
    else if (Bh(r, a))
      a += 2;
    else
      throw jr(
        e.source,
        a,
        `Invalid character within String: ${ws(
          e,
          a
        )}.`
      );
  }
  throw jr(e.source, a, "Unterminated string.");
}
function aT(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (HA(a))
      ++i;
    else
      break;
  }
  return Tr(
    e,
    J.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const oT = 10, ow = 2;
function Lg(e) {
  return Hh(e, []);
}
function Hh(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return sT(e, t);
    default:
      return String(e);
  }
}
function sT(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (lT(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Hh(n, r);
  } else if (Array.isArray(e))
    return cT(e, r);
  return dT(e, r);
}
function lT(e) {
  return typeof e.toJSON == "function";
}
function dT(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > ow ? "[" + uT(e) + "]" : "{ " + r.map(
    ([i, a]) => i + ": " + Hh(a, t)
  ).join(", ") + " }";
}
function cT(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > ow)
    return "[Array]";
  const r = Math.min(oT, e.length), n = e.length - r, i = [];
  for (let a = 0; a < r; ++a)
    i.push(Hh(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function uT(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const hT = globalThis.process && // eslint-disable-next-line no-undef
!0, fT = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  hT ? function(t, r) {
    return t instanceof r;
  } : function(t, r) {
    if (t instanceof r)
      return !0;
    if (typeof t == "object" && t !== null) {
      var n;
      const i = r.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === a) {
        const o = Lg(t);
        throw new Error(`Cannot use ${i} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class sw {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || i1(!1, `Body must be a string. Received: ${Lg(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || i1(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || i1(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function pT(e) {
  return fT(e, sw);
}
function mT(e, t) {
  const r = new gT(e, t), n = r.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: r.tokenCount
  }), n;
}
let gT = class {
  constructor(t, r = {}) {
    const { lexer: n, ...i } = r;
    if (n)
      this._lexer = n;
    else {
      const a = pT(t) ? t : new sw(t);
      this._lexer = new GA(a);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(J.NAME);
    return this.node(t, {
      kind: ye.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: ye.DOCUMENT,
      definitions: this.many(
        J.SOF,
        this.parseDefinition,
        J.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(J.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (t && r.kind === J.BRACE_L)
      throw jr(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (r.kind === J.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (t)
        throw jr(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (r.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(J.BRACE_L))
      return this.node(t, {
        kind: ye.OPERATION_DEFINITION,
        operation: yl.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseDescription(), n = this.parseOperationType();
    let i;
    return this.peek(J.NAME) && (i = this.parseName()), this.node(t, {
      kind: ye.OPERATION_DEFINITION,
      operation: n,
      description: r,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(J.NAME);
    switch (t.value) {
      case "query":
        return yl.QUERY;
      case "mutation":
        return yl.MUTATION;
      case "subscription":
        return yl.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      J.PAREN_L,
      this.parseVariableDefinition,
      J.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: ye.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(J.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(J.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(J.DOLLAR), this.node(t, {
      kind: ye.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: ye.SELECTION_SET,
      selections: this.many(
        J.BRACE_L,
        this.parseSelection,
        J.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(J.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(J.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: ye.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(J.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(J.PAREN_L, r, J.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(J.COLON), this.node(r, {
      kind: ye.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(J.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(J.NAME) ? this.node(t, {
      kind: ye.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: ye.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: ye.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: ye.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case J.BRACKET_L:
        return this.parseList(t);
      case J.BRACE_L:
        return this.parseObject(t);
      case J.INT:
        return this.advanceLexer(), this.node(r, {
          kind: ye.INT,
          value: r.value
        });
      case J.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: ye.FLOAT,
          value: r.value
        });
      case J.STRING:
      case J.BLOCK_STRING:
        return this.parseStringLiteral();
      case J.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: ye.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: ye.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: ye.NULL
            });
          default:
            return this.node(r, {
              kind: ye.ENUM,
              value: r.value
            });
        }
      case J.DOLLAR:
        if (t)
          if (this.expectToken(J.DOLLAR), this._lexer.token.kind === J.NAME) {
            const n = this._lexer.token.value;
            throw jr(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: ye.STRING,
      value: t.value,
      block: t.kind === J.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: ye.LIST,
      values: this.any(J.BRACKET_L, r, J.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: ye.OBJECT,
      fields: this.any(J.BRACE_L, r, J.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(J.COLON), this.node(r, {
      kind: ye.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(J.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(J.AT), this.node(r, {
      kind: ye.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(J.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(J.BRACKET_R), r = this.node(t, {
        kind: ye.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(J.BANG) ? this.node(t, {
      kind: ye.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: ye.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(J.STRING) || this.peek(J.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      J.BRACE_L,
      this.parseOperationTypeDefinition,
      J.BRACE_R
    );
    return this.node(t, {
      kind: ye.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(J.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: ye.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ye.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(J.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      J.BRACE_L,
      this.parseFieldDefinition,
      J.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(J.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      J.PAREN_L,
      this.parseInputValueDef,
      J.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(J.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(J.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ye.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: ye.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(J.EQUALS) ? this.delimitedMany(J.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: ye.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      J.BRACE_L,
      this.parseEnumValueDefinition,
      J.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ye.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw jr(
        this._lexer.source,
        this._lexer.token.start,
        `${_0(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: ye.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      J.BRACE_L,
      this.parseInputValueDef,
      J.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === J.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      J.BRACE_L,
      this.parseOperationTypeDefinition,
      J.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ye.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(J.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: ye.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(J.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(a5, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const t = this._lexer.token, r = this.expectOptionalToken(J.AT), n = this.parseName();
    let i;
    !r && this.expectOptionalToken(J.DOT) && (i = this.parseName());
    let a;
    return (r || i) && this.expectOptionalToken(J.PAREN_L) && (a = this.parseName(), this.expectToken(J.COLON), this.expectToken(J.PAREN_R)), r ? a ? this.node(t, {
      kind: ye.DIRECTIVE_ARGUMENT_COORDINATE,
      name: n,
      argumentName: a
    }) : this.node(t, {
      kind: ye.DIRECTIVE_COORDINATE,
      name: n
    }) : i ? a ? this.node(t, {
      kind: ye.ARGUMENT_COORDINATE,
      name: n,
      fieldName: i,
      argumentName: a
    }) : this.node(t, {
      kind: ye.MEMBER_COORDINATE,
      name: n,
      memberName: i
    }) : this.node(t, {
      kind: ye.TYPE_COORDINATE,
      name: n
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new qA(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw jr(
      this._lexer.source,
      r.start,
      `Expected ${lw(t)}, found ${_0(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === J.NAME && r.value === t)
      this.advanceLexer();
    else
      throw jr(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${_0(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === J.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return jr(
      this._lexer.source,
      r.start,
      `Unexpected ${_0(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (r.kind !== J.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
      throw jr(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
};
function _0(e) {
  const t = e.value;
  return lw(e.kind) + (t != null ? ` "${t}"` : "");
}
function lw(e) {
  return ZA(e) ? `"${e}"` : e;
}
function vT(e) {
  return `"${e.replace(yT, bT)}"`;
}
const yT = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function bT(e) {
  return wT[e.charCodeAt(0)];
}
const wT = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Wh = Object.freeze({});
function Ai(e, t, r = tw) {
  const n = /* @__PURE__ */ new Map();
  for (const v of Object.values(ye))
    n.set(v, $T(t, v));
  let i, a = Array.isArray(e), o = [e], s = -1, l = [], d = e, c, u;
  const h = [], f = [];
  do {
    s++;
    const v = s === o.length, b = v && l.length !== 0;
    if (v) {
      if (c = f.length === 0 ? void 0 : h[h.length - 1], d = u, u = f.pop(), b)
        if (a) {
          d = d.slice();
          let _ = 0;
          for (const [x, S] of l) {
            const A = x - _;
            S === null ? (d.splice(A, 1), _++) : d[A] = S;
          }
        } else {
          d = { ...d };
          for (const [_, x] of l)
            d[_] = x;
        }
      s = i.index, o = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (u) {
      if (c = a ? s : o[s], d = u[c], d == null)
        continue;
      h.push(c);
    }
    let $;
    if (!Array.isArray(d)) {
      var p, m;
      $4(d) || i1(!1, `Invalid AST Node: ${Lg(d)}.`);
      const _ = v ? (p = n.get(d.kind)) === null || p === void 0 ? void 0 : p.leave : (m = n.get(d.kind)) === null || m === void 0 ? void 0 : m.enter;
      if ($ = _?.call(t, d, c, u, h, f), $ === Wh)
        break;
      if ($ === !1) {
        if (!v) {
          h.pop();
          continue;
        }
      } else if ($ !== void 0 && (l.push([c, $]), !v))
        if ($4($))
          d = $;
        else {
          h.pop();
          continue;
        }
    }
    if ($ === void 0 && b && l.push([c, d]), v)
      h.pop();
    else {
      var y;
      i = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: i
      }, a = Array.isArray(d), o = a ? d : (y = r[d.kind]) !== null && y !== void 0 ? y : [], s = -1, l = [], u && f.push(u), u = d;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function $T(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function kT(e) {
  return Ai(e, xT);
}
const _T = 80, xT = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Ae(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = w2(e.variableDefinitions) ? Ye(`(
`, Ae(e.variableDefinitions, `
`), `
)`) : Ye("(", Ae(e.variableDefinitions, ", "), ")"), r = Ye("", e.description, `
`) + Ae(
        [
          e.operation,
          Ae([e.name, t]),
          Ae(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n, description: i }) => Ye("", i, `
`) + e + ": " + t + Ye(" = ", r) + Ye(" ", Ae(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => di(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const a = Ye("", e, ": ") + t;
      let o = a + Ye("(", Ae(r, ", "), ")");
      return o.length > _T && (o = a + Ye(`(
`, a1(Ae(r, `
`)), `
)`)), Ae([o, Ae(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + Ye(" ", Ae(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => Ae(
      [
        "...",
        Ye("on ", e),
        Ae(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: t,
      variableDefinitions: r,
      directives: n,
      selectionSet: i,
      description: a
    }) => Ye("", a, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${Ye("(", Ae(r, ", "), ")")} on ${t} ${Ye("", Ae(n, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? KA(e) : vT(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Ae(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Ae(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + Ye("(", Ae(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => Ye("", e, `
`) + Ae(["schema", Ae(t, " "), di(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Ye("", e, `
`) + Ae(["scalar", t, Ae(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Ye("", e, `
`) + Ae(
      [
        "type",
        t,
        Ye("implements ", Ae(r, " & ")),
        Ae(n, " "),
        di(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => Ye("", e, `
`) + t + (w2(r) ? Ye(`(
`, a1(Ae(r, `
`)), `
)`) : Ye("(", Ae(r, ", "), ")")) + ": " + n + Ye(" ", Ae(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => Ye("", e, `
`) + Ae(
      [t + ": " + r, Ye("= ", n), Ae(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Ye("", e, `
`) + Ae(
      [
        "interface",
        t,
        Ye("implements ", Ae(r, " & ")),
        Ae(n, " "),
        di(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => Ye("", e, `
`) + Ae(
      ["union", t, Ae(r, " "), Ye("= ", Ae(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => Ye("", e, `
`) + Ae(["enum", t, Ae(r, " "), di(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Ye("", e, `
`) + Ae([t, Ae(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => Ye("", e, `
`) + Ae(["input", t, Ae(r, " "), di(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => Ye("", e, `
`) + "directive @" + t + (w2(r) ? Ye(`(
`, a1(Ae(r, `
`)), `
)`) : Ye("(", Ae(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + Ae(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => Ae(
      ["extend schema", Ae(e, " "), di(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => Ae(["extend scalar", e, Ae(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Ae(
      [
        "extend type",
        e,
        Ye("implements ", Ae(t, " & ")),
        Ae(r, " "),
        di(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Ae(
      [
        "extend interface",
        e,
        Ye("implements ", Ae(t, " & ")),
        Ae(r, " "),
        di(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => Ae(
      [
        "extend union",
        e,
        Ae(t, " "),
        Ye("= ", Ae(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => Ae(["extend enum", e, Ae(t, " "), di(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => Ae(["extend input", e, Ae(t, " "), di(r)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: t }) => Ae([e, Ye(".", t)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: t, argumentName: r }) => Ae([e, Ye(".", t), Ye("(", r, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => Ae(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: t }) => Ae(["@", e, Ye("(", t, ":)")])
  }
};
function Ae(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function di(e) {
  return Ye(`{
`, a1(Ae(e, `
`)), `
}`);
}
function Ye(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function a1(e) {
  return Ye("  ", e.replace(/\n/g, `
  `));
}
function w2(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function _4(e) {
  return e.kind === ye.FIELD || e.kind === ye.FRAGMENT_SPREAD || e.kind === ye.INLINE_FRAGMENT;
}
function ju(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : ET(r).every(function(n) {
    var i = n.directive, a = n.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], ke(o !== void 0, 106, i.name.value)) : o = a.value.value, i.name.value === "skip" ? !o : o;
  });
}
function Jc(e, t, r) {
  var n = new Set(e), i = n.size;
  return Ai(t, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!r || !n.size))
        return Wh;
    }
  }), r ? !n.size : n.size < i;
}
function ST(e) {
  return e && Jc(["client", "export"], e, !0);
}
function CT(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function ET(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (CT(r)) {
      var n = r.arguments, i = r.name.value;
      ke(n && n.length === 1, 107, i);
      var a = n[0];
      ke(a.name && a.name.value === "if", 108, i);
      var o = a.value;
      ke(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 109, i), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
function AT(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(a) {
    var o = a.name;
    return o.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(a) {
    var o = a.name;
    return o.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === ye.VARIABLE ? globalThis.__DEV__ !== !1 && ke.warn(110) : i.value.kind !== ye.STRING ? globalThis.__DEV__ !== !1 && ke.warn(111) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && ke.warn(112, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const TT = () => /* @__PURE__ */ Object.create(null), { forEach: OT, slice: x4 } = Array.prototype, { hasOwnProperty: IT } = Object.prototype;
class Da {
  constructor(t = !0, r = TT) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return OT.call(t, (n) => r = r.getChildTrie(n)), IT.call(r, "data") ? r.data : r.data = this.makeData(x4.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const a = r.mapFor(t[n], !1);
      r = a && a.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (r = a.removeArray(x4.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new Da(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && PT(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function PT(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var NT = gi(function() {
  return navigator.product;
}) == "ReactNative", Fs = typeof WeakMap == "function" && !(NT && !global.HermesInternal), Fg = typeof WeakSet == "function", dw = typeof Symbol == "function" && typeof Symbol.for == "function", Qh = dw && Symbol.asyncIterator;
gi(function() {
  return window.document.createElement;
});
gi(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function vr(e) {
  return e !== null && typeof e == "object";
}
function DT(e, t) {
  var r = t, n = [];
  e.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw wn(
        113,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && n.push(a);
  }), typeof r > "u" && (ke(n.length === 1, 114, n.length), r = n[0].name.value);
  var i = z(z({}, e), { definitions: rn([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function $d(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function Kh(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return ke(n, 115, r), n || null;
    }
    default:
      return null;
  }
}
function MT(e) {
  var t = !0;
  return Ai(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return Wh;
    }
  }), t;
}
function RT() {
}
class s5 {
  constructor(t = 1 / 0, r = RT) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function l5() {
}
const LT = l5, FT = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, jT = typeof WeakMap < "u" ? WeakMap : Map, zT = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: l5,
    unregister: l5
  };
}, VT = 10024;
class U1 {
  constructor(t = 1 / 0, r = LT) {
    this.max = t, this.dispose = r, this.map = new jT(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < VT; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const o = a.key;
        delete a.key, a.keyRef = new FT(o), this.registry.register(o, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new zT(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var $2 = /* @__PURE__ */ new WeakSet();
function cw(e) {
  e.size <= (e.max || -1) || $2.has(e) || ($2.add(e), setTimeout(function() {
    e.clean(), $2.delete(e);
  }, 100));
}
var uw = function(e, t) {
  var r = new U1(e, t);
  return r.set = function(n, i) {
    var a = U1.prototype.set.call(this, n, i);
    return cw(this), a;
  }, r;
}, UT = function(e, t) {
  var r = new s5(e, t);
  return r.set = function(n, i) {
    var a = s5.prototype.set.call(this, n, i);
    return cw(this), a;
  }, r;
}, qT = /* @__PURE__ */ Symbol.for("apollo.cacheSize"), Sa = z({}, V1[qT]), Jo = {};
function hw(e, t) {
  Jo[e] = t;
}
var BT = globalThis.__DEV__ !== !1 ? KT : void 0, HT = globalThis.__DEV__ !== !1 ? GT : void 0, WT = globalThis.__DEV__ !== !1 ? fw : void 0;
function QT() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      Sa[r] || n
    ];
  }));
}
function KT() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: QT(),
    sizes: z({ print: (e = Jo.print) === null || e === void 0 ? void 0 : e.call(Jo), parser: (t = Jo.parser) === null || t === void 0 ? void 0 : t.call(Jo), canonicalStringify: (r = Jo.canonicalStringify) === null || r === void 0 ? void 0 : r.call(Jo), links: c5(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: mw(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function fw() {
  return {
    cache: {
      fragmentQueryDocuments: Za(this.getFragmentDoc)
    }
  };
}
function GT() {
  var e = this.config.fragments;
  return z(z({}, fw.apply(this)), { addTypenameDocumentTransform: mw(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: Za(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: Za(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: Za(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: Za(e?.findFragmentSpreads),
    lookup: Za(e?.lookup),
    transform: Za(e?.transform)
  } });
}
function ZT(e) {
  return !!e && "dirtyKey" in e;
}
function Za(e) {
  return ZT(e) ? e.size : void 0;
}
function pw(e) {
  return e != null;
}
function mw(e) {
  return d5(e).map(function(t) {
    return { cache: t };
  });
}
function d5(e) {
  return e ? rn(rn([
    Za(e?.performWork)
  ], d5(e?.left), !0), d5(e?.right), !0).filter(pw) : [];
}
function c5(e) {
  var t;
  return e ? rn(rn([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], c5(e?.left), !0), c5(e?.right), !0).filter(pw) : [];
}
var uo = Object.assign(function(t) {
  return JSON.stringify(t, YT);
}, {
  reset: function() {
    bl = new UT(
      Sa.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && hw("canonicalStringify", function() {
  return bl.size;
});
var bl;
uo.reset();
function YT(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(JT))
        return t;
      var i = JSON.stringify(n), a = bl.get(i);
      if (!a) {
        n.sort();
        var o = JSON.stringify(n);
        a = bl.get(o) || n, bl.set(i, a), bl.set(o, a);
      }
      var s = Object.create(r);
      return a.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function JT(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function Il(e) {
  return { __ref: String(e) };
}
function zt(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function XT(e) {
  return vr(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function eO(e) {
  return e.kind === "StringValue";
}
function tO(e) {
  return e.kind === "BooleanValue";
}
function rO(e) {
  return e.kind === "IntValue";
}
function nO(e) {
  return e.kind === "FloatValue";
}
function iO(e) {
  return e.kind === "Variable";
}
function aO(e) {
  return e.kind === "ObjectValue";
}
function oO(e) {
  return e.kind === "ListValue";
}
function sO(e) {
  return e.kind === "EnumValue";
}
function lO(e) {
  return e.kind === "NullValue";
}
function Gl(e, t, r, n) {
  if (rO(r) || nO(r))
    e[t.value] = Number(r.value);
  else if (tO(r) || eO(r))
    e[t.value] = r.value;
  else if (aO(r)) {
    var i = {};
    r.fields.map(function(o) {
      return Gl(i, o.name, o.value, n);
    }), e[t.value] = i;
  } else if (iO(r)) {
    var a = (n || {})[r.name.value];
    e[t.value] = a;
  } else if (oO(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return Gl(s, t, o, n), s[t.value];
    });
  else if (sO(r))
    e[t.value] = r.value;
  else if (lO(r))
    e[t.value] = null;
  else
    throw wn(124, t.value, r.kind);
}
function dO(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(i) {
    r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(a) {
      var o = a.name, s = a.value;
      return Gl(r[i.name.value], o, s, t);
    });
  }));
  var n = null;
  return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
    var a = i.name, o = i.value;
    return Gl(n, a, o, t);
  })), gw(e.name.value, n, r);
}
var cO = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Wd = uo, gw = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(Wd(i), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = Wd(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    cO.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(Wd(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = Wd;
    return Wd = e, t;
  }
});
function Gh(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return Gl(r, i, a, t);
    }), r;
  }
  return null;
}
function Ca(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function u5(e, t, r) {
  for (var n, i = 0, a = t.selections; i < a.length; i++) {
    var o = a[i];
    if (yo(o)) {
      if (o.name.value === "__typename")
        return e[Ca(o)];
    } else n ? n.push(o) : n = [o];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (n)
    for (var s = 0, l = n; s < l.length; s++) {
      var o = l[s], d = u5(e, Kh(o, r).selectionSet, r);
      if (typeof d == "string")
        return d;
    }
}
function yo(e) {
  return e.kind === "Field";
}
function uO(e) {
  return e.kind === "InlineFragment";
}
function kd(e) {
  ke(e && e.kind === "Document", 116);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw wn(117, r.kind);
    return r;
  });
  return ke(t.length <= 1, 118, t.length), e;
}
function $s(e) {
  return kd(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function yc(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function _d(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function vw(e) {
  var t = $s(e);
  return ke(t && t.operation === "query", 119), t;
}
function yw(e) {
  ke(e.kind === "Document", 120), ke(e.definitions.length <= 1, 121);
  var t = e.definitions[0];
  return ke(t.kind === "FragmentDefinition", 122), t;
}
function zu(e) {
  kd(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw wn(123);
}
function jg(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && Gl(t, n.variable.name, n.defaultValue);
  }), t;
}
let Zr = null;
const S4 = {};
let hO = 1;
const fO = () => class {
  constructor() {
    this.id = [
      "slot",
      hO++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = Zr; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === S4)
          break;
        return t !== Zr && (Zr.slots[this.id] = r), !0;
      }
    return Zr && (Zr.slots[this.id] = S4), !1;
  }
  getValue() {
    if (this.hasValue())
      return Zr.slots[this.id];
  }
  withValue(t, r, n, i) {
    const a = {
      __proto__: null,
      [this.id]: t
    }, o = Zr;
    Zr = { parent: o, slots: a };
    try {
      return r.apply(i, n);
    } finally {
      Zr = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = Zr;
    return function() {
      const n = Zr;
      try {
        return Zr = r, t.apply(this, arguments);
      } finally {
        Zr = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (Zr) {
      const i = Zr;
      try {
        return Zr = null, t.apply(n, r);
      } finally {
        Zr = i;
      }
    } else
      return t.apply(n, r);
  }
};
function C4(e) {
  try {
    return e();
  } catch {
  }
}
const k2 = "@wry/context:Slot", pO = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  C4(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  C4(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), E4 = pO, xd = E4[k2] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[k2] || (function(e) {
  try {
    Object.defineProperty(E4, k2, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(fO()), { bind: w2e, noContext: $2e } = xd, Zh = new xd(), { hasOwnProperty: mO } = Object.prototype, zg = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function Vg(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Xc = [], gO = 100;
function Zl(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function bw(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function ww(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function $w(e) {
  return e.slice(0);
}
class Yh {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Yh.count;
  }
  peek() {
    if (this.value.length === 1 && !bo(this))
      return A4(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return Zl(!this.recomputing, "already recomputing"), A4(this), bo(this) ? vO(this, t) : ww(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, kw(this), Vg(this));
  }
  dispose() {
    this.setDirty(), Ew(this), Ug(this, (t, r) => {
      t.setDirty(), Aw(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Xc.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (zg(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Xc.push(this.deps), this.deps = null);
  }
}
Yh.count = 0;
function A4(e) {
  const t = Zh.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), bo(e) ? xw(t, e) : Sw(t, e), t;
}
function vO(e, t) {
  return Ew(e), Zh.withValue(e, yO, [e, t]), wO(e, t) && bO(e), ww(e.value);
}
function yO(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = $w(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !bw(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function bo(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function bO(e) {
  e.dirty = !1, !bo(e) && _w(e);
}
function kw(e) {
  Ug(e, xw);
}
function _w(e) {
  Ug(e, Sw);
}
function Ug(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = zg(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function xw(e, t) {
  Zl(e.childValues.has(t)), Zl(bo(t));
  const r = !bo(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Xc.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && kw(e);
}
function Sw(e, t) {
  Zl(e.childValues.has(t)), Zl(!bo(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, $w(t.value)) : bw(r, t.value) || e.setDirty(), Cw(e, t), !bo(e) && _w(e);
}
function Cw(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (Xc.length < gO && Xc.push(r), e.dirtyChildren = null));
}
function Ew(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    Aw(e, r);
  }), e.forgetDeps(), Zl(e.dirtyChildren === null);
}
function Aw(e, t) {
  t.parents.delete(e), e.childValues.delete(t), Cw(e, t);
}
function wO(e, t) {
  if (typeof e.subscribe == "function")
    try {
      Vg(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const $O = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function Tw(e) {
  const t = /* @__PURE__ */ new Map();
  function r(n) {
    const i = Zh.getValue();
    if (i) {
      let a = t.get(n);
      a || t.set(n, a = /* @__PURE__ */ new Set()), i.dependOn(a);
    }
  }
  return r.dirty = function(i, a) {
    const o = t.get(i);
    if (o) {
      const s = a && mO.call($O, a) ? a : "setDirty";
      zg(o).forEach((l) => l[s]()), t.delete(i), Vg(o);
    }
  }, r;
}
let T4;
function kO(...e) {
  return (T4 || (T4 = new Da(typeof WeakMap == "function"))).lookupArray(e);
}
const _2 = /* @__PURE__ */ new Set();
function eu(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = kO, normalizeResult: i, subscribe: a, cache: o = s5 } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (h) => h.dispose()) : o, l = function() {
    const h = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (h === void 0)
      return e.apply(null, arguments);
    let f = s.get(h);
    f || (s.set(h, f = new Yh(e)), f.normalizeResult = i, f.subscribe = a, f.forget = () => s.delete(h));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(h, f), _2.add(s), Zh.hasValue() || (_2.forEach((m) => m.clean()), _2.clear()), p;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: s
  });
  function d(h) {
    const f = h && s.get(h);
    f && f.setDirty();
  }
  l.dirtyKey = d, l.dirty = function() {
    d(n.apply(null, arguments));
  };
  function c(h) {
    const f = h && s.get(h);
    if (f)
      return f.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(n.apply(null, arguments));
  };
  function u(h) {
    return h ? s.delete(h) : !1;
  }
  return l.forgetKey = u, l.forget = function() {
    return u(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(l);
}
function _O(e) {
  return e;
}
var Ow = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = Fg ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(_O, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var a = t(i) ? r : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new Da(Fs);
        this.performWork = eu(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return ke(Array.isArray(i), 105), r.lookupArray(i);
          },
          max: Sa["documentTransform.cache"],
          cache: U1
        });
      }
    }, e.prototype.performWork = function(t) {
      return kd(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), Nc, hs = Object.assign(function(e) {
  var t = Nc.get(e);
  return t || (t = kT(e), Nc.set(e, t)), t;
}, {
  reset: function() {
    Nc = new uw(
      Sa.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
hs.reset();
globalThis.__DEV__ !== !1 && hw("print", function() {
  return Nc ? Nc.size : 0;
});
var yr = Array.isArray;
function ta(e) {
  return Array.isArray(e) && e.length > 0;
}
var O4 = {
  kind: ye.FIELD,
  name: {
    kind: ye.NAME,
    value: "__typename"
  }
};
function Iw(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === ye.FRAGMENT_SPREAD && Iw(t[r.name.value], t);
  });
}
function xO(e) {
  return Iw($s(e) || yw(e), $d(_d(e))) ? null : e;
}
function SO(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(a, o) {
      o(n) && (i = a);
    }), i;
  };
}
function I4(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var i = t.get(n);
    return i || t.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function Pw(e, t) {
  kd(t);
  for (var r = I4(""), n = I4(""), i = function(v) {
    for (var b = 0, $ = void 0; b < v.length && ($ = v[b]); ++b)
      if (!yr($)) {
        if ($.kind === ye.OPERATION_DEFINITION)
          return r($.name && $.name.value);
        if ($.kind === ye.FRAGMENT_DEFINITION)
          return n($.name.value);
      }
    return globalThis.__DEV__ !== !1 && ke.error(125), null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === ye.OPERATION_DEFINITION && ++a;
  var s = SO(e), l = function(v) {
    return ta(v) && v.map(s).some(function(b) {
      return b && b.remove;
    });
  }, d = /* @__PURE__ */ new Map(), c = !1, u = {
    enter: function(v) {
      if (l(v.directives))
        return c = !0, null;
    }
  }, h = Ai(t, {
    // These two AST node types share the same implementation, defined above.
    Field: u,
    InlineFragment: u,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(v, b, $, _, x) {
        var S = i(x);
        S && S.variables.add(v.name.value);
      }
    },
    FragmentSpread: {
      enter: function(v, b, $, _, x) {
        if (l(v.directives))
          return c = !0, null;
        var S = i(x);
        S && S.fragmentSpreads.add(v.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(v, b, $, _) {
        d.set(JSON.stringify(_), v);
      },
      leave: function(v, b, $, _) {
        var x = d.get(JSON.stringify(_));
        if (v === x)
          return v;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && v.selectionSet.selections.every(function(S) {
            return S.kind === ye.FIELD && S.name.value === "__typename";
          })
        )
          return n(v.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(v) {
        if (s(v))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var f = function(v) {
    return v.transitiveVars || (v.transitiveVars = new Set(v.variables), v.removed || v.fragmentSpreads.forEach(function(b) {
      f(n(b)).transitiveVars.forEach(function($) {
        v.transitiveVars.add($);
      });
    })), v;
  }, p = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(v) {
    v.kind === ye.OPERATION_DEFINITION ? f(r(v.name && v.name.value)).fragmentSpreads.forEach(function(b) {
      p.add(b);
    }) : v.kind === ye.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(v.name.value).removed && p.add(v.name.value);
  }), p.forEach(function(v) {
    f(n(v)).fragmentSpreads.forEach(function(b) {
      p.add(b);
    });
  });
  var m = function(v) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(v) || n(v).removed);
  }, y = {
    enter: function(v) {
      if (m(v.name.value))
        return null;
    }
  };
  return xO(Ai(h, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: y,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: y,
    OperationDefinition: {
      leave: function(v) {
        if (v.variableDefinitions) {
          var b = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(v.name && v.name.value)
          ).transitiveVars;
          if (b.size < v.variableDefinitions.length)
            return z(z({}, v), { variableDefinitions: v.variableDefinitions.filter(function($) {
              return b.has($.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var qg = Object.assign(function(e) {
  return Ai(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === ye.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var a = i.some(function(s) {
              return yo(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = n;
              if (!(yo(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return z(z({}, t), { selections: rn(rn([], i, !0), [O4], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === O4;
  }
});
function CO(e) {
  var t = zu(e), r = t.operation;
  if (r === "query")
    return e;
  var n = Ai(e, {
    OperationDefinition: {
      enter: function(i) {
        return z(z({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function Nw(e) {
  kd(e);
  var t = Pw([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function EO(e) {
  return kd(e), Ai(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return z(z({}, t), { directives: rn(rn([], t.directives || [], !0), [
          {
            kind: ye.DIRECTIVE,
            name: { kind: ye.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var AO = Object.prototype.hasOwnProperty;
function P4() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Jh(e);
}
function Jh(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new wo(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var TO = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, wo = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = TO), this.reconciler = t, this.isObject = vr, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return vr(r) && vr(t) ? (Object.keys(r).forEach(function(o) {
        if (AO.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = n.reconciler.apply(n, rn([
              t,
              r,
              o
            ], i, !1));
            l !== s && (t = n.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = n.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return vr(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = z({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function OO(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = IO(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IO(e, t) {
  if (e) {
    if (typeof e == "string") return N4(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return N4(e, t);
  }
}
function N4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function D4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Bg(e, t, r) {
  return t && D4(e.prototype, t), r && D4(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Hg = function() {
  return typeof Symbol == "function";
}, Wg = function(e) {
  return Hg() && !!Symbol[e];
}, Qg = function(e) {
  return Wg(e) ? Symbol[e] : "@@" + e;
};
Hg() && !Wg("observable") && (Symbol.observable = /* @__PURE__ */ Symbol("observable"));
var PO = Qg("iterator"), h5 = Qg("observable"), Dw = Qg("species");
function q1(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function Qd(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Dw], t === null && (t = void 0)), t !== void 0 ? t : Gt;
}
function NO(e) {
  return e instanceof Gt;
}
function Yl(e) {
  Yl.log ? Yl.log(e) : setTimeout(function() {
    throw e;
  });
}
function o1(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      Yl(t);
    }
  });
}
function Mw(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = q1(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      Yl(n);
    }
}
function f5(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function DO(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (Rw(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function Rw(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = q1(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (f5(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        f5(e), i && i.call(n);
        break;
    }
  } catch (a) {
    Yl(a);
  }
  e._state === "closed" ? Mw(e) : e._state === "running" && (e._state = "ready");
}
function x2(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], o1(function() {
        return DO(e);
      });
      return;
    }
    Rw(e, t, r);
  }
}
var MO = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new RO(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (f5(this), Mw(this));
  }, Bg(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), RO = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    x2(this._subscription, "next", n);
  }, t.error = function(n) {
    x2(this._subscription, "error", n);
  }, t.complete = function() {
    x2(this._subscription, "complete");
  }, Bg(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Gt = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new MO(n, this._subscriber);
  }, t.forEach = function(n) {
    var i = this;
    return new Promise(function(a, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        l.unsubscribe(), a();
      }
      var l = i.subscribe({
        next: function(d) {
          try {
            n(d, s);
          } catch (c) {
            o(c), l.unsubscribe();
          }
        },
        error: o,
        complete: a
      });
    });
  }, t.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Qd(this);
    return new a(function(o) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Qd(this);
    return new a(function(o) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Qd(this), o = arguments.length > 1, s = !1, l = arguments[1], d = l;
    return new a(function(c) {
      return i.subscribe({
        next: function(u) {
          var h = !s;
          if (s = !0, !h || o)
            try {
              d = n(d, u);
            } catch (f) {
              return c.error(f);
            }
          else
            d = u;
        },
        error: function(u) {
          c.error(u);
        },
        complete: function() {
          if (!s && !o) return c.error(new TypeError("Cannot reduce an empty sequence"));
          c.next(d), c.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    var s = Qd(this);
    return new s(function(l) {
      var d, c = 0;
      function u(h) {
        d = h.subscribe({
          next: function(f) {
            l.next(f);
          },
          error: function(f) {
            l.error(f);
          },
          complete: function() {
            c === a.length ? (d = void 0, l.complete()) : u(s.from(a[c++]));
          }
        });
      }
      return u(n), function() {
        d && (d.unsubscribe(), d = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Qd(this);
    return new a(function(o) {
      var s = [], l = i.subscribe({
        next: function(c) {
          if (n)
            try {
              c = n(c);
            } catch (h) {
              return o.error(h);
            }
          var u = a.from(c).subscribe({
            next: function(h) {
              o.next(h);
            },
            error: function(h) {
              o.error(h);
            },
            complete: function() {
              var h = s.indexOf(u);
              h >= 0 && s.splice(h, 1), d();
            }
          });
          s.push(u);
        },
        error: function(c) {
          o.error(c);
        },
        complete: function() {
          d();
        }
      });
      function d() {
        l.closed && s.length === 0 && o.complete();
      }
      return function() {
        s.forEach(function(c) {
          return c.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, t[h5] = function() {
    return this;
  }, e.from = function(n) {
    var i = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var a = q1(n, h5);
    if (a) {
      var o = a.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return NO(o) && o.constructor === i ? o : new i(function(s) {
        return o.subscribe(s);
      });
    }
    if (Wg("iterator") && (a = q1(n, PO), a))
      return new i(function(s) {
        o1(function() {
          if (!s.closed) {
            for (var l = OO(a.call(n)), d; !(d = l()).done; ) {
              var c = d.value;
              if (s.next(c), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        o1(function() {
          if (!s.closed) {
            for (var l = 0; l < n.length; ++l)
              if (s.next(n[l]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = typeof this == "function" ? this : e;
    return new o(function(s) {
      o1(function() {
        if (!s.closed) {
          for (var l = 0; l < i.length; ++l)
            if (s.next(i[l]), s.closed) return;
          s.complete();
        }
      });
    });
  }, Bg(e, null, [{
    key: Dw,
    get: function() {
      return this;
    }
  }]), e;
})();
Hg() && Object.defineProperty(Gt, /* @__PURE__ */ Symbol("extensions"), {
  value: {
    symbol: h5,
    hostReportError: Yl
  },
  configurable: !0
});
function LO(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var nl;
typeof self < "u" ? nl = self : typeof window < "u" ? nl = window : typeof global < "u" ? nl = global : typeof module < "u" ? nl = module : nl = Function("return this")();
LO(nl);
var M4 = Gt.prototype, R4 = "@@observable";
M4[R4] || (M4[R4] = function() {
  return this;
});
function FO(e) {
  return e.catch(function() {
  }), e;
}
var jO = Object.prototype.toString;
function Lw(e) {
  return p5(e);
}
function p5(e, t) {
  switch (jO.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, a) {
        r[a] = p5(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = p5(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function zO(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    vr(r) && VO(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      vr(r[n]) && t.add(r[n]);
    });
  }), e;
}
function VO(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function B1(e) {
  return globalThis.__DEV__ !== !1 && zO(e), e;
}
function Dc(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function S2(e, t, r) {
  return new Gt(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(d) {
          return d(l());
        });
      }
    };
    function a(l, d) {
      return function(c) {
        if (l) {
          var u = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(u, u).then(function(h) {
            return n.next(h);
          }, function(h) {
            return n.error(h);
          });
        } else
          n[d](c);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function Fw(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Gt });
  }
  return dw && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function L4(e) {
  return e && typeof e.then == "function";
}
var il = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Dc(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Dc(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, o = i.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? L4(l) ? l.then(function(d) {
              return n.sub = d.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Dc(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Gt(r)]), L4(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, r(i, a));
      });
    }, t;
  })(Gt)
);
Fw(il);
function Pl(e) {
  return "incremental" in e;
}
function UO(e) {
  return "hasNext" in e && "data" in e;
}
function qO(e) {
  return Pl(e) || UO(e);
}
function BO(e) {
  return vr(e) && "payload" in e;
}
function jw(e, t) {
  var r = e, n = new wo();
  return Pl(t) && ta(t.incremental) && t.incremental.forEach(function(i) {
    for (var a = i.data, o = i.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], d = !isNaN(+l), c = d ? [] : {};
      c[l] = a, a = c;
    }
    r = n.merge(r, a);
  }), r;
}
function s1(e) {
  var t = m5(e);
  return ta(t);
}
function m5(e) {
  var t = ta(e.errors) ? e.errors.slice(0) : [];
  return Pl(e) && ta(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function Jl() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (r[i] = a);
    });
  }), r;
}
function C2(e, t) {
  return Jl(e, t, t.variables && {
    variables: Jl(z(z({}, e && e.variables), t.variables))
  });
}
function E2(e) {
  return new Gt(function(t) {
    t.error(e);
  });
}
var zw = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function HO(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw wn(58, i);
  }
  return e;
}
function WO(e, t) {
  var r = z({}, e), n = function(a) {
    typeof a == "function" ? r = z(z({}, r), a(r)) : r = z(z({}, r), a);
  }, i = function() {
    return z({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function QO(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? yc(t.query) || void 0 : ""), t;
}
function KO(e, t) {
  var r = z({}, e), n = new Set(Object.keys(e));
  return Ai(t, {
    Variable: function(i, a, o) {
      o && o.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
var GO = /* @__PURE__ */ Symbol.for("apollo.deprecations"), ZO = V1, g5 = new xd();
function YO(e) {
  return ZO[GO] || (g5.getValue() || []).includes(e);
}
function cn(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return g5.withValue.apply(g5, rn([Array.isArray(e) ? e : [e]], t, !1));
}
function kr(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), ss(t, function() {
    t in e && globalThis.__DEV__ !== !1 && ke.warn(104, r, t, n);
  });
}
function ss(e, t) {
  YO(e) || t();
}
function F4(e, t) {
  return t ? t(e) : Gt.of();
}
function Kd(e) {
  return typeof e == "function" ? new Sd(e) : e;
}
function x0(e) {
  return e.request.length <= 1;
}
var Sd = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Gt.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Kd).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = Kd(r), a = Kd(n || new e(F4)), o;
      return x0(i) && x0(a) ? o = new e(function(s) {
        return t(s) ? i.request(s) || Gt.of() : a.request(s) || Gt.of();
      }) : o = new e(function(s, l) {
        return t(s) ? i.request(s, l) || Gt.of() : a.request(s, l) || Gt.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.execute = function(t, r) {
      return t.request(WO(r.context, QO(HO(r)))) || Gt.of();
    }, e.concat = function(t, r) {
      var n = Kd(t);
      if (x0(n))
        return globalThis.__DEV__ !== !1 && ke.warn(47, n), n;
      var i = Kd(r), a;
      return x0(i) ? a = new e(function(o) {
        return n.request(o, function(s) {
          return i.request(s) || Gt.of();
        }) || Gt.of();
      }) : a = new e(function(o, s) {
        return n.request(o, function(l) {
          return i.request(l, s) || Gt.of();
        }) || Gt.of();
      }), Object.assign(a, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(F4)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw wn(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && ss("onError", function() {
        globalThis.__DEV__ !== !1 && ke.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ke.warn(50), this.onError = t, this;
    }, e;
  })()
), v5 = Sd.execute;
function JO(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function XO(e) {
  var t = null, r = null, n = !1, i = [], a = [];
  function o(u) {
    if (!r) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: u, done: !1 });
      }
      i.push(u);
    }
  }
  function s(u) {
    r = u;
    var h = a.slice();
    h.forEach(function(f) {
      f[1](u);
    }), !t || t();
  }
  function l() {
    n = !0;
    var u = a.slice();
    u.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function d() {
    return new Promise(function(u, h) {
      if (r)
        return h(r);
      if (i.length)
        return u({ value: i.shift(), done: !1 });
      if (n)
        return u({ value: void 0, done: !0 });
      a.push([u, h]);
    });
  }
  var c = {
    next: function() {
      return d();
    }
  };
  return Qh && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function eI(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Qh && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function j4(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Qh && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function tI(e) {
  return !!e.body;
}
function rI(e) {
  return !!e.getReader;
}
function nI(e) {
  return !!(Qh && e[Symbol.asyncIterator]);
}
function iI(e) {
  return !!e.stream;
}
function aI(e) {
  return !!e.arrayBuffer;
}
function oI(e) {
  return !!e.pipe;
}
function sI(e) {
  var t = e;
  if (tI(e) && (t = e.body), nI(t))
    return JO(t);
  if (rI(t))
    return j4(t.getReader());
  if (iI(t))
    return j4(t.stream().getReader());
  if (aI(t))
    return eI(t.arrayBuffer());
  if (oI(t))
    return XO(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Kg = /* @__PURE__ */ Symbol();
function lI(e) {
  return e.extensions ? Array.isArray(e.extensions[Kg]) : !1;
}
function Vw(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var dI = function(e) {
  var t = rn(rn(rn([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return vr(r) && r.message || "Error message not found.";
  }).join(`
`);
}, Xo = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, d = e.call(this, s) || this;
      return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = a || [], d.networkError = o || null, d.message = s || dI(d), d.extraInfo = l, d.cause = rn(rn(rn([
        o
      ], n || [], !0), i || [], !0), a || [], !0).find(function(c) {
        return !!c;
      }) || null, d.__proto__ = t.prototype, d;
    }
    return t;
  })(Error)
), z4 = Object.prototype.hasOwnProperty;
function cI(e, t) {
  return Xe(this, void 0, void 0, function() {
    var r, n, i, a, o, s, l, d, c, u, h, f, p, m, y, v, b, $, _, x, S, A, N, P;
    return Ka(this, function(D) {
      switch (D.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (P = e.headers) === null || P === void 0 ? void 0 : P.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", o = `\r
--`.concat(a), s = "", l = sI(e), d = !0, D.label = 1;
        case 1:
          return d ? [4, l.next()] : [3, 3];
        case 2:
          for (c = D.sent(), u = c.value, h = c.done, f = typeof u == "string" ? u : r.decode(u), p = s.length - o.length + 1, d = !h, s += f, m = s.indexOf(o, p); m > -1; ) {
            if (y = void 0, A = [
              s.slice(0, m),
              s.slice(m + o.length)
            ], y = A[0], s = A[1], v = y.indexOf(`\r
\r
`), b = uI(y.slice(0, v)), $ = b["content-type"], $ && $.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (_ = y.slice(v), _) {
              if (x = Uw(e, _), Object.keys(x).length > 1 || "data" in x || "incremental" in x || "errors" in x || "payload" in x)
                if (BO(x)) {
                  if (S = {}, "payload" in x) {
                    if (Object.keys(x).length === 1 && x.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    S = z({}, x.payload);
                  }
                  "errors" in x && (S = z(z({}, S), { extensions: z(z({}, "extensions" in S ? S.extensions : null), (N = {}, N[Kg] = x.errors, N)) })), t(S);
                } else
                  t(x);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(x).length === 1 && "hasNext" in x && !x.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(o);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function uI(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), a = r.slice(n + 1).trim();
      t[i] = a;
    }
  }), t;
}
function Uw(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    zw(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function hI(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function fI(e) {
  return function(t) {
    return t.text().then(function(r) {
      return Uw(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !z4.call(r, "data") && !z4.call(r, "errors") && zw(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var y5 = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = wn(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, pI = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, mI = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, gI = {
  method: "POST"
}, vI = {
  http: pI,
  headers: mI,
  options: gI
}, yI = function(e, t) {
  return t(e);
};
function bI(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, a = {};
  r.forEach(function(u) {
    i = z(z(z({}, i), u.options), { headers: z(z({}, i.headers), u.headers) }), u.credentials && (i.credentials = u.credentials), a = z(z({}, a), u.http);
  }), i.headers && (i.headers = wI(i.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, d = e.query, c = { operationName: o, variables: l };
  return a.includeExtensions && (c.extensions = s), a.includeQuery && (c.query = t(d, hs)), {
    options: i,
    body: c
  };
}
function wI(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var $I = function(e) {
  if (!e && typeof fetch > "u")
    throw wn(51);
}, kI = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function _I(e, t) {
  var r = [], n = function(u, h) {
    r.push("".concat(u, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = y5(t.variables, "Variables map");
    } catch (u) {
      return { parseError: u };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = y5(t.extensions, "Extensions map");
    } catch (u) {
      return { parseError: u };
    }
    n("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var d = s.indexOf("?") === -1 ? "?" : "&", c = s + d + r.join("&") + o;
  return { newURI: c };
}
var V4 = gi(function() {
  return fetch;
}), xI = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, a = i === void 0 ? yI : i, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, d = e.includeUnusedVariables, c = d === void 0 ? !1 : d, u = xi(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && $I(n || V4);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: u.fetchOptions,
    credentials: u.credentials,
    headers: u.headers
  };
  return new Sd(function(f) {
    var p = kI(f, r), m = f.getContext(), y = {};
    if (m.clientAwareness) {
      var v = m.clientAwareness, b = v.name, $ = v.version;
      b && (y["apollographql-client-name"] = b), $ && (y["apollographql-client-version"] = $);
    }
    var _ = z(z({}, y), m.headers), x = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: _
    };
    if (Jc(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ke.warn(52);
      var S = Nw(f.query);
      if (!S)
        return E2(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = S;
    }
    var A = bI(f, a, vI, h, x), N = A.options, P = A.body;
    P.variables && !c && (P.variables = KO(P.variables, f.query));
    var D;
    !N.signal && typeof AbortController < "u" && (D = new AbortController(), N.signal = D.signal);
    var T = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "mutation";
    }, I = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "subscription";
    }, j = I(zu(f.query)), F = Jc(["defer"], f.query);
    if (l && !f.query.definitions.some(T) && (N.method = "GET"), F || j) {
      N.headers = N.headers || {};
      var Z = "multipart/mixed;";
      j && F && globalThis.__DEV__ !== !1 && ke.warn(53), j ? Z += "boundary=graphql;subscriptionSpec=1.0,application/json" : F && (Z += "deferSpec=20220824,application/json"), N.headers.accept = Z;
    }
    if (N.method === "GET") {
      var te = _I(p, P), Y = te.newURI, Q = te.parseError;
      if (Q)
        return E2(Q);
      p = Y;
    } else
      try {
        N.body = y5(P, "Payload");
      } catch (R) {
        return E2(R);
      }
    return new Gt(function(R) {
      var re = n || gi(function() {
        return fetch;
      }) || V4, he = R.next.bind(R);
      return re(p, N).then(function(ge) {
        var ce;
        f.setContext({ response: ge });
        var W = (ce = ge.headers) === null || ce === void 0 ? void 0 : ce.get("content-type");
        return W !== null && /^multipart\/mixed/i.test(W) ? cI(ge, he) : fI(f)(ge).then(he);
      }).then(function() {
        D = void 0, R.complete();
      }).catch(function(ge) {
        D = void 0, hI(ge, R);
      }), function() {
        D && D.abort();
      };
    });
  });
}, qw = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, xI(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(Sd)
);
const { toString: U4, hasOwnProperty: SI } = Object.prototype, q4 = Function.prototype.toString, b5 = /* @__PURE__ */ new Map();
function er(e, t) {
  try {
    return w5(e, t);
  } finally {
    b5.clear();
  }
}
function w5(e, t) {
  if (e === t)
    return !0;
  const r = U4.call(e), n = U4.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (H4(e, t))
        return !0;
      const i = B4(e), a = B4(t), o = i.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!SI.call(t, i[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = i[s];
        if (!w5(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (H4(e, t))
        return !0;
      const i = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = i.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !w5(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = q4.call(e);
      return i !== q4.call(t) ? !1 : !AI(i, EI);
    }
  }
  return !1;
}
function B4(e) {
  return Object.keys(e).filter(CI, e);
}
function CI(e) {
  return this[e] !== void 0;
}
const EI = "{ [native code] }";
function AI(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function H4(e, t) {
  let r = b5.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    b5.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function Bw(e, t, r, n) {
  var i = t.data, a = xi(t, ["data"]), o = r.data, s = xi(r, ["data"]);
  return er(a, s) && l1(zu(e).selectionSet, i, o, {
    fragmentMap: $d(_d(e)),
    variables: n
  });
}
function l1(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !ju(a, n.variables)) || W4(a))
      return !0;
    if (yo(a)) {
      var o = Ca(a), s = t && t[o], l = r && r[o], d = a.selectionSet;
      if (!d)
        return er(s, l);
      var c = Array.isArray(s), u = Array.isArray(l);
      if (c !== u)
        return !1;
      if (c && u) {
        var h = s.length;
        if (l.length !== h)
          return !1;
        for (var f = 0; f < h; ++f)
          if (!l1(d, s[f], l[f], n))
            return !1;
        return !0;
      }
      return l1(d, s, l, n);
    } else {
      var p = Kh(a, n.fragmentMap);
      if (p)
        return W4(p) ? !0 : l1(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function W4(e) {
  return !!e.directives && e.directives.some(TI);
}
function TI(e) {
  return e.name.value === "nonreactive";
}
var Hw = Fs ? WeakMap : Map, Ww = Fg ? WeakSet : Set, Gg = new xd(), Q4 = !1;
function Qw() {
  Q4 || (Q4 = !0, globalThis.__DEV__ !== !1 && ke.warn(64));
}
function Kw(e, t, r) {
  return Gg.withValue(!0, function() {
    var n = bc(e, t, r, !1);
    return Object.isFrozen(e) && B1(n), n;
  });
}
function OI(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function bc(e, t, r, n, i) {
  var a, o = r.knownChanged, s = OI(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, d = Array.from(e.entries()); l < d.length; l++) {
      var c = d[l], u = c[0], h = c[1];
      if (h === null) {
        s[u] = null;
        continue;
      }
      var f = bc(h, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(u, "]") : void 0);
      o.has(f) && o.add(s), s[u] = f;
    }
    return o.has(s) ? s : e;
  }
  for (var p = 0, m = t.selections; p < m.length; p++) {
    var y = m[p], v = void 0;
    if (n && o.add(s), y.kind === ye.FIELD) {
      var b = Ca(y), $ = y.selectionSet;
      if (v = s[b] || e[b], v === void 0)
        continue;
      if ($ && v !== null) {
        var f = bc(e[b], $, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(b) : void 0);
        o.has(f) && (v = f);
      }
      globalThis.__DEV__ === !1 && (s[b] = v), globalThis.__DEV__ !== !1 && (n && b !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((a = Object.getOwnPropertyDescriptor(s, b)) === null || a === void 0) && a.value) ? Object.defineProperty(s, b, II(b, v, i || "", r.operationName, r.operationType)) : (delete s[b], s[b] = v));
    }
    if (y.kind === ye.INLINE_FRAGMENT && (!y.typeCondition || r.cache.fragmentMatches(y, e.__typename)) && (v = bc(e, y.selectionSet, r, n, i)), y.kind === ye.FRAGMENT_SPREAD) {
      var _ = y.name.value, x = r.fragmentMap[_] || (r.fragmentMap[_] = r.cache.lookupFragment(_));
      ke(x, 59, _);
      var S = AT(y);
      S !== "mask" && (v = bc(e, x.selectionSet, r, S === "migrate", i));
    }
    o.has(v) && o.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && o.add(s), o.has(s) ? s : e;
}
function II(e, t, r, n, i) {
  var a = function() {
    return Gg.getValue() || (globalThis.__DEV__ !== !1 && ke.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), a = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return a();
    },
    set: function(o) {
      a = function() {
        return o;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function Gw(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && Qw(), e;
  var i = t.definitions.filter(function(o) {
    return o.kind === ye.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (ke(i.length === 1, 61, i.length), n = i[0].name.value);
  var a = i.find(function(o) {
    return o.name.value === n;
  });
  return ke(!!a, 62, n), e == null || er(e, {}) ? e : Kw(e, a.selectionSet, {
    operationType: "fragment",
    operationName: a.name.value,
    fragmentMap: $d(_d(t)),
    cache: r,
    mutableTargets: new Hw(),
    knownChanged: new Ww()
  });
}
function PI(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && Qw(), e;
  var i = $s(t);
  return ke(i, 63), e == null ? e : Kw(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: $d(_d(t)),
    cache: r,
    mutableTargets: new Hw(),
    knownChanged: new Ww()
  });
}
var Zw = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = eu(DT, {
        max: Sa["cache.fragmentQueryDocuments"] || 1e3,
        cache: U1
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(r);
      }, n), i;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && kr(t, "canonizeResults", "cache.readQuery"), cn("canonizeResults", function() {
        return n.read(z(z({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      });
    }, e.prototype.watchFragment = function(t) {
      var r = this, n = t.fragment, i = t.fragmentName, a = t.from, o = t.optimistic, s = o === void 0 ? !0 : o, l = xi(t, ["fragment", "fragmentName", "from", "optimistic"]), d = this.getFragmentDoc(n, i), c = typeof a > "u" || typeof a == "string" ? a : this.identify(a), u = !!t[/* @__PURE__ */ Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var h = i || yw(n).name.value;
        c || globalThis.__DEV__ !== !1 && ke.warn(1, h);
      }
      var f = z(z({}, l), { returnPartialData: !0, id: c, query: d, optimistic: s }), p;
      return new Gt(function(m) {
        return r.watch(z(z({}, f), { immediate: !0, callback: function(y) {
          var v = u ? Gw(y.result, n, r, i) : y.result;
          if (
            // Always ensure we deliver the first result
            !(p && Bw(
              d,
              { data: p.result },
              { data: v },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var b = {
              data: v,
              complete: !!y.complete
            };
            y.missing && (b.missing = Jh(y.missing.map(function($) {
              return $.missing;
            }))), p = z(z({}, y), { result: v }), m.next(b);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && kr(t, "canonizeResults", "cache.readFragment"), cn("canonizeResults", function() {
        return n.read(z(z({}, t), { query: n.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      });
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, n = t.data, i = xi(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: r || "ROOT_QUERY",
        result: n
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, n = t.data, i = t.fragment, a = t.fragmentName, o = xi(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(o, {
        query: this.getFragmentDoc(i, a),
        dataId: r,
        result: n
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return globalThis.__DEV__ !== !1 && kr(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(n) {
          var i = cn("canonizeResults", function() {
            return n.readQuery(t);
          }), a = r(i);
          return a == null ? i : (n.writeQuery(z(z({}, t), { data: a })), a);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return globalThis.__DEV__ !== !1 && kr(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(n) {
          var i = cn("canonizeResults", function() {
            return n.readFragment(t);
          }), a = r(i);
          return a == null ? i : (n.writeFragment(z(z({}, t), { data: a })), a);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (Zw.prototype.getMemoryInternals = WT);
var Yw = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r, n, i, a) {
      var o, s = e.call(this, r) || this;
      if (s.message = r, s.path = n, s.query = i, s.variables = a, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (o = {}, o[s.path[l]] = s.missing, o);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), Wr = Object.prototype.hasOwnProperty;
function Gd(e) {
  return e == null;
}
function Jw(e, t) {
  var r = e.__typename, n = e.id, i = e._id;
  if (typeof r == "string" && (t && (t.keyObject = Gd(n) ? Gd(i) ? void 0 : { _id: i } : { id: n }), Gd(n) && !Gd(i) && (n = i), !Gd(n)))
    return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var Xw = {
  dataIdFromObject: Jw,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function NI(e) {
  return Jl(Xw, e);
}
function e$(e) {
  var t = e.canonizeResults;
  return t === void 0 ? Xw.canonizeResults : t;
}
function DI(e, t) {
  return zt(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var t$ = /^[_a-z][_0-9a-z]*/i;
function $o(e) {
  var t = e.match(t$);
  return t ? t[0] : e;
}
function $5(e, t, r) {
  return vr(t) ? yr(t) ? t.every(function(n) {
    return $5(e, n, r);
  }) : e.selections.every(function(n) {
    if (yo(n) && ju(n, r)) {
      var i = Ca(n);
      return Wr.call(t, i) && (!n.selectionSet || $5(n.selectionSet, t[i], r));
    }
    return !0;
  }) : !1;
}
function wl(e) {
  return vr(e) && !zt(e) && !yr(e);
}
function MI() {
  return new wo();
}
function r$(e, t) {
  var r = $d(_d(e));
  return {
    fragmentMap: r,
    lookupFragment: function(n) {
      var i = r[n];
      return !i && t && (i = t.lookup(n)), i || null;
    }
  };
}
var d1 = /* @__PURE__ */ Object.create(null), A2 = function() {
  return d1;
}, K4 = /* @__PURE__ */ Object.create(null), tu = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, a) {
        return B1(zt(i) ? n.get(i.__ref, a) : i && i[a]);
      }, this.canRead = function(i) {
        return zt(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, a) {
        if (typeof i == "string")
          return Il(i);
        if (zt(i))
          return i;
        var o = n.policies.identify(i)[0];
        if (o) {
          var s = Il(o);
          return a && n.merge(o, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return z({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), Wr.call(this.data, t)) {
        var n = this.data[t];
        if (n && Wr.call(n, r))
          return n[r];
      }
      if (r === "__typename" && Wr.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof Qa)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), Wr.call(this.data, t))
        return this.data[t];
      if (this instanceof Qa)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var n = this, i;
      zt(t) && (t = t.__ref), zt(r) && (r = r.__ref);
      var a = typeof t == "string" ? this.lookup(i = t) : t, o = typeof r == "string" ? this.lookup(i = r) : r;
      if (o) {
        ke(typeof i == "string", 2);
        var s = new wo(LI).merge(a, o);
        if (this.data[i] = s, s !== a && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          a || (l.__exists = 1), Object.keys(o).forEach(function(d) {
            if (!a || a[d] !== s[d]) {
              l[d] = 1;
              var c = $o(d);
              c !== d && !n.policies.hasKeyArgs(s.__typename, c) && (l[c] = 1), s[d] === void 0 && !(n instanceof Qa) && delete s[d];
            }
          }), l.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(d) {
            return n.group.dirty(i, d);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var n = this, i = this.lookup(t);
      if (i) {
        var a = /* @__PURE__ */ Object.create(null), o = !1, s = !0, l = {
          DELETE: d1,
          INVALIDATE: K4,
          isReference: zt,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(d, c) {
            return n.policies.readField(typeof d == "string" ? {
              fieldName: d,
              from: c || Il(t)
            } : d, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(d) {
          var c = $o(d), u = i[d];
          if (u !== void 0) {
            var h = typeof r == "function" ? r : r[d] || r[c];
            if (h) {
              var f = h === A2 ? d1 : h(B1(u), z(z({}, l), { fieldName: c, storeFieldName: d, storage: n.getStorage(t, d) }));
              if (f === K4)
                n.group.dirty(t, d);
              else if (f === d1 && (f = void 0), f !== u && (a[d] = f, o = !0, u = f, globalThis.__DEV__ !== !1)) {
                var p = function(x) {
                  if (n.lookup(x.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && ke.warn(3, x), !0;
                };
                if (zt(f))
                  p(f);
                else if (Array.isArray(f))
                  for (var m = !1, y = void 0, v = 0, b = f; v < b.length; v++) {
                    var $ = b[v];
                    if (zt($)) {
                      if (m = !0, p($))
                        break;
                    } else if (typeof $ == "object" && $) {
                      var _ = n.policies.identify($)[0];
                      _ && (y = $);
                    }
                    if (m && y !== void 0) {
                      globalThis.__DEV__ !== !1 && ke.warn(4, y);
                      break;
                    }
                  }
              }
            }
            u !== void 0 && (s = !1);
          }
        }), o)
          return this.merge(t, a), s && (this instanceof Qa ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, n) {
      var i, a = this.lookup(t);
      if (a) {
        var o = this.getFieldValue(a, "__typename"), s = r && n ? this.policies.getStoreFieldName({ typename: o, fieldName: r, args: n }) : r;
        return this.modify(t, s ? (i = {}, i[s] = A2, i) : A2);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var n = !1;
      return t.id && (Wr.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Qa && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        Wr.call(t.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(a) {
        t && Wr.call(t, a) || r.delete(a);
      }), t) {
        var n = t.__META, i = xi(t, ["__META"]);
        Object.keys(i).forEach(function(a) {
          r.merge(a, i[a]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Qa ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), n = this.toObject();
      r.forEach(function(o) {
        Wr.call(n, o) && (Object.keys(t.findChildRefIds(o)).forEach(r.add, r), delete n[o]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var a = this; a instanceof Qa; )
          a = a.parent;
        i.forEach(function(o) {
          return a.delete(o);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!Wr.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
        if (!n)
          return r;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(a) {
          zt(a) && (r[a.__ref] = !0), vr(a) && Object.keys(a).forEach(function(o) {
            var s = a[o];
            vr(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), n$ = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? Tw() : null, this.keyMaker = new Da(Fs);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(T2(t, r));
        var n = $o(r);
        n !== r && this.d(T2(t, n)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        T2(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function T2(e, t) {
  return t + "#" + e;
}
function G4(e, t) {
  Mc(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(r) {
      ia(n, r);
      function n(i) {
        var a = i.policies, o = i.resultCaching, s = o === void 0 ? !0 : o, l = i.seed, d = r.call(this, a, new n$(s)) || this;
        return d.stump = new RI(d), d.storageTrie = new Da(Fs), l && d.replace(l), d;
      }
      return n.prototype.addLayer = function(i, a) {
        return this.stump.addLayer(i, a);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(e)
  );
  e.Root = t;
})(tu || (tu = {}));
var Qa = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r, n, i, a) {
      var o = e.call(this, n.policies, a) || this;
      return o.id = r, o.parent = n, o.replay = i, o.group = a, i(o), o;
    }
    return t.prototype.addLayer = function(r, n) {
      return new t(r, this, n, this.group);
    }, t.prototype.removeLayer = function(r) {
      var n = this, i = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var o = n.data[a], s = i.lookup(a);
        s ? o ? o !== s && Object.keys(o).forEach(function(l) {
          er(o[l], s[l]) || n.group.dirty(a, l);
        }) : (n.group.dirty(a, "__exists"), Object.keys(s).forEach(function(l) {
          n.group.dirty(a, l);
        })) : n.delete(a);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return z(z({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var n = this.parent.findChildRefIds(r);
      return Wr.call(this.data, r) ? z(z({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(tu)
), RI = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new n$(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, n) {
      return this.parent.merge(r, n);
    }, t;
  })(Qa)
);
function LI(e, t, r) {
  var n = e[r], i = t[r];
  return er(n, i) ? n : i;
}
function Mc(e) {
  return !!(e instanceof tu && e.group.caching);
}
function FI(e) {
  return vr(e) ? yr(e) ? e.slice(0) : z({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Z4 = (
  /** @class */
  (function() {
    function e() {
      this.known = new (Fg ? WeakSet : Set)(), this.pool = new Da(Fs), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return vr(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (vr(t)) {
        var r = FI(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (vr(t)) {
        var n = this.passes.get(t);
        if (n)
          return n;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var a = t.map(this.admit, this), o = this.pool.lookupArray(a);
            return o.array || (this.known.add(o.array = a), globalThis.__DEV__ !== !1 && Object.freeze(a)), o.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], d = this.sortedKeys(t);
            l.push(d.json);
            var c = l.length;
            d.sorted.forEach(function(f) {
              l.push(r.admit(t[f]));
            });
            var o = this.pool.lookupArray(l);
            if (!o.object) {
              var u = o.object = Object.create(s);
              this.known.add(u), d.sorted.forEach(function(f, p) {
                u[f] = l[c + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(u);
            }
            return o.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), n = this.pool.lookupArray(r);
      if (!n.keys) {
        r.sort();
        var i = JSON.stringify(r);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
      }
      return n.keys;
    }, e;
  })()
);
function Y4(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var jI = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.knownResults = new (Fs ? WeakMap : Map)(), this.config = Jl(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: e$(t)
      }), this.canon = t.canon || new Z4(), this.executeSelectionSet = eu(function(n) {
        var i, a = n.context.canonizeResults, o = Y4(n);
        o[3] = !a;
        var s = (i = r.executeSelectionSet).peek.apply(i, o);
        return s ? a ? z(z({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (G4(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || Sa["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Y4,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, a, o) {
          if (Mc(a.store))
            return a.store.makeCacheKey(n, zt(i) ? i.__ref : i, a.varString, o);
        }
      }), this.executeSubSelectedArray = eu(function(n) {
        return G4(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || Sa["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, a = n.array, o = n.context;
          if (Mc(o.store))
            return o.store.makeCacheKey(i, a, o.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Z4();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, n = t.query, i = t.rootId, a = i === void 0 ? "ROOT_QUERY" : i, o = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, d = t.canonizeResults, c = d === void 0 ? this.config.canonizeResults : d, u = this.config.cache.policies;
      o = z(z({}, jg(vw(n))), o);
      var h = Il(a), f = this.executeSelectionSet({
        selectionSet: zu(n).selectionSet,
        objectOrReference: h,
        enclosingRef: h,
        context: z({ store: r, query: n, policies: u, variables: o, varString: uo(o), canonizeResults: c }, r$(n, this.config.fragments))
      }), p;
      if (f.missing && (p = [
        new Yw(zI(f.missing), f.missing, n, o)
      ], !l))
        throw p[0];
      return {
        result: f.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(t, r, n, i) {
      if (Mc(i.store) && this.knownResults.get(t) === n) {
        var a = this.executeSelectionSet.peek(
          n,
          r,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (a && t === a.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, n = t.selectionSet, i = t.objectOrReference, a = t.enclosingRef, o = t.context;
      if (zt(i) && !o.policies.rootTypenamesById[i.__ref] && !o.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = o.variables, l = o.policies, d = o.store, c = d.getFieldValue(i, "__typename"), u = [], h, f = new wo();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && u.push({ __typename: c });
      function p($, _) {
        var x;
        return $.missing && (h = f.merge(h, (x = {}, x[_] = $.missing, x))), $.result;
      }
      var m = new Set(n.selections);
      m.forEach(function($) {
        var _, x;
        if (ju($, s))
          if (yo($)) {
            var S = l.readField({
              fieldName: $.name.value,
              field: $,
              variables: o.variables,
              from: i
            }, o), A = Ca($);
            S === void 0 ? qg.added($) || (h = f.merge(h, (_ = {}, _[A] = "Can't find field '".concat($.name.value, "' on ").concat(zt(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), _))) : yr(S) ? S.length > 0 && (S = p(r.executeSubSelectedArray({
              field: $,
              array: S,
              enclosingRef: a,
              context: o
            }), A)) : $.selectionSet ? S != null && (S = p(r.executeSelectionSet({
              selectionSet: $.selectionSet,
              objectOrReference: S,
              enclosingRef: zt(S) ? S : a,
              context: o
            }), A)) : o.canonizeResults && (S = r.canon.pass(S)), S !== void 0 && u.push((x = {}, x[A] = S, x));
          } else {
            var N = Kh($, o.lookupFragment);
            if (!N && $.kind === ye.FRAGMENT_SPREAD)
              throw wn(10, $.name.value);
            N && l.fragmentMatches(N, c) && N.selectionSet.selections.forEach(m.add, m);
          }
      });
      var y = Jh(u), v = { result: y, missing: h }, b = o.canonizeResults ? this.canon.admit(v) : B1(v);
      return b.result && this.knownResults.set(b.result, n), b;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, n = t.field, i = t.array, a = t.enclosingRef, o = t.context, s, l = new wo();
      function d(c, u) {
        var h;
        return c.missing && (s = l.merge(s, (h = {}, h[u] = c.missing, h))), c.result;
      }
      return n.selectionSet && (i = i.filter(o.store.canRead)), i = i.map(function(c, u) {
        return c === null ? null : yr(c) ? d(r.executeSubSelectedArray({
          field: n,
          array: c,
          enclosingRef: a,
          context: o
        }), u) : n.selectionSet ? d(r.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: c,
          enclosingRef: zt(c) ? c : a,
          context: o
        }), u) : (globalThis.__DEV__ !== !1 && VI(o.store, n, c), c);
      }), {
        result: o.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function zI(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
function VI(e, t, r) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([r]);
    n.forEach(function(i) {
      vr(i) && (ke(
        !zt(i),
        11,
        DI(e, i),
        t.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var Zg = new xd(), J4 = /* @__PURE__ */ new WeakMap();
function Rc(e) {
  var t = J4.get(e);
  return t || J4.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: Tw()
  }), t;
}
function X4(e) {
  Rc(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function UI(e) {
  Rc(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function qI(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(a) {
    if (arguments.length > 0) {
      if (e !== a) {
        e = a, t.forEach(function(l) {
          Rc(l).dep.dirty(n), BI(l);
        });
        var o = Array.from(r);
        r.clear(), o.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = Zg.getValue();
      s && (i(s), Rc(s).dep(n));
    }
    return e;
  };
  n.onNextChange = function(a) {
    return r.add(a), function() {
      r.delete(a);
    };
  };
  var i = n.attachCache = function(a) {
    return t.add(a), Rc(a).vars.add(n), n;
  };
  return n.forgetCache = function(a) {
    return t.delete(a);
  }, n;
}
function BI(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var ey = /* @__PURE__ */ Object.create(null);
function Yg(e) {
  var t = JSON.stringify(e);
  return ey[t] || (ey[t] = /* @__PURE__ */ Object.create(null));
}
function ty(e) {
  var t = Yg(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
    var i = function(o, s) {
      return n.readField(s, o);
    }, a = n.keyObject = Jg(e, function(o) {
      var s = Nl(
        n.storeObject,
        o,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && r !== n.storeObject && Wr.call(r, o[0]) && (s = Nl(r, o, a$)), ke(s !== void 0, 5, o.join("."), r), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(a));
  });
}
function ry(e) {
  var t = Yg(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
    var i = n.field, a = n.variables, o = n.fieldName, s = Jg(e, function(d) {
      var c = d[0], u = c.charAt(0);
      if (u === "@") {
        if (i && ta(i.directives)) {
          var h = c.slice(1), f = i.directives.find(function(v) {
            return v.name.value === h;
          }), p = f && Gh(f, a);
          return p && Nl(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            d.slice(1)
          );
        }
        return;
      }
      if (u === "$") {
        var m = c.slice(1);
        if (a && Wr.call(a, m)) {
          var y = d.slice(0);
          return y[0] = m, Nl(a, y);
        }
        return;
      }
      if (r)
        return Nl(r, d);
    }), l = JSON.stringify(s);
    return (r || l !== "{}") && (o += ":" + l), o;
  });
}
function Jg(e, t) {
  var r = new wo();
  return i$(e).reduce(function(n, i) {
    var a, o = t(i);
    if (o !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        o = (a = {}, a[i[s]] = o, a);
      n = r.merge(n, o);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function i$(e) {
  var t = Yg(e);
  if (!t.paths) {
    var r = t.paths = [], n = [];
    e.forEach(function(i, a) {
      yr(i) ? (i$(i).forEach(function(o) {
        return r.push(n.concat(o));
      }), n.length = 0) : (n.push(i), yr(e[a + 1]) || (r.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function a$(e, t) {
  return e[t];
}
function Nl(e, t, r) {
  return r = r || a$, o$(t.reduce(function n(i, a) {
    return yr(i) ? i.map(function(o) {
      return n(o, a);
    }) : i && r(i, a);
  }, e));
}
function o$(e) {
  return vr(e) ? yr(e) ? e.map(o$) : Jg(Object.keys(e).sort(), function(t) {
    return Nl(e, t);
  }) : e;
}
function k5(e) {
  return e.args !== void 0 ? e.args : e.field ? Gh(e.field, e.variables) : null;
}
var HI = function() {
}, ny = function(e, t) {
  return t.fieldName;
}, iy = function(e, t, r) {
  var n = r.mergeObjects;
  return n(e, t);
}, ay = function(e, t) {
  return t;
}, WI = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = z({ dataIdFromObject: Jw }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var n, i = this, a = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var o = r && r.storeObject || t, s = z(z({}, r), { typename: a, storeObject: o, readField: r && r.readField || function() {
        var u = Xg(arguments, o);
        return i.readField(u, {
          store: i.cache.data,
          variables: u.variables
        });
      } }), l, d = a && this.getTypePolicy(a), c = d && d.keyFn || this.config.dataIdFromObject;
      return Gg.withValue(!0, function() {
        for (; c; ) {
          var u = c(z(z({}, t), o), s);
          if (yr(u))
            c = ty(u);
          else {
            l = u;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(n) {
        var i = t[n], a = i.queryType, o = i.mutationType, s = i.subscriptionType, l = xi(i, ["queryType", "mutationType", "subscriptionType"]);
        a && r.setRootTypename("Query", n), o && r.setRootTypename("Mutation", n), s && r.setRootTypename("Subscription", n), Wr.call(r.toBeAdded, n) ? r.toBeAdded[n].push(l) : r.toBeAdded[n] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, r, n) {
      var i = this.getTypePolicy(t), a = r.keyFields, o = r.fields;
      function s(l, d) {
        l.merge = typeof d == "function" ? d : d === !0 ? iy : d === !1 ? ay : l.merge;
      }
      s(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? HI : yr(a) ? ty(a) : typeof a == "function" ? a : i.keyFn, o && Object.keys(o).forEach(function(l) {
        var d = n[l];
        (!d || d?.typename !== t) && (d = n[l] = { typename: t });
        var c = o[l];
        if (typeof c == "function")
          d.read = c;
        else {
          var u = c.keyArgs, h = c.read, f = c.merge;
          d.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          u === !1 ? ny : yr(u) ? ry(u) : typeof u == "function" ? u : d.keyFn, typeof h == "function" && (d.read = h), s(d, f);
        }
        d.read && d.merge && (d.keyFn = d.keyFn || ny);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
      r !== i && (ke(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
        r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
          r.getSupertypeSet(i, !0).add(n);
          var a = i.match(t$);
          (!a || a[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!Wr.call(this.typePolicies, t)) {
        var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(o, s) {
          if (o.test(t)) {
            var l = r.supertypeMap.get(s);
            l && l.forEach(function(d) {
              return i.add(d);
            });
          }
        })), i && i.size && i.forEach(function(o) {
          var s = r.getTypePolicy(o), l = s.fields, d = xi(s, ["fields"]);
          Object.assign(n, d), Object.assign(n.fields, l);
        });
      }
      var a = this.toBeAdded[t];
      return a && a.length && a.splice(0).forEach(function(o) {
        r.updateTypePolicy(t, o, r.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r) {
      if (t)
        return this.getTypePolicy(t).fields[r];
    }, e.prototype.getSupertypeSet = function(t, r) {
      var n = this.supertypeMap.get(t);
      return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
    }, e.prototype.fragmentMatches = function(t, r, n, i) {
      var a = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var o = t.typeCondition.name.value;
      if (r === o)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(o))
        for (var s = this.getSupertypeSet(r, !0), l = [s], d = function(p) {
          var m = a.getSupertypeSet(p, !1);
          m && m.size && l.indexOf(m) < 0 && l.push(m);
        }, c = !!(n && this.fuzzySubtypes.size), u = !1, h = 0; h < l.length; ++h) {
          var f = l[h];
          if (f.has(o))
            return s.has(o) || (u && globalThis.__DEV__ !== !1 && ke.warn(7, r, o), s.add(o)), !0;
          f.forEach(d), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          h === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          $5(t.selectionSet, n, i) && (c = !1, u = !0, this.fuzzySubtypes.forEach(function(p, m) {
            var y = r.match(p);
            y && y[0] === r && d(m);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return !!(n && n.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n), a, o = i && i.keyFn;
      if (o && r)
        for (var s = {
          typename: r,
          fieldName: n,
          field: t.field || null,
          variables: t.variables
        }, l = k5(t); o; ) {
          var d = o(l, s);
          if (yr(d))
            o = ry(d);
          else {
            a = d || n;
            break;
          }
        }
      return a === void 0 && (a = t.field ? dO(t.field, t.variables) : gw(n, k5(t))), a === !1 ? n : n === $o(a) ? a : n + ":" + a;
    }, e.prototype.readField = function(t, r) {
      var n = t.from;
      if (n) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var a = r.store.getFieldValue(n, "__typename");
            a && (t.typename = a);
          }
          var o = this.getStoreFieldName(t), s = $o(o), l = r.store.getFieldValue(n, o), d = this.getFieldPolicy(t.typename, s), c = d && d.read;
          if (c) {
            var u = oy(this, n, t, r, r.store.getStorage(zt(n) ? n.__ref : n, o));
            return Zg.withValue(this.cache, c, [
              l,
              u
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return n && n.read;
    }, e.prototype.getMergeFunction = function(t, r, n) {
      var i = this.getFieldPolicy(t, r), a = i && i.merge;
      return !a && n && (i = this.getTypePolicy(n), a = i && i.merge), a;
    }, e.prototype.runMergeFunction = function(t, r, n, i, a) {
      var o = n.field, s = n.typename, l = n.merge;
      return l === iy ? s$(i.store)(t, r) : l === ay ? r : (i.overwrite && (t = void 0), l(t, r, oy(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: o.name.value,
          field: o,
          variables: i.variables
        },
        i,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function oy(e, t, r, n, i) {
  var a = e.getStoreFieldName(r), o = $o(a), s = r.variables || n.variables, l = n.store, d = l.toReference, c = l.canRead;
  return {
    args: k5(r),
    field: r.field || null,
    fieldName: o,
    storeFieldName: a,
    variables: s,
    isReference: zt,
    toReference: d,
    storage: i,
    cache: e.cache,
    canRead: c,
    readField: function() {
      return e.readField(Xg(arguments, t, s), n);
    },
    mergeObjects: s$(n.store)
  };
}
function Xg(e, t, r) {
  var n = e[0], i = e[1], a = e.length, o;
  return typeof n == "string" ? o = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? i : t
  } : (o = z({}, n), Wr.call(o, "from") || (o.from = t)), globalThis.__DEV__ !== !1 && o.from === void 0 && globalThis.__DEV__ !== !1 && ke.warn(8, Yb(Array.from(e))), o.variables === void 0 && (o.variables = r), o;
}
function s$(e) {
  return function(r, n) {
    if (yr(r) || yr(n))
      throw wn(9);
    if (vr(r) && vr(n)) {
      var i = e.getFieldValue(r, "__typename"), a = e.getFieldValue(n, "__typename"), o = i && a && i !== a;
      if (o)
        return n;
      if (zt(r) && wl(n))
        return e.merge(r.__ref, n), r;
      if (wl(r) && zt(n))
        return e.merge(r, n.__ref), n;
      if (wl(r) && wl(n))
        return z(z({}, r), n);
    }
    return n;
  };
}
function O2(e, t, r) {
  var n = "".concat(t).concat(r), i = e.flavors.get(n);
  return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : z(z({}, e), { clientOnly: t, deferred: r })), i;
}
var QI = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.cache = t, this.reader = r, this.fragments = n;
    }
    return e.prototype.writeToStore = function(t, r) {
      var n = this, i = r.query, a = r.result, o = r.dataId, s = r.variables, l = r.overwrite, d = $s(i), c = MI();
      s = z(z({}, jg(d)), s);
      var u = z(z({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(f, p) {
        return c.merge(f, p);
      }, variables: s, varString: uo(s) }, r$(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), h = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: o,
        selectionSet: d.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: u
      });
      if (!zt(h))
        throw wn(12, a);
      return u.incomingById.forEach(function(f, p) {
        var m = f.storeObject, y = f.mergeTree, v = f.fieldNodeSet, b = Il(p);
        if (y && y.map.size) {
          var $ = n.applyMerges(y, b, m, u);
          if (zt($))
            return;
          m = $;
        }
        if (globalThis.__DEV__ !== !1 && !u.overwrite) {
          var _ = /* @__PURE__ */ Object.create(null);
          v.forEach(function(A) {
            A.selectionSet && (_[A.name.value] = !0);
          });
          var x = function(A) {
            return _[$o(A)] === !0;
          }, S = function(A) {
            var N = y && y.map.get(A);
            return !!(N && N.info && N.info.merge);
          };
          Object.keys(m).forEach(function(A) {
            x(A) && !S(A) && KI(b, m, A, u.store);
          });
        }
        t.merge(p, m);
      }), t.retain(h.__ref), h;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, n = t.dataId, i = t.result, a = t.selectionSet, o = t.context, s = t.mergeTree, l = this.cache.policies, d = /* @__PURE__ */ Object.create(null), c = n && l.rootTypenamesById[n] || u5(i, a, o.fragmentMap) || n && o.store.get(n, "__typename");
      typeof c == "string" && (d.__typename = c);
      var u = function() {
        var $ = Xg(arguments, d, o.variables);
        if (zt($.from)) {
          var _ = o.incomingById.get($.from.__ref);
          if (_) {
            var x = l.readField(z(z({}, $), { from: _.storeObject }), o);
            if (x !== void 0)
              return x;
          }
        }
        return l.readField($, o);
      }, h = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        o,
        c
      ).forEach(function($, _) {
        var x, S = Ca(_), A = i[S];
        if (h.add(_), A !== void 0) {
          var N = l.getStoreFieldName({
            typename: c,
            fieldName: _.name.value,
            field: _,
            variables: $.variables
          }), P = sy(s, N), D = r.processFieldValue(
            A,
            _,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            _.selectionSet ? O2($, !1, !1) : $,
            P
          ), T = void 0;
          _.selectionSet && (zt(D) || wl(D)) && (T = u("__typename", D));
          var I = l.getMergeFunction(c, _.name.value, T);
          I ? P.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: _,
            typename: c,
            merge: I
          } : ly(s, N), d = $.merge(d, (x = {}, x[N] = D, x));
        } else globalThis.__DEV__ !== !1 && !$.clientOnly && !$.deferred && !qg.added(_) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(c, _.name.value) && globalThis.__DEV__ !== !1 && ke.error(13, Ca(_), i);
      });
      try {
        var f = l.identify(i, {
          typename: c,
          selectionSet: a,
          fragmentMap: o.fragmentMap,
          storeObject: d,
          readField: u
        }), p = f[0], m = f[1];
        n = n || p, m && (d = o.merge(d, m));
      } catch ($) {
        if (!n)
          throw $;
      }
      if (typeof n == "string") {
        var y = Il(n), v = o.written[n] || (o.written[n] = []);
        if (v.indexOf(a) >= 0 || (v.push(a), this.reader && this.reader.isFresh(i, y, a, o)))
          return y;
        var b = o.incomingById.get(n);
        return b ? (b.storeObject = o.merge(b.storeObject, d), b.mergeTree = _5(b.mergeTree, s), h.forEach(function($) {
          return b.fieldNodeSet.add($);
        })) : o.incomingById.set(n, {
          storeObject: d,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: H1(s) ? void 0 : s,
          fieldNodeSet: h
        }), y;
      }
      return d;
    }, e.prototype.processFieldValue = function(t, r, n, i) {
      var a = this;
      return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? Lw(t) : t : yr(t) ? t.map(function(o, s) {
        var l = a.processFieldValue(o, r, n, sy(i, s));
        return ly(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: n,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, r, n, i) {
      i === void 0 && (i = u5(r, t, n.fragmentMap));
      var a = /* @__PURE__ */ new Map(), o = this.cache.policies, s = new Da(!1);
      return (function l(d, c) {
        var u = s.lookup(
          d,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        u.visited || (u.visited = !0, d.selections.forEach(function(h) {
          if (ju(h, n.variables)) {
            var f = c.clientOnly, p = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && p) && ta(h.directives) && h.directives.forEach(function(v) {
                var b = v.name.value;
                if (b === "client" && (f = !0), b === "defer") {
                  var $ = Gh(v, n.variables);
                  (!$ || $.if !== !1) && (p = !0);
                }
              }), yo(h)
            ) {
              var m = a.get(h);
              m && (f = f && m.clientOnly, p = p && m.deferred), a.set(h, O2(n, f, p));
            } else {
              var y = Kh(h, n.lookupFragment);
              if (!y && h.kind === ye.FRAGMENT_SPREAD)
                throw wn(14, h.name.value);
              y && o.fragmentMatches(y, i, r, n.variables) && l(y.selectionSet, O2(n, f, p));
            }
          }
        }));
      })(t, n), a;
    }, e.prototype.applyMerges = function(t, r, n, i, a) {
      var o, s = this;
      if (t.map.size && !zt(n)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !yr(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (zt(r) || wl(r)) ? r : void 0
        ), d = n;
        l && !a && (a = [zt(l) ? l.__ref : l]);
        var c, u = function(h, f) {
          return yr(h) ? typeof f == "number" ? h[f] : void 0 : i.store.getFieldValue(h, String(f));
        };
        t.map.forEach(function(h, f) {
          var p = u(l, f), m = u(d, f);
          if (m !== void 0) {
            a && a.push(f);
            var y = s.applyMerges(h, p, m, i, a);
            y !== m && (c = c || /* @__PURE__ */ new Map(), c.set(f, y)), a && ke(a.pop() === f);
          }
        }), c && (n = yr(d) ? d.slice(0) : z({}, d), c.forEach(function(h, f) {
          n[f] = h;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, a && (o = i.store).getStorage.apply(o, a)) : n;
    }, e;
  })()
), l$ = [];
function sy(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, l$.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function _5(e, t) {
  if (e === t || !t || H1(t))
    return e;
  if (!e || H1(e))
    return t;
  var r = e.info && t.info ? z(z({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, a = { info: r, map: i };
  if (n) {
    var o = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      a.map.set(l, _5(s, t.map.get(l))), o.delete(l);
    }), o.forEach(function(s) {
      a.map.set(s, _5(t.map.get(s), e.map.get(s)));
    });
  }
  return a;
}
function H1(e) {
  return !e || !(e.info || e.map.size);
}
function ly(e, t) {
  var r = e.map, n = r.get(t);
  n && H1(n) && (l$.push(n), r.delete(t));
}
var dy = /* @__PURE__ */ new Set();
function KI(e, t, r, n) {
  var i = function(u) {
    var h = n.getFieldValue(u, r);
    return typeof h == "object" && h;
  }, a = i(e);
  if (a) {
    var o = i(t);
    if (o && !zt(a) && !er(a, o) && !Object.keys(a).every(function(u) {
      return n.getFieldValue(o, u) !== void 0;
    })) {
      var s = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), l = $o(r), d = "".concat(s, ".").concat(l);
      if (!dy.has(d)) {
        dy.add(d);
        var c = [];
        !yr(a) && !yr(o) && [a, o].forEach(function(u) {
          var h = n.getFieldValue(u, "__typename");
          typeof h == "string" && !c.includes(h) && c.push(h);
        }), globalThis.__DEV__ !== !1 && ke.warn(15, l, s, c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", d, z({}, a), z({}, o));
      }
    }
  }
}
var d$ = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new Ow(qg), n.assumeImmutableResults = !0, n.makeVar = qI, n.txCount = 0, globalThis.__DEV__ !== !1 && (kr(r, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), kr(r, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), n.config = NI(r), n.addTypename = !!n.config.addTypename, n.policies = new WI({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return t.prototype.init = function() {
      var r = this.data = new tu.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var n = this, i = this.storeReader, a = this.config.fragments;
      this.addTypenameTransform.resetCache(), a?.resetCaches(), this.storeWriter = new QI(this, this.storeReader = new jI({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: e$(this.config),
        canon: r ? void 0 : i && i.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = eu(function(o, s) {
        return n.broadcastWatch(o, s);
      }, {
        max: this.config.resultCacheMaxSize || Sa["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(o) {
          var s = o.optimistic ? n.optimisticData : n.data;
          if (Mc(s)) {
            var l = o.optimistic, d = o.id, c = o.variables;
            return s.makeCacheKey(
              o.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              o.callback,
              uo({ optimistic: l, id: d, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(o) {
        return o.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      globalThis.__DEV__ !== !1 && kr(r, "canonizeResults", "cache.read");
      var n = r.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(z(z({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (a) {
        if (a instanceof Yw)
          return null;
        throw a;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (Wr.call(r, "id") && !r.id)
        return !1;
      var n = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return globalThis.__DEV__ !== !1 && kr(r, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(z(z({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var n = this;
      return this.watches.size || UI(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        n.watches.delete(r) && !n.watches.size && X4(n), n.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      globalThis.__DEV__ !== !1 && kr(r || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), uo.reset(), hs.reset();
      var n = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, t.prototype.retain = function(r, n) {
      return (n ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, n) {
      return (n ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (zt(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (n) {
        globalThis.__DEV__ !== !1 && ke.warn(n);
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (Wr.call(r, "id"))
          return !1;
        r = z(z({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var n = this;
      return this.init(), uo.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), X4(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var n = this.optimisticData.removeLayer(r);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var n = this, i = r.update, a = r.optimistic, o = a === void 0 ? !0 : a, s = r.removeOptimistic, l = r.onWatchUpdated, d, c = function(h) {
        var f = n, p = f.data, m = f.optimisticData;
        ++n.txCount, h && (n.data = n.optimisticData = h);
        try {
          return d = i(n);
        } finally {
          --n.txCount, n.data = p, n.optimisticData = m;
        }
      }, u = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(z(z({}, r), { onWatchUpdated: function(h) {
        return u.add(h), !1;
      } })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, c) : o === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && u.size ? (this.broadcastWatches(z(z({}, r), { onWatchUpdated: function(h, f) {
        var p = l.call(this, h, f);
        return p !== !1 && u.delete(h), p;
      } })), u.size && u.forEach(function(h) {
        return n.maybeBroadcastWatch.dirty(h);
      })) : this.broadcastWatches(r), d;
    }, t.prototype.performTransaction = function(r, n) {
      return this.batch({
        update: r,
        optimistic: n || n !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.fragmentMatches = function(r, n) {
      return this.policies.fragmentMatches(r, n);
    }, t.prototype.lookupFragment = function(r) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
    }, t.prototype.broadcastWatches = function(r) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var n = this.config.fragments;
      return n ? n.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, n) {
      var i = this, a = r.lastDiff, o = cn("canonizeResults", function() {
        return i.diff(r);
      });
      n && (r.optimistic && typeof n.optimistic == "string" && (o.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, o, a) === !1) || (!a || !er(a.result, o.result)) && r.callback(r.lastDiff = o, a);
    }, t;
  })(Zw)
);
globalThis.__DEV__ !== !1 && (d$.prototype.getMemoryInternals = HT);
var Ft;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(Ft || (Ft = {}));
function $l(e) {
  return e ? e < 7 : !1;
}
var cy = Object.assign, GI = Object.hasOwnProperty, c1 = (
  /** @class */
  (function(e) {
    ia(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, a = r.options, o = this, s = t.inactiveOnCreation.getValue();
      o = e.call(this, function(v) {
        o._getOrCreateQuery();
        try {
          var b = v._subscription._observer;
          b && !b.error && (b.error = ZI);
        } catch {
        }
        var $ = !o.observers.size;
        o.observers.add(v);
        var _ = o.last;
        return _ && _.error ? v.error && v.error(_.error) : _ && _.result && v.next && v.next(o.maskResult(_.result)), $ && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(v) && !o.observers.size && o.tearDownQuery();
        };
      }) || this, o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.dirty = !1, o._getOrCreateQuery = function() {
        return s && (n.queries.set(o.queryId, i), s = !1), o.queryManager.getOrCreateQuery(o.queryId);
      }, o.queryInfo = i, o.queryManager = n, o.waitForOwnResult = I2(a.fetchPolicy), o.isTornDown = !1, o.subscribeToMore = o.subscribeToMore.bind(o), o.maskResult = o.maskResult.bind(o);
      var l = n.defaultOptions.watchQuery, d = l === void 0 ? {} : l, c = d.fetchPolicy, u = c === void 0 ? "cache-first" : c, h = a.fetchPolicy, f = h === void 0 ? u : h, p = a.initialFetchPolicy, m = p === void 0 ? f === "standby" ? u : f : p;
      o.options = z(z({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), o.queryId = i.queryId || n.generateQueryId();
      var y = $s(o.query);
      return o.queryName = y && y.name && y.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && ss("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && ke.warn(23);
      }), new Promise(function(n, i) {
        var a = {
          next: function(s) {
            n(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: i
        }, o = r.subscribe(a);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = cn("getLastResult", function() {
        return n.getLastResult(!0);
      }), a = this.queryInfo.networkStatus || i && i.networkStatus || Ft.ready, o = z(z({}, i), { loading: $l(a), networkStatus: a }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(I2(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var d = this.queryInfo.getDiff();
        (d.complete || this.options.returnPartialData) && (o.data = d.result), er(o.data, {}) && (o.data = void 0), d.complete ? (delete o.partial, d.complete && o.networkStatus === Ft.loading && (l === "cache-first" || l === "cache-only") && (o.networkStatus = Ft.ready, o.loading = !1)) : o.partial = !0, o.networkStatus === Ft.ready && (o.error || o.errors) && (o.networkStatus = Ft.error), globalThis.__DEV__ !== !1 && !d.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && c$(d.missing);
      }
      return r && this.updateLastResult(o), o;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, o = a ? i.nonReactiveQuery : this.query, s = a || i.hasNonreactiveDirective ? !Bw(o, this.last.result, r, this.variables) : !er(this.last.result, r);
      return s || n && !er(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || er(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && ss("getLastResult", function() {
        globalThis.__DEV__ !== !1 && ke.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && ss("getLastError", function() {
        globalThis.__DEV__ !== !1 && ke.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && ss("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && ke.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ke.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && GI.call(r, "variables")) {
        var o = vw(this.query), s = o.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && ke.warn(
          28,
          r,
          ((n = o.name) === null || n === void 0 ? void 0 : n.value) || o
        );
      }
      return r && !er(this.options.variables, r) && (i.variables = this.options.variables = z(z({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, Ft.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = z(z({}, r.query ? r : z(z(z(z({}, this.options), { query: this.options.query }), r), { variables: z(z({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = Ft.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), d = r?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || ke(d, 29), this.queryManager.fetchQuery(a, i, Ft.fetchMore).then(function(u) {
        if (n.queryManager.removeQuery(a), o.networkStatus === Ft.fetchMore && (o.networkStatus = s), c)
          n.queryManager.cache.batch({
            update: function(p) {
              var m = r.updateQuery;
              m ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(y) {
                return m(y, {
                  fetchMoreResult: u.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: u.data
              });
            },
            onWatchUpdated: function(p) {
              l.add(p.query);
            }
          });
        else {
          var h = n.getLast("result"), f = d(h.data, {
            fetchMoreResult: u.data,
            variables: i.variables
          });
          n.reportResult(z(z({}, h), { networkStatus: s, loading: $l(s), data: f }), n.variables);
        }
        return n.maskResult(u);
      }).finally(function() {
        c && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && n.updateQuery(function(s, l) {
            return o(s, z({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && ke.error(30, a);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (kr(r, "canonizeResults", "setOptions"), ss("setOptions", function() {
        globalThis.__DEV__ !== !1 && ke.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = Jl(this.options, r || {});
      cy(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return er(this.variables, r) ? this.observers.size ? cn("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, Ft.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, o = i.complete, s = r(a, {
        variables: this.variables,
        complete: !!o,
        previousData: a
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var a = this._getOrCreateQuery();
      return a.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(a, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          ke(a, 32);
          var o = i || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            var d, c;
            r.pollingInfo && (!$l(r.queryInfo.networkStatus) && !(!((c = (d = r.options).skipPollAttempt) === null || c === void 0) && c.call(d)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, Ft.poll).then(l, l) : l());
          }, l = function() {
            var d = r.pollingInfo;
            d && (clearTimeout(d.timeout), d.timeout = setTimeout(s, d.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var a = cn("getLastError", function() {
        return i.getLastError();
      });
      return a && this.last && !er(n, this.last.variables) && (a = void 0), this.last = z({ result: this.queryManager.assumeImmutableResults ? r : Lw(r), variables: n }, a ? { error: a } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === Ft.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === Ft.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === Ft.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = Jl(this.options, r || {}), d = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : cy(this.options, l), c = this.transformDocument(d.query);
      this.lastQuery = c, a || (this.updatePolling(), r && r.variables && !er(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (d.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = Ft.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = I2(d.fetchPolicy));
      var u = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, h = d.variables && z({}, d.variables), f = this.fetch(d, n, c), p = f.concast, m = f.fromLink, y = {
        next: function(v) {
          er(i.variables, h) && (u(), i.reportResult(v, h));
        },
        error: function(v) {
          er(i.variables, h) && (Vw(v) || (v = new Xo({ networkError: v })), u(), i.reportError(v, h));
        }
      };
      return !a && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = y), p.addObserver(y), p;
    }, t.prototype.reobserve = function(r, n) {
      return FO(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var a = this.last;
      cn("resetLastResults", function() {
        return r.resetLastResults();
      });
      var o = this.subscribe.apply(this, n);
      return this.last = a, o;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, a = cn("getLastError", function() {
        return i.getLastError();
      }), o = this.isDifferentFromLastResult(r, n);
      (a || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (a || o) && Dc(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, a = z(z({}, cn("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: Ft.error, loading: !1 });
      this.updateLastResult(a, n), Dc(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? z(z({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !$l(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(a, o) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(a, o) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new xd(), t;
  })(Gt)
);
Fw(c1);
function ZI(e) {
  globalThis.__DEV__ !== !1 && ke.error(33, e.message, e.stack);
}
function c$(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && ke.debug(34, e);
}
function I2(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var kl = new (Fs ? WeakMap : Map)();
function P2(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return kl.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (kl.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var N2 = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      kl.has(n) || (kl.set(n, 0), P2(n, "evict"), P2(n, "modify"), P2(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || Ft.loading;
      return this.variables && this.networkStatus !== Ft.loading && !er(this.variables, t.variables) && (r = Ft.setVariables), er(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && er(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = cn("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && cn("getLastError", function() {
        var a;
        return (a = r.observableQuery) === null || a === void 0 ? void 0 : a.getLastError();
      }) || (this.updateLastDiff(t), er(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = z(z({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !er(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === kl.get(this.cache) && er(r, n.variables) && er(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var a = this, o, s = new wo(), l = ta(t.errors) ? t.errors.slice(0) : [];
      if ((o = this.observableQuery) === null || o === void 0 || o.resetNotifications(), "incremental" in t && ta(t.incremental)) {
        var d = jw(this.getDiff().result, t);
        t.data = d;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (x5(t, n.errorPolicy) ? this.cache.performTransaction(function(u) {
        if (a.shouldWrite(t, n.variables))
          u.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: kl.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var h = a.getDiffOptions(n.variables), f = cn("canonizeResults", function() {
          return u.diff(h);
        });
        !a.stopped && er(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(f, h), f.complete && (t.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = Ft.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = Ft.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function x5(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !s1(e);
  return !n && r && e.data && (n = !0), n;
}
var YI = Object.prototype.hasOwnProperty, uy = /* @__PURE__ */ Object.create(null), JI = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new uw(
        Sa["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Da(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new Ow(
        function(a) {
          return r.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(wn(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return Xe(this, arguments, void 0, function(r) {
        var n, i, a, o, s, l, d, c = r.mutation, u = r.variables, h = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, m = p === void 0 ? [] : p, y = r.awaitRefetchQueries, v = y === void 0 ? !1 : y, b = r.update, $ = r.onQueryUpdated, _ = r.fetchPolicy, x = _ === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : _, S = r.errorPolicy, A = S === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : S, N = r.keepRootFields, P = r.context;
        return Ka(this, function(D) {
          switch (D.label) {
            case 0:
              return ke(c, 36), ke(x === "network-only" || x === "no-cache", 37), n = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, u = this.getVariables(c, u), i ? [4, this.localState.addExportedVariables(c, u, P)] : [3, 2];
            case 1:
              u = D.sent(), D.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: c,
                variables: u,
                loading: !0,
                error: null
              }), o = h && this.markMutationOptimistic(h, {
                mutationId: n,
                document: c,
                variables: u,
                fetchPolicy: x,
                errorPolicy: A,
                context: P,
                updateQueries: f,
                update: b,
                keepRootFields: N
              }), this.broadcastQueries(), s = this, [2, new Promise(function(T, I) {
                return S2(s.getObservableFromLink(c, z(z({}, P), { optimisticResponse: o ? h : void 0 }), u, {}, !1), function(j) {
                  if (s1(j) && A === "none")
                    throw new Xo({
                      graphQLErrors: m5(j)
                    });
                  a && (a.loading = !1, a.error = null);
                  var F = z({}, j);
                  return typeof m == "function" && (m = m(F)), A === "ignore" && s1(F) && delete F.errors, s.markMutationResult({
                    mutationId: n,
                    result: F,
                    document: c,
                    variables: u,
                    fetchPolicy: x,
                    errorPolicy: A,
                    context: P,
                    update: b,
                    updateQueries: f,
                    awaitRefetchQueries: v,
                    refetchQueries: m,
                    removeOptimistic: o ? n : void 0,
                    onQueryUpdated: $,
                    keepRootFields: N
                  });
                }).subscribe({
                  next: function(j) {
                    s.broadcastQueries(), (!("hasNext" in j) || j.hasNext === !1) && T(z(z({}, j), { data: s.maskOperation({
                      document: c,
                      data: j.data,
                      fetchPolicy: x,
                      id: n
                    }) }));
                  },
                  error: function(j) {
                    a && (a.loading = !1, a.error = j), o && s.cache.removeOptimistic(n), s.broadcastQueries(), I(j instanceof Xo ? j : new Xo({
                      networkError: j
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && x5(i, t.errorPolicy)) {
        if (Pl(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Pl(i) && ta(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = jw(s.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var d = t.updateQueries;
        d && this.queries.forEach(function(u, h) {
          var f = u.observableQuery, p = f && f.queryName;
          if (!(!p || !YI.call(d, p))) {
            var m = d[p], y = n.queries.get(h), v = y.document, b = y.variables, $ = r.diff({
              query: v,
              variables: b,
              returnPartialData: !0,
              optimistic: !1
            }), _ = $.result, x = $.complete;
            if (x && _) {
              var S = m(_, {
                mutationResult: i,
                queryName: v && yc(v) || void 0,
                queryVariables: b
              });
              S && a.push({
                result: S,
                dataId: "ROOT_QUERY",
                query: v,
                variables: b
              });
            }
          }
        });
      }
      if (a.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(u) {
            o || a.forEach(function(m) {
              return u.write(m);
            });
            var h = t.update, f = !qO(i) || Pl(i) && !i.hasNext;
            if (h) {
              if (!o) {
                var p = u.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = z(z({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && h(u, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && u.modify({
              id: "ROOT_MUTATION",
              fields: function(m, y) {
                var v = y.fieldName, b = y.DELETE;
                return v === "__typename" ? m : b;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(u) {
          return c.push(u);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: uy }) : t;
      return i === uy ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(z(z({}, r), { result: { data: i } }), a);
        } catch (o) {
          globalThis.__DEV__ !== !1 && ke.error(o);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: ST(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Jc(["nonreactive"], t),
          nonReactiveQuery: EO(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: Pw([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: jg($s(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: z(z({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? z(z({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return z(z({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = z(z({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new N2(this), i = new c1({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, c1.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), ke(t.query, 38), ke(t.query.kind === "Document", 39), ke(!t.returnPartialData, 40), ke(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, z(z({}, t), { query: i })).then(function(a) {
        return a && z(z({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(wn(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = Ft.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), a.set(s, !1);
        else if (XT(s)) {
          var l = hs(r.transform(s));
          i.set(l, yc(s)), a.set(l, !1);
        } else vr(s) && s.query && o.add(s);
      }), this.queries.forEach(function(s, l) {
        var d = s.observableQuery, c = s.document;
        if (d) {
          if (t === "all") {
            n.set(l, d);
            return;
          }
          var u = d.queryName, h = d.options.fetchPolicy;
          if (h === "standby" || t === "active" && !d.hasObservers())
            return;
          (t === "active" || u && a.has(u) || c && a.has(hs(c))) && (n.set(l, d), u && a.set(u, !0), c && a.set(hs(c), !0));
        }
      }), o.size && o.forEach(function(s) {
        var l = n5("legacyOneTimeQuery"), d = r.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new c1({
          queryManager: r,
          queryInfo: d,
          options: z(z({}, s), { fetchPolicy: "network-only" })
        });
        ke(c.queryId === l), d.setObservableQuery(c), n.set(l, c);
      }), globalThis.__DEV__ !== !1 && a.size && a.forEach(function(s, l) {
        if (!s) {
          var d = i.get(l);
          d ? globalThis.__DEV__ !== !1 && ke.warn(43, d) : globalThis.__DEV__ !== !1 && ke.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, a) {
        var o = i.options.fetchPolicy;
        cn("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), (r.queries.get(a) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, a = t.fetchPolicy, o = t.errorPolicy, s = o === void 0 ? "none" : o, l = t.context, d = l === void 0 ? {} : l, c = t.extensions, u = c === void 0 ? {} : c;
      n = this.transform(n), i = this.getVariables(n, i);
      var h = function(p) {
        return r.getObservableFromLink(n, d, p, u).map(function(m) {
          a !== "no-cache" && (x5(m, s) && r.cache.write({
            query: n,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var y = s1(m), v = lI(m);
          if (y || v) {
            var b = {};
            if (y && (b.graphQLErrors = m.errors), v && (b.protocolErrors = m.extensions[Kg]), s === "none" || v)
              throw new Xo(b);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, d).then(h);
        return new Gt(function(p) {
          var m = null;
          return f.then(function(y) {
            return m = y.subscribe(p);
          }, p.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return h(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, a) {
      var o = this, s;
      a === void 0 && (a = (s = r?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, d = this.getDocumentInfo(t), c = d.serverQuery, u = d.clientQuery;
      if (c) {
        var h = this, f = h.inFlightLinkObservables, p = h.link, m = {
          query: c,
          variables: n,
          operationName: yc(c) || void 0,
          context: this.prepareContext(z(z({}, r), { forceFetch: !a })),
          extensions: i
        };
        if (r = m.context, a) {
          var y = hs(c), v = uo(n), b = f.lookup(y, v);
          if (l = b.observable, !l) {
            var $ = new il([
              v5(p, m)
            ]);
            l = b.observable = $, $.beforeNext(function _(x, S) {
              x === "next" && "hasNext" in S && S.hasNext ? $.beforeNext(_) : f.remove(y, v);
            });
          }
        } else
          l = new il([
            v5(p, m)
          ]);
      } else
        l = new il([Gt.of({ data: {} })]), r = this.prepareContext(r);
      return u && (l = S2(l, function(_) {
        return o.localState.runResolvers({
          document: u,
          remoteResult: _,
          context: r,
          variables: n
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return S2(this.getObservableFromLink(a, n.context, n.variables), function(o) {
        var s = m5(o), l = s.length > 0, d = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && d === "none")
            throw t.markError(new Xo({
              graphQLErrors: s
            }));
          t.markResult(o, a, n, r), t.markReady();
        }
        var c = {
          data: o.data,
          loading: !1,
          networkStatus: Ft.ready
        };
        return l && d === "none" && (c.data = void 0), l && d !== "ignore" && (c.errors = s, c.networkStatus = Ft.error), c;
      }, function(o) {
        var s = Vw(o) ? o : new Xo({ networkError: o });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var a = this;
      n === void 0 && (n = Ft.loading), i === void 0 && (i = r.query);
      var o = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, l = r.fetchPolicy, d = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = r.errorPolicy, u = c === void 0 ? s && s.errorPolicy || "none" : c, h = r.returnPartialData, f = h === void 0 ? !1 : h, p = r.notifyOnNetworkStatusChange, m = p === void 0 ? !1 : p, y = r.context, v = y === void 0 ? {} : y, b = Object.assign({}, r, {
        query: i,
        variables: o,
        fetchPolicy: d,
        errorPolicy: u,
        returnPartialData: f,
        notifyOnNetworkStatusChange: m,
        context: v
      }), $ = function(N) {
        b.variables = N;
        var P = a.fetchQueryByPolicy(t, b, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          b.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          P.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), P
        );
      }, _ = function() {
        return a.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(N) {
        _(), setTimeout(function() {
          return x.cancel(N);
        });
      });
      var x, S;
      if (this.getDocumentInfo(b.query).hasClientExports)
        x = new il(this.localState.addExportedVariables(b.query, b.variables, b.context).then($).then(function(N) {
          return N.sources;
        })), S = !0;
      else {
        var A = $(b.variables);
        S = A.fromLink, x = new il(A.sources);
      }
      return x.promise.then(_, _), {
        concast: x,
        fromLink: S
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? n5("refetchQueries") : void 0 : s, d = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(h, f) {
        c.set(f, {
          oq: h,
          lastDiff: (r.queries.get(f) || h.queryInfo).getDiff()
        });
      });
      var u = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(h, f, p) {
          var m = h.watcher instanceof N2 && h.watcher.observableQuery;
          if (m) {
            if (d) {
              c.delete(m.queryId);
              var y = d(m, f, p);
              return y === !0 && (y = m.refetch()), y !== !1 && u.set(m, y), y;
            }
            d !== null && c.set(m.queryId, { oq: m, lastDiff: p, diff: f });
          }
        }
      }), c.size && c.forEach(function(h, f) {
        var p = h.oq, m = h.lastDiff, y = h.diff, v;
        d && (y || (y = cn("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), v = d(p, y, m)), (!d || v === !0) && (v = p.refetch()), v !== !1 && u.set(p, v), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), u;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, a = t.document, o = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, d = (r = $s(a)) === null || r === void 0 ? void 0 : r.operation, c = ((n = d?.[0]) !== null && n !== void 0 ? n : "o") + l;
        this.dataMasking && s === "no-cache" && !MT(a) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && ke.warn(
          45,
          (i = yc(a)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
        ));
      }
      return this.dataMasking ? PI(o, a, this.cache) : o;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? Gw(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, d = r.errorPolicy, c = r.returnPartialData, u = r.context, h = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, m = function(_, x) {
        x === void 0 && (x = t.networkStatus || Ft.loading);
        var S = _.result;
        globalThis.__DEV__ !== !1 && !c && !er(S, {}) && c$(_.missing);
        var A = function(N) {
          return Gt.of(z({ data: N, loading: $l(x), networkStatus: x }, _.complete ? null : { partial: !0 }));
        };
        return S && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: S },
          context: u,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(N) {
          return A(N.data || void 0);
        }) : d === "none" && x === Ft.refetch && Array.isArray(_.missing) ? A(void 0) : A(S);
      }, y = s === "no-cache" ? 0 : n === Ft.refetch && l !== "merge" ? 1 : 2, v = function() {
        return i.getResultsFromLink(t, y, {
          query: a,
          variables: o,
          context: u,
          fetchPolicy: s,
          errorPolicy: d
        });
      }, b = h && typeof f == "number" && f !== n && $l(n);
      switch (s) {
        default:
        case "cache-first": {
          var $ = p();
          return $.complete ? {
            fromLink: !1,
            sources: [m($, t.markReady())]
          } : c || b ? {
            fromLink: !0,
            sources: [m($), v()]
          } : { fromLink: !0, sources: [v()] };
        }
        case "cache-and-network": {
          var $ = p();
          return $.complete || c || b ? {
            fromLink: !0,
            sources: [m($), v()]
          } : { fromLink: !0, sources: [v()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(p(), t.markReady())]
          };
        case "network-only":
          return b ? {
            fromLink: !0,
            sources: [m(p()), v()]
          } : { fromLink: !0, sources: [v()] };
        case "no-cache":
          return b ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), v()]
          } : { fromLink: !0, sources: [v()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new N2(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return z(z(z({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), XI = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = P4(r.resolvers, n);
      }) : this.resolvers = P4(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return Xe(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, a = r.context, o = r.variables, s = r.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return Ka(this, function(d) {
          return n ? [2, this.resolveDocument(n, i.data, a, o, this.fragmentMatcher, l).then(function(c) {
            return z(z({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Jc(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return Nw(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return z(z({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return Xe(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Ka(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(o) {
            return z(z({}, n), o.exportedVariables);
          })] : [2, z({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Ai(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return Wh;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: CO(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return Xe(this, arguments, void 0, function(n, i, a, o, s, l) {
        var d, c, u, h, f, p, m, y, v, b, $;
        return a === void 0 && (a = {}), o === void 0 && (o = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), Ka(this, function(_) {
          return d = zu(n), c = _d(n), u = $d(c), h = this.collectSelectionsToResolve(d, u), f = d.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", m = this, y = m.cache, v = m.client, b = {
            fragmentMap: u,
            context: z(z({}, a), { cache: y, client: v }),
            variables: o,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: h,
            onlyRunForcedResolvers: l
          }, $ = !1, [2, this.resolveSelectionSet(d.selectionSet, $, i, b).then(function(x) {
            return {
              result: x,
              exportedVariables: b.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return Xe(this, void 0, void 0, function() {
        var a, o, s, l, d, c = this;
        return Ka(this, function(u) {
          return a = i.fragmentMap, o = i.context, s = i.variables, l = [n], d = function(h) {
            return Xe(c, void 0, void 0, function() {
              var f, p;
              return Ka(this, function(m) {
                return !r && !i.selectionsToResolve.has(h) ? [
                  2
                  /*return*/
                ] : ju(h, s) ? yo(h) ? [2, this.resolveField(h, r, n, i).then(function(y) {
                  var v;
                  typeof y < "u" && l.push((v = {}, v[Ca(h)] = y, v));
                })] : (uO(h) ? f = h : (f = a[h.name.value], ke(f, 21, h.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(y) {
                  l.push(y);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(d)).then(function() {
            return Jh(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return Xe(this, void 0, void 0, function() {
        var a, o, s, l, d, c, u, h, f, p = this;
        return Ka(this, function(m) {
          return n ? (a = i.variables, o = t.name.value, s = Ca(t), l = o !== s, d = n[s] || n[o], c = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (u = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[u], h && (f = h[l ? o : s], f && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Zg.withValue(this.cache, f, [
              n,
              Gh(t, a),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(y) {
            var v, b;
            if (y === void 0 && (y = d), t.directives && t.directives.forEach(function(_) {
              _.name.value === "export" && _.arguments && _.arguments.forEach(function(x) {
                x.name.value === "as" && x.value.kind === "StringValue" && (i.exportedVariables[x.value.value] = y);
              });
            }), !t.selectionSet || y == null)
              return y;
            var $ = (b = (v = t.directives) === null || v === void 0 ? void 0 : v.some(function(_) {
              return _.name.value === "client";
            })) !== null && b !== void 0 ? b : !1;
            if (Array.isArray(y))
              return p.resolveSubSelectedArray(t, r || $, y, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || $, y, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var a = this;
      return Promise.all(n.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, i);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(o) {
        return !Array.isArray(o);
      }, i = this.selectionsToResolveCache;
      function a(o) {
        if (!i.has(o)) {
          var s = /* @__PURE__ */ new Set();
          i.set(o, s), Ai(o, {
            Directive: function(l, d, c, u, h) {
              l.name.value === "client" && h.forEach(function(f) {
                n(f) && _4(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, d, c, u, h) {
              var f = r[l.name.value];
              ke(f, 22, l.name.value);
              var p = a(f);
              p.size > 0 && (h.forEach(function(m) {
                n(m) && _4(m) && s.add(m);
              }), s.add(l), p.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(o);
      }
      return a(t);
    }, e;
  })()
), hy = !1, u$ = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, a;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw wn(16);
      var o = t.uri, s = t.credentials, l = t.headers, d = t.cache, c = t.documentTransform, u = t.ssrMode, h = u === void 0 ? !1 : u, f = t.ssrForceFetchDelay, p = f === void 0 ? 0 : f, m = t.connectToDevTools, y = t.queryDeduplication, v = y === void 0 ? !0 : y, b = t.defaultOptions, $ = t.defaultContext, _ = t.assumeImmutableResults, x = _ === void 0 ? d.assumeImmutableResults : _, S = t.resolvers, A = t.typeDefs, N = t.fragmentMatcher, P = t.clientAwareness, D = t.name, T = t.version, I = t.devtools, j = t.dataMasking;
      globalThis.__DEV__ !== !1 && (kr(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), kr(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), kr(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), kr(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), kr(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), kr(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), kr(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && ke.warn(17));
      var F = t.link;
      F || (F = o ? new qw({ uri: o, credentials: s, headers: l }) : Sd.empty()), this.link = F, this.cache = d, this.disableNetworkFetches = h || p > 0, this.queryDeduplication = v, this.defaultOptions = b || /* @__PURE__ */ Object.create(null), this.typeDefs = A, this.devtoolsConfig = z(z({}, I), { enabled: (n = I?.enabled) !== null && n !== void 0 ? n : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Ng, this.localState = new XI({
        cache: d,
        client: this,
        resolvers: S,
        fragmentMatcher: N
      }), this.queryManager = new JI({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: $,
        documentTransform: c,
        queryDeduplication: v,
        ssrMode: h,
        dataMasking: !!j,
        clientAwareness: {
          name: (i = P?.name) !== null && i !== void 0 ? i : D,
          version: (a = P?.version) !== null && a !== void 0 ? a : T
        },
        localState: this.localState,
        assumeImmutableResults: x,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = /* @__PURE__ */ Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !hy && globalThis.__DEV__ !== !1 && (hy = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, a = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && ke.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = C2(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = z(z({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (kr(t, "canonizeResults", "client.watchQuery"), kr(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = C2(this.defaultOptions.query, t)), ke(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = z(z({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (kr(t, "canonizeResults", "client.query"), kr(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && ke.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = C2(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return z(z({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(z(z({}, t), (r = {}, r[/* @__PURE__ */ Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return v5(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(o, s) {
        n.push(s), i.push(o);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(o) {
        globalThis.__DEV__ !== !1 && ke.debug(20, o);
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (u$.prototype.getMemoryInternals = BT);
var u1 = /* @__PURE__ */ new Map(), S5 = /* @__PURE__ */ new Map(), h$ = !0, W1 = !1;
function f$(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function eP(e) {
  return f$(e.source.body.substring(e.start, e.end));
}
function tP(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = eP(n.loc), o = S5.get(i);
      o && !o.has(a) ? h$ && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || S5.set(i, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(n));
    } else
      r.push(n);
  }), z(z({}, e), { definitions: r });
}
function rP(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function nP(e) {
  var t = f$(e);
  if (!u1.has(t)) {
    var r = mT(e, {
      experimentalFragmentVariables: W1,
      allowLegacyFragmentVariables: W1
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    u1.set(t, rP(tP(r)));
  }
  return u1.get(t);
}
function Ie(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[a + 1];
  }), nP(n);
}
function iP() {
  u1.clear(), S5.clear();
}
function aP() {
  h$ = !1;
}
function oP() {
  W1 = !0;
}
function sP() {
  W1 = !1;
}
var Zd = {
  gql: Ie,
  resetCaches: iP,
  disableFragmentWarnings: aP,
  enableExperimentalFragmentVariables: oP,
  disableExperimentalFragmentVariables: sP
};
(function(e) {
  e.gql = Zd.gql, e.resetCaches = Zd.resetCaches, e.disableFragmentWarnings = Zd.disableFragmentWarnings, e.enableExperimentalFragmentVariables = Zd.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = Zd.disableExperimentalFragmentVariables;
})(Ie || (Ie = {}));
Ie.default = Ie;
function lP(e) {
  return new Sd(function(t, r) {
    var n = xi(t, []);
    return new Gt(function(i) {
      var a, o = !1;
      return Promise.resolve(n).then(function(s) {
        return e(s, t.getContext());
      }).then(t.setContext).then(function() {
        o || (a = r(t).subscribe({
          next: i.next.bind(i),
          error: i.error.bind(i),
          complete: i.complete.bind(i)
        }));
      }).catch(i.error.bind(i)), function() {
        o = !0, a && a.unsubscribe();
      };
    });
  });
}
const dP = /[?&]code=[^&]+/, cP = /[?&]state=[^&]+/, uP = /[?&]error=[^&]+/;
class D2 {
  /**
   * @param config - Photon AuthManager configuration options
   * @remarks - Note, that organization is optional for scenarios in which a provider supports more than themselves.
   */
  constructor({ authentication: t, organization: r, audience: n = "https://api.photon.health", connection: i }) {
    this._getAccessToken = (...a) => Xe(this, [...a], void 0, function* ({ audience: o } = {
      audience: this.audience
    }, s = !1) {
      const l = {
        authorizationParams: Object.assign({ audience: o || this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      let d;
      try {
        d = yield this.authentication.getTokenSilently(l);
      } catch (c) {
        c.message.includes("Consent required") && (d = yield this.authentication.getTokenWithPopup(l));
      }
      if (!d) {
        const c = Object.assign(Object.assign({}, l), { appState: {
          returnTo: `${window.location.pathname}${window.location.search}`
        } });
        if (yield this.authentication.loginWithRedirect(c), s)
          throw new Error("Unable to retrieve access token");
        return yield this._getAccessToken({ audience: o }, !0);
      }
      return d;
    }), this.authentication = t, this.organization = r, this.audience = n, this.connection = i;
  }
  /**
   * Performs a login against the specified Auth0 domain
   * @param config - Login configuration
   * @returns
   */
  login(t) {
    return Xe(this, arguments, void 0, function* ({ organizationId: r, invitation: n, connection: i, appState: a }) {
      const o = Object.assign({ authorizationParams: Object.assign(Object.assign(Object.assign(Object.assign({}, this.audience ? { audience: this.audience } : {}), i || this.connection ? { connection: i || this.connection } : {}), r || this.organization ? { organization: r || this.organization } : {}), n ? { invitation: n } : {}) }, a ? { appState: a } : {});
      return this.authentication.loginWithRedirect(o);
    });
  }
  /**
   * Performs a logout against the specified Auth0 domain
   * @param config - Logout configuration
   * @returns
   */
  logout(t) {
    return Xe(this, arguments, void 0, function* ({ returnTo: r, federated: n = !1 }) {
      const i = {
        logoutParams: Object.assign(Object.assign({}, r ? { returnTo: r } : {}), n ? { federated: n } : {})
      };
      return this.authentication.logout(i);
    });
  }
  /**
   * Determines if URL has Auth0 parameters
   * @returns boolean
   */
  hasAuthParams(t = window.location.search) {
    return (dP.test(t) || uP.test(t)) && cP.test(t);
  }
  /**
   * Retrieves a valid access token
   * @param config - getAccessToken configuration
   * @returns
   */
  getAccessToken() {
    return Xe(this, arguments, void 0, function* ({ audience: t } = {
      audience: this.audience
    }) {
      return yield this._getAccessToken({ audience: t ?? this.audience });
    });
  }
  /**
   * Retrieves a valid access token
   * @param config - getAccessToken configuration
   * @returns
   */
  getAccessTokenWithConsent() {
    return Xe(this, arguments, void 0, function* ({ audience: t } = {
      audience: this.audience
    }) {
      const r = {
        authorizationParams: Object.assign({ audience: t || this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      return this.authentication.getTokenWithPopup(r);
    });
  }
  /**
   * Silently performs a getAccessToken and pre-populates the token and user information caches
   * @returns
   */
  checkSession() {
    return Xe(this, void 0, void 0, function* () {
      const t = {
        authorizationParams: Object.assign({ audience: this.audience || void 0 }, this.organization ? { organization: this.organization } : {})
      };
      return this.authentication.checkSession(t);
    });
  }
  /**
   * Handes Auth0 redirect after login
   * @param url - The url which contains the code and state parameters (defaults to window.location.href)
   * @returns
   */
  handleRedirect(t) {
    return Xe(this, void 0, void 0, function* () {
      try {
        return this.authentication.handleRedirectCallback(t);
      } catch (r) {
        console.error(r);
      }
    });
  }
  /**
   * Retrieves information about the currently authenticated user
   * @returns
   */
  getUser() {
    return Xe(this, void 0, void 0, function* () {
      return this.authentication.getUser();
    });
  }
  /**
   * Determines whether or not a user is currently logged in
   * @returns
   */
  isAuthenticated() {
    return Xe(this, void 0, void 0, function* () {
      try {
        return yield this.authentication.checkSession(), yield this.authentication.isAuthenticated();
      } catch {
        return !1;
      }
    });
  }
}
const S0 = Ie`
  fragment OrganizationFields on Organization {
    id
    name
  }
`, da = Ie`
  fragment PatientFields on Patient {
    id
    externalId
    name {
      full
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      id
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`, fy = Ie`
  fragment AllergenFields on Allergen {
    id
    name
    rxcui
  }
`, C0 = Ie`
  fragment CatalogFields on Catalog {
    id
    name
  }
`, gs = Ie`
  fragment MedicationFields on Medication {
    id
    name
    form
    schedule
    controlled
  }
`, M2 = Ie`
  fragment SearchMedicationFields on SearchMedication {
    id
    name
  }
`, py = Ie`
  fragment MedicalEquipmentFields on MedicalEquipment {
    id
    name
  }
`;
Ie`
  fragment CatalogTreatmentFields on Catalog {
    treatments {
      id
      name
    }
  }
`;
const my = Ie`
  fragment DispenseUnitFields on DispenseUnit {
    name
  }
`, hP = Ie`
  fragment FillPrescriptionFields on Fill {
    id
    state
    requestedAt
    filledAt
    order {
      id
      createdAt
      state
      fulfillment {
        state
      }
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`, Yd = Ie`
  ${hP}
  fragment PrescriptionFields on Prescription {
    id
    externalId
    fills {
      ...FillPrescriptionFields
    }
    prescriber {
      id
      name {
        full
      }
    }
    patient {
      id
      name {
        full
      }
    }
    state
    treatment {
      id
      name
    }
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    fillsAllowed
    fillsRemaining
    daysSupply
    instructions
    notes
    effectiveDate
    doNotFillBeforeDate
    expirationDate
    writtenAt
  }
`, fP = Ie`
  fragment FillFields on Fill {
    id
    prescription {
      id
    }
    treatment {
      name
    }
    state
    requestedAt
    filledAt
  }
`, Jd = Ie`
  ${da}
  ${fP}
  fragment OrderFields on Order {
    id
    externalId
    state
    fills {
      ...FillFields
    }
    patient {
      ...PatientFields
    }
    pharmacy {
      id
      name
      phone
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
    }
    createdAt
  }
`, R2 = Ie`
  fragment WebhookFields on WebhookConfig {
    id
    name
    filters
    url
  }
`, gy = Ie`
  fragment ClientFields on Client {
    id
    name
    secret
    appType
  }
`, E0 = Ie`
  fragment PharmacyFields on Pharmacy {
    id
    NPI
    NCPDP
    name
    fulfillmentTypes
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`, L2 = Ie`
  fragment PrescriptionTemplateFields on PrescriptionTemplate {
    id
    daysSupply
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    instructions
    notes
    fillsAllowed
    treatment {
      id
      name
    }
    isPrivate
  }
`;
function or(e, t) {
  return Xe(this, arguments, void 0, function* (r, n, i = {}, a = "network-only") {
    const o = yield r.query({
      query: n,
      variables: i,
      fetchPolicy: a
    });
    return Object.assign(Object.assign({}, o), { refetch: (s) => r.query({ query: n, variables: Object.assign(i, s) }), fetchMore: ({ after: s, first: l }) => r.query({
      query: n,
      variables: Object.assign(i, { after: s, first: l })
    }) });
  });
}
function On(e, t) {
  return ({ variables: r, refetchQueries: n, awaitRefetchQueries: i = !1 }) => e.mutate({
    mutation: t,
    refetchQueries: n,
    awaitRefetchQueries: i,
    variables: r
  });
}
const C5 = {
  tau: "https://app.boson.health",
  boson: "https://app.boson.health",
  neutron: "https://app.neutron.health",
  photon: "https://app.photon.health"
}, A0 = {
  tau: "https://api.boson.health",
  boson: "https://api.boson.health",
  neutron: "https://api.neutron.health",
  photon: "https://api.photon.health"
}, vy = {
  tau: "http://clinical-api.tau.health:8080",
  boson: "https://clinical-api.boson.health",
  neutron: "https://clinical-api.neutron.health",
  photon: "https://clinical-api.photon.health"
};
function pP(e) {
  const t = Object.keys(C5).find((r) => e.toLowerCase().includes(r));
  return C5[t || "photon"];
}
class mP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all catalogs based on currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getCatalogs() {
    return Xe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { CatalogFields: C0 }
    }) {
      t || (t = { CatalogFields: C0 });
      const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      query catalogs {
        catalogs {
          ...${r}
        }
      }
    `;
      return or(this.apollo, i);
    });
  }
  /**
   * Retrieves catalog by id
   * @param options - Query options
   * @returns
   */
  getCatalog() {
    return Xe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { CatalogFields: C0 }
    }) {
      r || (r = { CatalogFields: C0 });
      const [n, i] = Object.entries(r)[0], a = Ie`
      ${i}
      query catalog($id: ID) {
        catalog(id: $id) {
          ...${n}
        }
      }
    `;
      return or(this.apollo, a, { id: t });
    });
  }
  /**
   * Adds a treatment to a catalog
   * @param options - Query options
   * @returns
   */
  addToCatalog({ fragment: t }) {
    t || (t = { MedicationFields: gs });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation addToCatalog(
        $catalogId: ID!
        $treatmentId: ID!
      ) {
        addToCatalog(
          catalogId: $catalogId
          treatmentId: $treatmentId
        ) {
          ...${r}
        }
      }
    `;
    return On(this.apollo, i);
  }
  /**
   * Removes a treatment from a catalog
   * @param options - Query options
   * @returns
   */
  removeFromCatalog({ fragment: t }) {
    t || (t = { MedicationFields: gs });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation removeFromCatalog(
        $catalogId: ID!
        $treatmentId: ID!
      ) {
        removeFromCatalog(
          catalogId: $catalogId
          treatmentId: $treatmentId
        ) {
          ...${r}
        }
      }
    `;
    return On(this.apollo, i);
  }
}
class gP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medications, optionally filtered by name, type, and code
   * @param options - Query options
   * @returns
   */
  getMedications() {
    return Xe(this, arguments, void 0, function* ({ filter: t, after: r, first: n, fragment: i } = {
      fragment: { MedicationFields: gs }
    }) {
      i || (i = { MedicationFields: gs });
      const [a, o] = Object.entries(i)[0], s = Ie`
      ${o}
      query medications($filter: MedicationFilter, $after: ID, $first: Int) {
        medications(filter: $filter, after: $after, first: $first) {
          ...${a}
    }
  }
    `;
      return or(this.apollo, s, {
        filter: t,
        after: r,
        first: n
      });
    });
  }
}
class vP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medical equipment, optionally filtered by name, type, and code
   * @param options - Query options
   * @returns
   */
  getMedicalEquipment() {
    return Xe(this, arguments, void 0, function* ({ name: t, after: r, first: n, fragment: i } = {
      fragment: { MedicalEquipmentFields: py }
    }) {
      i || (i = { MedicalEquipmentFields: py });
      const [a, o] = Object.entries(i)[0], s = Ie`
      ${o}
      query medicalEquipment($name: String, $after: ID, $first: Int) {
        medicalEquipment(name: $name, after: $after, first: $first) {
          ...${a}
    }
  }
    `;
      return or(this.apollo, s, {
        name: t,
        after: r,
        first: n
      });
    });
  }
}
class yP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all orders in a paginated fashion, optionally filtered by patientId, patientName
   * @param options - Query options
   * @returns
   */
  getOrders() {
    return Xe(this, arguments, void 0, function* ({ patientId: t, patientName: r, after: n, first: i, fragment: a } = {
      first: 25,
      fragment: { OrderFields: Jd }
    }) {
      i || (i = 25), a || (a = { OrderFields: Jd });
      const [o, s] = Object.entries(a)[0], l = Ie`
        ${s}
        query orders(
          $patientId: ID
          $patientName: String
          $after: ID
          $first: Int
      ) {
          orders(
              filter: {
                  patientId: $patientId
                  patientName: $patientName
              }
              after: $after
              first: $first
          ) {
              ...${o}
          }
        }
      `;
      return or(this.apollo, l, {
        patientId: t,
        patientName: r,
        after: n,
        first: i
      });
    });
  }
  /**
   * Retrieves order by id
   * @param options - Query options
   * @returns
   */
  getOrder() {
    return Xe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { OrderFields: Jd }
    }) {
      r || (r = { OrderFields: Jd });
      const [n, i] = Object.entries(r)[0], a = Ie`
        ${i}
        query order($id: ID!) {
          order(id: $id) {
            ...${n}
          }
        }
      `;
      return or(this.apollo, a, { id: t });
    });
  }
  /**
   * Creates a new order
   * @param options - Query options
   * @returns
   */
  createOrder({ fragment: t }) {
    t || (t = { OrderFields: Jd });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation createOrder(
        $externalId: ID
        $patientId: ID!
        $fills: [FillInput!]!
        $addressId: ID
        $address: AddressInput
        $pharmacyId: ID
        $groupId: ID
        $supervisorId: ID
      ) {
        createOrder(
          externalId: $externalId
          patientId: $patientId
          fills: $fills
          addressId: $addressId
          address: $address
          pharmacyId: $pharmacyId
          groupId: $groupId
          supervisorId: $supervisorId
        ) {
          ...${r}
        }
      }
    `;
    return On(this.apollo, i);
  }
}
class bP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves patient by id
   * @param options - Query options
   * @returns
   */
  getPatient() {
    return Xe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PatientFields: da }
    }) {
      r || (r = { PatientFields: da });
      const [n, i] = Object.entries(r)[0], a = Ie`
      ${i}
      query patient($id: ID!) {
        patient(id: $id) {
          ...${n}
        }
      }
    `;
      return or(this.apollo, a, { id: t });
    });
  }
  /**
   * Retrieves all patients in a paginated fashion, optionally filtered by name
   * @param options - Query options
   * @returns
   */
  getPatients() {
    return Xe(this, arguments, void 0, function* ({ after: t, first: r, name: n, fragment: i } = {
      first: 25,
      fragment: { PatientFields: da }
    }) {
      i || (i = { PatientFields: da }), r || (r = 25);
      const [a, o] = Object.entries(i)[0], s = Ie`
      ${o}
      query patients($after: ID, $name: String, $first: Int) {
        patients(after: $after, first: $first, filter: { name: $name }) {
          ...${a}
        }
      }
    `;
      return or(this.apollo, s, {
        after: t,
        name: n,
        first: r
      });
    });
  }
  /**
   * Creates a new patient
   * @param options - Query options
   * @returns
   */
  createPatient({ fragment: t }) {
    t || (t = { PatientFields: da });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation createPatient(
        $externalId: ID
        $name: NameInput!
        $dateOfBirth: AWSDate!
        $sex: SexType!
        $gender: String
        $email: AWSEmail
        $phone: AWSPhone!
        $address: AddressInput
        $allergies: [AllergenInput]
        $medicationHistory: [MedHistoryInput]
        $preferredPharmacies: [ID]
      ) {
        createPatient(
          externalId: $externalId
          name: $name
          dateOfBirth: $dateOfBirth
          sex: $sex
          gender: $gender
          address: $address
          email: $email
          phone: $phone
          allergies: $allergies
          medicationHistory: $medicationHistory
          preferredPharmacies: $preferredPharmacies
        ) {
          ...${r}
        }
      }`;
    return On(this.apollo, i);
  }
  /**
   * Updates an existing patient
   * @param options - Query options
   * @returns
   */
  updatePatient({ fragment: t }) {
    t || (t = { PatientFields: da });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation updatePatient(
        $id: ID!
        $externalId: ID
        $name: NameInput
        $dateOfBirth: AWSDate
        $sex: SexType
        $gender: String
        $email: AWSEmail
        $phone: AWSPhone
        $allergies: [AllergenInput]
        $medicationHistory: [MedHistoryInput]
        $address: AddressInput
        $preferredPharmacies: [ID]
      ) {
        updatePatient(
          id: $id
          externalId: $externalId
          name: $name
          dateOfBirth: $dateOfBirth
          sex: $sex
          gender: $gender
          email: $email
          phone: $phone
          allergies: $allergies
          medicationHistory: $medicationHistory
          address: $address,
          preferredPharmacies: $preferredPharmacies
        ) {
          ...${r}
        }
      }`;
    return On(this.apollo, i);
  }
  /**
   * Adds a preferred pharmcy to a patient
   * @param options - Query options
   * @returns
   */
  removePatientPreferredPharmacy({ fragment: t }) {
    t || (t = { PatientFields: da });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation removePatientPreferredPharmacy(
        $patientId: ID!
        $pharmacyId: ID!
      ) {
        removePatientPreferredPharmacy(
          patientId: $patientId
          pharmacyId: $pharmacyId
        ) {
          ...${r}
        }
      }`;
    return On(this.apollo, i);
  }
  /**
   * Removes an allergen from a patient
   * @param options - Query options
   * @returns
   */
  removePatientAllergy({ fragment: t }) {
    t || (t = { PatientFields: da });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation removePatientAllergy(
        $id: ID!
        $allergenId: ID!
      ) {
        updatePatient(
          id: $id
          allergenId: $allergenId
        ) {
          ...${r}
        }
      }`;
    return On(this.apollo, i);
  }
}
class wP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all pharmacies, optionally filtered by pharmacy name, in a given latitude/longitude/radius
   * @param options - Query options
   * @returns
   */
  getPharmacies() {
    return Xe(this, arguments, void 0, function* ({ name: t, location: r, type: n, after: i, first: a, fragment: o } = {
      first: 100,
      fragment: { PharmacyFields: E0 }
    }) {
      a || (a = 100), o || (o = { PharmacyFields: E0 });
      const [s, l] = Object.entries(o)[0], d = Ie`
      ${l}
      query pharmacies($name: String, $location: LatLongSearch, $type: FulfillmentType, $after: Int, $first: Int) {
        pharmacies(name: $name, location: $location, type: $type, after: $after, first: $first) {
          ...${s}
        }
      }
    `;
      return or(this.apollo, d, {
        name: t,
        location: r,
        type: n,
        after: i,
        first: a
      });
    });
  }
  /**
   * Retrieves pharmacy by id
   * @param options - Query options
   * @returns
   */
  getPharmacy() {
    return Xe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PharmacyFields: E0 }
    }) {
      r || (r = { PharmacyFields: E0 });
      const [n, i] = Object.entries(r)[0], a = Ie`
          ${i}
          query pharmacy($id: ID!) {
            pharmacy(id: $id) {
              ...${n}
            }
          }
        `;
      return or(this.apollo, a, { id: t });
    });
  }
}
class $P {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  getPrescriptions() {
    return Xe(this, arguments, void 0, function* ({ patientId: t, patientName: r, prescriberId: n, state: i, after: a, first: o, fragment: s } = {
      first: 25,
      fragment: { PrescriptionFields: Yd }
    }) {
      s || (s = { PrescriptionFields: Yd }), o || (o = 25);
      const [l, d] = Object.entries(s)[0], c = Ie`
      ${d}
      query prescriptions(
        $patientId: ID
        $patientName: String
        $prescriberId: ID
        $state: PrescriptionState
        $after: ID
        $first: Int
      ) {
        prescriptions(
          filter: {
            patientId: $patientId
            patientName: $patientName
            prescriberId: $prescriberId
            state: $state
          }
          after: $after
          first: $first
        ) {
          ...${l}
        }
      }
    `;
      return or(this.apollo, c, {
        patientId: t,
        patientName: r,
        prescriberId: n,
        state: i,
        after: a,
        first: o
      });
    });
  }
  getPrescription() {
    return Xe(this, arguments, void 0, function* ({ id: t, fragment: r } = {
      id: "",
      fragment: { PrescriptionFields: Yd }
    }) {
      r || (r = { PrescriptionFields: Yd });
      const [n, i] = Object.entries(r)[0], a = Ie`
      ${i}
      query prescription($id: ID!) {
        prescription(id: $id) {
          ...${n}
        }
      }
    `;
      return or(this.apollo, a, {
        id: t
      });
    });
  }
  getDispenseUnits() {
    return Xe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { DispenseUnitFields: my }
    }) {
      t || (t = { DispenseUnitFields: my });
      const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      query dispenseUnits {
        dispenseUnits {
          ...${r}
        }
      }
    `;
      return or(this.apollo, i, {});
    });
  }
  createPrescription({ fragment: t }) {
    t || (t = { PrescriptionFields: Yd });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation createPrescription(
        $externalId: ID
        $patientId: ID!
        $treatmentId: ID!
        $dispenseAsWritten: Boolean
        $dispenseQuantity: Float!
        $dispenseUnit: String!
        $fillsAllowed: Int!
        $daysSupply: Int
        $instructions: String!
        $notes: String
        $doNotFillBeforeDate: AWSDate
        $diagnoses: [ID]
      ) {
        createPrescription(
          externalId: $externalId
          patientId: $patientId
          treatmentId: $treatmentId
          dispenseAsWritten: $dispenseAsWritten
          dispenseQuantity: $dispenseQuantity
          dispenseUnit: $dispenseUnit
          fillsAllowed: $fillsAllowed
          daysSupply: $daysSupply
          instructions: $instructions
          notes: $notes
          doNotFillBeforeDate: $doNotFillBeforeDate
          diagnoses: $diagnoses
        ) {
          ...${r}
        }
      }`;
    return On(this.apollo, i);
  }
}
class kP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all allergens, optionally filtered by name (fuzzy)
   * @param options - Query options
   * @returns
   */
  getAllergens() {
    return Xe(this, arguments, void 0, function* ({ fragment: t, filter: r } = {
      fragment: { AllergenFields: fy }
    }) {
      t || (t = { AllergenFields: fy });
      const [n, i] = Object.entries(t)[0], a = Ie`
        ${i}
        query allergens($filter: AllergenFilter) {
            allergens(filter: $filter) {
                ...${n}
            }
        }
      `;
      return or(this.apollo, a, {
        filter: r
      });
    });
  }
}
class _P {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Creates a new prescription template
   * @param options - Query options
   * @returns
   */
  createPrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: L2 });
    const [r, n] = Object.entries(t)[0], i = Ie`
        ${n}
        mutation createPrescriptionTemplate(
          $catalogId: ID!,
          $treatmentId: ID!,
          $dispenseAsWritten: Boolean,
          $dispenseQuantity: Float,
          $dispenseUnit: String,
          $fillsAllowed: Int,
          $daysSupply: Int,
          $instructions: String,
          $notes: String,
          $name: String,
          $isPrivate: Boolean
        ) {
          createPrescriptionTemplate(
            catalogId: $catalogId
            treatmentId: $treatmentId
            dispenseAsWritten: $dispenseAsWritten
            dispenseQuantity: $dispenseQuantity
            dispenseUnit: $dispenseUnit
            fillsAllowed: $fillsAllowed
            daysSupply: $daysSupply
            instructions: $instructions
            notes: $notes
            name: $name
            isPrivate: $isPrivate
        ) {
            ...${r}
        }
      }
      `;
    return On(this.apollo, i);
  }
  /**
   * Updates a prescription template
   * @param options - Query options
   * @returns
   */
  updatePrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: L2 });
    const [r, n] = Object.entries(t)[0], i = Ie`
        ${n}
        mutation updatePrescriptionTemplate(
          $catalogId: ID!,
          $templateId: ID!,
          $dispenseAsWritten: Boolean,
          $dispenseQuantity: Float,
          $dispenseUnit: String,
          $fillsAllowed: Int,
          $daysSupply: Int,
          $instructions: String,
          $notes: String,
          $name: String
        ) {
          updatePrescriptionTemplate(
            catalogId: $catalogId
            templateId: $templateId
            dispenseAsWritten: $dispenseAsWritten
            dispenseQuantity: $dispenseQuantity
            dispenseUnit: $dispenseUnit
            fillsAllowed: $fillsAllowed
            daysSupply: $daysSupply
            instructions: $instructions
            notes: $notes
            name: $name
        ) {
            ...${r}
        }
      }
      `;
    return On(this.apollo, i);
  }
  /**
   * Deletes an existing prescription template
   * @param options - Query options
   * @returns
   */
  deletePrescriptionTemplate({ fragment: t }) {
    t || (t = { PrescriptionTemplateFields: L2 });
    const [r, n] = Object.entries(t)[0], i = Ie`
        ${n}
        mutation deletePrescriptionTemplate(
          $catalogId: ID!,
          $templateId: ID!
        ) {
          deletePrescriptionTemplate(
            catalogId: $catalogId
            templateId: $templateId
        ) {
            ...${r}
        }
      }
      `;
    return On(this.apollo, i);
  }
}
class xP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all medication concepts, filtered by name
   * @param options - Query options
   * @returns
   */
  getConcepts(t) {
    return Xe(this, arguments, void 0, function* ({ name: r, fragment: n }) {
      n || (n = { SearchMedicationFields: M2 });
      const [i, a] = Object.entries(n)[0], o = Ie`
        ${a}
        query medicationConcepts($name: String!) {
          medicationConcepts(name: $name) {
            ...${i}
      }
    }
      `;
      return or(this.apollo, o, {
        name: r
      });
    });
  }
  /**
   * Retrieves all strengths for a SearchMedication CONCEPT
   * @param options - Query options
   * @returns
   */
  getStrengths(t) {
    return Xe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { SearchMedicationFields: M2 });
      const [i, a] = Object.entries(n)[0], o = Ie`
          ${a}
          query medicationStrengths($id: String!) {
            medicationStrengths(id: $id) {
              ...${i}
        }
      }
        `;
      return or(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all routes for a SearchMedication STRENGTH
   * @param options - Query options
   * @returns
   */
  getRoutes(t) {
    return Xe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { SearchMedicationFields: M2 });
      const [i, a] = Object.entries(n)[0], o = Ie`
              ${a}
              query medicationRoutes($id: String!) {
                medicationRoutes(id: $id) {
                  ...${i}
            }
          }
            `;
      return or(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all forms for a SearchMedication ROUTE
   * @param options - Query options
   * @returns
   */
  getForms(t) {
    return Xe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: gs });
      const [i, a] = Object.entries(n)[0], o = Ie`
              ${a}
              query medicationForms($id: String!) {
                medicationForms(id: $id) {
                  ...${i}
            }
          }
            `;
      return or(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all products for a SearchMedication FORM/Medication DRUG
   * @param options - Query options
   * @returns
   */
  getProducts(t) {
    return Xe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: gs });
      const [i, a] = Object.entries(n)[0], o = Ie`
                  ${a}
                  query medicationProducts($id: String!) {
                    medicationProducts(id: $id) {
                      ...${i}
                }
              }
                `;
      return or(this.apollo, o, {
        id: r
      });
    });
  }
  /**
   * Retrieves all packages for a Medication PRODUCT
   * @param options - Query optiofns
   * @returns
   */
  getPackages(t) {
    return Xe(this, arguments, void 0, function* ({ id: r, fragment: n }) {
      n || (n = { MedicationFields: gs });
      const [i, a] = Object.entries(n)[0], o = Ie`
                  ${a}
                  query medicationPackages($id: String!) {
                    medicationPackages(id: $id) {
                      ...${i}
                }
              }
                `;
      return or(this.apollo, o, {
        id: r
      });
    });
  }
}
class SP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.catalog = new mP(t), this.medication = new gP(t), this.medicalEquipment = new vP(t), this.searchMedication = new xP(t), this.order = new yP(t), this.patient = new bP(t), this.pharmacy = new wP(t), this.prescription = new $P(t), this.allergens = new kP(t), this.prescriptionTemplate = new _P(t);
  }
}
class CP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves all Auth0 clients based on currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getClients() {
    return Xe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { ClientFields: gy }
    }) {
      const [r, n] = Object.entries(t)[0], i = Ie`
          ${n}
          query clients {
            clients {
              ...${r}
            }
          }
        `;
      return or(this.apollo, i);
    });
  }
  /**
   * Rotates client_secret for the authenticated Auth0 organization
   * @param options - Query options
   * @returns
   */
  rotateSecret({ fragment: t }) {
    t || (t = { ClientFields: gy });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation rotateSecret(
        $id: ID!
      ) {
        rotateSecret(id: $id) {
          ...${r}
        }
      }
    `;
    return On(this.apollo, i);
  }
}
class EP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves the organization associated with the authenticated user
   * @param options - Query options
   * @returns
   */
  getOrganization() {
    return Xe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { OrganizationFields: S0 }
    }) {
      t || (t = { OrganizationFields: S0 });
      const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      query organization {
        organization {
          ...${r}
        }
      }
    `;
      return or(this.apollo, i);
    });
  }
  /**
   * Retrieves all organizations associated with the auhenticated user
   * @param options - Query options
   * @returns
   */
  getOrganizations() {
    return Xe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { OrganizationFields: S0 }
    }) {
      t || (t = { OrganizationFields: S0 });
      const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      query organizations {
        organizations {
          ...${r}
        }
      }
    `;
      return or(this.apollo, i);
    });
  }
}
class AP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.apollo = t;
  }
  /**
   * Retrieves list of webhook associated with currently authenticated organization
   * @param options - Query options
   * @returns
   */
  getWebhooks() {
    return Xe(this, arguments, void 0, function* ({ fragment: t } = {
      fragment: { WebhookFields: R2 }
    }) {
      t || (t = { WebhookFields: R2 });
      const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      query webhooks {
        webhooks {
          ...${r}
        }
      }
    `;
      return or(this.apollo, i);
    });
  }
  /**
   * Creates a new webhook for the authenticated organization
   * @param options - Query options
   * @returns
   */
  createWebhook({ fragment: t }) {
    t || (t = { WebhookFields: R2 });
    const [r, n] = Object.entries(t)[0], i = Ie`
      ${n}
      mutation createWebhook(
        $name: String
        $filters: [String]
        $sharedSecret: String
        $url: String!
      ) {
        createWebhookConfig(name: $name, filters: $filters, sharedSecret: $sharedSecret, url: $url) {
          ...${r}
        }
      }`;
    return On(this.apollo, i);
  }
  /**
   * Deletes a webhook, by id, inside the currently authenticated organization
   * @returns
   */
  deleteWebhook() {
    const t = Ie`
      mutation deleteWebhookConfig($id: String!) {
        deleteWebhookConfig(id: $id)
      }
    `;
    return On(this.apollo, t);
  }
}
class TP {
  /**
   * @param apollo - An Apollo client instance
   */
  constructor(t) {
    this.client = new CP(t), this.organization = new EP(t), this.webhook = new AP(t);
  }
}
const OP = "1.4.1", F2 = {
  version: OP
};
var E5;
(function(e) {
  e.Drug = "DRUG", e.Package = "PACKAGE", e.Product = "PRODUCT";
})(E5 || (E5 = {}));
var A5;
(function(e) {
  e.Icd10 = "ICD10";
})(A5 || (A5 = {}));
var T5;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(T5 || (T5 = {}));
var O5;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(O5 || (O5 = {}));
var I5;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(I5 || (I5 = {}));
var P5;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING";
})(P5 || (P5 = {}));
var N5;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(N5 || (N5 = {}));
var D5;
(function(e) {
  e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED";
})(D5 || (D5 = {}));
var M5;
(function(e) {
  e.I = "I", e.Ii = "II", e.Iii = "III", e.Iv = "IV", e.V = "V";
})(M5 || (M5 = {}));
var R5;
(function(e) {
  e.Concept = "CONCEPT", e.Form = "FORM", e.Route = "ROUTE", e.Strength = "STRENGTH";
})(R5 || (R5 = {}));
var L5;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(L5 || (L5 = {}));
const Q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ConceptType() {
    return E5;
  },
  get DiagnosisType() {
    return A5;
  },
  get FillState() {
    return T5;
  },
  get FulfillmentType() {
    return O5;
  },
  get MedicationType() {
    return I5;
  },
  get OrderState() {
    return P5;
  },
  get OrgType() {
    return N5;
  },
  get PrescriptionState() {
    return D5;
  },
  get ScheduleType() {
    return M5;
  },
  get SearchMedicationType() {
    return R5;
  },
  get SexType() {
    return L5;
  }
}, Symbol.toStringTag, { value: "Module" }));
var yy;
(function(e) {
  e.Coupon = "coupon", e.Discount = "discount", e.Insurance = "insurance";
})(yy || (yy = {}));
var by;
(function(e) {
  e.Admin = "admin", e.Group = "group", e.Photon = "photon", e.Provider = "provider";
})(by || (by = {}));
var wy;
(function(e) {
  e.Covered = "COVERED", e.CoveredWithRestrictions = "COVERED_WITH_RESTRICTIONS", e.NotCovered = "NOT_COVERED";
})(wy || (wy = {}));
var $y;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})($y || ($y = {}));
var ky;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(ky || (ky = {}));
var _y;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(_y || (_y = {}));
var xy;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED";
})(xy || (xy = {}));
var Sy;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(Sy || (Sy = {}));
var Cy;
(function(e) {
  e.Major = "MAJOR", e.Minor = "MINOR", e.Moderate = "MODERATE";
})(Cy || (Cy = {}));
var Ey;
(function(e) {
  e.Allergen = "ALLERGEN", e.Drug = "DRUG";
})(Ey || (Ey = {}));
var Ay;
(function(e) {
  e.Active = "ACTIVE", e.Canceled = "CANCELED", e.Depleted = "DEPLETED", e.Draft = "DRAFT", e.Expired = "EXPIRED";
})(Ay || (Ay = {}));
var Ty;
(function(e) {
  e.Exclude = "EXCLUDE", e.Include = "INCLUDE", e.NoAdvice = "NO_ADVICE", e.NoRouting = "NO_ROUTING";
})(Ty || (Ty = {}));
var Oy;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(Oy || (Oy = {}));
const IP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "SupervisorCard" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Supervisor" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "npi" } }] } }] }, PP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateSupervisorMutation" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "npi" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createSupervisor" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "firstName" }, value: { kind: "Variable", name: { kind: "Name", value: "firstName" } } }, { kind: "ObjectField", name: { kind: "Name", value: "lastName" }, value: { kind: "Variable", name: { kind: "Name", value: "lastName" } } }, { kind: "ObjectField", name: { kind: "Name", value: "npi" }, value: { kind: "Variable", name: { kind: "Name", value: "npi" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SupervisorCard" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "SupervisorCard" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Supervisor" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "npi" } }] } }] }, NP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, DP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatmentOptionsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, MP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "MeUserQuery" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "me" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "state" } }] } }] } }] } }] }, RP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SupervisorCardQuery" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "supervisors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SupervisorCard" } }] } }, { kind: "Field", name: { kind: "Name", value: "mostRecentSupervisor" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "SupervisorCard" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Supervisor" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "npi" } }] } }] }, LP = {
  "\n  fragment SupervisorCard on Supervisor {\n    id\n    firstName\n    lastName\n    npi\n  }\n": IP,
  "\n  mutation CreateSupervisorMutation($firstName: String!, $lastName: String!, $npi: String!) {\n    createSupervisor(input: { firstName: $firstName, lastName: $lastName, npi: $npi }) {\n      ...SupervisorCard\n    }\n  }\n": PP,
  "\n  query SearchTreatments($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      id\n      name\n    }\n  }\n": NP,
  "\n  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      __typename\n      id\n      name\n    }\n  }\n": DP,
  "\n  query MeUserQuery {\n    me {\n      name {\n        title\n      }\n      address {\n        state\n      }\n    }\n  }\n": MP,
  "\n  query SupervisorCardQuery {\n    supervisors {\n      ...SupervisorCard\n    }\n    mostRecentSupervisor {\n      id\n    }\n  }\n": RP
};
function Vu(e) {
  var t;
  return (t = LP[e]) !== null && t !== void 0 ? t : {};
}
const FP = Vu(`
  query SearchTreatments($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      id
      name
    }
  }
`), jP = Vu(`
  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      __typename
      id
      name
    }
  }
`), zP = Vu(`
  query MeUserQuery {
    me {
      name {
        title
      }
      address {
        state
      }
    }
  }
`), VP = Vu(`
  query SupervisorCardQuery {
    supervisors {
      ...SupervisorCard
    }
    mostRecentSupervisor {
      id
    }
  }
`), UP = Vu(`
  mutation CreateSupervisorMutation($firstName: String!, $lastName: String!, $npi: String!) {
    createSupervisor(input: { firstName: $firstName, lastName: $lastName, npi: $npi }) {
      ...SupervisorCard
    }
  }
`);
var j2;
const qP = (j2 = F2?.version) !== null && j2 !== void 0 ? j2 : "unknown";
class BP {
  /**
   * Constructs a new PhotonSDK instance
   * @param config - Photon SDK configuration options
   * @remarks - Note, that organization is optional for scenarios in which a provider supports more than themselves.
   */
  constructor({ domain: t, clientId: r, redirectURI: n, organization: i, env: a = "photon", audience: o, connection: s, uri: l, developmentMode: d = !1 }, c) {
    this.audience = o || A0[a], this.uri = l || `${A0[a]}/graphql`, this.clinicalUrl = l ? pP(l) : C5[a], this.clinicalApiUri = `${vy[a]}/graphql`, d && (this.audience = A0.neutron, this.uri = `${A0.neutron}/graphql`, this.clinicalApiUri = `${vy.neutron}/graphql`);
    const u = {
      domain: t || (d ? "auth.neutron.health" : "auth.photon.health"),
      clientId: r,
      cacheLocation: "localstorage",
      useRefreshTokens: !0,
      useRefreshTokensFallback: !0,
      authorizationParams: Object.assign({ redirect_uri: n, audience: this.audience }, s ? { connection: s } : {})
    };
    this.auth0Client = new MA(u), this.organization = i, this.authentication = new D2(Object.assign({ authentication: this.auth0Client, organization: this.organization, audience: this.audience }, s ? { connection: s } : {})), this.apollo = this.constructApolloClient({ elementsVersion: c, isServices: !1 }), this.apolloClinical = this.constructApolloClient({ elementsVersion: c, isServices: !0 }), this.clinical = new SP(this.apollo), this.management = new TP(this.apollo);
  }
  constructApolloClient({ elementsVersion: t, isServices: r } = {
    isServices: !1
  }) {
    return new u$({
      link: lP((i, a) => Xe(this, void 0, void 0, function* () {
        var { headers: o } = a, s = xi(a, ["headers"]);
        let l;
        try {
          l = yield this.authentication.getAccessToken();
        } catch {
        }
        const d = Object.assign(Object.assign(Object.assign({}, o), { "x-photon-sdk-version": qP }), t ? { "x-photon-elements-version": t } : {});
        return l ? Object.assign(Object.assign({}, s), { headers: r ? Object.assign(Object.assign({}, d), { "x-photon-auth-token": l, "x-photon-auth-token-type": "auth0" }) : Object.assign(Object.assign({}, d), { authorization: l }) }) : Object.assign({ headers: d }, s);
      })).concat(new qw({
        uri: r ? this.clinicalApiUri : this.uri
      })),
      defaultOptions: {
        query: {
          fetchPolicy: "cache-first",
          errorPolicy: "all"
        },
        mutate: {
          // Because of the way we do lambdas, we have a _slight_ delay between reads and writes
          // This forces a delay of 1s which isn't the greatest, but also isn't the worst
          // https://github.com/apollographql/apollo-feature-requests/issues/207
          onQueryUpdated: WP
        }
      },
      cache: new d$({
        // Addresses and names don't have unique ids. So we just allow for merging these
        typePolicies: {
          Patient: {
            fields: {
              name: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              },
              address: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              }
            }
          },
          User: {
            fields: {
              name: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              },
              address: {
                merge(i, a, { mergeObjects: o }) {
                  return o(i, a);
                }
              }
            }
          }
        }
      })
    });
  }
  /**
   * Sets the organization ID to use
   * @returns PhotonSDK
   */
  setOrganization(t) {
    return this.organization = t, this.authentication = new D2({
      authentication: this.auth0Client,
      organization: t,
      audience: this.audience
    }), this;
  }
  /**
   * Clears the organization ID
   * @returns PhotonSDK
   */
  clearOrganization() {
    return this.organization = void 0, this.authentication = new D2({
      authentication: this.auth0Client,
      organization: void 0,
      audience: this.audience
    }), this.authentication.login({}), this;
  }
}
const HP = (e) => new Promise((t) => setTimeout(t, e)), WP = (e) => Xe(void 0, void 0, void 0, function* () {
  yield HP(1e3), e.refetch();
}), QP = [
  "allowfullscreen",
  "async",
  "alpha",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected",
  "adauctionheaders",
  "browsingtopics",
  "credentialless",
  "defaultchecked",
  "defaultmuted",
  "defaultselected",
  "defer",
  "disablepictureinpicture",
  "disableremoteplayback",
  "preservespitch",
  "shadowrootclonable",
  "shadowrootcustomelementregistry",
  "shadowrootdelegatesfocus",
  "shadowrootserializable",
  "sharedstoragewritable"
], KP = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "noValidate",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  "adAuctionHeaders",
  "allowFullscreen",
  "browsingTopics",
  "defaultChecked",
  "defaultMuted",
  "defaultSelected",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "preservesPitch",
  "shadowRootClonable",
  "shadowRootCustomElementRegistry",
  "shadowRootDelegatesFocus",
  "shadowRootSerializable",
  "sharedStorageWritable",
  ...QP
]), GP = /* @__PURE__ */ new Set(["innerHTML", "textContent", "innerText", "children"]), ZP = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), YP = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  novalidate: {
    $: "noValidate",
    FORM: 1
  },
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  },
  adauctionheaders: {
    $: "adAuctionHeaders",
    IFRAME: 1
  },
  allowfullscreen: {
    $: "allowFullscreen",
    IFRAME: 1
  },
  browsingtopics: {
    $: "browsingTopics",
    IMG: 1
  },
  defaultchecked: {
    $: "defaultChecked",
    INPUT: 1
  },
  defaultmuted: {
    $: "defaultMuted",
    AUDIO: 1,
    VIDEO: 1
  },
  defaultselected: {
    $: "defaultSelected",
    OPTION: 1
  },
  disablepictureinpicture: {
    $: "disablePictureInPicture",
    VIDEO: 1
  },
  disableremoteplayback: {
    $: "disableRemotePlayback",
    AUDIO: 1,
    VIDEO: 1
  },
  preservespitch: {
    $: "preservesPitch",
    AUDIO: 1,
    VIDEO: 1
  },
  shadowrootclonable: {
    $: "shadowRootClonable",
    TEMPLATE: 1
  },
  shadowrootdelegatesfocus: {
    $: "shadowRootDelegatesFocus",
    TEMPLATE: 1
  },
  shadowrootserializable: {
    $: "shadowRootSerializable",
    TEMPLATE: 1
  },
  sharedstoragewritable: {
    $: "sharedStorageWritable",
    IFRAME: 1,
    IMG: 1
  }
});
function JP(e, t) {
  const r = YP[e];
  return typeof r == "object" ? r[t] ? r.$ : void 0 : r;
}
const XP = /* @__PURE__ */ new Set(["beforeinput", "click", "dblclick", "contextmenu", "focusin", "focusout", "input", "keydown", "keyup", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "pointerdown", "pointermove", "pointerout", "pointerover", "pointerup", "touchend", "touchmove", "touchstart"]), eN = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), tN = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
}, Ut = (e) => K(() => e());
function rN(e, t, r) {
  let n = r.length, i = t.length, a = n, o = 0, s = 0, l = t[i - 1].nextSibling, d = null;
  for (; o < i || s < a; ) {
    if (t[o] === r[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === r[a - 1]; )
      i--, a--;
    if (i === o) {
      const c = a < n ? s ? r[s - 1].nextSibling : r[a - s] : l;
      for (; s < a; ) e.insertBefore(r[s++], c);
    } else if (a === s)
      for (; o < i; )
        (!d || !d.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === r[a - 1] && r[s] === t[i - 1]) {
      const c = t[--i].nextSibling;
      e.insertBefore(r[s++], t[o++].nextSibling), e.insertBefore(r[--a], c), t[i] = r[a];
    } else {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        let u = s;
        for (; u < a; ) d.set(r[u], u++);
      }
      const c = d.get(t[o]);
      if (c != null)
        if (s < c && c < a) {
          let u = o, h = 1, f;
          for (; ++u < i && u < a && !((f = d.get(t[u])) == null || f !== c + h); )
            h++;
          if (h > c - s) {
            const p = t[o];
            for (; s < c; ) e.insertBefore(r[s++], p);
          } else e.replaceChild(r[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const Iy = "_$DX_DELEGATE";
function k(e, t, r, n) {
  let i;
  const a = () => {
    const s = n ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, r ? s.content.firstChild.firstChild : n ? s.firstChild : s.content.firstChild;
  }, o = t ? () => Qe(() => document.importNode(i || (i = a()), !0)) : () => (i || (i = a())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function an(e, t = window.document) {
  const r = t[Iy] || (t[Iy] = /* @__PURE__ */ new Set());
  for (let n = 0, i = e.length; n < i; n++) {
    const a = e[n];
    r.has(a) || (r.add(a), t.addEventListener(a, lN));
  }
}
function pt(e, t, r) {
  r == null ? e.removeAttribute(t) : e.setAttribute(t, r);
}
function nN(e, t, r, n) {
  n == null ? e.removeAttributeNS(t, r) : e.setAttributeNS(t, r, n);
}
function iN(e, t, r) {
  r ? e.setAttribute(t, "") : e.removeAttribute(t);
}
function ft(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function K1(e, t, r, n) {
  if (n)
    Array.isArray(r) ? (e[`$$${t}`] = r[0], e[`$$${t}Data`] = r[1]) : e[`$$${t}`] = r;
  else if (Array.isArray(r)) {
    const i = r[0];
    e.addEventListener(t, r[0] = (a) => i.call(e, r[1], a));
  } else e.addEventListener(t, r, typeof r != "function" && r);
}
function aN(e, t, r = {}) {
  const n = Object.keys(t || {}), i = Object.keys(r);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || t[s] || (Py(e, s, !1), delete r[s]);
  }
  for (a = 0, o = n.length; a < o; a++) {
    const s = n[a], l = !!t[s];
    !s || s === "undefined" || r[s] === l || !l || (Py(e, s, !0), r[s] = l);
  }
  return r;
}
function zi(e, t, r) {
  if (!t) return r ? pt(e, "style") : t;
  const n = e.style;
  if (typeof t == "string") return n.cssText = t;
  typeof r == "string" && (n.cssText = r = void 0), r || (r = {}), t || (t = {});
  let i, a;
  for (a in r)
    t[a] == null && n.removeProperty(a), delete r[a];
  for (a in t)
    i = t[a], i !== r[a] && (n.setProperty(a, i), r[a] = i);
  return r;
}
function ii(e, t = {}, r, n) {
  const i = {};
  return n || se(() => i.children = ru(e, t.children, i.children)), se(() => typeof t.ref == "function" && Pn(t.ref, e)), se(() => oN(e, t, r, !0, i, !0)), i;
}
function Pn(e, t, r) {
  return Qe(() => e(t, r));
}
function E(e, t, r, n) {
  if (r !== void 0 && !n && (n = []), typeof t != "function") return ru(e, t, n, r);
  se((i) => ru(e, t(), i, r), n);
}
function oN(e, t, r, n, i = {}, a = !1) {
  t || (t = {});
  for (const o in i)
    if (!(o in t)) {
      if (o === "children") continue;
      i[o] = Ny(e, o, null, i[o], r, a, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    i[o] = Ny(e, o, s, i[o], r, a, t);
  }
}
function sN(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, r) => r.toUpperCase());
}
function Py(e, t, r) {
  const n = t.trim().split(/\s+/);
  for (let i = 0, a = n.length; i < a; i++) e.classList.toggle(n[i], r);
}
function Ny(e, t, r, n, i, a, o) {
  let s, l, d, c, u;
  if (t === "style") return zi(e, r, n);
  if (t === "classList") return aN(e, r, n);
  if (r === n) return n;
  if (t === "ref")
    a || r(e);
  else if (t.slice(0, 3) === "on:") {
    const h = t.slice(3);
    n && e.removeEventListener(h, n, typeof n != "function" && n), r && e.addEventListener(h, r, typeof r != "function" && r);
  } else if (t.slice(0, 10) === "oncapture:") {
    const h = t.slice(10);
    n && e.removeEventListener(h, n, !0), r && e.addEventListener(h, r, !0);
  } else if (t.slice(0, 2) === "on") {
    const h = t.slice(2).toLowerCase(), f = XP.has(h);
    if (!f && n) {
      const p = Array.isArray(n) ? n[0] : n;
      e.removeEventListener(h, p);
    }
    (f || r) && (K1(e, h, r, f), f && an([h]));
  } else if (t.slice(0, 5) === "attr:")
    pt(e, t.slice(5), r);
  else if (t.slice(0, 5) === "bool:")
    iN(e, t.slice(5), r);
  else if ((u = t.slice(0, 5) === "prop:") || (d = GP.has(t)) || !i && ((c = JP(t, e.tagName)) || (l = KP.has(t))) || (s = e.nodeName.includes("-") || "is" in o))
    u && (t = t.slice(5), l = !0), t === "class" || t === "className" ? ft(e, r) : s && !l && !d ? e[sN(t)] = r : e[c || t] = r;
  else {
    const h = i && t.indexOf(":") > -1 && tN[t.split(":")[0]];
    h ? nN(e, h, t, r) : pt(e, ZP[t] || t, r);
  }
  return r;
}
function lN(e) {
  let t = e.target;
  const r = `$$${e.type}`, n = e.target, i = e.currentTarget, a = (l) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: l
  }), o = () => {
    const l = t[r];
    if (l && !t.disabled) {
      const d = t[`${r}Data`];
      if (d !== void 0 ? l.call(t, d, e) : l.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && a(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), e.composedPath) {
    const l = e.composedPath();
    a(l[0]);
    for (let d = 0; d < l.length - 2 && (t = l[d], !!o()); d++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === i)
        break;
    }
  } else s();
  a(n);
}
function ru(e, t, r, n, i) {
  for (; typeof r == "function"; ) r = r();
  if (t === r) return r;
  const a = typeof t, o = n !== void 0;
  if (e = o && r[0] && r[0].parentNode || e, a === "string" || a === "number") {
    if (a === "number" && (t = t.toString(), t === r))
      return r;
    if (o) {
      let s = r[0];
      s && s.nodeType === 3 ? s.data !== t && (s.data = t) : s = document.createTextNode(t), r = Gs(e, r, n, s);
    } else
      r !== "" && typeof r == "string" ? r = e.firstChild.data = t : r = e.textContent = t;
  } else if (t == null || a === "boolean")
    r = Gs(e, r, n);
  else {
    if (a === "function")
      return se(() => {
        let s = t();
        for (; typeof s == "function"; ) s = s();
        r = ru(e, s, r, n);
      }), () => r;
    if (Array.isArray(t)) {
      const s = [], l = r && Array.isArray(r);
      if (F5(s, t, r, i))
        return se(() => r = ru(e, s, r, n, !0)), () => r;
      if (s.length === 0) {
        if (r = Gs(e, r, n), o) return r;
      } else l ? r.length === 0 ? Dy(e, s, n) : rN(e, r, s) : (r && Gs(e), Dy(e, s));
      r = s;
    } else if (t.nodeType) {
      if (Array.isArray(r)) {
        if (o) return r = Gs(e, r, n, t);
        Gs(e, r, null, t);
      } else r == null || r === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      r = t;
    }
  }
  return r;
}
function F5(e, t, r, n) {
  let i = !1;
  for (let a = 0, o = t.length; a < o; a++) {
    let s = t[a], l = r && r[e.length], d;
    if (!(s == null || s === !0 || s === !1)) if ((d = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      i = F5(e, s, l) || i;
    else if (d === "function")
      if (n) {
        for (; typeof s == "function"; ) s = s();
        i = F5(e, Array.isArray(s) ? s : [s], Array.isArray(l) ? l : [l]) || i;
      } else
        e.push(s), i = !0;
    else {
      const c = String(s);
      l && l.nodeType === 3 && l.data === c ? e.push(l) : e.push(document.createTextNode(c));
    }
  }
  return i;
}
function Dy(e, t, r = null) {
  for (let n = 0, i = t.length; n < i; n++) e.insertBefore(t[n], r);
}
function Gs(e, t, r, n) {
  if (r === void 0) return e.textContent = "";
  const i = n || document.createTextNode("");
  if (t.length) {
    let a = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const l = s.parentNode === e;
        !a && !o ? l ? e.replaceChild(i, s) : e.insertBefore(i, r) : l && s.remove();
      } else a = !0;
    }
  } else e.insertBefore(i, r);
  return [i];
}
const dN = "http://www.w3.org/2000/svg";
function cN(e, t = !1, r = void 0) {
  return t ? document.createElementNS(dN, e) : document.createElement(e, {
    is: r
  });
}
function uN(e, t) {
  const r = K(e);
  return K(() => {
    const n = r();
    switch (typeof n) {
      case "function":
        return Qe(() => n(t));
      case "string":
        const i = eN.has(n), a = cN(n, i, Qe(() => t.is));
        return ii(a, t, i), a;
    }
  });
}
function j5(e) {
  const [, t] = go(e, ["component"]);
  return uN(() => e.component, t);
}
function hN(e, ...t) {
  const r = e.subscribe(...t);
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
function ca(e) {
  let t;
  return hN(e, (r) => t = r)(), t;
}
class fN extends Error {
  constructor(t, r) {
    super(t), this.name = "FelteSubmitError", this.response = r;
  }
}
function pN(e, t) {
  return Object.keys(e).some((r) => t(e[r]));
}
function Xh(e, t) {
  return Object.keys(e || {}).reduce((r, n) => Object.assign(Object.assign({}, r), { [n]: t(e[n]) }), {});
}
function dt(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Cn(e) {
  return Object.keys(e || {}).reduce((t, r) => Object.assign(Object.assign({}, t), { [r]: dt(e[r]) ? Cn(e[r]) : Array.isArray(e[r]) ? [...e[r]] : e[r] }), {});
}
function mN(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function gN(e) {
  return function(t) {
    if (dt(t)) {
      const r = An(t, e);
      return mN(r, ["key"]);
    }
    return e;
  };
}
function An(e, t) {
  return Xh(e, (r) => dt(r) ? An(r, t) : Array.isArray(r) ? r.map(gN(t)) : t);
}
function ho(...e) {
  const t = e.pop(), r = e.shift();
  if (typeof r == "string")
    return r;
  const n = Cn(r);
  if (e.length === 0)
    return n;
  for (const i of e) {
    if (!i)
      continue;
    if (typeof i == "string")
      return i;
    let a = t(n, i);
    if (typeof a < "u")
      return a;
    const o = Array.from(new Set(Object.keys(n).concat(Object.keys(i))));
    for (const s of o)
      if (a = t(n[s], i[s]), typeof a < "u")
        n[s] = a;
      else if (dt(i[s]) && dt(n[s]))
        n[s] = ho(n[s], i[s], t);
      else if (Array.isArray(i[s]))
        n[s] = i[s].map((l, d) => {
          if (!dt(l))
            return l;
          const c = Array.isArray(n[s]) ? n[s][d] : n[s];
          return ho(c, l, t);
        });
      else if (dt(i[s])) {
        const l = An(Cn(i[s]), void 0);
        n[s] = ho(l, i[s], t);
      } else typeof i[s] < "u" && (n[s] = i[s]);
  }
  return n;
}
function vN(e, t) {
  if (!(dt(e) && dt(t))) {
    if (Array.isArray(t)) {
      if (t.some(dt))
        return;
      const r = Array.isArray(e) ? e : [];
      return t.map((n, i) => {
        var a;
        return (a = r[i]) !== null && a !== void 0 ? a : n;
      });
    }
    if (typeof e < "u")
      return e;
  }
}
function My(...e) {
  return ho(...e, vN);
}
function p$(...e) {
  return ho(...e, () => {
  });
}
function Qi(e, t, r) {
  const n = (a) => String.prototype.split.call(t, a).filter(Boolean).reduce((o, s) => o != null ? o[s] : o, e), i = n(/[,[\]]+?/) || n(/[,[\].]+?/);
  return i === void 0 || i === e ? r : i;
}
function Cd(e, t, r) {
  e && (e = Cn(e)), dt(e) || (e = {});
  const n = Array.isArray(t) ? t : t.match(/[^.[\]]+/g) || [], i = n[n.length - 1];
  if (!i)
    return e;
  let a = e;
  for (let o = 0; o < n.length - 1; o++) {
    const s = n[o];
    if (!a[s] || !dt(a[s]) && !Array.isArray(a[s])) {
      const l = n[o + 1];
      isNaN(Number(l)) ? a[s] = {} : a[s] = [];
    }
    a = a[s];
  }
  return a[i] = r(a[i]), e;
}
function Jt(e, t, r) {
  return Cd(e, t, () => r);
}
function wc(e, t) {
  if (!e || Object(e) !== e)
    return;
  typeof e < "u" && (e = Cn(e));
  const r = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g) || [], n = r.length === 1 ? e : Qi(e, r.slice(0, -1).join("."));
  return Array.isArray(n) ? n.splice(Number(r[r.length - 1]), 1) : n == null || delete n[r[r.length - 1]], e;
}
function nu(e, t) {
  return pN(e, (r) => dt(r) ? nu(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t(r) : r.some((n) => dt(n) ? nu(n, t) : t(n)) : t(r));
}
function Dl(e) {
  return e?.nodeName === "INPUT";
}
function yN(e) {
  return e?.nodeName === "TEXTAREA";
}
function Ml(e) {
  return e?.nodeName === "SELECT";
}
function ef(e) {
  return e?.nodeName === "FIELDSET";
}
function Vr(e) {
  return Dl(e) || yN(e) || Ml(e);
}
function z5(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function Jr(e, t) {
  return Vr(e) ? e.name : "";
}
function z2(e) {
  let t = e;
  for (; t && t.nodeName !== "FORM"; ) {
    if (t.hasAttribute("data-felte-ignore"))
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function Ry(e, t) {
  return !dt(e) || !t ? e : typeof t == "string" ? Qi(e, t) : t(e);
}
function bN(e, t) {
  if (!(dt(e) || dt(t))) {
    if (e === null || e === "")
      return t;
    if (t === null || t === "" || !t)
      return e;
    if (!(!e || !t)) {
      if (Array.isArray(e)) {
        if (!Array.isArray(t))
          return [...e, t];
        const r = [], n = Math.max(t.length, e.length);
        for (let i = 0; i < n; i++) {
          let a = e[i], o = t[i];
          !dt(a) && !dt(o) ? (Array.isArray(a) || (a = [a]), Array.isArray(o) || (o = [o]), r.push(...a, ...o)) : r.push(al([a ?? {}, o ?? {}]));
        }
        return r.filter(Boolean);
      }
      return Array.isArray(t) || (t = [t]), [e, ...t].reduce((r, n) => r.concat(n), []).filter(Boolean);
    }
  }
}
function al(e) {
  return ho(...e, bN);
}
function wN(e, t) {
  return t ? (Array.isArray(t) ? t : [t]).map((r) => r(e)) : [];
}
function V5(e, t) {
  return t ? Array.isArray(t) ? t.reduce((r, n) => n(r), e) : t(e) : e;
}
function m$(e = 8) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function U5(e, t) {
  if (e === t)
    return !0;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((r, n) => U5(r, t[n]));
  if (dt(e) && dt(t)) {
    const r = Object.keys(e), n = Object.keys(t);
    return r.length !== n.length ? !1 : r.every((i) => U5(e[i], t[i]));
  }
  return !1;
}
function G1(e, t, { onInit: r, onEnd: n } = {}) {
  let i;
  return (...a) => {
    i || r?.(), i && clearTimeout(i), i = setTimeout(() => {
      e.apply(this, a), i = void 0, n?.();
    }, t);
  };
}
function q5(e) {
  if (Vr(e))
    return [e];
  if (e.childElementCount === 0)
    return [];
  const t = /* @__PURE__ */ new Set();
  for (const r of e.children) {
    if (Vr(r) && t.add(r), ef(r))
      for (const n of r.elements)
        Vr(n) && t.add(n);
    r.childElementCount > 0 && q5(r).forEach((n) => t.add(n));
  }
  return Array.from(t);
}
function g$(e) {
  for (const t of e.elements)
    !Vr(t) && !ef(t) || e.hasAttribute("data-felte-keep-on-remove") && !t.hasAttribute("data-felte-keep-on-remove") && (t.dataset.felteKeepOnRemove = e.dataset.felteKeepOnRemove);
}
function v$(e) {
  return e.type.match(/^(number|range)$/) ? e.value ? +e.value : null : e.value;
}
function Ly(e) {
  var t;
  let r = {}, n = {};
  for (const i of e.elements) {
    if (ef(i) && g$(i), !Vr(i) || !i.name)
      continue;
    const a = Jr(i);
    if (Dl(i)) {
      if (i.type === "checkbox") {
        if (typeof Qi(r, a) > "u") {
          if (Array.from(e.querySelectorAll(`[name="${i.name}"]`)).filter((s) => Vr(s) ? a === Jr(s) : !1).length === 1) {
            r = Jt(r, a, i.checked), n = Jt(n, a, !1);
            continue;
          }
          r = Jt(r, a, i.checked ? [i.value] : []), n = Jt(n, a, !1);
          continue;
        }
        Array.isArray(Qi(r, a)) && i.checked && (r = Cd(r, a, (s) => [
          ...s,
          i.value
        ]));
        continue;
      }
      if (i.type === "radio") {
        if (Qi(r, a))
          continue;
        r = Jt(r, a, i.checked ? i.value : void 0), n = Jt(n, a, !1);
        continue;
      }
      if (i.type === "file") {
        r = Jt(r, a, i.multiple ? Array.from(i.files || []) : (t = i.files) === null || t === void 0 ? void 0 : t[0]), n = Jt(n, a, !1);
        continue;
      }
    } else if (Ml(i)) {
      if (!i.multiple)
        r = Jt(r, a, i.value);
      else {
        const s = Array.from(i.selectedOptions).map((l) => l.value);
        r = Jt(r, a, s);
      }
      n = Jt(n, a, !1);
      continue;
    }
    const o = v$(i);
    r = Jt(r, a, o), n = Jt(n, a, !1);
  }
  return { defaultData: r, defaultTouched: n };
}
function h1(e, t) {
  var r;
  if (!Vr(e))
    return;
  const n = t;
  if (Dl(e)) {
    if (e.type === "checkbox") {
      const i = n;
      if (typeof i > "u" || typeof i == "boolean") {
        e.checked = !!i;
        return;
      }
      Array.isArray(i) && (i.includes(e.value) ? e.checked = !0 : e.checked = !1);
      return;
    }
    if (e.type === "radio") {
      const i = n;
      e.value === i ? e.checked = !0 : e.checked = !1;
      return;
    }
    if (e.type === "file") {
      if (t instanceof FileList)
        e.files = t;
      else if (t instanceof File && typeof DataTransfer < "u") {
        const i = new DataTransfer();
        i.items.add(t), e.files = i.files;
      } else if (typeof DataTransfer < "u" && Array.isArray(t) && t.some((i) => i instanceof File)) {
        const i = new DataTransfer();
        for (const a of t)
          a instanceof File && i.items.add(a);
        e.files = i.files;
      } else (!t || Array.isArray(t) && !t.length) && (e.files = null, e.value = "");
      return;
    }
  } else if (Ml(e)) {
    if (e.multiple) {
      if (Array.isArray(n)) {
        e.value = String((r = n[0]) !== null && r !== void 0 ? r : "");
        const i = n.map((a) => String(a));
        for (const a of e.options)
          i.includes(a.value) ? a.selected = !0 : a.selected = !1;
      }
    } else {
      e.value = String(n ?? "");
      for (const i of e.options)
        i.value === String(n) ? i.selected = !0 : i.selected = !1;
    }
    return;
  }
  e.value = String(n ?? "");
}
function T0(e, t) {
  for (const r of e.elements) {
    if (ef(r) && g$(r), !Vr(r) || !r.name)
      continue;
    const n = Jr(r);
    h1(r, Qi(t, n));
  }
}
const $N = {
  attributes: !0,
  attributeFilter: ["data-felte-validation-message", "aria-invalid"]
};
function kN(e, t) {
  var r, n;
  let i, a, o, s, l, d;
  typeof e == "string" ? (i = e, a = void 0, o = (r = void 0) !== null && r !== void 0 ? r : !1, d = void 0) : (i = e.name, a = e.defaultValue, o = (n = e.touchOnChange) !== null && n !== void 0 ? n : !1, d = e?.onFormReset);
  function c(y, v) {
    if (!l)
      return;
    y !== "focusout" && h1(l, v);
    const b = new Event(y, {
      bubbles: !0,
      composed: !0
    });
    l.dispatchEvent(b);
  }
  function u(y) {
    y.forEach(() => {
      const v = l.getAttribute("aria-invalid");
      v ? s.setAttribute("aria-invalid", v) : s.removeAttribute("aria-invalid");
      const b = l.getAttribute("data-felte-validation-message");
      b ? s.setAttribute("data-felte-validation-message", b) : s.removeAttribute("data-felte-validation-message");
    });
  }
  function h(y) {
    d && (h1(l, a), d(y));
  }
  function f(y) {
    s = y;
    let v, b;
    if (Vr(y))
      return l = y, l.name = i, {};
    {
      let $ = !1, _ = !1;
      return setTimeout(() => {
        if (_)
          return;
        const x = s.parentNode;
        if (!x || !z5(x))
          return;
        const S = x.querySelector(`[name="${i}"]`);
        if (!S || !Vr(S)) {
          const A = document.createElement("input");
          A.type = "hidden", A.name = i, x.insertBefore(A, y.nextSibling), l = A, $ = !0;
        } else
          l = S;
        h1(l, a), v = new MutationObserver(u), v.observe(l, $N), b = l.closest("form"), b?.addEventListener("reset", h);
      }), {
        destroy() {
          var x;
          $ && ((x = l.parentNode) === null || x === void 0 || x.removeChild(l)), _ = !0, v?.disconnect(), b?.removeEventListener("reset", h);
        }
      };
    }
  }
  function p(y) {
    c(o ? "change" : "input", y);
  }
  function m() {
    c("focusout");
  }
  return {
    field: f,
    onInput: p,
    onChange: p,
    onBlur: m
  };
}
function y$(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function ua(e, t) {
  return Xh(e, (r) => dt(r) ? ua(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t : r.map((n) => {
    const i = ua(n, t);
    return y$(i, ["key"]);
  }) : t);
}
function ks(e) {
  return e ? Xh(e, (t) => dt(t) ? ks(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!dt(r))
      return r;
    const n = ks(r);
    return n.key || (n.key = m$()), n;
  }) : t) : {};
}
function Rl(e) {
  return e ? Xh(e, (t) => dt(t) ? Rl(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!dt(r))
      return r;
    const n = Rl(r);
    return y$(n, ["key"]);
  }) : t) : {};
}
function _N() {
  class e extends CustomEvent {
    constructor(i) {
      super("feltesuccess", { detail: i });
    }
  }
  class t extends CustomEvent {
    constructor(i) {
      super("felteerror", { detail: i, cancelable: !0 });
    }
    setErrors(i) {
      this.preventDefault(), this.errors = i;
    }
  }
  class r extends Event {
    constructor() {
      super("feltesubmit", { cancelable: !0 });
    }
    handleSubmit(i) {
      this.onSubmit = i;
    }
    handleError(i) {
      this.onError = i;
    }
    handleSuccess(i) {
      this.onSuccess = i;
    }
  }
  return {
    createErrorEvent: (n) => new t(n),
    createSubmitEvent: () => new r(),
    createSuccessEvent: (n) => new e(n)
  };
}
function xN(e) {
  if (e)
    return async function() {
      let t = new FormData(e);
      const r = new URL(e.action), n = e.method.toLowerCase() === "get" ? "get" : r.searchParams.get("_method") || e.method;
      let i = e.enctype;
      e.querySelector('input[type="file"]') && (i = "multipart/form-data"), (n === "get" || i === "application/x-www-form-urlencoded") && (t = new URLSearchParams(t));
      let a;
      n === "get" ? (t.forEach((s, l) => {
        r.searchParams.append(l, s);
      }), a = { method: n, headers: { Accept: "application/json" } }) : a = {
        method: n,
        body: t,
        headers: Object.assign(Object.assign({}, i !== "multipart/form-data" && {
          "Content-Type": i
        }), { Accept: "application/json" })
      };
      const o = await window.fetch(r.toString(), a);
      if (o.ok)
        return o;
      throw new fN("An error occurred while submitting the form", o);
    };
}
function O0(e, t, r, n) {
  return Cd(e, t, (i) => (typeof i < "u" && !Array.isArray(i) || (i || (i = []), typeof n > "u" ? i.push(r) : i.splice(n, 0, r)), i));
}
function SN(e, t, r, n) {
  return Cd(e, t, (i) => (!i || !Array.isArray(i) || ([i[r], i[n]] = [i[n], i[r]]), i));
}
function CN(e, t, r, n) {
  return Cd(e, t, (i) => (!i || !Array.isArray(i) || i.splice(n, 0, i.splice(r, 1)[0]), i));
}
function Fy(e) {
  return typeof e == "function";
}
function Ua(e) {
  return (t, r) => {
    if (typeof t == "string") {
      const n = t;
      e((i) => {
        const a = Fy(r) ? r(Qi(i, n)) : r;
        return Jt(i, n, a);
      });
    } else
      e((n) => Fy(t) ? t(n) : t);
  };
}
function EN({ stores: e, config: t, validateErrors: r, validateWarnings: n, _getCurrentExtenders: i }) {
  var a;
  let o, s = ks((a = t.initialValues) !== null && a !== void 0 ? a : {});
  const { data: l, touched: d, errors: c, warnings: u, isDirty: h, isSubmitting: f, interacted: p } = e, m = Ua(l.update), y = Ua(d.update), v = Ua(c.update), b = Ua(u.update);
  function $(Q) {
    m((R) => {
      const re = Q(R);
      return o && T0(o, re), re;
    });
  }
  const _ = (Q, R, re) => {
    Ua($)(Q, R), typeof Q == "string" && re && y(Q, !0);
  };
  function x(Q, R, re) {
    const he = dt(R) ? ua(R, !1) : !1, ge = dt(he) ? An(he, []) : [];
    R = dt(R) ? Object.assign(Object.assign({}, R), { key: m$() }) : R, c.update((ce) => O0(ce, Q, ge, re)), u.update((ce) => O0(ce, Q, ge, re)), d.update((ce) => O0(ce, Q, he, re)), l.update((ce) => {
      const W = O0(ce, Q, R, re);
      return setTimeout(() => o && T0(o, W)), W;
    });
  }
  function S(Q) {
    c.update(Q), u.update(Q), d.update(Q), l.update((R) => {
      const re = Q(R);
      return setTimeout(() => o && T0(o, re)), re;
    });
  }
  function A(Q) {
    S((R) => wc(R, Q));
  }
  function N(Q, R, re) {
    S((he) => SN(he, Q, R, re));
  }
  function P(Q, R, re) {
    S((he) => CN(he, Q, R, re));
  }
  function D(Q) {
    const R = Qi(s, Q), re = dt(R) ? ua(R, !1) : !1, he = dt(re) ? An(re, []) : [];
    l.update((ge) => {
      const ce = Jt(ge, Q, R);
      return o && T0(o, ce), ce;
    }), d.update((ge) => Jt(ge, Q, re)), c.update((ge) => Jt(ge, Q, he)), u.update((ge) => Jt(ge, Q, he));
  }
  const T = Ua(f.update), I = Ua(h.update), j = Ua(p.update);
  async function F() {
    const Q = ca(l);
    d.set(ua(Q, !0)), p.set(null);
    const R = await r(Q);
    return await n(Q), R;
  }
  function Z() {
    _(Cn(s)), y((Q) => An(Q, !1)), p.set(null), h.set(!1);
  }
  function te(Q) {
    return async function(R) {
      var re, he, ge, ce, W, oe, le;
      const { createErrorEvent: Fe, createSubmitEvent: We, createSuccessEvent: St } = _N(), bt = We();
      o?.dispatchEvent(bt);
      const Ct = (he = (re = bt.onError) !== null && re !== void 0 ? re : Q?.onError) !== null && he !== void 0 ? he : t.onError, _t = (ce = (ge = bt.onSuccess) !== null && ge !== void 0 ? ge : Q?.onSuccess) !== null && ce !== void 0 ? ce : t.onSuccess, G = (le = (oe = (W = bt.onSubmit) !== null && W !== void 0 ? W : Q?.onSubmit) !== null && oe !== void 0 ? oe : t.onSubmit) !== null && le !== void 0 ? le : xN(o);
      if (!G || (R?.preventDefault(), bt.defaultPrevented))
        return;
      f.set(!0), p.set(null);
      const M = Rl(ca(l)), ue = await r(M, Q?.validate), ie = await n(M, Q?.warn);
      if (ie && u.set(p$(An(M, []), ie)), d.set(ua(M, !0)), ue && (d.set(ua(ue, !0)), nu(ue, (je) => Array.isArray(je) ? je.length >= 1 : !!je))) {
        await new Promise((je) => setTimeout(je)), i().forEach((je) => {
          var He;
          return (He = je.onSubmitError) === null || He === void 0 ? void 0 : He.call(je, {
            data: M,
            errors: ue
          });
        }), f.set(!1);
        return;
      }
      const De = {
        event: R,
        setFields: _,
        setData: m,
        setTouched: y,
        setErrors: v,
        setWarnings: b,
        unsetField: A,
        addField: x,
        resetField: D,
        reset: Z,
        setInitialValues: Y.setInitialValues,
        moveField: P,
        swapFields: N,
        form: o,
        controls: o && Array.from(o.elements).filter(Vr),
        config: Object.assign(Object.assign({}, t), Q)
      };
      try {
        const je = await G(M, De);
        o?.dispatchEvent(St(Object.assign({ response: je }, De))), await _t?.(je, De);
      } catch (je) {
        const He = Fe(Object.assign({ error: je }, De));
        if (o?.dispatchEvent(He), !Ct && !He.defaultPrevented)
          throw je;
        if (!Ct && !He.errors)
          return;
        const _e = He.errors || await Ct?.(je, De);
        _e && (d.set(ua(_e, !0)), c.set(_e), await new Promise((ot) => setTimeout(ot)), i().forEach((ot) => {
          var Nt;
          return (Nt = ot.onSubmitError) === null || Nt === void 0 ? void 0 : Nt.call(ot, {
            data: M,
            errors: ca(c)
          });
        }));
      } finally {
        f.set(!1);
      }
    };
  }
  const Y = {
    setData: m,
    setFields: _,
    setTouched: y,
    setErrors: v,
    setWarnings: b,
    setIsSubmitting: T,
    setIsDirty: I,
    setInteracted: j,
    validate: F,
    reset: Z,
    unsetField: A,
    resetField: D,
    addField: x,
    swapFields: N,
    moveField: P,
    createSubmitHandler: te,
    handleSubmit: te(),
    setInitialValues: (Q) => {
      s = ks(Q);
    }
  };
  return {
    public: Y,
    private: {
      _setFormNode(Q) {
        o = Q;
      },
      _getInitialValues: () => s
    }
  };
}
function AN({ helpers: e, stores: t, config: r, extender: n, createSubmitHandler: i, handleSubmit: a, _setFormNode: o, _getInitialValues: s, _setCurrentExtenders: l, _getCurrentExtenders: d }) {
  const { setFields: c, setTouched: u, reset: h, setInitialValues: f } = e, { addValidator: p, addTransformer: m, validate: y } = e, { data: v, errors: b, warnings: $, touched: _, isSubmitting: x, isDirty: S, interacted: A, isValid: N, isValidating: P } = t;
  function D(T) {
    T.requestSubmit || (T.requestSubmit = a);
    function I(G) {
      return function(M) {
        return M({
          form: T,
          stage: G,
          controls: Array.from(T.elements).filter(Vr),
          data: v,
          errors: b,
          warnings: $,
          touched: _,
          isValid: N,
          isValidating: P,
          isSubmitting: x,
          isDirty: S,
          interacted: A,
          config: r,
          addValidator: p,
          addTransformer: m,
          setFields: c,
          validate: y,
          reset: h,
          createSubmitHandler: i,
          handleSubmit: a
        });
      };
    }
    l(n.map(I("MOUNT"))), T.noValidate = !!r.validate;
    const { defaultData: j, defaultTouched: F } = Ly(T);
    o(T), f(p$(Cn(j), s())), c(s()), _.set(F);
    function Z(G) {
      const M = Jr(G), ue = Array.from(T.querySelectorAll(`[name="${G.name}"]`)).filter((ie) => Vr(ie) ? M === Jr(ie) : !1);
      if (ue.length !== 0)
        return ue.length === 1 ? v.update((ie) => Jt(ie, Jr(G), G.checked)) : v.update((ie) => Jt(ie, Jr(G), ue.filter(Dl).filter((De) => De.checked).map((De) => De.value)));
    }
    function te(G) {
      const M = T.querySelectorAll(`[name="${G.name}"]`), ue = Array.from(M).find((ie) => Dl(ie) && ie.checked);
      v.update((ie) => Jt(ie, Jr(G), ue?.value));
    }
    function Y(G) {
      var M;
      const ue = Array.from((M = G.files) !== null && M !== void 0 ? M : []);
      v.update((ie) => Jt(ie, Jr(G), G.multiple ? ue : ue[0]));
    }
    function Q(G) {
      if (!G.multiple)
        v.update((M) => Jt(M, Jr(G), G.value));
      else {
        const M = Array.from(G.selectedOptions).map((ue) => ue.value);
        v.update((ue) => Jt(ue, Jr(G), M));
      }
    }
    function R(G) {
      const M = G.target;
      if (!M || !Vr(M) || Ml(M) || z2(M) || ["checkbox", "radio", "file"].includes(M.type) || !M.name)
        return;
      S.set(!0);
      const ue = v$(M);
      A.set(M.name), v.update((ie) => Jt(ie, Jr(M), ue));
    }
    function re(G) {
      const M = G.target;
      if (!(!M || !Vr(M) || z2(M)) && M.name)
        if (u(Jr(M), !0), A.set(M.name), (Ml(M) || ["checkbox", "radio", "file", "hidden"].includes(M.type)) && S.set(!0), M.type === "hidden" && v.update((ue) => Jt(ue, Jr(M), M.value)), Ml(M))
          Q(M);
        else if (Dl(M))
          M.type === "checkbox" ? Z(M) : M.type === "radio" ? te(M) : M.type === "file" && Y(M);
        else return;
    }
    function he(G) {
      const M = G.target;
      !M || !Vr(M) || z2(M) || M.name && (u(Jr(M), !0), A.set(M.name));
    }
    function ge(G) {
      G.preventDefault(), h();
    }
    const ce = { childList: !0, subtree: !0 };
    function W(G) {
      let M = ca(v), ue = ca(_), ie = ca(b), De = ca($);
      for (const je of G.reverse()) {
        if (je.hasAttribute("data-felte-keep-on-remove") && je.dataset.felteKeepOnRemove !== "false")
          continue;
        const He = /.*(\[[0-9]+\]|\.[0-9]+)\.[^.]+$/;
        let _e = Jr(je);
        const ot = ca(_);
        if (He.test(_e)) {
          const Nt = _e.split(".").slice(0, -1).join("."), ir = Qi(ot, Nt);
          dt(ir) && Object.keys(ir).length <= 1 && (_e = Nt);
        }
        M = wc(M, _e), ue = wc(ue, _e), ie = wc(ie, _e), De = wc(De, _e);
      }
      v.set(M), _.set(ue), b.set(ie), $.set(De);
    }
    const oe = G1(() => {
      d().forEach((ue) => {
        var ie;
        return (ie = ue.destroy) === null || ie === void 0 ? void 0 : ie.call(ue);
      }), l(n.map(I("UPDATE")));
      const { defaultData: G, defaultTouched: M } = Ly(T);
      v.update((ue) => My(ue, G)), _.update((ue) => My(ue, M)), e.setFields(ca(v));
    }, 0);
    let le = [];
    const Fe = G1(() => {
      d().forEach((G) => {
        var M;
        return (M = G.destroy) === null || M === void 0 ? void 0 : M.call(G);
      }), l(n.map(I("UPDATE"))), W(le), le = [];
    }, 0);
    function We(G) {
      Array.from(G.addedNodes).some((M) => z5(M) ? Vr(M) ? !0 : q5(M).length > 0 : !1) && oe();
    }
    function St(G) {
      for (const M of G.removedNodes) {
        if (!z5(M))
          continue;
        const ue = q5(M);
        ue.length !== 0 && (le.push(...ue), Fe());
      }
    }
    function bt(G) {
      for (const M of G)
        M.type === "childList" && (M.addedNodes.length > 0 && We(M), M.removedNodes.length > 0 && St(M));
    }
    const Ct = new MutationObserver(bt);
    Ct.observe(T, ce), T.addEventListener("input", R), T.addEventListener("change", re), T.addEventListener("focusout", he), T.addEventListener("submit", a), T.addEventListener("reset", ge);
    const _t = b.subscribe((G) => {
      for (const M of T.elements) {
        if (!Vr(M) || !M.name)
          continue;
        const ue = Qi(G, Jr(M)), ie = Array.isArray(ue) ? ue.join(`
`) : typeof ue == "string" ? ue : void 0;
        ie !== M.dataset.felteValidationMessage && (ie ? (M.dataset.felteValidationMessage = ie, M.setAttribute("aria-invalid", "true")) : (delete M.dataset.felteValidationMessage, M.removeAttribute("aria-invalid")));
      }
    });
    return {
      destroy() {
        Ct.disconnect(), T.removeEventListener("input", R), T.removeEventListener("change", re), T.removeEventListener("focusout", he), T.removeEventListener("submit", a), T.removeEventListener("reset", ge), _t(), d().forEach((G) => {
          var M;
          return (M = G.destroy) === null || M === void 0 ? void 0 : M.call(G);
        });
      }
    };
  }
  return { form: D };
}
function TN(e) {
  const t = { aborted: !1, priority: e };
  return {
    signal: t,
    abort() {
      t.aborted = !0;
    }
  };
}
function ON(e, t) {
  if (dt(e))
    return !t || dt(t) && Object.keys(t).length === 0 ? An(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(dt))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : n && a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? e ? t : null : e && t ? [t] : null;
}
function IN(e, t) {
  if (dt(e))
    return !t || dt(t) && Object.keys(t).length === 0 ? An(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(dt))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? t : t ? [t] : null;
}
function PN([e, t]) {
  return ho(t, e, ON);
}
function NN([e, t]) {
  return ho(t, e, IN);
}
function DN(e) {
  return function(t, r, n) {
    const i = Array.isArray(t) ? t : [t], a = new Array(i.length), o = e(n), s = o.set, l = o.subscribe;
    let d;
    function c() {
      d = i.map((h, f) => h.subscribe((p) => {
        a[f] = p, s(r(a));
      }));
    }
    function u() {
      d?.forEach((h) => h());
    }
    return o.subscribe = function(h) {
      const f = l(h);
      return () => {
        f();
      };
    }, [o, c, u];
  };
}
function MN(e, t) {
  var r, n, i, a, o, s, l, d, c;
  const u = DN(e), h = t.initialValues = t.initialValues ? ks(V5(Cn(t.initialValues), t.transform)) : {}, f = ua(Rl(h), !1), p = e(f), m = e(0), [y, v, b] = u([p, m], ([ze, Be]) => nu(ze, (lt) => !!lt) && Be >= 1, !1);
  delete y.set, delete y.update;
  function $(ze) {
    let Be;
    return async function(lt, Qt, Cr, ar = !1) {
      if (!Cr || !lt)
        return;
      let $r = Qt && Object.keys(Qt).length > 0 ? Qt : An(lt, []);
      const Br = TN(ar);
      if ((!Be?.signal.priority || ar) && (Be?.abort(), Be = Br), Be.signal.priority && !ar)
        return;
      m.update((ln) => ln + 1);
      const pr = wN(Rl(lt), Cr);
      return pr.forEach(async (ln) => {
        const xn = await ln;
        Br.signal.aborted || ($r = al([$r, xn]), ze.set($r));
      }), await Promise.all(pr), Be = void 0, m.update((ln) => ln - 1), $r;
    };
  }
  let _ = An(f, []);
  const x = e(h), S = An(f, []), A = e(S), N = e(Cn(S)), [P, D, T] = u([
    A,
    N
  ], al, Cn(S)), I = An(f, []), j = e(I), F = e(Cn(I)), [Z, te, Y] = u([
    j,
    F
  ], al, Cn(I)), [Q, R, re] = u([P, p], PN, Cn(S)), [he, ge, ce] = u([Z, p], NN, Cn(I));
  let W = !1;
  const [oe, le, Fe] = u(P, ([ze]) => {
    var Be;
    return W ? !nu(ze, (lt) => Array.isArray(lt) ? lt.length >= 1 : !!lt) : (W = !0, !t.validate && !(!((Be = t.debounced) === null || Be === void 0) && Be.validate));
  }, !t.validate && !(!((r = t.debounced) === null || r === void 0) && r.validate));
  delete oe.set, delete oe.update;
  const We = e(!1), St = e(!1), bt = e(null), Ct = $(A), _t = $(j), G = $(N), M = $(F), ue = G1(G, (o = (i = (n = t.debounced) === null || n === void 0 ? void 0 : n.validateTimeout) !== null && i !== void 0 ? i : (a = t.debounced) === null || a === void 0 ? void 0 : a.timeout) !== null && o !== void 0 ? o : 300, {
    onInit: () => {
      m.update((ze) => ze + 1);
    },
    onEnd: () => {
      m.update((ze) => ze - 1);
    }
  }), ie = G1(M, (c = (l = (s = t.debounced) === null || s === void 0 ? void 0 : s.warnTimeout) !== null && l !== void 0 ? l : (d = t.debounced) === null || d === void 0 ? void 0 : d.timeout) !== null && c !== void 0 ? c : 300);
  async function De(ze, Be) {
    var lt;
    const Qt = Ct(ze, _, Be ?? t.validate, !0);
    if (Be)
      return Qt;
    const Cr = G(ze, _, (lt = t.debounced) === null || lt === void 0 ? void 0 : lt.validate, !0);
    return al(await Promise.all([Qt, Cr]));
  }
  async function je(ze, Be) {
    var lt;
    const Qt = _t(ze, _, Be ?? t.warn, !0);
    if (Be)
      return Qt;
    const Cr = M(ze, _, (lt = t.debounced) === null || lt === void 0 ? void 0 : lt.warn, !0);
    return al(await Promise.all([Qt, Cr]));
  }
  let He = S, _e = I;
  function ot() {
    const ze = x.subscribe((ar) => {
      var $r, Br;
      const pr = Rl(ar);
      Ct(pr, _, t.validate), _t(pr, _, t.warn), ue(pr, _, ($r = t.debounced) === null || $r === void 0 ? void 0 : $r.validate), ie(pr, _, (Br = t.debounced) === null || Br === void 0 ? void 0 : Br.warn);
    }), Be = p.subscribe((ar) => {
      _ = An(ar, []);
    }), lt = P.subscribe((ar) => {
      He = ar;
    }), Qt = Z.subscribe((ar) => {
      _e = ar;
    });
    D(), le(), te(), R(), ge(), v();
    function Cr() {
      ze(), re(), T(), Y(), ce(), Fe(), b(), Be(), lt(), Qt();
    }
    return Cr;
  }
  function Nt(ze) {
    A.set(ze(He)), N.set({});
  }
  function ir(ze) {
    j.set(ze(_e)), F.set({});
  }
  function dr(ze) {
    Nt(() => ze);
  }
  function La(ze) {
    ir(() => ze);
  }
  return Q.set = dr, Q.update = Nt, he.set = La, he.update = ir, {
    data: x,
    errors: Q,
    warnings: he,
    touched: p,
    isValid: oe,
    isSubmitting: We,
    isDirty: St,
    isValidating: y,
    interacted: bt,
    validateErrors: De,
    validateWarnings: je,
    cleanup: t.preventStoreStart ? () => {
    } : ot(),
    start: ot
  };
}
function RN(e, t) {
  var r, n;
  (r = e.extend) !== null && r !== void 0 || (e.extend = []), (n = e.debounced) !== null && n !== void 0 || (e.debounced = {}), e.validate && !Array.isArray(e.validate) && (e.validate = [e.validate]), e.debounced.validate && !Array.isArray(e.debounced.validate) && (e.debounced.validate = [e.debounced.validate]), e.transform && !Array.isArray(e.transform) && (e.transform = [e.transform]), e.warn && !Array.isArray(e.warn) && (e.warn = [e.warn]), e.debounced.warn && !Array.isArray(e.debounced.warn) && (e.debounced.warn = [e.debounced.warn]);
  function i(te, { debounced: Y, level: Q } = {
    debounced: !1,
    level: "error"
  }) {
    var R;
    const re = Q === "error" ? "validate" : "warn";
    (R = e.debounced) !== null && R !== void 0 || (e.debounced = {});
    const he = Y ? e.debounced : e;
    he[re] ? he[re] = [
      ...he[re],
      te
    ] : he[re] = [te];
  }
  function a(te) {
    e.transform ? e.transform = [
      ...e.transform,
      te
    ] : e.transform = [te];
  }
  const o = Array.isArray(e.extend) ? e.extend : [e.extend];
  let s = [];
  const l = () => s, d = (te) => {
    s = te;
  }, { isSubmitting: c, isValidating: u, data: h, errors: f, warnings: p, touched: m, isValid: y, isDirty: v, cleanup: b, start: $, validateErrors: _, validateWarnings: x, interacted: S } = MN(t.storeFactory, e), A = h.update, N = h.set, P = (te) => A((Y) => ks(V5(te(Y), e.transform))), D = (te) => N(ks(V5(te, e.transform)));
  h.update = P, h.set = D;
  const T = EN({
    config: e,
    validateErrors: _,
    validateWarnings: x,
    _getCurrentExtenders: l,
    stores: {
      data: h,
      errors: f,
      warnings: p,
      touched: m,
      isSubmitting: c,
      isDirty: v,
      interacted: S
    }
  }), { createSubmitHandler: I, handleSubmit: j } = T.public;
  s = o.map((te) => te({
    stage: "SETUP",
    errors: f,
    warnings: p,
    touched: m,
    data: h,
    isDirty: v,
    isValid: y,
    isValidating: u,
    isSubmitting: c,
    interacted: S,
    config: e,
    addValidator: i,
    addTransformer: a,
    setFields: T.public.setFields,
    reset: T.public.reset,
    validate: T.public.validate,
    handleSubmit: j,
    createSubmitHandler: I
  }));
  const F = Object.assign({
    config: e,
    stores: {
      data: h,
      touched: m,
      errors: f,
      warnings: p,
      isSubmitting: c,
      isValidating: u,
      isValid: y,
      isDirty: v,
      interacted: S
    },
    createSubmitHandler: I,
    handleSubmit: j,
    helpers: Object.assign(Object.assign({}, T.public), {
      addTransformer: a,
      addValidator: i
    }),
    extender: o,
    _getCurrentExtenders: l,
    _setCurrentExtenders: d
  }, T.private), { form: Z } = AN(F);
  return Object.assign({
    data: h,
    errors: f,
    warnings: p,
    touched: m,
    isValid: y,
    isSubmitting: c,
    isValidating: u,
    isDirty: v,
    interacted: S,
    form: Z,
    cleanup: b,
    startStores: $
  }, T.public);
}
function LN(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function FN(e) {
  const t = {}, r = {};
  function n(i) {
    if (!i)
      return e();
    if (!t[i.toString()]) {
      const o = V(Ry(Qe(e), i));
      r[i.toString()] = o, t[i.toString()] = i;
    }
    const [a] = r[i.toString()];
    return a();
  }
  return fe(() => {
    const i = e(), a = Object.keys(t);
    for (const o of a) {
      const s = t[o], l = Ry(i, s), [d, c] = r[s.toString()];
      U5(l, Qe(d)) || c(l);
    }
  }), n;
}
function jN(e) {
  return function(t) {
    return so((r) => (fe(() => t(e())), r));
  };
}
const zN = (e) => {
  const [t, r] = V(e);
  function n(s) {
    r(() => s);
  }
  function i(s) {
    r(s);
  }
  const a = FN(t), o = jN(t);
  return a.subscribe = o, a.set = n, a.update = i, a;
};
function b$(e) {
  const t = RN(e ?? {}, {
    storeFactory: zN
  }), { form: r, cleanup: n, startStores: i, data: a, errors: o, warnings: s, touched: l } = t, d = LN(t, ["form", "cleanup", "startStores", "data", "errors", "warnings", "touched"]);
  let c = null;
  const u = () => c?.(), [h, f] = V(null);
  fe(() => {
    const m = h();
    m && (u(), c = r(m).destroy);
  });
  const p = (m) => (f(m), {
    destroy: u
  });
  return sr(u), sr(n), Object.assign(Object.assign({}, d), { data: a, errors: o, warnings: s, touched: l, form: p });
}
function VN(e, t) {
  const { field: r, onChange: n, onInput: i, onBlur: a } = kN(e);
  function o(s) {
    const { destroy: l } = r(s);
    return sr(() => l?.()), { destroy: l };
  }
  return {
    field: o,
    onChange: n,
    onInput: i,
    onBlur: a
  };
}
function UN(e) {
  function t(r) {
    return r.issues.reduce((n, i) => i.path ? Cd(n, i.path.join("."), (a) => !a || !Array.isArray(a) ? [i.message] : [...a, i.message]) : n, {});
  }
  return async function(r) {
    try {
      await e.parseAsync(r);
    } catch (n) {
      return t(n);
    }
  };
}
function w$({ schema: e, level: t = "error" }) {
  return function(r) {
    if (r.stage !== "SETUP")
      return {};
    const n = UN(e);
    return r.addValidator(n, { level: t }), {};
  };
}
var Mt;
(function(e) {
  e.assertEqual = (i) => {
  };
  function t(i) {
  }
  e.assertIs = t;
  function r(i) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, e.getValidEnumValues = (i) => {
    const a = e.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(a) {
    return i[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, e.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && Number.isFinite(i) && Math.floor(i) === i;
  function n(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(Mt || (Mt = {}));
var jy;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(jy || (jy = {}));
const Pe = Mt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ya = (e) => {
  switch (typeof e) {
    case "undefined":
      return Pe.undefined;
    case "string":
      return Pe.string;
    case "number":
      return Number.isNaN(e) ? Pe.nan : Pe.number;
    case "boolean":
      return Pe.boolean;
    case "function":
      return Pe.function;
    case "bigint":
      return Pe.bigint;
    case "symbol":
      return Pe.symbol;
    case "object":
      return Array.isArray(e) ? Pe.array : e === null ? Pe.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Pe.promise : typeof Map < "u" && e instanceof Map ? Pe.map : typeof Set < "u" && e instanceof Set ? Pe.set : typeof Date < "u" && e instanceof Date ? Pe.date : Pe.object;
    default:
      return Pe.unknown;
  }
}, pe = Mt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Ea extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(a) {
      return a.message;
    }, n = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const d = o.path[l];
            l === o.path.length - 1 ? (s[d] = s[d] || { _errors: [] }, s[d]._errors.push(r(o))) : s[d] = s[d] || { _errors: [] }, s = s[d], l++;
          }
        }
    };
    return i(this), n;
  }
  static assert(t) {
    if (!(t instanceof Ea))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Mt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      if (i.path.length > 0) {
        const a = i.path[0];
        r[a] = r[a] || [], r[a].push(t(i));
      } else
        n.push(t(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ea.create = (e) => new Ea(e);
const B5 = (e, t) => {
  let r;
  switch (e.code) {
    case pe.invalid_type:
      e.received === Pe.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case pe.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, Mt.jsonStringifyReplacer)}`;
      break;
    case pe.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Mt.joinValues(e.keys, ", ")}`;
      break;
    case pe.invalid_union:
      r = "Invalid input";
      break;
    case pe.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Mt.joinValues(e.options)}`;
      break;
    case pe.invalid_enum_value:
      r = `Invalid enum value. Expected ${Mt.joinValues(e.options)}, received '${e.received}'`;
      break;
    case pe.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case pe.invalid_return_type:
      r = "Invalid function return type";
      break;
    case pe.invalid_date:
      r = "Invalid date";
      break;
    case pe.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : Mt.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case pe.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case pe.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case pe.custom:
      r = "Invalid input";
      break;
    case pe.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case pe.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case pe.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, Mt.assertNever(e);
  }
  return { message: r };
};
let qN = B5;
function BN() {
  return qN;
}
const HN = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: i } = e, a = [...r, ...i.path || []], o = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let s = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    s = d(o, { data: t, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: s
  };
};
function Se(e, t) {
  const r = BN(), n = HN({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === B5 ? void 0 : B5
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(n);
}
class Hn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return nt;
      i.status === "dirty" && t.dirty(), n.push(i.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const i of r) {
      const a = await i.key, o = await i.value;
      n.push({
        key: a,
        value: o
      });
    }
    return Hn.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const i of r) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return nt;
      a.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (n[a.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const nt = Object.freeze({
  status: "aborted"
}), H5 = (e) => ({ status: "dirty", value: e }), ai = (e) => ({ status: "valid", value: e }), zy = (e) => e.status === "aborted", Vy = (e) => e.status === "dirty", Xl = (e) => e.status === "valid", Z1 = (e) => typeof Promise < "u" && e instanceof Promise;
var Me;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(Me || (Me = {}));
class ko {
  constructor(t, r, n, i) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Uy = (e, t) => {
  if (Xl(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Ea(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function ut(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: i } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (a, o) => {
    const { message: s } = e;
    return a.code === "invalid_enum_value" ? { message: s ?? o.defaultError } : typeof o.data > "u" ? { message: s ?? n ?? o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: s ?? r ?? o.defaultError };
  }, description: i };
}
class Tt {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Ya(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Ya(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Hn(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Ya(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Z1(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: r?.async ?? !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ya(t)
    }, i = this._parseSync({ data: t, path: n.path, parent: n });
    return Uy(n, i);
  }
  "~validate"(t) {
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ya(t)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: t, path: [], parent: r });
        return Xl(n) ? {
          value: n.value
        } : {
          issues: r.common.issues
        };
      } catch (n) {
        n?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((n) => Xl(n) ? {
      value: n.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ya(t)
    }, i = this._parse({ data: t, path: n.path, parent: n }), a = await (Z1(i) ? i : Promise.resolve(i));
    return Uy(n, a);
  }
  refine(t, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, a) => {
      const o = t(i), s = () => a.addIssue({
        code: pe.custom,
        ...n(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, i) => t(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(t) {
    return new td({
      schema: this,
      typeName: tt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return fo.create(this, this._def);
  }
  nullable() {
    return rd.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ki.create(this);
  }
  promise() {
    return eh.create(this, this._def);
  }
  or(t) {
    return J1.create([this, t], this._def);
  }
  and(t) {
    return X1.create(this, t, this._def);
  }
  transform(t) {
    return new td({
      ...ut(this._def),
      schema: this,
      typeName: tt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Q5({
      ...ut(this._def),
      innerType: this,
      defaultValue: r,
      typeName: tt.ZodDefault
    });
  }
  brand() {
    return new pD({
      typeName: tt.ZodBranded,
      type: this,
      ...ut(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new K5({
      ...ut(this._def),
      innerType: this,
      catchValue: r,
      typeName: tt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return e3.create(this, t);
  }
  readonly() {
    return G5.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const WN = /^c[^\s-]{8,}$/i, QN = /^[0-9a-z]+$/, KN = /^[0-9A-HJKMNP-TV-Z]{26}$/i, GN = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ZN = /^[a-z0-9_-]{21}$/i, YN = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, JN = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, XN = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, eD = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let V2;
const tD = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, rD = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, nD = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, iD = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, aD = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, oD = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, $$ = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", sD = new RegExp(`^${$$}$`);
function k$(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function lD(e) {
  return new RegExp(`^${k$(e)}$`);
}
function dD(e) {
  let t = `${$$}T${k$(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function cD(e, t) {
  return !!((t === "v4" || !t) && tD.test(e) || (t === "v6" || !t) && nD.test(e));
}
function uD(e, t) {
  if (!YN.test(e))
    return !1;
  try {
    const [r] = e.split(".");
    if (!r)
      return !1;
    const n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), i = JSON.parse(atob(n));
    return !(typeof i != "object" || i === null || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
  } catch {
    return !1;
  }
}
function hD(e, t) {
  return !!((t === "v4" || !t) && rD.test(e) || (t === "v6" || !t) && iD.test(e));
}
class oo extends Tt {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Pe.string) {
      const i = this._getOrReturnCtx(t);
      return Se(i, {
        code: pe.invalid_type,
        expected: Pe.string,
        received: i.parsedType
      }), nt;
    }
    const r = new Hn();
    let n;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (n = this._getOrReturnCtx(t, n), Se(n, {
          code: pe.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (n = this._getOrReturnCtx(t, n), Se(n, {
          code: pe.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const a = t.data.length > i.value, o = t.data.length < i.value;
        (a || o) && (n = this._getOrReturnCtx(t, n), a ? Se(n, {
          code: pe.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && Se(n, {
          code: pe.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        XN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "email",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        V2 || (V2 = new RegExp(eD, "u")), V2.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "emoji",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        GN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "uuid",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "nanoid")
        ZN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "nanoid",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        WN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "cuid",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        QN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "cuid2",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        KN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
          validation: "ulid",
          code: pe.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          n = this._getOrReturnCtx(t, n), Se(n, {
            validation: "url",
            code: pe.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "regex",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), r.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "datetime" ? dD(i).test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.invalid_string,
        validation: "datetime",
        message: i.message
      }), r.dirty()) : i.kind === "date" ? sD.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.invalid_string,
        validation: "date",
        message: i.message
      }), r.dirty()) : i.kind === "time" ? lD(i).test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.invalid_string,
        validation: "time",
        message: i.message
      }), r.dirty()) : i.kind === "duration" ? JN.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "duration",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "ip" ? cD(t.data, i.version) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "ip",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "jwt" ? uD(t.data, i.alg) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "jwt",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "cidr" ? hD(t.data, i.version) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "cidr",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64" ? aD.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "base64",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64url" ? oD.test(t.data) || (n = this._getOrReturnCtx(t, n), Se(n, {
        validation: "base64url",
        code: pe.invalid_string,
        message: i.message
      }), r.dirty()) : Mt.assertNever(i);
    return { status: r.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((i) => t.test(i), {
      validation: r,
      code: pe.invalid_string,
      ...Me.errToObj(n)
    });
  }
  _addCheck(t) {
    return new oo({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Me.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Me.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Me.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Me.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Me.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Me.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Me.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Me.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Me.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Me.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Me.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Me.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Me.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: t?.offset ?? !1,
      local: t?.local ?? !1,
      ...Me.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...Me.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Me.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Me.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r?.position,
      ...Me.errToObj(r?.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Me.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Me.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Me.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Me.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Me.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Me.errToObj(t));
  }
  trim() {
    return new oo({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new oo({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new oo({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
oo.create = (e) => new oo({
  checks: [],
  typeName: tt.ZodString,
  coerce: e?.coerce ?? !1,
  ...ut(e)
});
function fD(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, i = r > n ? r : n, a = Number.parseInt(e.toFixed(i).replace(".", "")), o = Number.parseInt(t.toFixed(i).replace(".", ""));
  return a % o / 10 ** i;
}
class iu extends Tt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Pe.number) {
      const i = this._getOrReturnCtx(t);
      return Se(i, {
        code: pe.invalid_type,
        expected: Pe.number,
        received: i.parsedType
      }), nt;
    }
    let r;
    const n = new Hn();
    for (const i of this._def.checks)
      i.kind === "int" ? Mt.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), n.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? fD(t.data, i.value) !== 0 && (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.not_finite,
        message: i.message
      }), n.dirty()) : Mt.assertNever(i);
    return { status: n.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Me.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Me.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Me.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Me.toString(r));
  }
  setLimit(t, r, n, i) {
    return new iu({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Me.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new iu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Me.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Me.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Me.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Me.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Me.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Me.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Me.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Me.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Me.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Mt.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
iu.create = (e) => new iu({
  checks: [],
  typeName: tt.ZodNumber,
  coerce: e?.coerce || !1,
  ...ut(e)
});
class au extends Tt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Pe.bigint)
      return this._getInvalidInput(t);
    let r;
    const n = new Hn();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), Se(r, {
        code: pe.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : Mt.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return Se(r, {
      code: pe.invalid_type,
      expected: Pe.bigint,
      received: r.parsedType
    }), nt;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Me.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Me.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Me.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Me.toString(r));
  }
  setLimit(t, r, n, i) {
    return new au({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Me.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new au({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Me.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Me.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Me.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Me.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Me.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
au.create = (e) => new au({
  checks: [],
  typeName: tt.ZodBigInt,
  coerce: e?.coerce ?? !1,
  ...ut(e)
});
class qy extends Tt {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Pe.boolean) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.boolean,
        received: r.parsedType
      }), nt;
    }
    return ai(t.data);
  }
}
qy.create = (e) => new qy({
  typeName: tt.ZodBoolean,
  coerce: e?.coerce || !1,
  ...ut(e)
});
class Y1 extends Tt {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Pe.date) {
      const i = this._getOrReturnCtx(t);
      return Se(i, {
        code: pe.invalid_type,
        expected: Pe.date,
        received: i.parsedType
      }), nt;
    }
    if (Number.isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return Se(i, {
        code: pe.invalid_date
      }), nt;
    }
    const r = new Hn();
    let n;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (n = this._getOrReturnCtx(t, n), Se(n, {
        code: pe.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : Mt.assertNever(i);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Y1({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Me.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Me.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Y1.create = (e) => new Y1({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: tt.ZodDate,
  ...ut(e)
});
class By extends Tt {
  _parse(t) {
    if (this._getType(t) !== Pe.symbol) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.symbol,
        received: r.parsedType
      }), nt;
    }
    return ai(t.data);
  }
}
By.create = (e) => new By({
  typeName: tt.ZodSymbol,
  ...ut(e)
});
class Hy extends Tt {
  _parse(t) {
    if (this._getType(t) !== Pe.undefined) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.undefined,
        received: r.parsedType
      }), nt;
    }
    return ai(t.data);
  }
}
Hy.create = (e) => new Hy({
  typeName: tt.ZodUndefined,
  ...ut(e)
});
class Wy extends Tt {
  _parse(t) {
    if (this._getType(t) !== Pe.null) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.null,
        received: r.parsedType
      }), nt;
    }
    return ai(t.data);
  }
}
Wy.create = (e) => new Wy({
  typeName: tt.ZodNull,
  ...ut(e)
});
class Qy extends Tt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return ai(t.data);
  }
}
Qy.create = (e) => new Qy({
  typeName: tt.ZodAny,
  ...ut(e)
});
class Ky extends Tt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return ai(t.data);
  }
}
Ky.create = (e) => new Ky({
  typeName: tt.ZodUnknown,
  ...ut(e)
});
class _o extends Tt {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return Se(r, {
      code: pe.invalid_type,
      expected: Pe.never,
      received: r.parsedType
    }), nt;
  }
}
_o.create = (e) => new _o({
  typeName: tt.ZodNever,
  ...ut(e)
});
class Gy extends Tt {
  _parse(t) {
    if (this._getType(t) !== Pe.undefined) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.void,
        received: r.parsedType
      }), nt;
    }
    return ai(t.data);
  }
}
Gy.create = (e) => new Gy({
  typeName: tt.ZodVoid,
  ...ut(e)
});
class Ki extends Tt {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), i = this._def;
    if (r.parsedType !== Pe.array)
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.array,
        received: r.parsedType
      }), nt;
    if (i.exactLength !== null) {
      const o = r.data.length > i.exactLength.value, s = r.data.length < i.exactLength.value;
      (o || s) && (Se(r, {
        code: o ? pe.too_big : pe.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (Se(r, {
      code: pe.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (Se(r, {
      code: pe.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => i.type._parseAsync(new ko(r, o, r.path, s)))).then((o) => Hn.mergeArray(n, o));
    const a = [...r.data].map((o, s) => i.type._parseSync(new ko(r, o, r.path, s)));
    return Hn.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Ki({
      ...this._def,
      minLength: { value: t, message: Me.toString(r) }
    });
  }
  max(t, r) {
    return new Ki({
      ...this._def,
      maxLength: { value: t, message: Me.toString(r) }
    });
  }
  length(t, r) {
    return new Ki({
      ...this._def,
      exactLength: { value: t, message: Me.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Ki.create = (e, t) => new Ki({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: tt.ZodArray,
  ...ut(t)
});
function ol(e) {
  if (e instanceof Pr) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = fo.create(ol(n));
    }
    return new Pr({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Ki ? new Ki({
    ...e._def,
    type: ol(e.element)
  }) : e instanceof fo ? fo.create(ol(e.unwrap())) : e instanceof rd ? rd.create(ol(e.unwrap())) : e instanceof _s ? _s.create(e.items.map((t) => ol(t))) : e;
}
class Pr extends Tt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = Mt.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== Pe.object) {
      const l = this._getOrReturnCtx(t);
      return Se(l, {
        code: pe.invalid_type,
        expected: Pe.object,
        received: l.parsedType
      }), nt;
    }
    const { status: r, ctx: n } = this._processInputParams(t), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof _o && this._def.unknownKeys === "strip"))
      for (const l in n.data)
        a.includes(l) || o.push(l);
    const s = [];
    for (const l of a) {
      const d = i[l], c = n.data[l];
      s.push({
        key: { status: "valid", value: l },
        value: d._parse(new ko(n, c, n.path, l)),
        alwaysSet: l in n.data
      });
    }
    if (this._def.catchall instanceof _o) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of o)
          s.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: n.data[d] }
          });
      else if (l === "strict")
        o.length > 0 && (Se(n, {
          code: pe.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of o) {
        const c = n.data[d];
        s.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new ko(n, c, n.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of s) {
        const c = await d.key, u = await d.value;
        l.push({
          key: c,
          value: u,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => Hn.mergeObjectSync(r, l)) : Hn.mergeObjectSync(r, s);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Me.errToObj, new Pr({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          const i = this._def.errorMap?.(r, n).message ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: Me.errToObj(t).message ?? i
          } : {
            message: i
          };
        }
      } : {}
    });
  }
  strip() {
    return new Pr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Pr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Pr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Pr({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: tt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Pr({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of Mt.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new Pr({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of Mt.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new Pr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ol(this);
  }
  partial(t) {
    const r = {};
    for (const n of Mt.objectKeys(this.shape)) {
      const i = this.shape[n];
      t && !t[n] ? r[n] = i : r[n] = i.optional();
    }
    return new Pr({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of Mt.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof fo; )
          i = i._def.innerType;
        r[n] = i;
      }
    return new Pr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return _$(Mt.objectKeys(this.shape));
  }
}
Pr.create = (e, t) => new Pr({
  shape: () => e,
  unknownKeys: "strip",
  catchall: _o.create(),
  typeName: tt.ZodObject,
  ...ut(t)
});
Pr.strictCreate = (e, t) => new Pr({
  shape: () => e,
  unknownKeys: "strict",
  catchall: _o.create(),
  typeName: tt.ZodObject,
  ...ut(t)
});
Pr.lazycreate = (e, t) => new Pr({
  shape: e,
  unknownKeys: "strip",
  catchall: _o.create(),
  typeName: tt.ZodObject,
  ...ut(t)
});
class J1 extends Tt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new Ea(s.ctx.common.issues));
      return Se(r, {
        code: pe.invalid_union,
        unionErrors: o
      }), nt;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, c = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !a && (a = { result: c, ctx: d }), d.common.issues.length && o.push(d.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((l) => new Ea(l));
      return Se(r, {
        code: pe.invalid_union,
        unionErrors: s
      }), nt;
    }
  }
  get options() {
    return this._def.options;
  }
}
J1.create = (e, t) => new J1({
  options: e,
  typeName: tt.ZodUnion,
  ...ut(t)
});
function W5(e, t) {
  const r = Ya(e), n = Ya(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Pe.object && n === Pe.object) {
    const i = Mt.objectKeys(t), a = Mt.objectKeys(e).filter((s) => i.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of a) {
      const l = W5(e[s], t[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === Pe.array && n === Pe.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], s = t[a], l = W5(o, s);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return r === Pe.date && n === Pe.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class X1 extends Tt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = (a, o) => {
      if (zy(a) || zy(o))
        return nt;
      const s = W5(a.value, o.value);
      return s.valid ? ((Vy(a) || Vy(o)) && r.dirty(), { status: r.value, value: s.data }) : (Se(n, {
        code: pe.invalid_intersection_types
      }), nt);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
X1.create = (e, t, r) => new X1({
  left: e,
  right: t,
  typeName: tt.ZodIntersection,
  ...ut(r)
});
class _s extends Tt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Pe.array)
      return Se(n, {
        code: pe.invalid_type,
        expected: Pe.array,
        received: n.parsedType
      }), nt;
    if (n.data.length < this._def.items.length)
      return Se(n, {
        code: pe.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), nt;
    !this._def.rest && n.data.length > this._def.items.length && (Se(n, {
      code: pe.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((a, o) => {
      const s = this._def.items[o] || this._def.rest;
      return s ? s._parse(new ko(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => Hn.mergeArray(r, a)) : Hn.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new _s({
      ...this._def,
      rest: t
    });
  }
}
_s.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new _s({
    items: e,
    typeName: tt.ZodTuple,
    rest: null,
    ...ut(t)
  });
};
class Zy extends Tt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Pe.map)
      return Se(n, {
        code: pe.invalid_type,
        expected: Pe.map,
        received: n.parsedType
      }), nt;
    const i = this._def.keyType, a = this._def.valueType, o = [...n.data.entries()].map(([s, l], d) => ({
      key: i._parse(new ko(n, s, n.path, [d, "key"])),
      value: a._parse(new ko(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const d = await l.key, c = await l.value;
          if (d.status === "aborted" || c.status === "aborted")
            return nt;
          (d.status === "dirty" || c.status === "dirty") && r.dirty(), s.set(d.value, c.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const d = l.key, c = l.value;
        if (d.status === "aborted" || c.status === "aborted")
          return nt;
        (d.status === "dirty" || c.status === "dirty") && r.dirty(), s.set(d.value, c.value);
      }
      return { status: r.value, value: s };
    }
  }
}
Zy.create = (e, t, r) => new Zy({
  valueType: t,
  keyType: e,
  typeName: tt.ZodMap,
  ...ut(r)
});
class ou extends Tt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Pe.set)
      return Se(n, {
        code: pe.invalid_type,
        expected: Pe.set,
        received: n.parsedType
      }), nt;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (Se(n, {
      code: pe.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (Se(n, {
      code: pe.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function o(l) {
      const d = /* @__PURE__ */ new Set();
      for (const c of l) {
        if (c.status === "aborted")
          return nt;
        c.status === "dirty" && r.dirty(), d.add(c.value);
      }
      return { status: r.value, value: d };
    }
    const s = [...n.data.values()].map((l, d) => a._parse(new ko(n, l, n.path, d)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(t, r) {
    return new ou({
      ...this._def,
      minSize: { value: t, message: Me.toString(r) }
    });
  }
  max(t, r) {
    return new ou({
      ...this._def,
      maxSize: { value: t, message: Me.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ou.create = (e, t) => new ou({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: tt.ZodSet,
  ...ut(t)
});
class Yy extends Tt {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Yy.create = (e, t) => new Yy({
  getter: e,
  typeName: tt.ZodLazy,
  ...ut(t)
});
class Jy extends Tt {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        received: r.data,
        code: pe.invalid_literal,
        expected: this._def.value
      }), nt;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Jy.create = (e, t) => new Jy({
  value: e,
  typeName: tt.ZodLiteral,
  ...ut(t)
});
function _$(e, t) {
  return new ed({
    values: e,
    typeName: tt.ZodEnum,
    ...ut(t)
  });
}
class ed extends Tt {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return Se(r, {
        expected: Mt.joinValues(n),
        received: r.parsedType,
        code: pe.invalid_type
      }), nt;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return Se(r, {
        received: r.data,
        code: pe.invalid_enum_value,
        options: n
      }), nt;
    }
    return ai(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return ed.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return ed.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
ed.create = _$;
class Xy extends Tt {
  _parse(t) {
    const r = Mt.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== Pe.string && n.parsedType !== Pe.number) {
      const i = Mt.objectValues(r);
      return Se(n, {
        expected: Mt.joinValues(i),
        received: n.parsedType,
        code: pe.invalid_type
      }), nt;
    }
    if (this._cache || (this._cache = new Set(Mt.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const i = Mt.objectValues(r);
      return Se(n, {
        received: n.data,
        code: pe.invalid_enum_value,
        options: i
      }), nt;
    }
    return ai(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Xy.create = (e, t) => new Xy({
  values: e,
  typeName: tt.ZodNativeEnum,
  ...ut(t)
});
class eh extends Tt {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Pe.promise && r.common.async === !1)
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.promise,
        received: r.parsedType
      }), nt;
    const n = r.parsedType === Pe.promise ? r.data : Promise.resolve(r.data);
    return ai(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
eh.create = (e, t) => new eh({
  type: e,
  typeName: tt.ZodPromise,
  ...ut(t)
});
class td extends Tt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === tt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = this._def.effect || null, a = {
      addIssue: (o) => {
        Se(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return nt;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? nt : l.status === "dirty" || r.value === "dirty" ? H5(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return nt;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? nt : s.status === "dirty" || r.value === "dirty" ? H5(s.value) : s;
      }
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const l = i.refinement(s, a);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? nt : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? nt : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Xl(o))
          return nt;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => Xl(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({
          status: r.value,
          value: s
        })) : nt);
    Mt.assertNever(i);
  }
}
td.create = (e, t, r) => new td({
  schema: e,
  typeName: tt.ZodEffects,
  effect: t,
  ...ut(r)
});
td.createWithPreprocess = (e, t, r) => new td({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: tt.ZodEffects,
  ...ut(r)
});
class fo extends Tt {
  _parse(t) {
    return this._getType(t) === Pe.undefined ? ai(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
fo.create = (e, t) => new fo({
  innerType: e,
  typeName: tt.ZodOptional,
  ...ut(t)
});
class rd extends Tt {
  _parse(t) {
    return this._getType(t) === Pe.null ? ai(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
rd.create = (e, t) => new rd({
  innerType: e,
  typeName: tt.ZodNullable,
  ...ut(t)
});
class Q5 extends Tt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === Pe.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Q5.create = (e, t) => new Q5({
  innerType: e,
  typeName: tt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ut(t)
});
class K5 extends Tt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Z1(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Ea(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Ea(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
K5.create = (e, t) => new K5({
  innerType: e,
  typeName: tt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ut(t)
});
class e9 extends Tt {
  _parse(t) {
    if (this._getType(t) !== Pe.nan) {
      const r = this._getOrReturnCtx(t);
      return Se(r, {
        code: pe.invalid_type,
        expected: Pe.nan,
        received: r.parsedType
      }), nt;
    }
    return { status: "valid", value: t.data };
  }
}
e9.create = (e) => new e9({
  typeName: tt.ZodNaN,
  ...ut(e)
});
class pD extends Tt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class e3 extends Tt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? nt : i.status === "dirty" ? (r.dirty(), H5(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? nt : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new e3({
      in: t,
      out: r,
      typeName: tt.ZodPipeline
    });
  }
}
class G5 extends Tt {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (i) => (Xl(i) && (i.value = Object.freeze(i.value)), i);
    return Z1(r) ? r.then((i) => n(i)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
G5.create = (e, t) => new G5({
  innerType: e,
  typeName: tt.ZodReadonly,
  ...ut(t)
});
var tt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(tt || (tt = {}));
const sl = oo.create;
_o.create;
Ki.create;
const x$ = Pr.create;
J1.create;
X1.create;
_s.create;
ed.create;
eh.create;
fo.create;
rd.create;
var Z5 = function(e, t) {
  return Z5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Z5(e, t);
};
function Uu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Z5(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var ne = function() {
  return ne = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ne.apply(this, arguments);
};
function Y5(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Ja(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function s(c) {
      try {
        d(n.next(c));
      } catch (u) {
        o(u);
      }
    }
    function l(c) {
      try {
        d(n.throw(c));
      } catch (u) {
        o(u);
      }
    }
    function d(c) {
      c.done ? a(c.value) : i(c.value).then(s, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function Xa(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(d) {
    return function(c) {
      return l([d, c]);
    };
  }
  function l(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, d[0] && (r = 0)), r; ) try {
      if (n = 1, i && (a = d[0] & 2 ? i.return : d[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, d[1])).done) return a;
      switch (i = 0, a && (d = [d[0] & 2, a.value]), d[0]) {
        case 0:
        case 1:
          a = d;
          break;
        case 4:
          return r.label++, { value: d[1], done: !1 };
        case 5:
          r.label++, i = d[1], d = [0];
          continue;
        case 7:
          d = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            r = 0;
            continue;
          }
          if (d[0] === 3 && (!a || d[1] > a[0] && d[1] < a[3])) {
            r.label = d[1];
            break;
          }
          if (d[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = d;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(d);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      d = t.call(e, r);
    } catch (c) {
      d = [6, c], i = 0;
    } finally {
      n = a = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function hn(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, a; n < i; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function f1(e, t) {
  throw new Error(t);
}
function mD(e) {
  return typeof e == "object" && e !== null;
}
function gD(e, t) {
  throw new Error(
    "Unexpected invariant triggered."
  );
}
const vD = /\r\n|[\n\r]/g;
function J5(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(vD)) {
    if (typeof i.index == "number" || gD(), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function yD(e) {
  return S$(
    e.source,
    J5(e.source, e.start)
  );
}
function S$(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, o = t.line + a, s = t.line === 1 ? r : 0, l = t.column + s, d = `${e.name}:${o}:${l}
`, c = n.split(/\r\n|[\n\r]/g), u = c[i];
  if (u.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, p = [];
    for (let m = 0; m < u.length; m += 80)
      p.push(u.slice(m, m + 80));
    return d + t9([
      [`${o} |`, p[0]],
      ...p.slice(1, h + 1).map((m) => ["|", m]),
      ["|", "^".padStart(f)],
      ["|", p[h + 1]]
    ]);
  }
  return d + t9([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, c[i - 1]],
    [`${o} |`, u],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, c[i + 1]]
  ]);
}
function t9(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function bD(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class t3 extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, a;
    const { nodes: o, source: s, positions: l, path: d, originalError: c, extensions: u } = bD(r);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = c ?? void 0, this.nodes = r9(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = r9(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = s ?? (h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? h?.map((p) => p.start), this.locations = l && s ? l.map((p) => J5(s, p)) : h?.map((p) => J5(p.source, p.start));
    const f = mD(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (a = u ?? f) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, t3) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + yD(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + S$(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function r9(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function zr(e, t, r) {
  return new t3(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class wD {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class C$ {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, a, o) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = a, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const E$ = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, $D = new Set(Object.keys(E$));
function n9(e) {
  const t = e?.kind;
  return typeof t == "string" && $D.has(t);
}
var _l;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(_l || (_l = {}));
var X5;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(X5 || (X5 = {}));
var we;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(we || (we = {}));
function em(e) {
  return e === 9 || e === 32;
}
function su(e) {
  return e >= 48 && e <= 57;
}
function A$(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function T$(e) {
  return A$(e) || e === 95;
}
function kD(e) {
  return A$(e) || su(e) || e === 95;
}
function _D(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < e.length; ++o) {
    var a;
    const s = e[o], l = xD(s);
    l !== s.length && (n = (a = n) !== null && a !== void 0 ? a : o, i = o, o !== 0 && l < r && (r = l));
  }
  return e.map((o, s) => s === 0 ? o : o.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function xD(e) {
  let t = 0;
  for (; t < e.length && em(e.charCodeAt(t)); )
    ++t;
  return t;
}
function SD(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((f) => f.length === 0 || em(f.charCodeAt(0))), o = r.endsWith('\\"""'), s = e.endsWith('"') && !o, l = e.endsWith("\\"), d = s || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || a || o
  );
  let u = "";
  const h = i && em(e.charCodeAt(0));
  return (c && !h || a) && (u += `
`), u += r, (c || d) && (u += `
`), '"""' + u + '"""';
}
var X;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(X || (X = {}));
class CD {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new C$(X.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== X.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = AD(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === X.COMMENT);
    return t;
  }
}
function ED(e) {
  return e === X.BANG || e === X.DOLLAR || e === X.AMP || e === X.PAREN_L || e === X.PAREN_R || e === X.DOT || e === X.SPREAD || e === X.COLON || e === X.EQUALS || e === X.AT || e === X.BRACKET_L || e === X.BRACKET_R || e === X.BRACE_L || e === X.PIPE || e === X.BRACE_R;
}
function Ed(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function tf(e, t) {
  return O$(e.charCodeAt(t)) && I$(e.charCodeAt(t + 1));
}
function O$(e) {
  return e >= 55296 && e <= 56319;
}
function I$(e) {
  return e >= 56320 && e <= 57343;
}
function xs(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return X.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function Or(e, t, r, n, i) {
  const a = e.line, o = 1 + r - e.lineStart;
  return new C$(t, r, n, a, o, i);
}
function AD(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    switch (a) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      // Comment
      case 35:
        return TD(e, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return Or(e, X.BANG, i, i + 1);
      case 36:
        return Or(e, X.DOLLAR, i, i + 1);
      case 38:
        return Or(e, X.AMP, i, i + 1);
      case 40:
        return Or(e, X.PAREN_L, i, i + 1);
      case 41:
        return Or(e, X.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return Or(e, X.SPREAD, i, i + 3);
        break;
      case 58:
        return Or(e, X.COLON, i, i + 1);
      case 61:
        return Or(e, X.EQUALS, i, i + 1);
      case 64:
        return Or(e, X.AT, i, i + 1);
      case 91:
        return Or(e, X.BRACKET_L, i, i + 1);
      case 93:
        return Or(e, X.BRACKET_R, i, i + 1);
      case 123:
        return Or(e, X.BRACE_L, i, i + 1);
      case 124:
        return Or(e, X.PIPE, i, i + 1);
      case 125:
        return Or(e, X.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? MD(e, i) : ID(e, i);
    }
    if (su(a) || a === 45)
      return OD(e, i, a);
    if (T$(a))
      return RD(e, i);
    throw zr(
      e.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Ed(a) || tf(r, i) ? `Unexpected character: ${xs(e, i)}.` : `Invalid character: ${xs(e, i)}.`
    );
  }
  return Or(e, X.EOF, n, n);
}
function TD(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (Ed(a))
      ++i;
    else if (tf(r, i))
      i += 2;
    else
      break;
  }
  return Or(
    e,
    X.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function OD(e, t, r) {
  const n = e.source.body;
  let i = t, a = r, o = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), su(a))
      throw zr(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${xs(
          e,
          i
        )}.`
      );
  } else
    i = U2(e, i, a), a = n.charCodeAt(i);
  if (a === 46 && (o = !0, a = n.charCodeAt(++i), i = U2(e, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (o = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = U2(e, i, a), a = n.charCodeAt(i)), a === 46 || T$(a))
    throw zr(
      e.source,
      i,
      `Invalid number, expected digit but got: ${xs(
        e,
        i
      )}.`
    );
  return Or(
    e,
    o ? X.FLOAT : X.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function U2(e, t, r) {
  if (!su(r))
    throw zr(
      e.source,
      t,
      `Invalid number, expected digit but got: ${xs(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; su(n.charCodeAt(i)); )
    ++i;
  return i;
}
function ID(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, a = i, o = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return o += r.slice(a, i), Or(e, X.STRING, t, i + 1, o);
    if (s === 92) {
      o += r.slice(a, i);
      const l = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? PD(e, i) : ND(e, i) : DD(e, i);
      o += l.value, i += l.size, a = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Ed(s))
      ++i;
    else if (tf(r, i))
      i += 2;
    else
      throw zr(
        e.source,
        i,
        `Invalid character within String: ${xs(
          e,
          i
        )}.`
      );
  }
  throw zr(e.source, i, "Unterminated string.");
}
function PD(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = r.charCodeAt(t + i++);
    if (a === 125) {
      if (i < 5 || !Ed(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | $c(a), n < 0)
      break;
  }
  throw zr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function ND(e, t) {
  const r = e.source.body, n = i9(r, t + 2);
  if (Ed(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (O$(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = i9(r, t + 8);
    if (I$(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw zr(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function i9(e, t) {
  return $c(e.charCodeAt(t)) << 12 | $c(e.charCodeAt(t + 1)) << 8 | $c(e.charCodeAt(t + 2)) << 4 | $c(e.charCodeAt(t + 3));
}
function $c(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function DD(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw zr(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function MD(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, a = t + 3, o = a, s = "";
  const l = [];
  for (; a < n; ) {
    const d = r.charCodeAt(a);
    if (d === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      s += r.slice(o, a), l.push(s);
      const c = Or(
        e,
        X.BLOCK_STRING,
        t,
        a + 3,
        // Return a string of the lines joined with U+000A.
        _D(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = i, c;
    }
    if (d === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      s += r.slice(o, a), o = a + 1, a += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += r.slice(o, a), l.push(s), d === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", o = a, i = a;
      continue;
    }
    if (Ed(d))
      ++a;
    else if (tf(r, a))
      a += 2;
    else
      throw zr(
        e.source,
        a,
        `Invalid character within String: ${xs(
          e,
          a
        )}.`
      );
  }
  throw zr(e.source, a, "Unterminated string.");
}
function RD(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const a = r.charCodeAt(i);
    if (kD(a))
      ++i;
    else
      break;
  }
  return Or(
    e,
    X.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const LD = 10, P$ = 2;
function r3(e) {
  return rf(e, []);
}
function rf(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return FD(e, t);
    default:
      return String(e);
  }
}
function FD(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (jD(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : rf(n, r);
  } else if (Array.isArray(e))
    return VD(e, r);
  return zD(e, r);
}
function jD(e) {
  return typeof e.toJSON == "function";
}
function zD(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > P$ ? "[" + UD(e) + "]" : "{ " + r.map(
    ([n, i]) => n + ": " + rf(i, t)
  ).join(", ") + " }";
}
function VD(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > P$)
    return "[Array]";
  const r = Math.min(LD, e.length), n = e.length - r, i = [];
  for (let a = 0; a < r; ++a)
    i.push(rf(e[a], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function UD(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const qD = globalThis.process && // eslint-disable-next-line no-undef
!0, BD = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  qD ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var r;
      const n = t.prototype[Symbol.toStringTag], i = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (r = e.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (n === i) {
        const a = r3(e);
        throw new Error(`Cannot use ${n} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class N$ {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || f1(!1, `Body must be a string. Received: ${r3(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || f1(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || f1(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function HD(e) {
  return BD(e, N$);
}
function WD(e, t) {
  const r = new QD(e, t), n = r.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: r.tokenCount
  }), n;
}
class QD {
  constructor(t, r = {}) {
    const { lexer: n, ...i } = r;
    if (n)
      this._lexer = n;
    else {
      const a = HD(t) ? t : new N$(t);
      this._lexer = new CD(a);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(X.NAME);
    return this.node(t, {
      kind: we.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: we.DOCUMENT,
      definitions: this.many(
        X.SOF,
        this.parseDefinition,
        X.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(X.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (t && r.kind === X.BRACE_L)
      throw zr(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (r.kind === X.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (t)
        throw zr(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (r.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(X.BRACE_L))
      return this.node(t, {
        kind: we.OPERATION_DEFINITION,
        operation: _l.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseDescription(), n = this.parseOperationType();
    let i;
    return this.peek(X.NAME) && (i = this.parseName()), this.node(t, {
      kind: we.OPERATION_DEFINITION,
      operation: n,
      description: r,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(X.NAME);
    switch (t.value) {
      case "query":
        return _l.QUERY;
      case "mutation":
        return _l.MUTATION;
      case "subscription":
        return _l.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      X.PAREN_L,
      this.parseVariableDefinition,
      X.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: we.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(X.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(X.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(X.DOLLAR), this.node(t, {
      kind: we.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: we.SELECTION_SET,
      selections: this.many(
        X.BRACE_L,
        this.parseSelection,
        X.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(X.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(X.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: we.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(X.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(X.PAREN_L, r, X.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(X.COLON), this.node(r, {
      kind: we.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(X.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(X.NAME) ? this.node(t, {
      kind: we.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: we.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: we.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: we.FRAGMENT_DEFINITION,
      description: r,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case X.BRACKET_L:
        return this.parseList(t);
      case X.BRACE_L:
        return this.parseObject(t);
      case X.INT:
        return this.advanceLexer(), this.node(r, {
          kind: we.INT,
          value: r.value
        });
      case X.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: we.FLOAT,
          value: r.value
        });
      case X.STRING:
      case X.BLOCK_STRING:
        return this.parseStringLiteral();
      case X.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: we.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: we.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: we.NULL
            });
          default:
            return this.node(r, {
              kind: we.ENUM,
              value: r.value
            });
        }
      case X.DOLLAR:
        if (t)
          if (this.expectToken(X.DOLLAR), this._lexer.token.kind === X.NAME) {
            const n = this._lexer.token.value;
            throw zr(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: we.STRING,
      value: t.value,
      block: t.kind === X.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: we.LIST,
      values: this.any(X.BRACKET_L, r, X.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: we.OBJECT,
      fields: this.any(X.BRACE_L, r, X.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(X.COLON), this.node(r, {
      kind: we.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(X.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(X.AT), this.node(r, {
      kind: we.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(X.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(X.BRACKET_R), r = this.node(t, {
        kind: we.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(X.BANG) ? this.node(t, {
      kind: we.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: we.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(X.STRING) || this.peek(X.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      X.BRACE_L,
      this.parseOperationTypeDefinition,
      X.BRACE_R
    );
    return this.node(t, {
      kind: we.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(X.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: we.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: we.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: we.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(X.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      X.BRACE_L,
      this.parseFieldDefinition,
      X.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(X.COLON);
    const a = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: we.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: a,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      X.PAREN_L,
      this.parseInputValueDef,
      X.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(X.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(X.EQUALS) && (a = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: we.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: a,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: we.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: a,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: we.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(X.EQUALS) ? this.delimitedMany(X.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: we.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      X.BRACE_L,
      this.parseEnumValueDefinition,
      X.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: we.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw zr(
        this._lexer.source,
        this._lexer.token.start,
        `${I0(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: we.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      X.BRACE_L,
      this.parseInputValueDef,
      X.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === X.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      X.BRACE_L,
      this.parseOperationTypeDefinition,
      X.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: we.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(X.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: we.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: a,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(X.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(X5, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const t = this._lexer.token, r = this.expectOptionalToken(X.AT), n = this.parseName();
    let i;
    !r && this.expectOptionalToken(X.DOT) && (i = this.parseName());
    let a;
    return (r || i) && this.expectOptionalToken(X.PAREN_L) && (a = this.parseName(), this.expectToken(X.COLON), this.expectToken(X.PAREN_R)), r ? a ? this.node(t, {
      kind: we.DIRECTIVE_ARGUMENT_COORDINATE,
      name: n,
      argumentName: a
    }) : this.node(t, {
      kind: we.DIRECTIVE_COORDINATE,
      name: n
    }) : i ? a ? this.node(t, {
      kind: we.ARGUMENT_COORDINATE,
      name: n,
      fieldName: i,
      argumentName: a
    }) : this.node(t, {
      kind: we.MEMBER_COORDINATE,
      name: n,
      memberName: i
    }) : this.node(t, {
      kind: we.TYPE_COORDINATE,
      name: n
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new wD(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw zr(
      this._lexer.source,
      r.start,
      `Expected ${D$(t)}, found ${I0(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === X.NAME && r.value === t)
      this.advanceLexer();
    else
      throw zr(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${I0(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === X.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return zr(
      this._lexer.source,
      r.start,
      `Unexpected ${I0(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (r.kind !== X.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
      throw zr(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function I0(e) {
  const t = e.value;
  return D$(e.kind) + (t != null ? ` "${t}"` : "");
}
function D$(e) {
  return ED(e) ? `"${e}"` : e;
}
function KD(e) {
  return `"${e.replace(GD, ZD)}"`;
}
const GD = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function ZD(e) {
  return YD[e.charCodeAt(0)];
}
const YD = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], nf = Object.freeze({});
function Ti(e, t, r = E$) {
  const n = /* @__PURE__ */ new Map();
  for (const v of Object.values(we))
    n.set(v, JD(t, v));
  let i, a = Array.isArray(e), o = [e], s = -1, l = [], d = e, c, u;
  const h = [], f = [];
  do {
    s++;
    const v = s === o.length, b = v && l.length !== 0;
    if (v) {
      if (c = f.length === 0 ? void 0 : h[h.length - 1], d = u, u = f.pop(), b)
        if (a) {
          d = d.slice();
          let _ = 0;
          for (const [x, S] of l) {
            const A = x - _;
            S === null ? (d.splice(A, 1), _++) : d[A] = S;
          }
        } else {
          d = { ...d };
          for (const [_, x] of l)
            d[_] = x;
        }
      s = i.index, o = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (u) {
      if (c = a ? s : o[s], d = u[c], d == null)
        continue;
      h.push(c);
    }
    let $;
    if (!Array.isArray(d)) {
      var p, m;
      if (n9(d) || f1(!1, `Invalid AST Node: ${r3(d)}.`), $ = (v ? (p = n.get(d.kind)) === null || p === void 0 ? void 0 : p.leave : (m = n.get(d.kind)) === null || m === void 0 ? void 0 : m.enter)?.call(t, d, c, u, h, f), $ === nf)
        break;
      if ($ === !1) {
        if (!v) {
          h.pop();
          continue;
        }
      } else if ($ !== void 0 && (l.push([c, $]), !v))
        if (n9($))
          d = $;
        else {
          h.pop();
          continue;
        }
    }
    if ($ === void 0 && b && l.push([c, d]), v)
      h.pop();
    else {
      var y;
      i = {
        inArray: a,
        index: s,
        keys: o,
        edits: l,
        prev: i
      }, a = Array.isArray(d), o = a ? d : (y = r[d.kind]) !== null && y !== void 0 ? y : [], s = -1, l = [], u && f.push(u), u = d;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function JD(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function XD(e) {
  return Ti(e, tM);
}
const eM = 80, tM = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Te(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = q2(e.variableDefinitions) ? Je(`(
`, Te(e.variableDefinitions, `
`), `
)`) : Je("(", Te(e.variableDefinitions, ", "), ")"), r = Je("", e.description, `
`) + Te(
        [
          e.operation,
          Te([e.name, t]),
          Te(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n, description: i }) => Je("", i, `
`) + e + ": " + t + Je(" = ", r) + Je(" ", Te(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => ci(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const a = Je("", e, ": ") + t;
      let o = a + Je("(", Te(r, ", "), ")");
      return o.length > eM && (o = a + Je(`(
`, p1(Te(r, `
`)), `
)`)), Te([o, Te(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + Je(" ", Te(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => Te(
      [
        "...",
        Je("on ", e),
        Te(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: t,
      variableDefinitions: r,
      directives: n,
      selectionSet: i,
      description: a
    }) => Je("", a, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${Je("(", Te(r, ", "), ")")} on ${t} ${Je("", Te(n, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? SD(e) : KD(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Te(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Te(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + Je("(", Te(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => Je("", e, `
`) + Te(["schema", Te(t, " "), ci(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Je("", e, `
`) + Te(["scalar", t, Te(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Je("", e, `
`) + Te(
      [
        "type",
        t,
        Je("implements ", Te(r, " & ")),
        Te(n, " "),
        ci(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => Je("", e, `
`) + t + (q2(r) ? Je(`(
`, p1(Te(r, `
`)), `
)`) : Je("(", Te(r, ", "), ")")) + ": " + n + Je(" ", Te(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => Je("", e, `
`) + Te(
      [t + ": " + r, Je("= ", n), Te(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => Je("", e, `
`) + Te(
      [
        "interface",
        t,
        Je("implements ", Te(r, " & ")),
        Te(n, " "),
        ci(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => Je("", e, `
`) + Te(
      ["union", t, Te(r, " "), Je("= ", Te(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => Je("", e, `
`) + Te(["enum", t, Te(r, " "), ci(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Je("", e, `
`) + Te([t, Te(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => Je("", e, `
`) + Te(["input", t, Te(r, " "), ci(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => Je("", e, `
`) + "directive @" + t + (q2(r) ? Je(`(
`, p1(Te(r, `
`)), `
)`) : Je("(", Te(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + Te(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => Te(
      ["extend schema", Te(e, " "), ci(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => Te(["extend scalar", e, Te(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Te(
      [
        "extend type",
        e,
        Je("implements ", Te(t, " & ")),
        Te(r, " "),
        ci(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Te(
      [
        "extend interface",
        e,
        Je("implements ", Te(t, " & ")),
        Te(r, " "),
        ci(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => Te(
      [
        "extend union",
        e,
        Te(t, " "),
        Je("= ", Te(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => Te(["extend enum", e, Te(t, " "), ci(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => Te(["extend input", e, Te(t, " "), ci(r)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: t }) => Te([e, Je(".", t)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: t, argumentName: r }) => Te([e, Je(".", t), Je("(", r, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => Te(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: t }) => Te(["@", e, Je("(", t, ":)")])
  }
};
function Te(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function ci(e) {
  return Je(`{
`, p1(Te(e, `
`)), `
}`);
}
function Je(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function p1(e) {
  return Je("  ", e.replace(/\n/g, `
  `));
}
function q2(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function a9(e) {
  return e.kind === we.FIELD || e.kind === we.FRAGMENT_SPREAD || e.kind === we.INLINE_FRAGMENT;
}
var m1 = /* @__PURE__ */ new Map(), tm = /* @__PURE__ */ new Map(), M$ = !0, th = !1;
function R$(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function rM(e) {
  return R$(e.source.body.substring(e.start, e.end));
}
function nM(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = rM(n.loc), o = tm.get(i);
      o && !o.has(a) ? M$ && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || tm.set(i, o = /* @__PURE__ */ new Set()), o.add(a), t.has(a) || (t.add(a), r.push(n));
    } else
      r.push(n);
  }), ne(ne({}, e), { definitions: r });
}
function iM(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && t.add(a);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function aM(e) {
  var t = R$(e);
  if (!m1.has(t)) {
    var r = WD(e, {
      experimentalFragmentVariables: th,
      allowLegacyFragmentVariables: th
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    m1.set(t, iM(nM(r)));
  }
  return m1.get(t);
}
function Ge(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[a + 1];
  }), aM(n);
}
function oM() {
  m1.clear(), tm.clear();
}
function sM() {
  M$ = !1;
}
function lM() {
  th = !0;
}
function dM() {
  th = !1;
}
var Xd = {
  gql: Ge,
  resetCaches: oM,
  disableFragmentWarnings: sM,
  enableExperimentalFragmentVariables: lM,
  disableExperimentalFragmentVariables: dM
};
(function(e) {
  e.gql = Xd.gql, e.resetCaches = Xd.resetCaches, e.disableFragmentWarnings = Xd.disableFragmentWarnings, e.enableExperimentalFragmentVariables = Xd.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = Xd.disableExperimentalFragmentVariables;
})(Ge || (Ge = {}));
Ge.default = Ge;
function L$(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = L$(e[t])) && (n && (n += " "), n += r);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function Yt() {
  for (var e, t, r = 0, n = ""; r < arguments.length; ) (e = arguments[r++]) && (t = L$(e)) && (n && (n += " "), n += t);
  return n;
}
var cM = /* @__PURE__ */ k("<svg>");
const uM = (e) => {
  const [t, r] = go(e, ["path"]);
  return (() => {
    var n = cM();
    return ii(n, it({
      get viewBox() {
        return t.path.mini ? "0 0 20 20" : "0 0 24 24";
      },
      get fill() {
        return t.path.outline ? "none" : "currentColor";
      },
      get stroke() {
        return t.path.outline ? "currentColor" : "none";
      },
      get "stroke-width"() {
        return t.path.outline ? 1.5 : void 0;
      }
    }, r), !0, !0), E(n, () => t.path.path), n;
  })();
};
var hM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"></svg>', !1, !0, !1), fM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"></svg>', !1, !0, !1), pM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"></svg>', !1, !0, !1), mM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), gM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), vM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), yM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), bM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 4.5l-15 15m0 0h11.25m-11.25 0V8.25"></svg>', !1, !0, !1), wM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m-6 3.75l3 3m0 0l3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></svg>', !1, !0, !1), $M = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"></svg>', !1, !0, !1), kM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25"></svg>', !1, !0, !1), _M = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></svg>', !1, !0, !1), xM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"></svg>', !1, !0, !1), SM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), CM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"></svg>', !1, !0, !1), EM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"></svg>', !1, !0, !1), AM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"></svg>', !1, !0, !1), TM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"></svg>', !1, !0, !1), OM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"></svg>', !1, !0, !1), IM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"></svg>', !1, !0, !1), PM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"></svg>', !1, !0, !1), NM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"></svg>', !1, !0, !1), DM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), MM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"></svg>', !1, !0, !1), RM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></svg>', !1, !0, !1), LM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"></svg>', !1, !0, !1), FM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></svg>', !1, !0, !1), jM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></svg>', !1, !0, !1), zM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"></svg>', !1, !0, !1), VM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"></svg>', !1, !0, !1), UM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"></svg>', !1, !0, !1), qM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"></svg>', !1, !0, !1), BM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), HM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 19.5l-15-15m0 0v11.25m0-11.25h11.25"></svg>', !1, !0, !1), WM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m0-3l-3-3m0 0l-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></svg>', !1, !0, !1), QM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"></svg>', !1, !0, !1), KM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></svg>', !1, !0, !1), GM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"></svg>', !1, !0, !1), ZM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"></svg>', !1, !0, !1), YM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 15l-6 6m0 0l-6-6m6 6V9a6 6 0 0112 0v3"></svg>', !1, !0, !1), JM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"></svg>', !1, !0, !1), XM = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 15l6-6m0 0l-6-6m6 6H9a6 6 0 000 12h3"></svg>', !1, !0, !1), eR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9l6-6m0 0l6 6m-6-6v12a6 6 0 01-12 0v-3"></svg>', !1, !0, !1), tR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"></svg>', !1, !0, !1), rR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"></svg>', !1, !0, !1), nR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"></svg>', !1, !0, !1), iR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"></svg>', !1, !0, !1), aR = /* @__PURE__ */ k('<svg><path stroke-linecap=round d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"></svg>', !1, !0, !1), oR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"></svg>', !1, !0, !1), sR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953l7.108-4.062A1.125 1.125 0 0121 8.688v8.123zM11.25 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953L9.567 7.71a1.125 1.125 0 011.683.977v8.123z"></svg>', !1, !0, !1), lR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"></svg>', !1, !0, !1), dR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 9h16.5m-16.5 6.75h16.5"></svg>', !1, !0, !1), cR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"></svg>', !1, !0, !1), uR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"></svg>', !1, !0, !1), hR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"></svg>', !1, !0, !1), fR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></svg>', !1, !0, !1), pR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"></svg>', !1, !0, !1), mR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0l-3.75-3.75M17.25 21L21 17.25"></svg>', !1, !0, !1), gR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"></svg>', !1, !0, !1), vR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), yR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), bR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"></svg>', !1, !0, !1), wR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"></svg>', !1, !0, !1), $R = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"></svg>', !1, !0, !1), kR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"></svg>', !1, !0, !1), _R = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M10.5 8.25h3l-3 4.5h3"></svg>', !1, !0, !1), xR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"></svg>', !1, !0, !1), SR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.412 15.655L9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457L3 3m5.457 5.457l7.086 7.086m0 0L21 21"></svg>', !1, !0, !1), CR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"></svg>', !1, !0, !1), ER = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"></svg>', !1, !0, !1), AR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 011.743-1.342 48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664L19.5 19.5"></svg>', !1, !0, !1), TR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9"></svg>', !1, !0, !1), OR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"></svg>', !1, !0, !1), IR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"></svg>', !1, !0, !1), PR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0112 12.75zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 01-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 002.248-2.354M12 12.75a2.25 2.25 0 01-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 00-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 01.4-2.253M12 8.25a2.25 2.25 0 00-2.248 2.146M12 8.25a2.25 2.25 0 012.248 2.146M8.683 5a6.032 6.032 0 01-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0115.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 00-.575-1.752M4.921 6a24.048 24.048 0 00-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 01-5.223 1.082"></svg>', !1, !0, !1), NR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"></svg>', !1, !0, !1), DR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), MR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"></svg>', !1, !0, !1), RR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"></svg>', !1, !0, !1), LR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.87c1.355 0 2.697.055 4.024.165C17.155 8.51 18 9.473 18 10.608v2.513m-3-4.87v-1.5m-6 1.5v-1.5m12 9.75l-1.5.75a3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0L3 16.5m15-3.38a48.474 48.474 0 00-6-.37c-2.032 0-4.034.125-6 .37m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.17c0 .62-.504 1.124-1.125 1.124H4.125A1.125 1.125 0 013 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 016 13.12M12.265 3.11a.375.375 0 11-.53 0L12 2.845l.265.265zm-3 0a.375.375 0 11-.53 0L9 2.845l.265.265zm6 0a.375.375 0 11-.53 0L15 2.845l.265.265z"></svg>', !1, !0, !1), FR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"></svg>', !1, !0, !1), jR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"></svg>', !1, !0, !1), zR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"></svg>', !1, !0, !1), VR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"></svg>', !1, !0, !1), UR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"></svg>', !1, !0, !1), qR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"></svg>', !1, !0, !1), BR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"></svg>', !1, !0, !1), HR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"></svg>', !1, !0, !1), WR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"></svg>', !1, !0, !1), QR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), KR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), GR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), ZR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"></svg>', !1, !0, !1), YR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"></svg>', !1, !0, !1), JR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"></svg>', !1, !0, !1), XR = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z"></svg>', !1, !0, !1), eL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"></svg>', !1, !0, !1), tL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), rL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12.75l6 6 9-13.5"></svg>', !1, !0, !1), nL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 5.25l-7.5 7.5-7.5-7.5m15 6l-7.5 7.5-7.5-7.5"></svg>', !1, !0, !1), iL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"></svg>', !1, !0, !1), aL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"></svg>', !1, !0, !1), oL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5"></svg>', !1, !0, !1), sL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 8.25l-7.5 7.5-7.5-7.5"></svg>', !1, !0, !1), lL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 19.5L8.25 12l7.5-7.5"></svg>', !1, !0, !1), dL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 4.5l7.5 7.5-7.5 7.5"></svg>', !1, !0, !1), cL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></svg>', !1, !0, !1), uL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 15.75l7.5-7.5 7.5 7.5"></svg>', !1, !0, !1), hL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"></svg>', !1, !0, !1), fL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"></svg>', !1, !0, !1), pL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"></svg>', !1, !0, !1), mL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"></svg>', !1, !0, !1), gL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"></svg>', !1, !0, !1), vL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), yL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"></svg>', !1, !0, !1), bL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"></svg>', !1, !0, !1), wL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"></svg>', !1, !0, !1), $L = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"></svg>', !1, !0, !1), kL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"></svg>', !1, !0, !1), _L = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"></svg>', !1, !0, !1), n3 = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), xL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"></svg>', !1, !0, !1), SL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"></svg>', !1, !0, !1), CL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), EL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"></svg>', !1, !0, !1), AL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z"></svg>', !1, !0, !1), TL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></svg>', !1, !0, !1), OL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"></svg>', !1, !0, !1), IL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"></svg>', !1, !0, !1), PL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 7.5l.415-.207a.75.75 0 011.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 005.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), NL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), DL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), ML = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.121 7.629A3 3 0 009.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 01-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 011.422 0l.655.218a2.25 2.25 0 001.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), RL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), LL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 7.5l3 4.5m0 0l3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), FL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59"></svg>', !1, !0, !1), jL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5"></svg>', !1, !0, !1), zL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"></svg>', !1, !0, !1), VL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), UL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), qL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), BL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), HL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12"></svg>', !1, !0, !1), WL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"></svg>', !1, !0, !1), QL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></svg>', !1, !0, !1), KL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), GL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), ZL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), YL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></svg>', !1, !0, !1), JL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), XL = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), eF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"></svg>', !1, !0, !1), tF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5 1.615a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V8.844a2.25 2.25 0 011.183-1.98l7.5-4.04a2.25 2.25 0 012.134 0l7.5 4.04a2.25 2.25 0 011.183 1.98V19.5z"></svg>', !1, !0, !1), rF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"></svg>', !1, !0, !1), nF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"></svg>', !1, !0, !1), iF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></svg>', !1, !0, !1), aF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 11.25l1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 10-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25L12.75 9"></svg>', !1, !0, !1), oF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"></svg>', !1, !0, !1), sF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"></svg>', !1, !0, !1), lF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"></svg>', !1, !0, !1), dF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"></svg>', !1, !0, !1), cF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0118 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0118 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 016 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"></svg>', !1, !0, !1), uF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33"></svg>', !1, !0, !1), hF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"></svg>', !1, !0, !1), fF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"></svg>', !1, !0, !1), pF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5"></svg>', !1, !0, !1), mF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 13.5l3 3m0 0l3-3m-3 3v-6m1.06-4.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), gF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 13.5H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), vF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776"></svg>', !1, !0, !1), yF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), bF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"></svg>', !1, !0, !1), wF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062A1.125 1.125 0 013 16.81V8.688zM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062a1.125 1.125 0 01-1.683-.977V8.688z"></svg>', !1, !0, !1), $F = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"></svg>', !1, !0, !1), kF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"></svg>', !1, !0, !1), _F = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 004.875-4.875V12m6.375 5.25a4.875 4.875 0 01-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 013.182 3.182zM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 113.182-3.182z"></svg>', !1, !0, !1), xF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), SF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"></svg>', !1, !0, !1), CF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 01-.98-.314l-.295-.295a1.125 1.125 0 010-1.591l.13-.132a1.125 1.125 0 011.3-.21l.603.302a.809.809 0 001.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 001.528-1.732l.146-.292M6.115 5.19A9 9 0 1017.18 4.64M6.115 5.19A8.965 8.965 0 0112 3c1.929 0 3.716.607 5.18 1.64"></svg>', !1, !0, !1), EF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 01-1.161.886l-.143.048a1.107 1.107 0 00-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 01-1.652.928l-.679-.906a1.125 1.125 0 00-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 00-8.862 12.872M12.75 3.031a9 9 0 016.69 14.036m0 0l-.177-.529A2.25 2.25 0 0017.128 15H16.5l-.324-.324a1.453 1.453 0 00-2.328.377l-.036.073a1.586 1.586 0 01-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 01-5.276 3.67m0 0a9 9 0 01-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"></svg>', !1, !0, !1), AF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525"></svg>', !1, !0, !1), TF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.05 4.575a1.575 1.575 0 10-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 013.15 0v1.5m-3.15 0l.075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 013.15 0V15M6.9 7.575a1.575 1.575 0 10-3.15 0v8.175a6.75 6.75 0 006.75 6.75h2.018a5.25 5.25 0 003.712-1.538l1.732-1.732a5.25 5.25 0 001.538-3.712l.003-2.024a.668.668 0 01.198-.471 1.575 1.575 0 10-2.228-2.228 3.818 3.818 0 00-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0116.35 15m.002 0h-.002"></svg>', !1, !0, !1), OF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 15h2.25m8.024-9.75c.011.05.028.1.052.148.591 1.2.924 2.55.924 3.977a8.96 8.96 0 01-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398C20.613 14.547 19.833 15 19 15h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 00.303-.54m.023-8.25H16.48a4.5 4.5 0 01-1.423-.23l-3.114-1.04a4.5 4.5 0 00-1.423-.23H6.504c-.618 0-1.217.247-1.605.729A11.95 11.95 0 002.25 12c0 .434.023.863.068 1.285C2.427 14.306 3.346 15 4.372 15h3.126c.618 0 .991.724.725 1.282A7.471 7.471 0 007.5 19.5a2.25 2.25 0 002.25 2.25.75.75 0 00.75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 002.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384"></svg>', !1, !0, !1), IF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"></svg>', !1, !0, !1), PF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5"></svg>', !1, !0, !1), NF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"></svg>', !1, !0, !1), DF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"></svg>', !1, !0, !1), MF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"></svg>', !1, !0, !1), RF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"></svg>', !1, !0, !1), LF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"></svg>', !1, !0, !1), FF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0021.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), jF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"></svg>', !1, !0, !1), zF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></svg>', !1, !0, !1), VF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"></svg>', !1, !0, !1), UF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"></svg>', !1, !0, !1), qF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.712 4.33a9.027 9.027 0 011.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 00-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 010 9.424m-4.138-5.976a3.736 3.736 0 00-.88-1.388 3.737 3.737 0 00-1.388-.88m2.268 2.268a3.765 3.765 0 010 2.528m-2.268-4.796a3.765 3.765 0 00-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 01-1.388.88m2.268-2.268l4.138 3.448m0 0a9.027 9.027 0 01-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0l-3.448-4.138m3.448 4.138a9.014 9.014 0 01-9.424 0m5.976-4.138a3.765 3.765 0 01-2.528 0m0 0a3.736 3.736 0 01-1.388-.88 3.737 3.737 0 01-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 01-1.652-1.306 9.027 9.027 0 01-1.306-1.652m0 0l4.138-3.448M4.33 16.712a9.014 9.014 0 010-9.424m4.138 5.976a3.765 3.765 0 010-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 011.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 00-1.652 1.306A9.025 9.025 0 004.33 7.288"></svg>', !1, !0, !1), BF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"></svg>', !1, !0, !1), HF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"></svg>', !1, !0, !1), WF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), QF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), KF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), GF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 15.75l-2.489-2.489m0 0a3.375 3.375 0 10-4.773-4.773 3.375 3.375 0 004.774 4.774zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), ZF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM13.5 10.5h-6"></svg>', !1, !0, !1), YF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"></svg>', !1, !0, !1), JF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"></svg>', !1, !0, !1), XF = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), ej = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"></svg>', !1, !0, !1), tj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"></svg>', !1, !0, !1), rj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"></svg>', !1, !0, !1), nj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z"></svg>', !1, !0, !1), ij = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), aj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18 12H6"></svg>', !1, !0, !1), oj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.5 12h-15"></svg>', !1, !0, !1), sj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"></svg>', !1, !0, !1), lj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"></svg>', !1, !0, !1), dj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"></svg>', !1, !0, !1), cj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></svg>', !1, !0, !1), uj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"></svg>', !1, !0, !1), hj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"></svg>', !1, !0, !1), fj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"></svg>', !1, !0, !1), pj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), mj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 5.25v13.5m-7.5-13.5v13.5"></svg>', !1, !0, !1), gj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"></svg>', !1, !0, !1), vj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"></svg>', !1, !0, !1), yj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), bj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M20.25 3.75v4.5m0-4.5h-4.5m4.5 0l-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), wj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 3.75L18 6m0 0l2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"></svg>', !1, !0, !1), $j = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"></svg>', !1, !0, !1), kj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), F$ = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), _j = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"></svg>', !1, !0, !1), xj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 010 1.954l-7.108 4.061A1.125 1.125 0 013 16.811z"></svg>', !1, !0, !1), Sj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"></svg>', !1, !0, !1), Cj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), Ej = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 6v12m6-6H6"></svg>', !1, !0, !1), Aj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 4.5v15m7.5-7.5h-15"></svg>', !1, !0, !1), Tj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.636 5.636a9 9 0 1012.728 0M12 3v9"></svg>', !1, !0, !1), Oj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"></svg>', !1, !0, !1), Ij = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"></svg>', !1, !0, !1), Pj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"></svg>', !1, !0, !1), Nj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z"></svg>', !1, !0, !1), Dj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"></svg>', !1, !0, !1), Mj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"></svg>', !1, !0, !1), Rj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"></svg>', !1, !0, !1), Lj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"></svg>', !1, !0, !1), Fj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 7.5l16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 004.5 21h15a2.25 2.25 0 002.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0012 6.75zm-1.683 6.443l-.005.005-.006-.005.006-.005.005.005zm-.005 2.127l-.005-.006.005-.005.005.005-.005.005zm-2.116-.006l-.005.006-.006-.006.005-.005.006.005zm-.005-2.116l-.006-.005.006-.005.005.005-.005.005zM9.255 10.5v.008h-.008V10.5h.008zm3.249 1.88l-.007.004-.003-.007.006-.003.004.006zm-1.38 5.126l-.003-.006.006-.004.004.007-.006.003zm.007-6.501l-.003.006-.007-.003.004-.007.006.004zm1.37 5.129l-.007-.004.004-.006.006.003-.004.007zm.504-1.877h-.008v-.007h.008v.007zM9.255 18v.008h-.008V18h.008zm-3.246-1.87l-.007.004L6 16.127l.006-.003.004.006zm1.366-5.119l-.004-.006.006-.004.004.007-.006.003zM7.38 17.5l-.003.006-.007-.003.004-.007.006.004zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007zm-.5 1.873h-.008v-.007h.008v.007zM17.25 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zm0 4.5a.75.75 0 110-1.5.75.75 0 010 1.5z"></svg>', !1, !0, !1), jj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), zj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 9.75h4.875a2.625 2.625 0 010 5.25H12M8.25 9.75L10.5 7.5M8.25 9.75L10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185z"></svg>', !1, !0, !1), Vj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"></svg>', !1, !0, !1), Uj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"></svg>', !1, !0, !1), qj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></svg>', !1, !0, !1), Bj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12.75 19.5v-.75a7.5 7.5 0 00-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), Hj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971z"></svg>', !1, !0, !1), Wj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.848 8.25l1.536.887M7.848 8.25a3 3 0 11-5.196-3 3 3 0 015.196 3zm1.536.887a2.165 2.165 0 011.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 11-5.196 3 3 3 0 015.196-3zm1.536-.887a2.165 2.165 0 001.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863l2.077-1.199m0-3.328a4.323 4.323 0 012.068-1.379l5.325-1.628a4.5 4.5 0 012.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.331 4.331 0 0010.607 12m3.736 0l7.794 4.5-.802.215a4.5 4.5 0 01-2.48-.043l-5.326-1.629a4.324 4.324 0 01-2.068-1.379M14.343 12l-2.882 1.664"></svg>', !1, !0, !1), Qj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), Kj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), Gj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"></svg>', !1, !0, !1), Zj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"></svg>', !1, !0, !1), Yj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"></svg>', !1, !0, !1), Jj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), Xj = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></svg>', !1, !0, !1), ez = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 3l8.735 8.735m0 0a.374.374 0 11.53.53m-.53-.53l.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 010 5.304m2.121-7.425a6.75 6.75 0 010 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 01-1.06-2.122m-1.061 4.243a6.75 6.75 0 01-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12z"></svg>', !1, !0, !1), tz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.789m13.788 0c3.808 3.808 3.808 9.981 0 13.79M12 12h.008v.007H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></svg>', !1, !0, !1), rz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"></svg>', !1, !0, !1), nz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z"></svg>', !1, !0, !1), iz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6l4.72-4.72a.75.75 0 011.28.531V19.94a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.506-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.395C2.806 8.757 3.63 8.25 4.51 8.25H6.75z"></svg>', !1, !0, !1), az = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"></svg>', !1, !0, !1), oz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"></svg>', !1, !0, !1), sz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"></svg>', !1, !0, !1), lz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), dz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"></svg>', !1, !0, !1), cz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 019 14.437V9.564z"></svg>', !1, !0, !1), uz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"></svg>', !1, !0, !1), hz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"></svg>', !1, !0, !1), fz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"></svg>', !1, !0, !1), pz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"></svg>', !1, !0, !1), mz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"></svg>', !1, !0, !1), gz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 6h.008v.008H6V6z"></svg>', !1, !0, !1), vz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"></svg>', !1, !0, !1), yz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"></svg>', !1, !0, !1), bz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"></svg>', !1, !0, !1), wz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></svg>', !1, !0, !1), $z = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), kz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), _z = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"></svg>', !1, !0, !1), xz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></svg>', !1, !0, !1), Sz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></svg>', !1, !0, !1), Cz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"></svg>', !1, !0, !1), Ez = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></svg>', !1, !0, !1), Az = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.745 3A23.933 23.933 0 003 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 011.105.402l2.402 7.206a.75.75 0 001.104.401l1.445-.889m-8.25.75l.213.09a1.687 1.687 0 002.062-.617l4.45-6.676a1.688 1.688 0 012.062-.618l.213.09"></svg>', !1, !0, !1), Tz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 00-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"></svg>', !1, !0, !1), Oz = /* @__PURE__ */ k('<svg><path stroke-linecap=round d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"></svg>', !1, !0, !1), Iz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z"></svg>', !1, !0, !1), Pz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z"></svg>', !1, !0, !1), Nz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"></svg>', !1, !0, !1), Dz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"></svg>', !1, !0, !1), Mz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z"></svg>', !1, !0, !1), Rz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), Lz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M21.75 6.75a4.5 4.5 0 01-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 11-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 016.336-4.486l-3.276 3.276a3.004 3.004 0 002.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852z"></svg>', !1, !0, !1), Fz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M4.867 19.125h.008v.008h-.008v-.008z"></svg>', !1, !0, !1), jz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></svg>', !1, !0, !1), zz = /* @__PURE__ */ k('<svg><path stroke-linecap=round stroke-linejoin=round d="M6 18L18 6M6 6l12 12"></svg>', !1, !0, !1);
const Vz = {
  path: () => hM(),
  outline: !0,
  mini: !1
}, Uz = {
  path: () => fM(),
  outline: !0,
  mini: !1
}, qz = {
  path: () => pM(),
  outline: !0,
  mini: !1
}, Bz = {
  path: () => mM(),
  outline: !0,
  mini: !1
}, Hz = {
  path: () => gM(),
  outline: !0,
  mini: !1
}, Wz = {
  path: () => vM(),
  outline: !0,
  mini: !1
}, Qz = {
  path: () => yM(),
  outline: !0,
  mini: !1
}, Kz = {
  path: () => bM(),
  outline: !0,
  mini: !1
}, Gz = {
  path: () => wM(),
  outline: !0,
  mini: !1
}, Zz = {
  path: () => $M(),
  outline: !0,
  mini: !1
}, Yz = {
  path: () => kM(),
  outline: !0,
  mini: !1
}, Jz = {
  path: () => _M(),
  outline: !0,
  mini: !1
}, Xz = {
  path: () => xM(),
  outline: !0,
  mini: !1
}, eV = {
  path: () => SM(),
  outline: !0,
  mini: !1
}, tV = {
  path: () => CM(),
  outline: !0,
  mini: !1
}, rV = {
  path: () => EM(),
  outline: !0,
  mini: !1
}, nV = {
  path: () => AM(),
  outline: !0,
  mini: !1
}, iV = {
  path: () => TM(),
  outline: !0,
  mini: !1
}, aV = {
  path: () => OM(),
  outline: !0,
  mini: !1
}, oV = {
  path: () => IM(),
  outline: !0,
  mini: !1
}, sV = {
  path: () => PM(),
  outline: !0,
  mini: !1
}, lV = {
  path: () => NM(),
  outline: !0,
  mini: !1
}, dV = {
  path: () => DM(),
  outline: !0,
  mini: !1
}, cV = {
  path: () => MM(),
  outline: !0,
  mini: !1
}, uV = {
  path: () => RM(),
  outline: !0,
  mini: !1
}, hV = {
  path: () => LM(),
  outline: !0,
  mini: !1
}, fV = {
  path: () => FM(),
  outline: !0,
  mini: !1
}, pV = {
  path: () => jM(),
  outline: !0,
  mini: !1
}, mV = {
  path: () => zM(),
  outline: !0,
  mini: !1
}, gV = {
  path: () => VM(),
  outline: !0,
  mini: !1
}, vV = {
  path: () => UM(),
  outline: !0,
  mini: !1
}, yV = {
  path: () => qM(),
  outline: !0,
  mini: !1
}, bV = {
  path: () => BM(),
  outline: !0,
  mini: !1
}, wV = {
  path: () => HM(),
  outline: !0,
  mini: !1
}, $V = {
  path: () => WM(),
  outline: !0,
  mini: !1
}, kV = {
  path: () => QM(),
  outline: !0,
  mini: !1
}, _V = {
  path: () => KM(),
  outline: !0,
  mini: !1
}, xV = {
  path: () => GM(),
  outline: !0,
  mini: !1
}, SV = {
  path: () => ZM(),
  outline: !0,
  mini: !1
}, CV = {
  path: () => YM(),
  outline: !0,
  mini: !1
}, EV = {
  path: () => JM(),
  outline: !0,
  mini: !1
}, AV = {
  path: () => XM(),
  outline: !0,
  mini: !1
}, TV = {
  path: () => eR(),
  outline: !0,
  mini: !1
}, OV = {
  path: () => tR(),
  outline: !0,
  mini: !1
}, IV = {
  path: () => rR(),
  outline: !0,
  mini: !1
}, PV = {
  path: () => nR(),
  outline: !0,
  mini: !1
}, NV = {
  path: () => iR(),
  outline: !0,
  mini: !1
}, DV = {
  path: () => aR(),
  outline: !0,
  mini: !1
}, MV = {
  path: () => oR(),
  outline: !0,
  mini: !1
}, RV = {
  path: () => sR(),
  outline: !0,
  mini: !1
}, LV = {
  path: () => lR(),
  outline: !0,
  mini: !1
}, FV = {
  path: () => dR(),
  outline: !0,
  mini: !1
}, jV = {
  path: () => cR(),
  outline: !0,
  mini: !1
}, zV = {
  path: () => uR(),
  outline: !0,
  mini: !1
}, VV = {
  path: () => hR(),
  outline: !0,
  mini: !1
}, UV = {
  path: () => fR(),
  outline: !0,
  mini: !1
}, qV = {
  path: () => pR(),
  outline: !0,
  mini: !1
}, BV = {
  path: () => mR(),
  outline: !0,
  mini: !1
}, HV = {
  path: () => gR(),
  outline: !0,
  mini: !1
}, WV = {
  path: () => vR(),
  outline: !0,
  mini: !1
}, QV = {
  path: () => yR(),
  outline: !0,
  mini: !1
}, KV = {
  path: () => bR(),
  outline: !0,
  mini: !1
}, GV = {
  path: () => wR(),
  outline: !0,
  mini: !1
}, ZV = {
  path: () => $R(),
  outline: !0,
  mini: !1
}, YV = {
  path: () => kR(),
  outline: !0,
  mini: !1
}, JV = {
  path: () => _R(),
  outline: !0,
  mini: !1
}, XV = {
  path: () => xR(),
  outline: !0,
  mini: !1
}, eU = {
  path: () => SR(),
  outline: !0,
  mini: !1
}, tU = {
  path: () => CR(),
  outline: !0,
  mini: !1
}, rU = {
  path: () => ER(),
  outline: !0,
  mini: !1
}, nU = {
  path: () => AR(),
  outline: !0,
  mini: !1
}, iU = {
  path: () => TR(),
  outline: !0,
  mini: !1
}, aU = {
  path: () => OR(),
  outline: !0,
  mini: !1
}, oU = {
  path: () => IR(),
  outline: !0,
  mini: !1
}, sU = {
  path: () => PR(),
  outline: !0,
  mini: !1
}, lU = {
  path: () => NR(),
  outline: !0,
  mini: !1
}, dU = {
  path: () => DR(),
  outline: !0,
  mini: !1
}, cU = {
  path: () => MR(),
  outline: !0,
  mini: !1
}, uU = {
  path: () => RR(),
  outline: !0,
  mini: !1
}, hU = {
  path: () => LR(),
  outline: !0,
  mini: !1
}, fU = {
  path: () => FR(),
  outline: !0,
  mini: !1
}, pU = {
  path: () => jR(),
  outline: !0,
  mini: !1
}, mU = {
  path: () => zR(),
  outline: !0,
  mini: !1
}, gU = {
  path: () => [VR(), UR()],
  outline: !0,
  mini: !1
}, vU = {
  path: () => qR(),
  outline: !0,
  mini: !1
}, yU = {
  path: () => BR(),
  outline: !0,
  mini: !1
}, bU = {
  path: () => [HR(), WR()],
  outline: !0,
  mini: !1
}, wU = {
  path: () => QR(),
  outline: !0,
  mini: !1
}, $U = {
  path: () => KR(),
  outline: !0,
  mini: !1
}, kU = {
  path: () => GR(),
  outline: !0,
  mini: !1
}, _U = {
  path: () => ZR(),
  outline: !0,
  mini: !1
}, xU = {
  path: () => YR(),
  outline: !0,
  mini: !1
}, SU = {
  path: () => JR(),
  outline: !0,
  mini: !1
}, CU = {
  path: () => XR(),
  outline: !0,
  mini: !1
}, EU = {
  path: () => eL(),
  outline: !0,
  mini: !1
}, AU = {
  path: () => tL(),
  outline: !0,
  mini: !1
}, TU = {
  path: () => rL(),
  outline: !0,
  mini: !1
}, OU = {
  path: () => nL(),
  outline: !0,
  mini: !1
}, IU = {
  path: () => iL(),
  outline: !0,
  mini: !1
}, PU = {
  path: () => aL(),
  outline: !0,
  mini: !1
}, NU = {
  path: () => oL(),
  outline: !0,
  mini: !1
}, DU = {
  path: () => sL(),
  outline: !0,
  mini: !1
}, MU = {
  path: () => lL(),
  outline: !0,
  mini: !1
}, RU = {
  path: () => dL(),
  outline: !0,
  mini: !1
}, LU = {
  path: () => cL(),
  outline: !0,
  mini: !1
}, FU = {
  path: () => uL(),
  outline: !0,
  mini: !1
}, jU = {
  path: () => hL(),
  outline: !0,
  mini: !1
}, zU = {
  path: () => fL(),
  outline: !0,
  mini: !1
}, VU = {
  path: () => pL(),
  outline: !0,
  mini: !1
}, UU = {
  path: () => mL(),
  outline: !0,
  mini: !1
}, qU = {
  path: () => gL(),
  outline: !0,
  mini: !1
}, BU = {
  path: () => vL(),
  outline: !0,
  mini: !1
}, HU = {
  path: () => yL(),
  outline: !0,
  mini: !1
}, WU = {
  path: () => bL(),
  outline: !0,
  mini: !1
}, QU = {
  path: () => wL(),
  outline: !0,
  mini: !1
}, KU = {
  path: () => $L(),
  outline: !0,
  mini: !1
}, GU = {
  path: () => kL(),
  outline: !0,
  mini: !1
}, ZU = {
  path: () => [_L(), n3()],
  outline: !0,
  mini: !1
}, YU = {
  path: () => [xL(), n3()],
  outline: !0,
  mini: !1
}, JU = {
  path: () => SL(),
  outline: !0,
  mini: !1
}, XU = {
  path: () => CL(),
  outline: !0,
  mini: !1
}, eq = {
  path: () => EL(),
  outline: !0,
  mini: !1
}, tq = {
  path: () => AL(),
  outline: !0,
  mini: !1
}, rq = {
  path: () => TL(),
  outline: !0,
  mini: !1
}, nq = {
  path: () => OL(),
  outline: !0,
  mini: !1
}, iq = {
  path: () => IL(),
  outline: !0,
  mini: !1
}, aq = {
  path: () => PL(),
  outline: !0,
  mini: !1
}, oq = {
  path: () => NL(),
  outline: !0,
  mini: !1
}, sq = {
  path: () => DL(),
  outline: !0,
  mini: !1
}, lq = {
  path: () => ML(),
  outline: !0,
  mini: !1
}, dq = {
  path: () => RL(),
  outline: !0,
  mini: !1
}, cq = {
  path: () => LL(),
  outline: !0,
  mini: !1
}, uq = {
  path: () => FL(),
  outline: !0,
  mini: !1
}, hq = {
  path: () => jL(),
  outline: !0,
  mini: !1
}, fq = {
  path: () => zL(),
  outline: !0,
  mini: !1
}, pq = {
  path: () => VL(),
  outline: !0,
  mini: !1
}, mq = {
  path: () => UL(),
  outline: !0,
  mini: !1
}, gq = {
  path: () => qL(),
  outline: !0,
  mini: !1
}, vq = {
  path: () => BL(),
  outline: !0,
  mini: !1
}, yq = {
  path: () => HL(),
  outline: !0,
  mini: !1
}, bq = {
  path: () => WL(),
  outline: !0,
  mini: !1
}, wq = {
  path: () => QL(),
  outline: !0,
  mini: !1
}, $q = {
  path: () => KL(),
  outline: !0,
  mini: !1
}, kq = {
  path: () => GL(),
  outline: !0,
  mini: !1
}, _q = {
  path: () => ZL(),
  outline: !0,
  mini: !1
}, xq = {
  path: () => YL(),
  outline: !0,
  mini: !1
}, Sq = {
  path: () => JL(),
  outline: !0,
  mini: !1
}, Cq = {
  path: () => XL(),
  outline: !0,
  mini: !1
}, Eq = {
  path: () => eF(),
  outline: !0,
  mini: !1
}, Aq = {
  path: () => tF(),
  outline: !0,
  mini: !1
}, Tq = {
  path: () => rF(),
  outline: !0,
  mini: !1
}, Oq = {
  path: () => nF(),
  outline: !0,
  mini: !1
}, Iq = {
  path: () => iF(),
  outline: !0,
  mini: !1
}, Pq = {
  path: () => aF(),
  outline: !0,
  mini: !1
}, Nq = {
  path: () => oF(),
  outline: !0,
  mini: !1
}, Dq = {
  path: () => [sF(), n3()],
  outline: !0,
  mini: !1
}, Mq = {
  path: () => lF(),
  outline: !0,
  mini: !1
}, Rq = {
  path: () => dF(),
  outline: !0,
  mini: !1
}, Lq = {
  path: () => cF(),
  outline: !0,
  mini: !1
}, Fq = {
  path: () => uF(),
  outline: !0,
  mini: !1
}, jq = {
  path: () => [hF(), fF()],
  outline: !0,
  mini: !1
}, zq = {
  path: () => pF(),
  outline: !0,
  mini: !1
}, Vq = {
  path: () => mF(),
  outline: !0,
  mini: !1
}, Uq = {
  path: () => gF(),
  outline: !0,
  mini: !1
}, qq = {
  path: () => vF(),
  outline: !0,
  mini: !1
}, Bq = {
  path: () => yF(),
  outline: !0,
  mini: !1
}, Hq = {
  path: () => bF(),
  outline: !0,
  mini: !1
}, Wq = {
  path: () => wF(),
  outline: !0,
  mini: !1
}, Qq = {
  path: () => $F(),
  outline: !0,
  mini: !1
}, Kq = {
  path: () => kF(),
  outline: !0,
  mini: !1
}, Gq = {
  path: () => _F(),
  outline: !0,
  mini: !1
}, Zq = {
  path: () => xF(),
  outline: !0,
  mini: !1
}, Yq = {
  path: () => SF(),
  outline: !0,
  mini: !1
}, Jq = {
  path: () => CF(),
  outline: !0,
  mini: !1
}, Xq = {
  path: () => EF(),
  outline: !0,
  mini: !1
}, eB = {
  path: () => AF(),
  outline: !0,
  mini: !1
}, tB = {
  path: () => TF(),
  outline: !0,
  mini: !1
}, rB = {
  path: () => OF(),
  outline: !0,
  mini: !1
}, nB = {
  path: () => IF(),
  outline: !0,
  mini: !1
}, iB = {
  path: () => PF(),
  outline: !0,
  mini: !1
}, aB = {
  path: () => NF(),
  outline: !0,
  mini: !1
}, oB = {
  path: () => DF(),
  outline: !0,
  mini: !1
}, sB = {
  path: () => MF(),
  outline: !0,
  mini: !1
}, lB = {
  path: () => RF(),
  outline: !0,
  mini: !1
}, dB = {
  path: () => LF(),
  outline: !0,
  mini: !1
}, cB = {
  path: () => FF(),
  outline: !0,
  mini: !1
}, uB = {
  path: () => jF(),
  outline: !0,
  mini: !1
}, hB = {
  path: () => zF(),
  outline: !0,
  mini: !1
}, fB = {
  path: () => VF(),
  outline: !0,
  mini: !1
}, pB = {
  path: () => UF(),
  outline: !0,
  mini: !1
}, mB = {
  path: () => qF(),
  outline: !0,
  mini: !1
}, gB = {
  path: () => BF(),
  outline: !0,
  mini: !1
}, vB = {
  path: () => HF(),
  outline: !0,
  mini: !1
}, yB = {
  path: () => WF(),
  outline: !0,
  mini: !1
}, bB = {
  path: () => QF(),
  outline: !0,
  mini: !1
}, wB = {
  path: () => KF(),
  outline: !0,
  mini: !1
}, $B = {
  path: () => GF(),
  outline: !0,
  mini: !1
}, kB = {
  path: () => ZF(),
  outline: !0,
  mini: !1
}, _B = {
  path: () => YF(),
  outline: !0,
  mini: !1
}, xB = {
  path: () => JF(),
  outline: !0,
  mini: !1
}, SB = {
  path: () => [XF(), ej()],
  outline: !0,
  mini: !1
}, CB = {
  path: () => tj(),
  outline: !0,
  mini: !1
}, EB = {
  path: () => rj(),
  outline: !0,
  mini: !1
}, AB = {
  path: () => nj(),
  outline: !0,
  mini: !1
}, TB = {
  path: () => ij(),
  outline: !0,
  mini: !1
}, OB = {
  path: () => aj(),
  outline: !0,
  mini: !1
}, IB = {
  path: () => oj(),
  outline: !0,
  mini: !1
}, PB = {
  path: () => sj(),
  outline: !0,
  mini: !1
}, NB = {
  path: () => lj(),
  outline: !0,
  mini: !1
}, DB = {
  path: () => dj(),
  outline: !0,
  mini: !1
}, MB = {
  path: () => cj(),
  outline: !0,
  mini: !1
}, RB = {
  path: () => uj(),
  outline: !0,
  mini: !1
}, LB = {
  path: () => hj(),
  outline: !0,
  mini: !1
}, FB = {
  path: () => fj(),
  outline: !0,
  mini: !1
}, jB = {
  path: () => pj(),
  outline: !0,
  mini: !1
}, zB = {
  path: () => mj(),
  outline: !0,
  mini: !1
}, VB = {
  path: () => gj(),
  outline: !0,
  mini: !1
}, UB = {
  path: () => vj(),
  outline: !0,
  mini: !1
}, qB = {
  path: () => yj(),
  outline: !0,
  mini: !1
}, BB = {
  path: () => bj(),
  outline: !0,
  mini: !1
}, HB = {
  path: () => wj(),
  outline: !0,
  mini: !1
}, WB = {
  path: () => $j(),
  outline: !0,
  mini: !1
}, QB = {
  path: () => kj(),
  outline: !0,
  mini: !1
}, KB = {
  path: () => [F$(), _j()],
  outline: !0,
  mini: !1
}, GB = {
  path: () => xj(),
  outline: !0,
  mini: !1
}, ZB = {
  path: () => Sj(),
  outline: !0,
  mini: !1
}, YB = {
  path: () => Cj(),
  outline: !0,
  mini: !1
}, JB = {
  path: () => Ej(),
  outline: !0,
  mini: !1
}, XB = {
  path: () => Aj(),
  outline: !0,
  mini: !1
}, eH = {
  path: () => Tj(),
  outline: !0,
  mini: !1
}, tH = {
  path: () => Oj(),
  outline: !0,
  mini: !1
}, rH = {
  path: () => Ij(),
  outline: !0,
  mini: !1
}, nH = {
  path: () => Pj(),
  outline: !0,
  mini: !1
}, iH = {
  path: () => Nj(),
  outline: !0,
  mini: !1
}, aH = {
  path: () => [Dj(), Mj()],
  outline: !0,
  mini: !1
}, oH = {
  path: () => Rj(),
  outline: !0,
  mini: !1
}, sH = {
  path: () => Lj(),
  outline: !0,
  mini: !1
}, lH = {
  path: () => Fj(),
  outline: !0,
  mini: !1
}, dH = {
  path: () => jj(),
  outline: !0,
  mini: !1
}, cH = {
  path: () => zj(),
  outline: !0,
  mini: !1
}, uH = {
  path: () => Vj(),
  outline: !0,
  mini: !1
}, hH = {
  path: () => Uj(),
  outline: !0,
  mini: !1
}, fH = {
  path: () => qj(),
  outline: !0,
  mini: !1
}, pH = {
  path: () => Bj(),
  outline: !0,
  mini: !1
}, mH = {
  path: () => Hj(),
  outline: !0,
  mini: !1
}, gH = {
  path: () => Wj(),
  outline: !0,
  mini: !1
}, vH = {
  path: () => Qj(),
  outline: !0,
  mini: !1
}, yH = {
  path: () => Kj(),
  outline: !0,
  mini: !1
}, bH = {
  path: () => Gj(),
  outline: !0,
  mini: !1
}, wH = {
  path: () => Zj(),
  outline: !0,
  mini: !1
}, $H = {
  path: () => Yj(),
  outline: !0,
  mini: !1
}, kH = {
  path: () => Jj(),
  outline: !0,
  mini: !1
}, _H = {
  path: () => Xj(),
  outline: !0,
  mini: !1
}, xH = {
  path: () => ez(),
  outline: !0,
  mini: !1
}, SH = {
  path: () => tz(),
  outline: !0,
  mini: !1
}, CH = {
  path: () => rz(),
  outline: !0,
  mini: !1
}, EH = {
  path: () => nz(),
  outline: !0,
  mini: !1
}, AH = {
  path: () => iz(),
  outline: !0,
  mini: !1
}, TH = {
  path: () => az(),
  outline: !0,
  mini: !1
}, OH = {
  path: () => oz(),
  outline: !0,
  mini: !1
}, IH = {
  path: () => sz(),
  outline: !0,
  mini: !1
}, PH = {
  path: () => lz(),
  outline: !0,
  mini: !1
}, NH = {
  path: () => dz(),
  outline: !0,
  mini: !1
}, DH = {
  path: () => [F$(), cz()],
  outline: !0,
  mini: !1
}, MH = {
  path: () => uz(),
  outline: !0,
  mini: !1
}, RH = {
  path: () => hz(),
  outline: !0,
  mini: !1
}, LH = {
  path: () => fz(),
  outline: !0,
  mini: !1
}, FH = {
  path: () => pz(),
  outline: !0,
  mini: !1
}, jH = {
  path: () => [mz(), gz()],
  outline: !0,
  mini: !1
}, zH = {
  path: () => vz(),
  outline: !0,
  mini: !1
}, VH = {
  path: () => yz(),
  outline: !0,
  mini: !1
}, UH = {
  path: () => bz(),
  outline: !0,
  mini: !1
}, qH = {
  path: () => wz(),
  outline: !0,
  mini: !1
}, BH = {
  path: () => $z(),
  outline: !0,
  mini: !1
}, HH = {
  path: () => kz(),
  outline: !0,
  mini: !1
}, WH = {
  path: () => _z(),
  outline: !0,
  mini: !1
}, QH = {
  path: () => xz(),
  outline: !0,
  mini: !1
}, KH = {
  path: () => Sz(),
  outline: !0,
  mini: !1
}, GH = {
  path: () => Cz(),
  outline: !0,
  mini: !1
}, ZH = {
  path: () => Ez(),
  outline: !0,
  mini: !1
}, YH = {
  path: () => Az(),
  outline: !0,
  mini: !1
}, JH = {
  path: () => Tz(),
  outline: !0,
  mini: !1
}, XH = {
  path: () => Oz(),
  outline: !0,
  mini: !1
}, eW = {
  path: () => Iz(),
  outline: !0,
  mini: !1
}, tW = {
  path: () => Pz(),
  outline: !0,
  mini: !1
}, rW = {
  path: () => Nz(),
  outline: !0,
  mini: !1
}, nW = {
  path: () => Dz(),
  outline: !0,
  mini: !1
}, iW = {
  path: () => Mz(),
  outline: !0,
  mini: !1
}, aW = {
  path: () => Rz(),
  outline: !0,
  mini: !1
}, oW = {
  path: () => [Lz(), Fz()],
  outline: !0,
  mini: !1
}, sW = {
  path: () => jz(),
  outline: !0,
  mini: !1
}, lW = {
  path: () => zz(),
  outline: !0,
  mini: !1
}, dW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  academicCap: Vz,
  adjustmentsHorizontal: Uz,
  adjustmentsVertical: qz,
  archiveBox: Wz,
  archiveBoxArrowDown: Bz,
  archiveBoxXMark: Hz,
  arrowDown: Xz,
  arrowDownCircle: Qz,
  arrowDownLeft: Kz,
  arrowDownOnSquare: Zz,
  arrowDownOnSquareStack: Gz,
  arrowDownRight: Yz,
  arrowDownTray: Jz,
  arrowLeft: rV,
  arrowLeftCircle: eV,
  arrowLeftOnRectangle: tV,
  arrowLongDown: nV,
  arrowLongLeft: iV,
  arrowLongRight: aV,
  arrowLongUp: oV,
  arrowPath: lV,
  arrowPathRoundedSquare: sV,
  arrowRight: uV,
  arrowRightCircle: dV,
  arrowRightOnRectangle: cV,
  arrowSmallDown: hV,
  arrowSmallLeft: fV,
  arrowSmallRight: pV,
  arrowSmallUp: mV,
  arrowTopRightOnSquare: gV,
  arrowTrendingDown: vV,
  arrowTrendingUp: yV,
  arrowUp: SV,
  arrowUpCircle: bV,
  arrowUpLeft: wV,
  arrowUpOnSquare: kV,
  arrowUpOnSquareStack: $V,
  arrowUpRight: _V,
  arrowUpTray: xV,
  arrowUturnDown: CV,
  arrowUturnLeft: EV,
  arrowUturnRight: AV,
  arrowUturnUp: TV,
  arrowsPointingIn: OV,
  arrowsPointingOut: IV,
  arrowsRightLeft: PV,
  arrowsUpDown: NV,
  atSymbol: DV,
  backspace: MV,
  backward: RV,
  banknotes: LV,
  barsArrowDown: BV,
  barsArrowUp: HV,
  bars_2: FV,
  bars_3: UV,
  bars_3BottomLeft: jV,
  bars_3BottomRight: zV,
  bars_3CenterLeft: VV,
  bars_4: qV,
  battery_0: WV,
  battery_100: QV,
  battery_50: KV,
  beaker: GV,
  bell: XV,
  bellAlert: ZV,
  bellSlash: YV,
  bellSnooze: JV,
  bolt: tU,
  boltSlash: eU,
  bookOpen: rU,
  bookmark: aU,
  bookmarkSlash: nU,
  bookmarkSquare: iU,
  briefcase: oU,
  bugAnt: sU,
  buildingLibrary: lU,
  buildingOffice: cU,
  buildingOffice_2: dU,
  buildingStorefront: uU,
  cake: hU,
  calculator: fU,
  calendar: mU,
  calendarDays: pU,
  camera: gU,
  chartBar: yU,
  chartBarSquare: vU,
  chartPie: bU,
  chatBubbleBottomCenter: $U,
  chatBubbleBottomCenterText: wU,
  chatBubbleLeft: xU,
  chatBubbleLeftEllipsis: kU,
  chatBubbleLeftRight: _U,
  chatBubbleOvalLeft: CU,
  chatBubbleOvalLeftEllipsis: SU,
  check: TU,
  checkBadge: EU,
  checkCircle: AU,
  chevronDoubleDown: OU,
  chevronDoubleLeft: IU,
  chevronDoubleRight: PU,
  chevronDoubleUp: NU,
  chevronDown: DU,
  chevronLeft: MU,
  chevronRight: RU,
  chevronUp: FU,
  chevronUpDown: LU,
  circleStack: jU,
  clipboard: qU,
  clipboardDocument: UU,
  clipboardDocumentCheck: zU,
  clipboardDocumentList: VU,
  clock: BU,
  cloud: QU,
  cloudArrowDown: HU,
  cloudArrowUp: WU,
  codeBracket: GU,
  codeBracketSquare: KU,
  cog: JU,
  cog_6Tooth: ZU,
  cog_8Tooth: YU,
  commandLine: XU,
  computerDesktop: eq,
  cpuChip: tq,
  creditCard: rq,
  cube: iq,
  cubeTransparent: nq,
  currencyBangladeshi: aq,
  currencyDollar: oq,
  currencyEuro: sq,
  currencyPound: lq,
  currencyRupee: dq,
  currencyYen: cq,
  cursorArrowRays: uq,
  cursorArrowRipple: hq,
  devicePhoneMobile: fq,
  deviceTablet: pq,
  document: xq,
  documentArrowDown: mq,
  documentArrowUp: gq,
  documentChartBar: vq,
  documentCheck: yq,
  documentDuplicate: bq,
  documentMagnifyingGlass: wq,
  documentMinus: $q,
  documentPlus: kq,
  documentText: _q,
  ellipsisHorizontal: Cq,
  ellipsisHorizontalCircle: Sq,
  ellipsisVertical: Eq,
  envelope: Tq,
  envelopeOpen: Aq,
  exclamationCircle: Oq,
  exclamationTriangle: Iq,
  eye: Dq,
  eyeDropper: Pq,
  eyeSlash: Nq,
  faceFrown: Mq,
  faceSmile: Rq,
  film: Lq,
  fingerPrint: Fq,
  fire: jq,
  flag: zq,
  folder: Hq,
  folderArrowDown: Vq,
  folderMinus: Uq,
  folderOpen: qq,
  folderPlus: Bq,
  forward: Wq,
  funnel: Qq,
  gif: Kq,
  gift: Zq,
  giftTop: Gq,
  globeAlt: Yq,
  globeAmericas: Jq,
  globeAsiaAustralia: Xq,
  globeEuropeAfrica: eB,
  handRaised: tB,
  handThumbDown: rB,
  handThumbUp: nB,
  hashtag: iB,
  heart: aB,
  home: sB,
  homeModern: oB,
  identification: lB,
  inbox: uB,
  inboxArrowDown: dB,
  inboxStack: cB,
  informationCircle: hB,
  key: fB,
  language: pB,
  lifebuoy: mB,
  lightBulb: gB,
  link: vB,
  listBullet: yB,
  lockClosed: bB,
  lockOpen: wB,
  magnifyingGlass: xB,
  magnifyingGlassCircle: $B,
  magnifyingGlassMinus: kB,
  magnifyingGlassPlus: _B,
  map: CB,
  mapPin: SB,
  megaphone: EB,
  microphone: AB,
  minus: IB,
  minusCircle: TB,
  minusSmall: OB,
  moon: PB,
  musicalNote: NB,
  newspaper: DB,
  noSymbol: MB,
  paintBrush: RB,
  paperAirplane: LB,
  paperClip: FB,
  pause: zB,
  pauseCircle: jB,
  pencil: UB,
  pencilSquare: VB,
  phone: WB,
  phoneArrowDownLeft: qB,
  phoneArrowUpRight: BB,
  phoneXMark: HB,
  photo: QB,
  play: ZB,
  playCircle: KB,
  playPause: GB,
  plus: XB,
  plusCircle: YB,
  plusSmall: JB,
  power: eH,
  presentationChartBar: tH,
  presentationChartLine: rH,
  printer: nH,
  puzzlePiece: iH,
  qrCode: aH,
  questionMarkCircle: oH,
  queueList: sH,
  radio: lH,
  receiptPercent: dH,
  receiptRefund: cH,
  rectangleGroup: uH,
  rectangleStack: hH,
  rocketLaunch: fH,
  rss: pH,
  scale: mH,
  scissors: gH,
  server: yH,
  serverStack: vH,
  share: bH,
  shieldCheck: wH,
  shieldExclamation: $H,
  shoppingBag: kH,
  shoppingCart: _H,
  signal: SH,
  signalSlash: xH,
  sparkles: CH,
  speakerWave: EH,
  speakerXMark: AH,
  square_2Stack: TH,
  square_3Stack_3d: OH,
  squaresPlus: PH,
  squares_2x2: IH,
  star: NH,
  stop: MH,
  stopCircle: DH,
  sun: RH,
  swatch: LH,
  tableCells: FH,
  tag: jH,
  ticket: zH,
  trash: VH,
  trophy: UH,
  truck: qH,
  tv: BH,
  user: GH,
  userCircle: HH,
  userGroup: WH,
  userMinus: QH,
  userPlus: KH,
  users: ZH,
  variable: YH,
  videoCamera: XH,
  videoCameraSlash: JH,
  viewColumns: eW,
  viewfinderCircle: tW,
  wallet: rW,
  wifi: nW,
  window: iW,
  wrench: oW,
  wrenchScrewdriver: aW,
  xCircle: sW,
  xMark: lW
}, Symbol.toStringTag, { value: "Module" }));
function mt(e) {
  const t = it({
    size: "md",
    name: "exclamationMark"
  }, e), r = K(() => Yt(e.class, {
    "h-4 w-4": t.size === "sm",
    "h-6 w-6": t.size === "md",
    "h-8 w-8": t.size === "lg",
    "h-10 w-10": t.size === "xl"
  }));
  return g(H, {
    get when() {
      return e.name;
    },
    get children() {
      return g(uM, {
        get path() {
          return dW[t.name];
        },
        get class() {
          return r();
        },
        "aria-hidden": "true"
      });
    }
  });
}
const rh = /* @__PURE__ */ Symbol("store-raw"), Ll = /* @__PURE__ */ Symbol("store-node"), ha = /* @__PURE__ */ Symbol("store-has"), j$ = /* @__PURE__ */ Symbol("store-self");
function z$(e) {
  let t = e[Qr];
  if (!t && (Object.defineProperty(e, Qr, {
    value: t = new Proxy(e, hW)
  }), !Array.isArray(e))) {
    const r = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, a = r.length; i < a; i++) {
      const o = r[i];
      n[o].get && Object.defineProperty(e, o, {
        enumerable: n[o].enumerable,
        get: n[o].get.bind(t)
      });
    }
  }
  return t;
}
function ra(e) {
  let t;
  return e != null && typeof e == "object" && (e[Qr] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function Ss(e, t = /* @__PURE__ */ new Set()) {
  let r, n, i, a;
  if (r = e != null && e[rh]) return r;
  if (!ra(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      i = e[o], (n = Ss(i, t)) !== i && (e[o] = n);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, d = o.length; l < d; l++)
      a = o[l], !s[a].get && (i = e[a], (n = Ss(i, t)) !== i && (e[a] = n));
  }
  return e;
}
function nh(e, t) {
  let r = e[t];
  return r || Object.defineProperty(e, t, {
    value: r = /* @__PURE__ */ Object.create(null)
  }), r;
}
function lu(e, t, r) {
  if (e[t]) return e[t];
  const [n, i] = V(r, {
    equals: !1,
    internal: !0
  });
  return n.$ = i, e[t] = n;
}
function cW(e, t) {
  const r = Reflect.getOwnPropertyDescriptor(e, t);
  return !r || r.get || !r.configurable || t === Qr || t === Ll || (delete r.value, delete r.writable, r.get = () => e[Qr][t]), r;
}
function V$(e) {
  Ql() && lu(nh(e, Ll), j$)();
}
function uW(e) {
  return V$(e), Reflect.ownKeys(e);
}
const hW = {
  get(e, t, r) {
    if (t === rh) return e;
    if (t === Qr) return r;
    if (t === Bc)
      return V$(e), r;
    const n = nh(e, Ll), i = n[t];
    let a = i ? i() : e[t];
    if (t === Ll || t === ha || t === "__proto__") return a;
    if (!i) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      Ql() && (typeof a != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (a = lu(n, t, a)());
    }
    return ra(a) ? z$(a) : a;
  },
  has(e, t) {
    return t === rh || t === Qr || t === Bc || t === Ll || t === ha || t === "__proto__" ? !0 : (Ql() && lu(nh(e, ha), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: uW,
  getOwnPropertyDescriptor: cW
};
function Sn(e, t, r, n = !1) {
  if (!n && e[t] === r) return;
  const i = e[t], a = e.length;
  r === void 0 ? (delete e[t], e[ha] && e[ha][t] && i !== void 0 && e[ha][t].$()) : (e[t] = r, e[ha] && e[ha][t] && i === void 0 && e[ha][t].$());
  let o = nh(e, Ll), s;
  if ((s = lu(o, t, i)) && s.$(() => r), Array.isArray(e) && e.length !== a) {
    for (let l = e.length; l < a; l++) (s = o[l]) && s.$();
    (s = lu(o, "length", a)) && s.$(e.length);
  }
  (s = o[j$]) && s.$();
}
function U$(e, t) {
  const r = Object.keys(t);
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    Sn(e, i, t[i]);
  }
}
function fW(e, t) {
  if (typeof t == "function" && (t = t(e)), t = Ss(t), Array.isArray(t)) {
    if (e === t) return;
    let r = 0, n = t.length;
    for (; r < n; r++) {
      const i = t[r];
      e[r] !== i && Sn(e, r, i);
    }
    Sn(e, "length", n);
  } else U$(e, t);
}
function kc(e, t, r = []) {
  let n, i = e;
  if (t.length > 1) {
    n = t.shift();
    const o = typeof n, s = Array.isArray(e);
    if (Array.isArray(n)) {
      for (let l = 0; l < n.length; l++)
        kc(e, [n[l]].concat(t), r);
      return;
    } else if (s && o === "function") {
      for (let l = 0; l < e.length; l++)
        n(e[l], l) && kc(e, [l].concat(t), r);
      return;
    } else if (s && o === "object") {
      const {
        from: l = 0,
        to: d = e.length - 1,
        by: c = 1
      } = n;
      for (let u = l; u <= d; u += c)
        kc(e, [u].concat(t), r);
      return;
    } else if (t.length > 1) {
      kc(e[n], t, [n].concat(r));
      return;
    }
    i = e[n], r = [n].concat(r);
  }
  let a = t[0];
  typeof a == "function" && (a = a(i, r), a === i) || n === void 0 && a == null || (a = Ss(a), n === void 0 || ra(i) && ra(a) && !Array.isArray(a) ? U$(i, a) : Sn(e, n, a));
}
function js(...[e, t]) {
  const r = Ss(e || {}), n = Array.isArray(r), i = z$(r);
  function a(...o) {
    A1(() => {
      n && o.length === 1 ? fW(r, o[0]) : kc(r, o);
    });
  }
  return [i, a];
}
const rm = /* @__PURE__ */ Symbol("store-root");
function ll(e, t, r, n, i) {
  const a = t[r];
  if (e === a) return;
  const o = Array.isArray(e);
  if (r !== rm && (!ra(e) || !ra(a) || o !== Array.isArray(a) || i && e[i] !== a[i])) {
    Sn(t, r, e);
    return;
  }
  if (o) {
    if (e.length && a.length && (!n || i && e[0] && e[0][i] != null)) {
      let d, c, u, h, f, p, m, y;
      for (u = 0, h = Math.min(a.length, e.length); u < h && (a[u] === e[u] || i && a[u] && e[u] && a[u][i] && a[u][i] === e[u][i]); u++)
        ll(e[u], a, u, n, i);
      const v = new Array(e.length), b = /* @__PURE__ */ new Map();
      for (h = a.length - 1, f = e.length - 1; h >= u && f >= u && (a[h] === e[f] || i && a[h] && e[f] && a[h][i] && a[h][i] === e[f][i]); h--, f--)
        v[f] = a[h];
      if (u > f || u > h) {
        for (c = u; c <= f; c++) Sn(a, c, e[c]);
        for (; c < e.length; c++)
          Sn(a, c, v[c]), ll(e[c], a, c, n, i);
        a.length > e.length && Sn(a, "length", e.length);
        return;
      }
      for (m = new Array(f + 1), c = f; c >= u; c--)
        p = e[c], y = i && p ? p[i] : p, d = b.get(y), m[c] = d === void 0 ? -1 : d, b.set(y, c);
      for (d = u; d <= h; d++)
        p = a[d], y = i && p ? p[i] : p, c = b.get(y), c !== void 0 && c !== -1 && (v[c] = a[d], c = m[c], b.set(y, c));
      for (c = u; c < e.length; c++)
        c in v ? (Sn(a, c, v[c]), ll(e[c], a, c, n, i)) : Sn(a, c, e[c]);
    } else
      for (let d = 0, c = e.length; d < c; d++)
        ll(e[d], a, d, n, i);
    a.length > e.length && Sn(a, "length", e.length);
    return;
  }
  const s = Object.keys(e);
  for (let d = 0, c = s.length; d < c; d++)
    ll(e[s[d]], a, s[d], n, i);
  const l = Object.keys(a);
  for (let d = 0, c = l.length; d < c; d++)
    e[l[d]] === void 0 && Sn(a, l[d], void 0);
}
function pW(e, t = {}) {
  const {
    merge: r,
    key: n = "id"
  } = t, i = Ss(e);
  return (a) => {
    if (!ra(a) || !ra(i)) return i;
    const o = ll(i, {
      [rm]: a
    }, rm, r, n);
    return o === void 0 ? a : o;
  };
}
const ih = /* @__PURE__ */ new WeakMap(), q$ = {
  get(e, t) {
    if (t === rh) return e;
    const r = e[t];
    let n;
    return ra(r) ? ih.get(r) || (ih.set(r, n = new Proxy(r, q$)), n) : r;
  },
  set(e, t, r) {
    return Sn(e, t, Ss(r)), !0;
  },
  deleteProperty(e, t) {
    return Sn(e, t, void 0, !0), !0;
  }
};
function P0(e) {
  return (t) => {
    if (ra(t)) {
      let r;
      (r = ih.get(t)) || ih.set(t, r = new Proxy(t, q$)), e(r);
    }
    return t;
  };
}
var mW = /* @__PURE__ */ k('<span aria-hidden=true class="text-red-500 ml-0.5">*'), gW = /* @__PURE__ */ k('<span class="text-xs text-gray-400 ml-2">Optional'), vW = /* @__PURE__ */ k("<label>"), yW = /* @__PURE__ */ k('<div class="text-xs leading-6 text-gray-500">'), bW = /* @__PURE__ */ k("<p>"), wW = /* @__PURE__ */ k('<div><div class="flex justify-between items-center"><div></div></div><div class=h-6>');
const i3 = Gr([{
  id: "",
  error: "",
  loading: !1,
  disabled: !1,
  required: !1
}, {
  setError: () => {
  },
  setLoading: () => {
  },
  setDisabled: () => {
  },
  setRequired: () => {
  }
}]);
function $W(e) {
  const [t, r] = js({
    id: `input-${va()}`,
    error: e.error || "",
    loading: !1,
    disabled: !1,
    required: !1
  }), n = [t, {
    setError(i) {
      r("error", i);
    },
    setLoading(i) {
      r("loading", i);
    },
    setDisabled(i) {
      r("disabled", i);
    },
    setRequired(i) {
      r("required", i);
    }
  }];
  return g(i3.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}
function qu() {
  return wr(i3);
}
function kW(e) {
  const [t, {
    setError: r,
    setLoading: n,
    setDisabled: i,
    setRequired: a
  }] = wr(i3), o = () => e.error ? `${t.id}-error` : e.helpText ? `${t.id}-help` : void 0;
  fe(() => {
    r(e.error || "");
  }), fe(() => {
    n(e.loading || !1);
  }), fe(() => {
    i(e.disabled || !1);
  }), fe(() => {
    a(e.required || !1);
  });
  const s = K(() => typeof e.label == "string");
  return (() => {
    var l = wW(), d = l.firstChild, c = d.firstChild, u = d.nextSibling;
    return E(c, g(H, {
      get when() {
        return s();
      },
      get children() {
        var h = vW();
        return E(h, () => e.label, null), E(h, g(H, {
          get when() {
            return e.required;
          },
          get children() {
            return mW();
          }
        }), null), E(h, g(H, {
          get when() {
            return e.showOptionalSubtext;
          },
          get children() {
            return gW();
          }
        }), null), se((f) => {
          var p = `block text-sm font-normal leading-6 text-gray-700 pb-1 ${e?.subLabel ? "mb-0" : ""}`, m = t.id;
          return p !== f.e && ft(h, f.e = p), m !== f.t && pt(h, "for", f.t = m), f;
        }, {
          e: void 0,
          t: void 0
        }), h;
      }
    }), null), E(c, g(H, {
      get when() {
        return !s();
      },
      get children() {
        return e.label;
      }
    }), null), E(c, g(H, {
      get when() {
        return e?.subLabel;
      },
      get children() {
        var h = yW();
        return E(h, () => e.subLabel), h;
      }
    }), null), E(l, () => e.children, u), E(u, g(H, {
      get when() {
        return e.error || e.helpText;
      },
      get children() {
        var h = bW();
        return E(h, () => e.error || e.helpText), se((f) => {
          var p = `text-sm ${e.error ? "text-red-400" : "text-gray-500"}`, m = o();
          return p !== f.e && ft(h, f.e = p), m !== f.t && pt(h, "id", f.t = m), f;
        }, {
          e: void 0,
          t: void 0
        }), h;
      }
    })), l;
  })();
}
function at(e) {
  return g($W, {
    get error() {
      return e.error;
    },
    get children() {
      return g(kW, it(e, {
        get children() {
          return e.children;
        }
      }));
    }
  });
}
var _W = /* @__PURE__ */ k('<div role=status><svg aria-hidden=true viewBox="0 0 100 100"fill=none xmlns=http://www.w3.org/2000/svg><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"fill=currentColor></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"fill=currentFill></path></svg><span class=sr-only>Loading...');
function aa(e) {
  const t = it({
    size: "lg",
    color: "blue"
  }, e), r = Yt("text-gray-200 animate-spin dark:text-gray-600", {
    "fill-blue-500": t.color === "blue",
    "fill-green-500": t.color === "green",
    "w-4 h-4": t.size === "sm",
    "w-6 h-6": t.size === "md",
    "w-8 h-8": t.size === "lg",
    "w-12 h-12": t.size === "xl"
  });
  return (() => {
    var n = _W(), i = n.firstChild;
    return pt(i, "class", r), n;
  })();
}
var xW = /* @__PURE__ */ k('<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">'), SW = /* @__PURE__ */ k('<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">'), CW = /* @__PURE__ */ k('<div class="absolute inset-y-0 right-0 flex items-center pr-3"><button aria-label="Drop Down for more options">'), EW = /* @__PURE__ */ k('<div class="relative rounded-lg shadow-sm"><input autocomplete=off>');
function AW(e) {
  return typeof e == "string" ? e : typeof e == "number" ? e.toString() : Array.isArray(e) ? e.join(", ") : "";
}
function Dt(e) {
  const [t, r] = go(e, ["error", "copy"]), [n, i] = go(r, ["onInput"]), [a, o] = V(!1), [s] = qu(), l = K(() => {
    const c = s.disabled || i.disabled, u = t.error || s.error, h = i.readonly || i.readOnly;
    return Yt("block w-full rounded-lg border-0 py-3 px-4 ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none", {
      "pl-10": i.type === "email",
      "ring-red-300 placeholder:text-red-300 focus:ring-sky-500/40": !!u && !c,
      "text-gray-900 ring-gray-300 placeholder:text-gray-400 hover:ring-gray-400 focus:ring-sky-500/40": !u && !c,
      "focus:ring-2": !h,
      "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": i.disabled,
      "focus:ring-1 focus:ring-1  focus:outline-0 focus:ring-gray-300 bg-gray-50 text-gray-500 ring-gray-200": h,
      "cursor-pointer": e.pointer
    });
  }), d = (c) => {
    const u = c.currentTarget;
    !isNaN(u.valueAsNumber) && typeof n.onInput == "function" && n.onInput(c);
  };
  return fe(() => {
    a() && setTimeout(() => {
      o(!1);
    }, 1e3);
  }), (() => {
    var c = EW(), u = c.firstChild;
    return E(c, g(H, {
      get when() {
        return i.type === "email";
      },
      get children() {
        var h = xW();
        return E(h, g(mt, {
          name: "envelope",
          class: "h-5 w-5 text-gray-400",
          size: "sm"
        })), h;
      }
    }), u), ii(u, it({
      get id() {
        return s?.id;
      },
      get "aria-invalid"() {
        return !!(t.error || s.error) || void 0;
      },
      get "aria-describedby"() {
        return t.error || s.error ? `${s.id}-error` : void 0;
      },
      get onInput() {
        return i.type === "number" ? d : n.onInput;
      }
    }, i, {
      get required() {
        return s.required || i.required;
      },
      get class() {
        return l();
      }
    }), !1, !1), E(c, g(H, {
      get when() {
        return s.loading || i.loading;
      },
      get children() {
        var h = SW();
        return E(h, g(aa, {
          size: "sm"
        })), h;
      }
    }), null), E(c, g(H, {
      get when() {
        return t.copy;
      },
      get children() {
        var h = CW(), f = h.firstChild;
        return f.$$click = () => {
          navigator.clipboard.writeText(AW(i?.value)), o(!0);
        }, E(f, g(H, {
          get when() {
            return a();
          },
          get children() {
            return g(mt, {
              name: "check",
              class: "h-5 w-5 text-gray-400",
              size: "sm"
            });
          }
        }), null), E(f, g(H, {
          get when() {
            return !a();
          },
          get children() {
            return g(mt, {
              name: "clipboard",
              class: "h-5 w-5 text-gray-400",
              size: "sm"
            });
          }
        }), null), h;
      }
    }), null), c;
  })();
}
an(["click"]);
const B$ = [
  { id: "AL", name: "Alabama" },
  { id: "AK", name: "Alaska" },
  { id: "AZ", name: "Arizona" },
  { id: "AR", name: "Arkansas" },
  { id: "CA", name: "California" },
  { id: "CO", name: "Colorado" },
  { id: "CT", name: "Connecticut" },
  { id: "DE", name: "Delaware" },
  { id: "DC", name: "District Of Columbia" },
  { id: "FL", name: "Florida" },
  { id: "GA", name: "Georgia" },
  { id: "HI", name: "Hawaii" },
  { id: "ID", name: "Idaho" },
  { id: "IL", name: "Illinois" },
  { id: "IN", name: "Indiana" },
  { id: "IA", name: "Iowa" },
  { id: "KS", name: "Kansas" },
  { id: "KY", name: "Kentucky" },
  { id: "LA", name: "Louisiana" },
  { id: "ME", name: "Maine" },
  { id: "MD", name: "Maryland" },
  { id: "MA", name: "Massachusetts" },
  { id: "MI", name: "Michigan" },
  { id: "MN", name: "Minnesota" },
  { id: "MS", name: "Mississippi" },
  { id: "MO", name: "Missouri" },
  { id: "MT", name: "Montana" },
  { id: "NE", name: "Nebraska" },
  { id: "NV", name: "Nevada" },
  { id: "NH", name: "New Hampshire" },
  { id: "NJ", name: "New Jersey" },
  { id: "NM", name: "New Mexico" },
  { id: "NY", name: "New York" },
  { id: "NC", name: "North Carolina" },
  { id: "ND", name: "North Dakota" },
  { id: "OH", name: "Ohio" },
  { id: "OK", name: "Oklahoma" },
  { id: "OR", name: "Oregon" },
  { id: "PA", name: "Pennsylvania" },
  { id: "PR", name: "Puerto Rico" },
  { id: "RI", name: "Rhode Island" },
  { id: "SC", name: "South Carolina" },
  { id: "SD", name: "South Dakota" },
  { id: "TN", name: "Tennessee" },
  { id: "TX", name: "Texas" },
  { id: "UT", name: "Utah" },
  { id: "VT", name: "Vermont" },
  { id: "VA", name: "Virginia" },
  { id: "WA", name: "Washington" },
  { id: "WV", name: "West Virginia" },
  { id: "WI", name: "Wisconsin" },
  { id: "WY", name: "Wyoming" }
];
function Bi(e, t) {
  let r = {}, n = Object.keys(e);
  for (let i = 0, a = n.length; i < a; i += 1) {
    let o = n[i];
    t.includes(o) || Object.defineProperty(r, o, { get() {
      return e[o];
    }, configurable: !0, enumerable: !0 });
  }
  return r;
}
function Cs(e, t) {
  if (!e) throw t;
}
function nm(e, t) {
  return e === t || e !== e && t !== t;
}
function TW(e) {
  let [t, r] = V(), n, i, a = e.by || nm;
  if ("defaultValue" in e) {
    let [s, l] = V(e.defaultValue);
    n = s, i = (d) => {
      l(() => d), e.onChange && e.onChange(d);
    };
  } else n = K(() => e.value), i = (s) => {
    e.onChange && e.onChange(s);
  };
  let o = K(() => !!e.disabled);
  return { isSelected(s) {
    return nm(s, n());
  }, select(s) {
    Qe(o) || (e.toggleable && a(Qe(n), s) ? i(void 0) : i(s));
  }, hasSelected() {
    return n() != null;
  }, disabled: o, hasActive() {
    return !!t();
  }, isActive(s) {
    let l = t();
    return l ? a(s, l.value) : !1;
  }, focus(s) {
    Qe(o) || r({ value: s });
  }, blur() {
    Qe(o) || r(void 0);
  } };
}
function OW(e) {
  let [t, r] = V(), n, i, a = e.by || nm;
  if ("defaultValue" in e) {
    let [s, l] = V(e.defaultValue);
    n = s, i = (d) => {
      l(() => d), e.onChange && e.onChange(d);
    };
  } else n = K(() => e.value), i = (s) => {
    e.onChange && e.onChange(s);
  };
  let o = K(() => !!e.disabled);
  return { isSelected(s) {
    let l = n();
    for (let d = 0, c = l.length; d < c; d += 1) if (a(s, l[d])) return !0;
    return !1;
  }, select(s) {
    if (!Qe(o)) {
      let l = [], d = Qe(n), c = !1;
      for (let u = 0, h = d.length; u < h; u += 1) {
        let f = d[u], p = a(f, s);
        p && (c = !0), e.toggleable && p || l.push(f);
      }
      c || l.push(s), i(l);
    }
  }, hasSelected: K(() => n().length > 0), disabled: o, hasActive: K(() => !!t()), isActive(s) {
    let l = t();
    return l ? a(s, l.value) : !1;
  }, focus(s) {
    Qe(o) || r({ value: s });
  }, blur() {
    Qe(o) || r(void 0);
  } };
}
var H$ = Gr();
function W$(e) {
  return g(H$.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
function a3() {
  let e = wr(H$);
  return Cs(e, new Error("Missing <SelectStateProvider>")), e;
}
function af(e, t) {
  return g(j5, it({ get component() {
    return e();
  } }, t));
}
function IW(e) {
  return typeof e == "function";
}
function Bu(e) {
  let [t, r] = V();
  return fe(() => {
    let n = t();
    n && "ref" in e && IW(e.ref) && e.ref(n);
  }), [t, r];
}
function Ad(e) {
  return e ? "" : void 0;
}
function Hu(e) {
  return { get disabled() {
    return e();
  }, get "aria-disabled"() {
    return e();
  } };
}
function PW(e) {
  return { get "aria-expanded"() {
    return e();
  } };
}
function NW(e) {
  return { get "aria-selected"() {
    return e();
  } };
}
function Wu(e) {
  return { get "tc-disabled"() {
    return Ad(e());
  } };
}
function o3(e) {
  return { get "tc-expanded"() {
    return Ad(e());
  } };
}
function DW(e) {
  return { get "tc-selected"() {
    return Ad(e());
  } };
}
function MW(e) {
  return { get "tc-active"() {
    return Ad(e());
  } };
}
function s3(e) {
  return { get "tc-has-selected"() {
    return Ad(e());
  } };
}
function l3(e) {
  return { get "tc-has-active"() {
    return Ad(e());
  } };
}
function RW(e, t, r, n) {
  e.addEventListener(t, r, n), sr(() => {
    e.removeEventListener(t, r, n);
  });
}
var yn = RW, of = "tc", Q$ = `[${of}-disabled]`, LW = `[${of}-selected]`;
function Qu(e) {
  return { [`${of}-${e}`]: "" };
}
var FW = /* @__PURE__ */ new Set();
function jW(e) {
  for (let t of FW.keys()) t(e);
}
function o9(e) {
  return !e.matches(Q$);
}
function sf(e, t, r, n) {
  let i = t + r;
  if (n) {
    for (r === 1 && i === e.length && (i = 0), r === -1 && i === -1 && (i = e.length - 1); t !== i; ) {
      if (o9(e[i])) return e[i];
      i += r, r === 1 && i >= e.length && (i = 0), r === -1 && i < 0 && (i = e.length - 1);
    }
    return;
  }
  for (; i >= 0 && i < e.length; ) {
    if (o9(e[i])) return e[i];
    i += r;
  }
}
function Td(e, t) {
  return e && (t ? jW(e) : e.focus()), e;
}
function zW(e, t, r, n) {
  for (let i = 0, a = e.length; i < a; i += 1) if (t === e[i] || e[i].contains(t)) return Td(sf(e, i, 1, r), n);
}
function VW(e, t, r, n) {
  for (let i = 0, a = e.length; i < a; i += 1) if (e[i].contains(t)) return Td(sf(e, i, -1, r), n);
}
function UW(e, t) {
  if (e.length) return Td(sf(e, -1, 1, !1), t);
}
function qW(e, t) {
  if (e.length) return Td(sf(e, e.length, -1, !1), t);
}
function BW(e, t, r) {
  let n = t.toLowerCase();
  for (let i = 0, a = e.length; i < a; i += 1) {
    let o = e[i].textContent;
    if (o != null && o.toLowerCase().startsWith(n)) return Td(e[i], r);
  }
}
var K$ = `${of}-owner`;
function HW(e, t, r = "") {
  let n = `[${K$}="${t}"]:not(${Q$})${r}`;
  return e.querySelectorAll(n);
}
function WW(e) {
  return { [K$]: e };
}
var QW = class {
  constructor(e, t = {}) {
    var r, n;
    this.ownerID = e, this.options = { virtual: (r = t.virtual) != null ? r : !1, base: (n = t.base) != null ? n : "" };
  }
  setRef(e) {
    this.internalRef = e;
  }
  clearRef() {
    this.internalRef = void 0;
  }
  query(e, t = "") {
    return HW(e, this.ownerID, `${this.options.base}${t}`);
  }
  setCurrent(e) {
    this.current = e;
  }
  setChecked(e) {
    this.current = Td(e, this.options.virtual);
  }
  setNextChecked(e) {
    if (this.internalRef instanceof HTMLElement) {
      Cs(this.current, new Error("missing current ref"));
      let t = zW(this.query(this.internalRef), this.current, e, this.options.virtual);
      t && (this.current = t);
    }
  }
  setPrevChecked(e) {
    if (this.internalRef instanceof HTMLElement) {
      Cs(this.current, new Error("missing current ref"));
      let t = VW(this.query(this.internalRef), this.current, e, this.options.virtual);
      t && (this.current = t);
    }
  }
  setFirstChecked(e = "") {
    if (this.internalRef instanceof HTMLElement) {
      let t = UW(this.query(this.internalRef, e), this.options.virtual);
      t && (this.current = t);
    }
  }
  setLastChecked(e = "") {
    if (this.internalRef instanceof HTMLElement) {
      let t = qW(this.query(this.internalRef, e), this.options.virtual);
      t && (this.current = t);
    }
  }
  setFirstMatch(e) {
    if (this.internalRef instanceof HTMLElement) {
      let t = BW(this.query(this.internalRef), e, this.options.virtual);
      t && (this.current = t);
    }
  }
  getId() {
    return this.ownerID;
  }
};
function KW(e) {
  let t = a3(), r = K(() => e.disabled || t.disabled());
  return { isSelected: K(() => t.isSelected(e.value)), isActive: K(() => t.isActive(e.value)), select() {
    Qe(r) || t.select(e.value);
  }, focus() {
    Qe(r) || t.focus(e.value);
  }, blur() {
    !Qe(r) && this.isActive() && t.blur();
  }, disabled: r };
}
var GW = Gr();
function ZW(e) {
  return g(GW.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
var YW = Qu("button");
function G$(e) {
  let [t, r] = Bu(e);
  return fe(() => {
    let n = t();
    n instanceof HTMLElement && n.tagName !== "BUTTON" && yn(n, "keydown", (i) => {
      switch (i.key) {
        case "Enter":
        case " ": {
          n.click();
          break;
        }
      }
    });
  }), af(() => e.as || "button", it(YW, { get tabindex() {
    return e.disabled ? -1 : 0;
  }, role: "button" }, Wu(() => e.disabled), Hu(() => e.disabled), Bi(e, ["as", "ref"]), { ref: r }));
}
function Z$(e, t, r) {
  let n = K(() => e.unmount == null ? !0 : e.unmount);
  return K(() => {
    let i = n();
    if (i === "offscreen") {
      let a = K(() => t()), o = wg(() => r());
      return K(() => a() && o);
    }
    if (i) {
      let a = K(() => t());
      return K(() => a() && r);
    }
    return r;
  });
}
function JW(e) {
  let t, r;
  if ("defaultOpen" in e) {
    let [i, a] = V(e.defaultOpen);
    t = i, r = (o) => {
      a(o), o && e.onOpen && e.onOpen(), e.onChange && e.onChange(o), !o && e.onClose && e.onClose();
    };
  } else t = K(() => e.isOpen), r = (i) => {
    i && e.onOpen && e.onOpen(), e.onChange && e.onChange(i), !i && e.onClose && e.onClose();
  };
  let n = K(() => !!e.disabled);
  return { isOpen() {
    return t();
  }, setState(i) {
    Qe(n) || r(i);
  }, disabled: n, open() {
    Qe(n) || r(!0);
  }, close() {
    Qe(n) || r(!1);
  }, toggle() {
    Qe(n) || r(!Qe(t));
  } };
}
var Y$ = Gr();
function XW(e) {
  return g(Y$.Provider, { value: e.state, get children() {
    let t = e.children;
    return typeof t == "function" ? t(e.state) : t;
  } });
}
function lf() {
  let e = wr(Y$);
  return Cs(e, new Error("Missing <DisclosureStateProvider>")), e;
}
function J$(e) {
  let t = lf();
  return K(() => {
    let r = e.children;
    return typeof r == "function" && r.length === 1 ? K(() => r(t)) : r;
  });
}
function s9() {
  let e = window.getSelection();
  if (e) {
    let t = e.focusNode;
    if (t) return t.parentElement;
  }
}
function eQ(e) {
  if (e) {
    let t = e.getAttribute("tabindex");
    e.setAttribute("tabindex", "-1"), e.focus(), e.blur(), t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
  }
}
var tQ = class {
  constructor() {
    this.returnElement = document.activeElement, this.fsp = s9(), sr(() => {
      this.load();
    });
  }
  load() {
    this.returnElement instanceof HTMLElement ? this.returnElement.focus() : eQ(this.fsp);
  }
  save() {
    this.returnElement = document.activeElement, this.fsp = s9();
  }
};
function rQ() {
  return new tQ();
}
var X$ = Gr();
function d3(e) {
  let t = wr(X$);
  return Cs(t, new Error(`<${e}> must be used inside a <Listbox>`)), t;
}
var nQ = Qu("listbox"), iQ = Qu("listbox-button"), aQ = Qu("listbox-options"), oQ = Qu("listbox-option");
function sQ(e) {
  return !!e.multiple;
}
function lQ(e) {
  return "defaultValue" in e;
}
function l9(e) {
  return "defaultOpen" in e;
}
function dQ(e) {
  return lQ(e) ? l9(e) ? Bi(e, ["as", "by", "children", "defaultOpen", "defaultValue", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : Bi(e, ["as", "by", "children", "isOpen", "defaultValue", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : l9(e) ? Bi(e, ["as", "by", "children", "defaultOpen", "value", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]) : Bi(e, ["as", "by", "children", "isOpen", "value", "disabled", "horizontal", "multiple", "onClose", "onDisclosureChange", "onOpen", "onSelectChange", "toggleable"]);
}
function cQ(e) {
  return K(() => {
    let t = va(), r = va(), n = va(), i = va(), a = JW(it(e, { onChange(l) {
      e.onDisclosureChange && e.onDisclosureChange(l);
    } })), o = sQ(e) ? OW(it(e, { onChange(l) {
      e.onSelectChange && e.onSelectChange(l);
    } })) : TW(it(e, { onChange(l) {
      e.onSelectChange && e.onSelectChange(l);
    } })), s = rQ();
    return fe(() => {
      a.isOpen() ? s.save() : s.load();
    }), g(X$.Provider, { value: { get multiple() {
      return e.multiple;
    }, ownerID: t, labelID: r, buttonID: n, optionsID: i, get horizontal() {
      return e.horizontal;
    }, buttonHovering: !1, optionsHovering: !1 }, get children() {
      return g(W$, { state: o, get children() {
        return g(XW, { state: a, get children() {
          return af(() => e.as || "div", it(nQ, { id: t, "aria-labelledby": r }, Wu(() => o.disabled()), Hu(() => o.disabled()), s3(() => o.hasSelected()), l3(() => o.hasActive()), o3(() => a.isOpen()), dQ(e), { get children() {
            return e.children;
          } }));
        } });
      } });
    } });
  });
}
function uQ(e) {
  let t = d3("ListboxButton"), r = lf(), n = a3(), [i, a] = Bu(e), o = () => r.disabled() || e.disabled;
  return fe(() => {
    let s = i();
    s instanceof HTMLElement && (t.anchor = s, yn(s, "click", () => {
      o() || r.toggle();
    }), yn(s, "keydown", (l) => {
      if (!o()) switch (l.key) {
        case "ArrowUp":
        case "ArrowDown": {
          l.preventDefault(), r.toggle();
          break;
        }
      }
    }), yn(s, "mouseenter", () => {
      t.buttonHovering = !0;
    }), yn(s, "mouseleave", () => {
      t.buttonHovering = !1;
    }));
  }), g(G$, it(iQ, { id: t.buttonID, "aria-haspopup": "listbox", "aria-controls": t.optionsID, ref: a }, Wu(o), Hu(o), o3(() => r.isOpen()), PW(() => r.isOpen()), s3(() => n.hasSelected()), l3(() => n.hasActive()), Bi(e, ["children", "ref"]), { get children() {
    return g(J$, { get children() {
      return e.children;
    } });
  } }));
}
var ek = Gr();
function hQ(e) {
  let t = wr(ek);
  return Cs(t, new Error(`<${e}> must be used inside a <ListboxOptions>`)), t;
}
function fQ(e) {
  return new QW(e);
}
function pQ(e) {
  let t = d3("ListboxOptions"), r = hQ("ListboxOptions"), n = lf(), i = KW(e), [a, o] = Bu(e);
  return se(() => {
    let s = a();
    s instanceof HTMLElement && (yn(s, "click", () => {
      i.disabled() || (i.select(), t.multiple || n.close());
    }), yn(s, "focus", () => {
      i.focus();
    }), yn(s, "blur", () => {
      i.blur();
    }), yn(s, "mouseenter", () => {
      i.disabled() || s.focus({ preventScroll: !0 });
    }), yn(s, "mouseleave", () => {
      i.disabled() || i.blur();
    }));
  }), g(G$, it(oQ, WW(r.getId()), { get as() {
    return e.as || "li";
  }, role: "option", tabindex: -1, ref: o }, Wu(() => i.disabled()), Hu(() => i.disabled()), DW(() => i.isSelected()), NW(() => i.isSelected()), MW(() => i.isActive()), Bi(e, ["as", "children", "disabled", "value", "ref"]), { get children() {
    return g(ZW, { state: i, get children() {
      return e.children;
    } });
  } }));
}
var mQ = 250;
function gQ(e, t = mQ) {
  let r = "", n;
  return sr(() => {
    n && clearTimeout(n);
  }), (i) => {
    r += i, n && clearTimeout(n), n = setTimeout(() => {
      e(r), r = "";
    }, t);
  };
}
function vQ(e) {
  let t = d3("ListboxOptions"), r = a3(), n = lf(), [i, a] = Bu(e), o = fQ(t.optionsID), s = gQ((l) => {
    o.setFirstMatch(l);
  });
  return lr(() => {
    fe(() => {
      let l = i();
      l instanceof HTMLElement && n.isOpen() && (o.setRef(l), sr(() => {
        o.clearRef();
      }), Qe(() => r.hasSelected()) ? o.setFirstChecked(LW) : o.setFirstChecked(), yn(l, "keydown", (d) => {
        if (!r.disabled()) switch (d.key) {
          case "Escape": {
            n.close();
            break;
          }
          case "ArrowLeft": {
            t.horizontal && (d.preventDefault(), o.setPrevChecked(!0));
            break;
          }
          case "ArrowUp": {
            t.horizontal || (d.preventDefault(), o.setPrevChecked(!0));
            break;
          }
          case "ArrowRight": {
            t.horizontal && (d.preventDefault(), o.setNextChecked(!0));
            break;
          }
          case "ArrowDown": {
            t.horizontal || (d.preventDefault(), o.setNextChecked(!0));
            break;
          }
          case "Home": {
            d.preventDefault(), o.setFirstChecked();
            break;
          }
          case "End": {
            d.preventDefault(), o.setLastChecked();
            break;
          }
          case " ":
          case "Enter": {
            d.preventDefault();
            break;
          }
          default: {
            d.key.length === 1 && s(d.key);
            break;
          }
        }
      }), yn(l, "focusout", (d) => {
        t.buttonHovering || t.optionsHovering || d.relatedTarget && l.contains(d.relatedTarget) || n.close();
      }), yn(l, "focusin", (d) => {
        d.target && d.target !== l && o.setCurrent(d.target);
      }), yn(l, "mouseenter", () => {
        t.optionsHovering = !0;
      }), yn(l, "mouseleave", () => {
        t.optionsHovering = !1;
      }));
    });
  }), Z$(e, () => n.isOpen(), () => g(ek.Provider, { value: o, get children() {
    return af(() => e.as || "ul", it(aQ, { id: t.optionsID, role: "listbox", "aria-multiselectable": t.multiple, "aria-labelledby": t.buttonID, ref: a, get "aria-orientation"() {
      return t.horizontal ? "horizontal" : "vertical";
    }, get tabindex() {
      return r.disabled() ? -1 : 0;
    } }, Wu(() => r.disabled()), Hu(() => r.disabled()), o3(() => n.isOpen()), s3(() => r.hasSelected()), l3(() => r.hasActive()), Bi(e, ["as", "children", "ref"]), { get children() {
      return g(W$, { state: r, get children() {
        return e.children;
      } });
    } }));
  } }));
}
var tk = Gr(), d9 = Gr();
function yQ(e) {
  let t = wr(tk);
  return Cs(t, new Error(`<${e}> must be used inside a <Transition>`)), t;
}
function bQ() {
  let [e, t] = V(0);
  return { register() {
    t((r) => r + 1);
  }, unregister() {
    t((r) => r - 1);
  }, done() {
    return e() === 0;
  } };
}
function qa(e) {
  return e ? e.split(" ") : [];
}
function Wo(e, t) {
  let r = t.filter((n) => n);
  r.length && e.classList.add(...r);
}
function Qo(e, t) {
  let r = t.filter((n) => n);
  r.length && e.classList.remove(...r);
}
function wQ(e) {
  let t = yQ("TransitionChild"), r = wr(d9), n = bQ(), [i, a] = V(), [o, s] = V(t.show), [l, d] = Bu(e), c = !0;
  function u(h, f) {
    if (f) {
      if (c) {
        let p = qa(e.enter), m = qa(e.enterFrom), y = qa(e.enterTo), v = qa(e.entered), b = () => {
          Qo(h, p), Qo(h, y), a("entered"), Wo(h, v), e.afterEnter && e.afterEnter();
        };
        e.beforeEnter && e.beforeEnter(), a("enter-from"), Wo(h, p), Wo(h, m), requestAnimationFrame(() => {
          Qo(h, m), a("enter-to"), Wo(h, y), h.addEventListener("transitionend", b, { once: !0 }), h.addEventListener("animationend", b, { once: !0 });
        });
      }
    } else {
      let p = qa(e.leave), m = qa(e.leaveFrom), y = qa(e.leaveTo), v = qa(e.entered);
      e.beforeLeave && e.beforeLeave(), r && r.register(), Qo(h, v), a("leave-from"), Wo(h, p), Wo(h, m), requestAnimationFrame(() => {
        Qo(h, m), a("leave-to"), Wo(h, y);
      });
      let b = () => {
        Qo(h, p), Qo(h, y), s(!1), r && r.unregister(), e.afterLeave && e.afterLeave();
      };
      h.addEventListener("transitionend", b, { once: !0 }), h.addEventListener("animationend", b, { once: !0 });
    }
  }
  return fe(() => {
    let h = t.show;
    h && s(!0);
    let f = l();
    f instanceof HTMLElement ? h ? u(f, !0) : n.done() && u(f, !1) : c = !0;
  }), g(d9.Provider, { value: n, get children() {
    return Z$(e, o, () => af(() => e.as || "div", it(Bi(e, ["as", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo", "unmount", "afterEnter", "afterLeave", "appear", "beforeEnter", "beforeLeave", "entered", "ref"]), { ref: d, get "tc-transition"() {
      return i();
    } })));
  } });
}
function $Q(e) {
  return g(tk.Provider, { value: e, get children() {
    return g(wQ, Bi(e, ["show"]));
  } });
}
var kQ = /* @__PURE__ */ k('<span class="block truncate">'), _Q = /* @__PURE__ */ k('<span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">'), xQ = /* @__PURE__ */ k("<div><span>"), SQ = /* @__PURE__ */ k("<span>");
function CQ(e) {
  const [t, r] = V({
    name: e.selectMessage
  }), {
    field: n,
    onInput: i
  } = VN(e.name), [a] = qu();
  return g(cQ, {
    ref: n,
    defaultOpen: !1,
    get value() {
      return t();
    },
    onSelectChange: (o) => {
      r(o ?? {
        name: e.selectMessage
      }), i(o?.value ?? o?.id ?? o?.name ?? "");
    },
    class: "relative shadow-sm rounded-lg",
    get children() {
      return [g(uQ, {
        type: "button",
        get class() {
          return `block text-left w-full rounded-lg border-0 py-3 px-4 shadow-sm ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-inset focus:ring-blue-600 focus:ring-2
          ${a.error ? "ring-red-300 placeholder:text-red-300 focus:ring-inset focus:ring-red-500" : ""}
          `;
        },
        get children() {
          return [(() => {
            var o = kQ();
            return E(o, () => t()?.name ?? ""), o;
          })(), (() => {
            var o = _Q();
            return E(o, g(mt, {
              name: "chevronDown",
              class: "w-5 h-5 text-gray-400",
              size: "sm"
            })), o;
          })()];
        }
      }), g(J$, {
        children: ({
          isOpen: o
        }) => g($Q, {
          get show() {
            return o();
          },
          enter: "transition ease-in duration-100",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition ease-out duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          get children() {
            return g(vQ, {
              unmount: !1,
              get class() {
                return Yt("absolute w-full py-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10", e.openUpward ? "bottom-full mb-1" : "mt-1");
              },
              get children() {
                return g(yt, {
                  get each() {
                    return e.list;
                  },
                  children: (s) => g(pQ, {
                    class: "focus:outline-none group",
                    value: s,
                    children: ({
                      isActive: l,
                      isSelected: d
                    }) => (() => {
                      var c = xQ(), u = c.firstChild;
                      return E(u, () => s.name), E(c, (() => {
                        var h = Ut(() => !!d());
                        return () => h() ? (() => {
                          var f = SQ();
                          return E(f, g(mt, {
                            name: "checkCircle"
                          })), se(() => ft(f, Yt((l(), "text-blue-600"), "group-hover:text-blue-600", "absolute inset-y-0 left-0 flex items-center pl-3"))), f;
                        })() : null;
                      })(), null), se((h) => {
                        var f = Yt(l() ? "text-blue-900 bg-blue-100" : "text-gray-900", "group-hover:text-blue-900 group-hover:bg-blue-100", "cursor-default select-none relative py-2 pl-10 pr-4"), p = Yt(d() ? "font-medium" : "font-normal", "block truncate");
                        return f !== h.e && ft(c, h.e = f), p !== h.t && ft(u, h.t = p), h;
                      }, {
                        e: void 0,
                        t: void 0
                      }), c;
                    })()
                  })
                });
              }
            });
          }
        })
      })];
    }
  });
}
var c9 = /* @__PURE__ */ k("<div>");
function Mn(e) {
  const t = it({
    variant: "white",
    autoPadding: !0
  }, e), r = K(() => Yt("border rounded-lg", {
    "divide-y divide-gray-300": t?.addChildrenDivider,
    "border-blue-600 bg-blue-50": t?.selected,
    "border-gray-300": !t?.selected,
    "bg-white": t?.variant === "white",
    "bg-gray-50": t?.variant === "gray",
    "opacity-35": t?.disabled
  }, t.class));
  return (() => {
    var n = c9();
    return E(n, g(yt, {
      get each() {
        return Array.isArray(t.children) ? t.children : [t.children];
      },
      children: (i) => (() => {
        var a = c9();
        return E(a, i), se(() => ft(a, Yt({
          "px-4 py-3 sm:px-6 sm:py-4": t.autoPadding
        }))), a;
      })()
    })), se(() => ft(n, r())), n;
  })();
}
var EQ = /* @__PURE__ */ k("<span>");
function Ee(e) {
  const t = it({
    size: "md",
    color: "black"
  }, e), r = K(() => (
    // [overflow-wrap:anywhere] is here to prevent long text from overflowing, should be in tailwind soon
    // https://github.com/tailwindlabs/tailwindcss/discussions/2213#discussioncomment-5316024
    Yt(e.class, "inline-flex my-px [overflow-wrap:anywhere] leading-snug", {
      "text-xs": t.size === "xs",
      "text-sm": t.size === "sm",
      "text-base": t.size === "md",
      "text-lg": t.size === "lg",
      "text-xl": t.size === "xl",
      "text-black": !e.loading && t.color === "black",
      "text-slate-500": !e.loading && t.color === "gray",
      "text-red-500": !e.loading && t.color === "red",
      "text-transparent box-border rounded-md": e.loading,
      "bg-gray-100": !e.selected && e.loading,
      "bg-blue-100": e.selected && e.loading,
      "font-semibold": e.bold,
      italic: e.italic
    })
  ));
  return (() => {
    var n = EQ();
    return E(n, g(H, {
      get when() {
        return !e.loading;
      },
      get children() {
        return e.children;
      }
    }), null), E(n, g(H, {
      get when() {
        return e.loading;
      },
      get children() {
        return e.sampleLoadingText;
      }
    }), null), se((i) => {
      var a = r(), o = e.loading, s = e.loading;
      return a !== i.e && ft(n, i.e = a), o !== i.t && pt(n, "aria-hidden", i.t = o), s !== i.a && pt(n, "aria-busy", i.a = s), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), n;
  })();
}
var AQ = /* @__PURE__ */ k("<button>");
function xt(e) {
  const t = it({
    variant: "primary",
    size: "lg"
  }, e), [r, n] = go(t, ["variant", "size", "color", "children", "iconLeft", "loading"]), i = K(() => {
    const a = r.color || "gray", o = r.variant === "secondary" && r.color ? `rounded bg-white text-${a}-600 shadow-sm ring-1 ring-inset ring-${a}-500 hover:bg-${a}-50` : "";
    return Yt("font-semibold flex justify-center inline-flex items-center gap-x-1", {
      "shadow-sm": r.variant !== "naked",
      "rounded-md": ["xl", "lg", "md"].includes(r.size),
      rounded: !["xl", "lg", "md"].includes(r.size),
      "text-xs": r.size === "xs",
      "text-sm": r.size !== "xs",
      "px-3.5 py-2.5": r.size === "xl" && r.variant !== "naked",
      "px-3 py-2": r.size === "lg" && r.variant !== "naked",
      "px-2.5 py-1.5": r.size === "md" && r.variant !== "naked",
      "px-2 py-1": (r.size === "sm" || r.size === "xs") && r.variant !== "naked",
      "text-white bg-blue-500 hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2": r.variant === "primary",
      "rounded bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50": r.variant === "secondary" && !r.color,
      "text-white bg-red-500 hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2": r.variant === "danger",
      "bg-blue-50 text-blue-600 hover:bg-blue-100": r.variant === "tertiary",
      "text-blue-600 hover:text-blue-500 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-300": r.variant === "naked",
      "opacity-50 cursor-not-allowed": n.disabled || r.loading
    }, o, e?.class);
  });
  return (() => {
    var a = AQ();
    return ii(a, it(n, {
      get class() {
        return i();
      },
      get disabled() {
        return n.disabled || r.loading;
      },
      get type() {
        return e?.type;
      }
    }), !1, !0), E(a, g(H, {
      get when() {
        return r?.loading;
      },
      get children() {
        return g(aa, {
          size: "sm"
        });
      }
    }), null), E(a, g(H, {
      get when() {
        return r?.iconLeft;
      },
      get children() {
        return r?.iconLeft;
      }
    }), null), E(a, () => t.children, null), a;
  })();
}
const rk = Gr();
function TQ(e) {
  return g(rk.Provider, {
    get value() {
      return e.client;
    },
    get children() {
      return e.children;
    }
  });
}
function Kn() {
  const e = wr(rk);
  if (!e)
    throw new Error("SDKContext must be defined");
  return e;
}
const OQ = (e) => typeof e == "function", ah = (e, t) => OQ(e) ? e(t) : e;
var Dr;
(function(e) {
  e[e.ADD_TOAST = 0] = "ADD_TOAST", e[e.UPDATE_TOAST = 1] = "UPDATE_TOAST", e[e.UPSERT_TOAST = 2] = "UPSERT_TOAST", e[e.DISMISS_TOAST = 3] = "DISMISS_TOAST", e[e.REMOVE_TOAST = 4] = "REMOVE_TOAST", e[e.START_PAUSE = 5] = "START_PAUSE", e[e.END_PAUSE = 6] = "END_PAUSE";
})(Dr || (Dr = {}));
const [vs, Ba] = js({
  toasts: [],
  pausedAt: void 0
}), IQ = () => {
  const { pausedAt: e, toasts: t } = vs;
  if (e)
    return;
  const r = Date.now();
  return t.map((n) => {
    if (n.duration === 1 / 0)
      return;
    const i = (n.duration || 0) + n.pauseDuration - (r - n.createdAt);
    if (i <= 0) {
      n.visible && Oi({
        type: Dr.DISMISS_TOAST,
        toastId: n.id
      });
      return;
    }
    return setTimeout(() => {
      Oi({
        type: Dr.DISMISS_TOAST,
        toastId: n.id
      });
    }, i);
  });
}, Lc = /* @__PURE__ */ new Map(), u9 = (e, t) => {
  if (Lc.has(e))
    return;
  const r = setTimeout(() => {
    Lc.delete(e), Oi({
      type: Dr.REMOVE_TOAST,
      toastId: e
    });
  }, t);
  Lc.set(e, r);
}, PQ = (e) => {
  const t = Lc.get(e);
  Lc.delete(e), t && clearTimeout(t);
}, Oi = (e) => {
  switch (e.type) {
    case Dr.ADD_TOAST:
      Ba("toasts", (i) => {
        const a = i;
        return [e.toast, ...a];
      });
      break;
    case Dr.DISMISS_TOAST:
      const { toastId: t } = e, r = vs.toasts;
      if (t) {
        const i = r.find((a) => a.id === t);
        i && u9(t, i.unmountDelay), Ba("toasts", (a) => a.id === t, P0((a) => a.visible = !1));
      } else
        r.forEach((i) => {
          u9(i.id, i.unmountDelay);
        }), Ba("toasts", (i) => i.id !== void 0, P0((i) => i.visible = !1));
      break;
    case Dr.REMOVE_TOAST:
      if (!e.toastId) {
        Ba("toasts", []);
        break;
      }
      Ba("toasts", (i) => i.filter((a) => a.id !== e.toastId));
      break;
    case Dr.UPDATE_TOAST:
      e.toast.id && PQ(e.toast.id), Ba("toasts", (i) => i.id === e.toast.id, (i) => ({
        ...i,
        ...e.toast
      }));
      break;
    case Dr.UPSERT_TOAST:
      vs.toasts.find((i) => i.id === e.toast.id) ? Oi({ type: Dr.UPDATE_TOAST, toast: e.toast }) : Oi({ type: Dr.ADD_TOAST, toast: e.toast });
      break;
    case Dr.START_PAUSE:
      Ba(P0((i) => {
        i.pausedAt = Date.now(), i.toasts.forEach((a) => {
          a.paused = !0;
        });
      }));
      break;
    case Dr.END_PAUSE:
      const n = e.time - (vs.pausedAt || 0);
      Ba(P0((i) => {
        i.pausedAt = void 0, i.toasts.forEach((a) => {
          a.pauseDuration += n, a.paused = !1;
        });
      }));
      break;
  }
}, NQ = {
  blank: 4e3,
  error: 4e3,
  success: 2e3,
  loading: 1 / 0,
  custom: 4e3
}, Fl = {
  id: "",
  icon: "",
  unmountDelay: 500,
  duration: 3e3,
  ariaProps: {
    role: "status",
    "aria-live": "polite"
  },
  className: "",
  style: {},
  position: "top-right",
  iconTheme: {}
}, nk = {
  position: "top-right",
  toastOptions: Fl,
  gutter: 8,
  containerStyle: {},
  containerClassName: ""
}, N0 = "16px", DQ = {
  position: "fixed",
  "z-index": 9999,
  top: N0,
  bottom: N0,
  left: N0,
  right: N0,
  "pointer-events": "none"
}, MQ = /* @__PURE__ */ (() => {
  let e = 0;
  return () => String(++e);
})(), RQ = (e) => {
  qQ((t) => ({
    containerClassName: e.containerClassName ?? t.containerClassName,
    containerStyle: e.containerStyle ?? t.containerStyle,
    gutter: e.gutter ?? t.gutter,
    position: e.position ?? t.position,
    toastOptions: {
      ...e.toastOptions
    }
  }));
}, LQ = (e, t) => {
  const r = e.includes("top") ? { top: 0, "margin-top": `${t}px` } : { bottom: 0, "margin-bottom": `${t}px` }, n = e.includes("center") ? { "justify-content": "center" } : e.includes("right") ? { "justify-content": "flex-end" } : {};
  return {
    left: 0,
    right: 0,
    display: "flex",
    position: "absolute",
    transition: "all 230ms cubic-bezier(.21,1.02,.73,1)",
    ...r,
    ...n
  };
}, FQ = (e, t) => {
  const r = e.getBoundingClientRect();
  r.height !== t.height && Oi({
    type: Dr.UPDATE_TOAST,
    toast: { id: t.id, height: r.height }
  });
}, jQ = (e, t) => {
  const { toasts: r } = vs, n = dl().gutter || nk.gutter || 8, i = r.filter((s) => (s.position || t) === t && s.height), a = i.findIndex((s) => s.id === e.id), o = i.filter((s, l) => l < a && s.visible).length;
  return i.slice(0, o).reduce((s, l) => s + n + (l.height || 0), 0);
}, zQ = (e, t) => (e.position || t).includes("top") ? 1 : -1, VQ = {
  display: "flex",
  "align-items": "center",
  color: "#363636",
  background: "white",
  "box-shadow": "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
  "max-width": "350px",
  "pointer-events": "auto",
  padding: "8px 10px",
  "border-radius": "4px",
  "line-height": "1.3",
  "will-change": "transform"
}, UQ = {
  display: "flex",
  "align-items": "center",
  flex: "1 1 auto",
  margin: "4px 10px",
  "white-space": "pre-line"
}, D0 = {
  "flex-shrink": 0,
  "min-width": "20px",
  "min-height": "20px",
  display: "flex",
  "align-items": "center",
  "justify-content": "center",
  "text-align": "center"
}, oh = (e) => ({
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: e
}), [dl, qQ] = V(nk), BQ = (e, t = "blank", r) => ({
  ...Fl,
  ...dl().toastOptions,
  ...r,
  type: t,
  message: e,
  pauseDuration: 0,
  createdAt: Date.now(),
  visible: !0,
  id: r.id || MQ(),
  paused: !1,
  style: {
    ...Fl.style,
    ...dl().toastOptions?.style,
    ...r.style
  },
  duration: r.duration || dl().toastOptions?.duration || NQ[t],
  position: r.position || dl().toastOptions?.position || dl().position || Fl.position
}), Ku = (e) => (t, r = {}) => so(() => {
  const n = vs.toasts.find((a) => a.id === r.id), i = BQ(t, e, { ...n, duration: void 0, ...r });
  return Oi({ type: Dr.UPSERT_TOAST, toast: i }), i.id;
}), qn = (e, t) => Ku("blank")(e, t);
Qe(() => qn);
qn.error = Ku("error");
qn.success = Ku("success");
qn.loading = Ku("loading");
qn.custom = Ku("custom");
qn.dismiss = (e) => {
  Oi({
    type: Dr.DISMISS_TOAST,
    toastId: e
  });
};
qn.promise = (e, t, r) => {
  const n = qn.loading(t.loading, { ...r });
  return e.then((i) => (qn.success(ah(t.success, i), {
    id: n,
    ...r
  }), i)).catch((i) => {
    qn.error(ah(t.error, i), {
      id: n,
      ...r
    });
  }), e;
};
qn.remove = (e) => {
  Oi({
    type: Dr.REMOVE_TOAST,
    toastId: e
  });
};
var HQ = /* @__PURE__ */ k("<div><style>.sldt-active{z-index:9999;}.sldt-active>*{pointer-events:auto;}");
const WQ = (e) => (fe(() => {
  RQ(e);
}), fe(() => {
  const t = IQ();
  sr(() => {
    t && t.forEach((r) => r && clearTimeout(r));
  });
}), (() => {
  var t = HQ();
  return t.firstChild, E(t, g(yt, {
    get each() {
      return vs.toasts;
    },
    children: (r) => g(ZQ, {
      toast: r
    })
  }), null), se((r) => {
    var n = {
      ...DQ,
      ...e.containerStyle
    }, i = e.containerClassName;
    return r.e = zi(t, n, r.e), i !== r.t && ft(t, r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})());
var M0 = /* @__PURE__ */ k("<div>"), QQ = /* @__PURE__ */ k("<div><div>");
const KQ = (e) => {
  let t;
  return fe(() => {
    if (!t) return;
    const r = zQ(e.toast, e.position);
    e.toast.visible ? t.animate([{
      transform: `translate3d(0,${r * -200}%,0) scale(.6)`,
      opacity: 0.5
    }, {
      transform: "translate3d(0,0,0) scale(1)",
      opacity: 1
    }], {
      duration: 350,
      fill: "forwards",
      easing: "cubic-bezier(.21,1.02,.73,1)"
    }) : t.animate([{
      transform: "translate3d(0,0,-1px) scale(1)",
      opacity: 1
    }, {
      transform: `translate3d(0,${r * -150}%,-1px) scale(.4)`,
      opacity: 0
    }], {
      duration: 400,
      fill: "forwards",
      easing: "cubic-bezier(.06,.71,.55,1)"
    });
  }), (() => {
    var r = QQ(), n = r.firstChild, i = t;
    return typeof i == "function" ? Pn(i, r) : t = r, E(r, g(Fh, {
      get children() {
        return [g(ri, {
          get when() {
            return e.toast.icon;
          },
          get children() {
            var a = M0();
            return E(a, () => e.toast.icon), se((o) => zi(a, D0, o)), a;
          }
        }), g(ri, {
          get when() {
            return e.toast.type === "loading";
          },
          get children() {
            var a = M0();
            return E(a, g(iK, it(() => e.toast.iconTheme))), se((o) => zi(a, D0, o)), a;
          }
        }), g(ri, {
          get when() {
            return e.toast.type === "success";
          },
          get children() {
            var a = M0();
            return E(a, g(eK, it(() => e.toast.iconTheme))), se((o) => zi(a, D0, o)), a;
          }
        }), g(ri, {
          get when() {
            return e.toast.type === "error";
          },
          get children() {
            var a = M0();
            return E(a, g(rK, it(() => e.toast.iconTheme))), se((o) => zi(a, D0, o)), a;
          }
        })];
      }
    }), n), ii(n, it(() => e.toast.ariaProps), !1, !0), E(n, () => ah(e.toast.message, e.toast)), se((a) => {
      var o = e.toast.className, s = {
        ...VQ,
        ...e.toast.style
      }, l = UQ;
      return o !== a.e && ft(r, a.e = o), a.t = zi(r, s, a.t), a.a = zi(n, l, a.a), a;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), r;
  })();
};
var GQ = /* @__PURE__ */ k("<div>");
const ZQ = (e) => {
  const t = () => {
    const i = e.toast.position || Fl.position, a = jQ(e.toast, i);
    return LQ(i, a);
  }, r = K(() => t());
  let n;
  return lr(() => {
    n && FQ(n, e.toast);
  }), (() => {
    var i = GQ();
    i.addEventListener("mouseleave", () => Oi({
      type: Dr.END_PAUSE,
      time: Date.now()
    })), i.addEventListener("mouseenter", () => Oi({
      type: Dr.START_PAUSE,
      time: Date.now()
    }));
    var a = n;
    return typeof a == "function" ? Pn(a, i) : n = i, E(i, (() => {
      var o = Ut(() => e.toast.type === "custom");
      return () => o() ? ah(e.toast.message, e.toast) : g(KQ, {
        get toast() {
          return e.toast;
        },
        get position() {
          return e.toast.position || Fl.position;
        }
      });
    })()), se((o) => {
      var s = r(), l = e.toast.visible ? "sldt-active" : "";
      return o.e = zi(i, s, o.e), l !== o.t && ft(i, o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), i;
  })();
};
var YQ = /* @__PURE__ */ k('<svg><circle cx=16 cy=16 r=0><animate attributeName=opacity values="0; 1; 1"></animate><animate attributeName=r values="0; 17.5; 16"></svg>', !1, !0, !1), JQ = /* @__PURE__ */ k('<svg><circle cx=16 cy=16 r=12 opacity=0><animate attributeName=opacity values="1; 0"></animate><animate attributeName=r values="12; 26"></svg>', !1, !0, !1);
const ik = (e) => {
  const t = {
    dur: "0.35s",
    begin: "100ms",
    fill: "freeze",
    calcMode: "spline",
    keyTimes: "0; 0.6; 1",
    keySplines: "0.25 0.71 0.4 0.88; .59 .22 .87 .63"
  };
  return (() => {
    var r = YQ(), n = r.firstChild, i = n.nextSibling;
    return ii(n, t, !0, !1), ii(i, t, !0, !1), se(() => pt(r, "fill", e.fill)), r;
  })();
}, ak = (e) => {
  const t = {
    dur: "1s",
    begin: e.begin || "320ms",
    fill: "freeze",
    ...oh("0.0 0.0 0.2 1")
  };
  return (() => {
    var r = JQ(), n = r.firstChild, i = n.nextSibling;
    return ii(n, t, !0, !1), ii(i, t, !0, !1), se(() => pt(r, "fill", e.fill)), r;
  })();
};
var XQ = /* @__PURE__ */ k('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-dasharray=22 stroke-dashoffset=22 stroke-linecap=round stroke-miterlimit=10 d=M9.8,17.2l3.8,3.6c0.1,0.1,0.3,0.1,0.4,0l9.6-9.7><animate attributeName=stroke-dashoffset values=22;0 dur=0.25s begin=250ms fill=freeze>');
const eK = (e) => {
  const t = e.primary || "#34C759";
  return (() => {
    var r = XQ(), n = r.firstChild, i = n.firstChild;
    return r.style.setProperty("overflow", "visible"), E(r, g(ik, {
      fill: t
    }), n), E(r, g(ak, {
      fill: t,
      begin: "350ms"
    }), n), ii(i, it(() => oh("0.0, 0.0, 0.58, 1.0")), !0, !1), se(() => pt(n, "stroke", e.secondary || "#FCFCFC")), r;
  })();
};
var tK = /* @__PURE__ */ k('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-dasharray=9 stroke-dashoffset=9 stroke-linecap=round d=M16,7l0,9><animate attributeName=stroke-dashoffset values=9;0 dur=0.2s begin=250ms fill=freeze></animate></path><circle cx=16 cy=23 r=2.5 opacity=0><animate attributeName=opacity values=0;1 dur=0.25s begin=350ms fill=freeze>');
const rK = (e) => {
  const t = e.primary || "#FF3B30";
  return (() => {
    var r = tK(), n = r.firstChild, i = n.firstChild, a = n.nextSibling, o = a.firstChild;
    return r.style.setProperty("overflow", "visible"), E(r, g(ik, {
      fill: t
    }), n), E(r, g(ak, {
      fill: t
    }), n), ii(i, it(() => oh("0.0, 0.0, 0.58, 1.0")), !0, !1), ii(o, it(() => oh("0.0, 0.0, 0.58, 1.0")), !0, !1), se((s) => {
      var l = e.secondary || "#FFFFFF", d = e.secondary || "#FFFFFF";
      return l !== s.e && pt(n, "stroke", s.e = l), d !== s.t && pt(a, "fill", s.t = d), s;
    }, {
      e: void 0,
      t: void 0
    }), r;
  })();
};
var nK = /* @__PURE__ */ k('<svg viewBox="0 0 32 32"width=1.25rem height=1.25rem><path fill=none stroke-width=4 stroke-miterlimit=10 d=M16,6c3,0,5.7,1.3,7.5,3.4c1.5,1.8,2.5,4,2.5,6.6c0,5.5-4.5,10-10,10S6,21.6,6,16S10.5,6,16,6z></path><path fill=none stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=M16,6c3,0,5.7,1.3,7.5,3.4c0.6,0.7,1.1,1.4,1.5,2.2><animateTransform attributeName=transform type=rotate from="0 16 16"to="360 16 16"dur=0.75s repeatCount=indefinite>');
const iK = (e) => (() => {
  var t = nK(), r = t.firstChild, n = r.nextSibling;
  return t.style.setProperty("overflow", "visible"), se((i) => {
    var a = e.primary || "#E5E7EB", o = e.secondary || "#4b5563";
    return a !== i.e && pt(r, "stroke", i.e = a), o !== i.t && pt(n, "stroke", i.t = o), i;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
var aK = /* @__PURE__ */ k("<div>"), oK = /* @__PURE__ */ k('<div><div></div><div></div><button type=button class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"><span class=sr-only>Close');
const rr = (e) => {
  qn.custom((t) => (() => {
    var r = oK(), n = r.firstChild, i = n.nextSibling, a = i.nextSibling;
    return a.firstChild, E(n, g(mt, {
      get name() {
        return e.status === "success" ? "checkCircle" : e.status === "error" ? "exclamationCircle" : "informationCircle";
      },
      class: "mr-2"
    })), E(i, g(H, {
      get when() {
        return e?.header;
      },
      get children() {
        return g(Ee, {
          bold: !0,
          get children() {
            return e.header;
          }
        });
      }
    }), null), E(i, g(H, {
      get when() {
        return e.body;
      },
      get children() {
        var o = aK();
        return E(o, g(Ee, {
          get children() {
            return e.body;
          }
        })), o;
      }
    }), null), a.$$click = () => qn.dismiss(t.id), E(a, g(mt, {
      name: "xMark",
      class: "h-6 w-6",
      "aria-hidden": "true"
    }), null), se((o) => {
      var s = `${t.visible ? "animate-enter" : "animate-leave"} flex gap-1 items-start border ${e.status === "success" ? "border-green-400" : e.status === "error" ? "border-red-400" : "border-blue-400"} border-2 rounded-lg p-4 bg-white w-full sm:max-w-md sm:w-auto`, l = e.status === "success" ? "text-green-500" : e.status === "error" ? "text-red-400" : "text-blue-500";
      return s !== o.e && ft(r, o.e = s), l !== o.t && ft(n, o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), r;
  })(), {
    position: "top-right",
    unmountDelay: 3e3,
    ariaProps: {
      role: "status",
      "aria-live": "polite"
    }
  });
};
an(["click"]);
var sK = /* @__PURE__ */ k('<div class="flex-shrink-0 mr-2">'), lK = /* @__PURE__ */ k("<button type=button title=Close>"), dK = /* @__PURE__ */ k('<div><div class="flex w-full">');
function No(e) {
  const [t, r] = V(!0);
  lr(() => {
    sessionStorage.getItem(`banner-${e.id}`) === "closed" && r(!1);
  });
  const n = () => {
    r(!1), e.id && sessionStorage.setItem(`banner-${e.id}`, "closed");
  }, i = () => Yt("flex place-items-start justify-between gap-2 py-3 px-3 sm:px-4 rounded-lg", {
    "border-2 rounded border-solid": e.withBorder,
    "text-blue-600 bg-blue-50": e.status === "info",
    "border-blue-600": e.status === "info" && e.withBorder,
    "text-red-600 bg-red-50": e.status === "error",
    "border-red-600": e.status === "error" && e.withBorder,
    "text-green-600 bg-green-50": e.status === "success",
    "border-green-600": e.status === "success" && e.withBorder,
    "text-yellow-600 bg-yellow-50": e.status === "warning",
    "border-yellow-600": e.status === "warning" && e.withBorder,
    "text-slate-600 bg-slate-50": e.status === "suggestion",
    "border-slate-600": e.status === "suggestion" && e.withBorder
  }), a = () => Yt("", {
    "text-blue-600": e.status === "info",
    "text-red-600": e.status === "error",
    "text-green-600": e.status === "success",
    "text-yellow-600": e.status === "warning",
    "text-slate-600": e.status === "suggestion"
  });
  return g(H, {
    get when() {
      return t();
    },
    get children() {
      var o = dK(), s = o.firstChild;
      return E(s, g(H, {
        get when() {
          return !e.withoutIcon;
        },
        get children() {
          var l = sK();
          return E(l, g(mt, {
            get name() {
              return e.iconName ? e.iconName : "informationCircle";
            },
            get class() {
              return a();
            }
          })), l;
        }
      }), null), E(s, () => e.children, null), E(o, g(H, {
        get when() {
          return e.closable;
        },
        get children() {
          var l = lK();
          return l.$$click = n, E(l, g(mt, {
            name: "xMark",
            size: "sm"
          })), se(() => ft(l, "ml-auto " + a())), l;
        }
      }), null), se(() => ft(o, i())), o;
    }
  });
}
an(["click"]);
var cK = /* @__PURE__ */ k('<div class="flex items-center justify-between">'), uK = /* @__PURE__ */ k('<div><form id=patient-address class=mt-4><div class="grid grid-cols-1 sm:gap-4 sm:grid-cols-2">');
const hK = x$({
  street1: sl().min(1, {
    message: "Street 1 is required"
  }),
  street2: sl().optional(),
  city: sl().min(1, {
    message: "City is required"
  }),
  state: sl().min(1, {
    message: "State is required"
  }),
  postalCode: sl().min(5, {
    message: "Postal code must be 5 digits"
  })
}), fK = Ge`
  mutation UpdateAddress($id: ID!, $address: AddressInput) {
    updatePatient(id: $id, address: $address) {
      id
      address {
        id
        street1
        street2
        city
        state
        postalCode
        country
      }
    }
  }
`;
function ok(e) {
  const [t, r] = V(!1), n = Kn(), i = () => e.showRequiredBanner ?? !0, a = async (l) => {
    const {
      data: d
    } = await n.apollo.mutate({
      mutation: fK,
      variables: {
        id: e.patientId,
        address: l
      }
    });
    r(!1), rr({
      header: "Address Updated",
      body: "The patient address has been updated.",
      status: "success"
    }), e?.setAddress && e.setAddress(d?.updatePatient?.address ?? l);
  }, {
    form: o,
    errors: s
  } = b$({
    onSubmit: async (l) => {
      r(!0);
      try {
        await a({
          country: "US",
          ...l
        });
      } catch {
        r(!1), rr({
          header: "Error Updating Patient",
          body: "The patient address has not been updated.",
          status: "info"
        });
      }
    },
    extend: w$({
      schema: hK
    })
  });
  return g(Mn, {
    addChildrenDivider: !0,
    get children() {
      return [(() => {
        var l = cK();
        return E(l, g(Ee, {
          color: "gray",
          children: "Patient Address"
        }), null), E(l, g(xt, {
          type: "submit",
          form: "patient-address",
          get disabled() {
            return t();
          },
          get loading() {
            return t();
          },
          children: "Save address"
        }), null), l;
      })(), (() => {
        var l = uK(), d = l.firstChild, c = d.firstChild;
        return E(l, (() => {
          var u = Ut(() => !!i());
          return () => u() && g(No, {
            status: "info",
            children: "Patient address is required to write a prescription"
          });
        })(), d), Pn(o, d), E(d, g(at, {
          label: "Address Line 1 *",
          subLabel: "Enter Street Number and Name",
          get error() {
            return s().street1;
          },
          get children() {
            return g(Dt, {
              type: "text",
              name: "street1"
            });
          }
        }), c), E(d, g(at, {
          label: "Address Line 2",
          subLabel: "Enter Apt, Unit, or Suite",
          get children() {
            return g(Dt, {
              type: "text",
              name: "street2"
            });
          }
        }), c), E(d, g(at, {
          label: "City *",
          get error() {
            return s().city;
          },
          get children() {
            return g(Dt, {
              type: "text",
              name: "city"
            });
          }
        }), c), E(c, g(at, {
          label: "State *",
          get error() {
            return s().state;
          },
          get children() {
            return g(CQ, {
              list: B$,
              selectMessage: "Select a State",
              name: "state",
              get openUpward() {
                return e.openStateDropdownUpward;
              }
            });
          }
        }), null), E(c, g(at, {
          label: "Zip Code *",
          get error() {
            return s().postalCode;
          },
          get children() {
            return g(Dt, {
              type: "text",
              name: "postalCode"
            });
          }
        }), null), l;
      })()];
    }
  });
}
var pK = /* @__PURE__ */ k('<div><div class=flex><div class=flex-shrink-0></div><div class=ml-3><h3></h3><div><p class="text-sm mb-0">');
const du = (e) => {
  const t = K(() => {
    switch (e.type) {
      case "success":
        return "checkCircle";
      case "info":
        return "informationCircle";
      case "warning":
        return "exclamationTriangle";
      case "error":
        return "xCircle";
    }
  }), r = K(() => {
    switch (e.type) {
      case "success":
        return "text-green-800";
      case "info":
        return "text-blue-800";
      case "warning":
        return "text-yellow-800";
      case "error":
        return "text-red-800";
    }
  }), n = K(() => {
    switch (e.type) {
      case "success":
        return "bg-green-50";
      case "info":
        return "bg-blue-50";
      case "warning":
        return "bg-yellow-50";
      case "error":
        return "bg-red-50";
    }
  }), i = K(() => {
    switch (e.type) {
      case "success":
        return "border-green-200";
      case "info":
        return "border-blue-200";
      case "warning":
        return "border-yellow-200";
      case "error":
        return "border-red-200";
    }
  });
  return (() => {
    var a = pK(), o = a.firstChild, s = o.firstChild, l = s.nextSibling, d = l.firstChild, c = d.nextSibling, u = c.firstChild;
    return E(s, g(mt, {
      get name() {
        return t();
      },
      get class() {
        return r();
      }
    })), E(d, () => e.header), E(u, () => e.message), se((h) => {
      var f = `rounded-md ${n()} border-2 ${i()} p-4`, p = `text-base font-medium mt-0 ${r()}`, m = `mt-2 ${r()}`;
      return f !== h.e && ft(a, h.e = f), p !== h.t && ft(d, h.t = p), m !== h.a && ft(c, h.a = m), h;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), a;
  })();
};
var mK = /* @__PURE__ */ k('<div role=tooltip class="absolute z-50 whitespace-normal rounded bg-gray-900 px-3 py-2 text-sm leading-snug text-gray-50 shadow-lg">'), gK = /* @__PURE__ */ k('<div class="relative inline-flex">');
function vK(e) {
  let t, r;
  const [n, i] = V(!1), [a, o] = V("top"), [s, l] = V(0), d = () => {
    if (!t || !r) return;
    const p = t.getBoundingClientRect(), m = r.getBoundingClientRect(), y = 8;
    p.top - m.height - y < 0 ? o("bottom") : o("top");
    const v = p.left + p.width / 2 - m.width / 2, b = v + m.width;
    v < y ? l(y - v) : b > window.innerWidth - y ? l(window.innerWidth - y - b) : l(0);
  }, c = () => {
    i(!0), requestAnimationFrame(d);
  }, u = () => i(!1), h = () => n() ? u() : c(), f = (p) => {
    n() && t && !t.contains(p.target) && u();
  };
  return lr(() => {
    document.addEventListener("click", f, !0);
  }), sr(() => {
    document.removeEventListener("click", f, !0);
  }), (() => {
    var p = gK();
    p.$$click = h, p.addEventListener("blur", u), p.$$focusin = c, p.addEventListener("mouseleave", u), p.addEventListener("mouseenter", c);
    var m = t;
    return typeof m == "function" ? Pn(m, p) : t = p, E(p, () => e.children, null), E(p, g(H, {
      get when() {
        return n();
      },
      get children() {
        var y = mK(), v = r;
        return typeof v == "function" ? Pn(v, y) : r = y, E(y, () => e.text), se((b) => zi(y, {
          width: "360px",
          "max-width": "min(360px, calc(100vw - 16px))",
          left: `calc(50% + ${s()}px)`,
          transform: "translateX(-50%)",
          ...a() === "top" ? {
            bottom: "100%",
            "margin-bottom": "8px"
          } : {
            top: "100%",
            "margin-top": "8px"
          }
        }, b)), y;
      }
    }), null), p;
  })();
}
an(["focusin", "click"]);
var yK = /* @__PURE__ */ k('<label class="m-0 text-gray-400 text-xs cursor-pointer">Optional'), bK = /* @__PURE__ */ k('<div class="relative flex items-center"><input type=checkbox class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-600"><div class="ml-3 text-sm leading-none"><div class="flex items-center gap-1"><label class="m-0 font-medium text-gray-500">');
function im(e) {
  const t = va(), r = it({
    id: `checkbox-${t}`,
    checked: !1
  }, e), n = (i) => {
    const a = i.target;
    r.onChange(a.checked);
  };
  return (() => {
    var i = bK(), a = i.firstChild, o = a.nextSibling, s = o.firstChild, l = s.firstChild;
    return a.addEventListener("change", n), E(l, () => r.mainText), E(s, g(H, {
      get when() {
        return r.tooltip;
      },
      get children() {
        return g(vK, {
          get text() {
            return r.tooltip;
          },
          get children() {
            return g(mt, {
              name: "informationCircle",
              size: "sm",
              class: "text-gray-400 cursor-help"
            });
          }
        });
      }
    }), null), E(o, g(H, {
      get when() {
        return r.showOptionalSubtext;
      },
      get children() {
        var d = yK();
        return se(() => pt(d, "for", r.id)), d;
      }
    }), null), se((d) => {
      var c = r.id, u = `${r.id}-description`, h = r.id, f = r.id;
      return c !== d.e && pt(a, "id", d.e = c), u !== d.t && pt(a, "aria-describedby", d.t = u), h !== d.a && pt(a, "name", d.a = h), f !== d.o && pt(l, "for", d.o = f), d;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), se(() => a.checked = r.checked), i;
  })();
}
var wK = /* @__PURE__ */ k("<select>");
function Gu(e) {
  const [t] = qu(), r = () => {
    const n = t.disabled || e.disabled, i = t.error;
    return Yt("block w-full rounded-lg border-0 py-3 px-4 ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:outline-none bg-white", {
      "ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-sky-500/40": !!i && !n,
      "text-gray-900 ring-gray-300 hover:ring-gray-400 focus:ring-2 focus:ring-sky-500/40": !i && !n && !!e.value,
      "text-gray-400 ring-gray-300 hover:ring-gray-400 focus:ring-2 focus:ring-sky-500/40": !i && !n && !e.value,
      "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": !!n
    });
  };
  return (() => {
    var n = wK();
    return K1(n, "blur", e.onBlur), K1(n, "change", e.onChange), E(n, () => e.children), se((i) => {
      var a = t.id, o = !!t.error || void 0, s = t.error ? `${t.id}-error` : void 0, l = t.required || e.required, d = t.required || e.required, c = t.disabled || e.disabled, u = r();
      return a !== i.e && pt(n, "id", i.e = a), o !== i.t && pt(n, "aria-invalid", i.t = o), s !== i.a && pt(n, "aria-describedby", i.a = s), l !== i.o && pt(n, "aria-required", i.o = l), d !== i.i && (n.required = i.i = d), c !== i.n && (n.disabled = i.n = c), u !== i.s && ft(n, i.s = u), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0
    }), se(() => n.value = e.value ?? ""), n;
  })();
}
const sk = Gr(), Rn = () => {
  const e = wr(sk);
  if (!e)
    throw new Error("usePhoton must be used within PhotonContext");
  return e;
};
var $K = /* @__PURE__ */ k("<option value disabled>"), kK = /* @__PURE__ */ k("<option>");
function _K(e) {
  const t = Rn();
  lr(() => {
    t && t.clinical.dispenseUnits.state.dispenseUnits.length === 0 && t.clinical.dispenseUnits.getDispenseUnits();
  });
  const r = () => t?.clinical.dispenseUnits.state.isLoading;
  return g(Gu, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled || r();
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [(() => {
        var n = $K();
        return E(n, () => r() ? "Loading..." : "Select a dispense unit"), n;
      })(), g(yt, {
        get each() {
          return t?.clinical.dispenseUnits.state.dispenseUnits;
        },
        children: (n) => (() => {
          var i = kK();
          return E(i, () => n.name), se(() => i.selected = e.value === n.name), se(() => i.value = n.name), i;
        })()
      })];
    }
  });
}
var xK = /* @__PURE__ */ k('<ul class="absolute z-10 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-sm ring-1 ring-black ring-opacity-5 overflow-auto mt-1"role=listbox>'), SK = /* @__PURE__ */ k('<li class="px-4 py-3 cursor-pointer text-gray-900 hover:bg-gray-50 active:bg-gray-100"role=option>');
function CK(e) {
  return g(H, {
    get when() {
      return e.suggestions.length > 0;
    },
    get children() {
      var t = xK();
      return E(t, g(yt, {
        get each() {
          return e.suggestions;
        },
        children: (r) => (() => {
          var n = SK();
          return n.$$mousedown = (i) => {
            i.preventDefault(), e.onSelect(r);
          }, E(n, () => r.description), n;
        })()
      })), t;
    }
  });
}
an(["mousedown"]);
let R0 = !1;
function EK({ onLoad: e, onError: t }) {
  if (window?.google?.maps)
    e();
  else if (R0) {
    const r = setInterval(() => {
      window?.google?.maps && (clearInterval(r), e());
    }, 100);
  } else {
    R0 = !0;
    const r = document.createElement("script");
    r.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAvuwwE6g2Bsmih66nu4dB7-H7U1_7KQ6g&callback=Function.prototype&libraries=places", document.head.appendChild(r), r.onload = () => {
      R0 = !1, e();
    }, r.onerror = (n) => {
      R0 = !1, t && t(n);
    };
  }
}
const c3 = Gr(), AK = (e) => {
  const [t, r] = V({
    geocoder: null,
    autocompleteService: null
  });
  return lr(() => {
    EK({
      onLoad: () => {
        r({
          geocoder: new google.maps.Geocoder(),
          autocompleteService: new google.maps.places.AutocompleteService()
        });
      },
      onError: (n) => {
        console.error("Error loading Google Maps script:", n);
      }
    });
  }), g(c3.Provider, {
    value: {
      googleMapsServices: t
    },
    get children() {
      return e.children;
    }
  });
}, u3 = () => {
  const e = wr(c3);
  if (!e)
    throw new Error("useGoogleService must be used within the GoogleServiceProvider");
  return e;
}, TK = () => wr(c3), h9 = [
  "locality",
  // most US addresses
  "sublocality_level_1",
  // NYC boroughs (Brooklyn, Queens, etc.)
  "sublocality",
  // other sub-city areas
  "neighborhood",
  // rare fallback
  "administrative_area_level_2"
  // unincorporated county areas
];
function OK(e) {
  let t = "", r = "", n = "";
  const i = {};
  let a = "", o = "";
  for (const c of e) {
    const u = c.types;
    if (u.includes("subpremise"))
      n = c.long_name;
    else if (u.includes("street_number"))
      t = c.long_name;
    else if (u.includes("route"))
      r = c.long_name;
    else if (u.includes("administrative_area_level_1"))
      a = c.short_name;
    else if (u.includes("postal_code"))
      o = c.long_name;
    else
      for (const h of h9)
        if (u.includes(h)) {
          i[h] = c.long_name;
          break;
        }
  }
  const s = h9.reduce((c, u) => c || i[u] || "", ""), l = t ? `${t} ${r}` : r, d = n ? `#${n}` : "";
  return { street1: l, street2: d, city: s, state: a, postalCode: o };
}
function IK({ onSelect: e }) {
  const [t, r] = V([]);
  let n = [], i;
  const a = TK();
  return { suggestions: t, fetchSuggestions: (o) => {
    if (clearTimeout(i), o.length < 3) {
      r([]);
      return;
    }
    i = setTimeout(async () => {
      const s = a?.googleMapsServices().autocompleteService;
      if (s)
        try {
          const l = ((await s.getPlacePredictions({
            input: o,
            types: ["address"],
            componentRestrictions: { country: "us" }
          })).predictions ?? []).map((d) => ({
            placeId: d.place_id,
            description: d.description
          }));
          n = l, r(l);
        } catch {
          r([]);
        }
    }, 300);
  }, selectSuggestion: async (o) => {
    n = [], r([]);
    const s = a?.googleMapsServices().geocoder;
    if (s)
      try {
        const l = (await s.geocode({ placeId: o.placeId })).results[0];
        l?.address_components && e(OK(l.address_components));
      } catch (l) {
        console.error("Geocode failed", l);
      }
  }, closeSuggestions: () => {
    clearTimeout(i), r([]);
  }, openSuggestions: () => {
    n.length > 0 && r(n);
  } };
}
var PK = /* @__PURE__ */ k("<div class=relative>");
function NK(e) {
  const [t, r, n] = go(e, ["onAddressSelect"], ["onInput", "onBlur"]), {
    suggestions: i,
    fetchSuggestions: a,
    selectSuggestion: o,
    closeSuggestions: s,
    openSuggestions: l
  } = IK({
    onSelect: t.onAddressSelect
  });
  return (() => {
    var d = PK();
    return E(d, g(Dt, it(n, {
      "data-1p-ignore": !0,
      onInput: (c) => {
        r.onInput && r.onInput(c), a(c.currentTarget.value);
      },
      onFocus: l,
      onBlur: (c) => {
        r.onBlur && r.onBlur(c), setTimeout(s, 200);
      }
    })), null), E(d, g(CK, {
      get suggestions() {
        return i();
      },
      onSelect: o
    }), null), d;
  })();
}
function DK(e) {
  return g(Dt, {
    type: "date",
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get value() {
      return e.value;
    },
    onInput: (t) => {
      e.onDateChange?.(t.currentTarget.value || void 0);
    },
    onPaste: (t) => {
      const r = t.clipboardData?.getData("Text");
      if (!r) return;
      const n = MK(r);
      n && (t.preventDefault(), e.onDateChange?.(n));
    },
    get onBlur() {
      return e.onBlur;
    }
  });
}
function MK(e) {
  const t = e.split(/[/\s-]/);
  if (t.length !== 3) return "";
  const [r, n, i] = t.map((a) => parseInt(a));
  return isNaN(r) || isNaN(n) || isNaN(i) || r < 1 || r > 12 || n < 1 || n > 31 ? "" : `${i}-${r.toString().padStart(2, "0")}-${n.toString().padStart(2, "0")}`;
}
var RK = /* @__PURE__ */ k("<option value disabled>Select state"), LK = /* @__PURE__ */ k("<option>");
function FK(e) {
  return g(Gu, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [RK(), g(yt, {
        each: B$,
        children: (t) => (() => {
          var r = LK();
          return E(r, () => t.name), se(() => r.selected = e.value === t.id), se(() => r.value = t.id), r;
        })()
      })];
    }
  });
}
const lk = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|8)\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "8776\\d{4}|(?:[27]\\d|61)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-8]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, 0, [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689])\\d|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["16|[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["18[06]", "18[06]0"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "8\\d{13}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["20"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["20"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{4})(\\d{5})", "$1-$2", ["892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8(?:0[0-7]|9)"], "0$1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, "[5-8]"], MC: ["377", "00", "(?:[3489]|[67]\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[67]"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["3[289]|4[246-8]|61|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "[3489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[25-7]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "(?:[0-57-9]\\d|66)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["\\d"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-579]|61)", "5(?:[0-579]|61[06])", "5(?:[0-579]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:274[27]|(?:472|983)[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|5[12]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function jK(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(lk), e.apply(this, r);
}
function f9(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), i = 0; i < 3; i++) {
    var a = Number(r[i]), o = Number(n[i]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var zK = {}.constructor;
function ys(e) {
  return e != null && e.constructor === zK;
}
function nd(e) {
  "@babel/helpers - typeof";
  return nd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nd(e);
}
function df(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function VK(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UK(n.key), n);
  }
}
function cf(e, t, r) {
  return t && VK(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function UK(e) {
  var t = qK(e, "string");
  return nd(t) == "symbol" ? t : t + "";
}
function qK(e, t) {
  if (nd(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (nd(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var BK = "1.2.0", HK = "1.7.35", p9 = " ext. ", WK = /^\d+$/, Kr = /* @__PURE__ */ (function() {
  function e(t) {
    df(this, e), dk(t), this.metadata = t, ck.call(this, t);
  }
  return cf(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && WK.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new m9(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new m9(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var n = this.nonGeographic()[t];
        if (n)
          return n;
      } else {
        var i = this.countryCallingCodes()[t];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]);
})(), m9 = /* @__PURE__ */ (function() {
  function e(t, r) {
    df(this, e), this.globalMetadataObject = r, this.metadata = t, ck.call(this, r.metadata);
  }
  return cf(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(n) {
        return new QK(n, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && g9(this.types(), t))
        return new GK(g9(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? p9 : this.metadata[13] || p9;
    }
  }]);
})(), QK = /* @__PURE__ */ (function() {
  function e(t, r) {
    df(this, e), this._format = t, this.metadata = r;
  }
  return cf(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !KK.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]);
})(), KK = /^\(?\$1\)?$/, GK = /* @__PURE__ */ (function() {
  function e(t, r) {
    df(this, e), this.type = t, this.metadata = r;
  }
  return cf(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
})();
function g9(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function dk(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!ys(e) || !ys(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(ys(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + ZK(e) + ": " + e, "."));
}
var ZK = function(e) {
  return nd(e);
};
function h3(e, t) {
  if (t = new Kr(t), t.hasCountry(e))
    return t.selectNumberingPlan(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function ck(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? f9(t, BK) === -1 ? this.v2 = !0 : f9(t, HK) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function uf(e, t, r) {
  return YK(e, t, void 0, r);
}
function YK(e, t, r, n) {
  t && (n = new Kr(n.metadata), n.selectNumberingPlan(t));
  var i = n.type(r), a = i && i.possibleLengths() || n.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var o = e.length, s = a[0];
  return s === o ? "IS_POSSIBLE" : s > o ? "TOO_SHORT" : a[a.length - 1] < o ? "TOO_LONG" : a.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function JK(e, t, r) {
  if (t === void 0 && (t = {}), r = new Kr(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.selectNumberingPlan(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return uk(e.phone || e.nationalNumber, e.country, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function uk(e, t, r) {
  return uf(e, t, r) === "IS_POSSIBLE";
}
function Aa(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function XK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = eG(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eG(e, t) {
  if (e) {
    if (typeof e == "string") return v9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v9(e, t) : void 0;
  }
}
function v9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var tG = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function f3(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new Kr(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (Aa(n, r.nationalNumberPattern())) {
      if (B2(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || B2(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = XK(tG), a; !(a = i()).done; ) {
        var o = a.value;
        if (B2(n, o, r))
          return o;
      }
    }
  }
}
function B2(e, t, r) {
  var n = r.type(t);
  return !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : Aa(e, n.pattern());
}
function rG(e, t, r) {
  if (t = t || {}, r = new Kr(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return f3(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return Aa(n, r.nationalNumberPattern());
}
function nG(e, t, r) {
  var n = new Kr(r), i = n.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(a) {
    return iG(t, a, r);
  }) : [];
}
function iG(e, t, r) {
  var n = new Kr(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var p3 = 2, aG = 17, oG = 3, $n = "0-9０-９٠-٩۰-۹", sG = "-‐-―−ー－", lG = "／/", dG = "．.", cG = "  ­​⁠　", uG = "()（）［］\\[\\]", hG = "~⁓∼～", Si = "".concat(sG).concat(lG).concat(dG).concat(cG).concat(uG).concat(hG), hf = "+＋", fG = new RegExp("([" + $n + "])");
function hk(e, t, r, n) {
  if (t) {
    var i = new Kr(n);
    i.selectNumberingPlan(t, r);
    var a = new RegExp(i.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(fG);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function am(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var i, a, o = n.length - 1, s = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && s)
        i = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (a = n[1]);
      else {
        var l = n[0];
        i = e.slice(l.length), s && (a = n[1]);
      }
      var d;
      if (s) {
        var c = e.indexOf(n[1]), u = e.slice(0, c);
        u === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = n[0];
      return {
        nationalNumber: i,
        nationalPrefix: d,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function pG(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = mG(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mG(e, t) {
  if (e) {
    if (typeof e == "string") return y9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y9(e, t) : void 0;
  }
}
function y9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function fk(e, t) {
  var r = t.countries, n = t.metadata;
  n = new Kr(n);
  for (var i = pG(r), a; !(a = i()).done; ) {
    var o = a.value;
    if (n.selectNumberingPlan(o), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return o;
    } else if (f3({
      phone: e,
      country: o
    }, void 0, n.metadata))
      return o;
  }
}
function m3(e, t) {
  var r = t.nationalNumber, n = t.metadata, i = n.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : fk(r, {
      countries: i,
      metadata: n.metadata
    });
}
function om(e, t, r) {
  var n = am(e, r), i = n.carrierCode, a = n.nationalNumber;
  if (a !== e) {
    if (!gG(e, a, r))
      return {
        nationalNumber: e
      };
    if (r.numberingPlan.possibleLengths() && (t || (t = m3(r.numberingPlan.callingCode(), {
      nationalNumber: a,
      metadata: r
    })), !vG(a, t, r)))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: i
  };
}
function gG(e, t, r) {
  return !(Aa(e, r.nationalNumberPattern()) && !Aa(t, r.nationalNumberPattern()));
}
function vG(e, t, r) {
  switch (uf(e, t, r)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function pk(e, t, r, n, i) {
  var a = t || r ? h3(t || r, i) : n;
  if (e.indexOf(a) === 0) {
    i = new Kr(i), i.selectNumberingPlan(t || r, a);
    var o = e.slice(a.length), s = om(o, t, i), l = s.nationalNumber, d = om(e, t, i), c = d.nationalNumber;
    if (!Aa(c, i.nationalNumberPattern()) && Aa(l, i.nationalNumberPattern()) || uf(c, t, i) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: o
      };
  }
  return {
    number: e
  };
}
function g3(e, t, r, n, i) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var o = hk(e, t || r, n, i);
    if (o && o !== e)
      a = !0, e = "+" + o;
    else {
      if (t || r || n) {
        var s = pk(e, t, r, n, i), l = s.countryCallingCode, d = s.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  i = new Kr(i);
  for (var c = 2; c - 1 <= oG && c <= e.length; ) {
    var u = e.slice(1, c);
    if (i.hasCallingCode(u))
      return i.selectNumberingPlan(u), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(c)
      };
    c++;
  }
  return {};
}
function mk(e) {
  return e.replace(new RegExp("[".concat(Si, "]+"), "g"), " ").trim();
}
var gk = /(\$\d)/;
function vk(e, t, r) {
  var n = r.useInternationalFormat, i = r.withNationalPrefix;
  r.carrierCode, r.metadata;
  var a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && t.nationalPrefixFormattingRule() ? t.format().replace(gk, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? mk(a) : a;
}
var yG = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function bG(e, t, r) {
  var n = new Kr(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (yG.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var wG = ";ext=", Zs = function(e) {
  return "([".concat($n, "]{1,").concat(e, "})");
};
function yk(e) {
  var t = "20", r = "15", n = "9", i = "6", a = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", u = "[  \\t]*", h = "(?:,{2}|;)", f = wG + Zs(t), p = a + l + o + Zs(t) + s, m = a + d + o + Zs(n) + s, y = c + Zs(i) + "#", v = u + h + o + Zs(r) + s, b = u + "(?:,)+" + o + Zs(n) + s;
  return f + "|" + p + "|" + m + "|" + y + "|" + v + "|" + b;
}
var $G = "[" + $n + "]{" + p3 + "}", kG = "[" + hf + "]{0,1}(?:[" + Si + "]*[" + $n + "]){3,}[" + Si + $n + "]*", _G = new RegExp("^[" + hf + "]{0,1}(?:[" + Si + "]*[" + $n + "]){1,2}$", "i"), xG = kG + // Phone number extensions
"(?:" + yk() + ")?", SG = new RegExp(
  // Either a short two-digit-only phone number
  "^" + $G + "$|^" + xG + "$",
  "i"
);
function CG(e) {
  return e.length >= p3 && SG.test(e);
}
function EG(e) {
  return _G.test(e);
}
function AG(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
var b9 = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function TG(e, t, r, n) {
  if (r ? r = PG({}, b9, r) : r = b9, n = new Kr(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.selectNumberingPlan(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var i = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return a ? (o = sh(a, e.carrierCode, "NATIONAL", n, r), H2(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (o = sh(a, null, "INTERNATIONAL", n, r), o = "+".concat(i, " ").concat(o), H2(o, e.ext, n, r.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(a);
    case "RFC3966":
      return AG({
        number: "+".concat(i).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var s = IG(a, e.carrierCode, i, r.fromCountry, n);
      return s ? H2(s, e.ext, n, r.formatExtension) : void 0;
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function sh(e, t, r, n, i) {
  var a = OG(n.formats(), e);
  return a ? vk(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: t,
    metadata: n
  }) : e;
}
function OG(e, t) {
  return NG(e, function(r) {
    if (r.leadingDigitsPatterns().length > 0) {
      var n = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(n) !== 0)
        return !1;
    }
    return Aa(t, r.pattern());
  });
}
function H2(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function IG(e, t, r, n, i) {
  var a = h3(n, i.metadata);
  if (a === r) {
    var o = sh(e, t, "NATIONAL", i);
    return r === "1" ? r + " " + o : o;
  }
  var s = bG(n, void 0, i.metadata);
  if (s)
    return "".concat(s, " ").concat(r, " ").concat(sh(e, null, "INTERNATIONAL", i));
}
function PG() {
  for (var e = 1, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  for (; e < r.length; ) {
    if (r[e])
      for (var i in r[e])
        r[0][i] = r[e][i];
    e++;
  }
  return r[0];
}
function NG(e, t) {
  for (var r = 0; r < e.length; ) {
    if (t(e[r]))
      return e[r];
    r++;
  }
}
function cu(e) {
  "@babel/helpers - typeof";
  return cu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cu(e);
}
function w9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w9(Object(r), !0).forEach(function(n) {
      DG(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : w9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DG(e, t, r) {
  return (t = bk(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MG(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function RG(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bk(n.key), n);
  }
}
function LG(e, t, r) {
  return t && RG(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bk(e) {
  var t = FG(e, "string");
  return cu(t) == "symbol" ? t : t + "";
}
function FG(e, t) {
  if (cu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (cu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var wk = /* @__PURE__ */ (function() {
  function e(t, r, n) {
    if (MG(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (t[0] === "+" && !r)
      throw new TypeError("`metadata` argument not passed");
    if (ys(r) && ys(r.countries)) {
      n = r;
      var i = t;
      if (!VG.test(i))
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      var a = g3(i, void 0, void 0, void 0, n), o = a.countryCallingCode, s = a.number;
      if (r = s, t = o, !r)
        throw new Error("Invalid `number` argument passed: too short");
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    dk(n);
    var l = zG(t, n), d = l.country, c = l.countryCallingCode;
    this.country = d, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return LG(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : nG(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return JK(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return rG(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new Kr(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return f3(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return TG(this, t, r ? $9($9({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]);
})(), jG = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function zG(e, t) {
  var r, n, i = new Kr(t);
  return jG(e) ? (r = e, i.selectNumberingPlan(r), n = i.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var VG = /^\+\d+$/;
function sm(e) {
  "@babel/helpers - typeof";
  return sm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sm(e);
}
function UG(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qG(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function BG(e, t, r) {
  return t = hu(t), HG(e, v3() ? Reflect.construct(t, r || [], hu(e).constructor) : t.apply(e, r));
}
function HG(e, t) {
  if (t && (sm(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return WG(e);
}
function WG(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function QG(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && uu(e, t);
}
function lm(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return lm = function(r) {
    if (r === null || !GG(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r)) return t.get(r);
      t.set(r, n);
    }
    function n() {
      return KG(r, arguments, hu(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), uu(n, r);
  }, lm(e);
}
function KG(e, t, r) {
  if (v3()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var i = new (e.bind.apply(e, n))();
  return r && uu(i, r.prototype), i;
}
function v3() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (v3 = function() {
    return !!e;
  })();
}
function GG(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function uu(e, t) {
  return uu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, uu(e, t);
}
function hu(e) {
  return hu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, hu(e);
}
var eo = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return qG(this, t), n = BG(this, t, [r]), Object.setPrototypeOf(n, t.prototype), n.name = n.constructor.name, n;
  }
  return QG(t, e), UG(t);
})(/* @__PURE__ */ lm(Error)), k9 = new RegExp("(?:" + yk() + ")$", "i");
function ZG(e) {
  var t = e.search(k9);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(k9), i = 1; i < n.length; ) {
    if (n[i])
      return {
        number: r,
        ext: n[i]
      };
    i++;
  }
}
function YG(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = JG(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JG(e, t) {
  if (e) {
    if (typeof e == "string") return _9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _9(e, t) : void 0;
  }
}
function _9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var XG = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function $k(e) {
  return XG[e];
}
function lh(e) {
  for (var t = "", r = YG(e.split("")), n; !(n = r()).done; ) {
    var i = n.value, a = $k(i);
    a && (t += a);
  }
  return t;
}
function eZ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = tZ(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tZ(e, t) {
  if (e) {
    if (typeof e == "string") return x9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? x9(e, t) : void 0;
  }
}
function x9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function S9(e) {
  for (var t = "", r = eZ(e.split("")), n; !(n = r()).done; ) {
    var i = n.value;
    t += rZ(i, t) || "";
  }
  return t;
}
function rZ(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : $k(e);
}
var kk = "+", nZ = "[\\-\\.\\(\\)]?", C9 = "([" + $n + "]|" + nZ + ")", iZ = "^\\" + kk + C9 + "*[" + $n + "]" + C9 + "*$", aZ = new RegExp(iZ, "g"), dm = $n, oZ = "[" + dm + "]+((\\-)*[" + dm + "])*", sZ = "a-zA-Z", lZ = "[" + sZ + "]+((\\-)*[" + dm + "])*", dZ = "^(" + oZ + "\\.)*" + lZ + "\\.?$", cZ = new RegExp(dZ, "g"), E9 = "tel:", cm = ";phone-context=", uZ = ";isub=";
function hZ(e) {
  var t = e.indexOf(cm);
  if (t < 0)
    return null;
  var r = t + cm.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function fZ(e) {
  return e === null ? !0 : e.length === 0 ? !1 : aZ.test(e) || cZ.test(e);
}
function pZ(e, t) {
  var r = t.extractFormattedPhoneNumber, n = hZ(e);
  if (!fZ(n))
    throw new eo("NOT_A_NUMBER");
  var i;
  if (n === null)
    i = r(e) || "";
  else {
    i = "", n.charAt(0) === kk && (i += n);
    var a = e.indexOf(E9), o;
    a >= 0 ? o = a + E9.length : o = 0;
    var s = e.indexOf(cm);
    i += e.substring(o, s);
  }
  var l = i.indexOf(uZ);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var mZ = 250, gZ = new RegExp("[" + hf + $n + "]"), vZ = new RegExp("[^" + $n + "#]+$");
function yZ(e, t, r) {
  if (t = t || {}, r = new Kr(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new eo("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = wZ(e, t.v2, t.extract), i = n.number, a = n.ext, o = n.error;
  if (!i) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new eo("TOO_SHORT") : new eo("NOT_A_NUMBER");
    return {};
  }
  var s = kZ(i, t.defaultCountry, t.defaultCallingCode, r), l = s.country, d = s.nationalNumber, c = s.countryCallingCode, u = s.countryCallingCodeSource, h = s.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new eo("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < p3) {
    if (t.v2)
      throw new eo("TOO_SHORT");
    return {};
  }
  if (d.length > aG) {
    if (t.v2)
      throw new eo("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var f = new wk(c, d, r.metadata);
    return l && (f.country = l), h && (f.carrierCode = h), a && (f.ext = a), f.__countryCallingCodeSource = u, f;
  }
  var p = (t.extended ? r.hasSelectedNumberingPlan() : l) ? Aa(d, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: c,
    carrierCode: h,
    valid: p,
    possible: p ? !0 : !!(t.extended === !0 && r.possibleLengths() && uk(d, l, r)),
    phone: d,
    ext: a
  } : p ? $Z(l, d, a) : {};
}
function bZ(e, t, r) {
  if (e) {
    if (e.length > mZ) {
      if (r)
        throw new eo("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(gZ);
    if (!(n < 0))
      return e.slice(n).replace(vZ, "");
  }
}
function wZ(e, t, r) {
  var n = pZ(e, {
    extractFormattedPhoneNumber: function(a) {
      return bZ(a, r, t);
    }
  });
  if (!n)
    return {};
  if (!CG(n))
    return EG(n) ? {
      error: "TOO_SHORT"
    } : {};
  var i = ZG(n);
  return i.ext ? i : {
    number: n
  };
}
function $Z(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function kZ(e, t, r, n) {
  var i = g3(S9(e), void 0, t, r, n.metadata), a = i.countryCallingCodeSource, o = i.countryCallingCode, s = i.number, l;
  if (o)
    n.selectNumberingPlan(o);
  else if (s && (t || r))
    n.selectNumberingPlan(t, r), t && (l = t), o = r || h3(t, n.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o
    };
  var d = om(S9(s), l, n), c = d.nationalNumber, u = d.carrierCode, h = m3(o, {
    nationalNumber: c,
    metadata: n
  });
  return h && (l = h, h === "001" || n.selectNumberingPlan(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: u
  };
}
function fu(e) {
  "@babel/helpers - typeof";
  return fu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fu(e);
}
function A9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function T9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A9(Object(r), !0).forEach(function(n) {
      _Z(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : A9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _Z(e, t, r) {
  return (t = xZ(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xZ(e) {
  var t = SZ(e, "string");
  return fu(t) == "symbol" ? t : t + "";
}
function SZ(e, t) {
  if (fu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function CZ(e, t, r) {
  return yZ(e, T9(T9({}, t), {}, {
    v2: !0
  }), r);
}
function pu(e) {
  "@babel/helpers - typeof";
  return pu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pu(e);
}
function O9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function EZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O9(Object(r), !0).forEach(function(n) {
      AZ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function AZ(e, t, r) {
  return (t = TZ(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function TZ(e) {
  var t = OZ(e, "string");
  return pu(t) == "symbol" ? t : t + "";
}
function OZ(e, t) {
  if (pu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (pu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function IZ(e, t) {
  return MZ(e) || DZ(e, t) || NZ(e, t) || PZ();
}
function PZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NZ(e, t) {
  if (e) {
    if (typeof e == "string") return I9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? I9(e, t) : void 0;
  }
}
function I9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function DZ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (c) {
      d = !0, i = c;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw i;
      }
    }
    return s;
  }
}
function MZ(e) {
  if (Array.isArray(e)) return e;
}
function RZ(e) {
  var t = Array.prototype.slice.call(e), r = IZ(t, 4), n = r[0], i = r[1], a = r[2], o = r[3], s, l, d;
  if (typeof n == "string")
    s = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    o ? (l = a, d = o) : (l = void 0, d = a), i && (l = EZ({
      defaultCountry: i
    }, l));
  else if (ys(i))
    a ? (l = i, d = a) : d = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: s,
    options: l,
    metadata: d
  };
}
function LZ() {
  var e = RZ(arguments), t = e.text, r = e.options, n = e.metadata;
  return CZ(t, r, n);
}
function mu(e) {
  "@babel/helpers - typeof";
  return mu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mu(e);
}
function FZ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function jZ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VZ(n.key), n);
  }
}
function zZ(e, t, r) {
  return t && jZ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function VZ(e) {
  var t = UZ(e, "string");
  return mu(t) == "symbol" ? t : t + "";
}
function UZ(e, t) {
  if (mu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (mu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var qZ = /* @__PURE__ */ (function() {
  function e(t) {
    var r = t.onCountryChange, n = t.onCallingCodeChange;
    FZ(this, e), this.onCountryChange = r, this.onCallingCodeChange = n;
  }
  return zZ(e, [{
    key: "reset",
    value: function(t) {
      var r = t.country, n = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, n);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberIsModified = !1, this.nationalPrefix = void 0, this.carrierCode = void 0, this.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var r = 0, n = Object.keys(t); r < n.length; r++) {
        var i = n[r];
        this[i] = t[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, r) {
      this.setCountry(t), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      this.international = !0, this.initCountryAndCallingCode(t, r);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]);
})();
function BZ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = HZ(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HZ(e, t) {
  if (e) {
    if (typeof e == "string") return P9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? P9(e, t) : void 0;
  }
}
function P9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var hi = "x", W2 = new RegExp(hi);
function g1(e, t) {
  if (t < 1)
    return "";
  for (var r = ""; t > 1; )
    t & 1 && (r += e), t >>= 1, e += e;
  return r + e;
}
function N9(e, t) {
  return e[t] === ")" && t++, WZ(e.slice(0, t));
}
function WZ(e) {
  for (var t = [], r = 0; r < e.length; )
    e[r] === "(" ? t.push(r) : e[r] === ")" && t.pop(), r++;
  var n = 0, i = "";
  t.push(e.length);
  for (var a = 0, o = t; a < o.length; a++) {
    var s = o[a];
    i += e.slice(n, s), n = s + 1;
  }
  return i;
}
function QZ(e, t, r) {
  for (var n = BZ(r.split("")), i; !(i = n()).done; ) {
    var a = i.value;
    if (e.slice(t + 1).search(W2) < 0)
      return;
    t = e.search(W2), e = e.replace(W2, a);
  }
  return [e, t];
}
function KZ(e, t, r) {
  var n = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return ZZ(e, t, {
      metadata: n,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: a
    });
}
function GZ(e, t, r) {
  return uf(e, t, r) === "IS_POSSIBLE";
}
function ZZ(e, t, r) {
  var n = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, i(t)) {
    var o = D9(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: a,
      metadata: n
    });
    if (o)
      return o;
  }
  return D9(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: a,
    metadata: n
  });
}
function D9(e, t, r) {
  var n = r.metadata, i = r.useNationalPrefixFormattingRule, a = r.getSeparatorAfterNationalPrefix, o = vk(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: i,
    metadata: n
  });
  if (i || (e.nationalPrefix ? o = e.nationalPrefix + a(t) + o : e.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix && (o = e.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix + " " + o)), YZ(o, e))
    return o;
}
function YZ(e, t) {
  return lh(e) === t.getNationalDigits();
}
function gu(e) {
  "@babel/helpers - typeof";
  return gu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gu(e);
}
function JZ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function XZ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tY(n.key), n);
  }
}
function eY(e, t, r) {
  return t && XZ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tY(e) {
  var t = rY(e, "string");
  return gu(t) == "symbol" ? t : t + "";
}
function rY(e, t) {
  if (gu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (gu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var nY = /* @__PURE__ */ (function() {
  function e() {
    JZ(this, e);
  }
  return eY(e, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], n = r.branches, i = r.instructions;
      if (n)
        return {
          op: "|",
          args: n.concat([Q2(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var r = t.match(oY);
      if (!r) {
        if (aY.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var n = r[1], i = t.slice(0, r.index), a = t.slice(r.index + n.length);
      switch (n) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var o = this.getContext(), s = o.branches;
          s.push(Q2(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: s
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(Q2(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: iY(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(n));
      }
      a && this.parsePattern(a);
    }
  }]);
})();
function iY(e) {
  for (var t = [], r = 0; r < e.length; ) {
    if (e[r] === "-") {
      if (r === 0 || r === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var n = e[r - 1].charCodeAt(0) + 1, i = e[r + 1].charCodeAt(0) - 1, a = n; a <= i; )
        t.push(String.fromCharCode(a)), a++;
    } else
      t.push(e[r]);
    r++;
  }
  return t;
}
var aY = /[\(\)\[\]\?\:\|]/, oY = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function Q2(e) {
  return e.length === 1 ? e[0] : e;
}
function M9(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = sY(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sY(e, t) {
  if (e) {
    if (typeof e == "string") return R9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? R9(e, t) : void 0;
  }
}
function R9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function vu(e) {
  "@babel/helpers - typeof";
  return vu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vu(e);
}
function lY(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function dY(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uY(n.key), n);
  }
}
function cY(e, t, r) {
  return t && dY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function uY(e) {
  var t = hY(e, "string");
  return vu(t) == "symbol" ? t : t + "";
}
function hY(e, t) {
  if (vu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fY = /* @__PURE__ */ (function() {
  function e(t) {
    lY(this, e), this.matchTree = new nY().parse(t);
  }
  return cY(e, [{
    key: "match",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var i = um(t.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !n))
        return i;
    }
  }]);
})();
function um(e, t, r) {
  if (typeof t == "string") {
    var n = e.join("");
    return t.indexOf(n) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : n.indexOf(t) === 0 ? r && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var i = e.slice(), a = 0; a < t.length; ) {
      var o = t[a], s = um(i, o, r && a === t.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (i = i.slice(s.matchedChars.length), i.length === 0)
            return a === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      a++;
    }
    return r ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - i.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var l, d = M9(t.args), c; !(c = d()).done; ) {
        var u = c.value, h = um(e, u, r);
        if (h) {
          if (h.overflow)
            return h;
          if (h.match)
            return {
              match: !0,
              matchedChars: h.matchedChars
            };
          if (h.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(h, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var f = M9(t.args), p; !(p = f()).done; ) {
        var m = p.value;
        if (e[0] === m)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : r ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [m]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function yu(e) {
  "@babel/helpers - typeof";
  return yu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yu(e);
}
function L9(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = pY(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pY(e, t) {
  if (e) {
    if (typeof e == "string") return F9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? F9(e, t) : void 0;
  }
}
function F9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function mY(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function gY(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yY(n.key), n);
  }
}
function vY(e, t, r) {
  return t && gY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yY(e) {
  var t = bY(e, "string");
  return yu(t) == "symbol" ? t : t + "";
}
function bY(e, t) {
  if (yu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (yu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var hm = "9", wY = 15, $Y = g1(hm, wY), kY = /[- ]/, _Y = function() {
  return /\[([^\[\]])*\]/g;
}, xY = function() {
  return /\d(?=[^,}][^,}])/g;
}, SY = new RegExp("[" + Si + "]*\\$1[" + Si + "]*(\\$\\d[" + Si + "]*)*$"), j9 = 3, CY = /* @__PURE__ */ (function() {
  function e(t) {
    t.state;
    var r = t.metadata;
    mY(this, e), this.metadata = r, this.resetFormat();
  }
  return vY(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, r) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, r) {
      var n = this;
      if (GZ(r.nationalSignificantNumber, r.country, this.metadata))
        for (var i = L9(this.matchingFormats), a; !(a = i()).done; ) {
          var o = a.value, s = KZ(r, o, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(l) {
              return n.shouldTryNationalPrefixFormattingRule(l, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(l) {
              return n.getSeparatorAfterNationalPrefix(l);
            }
          });
          if (s)
            return this.resetFormat(), this.chosenFormat = o, this.setNationalNumberTemplate(s.replace(/\d/g, hi), r), this.populatedNationalNumberTemplate = s, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(hi), s;
        }
      return this.formatNationalNumberWithNextDigits(t, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, r) {
      var n = this.chosenFormat, i = this.chooseFormat(r);
      if (i)
        return i === n ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var r = this, n = t.nationalSignificantNumber, i = t.nationalPrefix, a = t.international, o = n, s = o.length - j9;
      s < 0 && (s = 0), this.matchingFormats = this.matchingFormats.filter(function(l) {
        return r.formatSuits(l, a, i) && r.formatMatches(l, o, s);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, r, n) {
      return !(n && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !n && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, r, n) {
      var i = t.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      n = Math.min(n, i - 1);
      var a = t.leadingDigitsPatterns()[n];
      if (r.length < j9)
        try {
          return new fY(a).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (o) {
          return console.error(o), !0;
        }
      return new RegExp("^(".concat(a, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, r) {
      return r ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var r = this, n = function() {
        var s = o.value;
        return r.chosenFormat === s ? 0 : SY.test(r.getFormatFormat(s, t.international)) ? r.createTemplateForFormat(s, t) ? (r.chosenFormat = s, 0) : (r.matchingFormats = r.matchingFormats.filter(function(l) {
          return l !== s;
        }), 1) : 1;
      }, i, a = L9(this.matchingFormats.slice()), o; !(o = a()).done && (i = n(), i !== 0); )
        ;
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, r) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var n = this.getTemplateForFormat(t, r);
        if (n)
          return this.setNationalNumberTemplate(n, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && kY.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, r) {
      var n = t.IDDPrefix, i = t.missingPlus;
      return n ? r && r.spacing === !1 ? n : n + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var r = -1, n = 0, i = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; n < i.length + t.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(hi, r + 1), n++;
        return N9(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, r) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, hi) + g1(hi, r.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, r) {
      var n = r.nationalSignificantNumber, i = r.international, a = r.nationalPrefix, o = r.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, s = t.pattern();
      s = s.replace(_Y(), "\\d").replace(xY(), "\\d");
      var l = $Y.match(s)[0];
      if (!(n.length > l.length)) {
        var d = new RegExp("^" + s + "$"), c = n.replace(/\d/g, hm);
        d.test(c) && (l = c);
        var u = this.getFormatFormat(t, i), h;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: i,
          nationalPrefix: a
        })) {
          var f = u.replace(gk, t.nationalPrefixFormattingRule());
          if (lh(t.nationalPrefixFormattingRule()) === (a || "") + lh("$1") && (u = f, h = !0, a))
            for (var p = a.length; p > 0; )
              u = u.replace(/\d/, hi), p--;
        }
        var m = l.replace(new RegExp(s), u).replace(new RegExp(hm, "g"), hi);
        return h || (o ? m = g1(hi, o.length) + " " + m : a && (m = g1(hi, a.length) + this.getSeparatorAfterNationalPrefix(t) + m)), i && (m = mk(m)), m;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var r = QZ(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], N9(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, r) {
      var n = r.international, i = r.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var a = t.usesNationalPrefix();
        if (a && i || !a && !n)
          return !0;
      }
    }
  }]);
})();
function bu(e) {
  "@babel/helpers - typeof";
  return bu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bu(e);
}
function _k(e, t) {
  return OY(e) || TY(e, t) || AY(e, t) || EY();
}
function EY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AY(e, t) {
  if (e) {
    if (typeof e == "string") return z9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? z9(e, t) : void 0;
  }
}
function z9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function TY(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (c) {
      d = !0, i = c;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw i;
      }
    }
    return s;
  }
}
function OY(e) {
  if (Array.isArray(e)) return e;
}
function IY(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function PY(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DY(n.key), n);
  }
}
function NY(e, t, r) {
  return t && PY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function DY(e) {
  var t = MY(e, "string");
  return bu(t) == "symbol" ? t : t + "";
}
function MY(e, t) {
  if (bu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (bu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var RY = "[" + Si + $n + "]+", LY = new RegExp("^" + RY + "$", "i"), FY = "(?:[" + hf + "][" + Si + $n + "]*|[" + Si + $n + "]+)", jY = new RegExp("[^" + Si + $n + "]+.*$"), zY = /[^\d\[\]]/, VY = /* @__PURE__ */ (function() {
  function e(t) {
    var r = t.defaultCountry, n = t.defaultCallingCode, i = t.metadata, a = t.onNationalSignificantNumberChange;
    IY(this, e), this.defaultCountry = r, this.defaultCallingCode = n, this.metadata = i, this.onNationalSignificantNumberChange = a;
  }
  return NY(e, [{
    key: "input",
    value: function(t, r) {
      var n = BY(t), i = _k(n, 2), a = i[0], o = i[1], s = lh(a), l;
      return o && (r.digits || (r.startInternationalNumber(void 0, void 0), s || (l = !0))), s && this.inputDigits(s, r), {
        digits: s,
        justLeadingPlus: l
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, r) {
      var n = r.digits, i = n.length < 3 && n.length + t.length >= 3;
      if (r.appendDigits(t), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(t);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
        return r.update(a);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var r = t.international, n = t.callingCode;
      return r && !n;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var r = g3("+" + t.getDigitsWithoutInternationalPrefix(), t.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), n = r.countryCallingCode, i = r.number;
      if (n)
        return t.setCallingCode(n), t.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var r = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && zY.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, r) {
      if (this.hasSelectedNumberingPlan) {
        var n = am(t, this.metadata), i = n.nationalPrefix, a = n.nationalNumber, o = n.carrierCode;
        if (a !== t)
          return this.onExtractedNationalNumber(i, o, a, t, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, r, n) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, n);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = am(t, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, s = i.carrierCode;
        if (o !== r)
          return this.onExtractedNationalNumber(a, s, o, t, n), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, r, n, i, a) {
      var o = !1, s, l = i.lastIndexOf(n);
      if (l < 0 || l !== i.length - n.length)
        o = !0;
      else {
        var d = i.slice(0, l);
        d && d !== t && (s = d);
      }
      a({
        nationalPrefix: t,
        carrierCode: r,
        nationalSignificantNumber: n,
        nationalSignificantNumberIsModified: o,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(r) {
        return t.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var r = t.international, n = t.IDDPrefix, i = t.digits;
      if (t.nationalSignificantNumber, !(r || n)) {
        var a = hk(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (a !== void 0 && a !== i)
          return t.update({
            IDDPrefix: i.slice(0, i.length - a.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var r = pk(t.digits, t.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), n = r.countryCallingCode;
        if (n)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: n
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      var n = r.country, i = r.callingCode;
      t.startInternationalNumber(n, i), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(r) {
        return t.update(r);
      });
    }
  }]);
})();
function UY(e) {
  var t = e.search(FY);
  if (!(t < 0)) {
    e = e.slice(t);
    var r;
    return e[0] === "+" && (r = !0, e = e.slice(1)), e = e.replace(jY, ""), r && (e = "+" + e), e;
  }
}
function qY(e) {
  var t = UY(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function BY(e) {
  var t = qY(e), r = _k(t, 2), n = r[0], i = r[1];
  return LY.test(n) || (n = ""), [n, i];
}
function wu(e) {
  "@babel/helpers - typeof";
  return wu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wu(e);
}
function HY(e, t) {
  return GY(e) || KY(e, t) || QY(e, t) || WY();
}
function WY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QY(e, t) {
  if (e) {
    if (typeof e == "string") return V9(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? V9(e, t) : void 0;
  }
}
function V9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function KY(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (c) {
      d = !0, i = c;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw i;
      }
    }
    return s;
  }
}
function GY(e) {
  if (Array.isArray(e)) return e;
}
function ZY(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function YY(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, XY(n.key), n);
  }
}
function JY(e, t, r) {
  return t && YY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function XY(e) {
  var t = eJ(e, "string");
  return wu(t) == "symbol" ? t : t + "";
}
function eJ(e, t) {
  if (wu(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var xk = /* @__PURE__ */ (function() {
  function e(t, r) {
    ZY(this, e), this.metadata = new Kr(r);
    var n = this.getCountryAndCallingCode(t), i = HY(n, 2), a = i[0], o = i[1];
    this.defaultCountry = a, this.defaultCallingCode = o, this.reset();
  }
  return JY(e, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var r, n;
      return t && (ys(t) ? (r = t.defaultCountry, n = t.defaultCallingCode) : r = t), r && !this.metadata.hasCountry(r) && (r = void 0), [r, n];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var r = this.parser.input(t, this.state), n = r.digits, i = r.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (n) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var a;
        if (this.metadata.hasSelectedNumberingPlan() && (a = this.formatter.format(n, this.state)), a === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var o = this.state.getNationalDigits();
          o && (a = this.formatter.format(o, this.state));
        }
        this.formattedOutput = a ? this.getFullNumber(a) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new qZ({
        onCountryChange: function(r) {
          t.country = r;
        },
        onCallingCodeChange: function(r, n) {
          t.metadata.selectNumberingPlan(n, r), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new CY({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new VY({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var r = this;
      if (this.isInternational()) {
        var n = function(a) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!a
          }) + a;
        }, i = this.state.callingCode;
        return n(i ? t ? "".concat(i, " ").concat(t) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, n = t.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, i = t.nationalPrefix, a = r, o = n || i;
      return o && (a = o + a), a;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberIsModified;
      return this.getFullNumber(t ? this.state.getNationalDigits() : this.getNonFormattedNationalNumberWithPrefix());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, hi);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(t);
      return r && r.length > 1;
    }
    // Determines the exact country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(m3(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, r = t.digits, n = t.callingCode, i = t.country, a = t.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return n ? "+" + n + a : "+" + r;
        if (i || n) {
          var o = i ? this.metadata.countryCallingCode() : n;
          return "+" + o + a;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, n = t.carrierCode, i = t.callingCode, a = this._getCountry();
      if (r && !(!a && !i)) {
        if (a && a === this.defaultCountry) {
          var o = new Kr(this.metadata.metadata);
          o.selectNumberingPlan(a);
          var s = o.numberingPlan.callingCode(), l = this.metadata.getCountryCodesForCallingCode(s);
          if (l.length > 1) {
            var d = fk(r, {
              countries: l,
              metadata: this.metadata.metadata
            });
            d && (a = d);
          }
        }
        var c = new wk(a || i, r, this.metadata.metadata);
        return n && (c.carrierCode = n), c;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]);
})();
function Sk() {
  return jK(LZ, arguments);
}
function dh(e) {
  return xk.call(this, e, lk);
}
dh.prototype = Object.create(xk.prototype, {});
dh.prototype.constructor = dh;
function tJ(e) {
  const [t, r] = V(e.value ? U9(e.value) : "");
  return fe(() => {
    e.value && r(U9(e.value));
  }), g(Dt, {
    type: "tel",
    placeholder: "(   ) ___-____",
    get value() {
      return t();
    },
    onInput: (n) => {
      r(n.currentTarget.value), e.onPhoneChange?.(rJ(n.currentTarget.value));
    },
    get onBlur() {
      return e.onBlur;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    }
  });
}
function U9(e) {
  try {
    if (e.length > 2)
      return new dh("US").input(Sk(e, "US").formatNational());
  } catch {
  }
  return e;
}
function rJ(e) {
  try {
    return Sk(e, "US").format("E.164");
  } catch {
    return e;
  }
}
var nJ = /* @__PURE__ */ k("<option value disabled>Select sex"), iJ = /* @__PURE__ */ k("<option>");
const Ck = [{
  value: "MALE",
  name: "Male"
}, {
  value: "FEMALE",
  name: "Female"
}, {
  value: "UNKNOWN",
  name: "Unknown"
}];
function aJ(e) {
  return g(Gu, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [nJ(), g(yt, {
        each: Ck,
        children: (t) => (() => {
          var r = iJ();
          return E(r, () => t.name), se(() => r.selected = e.value === t.value), se(() => r.value = t.value), r;
        })()
      })];
    }
  });
}
var oJ = /* @__PURE__ */ k("<option value disabled>Select gender"), sJ = /* @__PURE__ */ k("<option>");
const lJ = [{
  value: "Male/Man",
  name: "Male/Man"
}, {
  value: "Female/Woman",
  name: "Female/Woman"
}, {
  value: "TransMale/TransMan",
  name: "TransMale/TransMan"
}, {
  value: "TransFemale/TransWoman",
  name: "TransFemale/TransWoman"
}, {
  value: "Genderqueer/Gender nonconforming",
  name: "Genderqueer/Gender nonconforming"
}, {
  value: "Something else",
  name: "Something else"
}, {
  value: "Decline to answer",
  name: "Decline to answer"
}];
function dJ(e) {
  return g(Gu, {
    get value() {
      return e.value;
    },
    get required() {
      return e.required;
    },
    get disabled() {
      return e.disabled;
    },
    get onChange() {
      return e.onChange;
    },
    get onBlur() {
      return e.onBlur;
    },
    get children() {
      return [oJ(), g(yt, {
        each: lJ,
        children: (t) => (() => {
          var r = sJ();
          return E(r, () => t.name), se(() => r.selected = e.value === t.value), se(() => r.value = t.value), r;
        })()
      })];
    }
  });
}
const cJ = () => {
}, q9 = (e, t) => t();
function uJ(e, t) {
  const r = Qe(e), n = r ? [r] : [], { onEnter: i = q9, onExit: a = q9 } = t, [o, s] = V(t.appear ? [] : n), [l] = OS();
  let d, c = !1;
  function u(p, m) {
    if (!p)
      return m && m();
    c = !0, a(p, () => {
      A1(() => {
        c = !1, s((y) => y.filter((v) => v !== p)), m && m();
      });
    });
  }
  function h(p) {
    const m = d;
    if (!m)
      return p && p();
    d = void 0, s((y) => [m, ...y]), i(m, p ?? cJ);
  }
  const f = t.mode === "out-in" ? (
    // exit -> enter
    // exit -> enter
    ((p) => c || u(p, h))
  ) : t.mode === "in-out" ? (
    // enter -> exit
    // enter -> exit
    ((p) => h(() => u(p)))
  ) : (
    // exit & enter
    // exit & enter
    ((p) => {
      u(p), h();
    })
  );
  return bg((p) => {
    const m = e();
    return Qe(l) ? (l(), p) : (m !== p && (d = m, A1(() => Qe(() => f(p)))), m);
  }, t.appear ? void 0 : r), o;
}
const B9 = (e) => e instanceof Element;
function fm(e, t) {
  if (t(e))
    return e;
  if (typeof e == "function" && !e.length)
    return fm(e(), t);
  if (Array.isArray(e))
    for (const r of e) {
      const n = fm(r, t);
      if (n)
        return n;
    }
  return null;
}
function hJ(e, t = B9, r = B9) {
  const n = K(e);
  return K(() => fm(n(), t));
}
function fJ(e) {
  return K(() => {
    const t = e.name || "s";
    return {
      enterActive: (e.enterActiveClass || t + "-enter-active").split(" "),
      enter: (e.enterClass || t + "-enter").split(" "),
      enterTo: (e.enterToClass || t + "-enter-to").split(" "),
      exitActive: (e.exitActiveClass || t + "-exit-active").split(" "),
      exit: (e.exitClass || t + "-exit").split(" "),
      exitTo: (e.exitToClass || t + "-exit-to").split(" "),
      move: (e.moveClass || t + "-move").split(" ")
    };
  });
}
function Ek(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
function pJ(e, t, r, n) {
  const { onBeforeEnter: i, onEnter: a, onAfterEnter: o } = t;
  i?.(r), r.classList.add(...e.enter), r.classList.add(...e.enterActive), queueMicrotask(() => {
    if (!r.parentNode)
      return n?.();
    a?.(r, () => s());
  }), Ek(() => {
    r.classList.remove(...e.enter), r.classList.add(...e.enterTo), (!a || a.length < 2) && (r.addEventListener("transitionend", s), r.addEventListener("animationend", s));
  });
  function s(l) {
    (!l || l.target === r) && (n?.(), r.removeEventListener("transitionend", s), r.removeEventListener("animationend", s), r.classList.remove(...e.enterActive), r.classList.remove(...e.enterTo), o?.(r));
  }
}
function mJ(e, t, r, n) {
  const { onBeforeExit: i, onExit: a, onAfterExit: o } = t;
  if (!r.parentNode)
    return n?.();
  i?.(r), r.classList.add(...e.exit), r.classList.add(...e.exitActive), a?.(r, () => s()), Ek(() => {
    r.classList.remove(...e.exit), r.classList.add(...e.exitTo), (!a || a.length < 2) && (r.addEventListener("transitionend", s), r.addEventListener("animationend", s));
  });
  function s(l) {
    (!l || l.target === r) && (n?.(), r.removeEventListener("transitionend", s), r.removeEventListener("animationend", s), r.classList.remove(...e.exitActive), r.classList.remove(...e.exitTo), o?.(r));
  }
}
const gJ = {
  inout: "in-out",
  outin: "out-in"
}, H9 = (e) => {
  const t = fJ(e);
  return uJ(hJ(() => e.children), {
    mode: gJ[e.mode],
    appear: e.appear,
    onEnter(r, n) {
      pJ(t(), e, r, n);
    },
    onExit(r, n) {
      mJ(t(), e, r, n);
    }
  });
}, L0 = (e, t) => (r, n) => {
  r.animate(e, t).finished.then(n);
};
var vJ = /* @__PURE__ */ k('<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">'), yJ = /* @__PURE__ */ k('<div class="relative z-100">'), bJ = /* @__PURE__ */ k('<div class="absolute right-0 top-0 pr-4 pt-4 sm:pr-6 sm:pt-6 sm:block"><button type=button aria-label=Dismiss class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">'), wJ = /* @__PURE__ */ k('<div class="fixed inset-0 z-20 overflow-y-auto"><div><div>');
const F0 = 100;
function zs(e) {
  const t = it({
    size: "md",
    open: !1,
    position: "center"
  }, e), r = K(() => Yt("relative transform rounded-lg bg-white p-4 text-left shadow-xl transition-all sm:my-8 w-full sm:p-6", {
    "sm:max-w-lg": t.size === "lg",
    "sm:max-w-sm": t.size === "md"
  }));
  return fe(() => {
    const n = window?.zE;
    n && (t.open ? n("messenger", "hide") : n("messenger", "show"));
  }), (() => {
    var n = yJ();
    return E(n, g(H9, {
      get onEnter() {
        return L0([{
          opacity: 0
        }, {
          opacity: 1
        }], {
          duration: F0,
          easing: "ease-in"
        });
      },
      get onExit() {
        return L0([{
          opacity: 1
        }, {
          opacity: 0
        }], {
          duration: F0,
          easing: "ease-out"
        });
      },
      get children() {
        return g(H, {
          get when() {
            return t.open;
          },
          get children() {
            return vJ();
          }
        });
      }
    }), null), E(n, g(H9, {
      get onEnter() {
        return L0([{
          opacity: 0,
          transform: "scale(0.95)"
        }, {
          opacity: 1,
          transform: "scale(1)"
        }], {
          duration: F0,
          easing: "ease-in"
        });
      },
      get onExit() {
        return L0([{
          opacity: 1,
          transform: "scale(1)"
        }, {
          opacity: 0,
          transform: "scale(0.95)"
        }], {
          duration: F0,
          easing: "ease-out"
        });
      },
      get children() {
        return Ut(() => !!t.open)() && (() => {
          var i = wJ(), a = i.firstChild, o = a.firstChild;
          return E(o, g(H, {
            get when() {
              return t?.onClose;
            },
            get children() {
              var s = bJ(), l = s.firstChild;
              return K1(l, "click", t.onClose, !0), E(l, g(mt, {
                name: "xMark",
                class: "h-6 w-6",
                "aria-hidden": "true"
              })), s;
            }
          }), null), E(o, () => t.children, null), se((s) => {
            var l = Yt("flex min-h-full justify-center p-4 text-center sm:p-0", {
              "items-end": t.position === "bottom",
              "items-center": t.position === "center"
            }), d = r();
            return l !== s.e && ft(a, s.e = l), d !== s.t && ft(o, s.t = d), s;
          }, {
            e: void 0,
            t: void 0
          }), i;
        })();
      }
    }), null), n;
  })();
}
an(["click"]);
const W9 = ["mcg", "mg", "g"], Q9 = ["mL", "L"], K9 = ["mcg/kg", "mg/kg", "g/kg"], pm = (e) => 0.453592 * e, mm = (e) => 2.20462 * e, Ak = (e) => e / 16, Tk = (e) => e / 1e3, G9 = (e) => pm(Ak(e)), Z9 = (e) => mm(Tk(e)), Y9 = (e) => 1e3 * e, J9 = (e) => 16 * e, $J = {
  lb: {
    lb: (e) => e,
    kg: pm,
    oz: (e) => 16 * e,
    g: (e) => Y9(pm(e))
  },
  kg: {
    lb: mm,
    kg: (e) => e,
    oz: (e) => J9(mm(e)),
    g: (e) => 1e3 * e
  },
  oz: {
    lb: Ak,
    kg: G9,
    oz: (e) => e,
    g: (e) => Y9(G9(e))
  },
  g: {
    lb: Z9,
    kg: Tk,
    oz: (e) => J9(Z9(e)),
    g: (e) => e
  }
}, kJ = (e, t) => $J[t.unit][e](t.value), _J = {
  g: {
    g: (e) => e,
    mcg: (e) => e * 1e3 * 1e3,
    mg: (e) => e * 1e3
  },
  mg: {
    g: (e) => e / 1e3,
    mg: (e) => e,
    mcg: (e) => e * 1e3
  },
  mcg: {
    g: (e) => e / (1e3 * 1e3),
    mg: (e) => e / 1e3,
    mcg: (e) => e
  }
}, xJ = (e) => e.split("/")[0], SJ = (e, t) => _J[t.unit][xJ(e)](t.value), CJ = (e) => {
  switch (e) {
    case "g/kg":
    case "mg/kg":
    case "mcg/kg":
      return "kg";
  }
}, EJ = (e, t) => e.value * kJ(CJ(e.unit), t), AJ = (e, t, r) => {
  const n = r.unit === "L" ? r.value * 1e3 : r.value;
  return e.value * n / SJ(e.unit, t);
};
var TJ = /* @__PURE__ */ k("<option>");
function ec(e) {
  return g(Gu, {
    get value() {
      return e.selected;
    },
    onChange: (t) => e.setSelected(t.currentTarget.value),
    get children() {
      return g(yt, {
        get each() {
          return e.options;
        },
        children: (t) => (() => {
          var r = TJ();
          return r.value = t, E(r, t), se(() => r.selected = e.selected === t), r;
        })()
      });
    }
  });
}
var OJ = /* @__PURE__ */ k('<div class="flex items-center"><h2>Calculate Dose Quantity'), IJ = /* @__PURE__ */ k("<p>Enter desired dosage and patient weight to calculate total and dose quantity."), PJ = /* @__PURE__ */ k('<div class=my-8><div class="flex items-center"><h3>Selected Medication</h3></div><p>'), NJ = /* @__PURE__ */ k('<div class="grid grid-cols-1 sm:grid-cols-2 gap-4"><div class="grid grid-cols-2 gap-4 sm:gap-2"></div><div class="flex gap-4 items-center"><div>per</div><div class=grow>'), DJ = /* @__PURE__ */ k('<div class="grid grid-cols-1 sm:grid-cols-2 gap-4"><div class="grid grid-cols-2 gap-4 sm:gap-2">'), X9 = /* @__PURE__ */ k('<div class="flex gap-4 sm:gap-2">'), MJ = /* @__PURE__ */ k('<section class=mt-8><div class="flex items-center"><h3>Dosage Inputs</h3></div><div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">'), RJ = /* @__PURE__ */ k('<section class=mt-8><div class="flex items-center"><h3>Frequency</h3></div><div class="grid grid-cols-2 gap-4">'), LJ = /* @__PURE__ */ k('<section class=mt-8><div class="flex items-center"><h3>Dosage</h3></div><div class="grid grid-cols-2 gap-4"></div><hr class="h-px mb-4 bg-gray-200 border-0 dark:bg-gray-700 w-full"><div class="grid grid-cols-2 gap-4">'), FJ = /* @__PURE__ */ k('<div class="mt-8 flex gap-4 justify-end">');
const Ys = (e) => parseFloat(e.toFixed(1)), e6 = ["day", "dose"], t6 = ["lb", "kg"], jJ = (e) => {
  switch (e?.toLowerCase()) {
    case "kg":
    case "kgs":
      return "kg";
    case "lb":
    case "lbs":
      return "lb";
    default:
      return;
  }
}, j0 = (e) => isNaN(e) || !isFinite(e) ? 0 : e;
function zJ(e) {
  const [t, r] = V(0), [n, i] = V(K9[1]), [a, o] = V(e6[0]), [s, l] = V(0), [d, c] = V(t6[0]), [u, h] = V(0), [f, p] = V(W9[1]), [m, y] = V(0), [v, b] = V(Q9[0]), [$, _] = V(1), [x, S] = V(1);
  lr(() => {
    const F = jJ(e.weightUnit);
    F ? (e.weight && l(e.weight), e.weightUnit && c(F)) : (l(0), c("lb"));
  });
  const A = K(() => d() ? EJ({
    unit: n(),
    value: t()
  }, {
    unit: d(),
    value: s()
  }) : 0), N = K(() => AJ({
    unit: n(),
    value: A()
  }, {
    unit: f(),
    value: u()
  }, {
    unit: v(),
    value: m()
  })), P = K(() => j0(a() === "day" ? A() / x() : A())), D = K(() => j0(P() * $() * x())), T = K(() => n().split("/")[0]), I = K(() => j0(a() === "day" ? N() / x() : N())), j = K(() => j0(I() * $() * x()));
  return g(zs, {
    get open() {
      return e.open;
    },
    get onClose() {
      return e.onClose;
    },
    size: "lg",
    get children() {
      return [(() => {
        var F = OJ(), Z = F.firstChild;
        return E(F, g(mt, {
          name: "calculator",
          class: "mr-2"
        }), Z), F;
      })(), IJ(), (() => {
        var F = PJ(), Z = F.firstChild, te = Z.firstChild, Y = Z.nextSibling;
        return E(Z, g(mt, {
          name: "pencilSquare",
          class: "mr-2"
        }), te), E(Y, () => e?.medicationName || "None Selected"), se(() => ft(Y, e?.medicationName ? "" : "@apply text-gray-400")), F;
      })(), (() => {
        var F = MJ(), Z = F.firstChild, te = Z.firstChild, Y = Z.nextSibling;
        return E(Z, g(mt, {
          name: "beaker",
          class: "mr-2"
        }), te), E(F, g(at, {
          label: "Dose",
          get children() {
            var Q = NJ(), R = Q.firstChild, re = R.nextSibling, he = re.firstChild, ge = he.nextSibling;
            return E(R, g(Dt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return t();
              },
              onInput: (ce) => r(ce.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (ce) => r(Math.max(ce.currentTarget?.valueAsNumber || 0, 0))
            }), null), E(R, g(ec, {
              get selected() {
                return n();
              },
              setSelected: i,
              options: K9
            }), null), E(ge, g(ec, {
              get selected() {
                return a();
              },
              setSelected: o,
              options: e6
            })), Q;
          }
        }), Y), E(F, g(at, {
          label: "Patient Weight",
          get children() {
            var Q = DJ(), R = Q.firstChild;
            return E(R, g(Dt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return s();
              },
              onInput: (re) => l(re.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (re) => l(Math.max(re.currentTarget?.valueAsNumber || 0, 0))
            }), null), E(R, g(ec, {
              setSelected: c,
              options: t6,
              get selected() {
                return d();
              }
            }), null), Q;
          }
        }), Y), E(Y, g(at, {
          label: "Liquid Concentration",
          get children() {
            var Q = X9();
            return E(Q, g(Dt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return u();
              },
              onInput: (R) => h(R.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (R) => h(Math.max(R.currentTarget?.valueAsNumber || 0, 0))
            }), null), E(Q, g(ec, {
              get selected() {
                return f();
              },
              setSelected: p,
              options: W9
            }), null), Q;
          }
        }), null), E(Y, g(at, {
          label: "Per Volume",
          get children() {
            var Q = X9();
            return E(Q, g(Dt, {
              type: "number",
              inputmode: "decimal",
              min: "0",
              get value() {
                return m();
              },
              onInput: (R) => y(R.currentTarget?.valueAsNumber ?? 0),
              onFocusOut: (R) => y(Math.max(R.currentTarget?.valueAsNumber || 0, 0))
            }), null), E(Q, g(ec, {
              get selected() {
                return v();
              },
              setSelected: b,
              options: Q9
            }), null), Q;
          }
        }), null), F;
      })(), (() => {
        var F = RJ(), Z = F.firstChild, te = Z.firstChild, Y = Z.nextSibling;
        return E(Z, g(mt, {
          name: "clock",
          class: "mr-2"
        }), te), E(Y, g(at, {
          label: "Duration in Days",
          get children() {
            return g(Dt, {
              type: "number",
              inputmode: "decimal",
              min: "1",
              get value() {
                return $();
              },
              onInput: (Q) => _(Q.currentTarget?.valueAsNumber),
              onFocusOut: (Q) => _(Math.max(Q.currentTarget?.valueAsNumber || 1, 1))
            });
          }
        }), null), E(Y, g(at, {
          label: "Doses per Day",
          get children() {
            return g(Dt, {
              type: "number",
              inputmode: "decimal",
              min: "1",
              get value() {
                return x();
              },
              onInput: (Q) => S(Q.currentTarget?.valueAsNumber),
              onFocusOut: (Q) => S(Math.max(Q.currentTarget?.valueAsNumber || 1, 1))
            });
          }
        }), null), F;
      })(), (() => {
        var F = LJ(), Z = F.firstChild, te = Z.firstChild, Y = Z.nextSibling, Q = Y.nextSibling, R = Q.nextSibling;
        return E(Z, g(mt, {
          name: "chartPie",
          class: "mr-2"
        }), te), E(Y, g(at, {
          label: "Single Dose",
          get children() {
            return g(Dt, {
              type: "text",
              get value() {
                return `${Ys(P())} ${T()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), E(Y, g(at, {
          label: "Total Quantity",
          get children() {
            return g(Dt, {
              type: "text",
              get value() {
                return `${Ys(D())} ${T()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), E(R, g(at, {
          label: "Single Liquid Dose",
          get children() {
            return g(Dt, {
              type: "text",
              get value() {
                return `${Ys(I())} ${v()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), E(R, g(at, {
          label: "Total Liquid Quantity",
          get children() {
            return g(Dt, {
              type: "text",
              get value() {
                return `${Ys(j())} ${v()}`;
              },
              readonly: !0,
              copy: !0
            });
          }
        }), null), F;
      })(), (() => {
        var F = FJ();
        return E(F, g(xt, {
          variant: "secondary",
          get onClick() {
            return e.onClose;
          },
          children: "Cancel"
        }), null), E(F, g(xt, {
          onClick: () => {
            e.setAutocompleteValues({
              days: $(),
              liquidDose: Ys(I()),
              totalLiquid: Ys(j()),
              unit: v()
            }), e.onClose();
          },
          get disabled() {
            return j() === 0;
          },
          children: "Autofill"
        }), null), F;
      })()];
    }
  });
}
var VJ = /* @__PURE__ */ k("<button type=button><span>"), UJ = /* @__PURE__ */ k("<div>");
function Ok(e) {
  const t = it({
    defaultOpen: !1
  }, e), [r, n] = V(t.defaultOpen), i = va(), a = () => t.alwaysOpen || (t.isOpen ?? r());
  return [g(H, {
    get when() {
      return !t.alwaysOpen;
    },
    get children() {
      var o = VJ(), s = o.firstChild;
      return o.$$click = () => {
        const l = !a();
        t.onOpenChange?.(l), n(l);
      }, pt(o, "aria-controls", i), E(s, () => a() ? t.openLabel : t.closedLabel), E(o, g(mt, {
        get name() {
          return a() ? "chevronUp" : "chevronDown";
        },
        size: "sm"
      }), null), se((l) => {
        var d = Yt("flex items-center gap-1 text-left text-xs text-gray-500 hover:text-gray-600", t.buttonClass), c = a() ? "true" : "false";
        return d !== l.e && ft(o, l.e = d), c !== l.t && pt(o, "aria-expanded", l.t = c), l;
      }, {
        e: void 0,
        t: void 0
      }), o;
    }
  }), (() => {
    var o = UJ();
    return pt(o, "id", i), E(o, () => t.children), se(() => ft(o, Yt({
      hidden: !a()
    }, "pt-2", t.class))), o;
  })()];
}
an(["click"]);
function qJ(e, t) {
  const r = (n) => {
    e?.contains(n.target) || t();
  };
  document.body.addEventListener("click", r), sr(() => document.body.removeEventListener("click", r));
}
var BJ = /* @__PURE__ */ k("<div class=relative>"), HJ = /* @__PURE__ */ k("<ul role=listbox tabindex=-1>"), Ik = /* @__PURE__ */ k("<div>"), WJ = /* @__PURE__ */ k('<li class="relative cursor-default select-none py-2 px-3 text-gray-400"role=option aria-disabled=true tabindex=-1><span class="block truncate">'), QJ = /* @__PURE__ */ k('<li role=option tabindex=-1><span class="w-full truncate">'), KJ = /* @__PURE__ */ k('<button class="absolute inset-y-0 right-8 flex items-center px-1"aria-label="Clear selection"type=button><span class="text-sm text-gray-400">Clear'), GJ = /* @__PURE__ */ k('<button class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2"aria-label="Show options">');
const ff = Gr([{
  open: !1,
  selected: {},
  active: "",
  typing: !1
}, {
  setOpen: () => {
  },
  setSelected: () => {
  },
  setActive: () => {
  },
  setTyping: () => {
  }
}]);
function ZJ() {
  return wr(ff);
}
function _r(e) {
  const [t, r] = js({
    open: !1,
    selected: {},
    active: "",
    typing: !1
  }), n = [t, {
    setOpen(i) {
      r("open", i), i && e.onOpen && e.onOpen();
    },
    setSelected(i) {
      (e.value?.id !== i?.id || e.value === void 0) && e.setSelected(i);
    },
    setActive(i) {
      r("active", i);
    },
    setTyping(i) {
      r("typing", i);
    }
  }];
  return fe(() => {
    r("selected", e.value);
  }), g(ff.Provider, {
    value: n,
    get children() {
      var i = BJ();
      return E(i, () => e.children), i;
    }
  });
}
function YJ(e) {
  const [t] = wr(ff);
  let r;
  const n = K(() => {
    if (t.open && r?.getBoundingClientRect) {
      const a = r.getBoundingClientRect(), o = window.innerHeight - a.bottom, s = a.top;
      return o > s ? "bottom" : "top";
    }
    return "bottom";
  }), i = K(() => Yt("absolute z-10 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm", {
    "bottom-full mb-1": n() === "top",
    "top-full mt-1": n() === "bottom"
  }));
  return (() => {
    var a = Ik(), o = r;
    return typeof o == "function" ? Pn(o, a) : r = a, E(a, g(H, {
      get when() {
        return t.open;
      },
      get children() {
        var s = HJ();
        return E(s, () => e.children), se(() => ft(s, i())), s;
      }
    })), a;
  })();
}
function JJ(e) {
  const [t, {
    setSelected: r,
    setActive: n
  }] = wr(ff), i = () => t.active === e.key;
  return e.disabled ? (() => {
    var a = WJ(), o = a.firstChild;
    return E(o, (() => {
      var s = Ut(() => !!e.render);
      return () => s() ? g(j5, {
        get component() {
          return e.render;
        },
        get value() {
          return e.value;
        },
        get active() {
          return i();
        }
      }) : e.children;
    })()), a;
  })() : (() => {
    var a = QJ(), o = a.firstChild;
    return a.addEventListener("mouseleave", () => n("")), a.addEventListener("mouseenter", () => n(e.key)), a.$$click = () => r(e.value), E(o, (() => {
      var s = Ut(() => !!e.render);
      return () => s() ? g(j5, {
        get component() {
          return e.render;
        },
        get value() {
          return e.value;
        },
        get active() {
          return i();
        }
      }) : e.children;
    })()), E(a, g(mt, {
      name: "checkCircle",
      get class() {
        return Yt(
          "ml-2 shrink-0",
          // Use visibility prop so Icon still occupies space when invisible
          t.selected?.id === e.key ? "visible" : "invisible",
          i() ? "text-white" : "text-blue-600"
        );
      }
    }), null), se(() => ft(a, Yt("flex items-center cursor-pointer select-none py-2 px-3 text-gray-900", {
      "bg-blue-600 text-white": i()
    }))), a;
  })();
}
function XJ(e) {
  const [t, {
    setOpen: r,
    setSelected: n
  }] = ZJ(), [i] = qu(), [a, o] = go(e, ["onInput", "onClick", "value"]), [s, l] = V("");
  let d;
  return lr(() => {
    qJ(d, () => {
      r(!1);
    });
  }), fe(() => {
    t.selected && l(e.displayValue(t.selected)), t.selected === void 0 && l("");
  }), fe(() => {
    t.open || l(t.selected ? e.displayValue(t.selected) : "");
  }), [(() => {
    var c = Ik(), u = d;
    return typeof u == "function" ? Pn(u, c) : d = c, E(c, g(Dt, it(o, {
      get "aria-label"() {
        return e.label;
      },
      get value() {
        return s() || "";
      },
      onClick: (h) => {
        r(!t.open), a?.onClick && a.onClick(h);
      },
      onInput: (h) => {
        a?.onInput && a.onInput(h), l(h.currentTarget.value), r(!0);
      },
      type: "text"
    }))), c;
  })(), g(H, {
    get when() {
      return e.showClear && t.selected;
    },
    get children() {
      var c = KJ();
      return c.$$click = () => {
        n(void 0);
      }, c;
    }
  }), g(H, {
    get when() {
      return !i.loading && !e.loading;
    },
    get children() {
      var c = GJ();
      return c.$$click = () => r(!t.open), E(c, g(mt, {
        name: "chevronUpDown",
        class: "text-gray-400"
      })), c;
    }
  })];
}
_r.Input = XJ;
_r.Options = YJ;
_r.Option = JJ;
an(["click"]);
function eX(e) {
  const t = ["00002015204", "00002024304", "00002121404", "00002134004", "00002200204", "00002142304"], r = ["000021423", "000021214", "000022002", "000020152", "000021340", "000020243"], n = ["00002246001", "00002246080", "00002250601", "00002250661", "00002250680", "00002247101", "00002247180", "00002245701", "00002245780", "00002249501", "00002249580", "00002248401", "00002248480"], i = ["000022457", "000022460", "000022484", "000022495", "000022506", "000022471"], a = e.treatment?.codes?.packageNDC?.replaceAll("-", ""), o = e.treatment?.codes?.productNDC?.replaceAll("-", "") || a?.substring(0, a?.length - 2);
  return !a || !o ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_advice"
  } : t.includes(a) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "include",
    constraint_pharmacies: [{
      id: "phr_01J6APWHGNFJCE74SB031VYPHW",
      name: "LillyDirect Self Pay Pharmacy Solutions"
    }]
  } : r.includes(o) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_routing"
  } : n.includes(a) || i.includes(o) ? {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "exclude",
    constraint_pharmacies: [{
      id: "phr_01J6APWHGNFJCE74SB031VYPHW",
      name: "LillyDirect Self Pay Pharmacy Solutions"
    }]
  } : {
    prescriptions: [{
      id: e.id,
      prescribable_name: e.treatment.name
    }],
    routing_constraint_type: "no_advice"
  };
}
function Pk(e) {
  return !!(["include", "no_routing"].includes(e.routing_constraint_type) && e.prescriptions.length === 1);
}
function tX(e) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    Pk(r) && t.set(r.prescriptions[0].id, r);
  return t;
}
const rX = {
  prescriptions: [],
  routing_constraint_type: "exclude",
  constraint_pharmacies: []
};
function r6(e) {
  return e.routing_constraint_type === "no_routing" ? {
    prescriptions: e.prescriptions,
    constraint_pharmacies: [],
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "no_advice" ? {
    prescriptions: e.prescriptions,
    constraint_pharmacies: [],
    routing_constraint_type: "exclude"
  } : e;
}
function nX(e, t) {
  e = r6(e), t = r6(t);
  const r = (d) => {
    const c = d.constraint_pharmacies?.map((u) => u.id);
    return new Set(c);
  }, n = r(e), i = r(t), a = /* @__PURE__ */ new Map();
  for (const d of e?.constraint_pharmacies || [])
    a.set(d.id, d);
  for (const d of t?.constraint_pharmacies || [])
    a.set(d.id, d);
  const o = (d, c) => {
    const u = [];
    for (const h of Array.from(c))
      d.has(h) && u.push(a.get(h));
    return u;
  }, s = (d, c) => {
    const u = Array.from(d).map((h) => a.get(h));
    for (const h of Array.from(c))
      d.has(h) || u.push(a.get(h));
    return u;
  }, l = (d, c) => {
    const u = [];
    for (const h of Array.from(d))
      c.has(h) || u.push(a.get(h));
    return u;
  };
  return e.routing_constraint_type === "include" && t.routing_constraint_type === "include" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: o(n, i),
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "include" && t.routing_constraint_type === "exclude" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: l(n, i),
    routing_constraint_type: "include"
  } : e.routing_constraint_type === "exclude" && t.routing_constraint_type === "include" ? {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: l(i, n),
    routing_constraint_type: "include"
  } : {
    prescriptions: e.prescriptions.concat(t.prescriptions),
    constraint_pharmacies: s(n, i),
    routing_constraint_type: "exclude"
  };
}
function n6(e, t = ["include", "exclude", "no_advice", "no_routing"]) {
  return e.reduce((r, n) => t.includes(n.routing_constraint_type) ? nX(r, n) : r, rX);
}
const iX = (e) => e <= 0 ? "error" : "warning", aX = (e, t) => {
  if (!e.constraint_pharmacies || t === 0)
    return "";
  const r = e.constraint_pharmacies.map((n) => n.name);
  return t === 1 ? r[0] : (r[t - 1] = `and ${r[t - 1]}`, t === 2 ? r.join(" ") : r.join(", "));
}, oX = (e, t, r) => r <= 0 ? `${e.treatment.name} cannot be filled at any pharmacies.` : `${e.treatment.name} can only be filled at ${aX(t, r)}.`, sX = (e) => {
  fe(() => {
    if (!Pk(e.routingConstraint))
      throw new Error("Cannot create a PrescriptionRoutingAlert for the given routing constraint.");
    if (e.routingConstraint.prescriptions[0].id !== e.prescription.id)
      throw new Error(`Prescription ID ${e.prescription.id} and the constraint's prescription ID ${e.routingConstraint.prescriptions[0].id} do not match.`);
  });
  const t = K(() => e.routingConstraint.routing_constraint_type === "no_routing" || !e.routingConstraint.constraint_pharmacies ? 0 : e.routingConstraint.constraint_pharmacies.length);
  return g(No, {
    iconName: "exclamationTriangle",
    get status() {
      return iX(t());
    },
    withBorder: !0,
    get children() {
      return oX(e.prescription, e.routingConstraint, t());
    }
  });
}, lX = () => g(No, {
  iconName: "exclamationTriangle",
  status: "warning",
  withBorder: !0,
  children: "One or more prescriptions in the order cannot be filled at this pharmacy."
}), dX = [
  "treatment",
  "dispenseQuantity",
  "dispenseUnit",
  "daysSupply",
  "refills",
  "instructions",
  "notes",
  "doNotFillBeforeDate",
  "addToTemplates",
  "templateName"
], i6 = [
  "firstName",
  "lastName",
  "dateOfBirth",
  "phone",
  "sex",
  "gender",
  "email",
  "address_street1",
  "address_street2",
  "address_city",
  "address_state",
  "address_zip",
  "preferredPharmacy"
], Nk = (e) => e != null && e !== "" && e !== !1, a6 = (e, t) => Object.fromEntries(
  t.map((r) => [r, { completed: Nk(e[r]?.value) }])
), o6 = (e, t) => {
  const r = {
    treatment: e.treatment,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply,
    refills: e.fillsAllowed != null ? Number(e.fillsAllowed) - 1 : void 0,
    instructions: e.instructions,
    notes: e.notes,
    doNotFillBeforeDate: e.doNotFillBeforeDate,
    addToTemplates: t?.addToTemplates,
    templateName: t?.templateName
  };
  return Object.fromEntries(
    dX.map((n) => [n, { completed: Nk(r[n]) }])
  );
}, Fc = (e, t, r) => {
  const n = new CustomEvent("photon-analytics-track-event", {
    composed: !0,
    bubbles: !0,
    detail: { ...t, category: e, timestamp: (/* @__PURE__ */ new Date()).toISOString() }
  });
  r?.dispatchEvent(n);
};
var cX = /* @__PURE__ */ k("<div>");
const Dk = Gr(), uX = (e) => {
  let t;
  const r = {
    dispatchFormValidate: (n, i) => {
      const a = new CustomEvent("photon-form-validate", {
        composed: !0,
        bubbles: !0,
        detail: {
          canSubmit: n,
          form: i
        }
      });
      t.dispatchEvent(a);
    },
    dispatchDraftPrescriptionCreated: (n) => {
      const i = new CustomEvent("photon-draft-prescription-created", {
        composed: !0,
        bubbles: !0,
        detail: {
          draft: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchDraftPrescriptionDeleted: (n) => {
      const i = new CustomEvent("photon-draft-prescription-deleted", {
        composed: !0,
        bubbles: !0,
        detail: {
          prescription: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchPrescriptionsCreated: (n) => {
      const i = new CustomEvent("photon-prescriptions-created", {
        composed: !0,
        bubbles: !0,
        detail: {
          prescriptions: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchPrescriptionsError: (n) => {
      const i = new CustomEvent("photon-prescriptions-error", {
        composed: !0,
        bubbles: !0,
        detail: {
          errors: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchOrderCreated: (n) => {
      const i = new CustomEvent("photon-order-created", {
        composed: !0,
        bubbles: !0,
        detail: {
          order: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchOrderCombined: (n) => {
      const i = new CustomEvent("photon-order-combined", {
        composed: !0,
        bubbles: !0,
        detail: {
          order: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchOrderError: (n) => {
      const i = new CustomEvent("photon-order-error", {
        composed: !0,
        bubbles: !0,
        detail: {
          errors: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchTicketCreatedDuplicate: () => {
      const n = new CustomEvent("photon-ticket-created-duplicate", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t.dispatchEvent(n);
    },
    dispatchClinicalAlertAcknowledge: (n) => {
      const i = new CustomEvent("photon-clinical-alert-acknowledge", {
        composed: !0,
        bubbles: !0,
        detail: {
          alerts: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchClinicalAlertCancel: (n) => {
      const i = new CustomEvent("photon-clinical-alert-cancel", {
        composed: !0,
        bubbles: !0,
        detail: {
          alerts: n
        }
      });
      t.dispatchEvent(i);
    },
    dispatchSignatureAttestationAgreed: () => {
      const n = new CustomEvent("photon-signature-attestation-agreed", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t?.dispatchEvent(n);
    },
    dispatchSignatureAttestationCanceled: () => {
      const n = new CustomEvent("photon-signature-attestation-canceled", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t?.dispatchEvent(n);
    },
    dispatchAttestationResolved: () => {
      const n = new CustomEvent("photon-signature-attestation-resolved", {
        composed: !0,
        bubbles: !0,
        detail: {}
      });
      t?.dispatchEvent(n);
    },
    dispatchAnalyticsTrackEvent: (n, i) => Fc(n, i, t)
  };
  return g(Dk.Provider, {
    value: r,
    get children() {
      var n = cX(), i = t;
      return typeof i == "function" ? Pn(i, n) : t = n, E(n, () => e.children), n;
    }
  });
}, Ma = () => {
  const e = wr(Dk);
  if (!e)
    throw new Error("can't find PrescribeEventDispatchContext");
  return e;
};
var K2 = "Invariant Violation", s6 = Object.setPrototypeOf, hX = s6 === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : s6, Mk = (
  /** @class */
  (function(e) {
    Uu(t, e);
    function t(r) {
      r === void 0 && (r = K2);
      var n = e.call(this, typeof r == "number" ? K2 + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = K2, hX(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function ls(e, t) {
  if (!e)
    throw new Mk(t);
}
var Rk = ["debug", "log", "warn", "error", "silent"], fX = Rk.indexOf("log");
function z0(e) {
  return function() {
    if (Rk.indexOf(e) >= fX) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = z0("debug"), e.log = z0("log"), e.warn = z0("warn"), e.error = z0("error");
})(ls || (ls = {}));
var y3 = "3.14.0";
function vi(e) {
  try {
    return e();
  } catch {
  }
}
const ch = vi(function() {
  return globalThis;
}) || vi(function() {
  return window;
}) || vi(function() {
  return self;
}) || vi(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
vi(function() {
  return vi.constructor("return this")();
});
var l6 = /* @__PURE__ */ new Map();
function gm(e) {
  var t = l6.get(e) || 1;
  return l6.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function pX(e, t) {
  var r = gm("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function V0(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = b3(i), t || (t = w3(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var Le = Object.assign(function(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  e || ls(e, b3(t, r) || w3(t, r));
}, {
  debug: V0(ls.debug),
  log: V0(ls.log),
  warn: V0(ls.warn),
  error: V0(ls.error)
});
function na(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new Mk(b3(e, t) || w3(e, t));
}
var d6 = /* @__PURE__ */ Symbol.for("ApolloErrorMessageHandler_" + y3);
function Lk(e) {
  if (typeof e == "string")
    return e;
  try {
    return pX(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function b3(e, t) {
  if (t === void 0 && (t = []), !!e)
    return ch[d6] && ch[d6](e, t.map(Lk));
}
function w3(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: y3,
      message: e,
      args: t.map(Lk)
    })));
}
function Fk(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : vX(r).every(function(n) {
    var i = n.directive, a = n.ifArgument, o = !1;
    return a.value.kind === "Variable" ? (o = t && t[a.value.name.value], Le(o !== void 0, 106, i.name.value)) : o = a.value.value, i.name.value === "skip" ? !o : o;
  });
}
function $u(e, t, r) {
  var n = new Set(e), i = n.size;
  return Ti(t, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!r || !n.size))
        return nf;
    }
  }), r ? !n.size : n.size < i;
}
function mX(e) {
  return e && $u(["client", "export"], e, !0);
}
function gX(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function vX(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (gX(r)) {
      var n = r.arguments, i = r.name.value;
      Le(n && n.length === 1, 107, i);
      var a = n[0];
      Le(a.name && a.name.value === "if", 108, i);
      var o = a.value;
      Le(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 109, i), t.push({ directive: r, ifArgument: a });
    }
  }), t;
}
function yX(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(a) {
    var o = a.name;
    return o.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(a) {
    var o = a.name;
    return o.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === we.VARIABLE ? globalThis.__DEV__ !== !1 && Le.warn(110) : i.value.kind !== we.STRING ? globalThis.__DEV__ !== !1 && Le.warn(111) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Le.warn(112, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const bX = () => /* @__PURE__ */ Object.create(null), { forEach: wX, slice: c6 } = Array.prototype, { hasOwnProperty: $X } = Object.prototype;
class Zu {
  constructor(t = !0, r = bX) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return wX.call(t, (n) => r = r.getChildTrie(n)), $X.call(r, "data") ? r.data : r.data = this.makeData(c6.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const a = r.mapFor(t[n], !1);
      r = a && a.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (r = a.removeArray(c6.call(t, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new Zu(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && kX(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function kX(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var _X = vi(function() {
  return navigator.product;
}) == "ReactNative", $3 = typeof WeakMap == "function" && !(_X && !global.HermesInternal), jk = typeof WeakSet == "function", zk = typeof Symbol == "function" && typeof Symbol.for == "function", pf = zk && Symbol.asyncIterator;
vi(function() {
  return window.document.createElement;
});
vi(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Hi(e) {
  return e !== null && typeof e == "object";
}
function Yu(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function xX(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return Le(n, 115, r), n || null;
    }
    default:
      return null;
  }
}
function SX(e) {
  var t = !0;
  return Ti(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return nf;
    }
  }), t;
}
function CX() {
}
class vm {
  constructor(t = 1 / 0, r = CX) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function ym() {
}
const EX = ym, AX = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, TX = typeof WeakMap < "u" ? WeakMap : Map, OX = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: ym,
    unregister: ym
  };
}, IX = 10024;
class bm {
  constructor(t = 1 / 0, r = EX) {
    this.max = t, this.dispose = r, this.map = new TX(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < IX; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const o = a.key;
        delete a.key, a.keyRef = new AX(o), this.registry.register(o, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new OX(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var G2 = /* @__PURE__ */ new WeakSet();
function Vk(e) {
  e.size <= (e.max || -1) || G2.has(e) || (G2.add(e), setTimeout(function() {
    e.clean(), G2.delete(e);
  }, 100));
}
var Uk = function(e, t) {
  var r = new bm(e, t);
  return r.set = function(n, i) {
    var a = bm.prototype.set.call(this, n, i);
    return Vk(this), a;
  }, r;
}, PX = function(e, t) {
  var r = new vm(e, t);
  return r.set = function(n, i) {
    var a = vm.prototype.set.call(this, n, i);
    return Vk(this), a;
  }, r;
}, NX = /* @__PURE__ */ Symbol.for("apollo.cacheSize"), Ju = ne({}, ch[NX]), es = {};
function qk(e, t) {
  es[e] = t;
}
var DX = globalThis.__DEV__ !== !1 ? RX : void 0;
function MX() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      Ju[r] || n
    ];
  }));
}
function RX() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: MX(),
    sizes: ne({ print: (e = es.print) === null || e === void 0 ? void 0 : e.call(es), parser: (t = es.parser) === null || t === void 0 ? void 0 : t.call(es), canonicalStringify: (r = es.canonicalStringify) === null || r === void 0 ? void 0 : r.call(es), links: $m(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: jX(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function LX(e) {
  return !!e && "dirtyKey" in e;
}
function FX(e) {
  return LX(e) ? e.size : void 0;
}
function Bk(e) {
  return e != null;
}
function jX(e) {
  return wm(e).map(function(t) {
    return { cache: t };
  });
}
function wm(e) {
  return e ? hn(hn([
    FX(e?.performWork)
  ], wm(e?.left), !0), wm(e?.right), !0).filter(Bk) : [];
}
function $m(e) {
  var t;
  return e ? hn(hn([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], $m(e?.left), !0), $m(e?.right), !0).filter(Bk) : [];
}
var k3 = Object.assign(function(e) {
  return JSON.stringify(e, zX);
}, {
  reset: function() {
    xl = new PX(
      Ju.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && qk("canonicalStringify", function() {
  return xl.size;
});
var xl;
k3.reset();
function zX(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(VX))
        return t;
      var i = JSON.stringify(n), a = xl.get(i);
      if (!a) {
        n.sort();
        var o = JSON.stringify(n);
        a = xl.get(o) || n, xl.set(i, a), xl.set(o, a);
      }
      var s = Object.create(r);
      return a.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function VX(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function UX(e) {
  return Hi(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function qX(e) {
  return e.kind === "StringValue";
}
function BX(e) {
  return e.kind === "BooleanValue";
}
function HX(e) {
  return e.kind === "IntValue";
}
function WX(e) {
  return e.kind === "FloatValue";
}
function QX(e) {
  return e.kind === "Variable";
}
function KX(e) {
  return e.kind === "ObjectValue";
}
function GX(e) {
  return e.kind === "ListValue";
}
function ZX(e) {
  return e.kind === "EnumValue";
}
function YX(e) {
  return e.kind === "NullValue";
}
function uh(e, t, r, n) {
  if (HX(r) || WX(r))
    e[t.value] = Number(r.value);
  else if (BX(r) || qX(r))
    e[t.value] = r.value;
  else if (KX(r)) {
    var i = {};
    r.fields.map(function(o) {
      return uh(i, o.name, o.value, n);
    }), e[t.value] = i;
  } else if (QX(r)) {
    var a = (n || {})[r.name.value];
    e[t.value] = a;
  } else if (GX(r))
    e[t.value] = r.values.map(function(o) {
      var s = {};
      return uh(s, t, o, n), s[t.value];
    });
  else if (ZX(r))
    e[t.value] = r.value;
  else if (YX(r))
    e[t.value] = null;
  else
    throw na(124, t.value, r.kind);
}
var JX = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], tc = k3;
Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(tc(i), ")");
    } else
      return r.connection.key;
  var a = e;
  if (t) {
    var o = tc(t);
    a += "(".concat(o, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    JX.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? a += "@".concat(s, "(").concat(tc(r[s]), ")") : a += "@".concat(s));
  }), a;
}, {
  setStringify: function(e) {
    var t = tc;
    return tc = e, t;
  }
});
function XX(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return uh(r, i, a, t);
    }), r;
  }
  return null;
}
function hh(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function fh(e) {
  return e.kind === "Field";
}
function eee(e) {
  return e.kind === "InlineFragment";
}
function Od(e) {
  Le(e && e.kind === "Document", 116);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw na(117, r.kind);
    return r;
  });
  return Le(t.length <= 1, 118, t.length), e;
}
function id(e) {
  return Od(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function _c(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Xu(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function tee(e) {
  var t = id(e);
  return Le(t && t.operation === "query", 119), t;
}
function ree(e) {
  Le(e.kind === "Document", 120), Le(e.definitions.length <= 1, 121);
  var t = e.definitions[0];
  return Le(t.kind === "FragmentDefinition", 122), t;
}
function mf(e) {
  Od(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw na(123);
}
function nee(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && uh(t, n.variable.name, n.defaultValue);
  }), t;
}
let Yr = null;
const u6 = {};
let iee = 1;
const aee = () => class {
  constructor() {
    this.id = [
      "slot",
      iee++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = Yr; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === u6)
          break;
        return e !== Yr && (Yr.slots[this.id] = t), !0;
      }
    return Yr && (Yr.slots[this.id] = u6), !1;
  }
  getValue() {
    if (this.hasValue())
      return Yr.slots[this.id];
  }
  withValue(e, t, r, n) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, a = Yr;
    Yr = { parent: a, slots: i };
    try {
      return t.apply(n, r);
    } finally {
      Yr = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = Yr;
    return function() {
      const r = Yr;
      try {
        return Yr = t, e.apply(this, arguments);
      } finally {
        Yr = r;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, r) {
    if (Yr) {
      const n = Yr;
      try {
        return Yr = null, e.apply(r, t);
      } finally {
        Yr = n;
      }
    } else
      return e.apply(r, t);
  }
};
function h6(e) {
  try {
    return e();
  } catch {
  }
}
const Z2 = "@wry/context:Slot", oee = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  h6(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  h6(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), f6 = oee, Id = f6[Z2] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Z2] || (function(e) {
  try {
    Object.defineProperty(f6, Z2, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(aee()), { bind: k2e, noContext: _2e } = Id, _3 = new Id(), Hk = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function Wk(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const ku = [], see = 100;
function ad(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function Qk(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function Kk(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function Gk(e) {
  return e.slice(0);
}
class gf {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++gf.count;
  }
  peek() {
    if (this.value.length === 1 && !xo(this))
      return p6(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return ad(!this.recomputing, "already recomputing"), p6(this), xo(this) ? lee(this, t) : Kk(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, Zk(this), Wk(this));
  }
  dispose() {
    this.setDirty(), t_(this), x3(this, (t, r) => {
      t.setDirty(), r_(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = ku.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (Hk(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), ku.push(this.deps), this.deps = null);
  }
}
gf.count = 0;
function p6(e) {
  const t = _3.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), xo(e) ? Jk(t, e) : Xk(t, e), t;
}
function lee(e, t) {
  return t_(e), _3.withValue(e, dee, [e, t]), uee(e, t) && cee(e), Kk(e.value);
}
function dee(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = Gk(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !Qk(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function xo(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function cee(e) {
  e.dirty = !1, !xo(e) && Yk(e);
}
function Zk(e) {
  x3(e, Jk);
}
function Yk(e) {
  x3(e, Xk);
}
function x3(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = Hk(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function Jk(e, t) {
  ad(e.childValues.has(t)), ad(xo(t));
  const r = !xo(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = ku.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && Zk(e);
}
function Xk(e, t) {
  ad(e.childValues.has(t)), ad(!xo(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, Gk(t.value)) : Qk(r, t.value) || e.setDirty(), e_(e, t), !xo(e) && Yk(e);
}
function e_(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (ku.length < see && ku.push(r), e.dirtyChildren = null));
}
function t_(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    r_(e, r);
  }), e.forgetDeps(), ad(e.dirtyChildren === null);
}
function r_(e, t) {
  t.parents.delete(e), e.childValues.delete(t), e_(e, t);
}
function uee(e, t) {
  if (typeof e.subscribe == "function")
    try {
      Wk(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
let m6;
function hee(...e) {
  return (m6 || (m6 = new Zu(typeof WeakMap == "function"))).lookupArray(e);
}
const Y2 = /* @__PURE__ */ new Set();
function fee(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = hee, normalizeResult: i, subscribe: a, cache: o = vm } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof o == "function" ? new o(t, (h) => h.dispose()) : o, l = function() {
    const h = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (h === void 0)
      return e.apply(null, arguments);
    let f = s.get(h);
    f || (s.set(h, f = new gf(e)), f.normalizeResult = i, f.subscribe = a, f.forget = () => s.delete(h));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(h, f), Y2.add(s), _3.hasValue() || (Y2.forEach((m) => m.clean()), Y2.clear()), p;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: s
  });
  function d(h) {
    const f = h && s.get(h);
    f && f.setDirty();
  }
  l.dirtyKey = d, l.dirty = function() {
    d(n.apply(null, arguments));
  };
  function c(h) {
    const f = h && s.get(h);
    if (f)
      return f.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(n.apply(null, arguments));
  };
  function u(h) {
    return h ? s.delete(h) : !1;
  }
  return l.forgetKey = u, l.forget = function() {
    return u(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(l);
}
function pee(e) {
  return e;
}
var mee = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = jk ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(pee, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var a = t(i) ? r : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new Zu($3);
        this.performWork = fee(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return Le(Array.isArray(i), 105), r.lookupArray(i);
          },
          max: Ju["documentTransform.cache"],
          cache: bm
        });
      }
    }, e.prototype.performWork = function(t) {
      return Od(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), jc, Sl = Object.assign(function(e) {
  var t = jc.get(e);
  return t || (t = XD(e), jc.set(e, t)), t;
}, {
  reset: function() {
    jc = new Uk(
      Ju.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Sl.reset();
globalThis.__DEV__ !== !1 && qk("print", function() {
  return jc ? jc.size : 0;
});
var gee = Array.isArray;
function So(e) {
  return Array.isArray(e) && e.length > 0;
}
var g6 = {
  kind: we.FIELD,
  name: {
    kind: we.NAME,
    value: "__typename"
  }
};
function n_(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === we.FRAGMENT_SPREAD && n_(t[r.name.value], t);
  });
}
function vee(e) {
  return n_(id(e) || ree(e), Yu(Xu(e))) ? null : e;
}
function yee(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(a, o) {
      o(n) && (i = a);
    }), i;
  };
}
function v6(e) {
  var t = /* @__PURE__ */ new Map();
  return function(r) {
    r === void 0 && (r = e);
    var n = t.get(r);
    return n || t.set(r, n = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), n;
  };
}
function i_(e, t) {
  Od(t);
  for (var r = v6(""), n = v6(""), i = function(v) {
    for (var b = 0, $ = void 0; b < v.length && ($ = v[b]); ++b)
      if (!gee($)) {
        if ($.kind === we.OPERATION_DEFINITION)
          return r($.name && $.name.value);
        if ($.kind === we.FRAGMENT_DEFINITION)
          return n($.name.value);
      }
    return globalThis.__DEV__ !== !1 && Le.error(125), null;
  }, a = 0, o = t.definitions.length - 1; o >= 0; --o)
    t.definitions[o].kind === we.OPERATION_DEFINITION && ++a;
  var s = yee(e), l = function(v) {
    return So(v) && v.map(s).some(function(b) {
      return b && b.remove;
    });
  }, d = /* @__PURE__ */ new Map(), c = !1, u = {
    enter: function(v) {
      if (l(v.directives))
        return c = !0, null;
    }
  }, h = Ti(t, {
    // These two AST node types share the same implementation, defined above.
    Field: u,
    InlineFragment: u,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(v, b, $, _, x) {
        var S = i(x);
        S && S.variables.add(v.name.value);
      }
    },
    FragmentSpread: {
      enter: function(v, b, $, _, x) {
        if (l(v.directives))
          return c = !0, null;
        var S = i(x);
        S && S.fragmentSpreads.add(v.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(v, b, $, _) {
        d.set(JSON.stringify(_), v);
      },
      leave: function(v, b, $, _) {
        var x = d.get(JSON.stringify(_));
        if (v === x)
          return v;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && v.selectionSet.selections.every(function(S) {
            return S.kind === we.FIELD && S.name.value === "__typename";
          })
        )
          return n(v.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(v) {
        if (s(v))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var f = function(v) {
    return v.transitiveVars || (v.transitiveVars = new Set(v.variables), v.removed || v.fragmentSpreads.forEach(function(b) {
      f(n(b)).transitiveVars.forEach(function($) {
        v.transitiveVars.add($);
      });
    })), v;
  }, p = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(v) {
    v.kind === we.OPERATION_DEFINITION ? f(r(v.name && v.name.value)).fragmentSpreads.forEach(function(b) {
      p.add(b);
    }) : v.kind === we.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(v.name.value).removed && p.add(v.name.value);
  }), p.forEach(function(v) {
    f(n(v)).fragmentSpreads.forEach(function(b) {
      p.add(b);
    });
  });
  var m = function(v) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(v) || n(v).removed);
  }, y = {
    enter: function(v) {
      if (m(v.name.value))
        return null;
    }
  };
  return vee(Ti(h, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: y,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: y,
    OperationDefinition: {
      leave: function(v) {
        if (v.variableDefinitions) {
          var b = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(v.name && v.name.value)
          ).transitiveVars;
          if (b.size < v.variableDefinitions.length)
            return ne(ne({}, v), { variableDefinitions: v.variableDefinitions.filter(function($) {
              return b.has($.variable.name.value);
            }) });
        }
      }
    }
  }));
}
Object.assign(function(e) {
  return Ti(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === we.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var a = i.some(function(s) {
              return fh(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var o = n;
              if (!(fh(o) && o.directives && o.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return ne(ne({}, t), { selections: hn(hn([], i, !0), [g6], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === g6;
  }
});
function bee(e) {
  var t = mf(e), r = t.operation;
  if (r === "query")
    return e;
  var n = Ti(e, {
    OperationDefinition: {
      enter: function(i) {
        return ne(ne({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function a_(e) {
  Od(e);
  var t = i_([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function wee(e) {
  return Od(e), Ti(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return ne(ne({}, t), { directives: hn(hn([], t.directives || [], !0), [
          {
            kind: we.DIRECTIVE,
            name: { kind: we.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var $ee = Object.prototype.hasOwnProperty;
function y6() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return o_(e);
}
function o_(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new S3(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var kee = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, S3 = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = kee), this.reconciler = t, this.isObject = Hi, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return Hi(r) && Hi(t) ? (Object.keys(r).forEach(function(o) {
        if ($ee.call(t, o)) {
          var s = t[o];
          if (r[o] !== s) {
            var l = n.reconciler.apply(n, hn([
              t,
              r,
              o
            ], i, !1));
            l !== s && (t = n.shallowCopyForMerge(t), t[o] = l);
          }
        } else
          t = n.shallowCopyForMerge(t), t[o] = r[o];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Hi(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = ne({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function _ee(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = xee(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xee(e, t) {
  if (e) {
    if (typeof e == "string") return b6(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return b6(e, t);
  }
}
function b6(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function w6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function C3(e, t, r) {
  return t && w6(e.prototype, t), r && w6(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var E3 = function() {
  return typeof Symbol == "function";
}, A3 = function(e) {
  return E3() && !!Symbol[e];
}, T3 = function(e) {
  return A3(e) ? Symbol[e] : "@@" + e;
};
E3() && !A3("observable") && (Symbol.observable = /* @__PURE__ */ Symbol("observable"));
var See = T3("iterator"), km = T3("observable"), s_ = T3("species");
function ph(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function rc(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[s_], t === null && (t = void 0)), t !== void 0 ? t : tr;
}
function Cee(e) {
  return e instanceof tr;
}
function od(e) {
  od.log ? od.log(e) : setTimeout(function() {
    throw e;
  });
}
function v1(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      od(t);
    }
  });
}
function l_(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = ph(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      od(n);
    }
}
function _m(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function Eee(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (d_(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function d_(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = ph(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (_m(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        _m(e), i && i.call(n);
        break;
    }
  } catch (a) {
    od(a);
  }
  e._state === "closed" ? l_(e) : e._state === "running" && (e._state = "ready");
}
function J2(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], v1(function() {
        return Eee(e);
      });
      return;
    }
    d_(e, t, r);
  }
}
var Aee = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new Tee(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (_m(this), l_(this));
  }, C3(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), Tee = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(r) {
    J2(this._subscription, "next", r);
  }, t.error = function(r) {
    J2(this._subscription, "error", r);
  }, t.complete = function() {
    J2(this._subscription, "complete");
  }, C3(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), tr = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(r) {
    return (typeof r != "object" || r === null) && (r = {
      next: r,
      error: arguments[1],
      complete: arguments[2]
    }), new Aee(r, this._subscriber);
  }, t.forEach = function(r) {
    var n = this;
    return new Promise(function(i, a) {
      if (typeof r != "function") {
        a(new TypeError(r + " is not a function"));
        return;
      }
      function o() {
        s.unsubscribe(), i();
      }
      var s = n.subscribe({
        next: function(l) {
          try {
            r(l, o);
          } catch (d) {
            a(d), s.unsubscribe();
          }
        },
        error: a,
        complete: i
      });
    });
  }, t.map = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = rc(this);
    return new i(function(a) {
      return n.subscribe({
        next: function(o) {
          try {
            o = r(o);
          } catch (s) {
            return a.error(s);
          }
          a.next(o);
        },
        error: function(o) {
          a.error(o);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = rc(this);
    return new i(function(a) {
      return n.subscribe({
        next: function(o) {
          try {
            if (!r(o)) return;
          } catch (s) {
            return a.error(s);
          }
          a.next(o);
        },
        error: function(o) {
          a.error(o);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = rc(this), a = arguments.length > 1, o = !1, s = arguments[1], l = s;
    return new i(function(d) {
      return n.subscribe({
        next: function(c) {
          var u = !o;
          if (o = !0, !u || a)
            try {
              l = r(l, c);
            } catch (h) {
              return d.error(h);
            }
          else
            l = c;
        },
        error: function(c) {
          d.error(c);
        },
        complete: function() {
          if (!o && !a) return d.error(new TypeError("Cannot reduce an empty sequence"));
          d.next(l), d.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var r = this, n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = rc(this);
    return new o(function(s) {
      var l, d = 0;
      function c(u) {
        l = u.subscribe({
          next: function(h) {
            s.next(h);
          },
          error: function(h) {
            s.error(h);
          },
          complete: function() {
            d === i.length ? (l = void 0, s.complete()) : c(o.from(i[d++]));
          }
        });
      }
      return c(r), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(r) {
    var n = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var i = rc(this);
    return new i(function(a) {
      var o = [], s = n.subscribe({
        next: function(d) {
          if (r)
            try {
              d = r(d);
            } catch (u) {
              return a.error(u);
            }
          var c = i.from(d).subscribe({
            next: function(u) {
              a.next(u);
            },
            error: function(u) {
              a.error(u);
            },
            complete: function() {
              var u = o.indexOf(c);
              u >= 0 && o.splice(u, 1), l();
            }
          });
          o.push(c);
        },
        error: function(d) {
          a.error(d);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && o.length === 0 && a.complete();
      }
      return function() {
        o.forEach(function(d) {
          return d.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[km] = function() {
    return this;
  }, e.from = function(r) {
    var n = typeof this == "function" ? this : e;
    if (r == null) throw new TypeError(r + " is not an object");
    var i = ph(r, km);
    if (i) {
      var a = i.call(r);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return Cee(a) && a.constructor === n ? a : new n(function(o) {
        return a.subscribe(o);
      });
    }
    if (A3("iterator") && (i = ph(r, See), i))
      return new n(function(o) {
        v1(function() {
          if (!o.closed) {
            for (var s = _ee(i.call(r)), l; !(l = s()).done; ) {
              var d = l.value;
              if (o.next(d), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(r))
      return new n(function(o) {
        v1(function() {
          if (!o.closed) {
            for (var s = 0; s < r.length; ++s)
              if (o.next(r[s]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(r + " is not observable");
  }, e.of = function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    var a = typeof this == "function" ? this : e;
    return new a(function(o) {
      v1(function() {
        if (!o.closed) {
          for (var s = 0; s < n.length; ++s)
            if (o.next(n[s]), o.closed) return;
          o.complete();
        }
      });
    });
  }, C3(e, null, [{
    key: s_,
    get: function() {
      return this;
    }
  }]), e;
})();
E3() && Object.defineProperty(tr, /* @__PURE__ */ Symbol("extensions"), {
  value: {
    symbol: km,
    hostReportError: od
  },
  configurable: !0
});
function Oee(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var cl;
typeof self < "u" ? cl = self : typeof window < "u" ? cl = window : typeof global < "u" ? cl = global : typeof module < "u" ? cl = module : cl = Function("return this")();
Oee(cl);
var $6 = tr.prototype, k6 = "@@observable";
$6[k6] || ($6[k6] = function() {
  return this;
});
function Iee(e) {
  return e.catch(function() {
  }), e;
}
var Pee = Object.prototype.toString;
function Nee(e) {
  return xm(e);
}
function xm(e, t) {
  switch (Pee.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, a) {
        r[a] = xm(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = xm(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function Dee(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    Hi(r) && Mee(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      Hi(r[n]) && t.add(r[n]);
    });
  }), e;
}
function Mee(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function Ree(e) {
  return globalThis.__DEV__ !== !1 && Dee(e), e;
}
function zc(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function X2(e, t, r) {
  return new tr(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(d) {
          return d(l());
        });
      }
    };
    function a(l, d) {
      return function(c) {
        if (l) {
          var u = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(u, u).then(function(h) {
            return n.next(h);
          }, function(h) {
            return n.error(h);
          });
        } else
          n[d](c);
      };
    }
    var o = {
      next: a(t, "next"),
      error: a(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(o);
    return function() {
      return s.unsubscribe();
    };
  });
}
function c_(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: tr });
  }
  return zk && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function _6(e) {
  return e && typeof e.then == "function";
}
var ul = (
  /** @class */
  (function(e) {
    Uu(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), zc(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), zc(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, o = i.sources, s = o === void 0 ? [] : o;
          if (a !== null) {
            var l = s.shift();
            l ? _6(l) ? l.then(function(d) {
              return n.sub = d.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), zc(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new tr(r)]), _6(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, r(i, a));
      });
    }, t;
  })(tr)
);
c_(ul);
function jl(e) {
  return "incremental" in e;
}
function Lee(e) {
  return "hasNext" in e && "data" in e;
}
function Fee(e) {
  return jl(e) || Lee(e);
}
function jee(e) {
  return Hi(e) && "payload" in e;
}
function u_(e, t) {
  var r = e, n = new S3();
  return jl(t) && So(t.incremental) && t.incremental.forEach(function(i) {
    for (var a = i.data, o = i.path, s = o.length - 1; s >= 0; --s) {
      var l = o[s], d = !isNaN(+l), c = d ? [] : {};
      c[l] = a, a = c;
    }
    r = n.merge(r, a);
  }), r;
}
function y1(e) {
  var t = Sm(e);
  return So(t);
}
function Sm(e) {
  var t = So(e.errors) ? e.errors.slice(0) : [];
  return jl(e) && So(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function mh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (r[i] = a);
    });
  }), r;
}
function b1(e, t) {
  return mh(e, t, t.variables && {
    variables: mh(ne(ne({}, e && e.variables), t.variables))
  });
}
function ep(e) {
  return new tr(function(t) {
    t.error(e);
  });
}
var h_ = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function zee(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw na(58, i);
  }
  return e;
}
function Vee(e, t) {
  var r = ne({}, e), n = function(a) {
    typeof a == "function" ? r = ne(ne({}, r), a(r)) : r = ne(ne({}, r), a);
  }, i = function() {
    return ne({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function Uee(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? _c(t.query) || void 0 : ""), t;
}
function qee(e, t) {
  var r = ne({}, e), n = new Set(Object.keys(e));
  return Ti(t, {
    Variable: function(i, a, o) {
      o && o.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
var Bee = /* @__PURE__ */ Symbol.for("apollo.deprecations"), Hee = ch, Cm = new Id();
function Wee(e) {
  return Hee[Bee] || (Cm.getValue() || []).includes(e);
}
function yi(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return Cm.withValue.apply(Cm, hn([Array.isArray(e) ? e : [e]], t, !1));
}
function Xn(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), ds(t, function() {
    t in e && globalThis.__DEV__ !== !1 && Le.warn(104, r, t, n);
  });
}
function ds(e, t) {
  Wee(e) || t();
}
function x6(e, t) {
  return t ? t(e) : tr.of();
}
function nc(e) {
  return typeof e == "function" ? new e0(e) : e;
}
function U0(e) {
  return e.request.length <= 1;
}
var e0 = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return tr.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(nc).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = nc(r), a = nc(n || new e(x6)), o;
      return U0(i) && U0(a) ? o = new e(function(s) {
        return t(s) ? i.request(s) || tr.of() : a.request(s) || tr.of();
      }) : o = new e(function(s, l) {
        return t(s) ? i.request(s, l) || tr.of() : a.request(s, l) || tr.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.execute = function(t, r) {
      return t.request(Vee(r.context, Uee(zee(r)))) || tr.of();
    }, e.concat = function(t, r) {
      var n = nc(t);
      if (U0(n))
        return globalThis.__DEV__ !== !1 && Le.warn(47, n), n;
      var i = nc(r), a;
      return U0(i) ? a = new e(function(o) {
        return n.request(o, function(s) {
          return i.request(s) || tr.of();
        }) || tr.of();
      }) : a = new e(function(o, s) {
        return n.request(o, function(l) {
          return i.request(l, s) || tr.of();
        }) || tr.of();
      }), Object.assign(a, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(x6)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw na(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && ds("onError", function() {
        globalThis.__DEV__ !== !1 && Le.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Le.warn(50), this.onError = t, this;
    }, e;
  })()
), Em = e0.execute;
function Qee(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function Kee(e) {
  var t = null, r = null, n = !1, i = [], a = [];
  function o(u) {
    if (!r) {
      if (a.length) {
        var h = a.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: u, done: !1 });
      }
      i.push(u);
    }
  }
  function s(u) {
    r = u;
    var h = a.slice();
    h.forEach(function(f) {
      f[1](u);
    }), !t || t();
  }
  function l() {
    n = !0;
    var u = a.slice();
    u.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", o), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function d() {
    return new Promise(function(u, h) {
      if (r)
        return h(r);
      if (i.length)
        return u({ value: i.shift(), done: !1 });
      if (n)
        return u({ value: void 0, done: !0 });
      a.push([u, h]);
    });
  }
  var c = {
    next: function() {
      return d();
    }
  };
  return pf && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function Gee(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return pf && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function S6(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return pf && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function Zee(e) {
  return !!e.body;
}
function Yee(e) {
  return !!e.getReader;
}
function Jee(e) {
  return !!(pf && e[Symbol.asyncIterator]);
}
function Xee(e) {
  return !!e.stream;
}
function ete(e) {
  return !!e.arrayBuffer;
}
function tte(e) {
  return !!e.pipe;
}
function rte(e) {
  var t = e;
  if (Zee(e) && (t = e.body), Jee(t))
    return Qee(t);
  if (Yee(t))
    return S6(t.getReader());
  if (Xee(t))
    return S6(t.stream().getReader());
  if (ete(t))
    return Gee(t.arrayBuffer());
  if (tte(t))
    return Kee(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var O3 = /* @__PURE__ */ Symbol();
function nte(e) {
  return e.extensions ? Array.isArray(e.extensions[O3]) : !1;
}
function f_(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var ite = function(e) {
  var t = hn(hn(hn([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return Hi(r) && r.message || "Error message not found.";
  }).join(`
`);
}, ts = (
  /** @class */
  (function(e) {
    Uu(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, a = r.clientErrors, o = r.networkError, s = r.errorMessage, l = r.extraInfo, d = e.call(this, s) || this;
      return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = a || [], d.networkError = o || null, d.message = s || ite(d), d.extraInfo = l, d.cause = hn(hn(hn([
        o
      ], n || [], !0), i || [], !0), a || [], !0).find(function(c) {
        return !!c;
      }) || null, d.__proto__ = t.prototype, d;
    }
    return t;
  })(Error)
), C6 = Object.prototype.hasOwnProperty;
function ate(e, t) {
  return Ja(this, void 0, void 0, function() {
    var r, n, i, a, o, s, l, d, c, u, h, f, p, m, y, v, b, $, _, x, S, A, N, P;
    return Xa(this, function(D) {
      switch (D.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (P = e.headers) === null || P === void 0 ? void 0 : P.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", o = `\r
--`.concat(a), s = "", l = rte(e), d = !0, D.label = 1;
        case 1:
          return d ? [4, l.next()] : [3, 3];
        case 2:
          for (c = D.sent(), u = c.value, h = c.done, f = typeof u == "string" ? u : r.decode(u), p = s.length - o.length + 1, d = !h, s += f, m = s.indexOf(o, p); m > -1; ) {
            if (y = void 0, A = [
              s.slice(0, m),
              s.slice(m + o.length)
            ], y = A[0], s = A[1], v = y.indexOf(`\r
\r
`), b = ote(y.slice(0, v)), $ = b["content-type"], $ && $.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (_ = y.slice(v), _) {
              if (x = p_(e, _), Object.keys(x).length > 1 || "data" in x || "incremental" in x || "errors" in x || "payload" in x)
                if (jee(x)) {
                  if (S = {}, "payload" in x) {
                    if (Object.keys(x).length === 1 && x.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    S = ne({}, x.payload);
                  }
                  "errors" in x && (S = ne(ne({}, S), { extensions: ne(ne({}, "extensions" in S ? S.extensions : null), (N = {}, N[O3] = x.errors, N)) })), t(S);
                } else
                  t(x);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(x).length === 1 && "hasNext" in x && !x.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(o);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function ote(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), a = r.slice(n + 1).trim();
      t[i] = a;
    }
  }), t;
}
function p_(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    h_(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function ste(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function lte(e) {
  return function(t) {
    return t.text().then(function(r) {
      return p_(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !C6.call(r, "data") && !C6.call(r, "errors") && h_(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var Am = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = na(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, dte = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, cte = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, ute = {
  method: "POST"
}, hte = {
  http: dte,
  headers: cte,
  options: ute
}, fte = function(e, t) {
  return t(e);
};
function pte(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, a = {};
  r.forEach(function(u) {
    i = ne(ne(ne({}, i), u.options), { headers: ne(ne({}, i.headers), u.headers) }), u.credentials && (i.credentials = u.credentials), a = ne(ne({}, a), u.http);
  }), i.headers && (i.headers = mte(i.headers, a.preserveHeaderCase));
  var o = e.operationName, s = e.extensions, l = e.variables, d = e.query, c = { operationName: o, variables: l };
  return a.includeExtensions && (c.extensions = s), a.includeQuery && (c.query = t(d, Sl)), {
    options: i,
    body: c
  };
}
function mte(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(a) {
      r[a.toLowerCase()] = e[a];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: e[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var gte = function(e) {
  if (!e && typeof fetch > "u")
    throw na(51);
}, vte = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function yte(e, t) {
  var r = [], n = function(u, h) {
    r.push("".concat(u, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = Am(t.variables, "Variables map");
    } catch (u) {
      return { parseError: u };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var a = void 0;
    try {
      a = Am(t.extensions, "Extensions map");
    } catch (u) {
      return { parseError: u };
    }
    n("extensions", a);
  }
  var o = "", s = e, l = e.indexOf("#");
  l !== -1 && (o = e.substr(l), s = e.substr(0, l));
  var d = s.indexOf("?") === -1 ? "?" : "&", c = s + d + r.join("&") + o;
  return { newURI: c };
}
var E6 = vi(function() {
  return fetch;
}), bte = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, a = i === void 0 ? fte : i, o = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, d = e.includeUnusedVariables, c = d === void 0 ? !1 : d, u = Y5(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && gte(n || E6);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: s },
    options: u.fetchOptions,
    credentials: u.credentials,
    headers: u.headers
  };
  return new e0(function(f) {
    var p = vte(f, r), m = f.getContext(), y = {};
    if (m.clientAwareness) {
      var v = m.clientAwareness, b = v.name, $ = v.version;
      b && (y["apollographql-client-name"] = b), $ && (y["apollographql-client-version"] = $);
    }
    var _ = ne(ne({}, y), m.headers), x = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: _
    };
    if ($u(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Le.warn(52);
      var S = a_(f.query);
      if (!S)
        return ep(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = S;
    }
    var A = pte(f, a, hte, h, x), N = A.options, P = A.body;
    P.variables && !c && (P.variables = qee(P.variables, f.query));
    var D;
    !N.signal && typeof AbortController < "u" && (D = new AbortController(), N.signal = D.signal);
    var T = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "mutation";
    }, I = function(R) {
      return R.kind === "OperationDefinition" && R.operation === "subscription";
    }, j = I(mf(f.query)), F = $u(["defer"], f.query);
    if (l && !f.query.definitions.some(T) && (N.method = "GET"), F || j) {
      N.headers = N.headers || {};
      var Z = "multipart/mixed;";
      j && F && globalThis.__DEV__ !== !1 && Le.warn(53), j ? Z += "boundary=graphql;subscriptionSpec=1.0,application/json" : F && (Z += "deferSpec=20220824,application/json"), N.headers.accept = Z;
    }
    if (N.method === "GET") {
      var te = yte(p, P), Y = te.newURI, Q = te.parseError;
      if (Q)
        return ep(Q);
      p = Y;
    } else
      try {
        N.body = Am(P, "Payload");
      } catch (R) {
        return ep(R);
      }
    return new tr(function(R) {
      var re = n || vi(function() {
        return fetch;
      }) || E6, he = R.next.bind(R);
      return re(p, N).then(function(ge) {
        var ce;
        f.setContext({ response: ge });
        var W = (ce = ge.headers) === null || ce === void 0 ? void 0 : ce.get("content-type");
        return W !== null && /^multipart\/mixed/i.test(W) ? ate(ge, he) : lte(f)(ge).then(he);
      }).then(function() {
        D = void 0, R.complete();
      }).catch(function(ge) {
        D = void 0, ste(ge, R);
      }), function() {
        D && D.abort();
      };
    });
  });
}, wte = (
  /** @class */
  (function(e) {
    Uu(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, bte(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(e0)
);
const { toString: A6, hasOwnProperty: $te } = Object.prototype, T6 = Function.prototype.toString, Tm = /* @__PURE__ */ new Map();
function mr(e, t) {
  try {
    return Om(e, t);
  } finally {
    Tm.clear();
  }
}
function Om(e, t) {
  if (e === t)
    return !0;
  const r = A6.call(e), n = A6.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (I6(e, t))
        return !0;
      const i = O6(e), a = O6(t), o = i.length;
      if (o !== a.length)
        return !1;
      for (let s = 0; s < o; ++s)
        if (!$te.call(t, i[s]))
          return !1;
      for (let s = 0; s < o; ++s) {
        const l = i[s];
        if (!Om(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (I6(e, t))
        return !0;
      const i = e.entries(), a = r === "[object Map]";
      for (; ; ) {
        const o = i.next();
        if (o.done)
          break;
        const [s, l] = o.value;
        if (!t.has(s) || a && !Om(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = T6.call(e);
      return i !== T6.call(t) ? !1 : !xte(i, _te);
    }
  }
  return !1;
}
function O6(e) {
  return Object.keys(e).filter(kte, e);
}
function kte(e) {
  return this[e] !== void 0;
}
const _te = "{ [native code] }";
function xte(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function I6(e, t) {
  let r = Tm.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    Tm.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function Ste(e, t, r, n) {
  var i = t.data, a = Y5(t, ["data"]), o = r.data, s = Y5(r, ["data"]);
  return mr(a, s) && w1(mf(e).selectionSet, i, o, {
    fragmentMap: Yu(Xu(e)),
    variables: n
  });
}
function w1(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !Fk(a, n.variables)) || P6(a))
      return !0;
    if (fh(a)) {
      var o = hh(a), s = t && t[o], l = r && r[o], d = a.selectionSet;
      if (!d)
        return mr(s, l);
      var c = Array.isArray(s), u = Array.isArray(l);
      if (c !== u)
        return !1;
      if (c && u) {
        var h = s.length;
        if (l.length !== h)
          return !1;
        for (var f = 0; f < h; ++f)
          if (!w1(d, s[f], l[f], n))
            return !1;
        return !0;
      }
      return w1(d, s, l, n);
    } else {
      var p = xX(a, n.fragmentMap);
      if (p)
        return P6(p) ? !0 : w1(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function P6(e) {
  return !!e.directives && e.directives.some(Cte);
}
function Cte(e) {
  return e.name.value === "nonreactive";
}
var m_ = $3 ? WeakMap : Map, g_ = jk ? WeakSet : Set, v_ = new Id(), N6 = !1;
function y_() {
  N6 || (N6 = !0, globalThis.__DEV__ !== !1 && Le.warn(64));
}
function b_(e, t, r) {
  return v_.withValue(!0, function() {
    var n = xc(e, t, r, !1);
    return Object.isFrozen(e) && Ree(n), n;
  });
}
function Ete(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function xc(e, t, r, n, i) {
  var a, o = r.knownChanged, s = Ete(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, d = Array.from(e.entries()); l < d.length; l++) {
      var c = d[l], u = c[0], h = c[1];
      if (h === null) {
        s[u] = null;
        continue;
      }
      var f = xc(h, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(u, "]") : void 0);
      o.has(f) && o.add(s), s[u] = f;
    }
    return o.has(s) ? s : e;
  }
  for (var p = 0, m = t.selections; p < m.length; p++) {
    var y = m[p], v = void 0;
    if (n && o.add(s), y.kind === we.FIELD) {
      var b = hh(y), $ = y.selectionSet;
      if (v = s[b] || e[b], v === void 0)
        continue;
      if ($ && v !== null) {
        var f = xc(e[b], $, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(b) : void 0);
        o.has(f) && (v = f);
      }
      globalThis.__DEV__ === !1 && (s[b] = v), globalThis.__DEV__ !== !1 && (n && b !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((a = Object.getOwnPropertyDescriptor(s, b)) === null || a === void 0) && a.value) ? Object.defineProperty(s, b, Ate(b, v, i || "", r.operationName, r.operationType)) : (delete s[b], s[b] = v));
    }
    if (y.kind === we.INLINE_FRAGMENT && (!y.typeCondition || r.cache.fragmentMatches(y, e.__typename)) && (v = xc(e, y.selectionSet, r, n, i)), y.kind === we.FRAGMENT_SPREAD) {
      var _ = y.name.value, x = r.fragmentMap[_] || (r.fragmentMap[_] = r.cache.lookupFragment(_));
      Le(x, 59, _);
      var S = yX(y);
      S !== "mask" && (v = xc(e, x.selectionSet, r, S === "migrate", i));
    }
    o.has(v) && o.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && o.add(s), o.has(s) ? s : e;
}
function Ate(e, t, r, n, i) {
  var a = function() {
    return v_.getValue() || (globalThis.__DEV__ !== !1 && Le.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), a = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return a();
    },
    set: function(o) {
      a = function() {
        return o;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function Tte(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && y_(), e;
  var i = t.definitions.filter(function(o) {
    return o.kind === we.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (Le(i.length === 1, 61, i.length), n = i[0].name.value);
  var a = i.find(function(o) {
    return o.name.value === n;
  });
  return Le(!!a, 62, n), e == null || mr(e, {}) ? e : b_(e, a.selectionSet, {
    operationType: "fragment",
    operationName: a.name.value,
    fragmentMap: Yu(Xu(t)),
    cache: r,
    mutableTargets: new m_(),
    knownChanged: new g_()
  });
}
function Ote(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && y_(), e;
  var i = id(t);
  return Le(i, 63), e == null ? e : b_(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: Yu(Xu(t)),
    cache: r,
    mutableTargets: new m_(),
    knownChanged: new g_()
  });
}
var Ite = new Id(), jt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(jt || (jt = {}));
function Cl(e) {
  return e ? e < 7 : !1;
}
var D6 = Object.assign, Pte = Object.hasOwnProperty, $1 = (
  /** @class */
  (function(e) {
    Uu(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, a = r.options, o = this, s = t.inactiveOnCreation.getValue();
      o = e.call(this, function(v) {
        o._getOrCreateQuery();
        try {
          var b = v._subscription._observer;
          b && !b.error && (b.error = Nte);
        } catch {
        }
        var $ = !o.observers.size;
        o.observers.add(v);
        var _ = o.last;
        return _ && _.error ? v.error && v.error(_.error) : _ && _.result && v.next && v.next(o.maskResult(_.result)), $ && o.reobserve().catch(function() {
        }), function() {
          o.observers.delete(v) && !o.observers.size && o.tearDownQuery();
        };
      }) || this, o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.dirty = !1, o._getOrCreateQuery = function() {
        return s && (n.queries.set(o.queryId, i), s = !1), o.queryManager.getOrCreateQuery(o.queryId);
      }, o.queryInfo = i, o.queryManager = n, o.waitForOwnResult = tp(a.fetchPolicy), o.isTornDown = !1, o.subscribeToMore = o.subscribeToMore.bind(o), o.maskResult = o.maskResult.bind(o);
      var l = n.defaultOptions.watchQuery, d = l === void 0 ? {} : l, c = d.fetchPolicy, u = c === void 0 ? "cache-first" : c, h = a.fetchPolicy, f = h === void 0 ? u : h, p = a.initialFetchPolicy, m = p === void 0 ? f === "standby" ? u : f : p;
      o.options = ne(ne({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), o.queryId = i.queryId || n.generateQueryId();
      var y = id(o.query);
      return o.queryName = y && y.name && y.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && ds("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && Le.warn(23);
      }), new Promise(function(n, i) {
        var a = {
          next: function(s) {
            n(s), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              o.unsubscribe();
            }, 0);
          },
          error: i
        }, o = r.subscribe(a);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = yi("getLastResult", function() {
        return n.getLastResult(!0);
      }), a = this.queryInfo.networkStatus || i && i.networkStatus || jt.ready, o = ne(ne({}, i), { loading: Cl(a), networkStatus: a }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(tp(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var d = this.queryInfo.getDiff();
        (d.complete || this.options.returnPartialData) && (o.data = d.result), mr(o.data, {}) && (o.data = void 0), d.complete ? (delete o.partial, d.complete && o.networkStatus === jt.loading && (l === "cache-first" || l === "cache-only") && (o.networkStatus = jt.ready, o.loading = !1)) : o.partial = !0, o.networkStatus === jt.ready && (o.error || o.errors) && (o.networkStatus = jt.error), globalThis.__DEV__ !== !1 && !d.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && w_(d.missing);
      }
      return r && this.updateLastResult(o), o;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, o = a ? i.nonReactiveQuery : this.query, s = a || i.hasNonreactiveDirective ? !Ste(o, this.last.result, r, this.variables) : !mr(this.last.result, r);
      return s || n && !mr(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || mr(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && ds("getLastResult", function() {
        globalThis.__DEV__ !== !1 && Le.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && ds("getLastError", function() {
        globalThis.__DEV__ !== !1 && Le.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && ds("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && Le.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Le.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && Pte.call(r, "variables")) {
        var o = tee(this.query), s = o.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Le.warn(
          28,
          r,
          ((n = o.name) === null || n === void 0 ? void 0 : n.value) || o
        );
      }
      return r && !mr(this.options.variables, r) && (i.variables = this.options.variables = ne(ne({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, jt.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = ne(ne({}, r.query ? r : ne(ne(ne(ne({}, this.options), { query: this.options.query }), r), { variables: ne(ne({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var o = this.queryInfo, s = o.networkStatus;
      o.networkStatus = jt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), d = r?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || Le(d, 29), this.queryManager.fetchQuery(a, i, jt.fetchMore).then(function(u) {
        if (n.queryManager.removeQuery(a), o.networkStatus === jt.fetchMore && (o.networkStatus = s), c)
          n.queryManager.cache.batch({
            update: function(p) {
              var m = r.updateQuery;
              m ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(y) {
                return m(y, {
                  fetchMoreResult: u.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: u.data
              });
            },
            onWatchUpdated: function(p) {
              l.add(p.query);
            }
          });
        else {
          var h = n.getLast("result"), f = d(h.data, {
            fetchMoreResult: u.data,
            variables: i.variables
          });
          n.reportResult(ne(ne({}, h), { networkStatus: s, loading: Cl(s), data: f }), n.variables);
        }
        return n.maskResult(u);
      }).finally(function() {
        c && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var o = r.updateQuery;
          o && n.updateQuery(function(s, l) {
            return o(s, ne({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && Le.error(30, a);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (Xn(r, "canonizeResults", "setOptions"), ds("setOptions", function() {
        globalThis.__DEV__ !== !1 && Le.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = mh(this.options, r || {});
      D6(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return mr(this.variables, r) ? this.observers.size ? yi("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, jt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, o = i.complete, s = r(a, {
        variables: this.variables,
        complete: !!o,
        previousData: a
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, s = o === void 0 ? a : o;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var a = this._getOrCreateQuery();
      return a.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(a, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          Le(a, 32);
          var o = i || (this.pollingInfo = {});
          o.interval = a;
          var s = function() {
            var d, c;
            r.pollingInfo && (!Cl(r.queryInfo.networkStatus) && !(!((c = (d = r.options).skipPollAttempt) === null || c === void 0) && c.call(d)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, jt.poll).then(l, l) : l());
          }, l = function() {
            var d = r.pollingInfo;
            d && (clearTimeout(d.timeout), d.timeout = setTimeout(s, d.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var a = yi("getLastError", function() {
        return i.getLastError();
      });
      return a && this.last && !mr(n, this.last.variables) && (a = void 0), this.last = ne({ result: this.queryManager.assumeImmutableResults ? r : Nee(r), variables: n }, a ? { error: a } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === jt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === jt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === jt.poll
      ), o = this.options.variables, s = this.options.fetchPolicy, l = mh(this.options, r || {}), d = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : D6(this.options, l), c = this.transformDocument(d.query);
      this.lastQuery = c, a || (this.updatePolling(), r && r.variables && !mr(r.variables, o) && // Don't mess with the fetchPolicy if it's currently "standby".
      d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (d.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = jt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = tp(d.fetchPolicy));
      var u = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, h = d.variables && ne({}, d.variables), f = this.fetch(d, n, c), p = f.concast, m = f.fromLink, y = {
        next: function(v) {
          mr(i.variables, h) && (u(), i.reportResult(v, h));
        },
        error: function(v) {
          mr(i.variables, h) && (f_(v) || (v = new ts({ networkError: v })), u(), i.reportError(v, h));
        }
      };
      return !a && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = y), p.addObserver(y), p;
    }, t.prototype.reobserve = function(r, n) {
      return Iee(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var a = this.last;
      yi("resetLastResults", function() {
        return r.resetLastResults();
      });
      var o = this.subscribe.apply(this, n);
      return this.last = a, o;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, a = yi("getLastError", function() {
        return i.getLastError();
      }), o = this.isDifferentFromLastResult(r, n);
      (a || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (a || o) && zc(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, a = ne(ne({}, yi("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: jt.error, loading: !1 });
      this.updateLastResult(a, n), zc(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? ne(ne({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !Cl(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(a, o) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(a, o) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new Id(), t;
  })(tr)
);
c_($1);
function Nte(e) {
  globalThis.__DEV__ !== !1 && Le.error(33, e.message, e.stack);
}
function w_(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Le.debug(34, e);
}
function tp(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var El = new ($3 ? WeakMap : Map)();
function rp(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return El.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (El.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var np = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      El.has(n) || (El.set(n, 0), rp(n, "evict"), rp(n, "modify"), rp(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || jt.loading;
      return this.variables && this.networkStatus !== jt.loading && !mr(this.variables, t.variables) && (r = jt.setVariables), mr(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && mr(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = yi("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && yi("getLastError", function() {
        var a;
        return (a = r.observableQuery) === null || a === void 0 ? void 0 : a.getLastError();
      }) || (this.updateLastDiff(t), mr(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = ne(ne({}, this.getDiffOptions(t)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !mr(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === El.get(this.cache) && mr(r, n.variables) && mr(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var a = this, o, s = new S3(), l = So(t.errors) ? t.errors.slice(0) : [];
      if ((o = this.observableQuery) === null || o === void 0 || o.resetNotifications(), "incremental" in t && So(t.incremental)) {
        var d = u_(this.getDiff().result, t);
        t.data = d;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (Im(t, n.errorPolicy) ? this.cache.performTransaction(function(u) {
        if (a.shouldWrite(t, n.variables))
          u.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: El.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          t.data = a.lastDiff.diff.result;
          return;
        }
        var h = a.getDiffOptions(n.variables), f = yi("canonizeResults", function() {
          return u.diff(h);
        });
        !a.stopped && mr(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(f, h), f.complete && (t.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = jt.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = jt.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function Im(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !y1(e);
  return !n && r && e.data && (n = !0), n;
}
var Dte = Object.prototype.hasOwnProperty, M6 = /* @__PURE__ */ Object.create(null), Mte = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new Uk(
        Ju["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Zu(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new mee(
        function(a) {
          return r.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(na(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return Ja(this, arguments, void 0, function(r) {
        var n, i, a, o, s, l, d, c = r.mutation, u = r.variables, h = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, m = p === void 0 ? [] : p, y = r.awaitRefetchQueries, v = y === void 0 ? !1 : y, b = r.update, $ = r.onQueryUpdated, _ = r.fetchPolicy, x = _ === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : _, S = r.errorPolicy, A = S === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : S, N = r.keepRootFields, P = r.context;
        return Xa(this, function(D) {
          switch (D.label) {
            case 0:
              return Le(c, 36), Le(x === "network-only" || x === "no-cache", 37), n = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, u = this.getVariables(c, u), i ? [4, this.localState.addExportedVariables(c, u, P)] : [3, 2];
            case 1:
              u = D.sent(), D.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: c,
                variables: u,
                loading: !0,
                error: null
              }), o = h && this.markMutationOptimistic(h, {
                mutationId: n,
                document: c,
                variables: u,
                fetchPolicy: x,
                errorPolicy: A,
                context: P,
                updateQueries: f,
                update: b,
                keepRootFields: N
              }), this.broadcastQueries(), s = this, [2, new Promise(function(T, I) {
                return X2(s.getObservableFromLink(c, ne(ne({}, P), { optimisticResponse: o ? h : void 0 }), u, {}, !1), function(j) {
                  if (y1(j) && A === "none")
                    throw new ts({
                      graphQLErrors: Sm(j)
                    });
                  a && (a.loading = !1, a.error = null);
                  var F = ne({}, j);
                  return typeof m == "function" && (m = m(F)), A === "ignore" && y1(F) && delete F.errors, s.markMutationResult({
                    mutationId: n,
                    result: F,
                    document: c,
                    variables: u,
                    fetchPolicy: x,
                    errorPolicy: A,
                    context: P,
                    update: b,
                    updateQueries: f,
                    awaitRefetchQueries: v,
                    refetchQueries: m,
                    removeOptimistic: o ? n : void 0,
                    onQueryUpdated: $,
                    keepRootFields: N
                  });
                }).subscribe({
                  next: function(j) {
                    s.broadcastQueries(), (!("hasNext" in j) || j.hasNext === !1) && T(ne(ne({}, j), { data: s.maskOperation({
                      document: c,
                      data: j.data,
                      fetchPolicy: x,
                      id: n
                    }) }));
                  },
                  error: function(j) {
                    a && (a.loading = !1, a.error = j), o && s.cache.removeOptimistic(n), s.broadcastQueries(), I(j instanceof ts ? j : new ts({
                      networkError: j
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, a = [], o = t.fetchPolicy === "no-cache";
      if (!o && Im(i, t.errorPolicy)) {
        if (jl(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), jl(i) && So(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = u_(s.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var d = t.updateQueries;
        d && this.queries.forEach(function(u, h) {
          var f = u.observableQuery, p = f && f.queryName;
          if (!(!p || !Dte.call(d, p))) {
            var m = d[p], y = n.queries.get(h), v = y.document, b = y.variables, $ = r.diff({
              query: v,
              variables: b,
              returnPartialData: !0,
              optimistic: !1
            }), _ = $.result, x = $.complete;
            if (x && _) {
              var S = m(_, {
                mutationResult: i,
                queryName: v && _c(v) || void 0,
                queryVariables: b
              });
              S && a.push({
                result: S,
                dataId: "ROOT_QUERY",
                query: v,
                variables: b
              });
            }
          }
        });
      }
      if (a.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(u) {
            o || a.forEach(function(m) {
              return u.write(m);
            });
            var h = t.update, f = !Fee(i) || jl(i) && !i.hasNext;
            if (h) {
              if (!o) {
                var p = u.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = ne(ne({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && h(u, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && f && u.modify({
              id: "ROOT_MUTATION",
              fields: function(m, y) {
                var v = y.fieldName, b = y.DELETE;
                return v === "__typename" ? m : b;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(u) {
          return c.push(u);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: M6 }) : t;
      return i === M6 ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(ne(ne({}, r), { result: { data: i } }), a);
        } catch (o) {
          globalThis.__DEV__ !== !1 && Le.error(o);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: mX(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: $u(["nonreactive"], t),
          nonReactiveQuery: wee(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: i_([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: nee(id(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: ne(ne({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? ne(ne({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return ne(ne({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = ne(ne({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new np(this), i = new $1({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, $1.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), Le(t.query, 38), Le(t.query.kind === "Document", 39), Le(!t.returnPartialData, 40), Le(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, ne(ne({}, t), { query: i })).then(function(a) {
        return a && ne(ne({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(na(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = jt.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), a.set(s, !1);
        else if (UX(s)) {
          var l = Sl(r.transform(s));
          i.set(l, _c(s)), a.set(l, !1);
        } else Hi(s) && s.query && o.add(s);
      }), this.queries.forEach(function(s, l) {
        var d = s.observableQuery, c = s.document;
        if (d) {
          if (t === "all") {
            n.set(l, d);
            return;
          }
          var u = d.queryName, h = d.options.fetchPolicy;
          if (h === "standby" || t === "active" && !d.hasObservers())
            return;
          (t === "active" || u && a.has(u) || c && a.has(Sl(c))) && (n.set(l, d), u && a.set(u, !0), c && a.set(Sl(c), !0));
        }
      }), o.size && o.forEach(function(s) {
        var l = gm("legacyOneTimeQuery"), d = r.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new $1({
          queryManager: r,
          queryInfo: d,
          options: ne(ne({}, s), { fetchPolicy: "network-only" })
        });
        Le(c.queryId === l), d.setObservableQuery(c), n.set(l, c);
      }), globalThis.__DEV__ !== !1 && a.size && a.forEach(function(s, l) {
        if (!s) {
          var d = i.get(l);
          d ? globalThis.__DEV__ !== !1 && Le.warn(43, d) : globalThis.__DEV__ !== !1 && Le.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, a) {
        var o = i.options.fetchPolicy;
        yi("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), (r.queries.get(a) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, a = t.fetchPolicy, o = t.errorPolicy, s = o === void 0 ? "none" : o, l = t.context, d = l === void 0 ? {} : l, c = t.extensions, u = c === void 0 ? {} : c;
      n = this.transform(n), i = this.getVariables(n, i);
      var h = function(p) {
        return r.getObservableFromLink(n, d, p, u).map(function(m) {
          a !== "no-cache" && (Im(m, s) && r.cache.write({
            query: n,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var y = y1(m), v = nte(m);
          if (y || v) {
            var b = {};
            if (y && (b.graphQLErrors = m.errors), v && (b.protocolErrors = m.extensions[O3]), s === "none" || v)
              throw new ts(b);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, d).then(h);
        return new tr(function(p) {
          var m = null;
          return f.then(function(y) {
            return m = y.subscribe(p);
          }, p.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return h(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, a) {
      var o = this, s;
      a === void 0 && (a = (s = r?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, d = this.getDocumentInfo(t), c = d.serverQuery, u = d.clientQuery;
      if (c) {
        var h = this, f = h.inFlightLinkObservables, p = h.link, m = {
          query: c,
          variables: n,
          operationName: _c(c) || void 0,
          context: this.prepareContext(ne(ne({}, r), { forceFetch: !a })),
          extensions: i
        };
        if (r = m.context, a) {
          var y = Sl(c), v = k3(n), b = f.lookup(y, v);
          if (l = b.observable, !l) {
            var $ = new ul([
              Em(p, m)
            ]);
            l = b.observable = $, $.beforeNext(function _(x, S) {
              x === "next" && "hasNext" in S && S.hasNext ? $.beforeNext(_) : f.remove(y, v);
            });
          }
        } else
          l = new ul([
            Em(p, m)
          ]);
      } else
        l = new ul([tr.of({ data: {} })]), r = this.prepareContext(r);
      return u && (l = X2(l, function(_) {
        return o.localState.runResolvers({
          document: u,
          remoteResult: _,
          context: r,
          variables: n
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return X2(this.getObservableFromLink(a, n.context, n.variables), function(o) {
        var s = Sm(o), l = s.length > 0, d = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && d === "none")
            throw t.markError(new ts({
              graphQLErrors: s
            }));
          t.markResult(o, a, n, r), t.markReady();
        }
        var c = {
          data: o.data,
          loading: !1,
          networkStatus: jt.ready
        };
        return l && d === "none" && (c.data = void 0), l && d !== "ignore" && (c.errors = s, c.networkStatus = jt.error), c;
      }, function(o) {
        var s = f_(o) ? o : new ts({ networkError: o });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var a = this;
      n === void 0 && (n = jt.loading), i === void 0 && (i = r.query);
      var o = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, l = r.fetchPolicy, d = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = r.errorPolicy, u = c === void 0 ? s && s.errorPolicy || "none" : c, h = r.returnPartialData, f = h === void 0 ? !1 : h, p = r.notifyOnNetworkStatusChange, m = p === void 0 ? !1 : p, y = r.context, v = y === void 0 ? {} : y, b = Object.assign({}, r, {
        query: i,
        variables: o,
        fetchPolicy: d,
        errorPolicy: u,
        returnPartialData: f,
        notifyOnNetworkStatusChange: m,
        context: v
      }), $ = function(N) {
        b.variables = N;
        var P = a.fetchQueryByPolicy(t, b, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          b.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          P.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), P
        );
      }, _ = function() {
        return a.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(N) {
        _(), setTimeout(function() {
          return x.cancel(N);
        });
      });
      var x, S;
      if (this.getDocumentInfo(b.query).hasClientExports)
        x = new ul(this.localState.addExportedVariables(b.query, b.variables, b.context).then($).then(function(N) {
          return N.sources;
        })), S = !0;
      else {
        var A = $(b.variables);
        S = A.fromLink, x = new ul(A.sources);
      }
      return x.promise.then(_, _), {
        concast: x,
        fromLink: S
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, a = t.optimistic, o = a === void 0 ? !1 : a, s = t.removeOptimistic, l = s === void 0 ? o ? gm("refetchQueries") : void 0 : s, d = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(h, f) {
        c.set(f, {
          oq: h,
          lastDiff: (r.queries.get(f) || h.queryInfo).getDiff()
        });
      });
      var u = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: o && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(h, f, p) {
          var m = h.watcher instanceof np && h.watcher.observableQuery;
          if (m) {
            if (d) {
              c.delete(m.queryId);
              var y = d(m, f, p);
              return y === !0 && (y = m.refetch()), y !== !1 && u.set(m, y), y;
            }
            d !== null && c.set(m.queryId, { oq: m, lastDiff: p, diff: f });
          }
        }
      }), c.size && c.forEach(function(h, f) {
        var p = h.oq, m = h.lastDiff, y = h.diff, v;
        d && (y || (y = yi("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), v = d(p, y, m)), (!d || v === !0) && (v = p.refetch()), v !== !1 && u.set(p, v), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), l && this.cache.removeOptimistic(l), u;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, a = t.document, o = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, d = (r = id(a)) === null || r === void 0 ? void 0 : r.operation, c = ((n = d?.[0]) !== null && n !== void 0 ? n : "o") + l;
        this.dataMasking && s === "no-cache" && !SX(a) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && Le.warn(
          45,
          (i = _c(a)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
        ));
      }
      return this.dataMasking ? Ote(o, a, this.cache) : o;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? Tte(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, a = r.query, o = r.variables, s = r.fetchPolicy, l = r.refetchWritePolicy, d = r.errorPolicy, c = r.returnPartialData, u = r.context, h = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: a,
        variables: o,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, m = function(_, x) {
        x === void 0 && (x = t.networkStatus || jt.loading);
        var S = _.result;
        globalThis.__DEV__ !== !1 && !c && !mr(S, {}) && w_(_.missing);
        var A = function(N) {
          return tr.of(ne({ data: N, loading: Cl(x), networkStatus: x }, _.complete ? null : { partial: !0 }));
        };
        return S && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: S },
          context: u,
          variables: o,
          onlyRunForcedResolvers: !0
        }).then(function(N) {
          return A(N.data || void 0);
        }) : d === "none" && x === jt.refetch && Array.isArray(_.missing) ? A(void 0) : A(S);
      }, y = s === "no-cache" ? 0 : n === jt.refetch && l !== "merge" ? 1 : 2, v = function() {
        return i.getResultsFromLink(t, y, {
          query: a,
          variables: o,
          context: u,
          fetchPolicy: s,
          errorPolicy: d
        });
      }, b = h && typeof f == "number" && f !== n && Cl(n);
      switch (s) {
        default:
        case "cache-first": {
          var $ = p();
          return $.complete ? {
            fromLink: !1,
            sources: [m($, t.markReady())]
          } : c || b ? {
            fromLink: !0,
            sources: [m($), v()]
          } : { fromLink: !0, sources: [v()] };
        }
        case "cache-and-network": {
          var $ = p();
          return $.complete || c || b ? {
            fromLink: !0,
            sources: [m($), v()]
          } : { fromLink: !0, sources: [v()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(p(), t.markReady())]
          };
        case "network-only":
          return b ? {
            fromLink: !0,
            sources: [m(p()), v()]
          } : { fromLink: !0, sources: [v()] };
        case "no-cache":
          return b ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), v()]
          } : { fromLink: !0, sources: [v()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new np(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return ne(ne(ne({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), Rte = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, a = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = y6(r.resolvers, n);
      }) : this.resolvers = y6(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return Ja(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, a = r.context, o = r.variables, s = r.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return Xa(this, function(d) {
          return n ? [2, this.resolveDocument(n, i.data, a, o, this.fragmentMatcher, l).then(function(c) {
            return ne(ne({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return $u(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return a_(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return ne(ne({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return Ja(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Xa(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(o) {
            return ne(ne({}, n), o.exportedVariables);
          })] : [2, ne({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Ti(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return nf;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: bee(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return Ja(this, arguments, void 0, function(n, i, a, o, s, l) {
        var d, c, u, h, f, p, m, y, v, b, $;
        return a === void 0 && (a = {}), o === void 0 && (o = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), Xa(this, function(_) {
          return d = mf(n), c = Xu(n), u = Yu(c), h = this.collectSelectionsToResolve(d, u), f = d.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", m = this, y = m.cache, v = m.client, b = {
            fragmentMap: u,
            context: ne(ne({}, a), { cache: y, client: v }),
            variables: o,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: h,
            onlyRunForcedResolvers: l
          }, $ = !1, [2, this.resolveSelectionSet(d.selectionSet, $, i, b).then(function(x) {
            return {
              result: x,
              exportedVariables: b.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return Ja(this, void 0, void 0, function() {
        var a, o, s, l, d, c = this;
        return Xa(this, function(u) {
          return a = i.fragmentMap, o = i.context, s = i.variables, l = [n], d = function(h) {
            return Ja(c, void 0, void 0, function() {
              var f, p;
              return Xa(this, function(m) {
                return !r && !i.selectionsToResolve.has(h) ? [
                  2
                  /*return*/
                ] : Fk(h, s) ? fh(h) ? [2, this.resolveField(h, r, n, i).then(function(y) {
                  var v;
                  typeof y < "u" && l.push((v = {}, v[hh(h)] = y, v));
                })] : (eee(h) ? f = h : (f = a[h.name.value], Le(f, 21, h.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, o)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(y) {
                  l.push(y);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(d)).then(function() {
            return o_(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return Ja(this, void 0, void 0, function() {
        var a, o, s, l, d, c, u, h, f, p = this;
        return Xa(this, function(m) {
          return n ? (a = i.variables, o = t.name.value, s = hh(t), l = o !== s, d = n[s] || n[o], c = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (u = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[u], h && (f = h[l ? o : s], f && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Ite.withValue(this.cache, f, [
              n,
              XX(t, a),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(y) {
            var v, b;
            if (y === void 0 && (y = d), t.directives && t.directives.forEach(function(_) {
              _.name.value === "export" && _.arguments && _.arguments.forEach(function(x) {
                x.name.value === "as" && x.value.kind === "StringValue" && (i.exportedVariables[x.value.value] = y);
              });
            }), !t.selectionSet || y == null)
              return y;
            var $ = (b = (v = t.directives) === null || v === void 0 ? void 0 : v.some(function(_) {
              return _.name.value === "client";
            })) !== null && b !== void 0 ? b : !1;
            if (Array.isArray(y))
              return p.resolveSubSelectedArray(t, r || $, y, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || $, y, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var a = this;
      return Promise.all(n.map(function(o) {
        if (o === null)
          return null;
        if (Array.isArray(o))
          return a.resolveSubSelectedArray(t, r, o, i);
        if (t.selectionSet)
          return a.resolveSelectionSet(t.selectionSet, r, o, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(o) {
        return !Array.isArray(o);
      }, i = this.selectionsToResolveCache;
      function a(o) {
        if (!i.has(o)) {
          var s = /* @__PURE__ */ new Set();
          i.set(o, s), Ti(o, {
            Directive: function(l, d, c, u, h) {
              l.name.value === "client" && h.forEach(function(f) {
                n(f) && a9(f) && s.add(f);
              });
            },
            FragmentSpread: function(l, d, c, u, h) {
              var f = r[l.name.value];
              Le(f, 22, l.name.value);
              var p = a(f);
              p.size > 0 && (h.forEach(function(m) {
                n(m) && a9(m) && s.add(m);
              }), s.add(l), p.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(o);
      }
      return a(t);
    }, e;
  })()
), R6 = !1, Lte = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, a;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw na(16);
      var o = t.uri, s = t.credentials, l = t.headers, d = t.cache, c = t.documentTransform, u = t.ssrMode, h = u === void 0 ? !1 : u, f = t.ssrForceFetchDelay, p = f === void 0 ? 0 : f, m = t.connectToDevTools, y = t.queryDeduplication, v = y === void 0 ? !0 : y, b = t.defaultOptions, $ = t.defaultContext, _ = t.assumeImmutableResults, x = _ === void 0 ? d.assumeImmutableResults : _, S = t.resolvers, A = t.typeDefs, N = t.fragmentMatcher, P = t.clientAwareness, D = t.name, T = t.version, I = t.devtools, j = t.dataMasking;
      globalThis.__DEV__ !== !1 && (Xn(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), Xn(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), Xn(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), Xn(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), Xn(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), Xn(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), Xn(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && Le.warn(17));
      var F = t.link;
      F || (F = o ? new wte({ uri: o, credentials: s, headers: l }) : e0.empty()), this.link = F, this.cache = d, this.disableNetworkFetches = h || p > 0, this.queryDeduplication = v, this.defaultOptions = b || /* @__PURE__ */ Object.create(null), this.typeDefs = A, this.devtoolsConfig = ne(ne({}, I), { enabled: (n = I?.enabled) !== null && n !== void 0 ? n : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = y3, this.localState = new Rte({
        cache: d,
        client: this,
        resolvers: S,
        fragmentMatcher: N
      }), this.queryManager = new Mte({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: $,
        documentTransform: c,
        queryDeduplication: v,
        ssrMode: h,
        dataMasking: !!j,
        clientAwareness: {
          name: (i = P?.name) !== null && i !== void 0 ? i : D,
          version: (a = P?.version) !== null && a !== void 0 ? a : T
        },
        localState: this.localState,
        assumeImmutableResults: x,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = /* @__PURE__ */ Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !R6 && globalThis.__DEV__ !== !1 && (R6 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, a = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && Le.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = b1(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = ne(ne({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (Xn(t, "canonizeResults", "client.watchQuery"), Xn(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = b1(this.defaultOptions.query, t)), Le(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = ne(ne({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (Xn(t, "canonizeResults", "client.query"), Xn(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && Le.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = b1(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return ne(ne({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(ne(ne({}, t), (r = {}, r[/* @__PURE__ */ Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return Em(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(o, s) {
        n.push(s), i.push(o);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(o) {
        globalThis.__DEV__ !== !1 && Le.debug(20, o);
      }), a;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (Lte.prototype.getMemoryInternals = DX);
function vf(e) {
  return e ? new Date(e).toLocaleDateString("en-US", { timeZone: "UTC" }) : "";
}
const $_ = "yyyy-MM-dd";
var Fte = /* @__PURE__ */ k("<div>");
function Al(e) {
  const t = it({
    size: "md",
    color: "blue"
  }, e), r = K(() => Yt(e.class, "inline-flex items-center text-xs font-medium whitespace-nowrap", {
    "px-2 py-1 rounded-xl": t.size === "md",
    "px-1.5 py-0.5 rounded-lg": t.size === "sm",
    "bg-gray-100 text-gray-600 border-gray-300 border-2": t.color === "gray",
    "bg-red-100 text-red-700 border-red-300 border-2": t.color === "red",
    "bg-yellow-100 text-yellow-800 border-yellow-300 border-2": t.color === "yellow",
    "bg-green-100 text-green-700 border-green-300 border-2": t.color === "green",
    "bg-blue-100 text-blue-700 border-blue-300 border-2": t.color === "blue",
    "bg-indigo-100 text-indigo-700 border-indigo-300 border-2": t.color === "indigo",
    "bg-purple-100 text-purple-700 border-purple-300 border-2": t.color === "purple",
    "bg-pink-100 text-pink-700 border-pink-300 border-2": t.color === "pink"
  }));
  return (() => {
    var n = Fte();
    return E(n, () => e.children), se(() => ft(n, r())), n;
  })();
}
var jte = /* @__PURE__ */ k('<div class="group relative w-max"><span class="pointer-events-none absolute -bottom-8 left-0 w-max rounded bg-gray-900 px-2 py-1 text-sm font-medium text-gray-50 opacity-0 shadow transition-opacity group-hover:opacity-100">');
function k_(e) {
  return (() => {
    var t = jte(), r = t.firstChild;
    return E(t, () => e.children, r), E(r, () => e.text), t;
  })();
}
var zte = /* @__PURE__ */ k("<div class=mr-1>");
const Vte = {
  PLACED: "Placed",
  ROUTING: "Routing",
  PENDING: "Pending",
  CANCELED: "Canceled",
  COMPLETED: "Completed",
  ERROR: "Error"
}, Ute = {
  PLACED: "arrowUpRight",
  ROUTING: "arrowUturnRight",
  PENDING: "clock",
  CANCELED: "xCircle",
  COMPLETED: "checkCircle",
  ERROR: "questionMarkCircle"
}, qte = {
  SENT: "Sent",
  RECEIVED: "Received",
  READY: "Ready",
  PICKED_UP: "Picked up",
  FILLING: "Filling",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered"
}, Bte = {
  SENT: "Order sent to pharmacy",
  RECEIVED: "Order received by pharmacy",
  READY: "Order ready at pharmacy",
  PICKED_UP: "Order picked up by patient",
  FILLING: "Mail order being filled",
  SHIPPED: "Mail order shipped",
  DELIVERED: "Mail order delivered"
}, Hte = {
  PLACED: "Order has been placed",
  ROUTING: "Order waiting on patient pharmacy selection",
  PENDING: "Order is pending",
  CANCELED: "Order has been canceled",
  COMPLETED: "Order has been completed",
  ERROR: "Order has an error"
}, Wte = {
  ERROR: "red",
  CANCELED: "red",
  ROUTING: "gray",
  PLACED: "yellow",
  PENDING: "yellow",
  COMPLETED: "green"
}, Qte = {
  SENT: "yellow",
  RECEIVED: "yellow",
  FILLING: "yellow",
  SHIPPED: "yellow",
  READY: "green",
  PICKED_UP: "green",
  DELIVERED: "green"
};
function Kte(e) {
  const t = K(() => {
    if (e.orderState === "PLACED" && e.fulfillmentState) {
      const r = e.fulfillmentState;
      return {
        status: qte[r],
        statusColor: Qte[r],
        statusTip: Bte[r]
      };
    } else {
      const r = e.orderState;
      return {
        status: Vte[r],
        statusTip: Hte[r],
        statusIcon: Ute[r],
        statusColor: Wte[r]
      };
    }
  });
  return g(H, {
    get when() {
      return t().status;
    },
    get children() {
      return g(k_, {
        get text() {
          return t().statusTip;
        },
        get children() {
          return g(Al, {
            get color() {
              return t().statusColor;
            },
            get children() {
              return [g(H, {
                get when() {
                  return t().statusIcon;
                },
                get children() {
                  var r = zte();
                  return E(r, g(mt, {
                    get name() {
                      return t().statusIcon;
                    },
                    size: "sm"
                  })), r;
                }
              }), Ut(() => t().status)];
            }
          });
        }
      });
    }
  });
}
var Gte = /* @__PURE__ */ k('<div class="flex items-center justify-between">'), Zte = /* @__PURE__ */ k('<table class="table-fixed divide-y divide-gray-300 break-words"><tbody class="divide-y divide-gray-200">'), Yte = /* @__PURE__ */ k('<div class="flex flex-col gap-2"><div class="flex gap-x-4">'), Jte = /* @__PURE__ */ k("<div class=mt-4>"), Xte = /* @__PURE__ */ k('<tr><td class="align-top whitespace-nowrap pr-4 py-4 text-sm text-gray-500"></td><td class="py-4 text-sm text-gray-500"><div class=flex><div class=pr-4></div><div>');
function ere() {
  const [e, t] = Pd();
  return g(H, {
    get when() {
      return e.orders.length > 0;
    },
    get children() {
      return g(Mn, {
        addChildrenDivider: !0,
        get children() {
          return [(() => {
            var r = Gte();
            return E(r, g(Ee, {
              color: "gray",
              children: "Recent Orders"
            })), r;
          })(), (() => {
            var r = Zte(), n = r.firstChild;
            return E(n, g(yt, {
              get each() {
                return e.orders;
              },
              children: (i) => {
                const a = /* @__PURE__ */ new Set();
                return i?.fills.forEach((o) => {
                  a.add(o.treatment?.name);
                }), (() => {
                  var o = Xte(), s = o.firstChild, l = s.nextSibling, d = l.firstChild, c = d.firstChild, u = c.nextSibling;
                  return E(s, g(Ee, {
                    color: "gray",
                    size: "sm",
                    get children() {
                      return vf(i.createdAt);
                    }
                  })), E(c, g(Kte, {
                    get orderState() {
                      return i.state;
                    }
                  })), E(u, g(yt, {
                    get each() {
                      return [...a];
                    },
                    children: (h, f) => g(Ee, {
                      color: "black",
                      size: "sm",
                      get children() {
                        return [h, Ut(() => f() < a.size - 1 ? ",  " : null)];
                      }
                    })
                  })), E(l, g(H, {
                    get when() {
                      return i.state === "ROUTING";
                    },
                    get children() {
                      var h = Jte();
                      return E(h, g(No, {
                        status: "info",
                        withoutIcon: !0,
                        get children() {
                          var f = Yte(), p = f.firstChild;
                          return E(f, g(Ee, {
                            size: "sm",
                            color: "black",
                            children: "This order is pending pharmacy selection by the patient"
                          }), p), E(p, g(xt, {
                            variant: "naked",
                            onClick: () => t.setIsIssueDialogOpen(!0, i),
                            children: "Report Issue"
                          })), f;
                        }
                      })), h;
                    }
                  }), null), o;
                })();
              }
            })), r;
          })()];
        }
      });
    }
  });
}
const In = (e, t, r) => {
  const n = new CustomEvent("photon-datadog-action", {
    composed: !0,
    bubbles: !0,
    detail: {
      action: e,
      data: { ...t, timestamp: (/* @__PURE__ */ new Date()).toISOString() }
    }
  });
  r?.dispatchEvent(n);
};
function sd({
  dispenseQuantity: e = 0,
  dispenseUnit: t = "",
  fillsAllowed: r = 0,
  instructions: n = ""
}) {
  const i = __(r);
  return `${e} ${t}, ${i} Refill${i === 1 ? "" : "s"} - ${n}`;
}
function __(e = 0) {
  return Math.max(e - 1, 0);
}
var tre = /* @__PURE__ */ k('<div class="flex flex-col gap-6"><div><div class="table bg-red-50 text-red-600 p-2 rounded-full mb-4"></div></div><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4"><br></div><div class="flex flex-col items-stretch gap-4">');
function rre() {
  let e;
  const [t, r] = Pd();
  return fe(() => {
    t.isDuplicateDialogOpen && In("prescribe-duplicate-dialog-open", {
      duplicate: t.duplicateFill,
      order: t.orderWithIssue
    }, e);
  }), g(zs, {
    get open() {
      return t.isDuplicateDialogOpen;
    },
    onClose: () => {
      In("prescribe-duplicate-dialog-exit", {}, e), t?.duplicateDialogCancelCb?.(), r.setIsDuplicateDialogOpen(!1);
    },
    get children() {
      var n = tre(), i = n.firstChild, a = i.firstChild, o = i.nextSibling, s = o.firstChild, l = o.nextSibling, d = e;
      return typeof d == "function" ? Pn(d, n) : e = n, E(a, g(mt, {
        name: "exclamationCircle"
      })), E(i, g(Ee, {
        bold: !0,
        class: "mb-2",
        children: "Looks like a duplicate order"
      }), null), E(i, g(Ee, {
        children: "This patient already has the same prescription:"
      }), null), E(o, g(Ee, {
        size: "sm",
        get children() {
          return t?.duplicateFill?.treatment?.name;
        }
      }), s), E(o, g(Ee, {
        size: "sm",
        color: "gray",
        get children() {
          return sd({
            dispenseQuantity: t?.duplicateFill?.prescription?.dispenseQuantity,
            dispenseUnit: t?.duplicateFill?.prescription?.dispenseUnit,
            fillsAllowed: t?.duplicateFill?.prescription?.fillsAllowed,
            instructions: t?.duplicateFill?.prescription?.instructions
          });
        }
      }), null), E(o, g(Ee, {
        size: "sm",
        color: "gray",
        get children() {
          return ["Written by ", Ut(() => t?.duplicateFill?.prescription?.prescriber?.name?.full), " on", " ", Ut(() => new Date(t?.duplicateFill?.prescription?.writtenAt).toLocaleDateString())];
        }
      }), null), E(l, g(xt, {
        size: "xl",
        onClick: () => {
          t?.duplicateDialogCancelCb?.(), r.setIsDuplicateDialogOpen(!1), r.setIsIssueDialogOpen(!0);
        },
        children: "Report Issue"
      }), null), E(l, g(xt, {
        size: "xl",
        variant: "secondary",
        onClick: () => {
          In("prescribe-duplicate-dialog-add-anyway", {}, e), t?.duplicateDialogContinueCb?.(), r.setIsDuplicateDialogOpen(!1);
        },
        children: "Add Prescriptions Anyway"
      }), null), E(l, g(xt, {
        variant: "naked",
        size: "xl",
        onClick: () => {
          t?.duplicateDialogCancelCb?.(), In("prescribe-duplicate-dialog-exit", {}, e), r.setIsDuplicateDialogOpen(!1);
        },
        children: "Go Back"
      }), null), n;
    }
  });
}
var nre = /* @__PURE__ */ k("<textarea>");
function Pm(e) {
  const t = va(), r = it({
    resize: !1,
    rows: 4,
    placeholder: ""
  }, e), [n] = qu(), i = K(() => Yt("block w-full touch-pan-y overflow-x-hidden rounded-lg border-0 py-3 px-4 ring-1 ring-inset text-sm sm:text-base sm:leading-6 focus:ring-2 focus:ring-inset focus:outline-none", {
    "resize-y": r.resize,
    "resize-none": !r.resize,
    "ring-red-300 text-gray-900 placeholder:text-red-300 focus:ring-sky-500/40": !!n.error,
    "ring-gray-300 text-gray-900 placeholder:text-gray-400 hover:ring-gray-400 focus:ring-sky-500/40": !n.error && !r.disabled,
    "cursor-not-allowed bg-gray-50 text-gray-500 ring-gray-200": r.disabled
  }));
  return (() => {
    var a = nre();
    return a.addEventListener("blur", (o) => e.onBlur?.(o.currentTarget.value)), a.$$input = (o) => e.onInput?.(o.currentTarget.value), se((o) => {
      var s = n?.id || (e?.name ?? t), l = e?.name ?? t, d = r.rows, c = r.disabled, u = r.placeholder, h = i();
      return s !== o.e && pt(a, "id", o.e = s), l !== o.t && pt(a, "name", o.t = l), d !== o.a && pt(a, "rows", o.a = d), c !== o.o && (a.disabled = o.o = c), u !== o.i && pt(a, "placeholder", o.i = u), h !== o.n && ft(a, o.n = h), o;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0
    }), se(() => a.value = r.value), a;
  })();
}
an(["input"]);
function x_(e) {
  const t = /* @__PURE__ */ new Set();
  return e.fills.filter((r) => {
    const n = r.treatment?.name;
    return !n || t.has(n) ? !1 : (t.add(n), !0);
  });
}
const Nm = (e, t) => {
  const r = (typeof t == "function" ? t() : t).client;
  let n = null, i = null;
  const [a, o] = V(!1), [s] = C8(a, async (l) => {
    let d;
    try {
      d = await r.mutate(l);
    } catch (h) {
      throw i && (i(h), i = null), h;
    }
    const { data: c, errors: u } = d;
    if (u)
      throw i && (i(u[0]), i = null), u[0];
    if (c != null)
      return n && (n(c), n = null), c;
    throw new Error("Mutation did not return any data.");
  });
  return [async (l) => {
    const d = {
      mutation: e,
      ...typeof t == "function" ? Qe(t) : t
    }, c = b1(l, d);
    return o(c), new Promise((u, h) => {
      n = u, i = h;
    });
  }, s];
};
var ire = /* @__PURE__ */ k('<div class="flex flex-col gap-6"><div></div><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4 flex flex-col gap-4"><div class="flex flex-col"></div><div class="flex flex-col"><div class="flex flex-col gap-y-4"></div></div></div><form class=mt-4 id=prescribe-flow-duplicate></form><div class="flex flex-col items-stretch gap-4">'), are = /* @__PURE__ */ k("<div><br>");
const ore = x$({
  description: sl().min(1, {
    message: "A description is required"
  })
}), sre = Ge`
  mutation CreateTicket($input: TicketInput!) {
    createTicket(input: $input) {
      id
    }
  }
`, lre = ({
  patient: e,
  order: t,
  prescriptions: r,
  values: n
}) => {
  const i = (o) => `
    Name: ${o.name}
    Info: ${sd({
    dispenseQuantity: o.dispenseQuantity,
    dispenseUnit: o.dispenseUnit,
    fillsAllowed: o.fillsAllowed,
    instructions: o.instructions
  })}
  `, a = r.map(i).join(`

`);
  return `
Order:
  ID: ${t.id}

----
Patient:
  ID: ${e.id}
  Name: ${e.name}

----
Prescriptions:
${a}

----
Description:
  ${n.description}
`;
}, dre = "prescribe-flow-duplicate";
function cre() {
  let e;
  const [t, r] = Pd(), {
    dispatchTicketCreatedDuplicate: n
  } = Ma(), i = Kn(), [a, o] = Nm(sre, {
    client: i.apolloClinical
  });
  fe(() => {
    t.isIssueDialogOpen && In("prescribe-issue-dialog-open", {}, e);
  });
  const s = K(() => t?.orderWithIssue ? x_(t.orderWithIssue) : t?.duplicateFill ? [t.duplicateFill] : []), l = async (u) => {
    In("prescribe-issue-dialog-submitting", {}, e);
    const h = lre({
      patient: {
        id: t?.patientId,
        name: t?.patientName
      },
      order: {
        id: t?.orderWithIssue?.id
      },
      prescriptions: s().map((f) => ({
        name: f?.treatment?.name,
        dispenseQuantity: f?.prescription?.dispenseQuantity,
        dispenseUnit: f?.prescription?.dispenseUnit,
        fillsAllowed: f?.prescription?.fillsAllowed,
        instructions: f?.prescription?.instructions
      })),
      values: u
    });
    await a({
      variables: {
        input: {
          subject: `Issue with ${t?.duplicateFill?.treatment?.name || t?.orderWithIssue?.id}`,
          comment: {
            body: h
          }
        }
      }
    }), rr({
      header: "Issue reported",
      body: "The customer support team will respond to you shortly.",
      status: "success"
    }), n(), r.setIsIssueDialogOpen(!1);
  }, {
    form: d,
    errors: c
  } = b$({
    onSubmit: async (u) => {
      try {
        l({
          ...u
        });
      } catch {
        rr({
          header: "Error Creating Issue",
          body: "A ticket for this order has not been sent.",
          status: "info"
        });
      }
    },
    extend: w$({
      schema: ore
    })
  });
  return g(zs, {
    get open() {
      return t.isIssueDialogOpen;
    },
    onClose: () => {
      In("prescribe-issue-dialog-exit", {}, e), r.setIsIssueDialogOpen(!1);
    },
    get children() {
      var u = ire(), h = u.firstChild, f = h.nextSibling, p = f.firstChild, m = p.nextSibling, y = m.firstChild, v = f.nextSibling, b = v.nextSibling, $ = e;
      return typeof $ == "function" ? Pn($, u) : e = u, E(h, g(Ee, {
        bold: !0,
        class: "mb-2",
        children: "Report issue with existing order"
      }), null), E(h, g(Ee, {
        children: "Start an email thread with the Photon team to discuss next steps."
      }), null), E(p, g(Ee, {
        size: "xs",
        color: "gray",
        children: "PATIENT"
      }), null), E(p, g(Ee, {
        size: "sm",
        get children() {
          return t?.patientName;
        }
      }), null), E(m, g(Ee, {
        size: "xs",
        color: "gray",
        children: "PRESCRIPTION"
      }), y), E(y, g(yt, {
        get each() {
          return s();
        },
        children: (_) => (() => {
          var x = are(), S = x.firstChild;
          return E(x, g(Ee, {
            size: "sm",
            get children() {
              return _?.treatment?.name;
            }
          }), S), E(x, g(Ee, {
            size: "sm",
            color: "gray",
            get children() {
              return sd({
                dispenseQuantity: _?.prescription?.dispenseQuantity,
                dispenseUnit: _?.prescription?.dispenseUnit,
                fillsAllowed: _?.prescription?.fillsAllowed,
                instructions: _?.prescription?.instructions
              });
            }
          }), null), x;
        })()
      })), Pn(d, v), E(v, g(Ee, {
        size: "xs",
        class: "mb-2",
        bold: !0,
        children: "Description"
      }), null), E(v, g(Pm, {
        placeholder: "Describe issue with this order",
        name: "description"
      }), null), E(v, g(Ee, {
        size: "xs",
        color: "red",
        get children() {
          return c().description;
        }
      }), null), E(b, g(xt, {
        size: "xl",
        get disabled() {
          return o.loading;
        },
        get loading() {
          return o.loading;
        },
        type: "submit",
        form: dre,
        children: "Report Issue"
      }), null), E(b, g(xt, {
        variant: "naked",
        size: "xl",
        onClick: () => {
          In("prescribe-issue-dialog-exit", {}, e), r.setIsIssueDialogOpen(!1);
        },
        children: "Go Back"
      }), null), u;
    }
  });
}
var ure = /* @__PURE__ */ k('<div class="flex flex-col gap-6"><div><div class="table bg-blue-50 text-blue-600 p-2 rounded-full mb-4"></div></div><div class="flex flex-col gap-4"><div class="flex flex-col gap-2"><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4"></div></div><div class="flex flex-col gap-2"><div class="border border-solid border-gray-200 rounded-lg bg-gray-50 py-3 px-4 flex flex-col gap-4"></div></div></div><div class="flex flex-col items-stretch gap-2">'), L6 = /* @__PURE__ */ k("<div><br>");
const hre = Ge`
  mutation RecentOrdersCombineDialogUpdateOrder($orderId: ID!, $fills: [FillInput!]!) {
    updateOrder(id: $orderId, fills: $fills) {
      id
      createdAt
      fills {
        id
        prescription {
          id
          dispenseQuantity
          dispenseUnit
          fillsAllowed
          instructions
          notes
        }
        treatment {
          name
        }
      }
    }
  }
`, fre = Ge`
  mutation RecentOrdersCombineDialogCreateOrder(
    $patientId: ID!
    $fills: [FillInput!]!
    $addressId: ID
    $address: AddressInput
  ) {
    createOrder(patientId: $patientId, fills: $fills, addressId: $addressId, address: $address) {
      id
    }
  }
`;
function pre() {
  let e;
  const {
    draftPrescriptions: t
  } = Vs(), {
    dispatchOrderCreated: r,
    dispatchOrderCombined: n,
    dispatchAnalyticsTrackEvent: i
  } = Ma(), a = Kn(), [o, s] = Pd(), [l, d] = V(!1), [c, u] = V(!1), [h] = Nm(hre, {
    client: a.apollo
  }), [f] = Nm(fre, {
    client: a.apollo
  });
  fe(() => {
    o.isCombineDialogOpen && In("prescribe-combine-dialog-open", {}, e);
  });
  const p = K(() => o.orders.find((v) => v.state === "ROUTING")), m = K(() => {
    const v = p();
    return v ? x_(v) : [];
  }), y = async () => {
    const v = p();
    if (!v)
      return;
    u(!0), In("prescribe-combine-dialog-combining", {}, e), i("ctaClicked", {
      name: "Combine Orders Confirmed",
      buttonText: "Yes, combine orders"
    });
    const b = t().map(($) => ({
      prescriptionId: $.id
    }));
    try {
      const $ = await h({
        variables: {
          orderId: v.id,
          fills: b
        }
      });
      n($.updateOrder), i("ctaClicked", {
        name: "Order Sent",
        buttonText: "Send",
        orderId: v.id,
        prescriptionCount: t().length,
        fulfillmentType: null,
        hasPreferredPharmacy: !1,
        setAsPreferred: !1,
        pharmacyId: null,
        isCombinedOrder: !0
      }), u(!1), s.setIsCombineDialogOpen(!1);
      return;
    } catch {
      try {
        if (!o?.addressId && !o?.address || !o?.patientId)
          throw new Error("No address provided");
        const $ = await f({
          variables: {
            patientId: o.patientId,
            fills: b,
            ...o.addressId ? {
              addressId: o.addressId
            } : {
              address: o.address
            }
          }
        });
        r($.createOrder), i("ctaClicked", {
          name: "Order Sent",
          buttonText: "Send",
          orderId: $.createOrder.id,
          prescriptionCount: t().length,
          fulfillmentType: "SEND_TO_PATIENT",
          hasPreferredPharmacy: !1,
          setAsPreferred: !1,
          pharmacyId: null,
          isCombinedOrder: !1
        }), u(!1);
      } catch {
        rr({
          header: "Error Creating Order",
          body: "The draft was created but not turned into an active prescription.",
          status: "info"
        }), u(!1);
        return;
      }
    }
  };
  return g(zs, {
    get open() {
      return o.isCombineDialogOpen;
    },
    onClose: () => {
      In("prescribe-combine-dialog-exit", {}, e), s.setIsCombineDialogOpen(!1);
    },
    get children() {
      var v = ure(), b = v.firstChild, $ = b.firstChild, _ = b.nextSibling, x = _.firstChild, S = x.firstChild, A = x.nextSibling, N = A.firstChild, P = _.nextSibling, D = e;
      return typeof D == "function" ? Pn(D, v) : e = v, E($, g(mt, {
        name: "exclamationCircle"
      })), E(b, g(Ee, {
        bold: !0,
        children: "Add prescription to recent order?"
      }), null), E(x, g(Ee, {
        children: "This patient currently has prescriptions for:"
      }), S), E(S, g(yt, {
        get each() {
          return m();
        },
        children: (T) => (() => {
          var I = L6(), j = I.firstChild;
          return E(I, g(Ee, {
            size: "sm",
            get children() {
              return T?.treatment?.name;
            }
          }), j), E(I, g(Ee, {
            size: "sm",
            color: "gray",
            get children() {
              return sd({
                dispenseQuantity: T?.prescription?.dispenseQuantity,
                dispenseUnit: T?.prescription?.dispenseUnit,
                fillsAllowed: T?.prescription?.fillsAllowed,
                instructions: T?.prescription?.instructions
              });
            }
          }), null), I;
        })()
      })), E(A, g(Ee, {
        children: "Select YES to combine orders and enable the patient to send it to the same pharmacy:"
      }), N), E(N, () => g(yt, {
        get each() {
          return t();
        },
        children: (T) => (() => {
          var I = L6(), j = I.firstChild;
          return E(I, g(Ee, {
            size: "sm",
            get children() {
              return T.treatment.name;
            }
          }), j), E(I, g(Ee, {
            size: "sm",
            color: "gray",
            get children() {
              return sd({
                dispenseQuantity: T?.dispenseQuantity ?? 0,
                dispenseUnit: T?.dispenseUnit ?? "",
                fillsAllowed: T?.fillsAllowed ?? 0,
                instructions: T?.instructions ?? ""
              });
            }
          }), null), I;
        })()
      })), E(P, g(xt, {
        size: "xl",
        onClick: y,
        get disabled() {
          return l() || c();
        },
        get loading() {
          return c();
        },
        children: "Yes, combine orders"
      }), null), E(P, g(xt, {
        variant: "secondary",
        size: "xl",
        onClick: () => {
          In("prescribe-combine-dialog-not-combining", {}, e), i("ctaClicked", {
            name: "Combine Orders Rejected",
            buttonText: "No, send new order"
          }), o.createOrder?.(), d(!0);
        },
        get disabled() {
          return l() || c();
        },
        get loading() {
          return l();
        },
        get children() {
          return l() ? "Creating order..." : "No, send new order";
        }
      }), null), v;
    }
  });
}
const gh = (e, t) => {
  const r = (typeof t == "function" ? t() : t).client, n = () => {
    if (typeof t != "function")
      return t.skip && console.warn(
        `you passed options.skip to createQuery, but the options are not an acccessor.
This query will never execute!

Replace your options with a function.`
      ), t;
    const a = typeof t == "function" ? t() : t;
    return a.skip ? !1 : a;
  }, [i] = C8(
    n,
    (a) => {
      const o = r.watchQuery({ query: e, ...a }), [s, l] = js({});
      let d = !1;
      return new Promise((c, u) => {
        const h = o.subscribe({
          error: u,
          next: ({ data: f, error: p }) => {
            p && u(p), d ? l(pW(f)) : (d = !0, l(f), c(s));
          }
        });
        sr(() => h.unsubscribe());
      });
    }
  );
  return i;
};
var S_ = /* @__PURE__ */ ((e) => (e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING", e))(S_ || {});
const mre = Ge`
  query GetPatientOrders($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        full
      }
      orders(first: 5) {
        id
        createdAt
        state
        fills {
          treatment {
            name
          }
          prescription {
            dispenseQuantity
            dispenseUnit
            fillsAllowed
            instructions
            writtenAt
            prescriber {
              name {
                full
              }
            }
          }
        }
      }
    }
  }
`, C_ = Gr();
function ya(e) {
  const t = Kn(), [r, n] = js({
    orders: [],
    isLoading: !0,
    isCombineDialogOpen: !1,
    isDuplicateDialogOpen: !1,
    isIssueDialogOpen: !1,
    duplicateDialogContinueCb: () => {
    },
    duplicateDialogCancelCb: () => {
    }
  }), i = K(() => ({
    variables: {
      patientId: e.patientId
    },
    skip: !e.patientId,
    client: t.apollo,
    fetchPolicy: "network-only"
  })), a = gh(mre, i), o = [r, {
    setIsCombineDialogOpen(s, l, d, c) {
      n({
        isCombineDialogOpen: s,
        ...l ? {
          createOrder: l
        } : {
          createOrderCb: void 0
        },
        ...d ? {
          addressId: d
        } : {
          addressId: void 0
        },
        ...c ? {
          address: c
        } : {
          address: void 0
        }
      });
    },
    setIsDuplicateDialogOpen(s, l, d, c) {
      n({
        isDuplicateDialogOpen: s,
        ...d ? {
          duplicateDialogContinueCb: d
        } : {
          duplicateDialogContinueCb: void 0
        },
        ...c ? {
          duplicateDialogCancelCb: c
        } : {
          duplicateDialogCancelCb: void 0
        },
        ...l ? {
          duplicateFill: l.fill
        } : {},
        ...l ? {
          orderWithIssue: l.order
        } : {}
      });
    },
    setIsIssueDialogOpen(s, l) {
      n({
        isIssueDialogOpen: s,
        ...l && {
          orderWithIssue: l
        },
        ...!s && {
          duplicateFill: void 0,
          orderWithIssue: void 0
        }
      });
    },
    checkDuplicateFill(s) {
      const l = r.orders.filter((d) => d.state !== S_.Canceled);
      for (const d of l) {
        const c = d.fills.find((u) => u.treatment.name === s);
        if (c !== void 0)
          return {
            order: d,
            fill: c
          };
      }
    },
    hasRoutingOrder() {
      return r.orders.some((s) => s.state === "ROUTING");
    }
  }];
  return fe(() => {
    n({
      isLoading: a.loading
    });
    const s = a()?.patient;
    if (!a.loading && s) {
      const l = s.orders;
      if (l?.length > 0) {
        const d = /* @__PURE__ */ new Date(), c = new Date(d.getTime() - 480 * 60 * 1e3), u = l.filter((h) => new Date(h.createdAt) > c);
        n({
          orders: u,
          patientName: s?.name?.full,
          patientId: s?.id
        });
      }
    }
  }), g(C_.Provider, {
    value: o,
    get children() {
      return e.children;
    }
  });
}
function Pd() {
  const e = wr(C_);
  if (!e)
    throw new Error("useRecentOrders must be used within RecentOrdersContext");
  return e;
}
ya.Card = ere;
ya.CombineDialog = pre;
ya.DuplicateDialog = rre;
ya.IssueDialog = cre;
const gre = Ge`
  mutation CreatePrescriptionTemplate(
    $catalogId: ID!
    $name: String
    $treatmentId: ID!
    $dispenseAsWritten: Boolean
    $dispenseQuantity: Float
    $dispenseUnit: String
    $refillsAllowed: Int
    $fillsAllowed: Int
    $daysSupply: Int
    $instructions: String
    $notes: String
    $isPrivate: Boolean
  ) {
    createPrescriptionTemplate(
      catalogId: $catalogId
      name: $name
      treatmentId: $treatmentId
      dispenseAsWritten: $dispenseAsWritten
      dispenseQuantity: $dispenseQuantity
      dispenseUnit: $dispenseUnit
      refillsAllowed: $refillsAllowed
      fillsAllowed: $fillsAllowed
      daysSupply: $daysSupply
      instructions: $instructions
      notes: $notes
      isPrivate: $isPrivate
    ) {
      id
    }
  }
`, vre = Ge`
  mutation CreatePrescription(
    $externalId: ID
    $patientId: ID!
    $treatmentId: ID!
    $dispenseAsWritten: Boolean
    $dispenseQuantity: Float!
    $dispenseUnit: String!
    $refillsAllowed: Int
    $fillsAllowed: Int
    $daysSupply: Int
    $instructions: String!
    $notes: String
    $doNotFillBeforeDate: AWSDate
    $diagnoses: [ID]
  ) {
    createPrescription(
      externalId: $externalId
      patientId: $patientId
      treatmentId: $treatmentId
      dispenseAsWritten: $dispenseAsWritten
      dispenseQuantity: $dispenseQuantity
      dispenseUnit: $dispenseUnit
      refillsAllowed: $refillsAllowed #todo: remove this?
      fillsAllowed: $fillsAllowed
      daysSupply: $daysSupply
      instructions: $instructions
      notes: $notes
      doNotFillBeforeDate: $doNotFillBeforeDate
      diagnoses: $diagnoses
    ) {
      id
      externalId
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      fillsAllowed
      daysSupply
      instructions
      notes
      effectiveDate
      doNotFillBeforeDate
      diagnoses {
        code
      }
      treatment {
        id
        name
        codes {
          packageNDC
          productNDC
        }
      }
    }
  }
`, yre = Ge`
  mutation CreatePrescriptions($prescriptions: [PrescriptionInput]!) {
    createPrescriptions(prescriptions: $prescriptions) {
      id
      externalId
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      fillsAllowed
      daysSupply
      instructions
      notes
      doNotFillBeforeDate
      diagnoses {
        code
      }
      treatment {
        id
        name
        codes {
          packageNDC
          productNDC
        }
      }
    }
  }
`, bre = Ge`
  mutation UpdatePrescriptionStates($input: UpdatePrescriptionStatesInput!) {
    updatePrescriptionStates(input: $input)
  }
`, wre = Ge`
  mutation GenerateCoverageOptions($pharmacyId: ID!, $prescriptions: [CoverageRxInput!]!) {
    generateCoverageOptions(pharmacyId: $pharmacyId, prescriptions: $prescriptions) {
      id
      prescriptionId
      isAlternative
      status
      statusMessage
      paRequired
      price
      daysSupply
      dispenseQuantity
      dispenseUnit
      treatment {
        id
        name
      }
      pharmacy {
        id
        name
      }
      alerts {
        label
        text
      }
    }
  }
`, $re = Ge`
  query GetPrescription($id: ID!) {
    prescription(id: $id) {
      id
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
    }
  }
`;
Ge`
  query TemplatesFromCatalogs {
    catalogs {
      templates {
        id
        daysSupply
        dispenseAsWritten
        dispenseQuantity
        dispenseUnit
        instructions
        notes
        fillsAllowed
        treatment {
          id
          name
        }
      }
    }
  }
`;
Ge`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      preferredPharmacyId
      benefits {
        id
        bin
        groupId
        memberId
        pcn
      }
    }
  }
`;
const I3 = Ge`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      preferredPharmacies {
        id
        name
        address {
          street1
          city
          state
        }
      }
      address {
        street1
        street2
        city
        state
        postalCode
      }
    }
  }
`, E_ = Ge`
  query GetPharmacies($location: LatLongSearch!) {
    pharmacies(location: $location) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`, kre = Ge`
  query GetMailOrderPharmacies(
    $name: String
    $fulfillmentType: FulfillmentType
    $integrated: Boolean
    $limit: Int
    $offset: Int
  ) {
    pharmacies(
      name: $name
      fulfillmentType: $fulfillmentType
      integrated: $integrated
      limit: $limit
      offset: $offset
    ) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`, P3 = Gr(), Dm = (e, t) => ({
  externalId: e.externalId,
  patientId: t,
  treatmentId: e.treatment?.id,
  dispenseAsWritten: e.dispenseAsWritten,
  dispenseQuantity: e.dispenseQuantity,
  dispenseUnit: e.dispenseUnit,
  fillsAllowed: e.fillsAllowed,
  daysSupply: e.daysSupply,
  instructions: e.instructions,
  notes: e.notes,
  doNotFillBeforeDate: e.doNotFillBeforeDate,
  diagnoses: e.diagnoseCodes
});
function _re(e, t) {
  return t.some((r) => r.treatment.id === e);
}
const xre = async ({
  client: e,
  props: t
}) => {
  let r = [];
  if (t.templateIdsPrefill.length > 0) {
    const n = Array.from(new Set(t.templateIdsPrefill)).map((i) => ({
      ...t.templateOverrides?.[i],
      patientId: t.patientId,
      templateId: i
    }));
    r = r.concat(n);
  }
  if (t.prescriptionIdsPrefill.length > 0) {
    const n = await Promise.all(t.prescriptionIdsPrefill.map(async (i) => {
      const {
        data: a
      } = await e.apollo.query({
        query: $re,
        variables: {
          id: i
        }
      });
      return Dm(a?.prescription, t.patientId);
    }));
    r = r.concat(n);
  }
  return r.length ? (await e.apollo.mutate({
    mutation: yre,
    variables: {
      prescriptions: r
    }
  })).data.createPrescriptions : void 0;
}, Sre = (e) => {
  const {
    dispatchDraftPrescriptionCreated: t,
    dispatchAnalyticsTrackEvent: r
  } = Ma(), [, n] = Pd(), i = Kn(), [a, o] = V(!1), [s, l] = V(!1), [d, c] = V([]), u = K(() => d().map((y) => y.id));
  fe(async () => {
    if (
      // must have templateIds or prescriptionIds to create prescriptions
      (e.templateIdsPrefill.length > 0 || e.prescriptionIdsPrefill.length > 0) && e.patientId && // must not have created prescriptions yet
      !a()
    ) {
      o(!0), l(!0);
      try {
        const y = await xre({
          client: i,
          props: e
        });
        y && (c((v) => [...v, ...y]), y.forEach((v) => {
          t(v), r("ctaClicked", {
            name: "Draft Prescription Added",
            draftPrescriptionSource: "prefill",
            fields: o6(v)
          });
        }));
      } catch (y) {
        console.error("Error while trying to create prescriptions from prefill IDs", {
          error: y
        }), rr({
          status: "error",
          body: "There was an issue creating prescriptions from prefill IDs. Please check your configuration."
        });
      } finally {
        l(!1);
      }
    }
  });
  const h = async (y, v = {
    showSuccessToast: !0
  }, b = "form") => {
    if (_re(y.treatment.id, d()))
      throw rr({
        status: "error",
        body: "You already have this prescription in your order. You can modify the prescription or delete it in Pending Order."
      }), new Error("Prescription already added");
    const $ = n.checkDuplicateFill(y.treatment.name);
    return e.enableCombineAndDuplicate && $ && await new Promise((_, x) => {
      n.setIsDuplicateDialogOpen(!0, $, _, x);
    }), await f(y, v, b);
  }, f = async (y, v = {
    addToTemplates: !1,
    showSuccessToast: !0
  }, b = "form") => {
    let $ = null;
    try {
      const _ = (await i.apollo.mutate({
        mutation: vre,
        variables: Dm(y, e.patientId)
      })).data.createPrescription;
      $ = _, c((x) => [...x, _]), t(_), r("ctaClicked", {
        name: "Draft Prescription Added",
        draftPrescriptionSource: b,
        fields: o6(y, {
          addToTemplates: v?.addToTemplates,
          templateName: v?.templateName
        })
      });
    } catch (_) {
      console.error("Mutation error:", _);
      const x = _.message;
      throw rr({
        status: "error",
        header: "Error Adding Prescription",
        body: x.includes("controlled substance") ? x : "There was an issue adding the prescription. Please try again."
      }), _;
    }
    return v?.addToTemplates && v?.catalogId != null && (await p(y, v.catalogId, v.templateName), v.showSuccessToast && rr({
      status: "success",
      header: "Personal Template Saved"
    })), v.showSuccessToast && rr({
      status: "success",
      header: "Prescription Added",
      body: "You can send this order or add another prescription before sending it"
    }), $;
  }, p = async (y, v, b = "") => await i.apollo.mutate({
    mutation: gre,
    variables: {
      ...Dm(y, e.patientId),
      catalogId: v,
      isPrivate: !0,
      ...b ? {
        name: b
      } : {}
    }
  }), m = {
    // values
    draftPrescriptions: d,
    prescriptionIds: u,
    isLoadingPrefills: s,
    // actions
    setDraftPrescriptions: c,
    tryCreatePrescription: h,
    tryUpdatePrescriptionStates: async (y, v) => {
      try {
        return (await i.apolloClinical.mutate({
          mutation: bre,
          variables: {
            input: {
              ids: y,
              state: v
            }
          }
        })).data.updatePrescriptionStates;
      } catch (b) {
        throw console.error("Mutation error:", b), rr({
          status: "error",
          header: "Error Saving Prescription(s)",
          body: b.message
        }), b;
      }
    },
    deletePrescription: (y) => {
      c((v) => v.filter((b) => b.id !== y));
    }
  };
  return g(P3.Provider, {
    value: m,
    get children() {
      return e.children;
    }
  });
}, Vs = () => {
  const e = wr(P3);
  if (!e)
    throw new Error("can't find DraftPrescriptionsContext");
  return e;
}, Cre = () => wr(P3), vh = async (e, t) => {
  if (typeof e != "string" && (!e.latitude || !e.longitude))
    return [];
  const r = await t.geocode({
    ...typeof e == "string" ? { address: e } : { location: { lat: e.latitude, lng: e.longitude } }
  });
  return r?.results?.length ? r.results.map(() => ({
    latitude: r.results[0].geometry.location.lat(),
    longitude: r.results[0].geometry.location.lng(),
    address: r.results[0].formatted_address
  })) : [];
}, A_ = Gr(), Ere = (e) => {
  const {
    draftPrescriptions: t
  } = Vs(), {
    googleMapsServices: r
  } = u3(), n = Kn(), [i, a] = V(), [o, s] = V(), [l, d] = V(!1), c = K(() => t().map((S) => eX(S))), u = K(() => n6(c())), h = K(() => {
    const S = n6(c(), ["exclude"]);
    return new Set(S.constraint_pharmacies?.map((A) => A.id) || []);
  });
  async function f(S) {
    const {
      data: A
    } = await n.apollo.query({
      query: E_,
      variables: {
        location: {
          latitude: S?.latitude,
          longitude: S?.longitude
        }
      }
    });
    return A?.pharmacies ? A.pharmacies : [];
  }
  async function p(S) {
    const {
      geocoder: A
    } = r();
    if (!A) throw new Error("Geocoder not loaded");
    const N = `${S?.street1}, ${S?.city}, ${S?.state} ${S?.postalCode}`, P = await vh(N, A);
    return await f(P[0]);
  }
  const m = K(() => {
    if (e.pharmacyIdProp)
      return e.pharmacyIdProp;
    if (u()?.routing_constraint_type === "include" && u()?.constraint_pharmacies?.length === 1)
      return u().constraint_pharmacies?.[0].id;
  }), y = K(() => !!m()), v = K(() => e.enableLocalPickup || !e.enableSendToPatient && !e.mailOrderIds), b = K(() => e.enableSendToPatient ?? !1), $ = K(() => e.enableDeliveryPharmacies ?? !1), _ = K(() => e.mailOrderIds ? e.mailOrderIds.split(",") : void 0);
  fe(() => {
    e.onFulfillmentTypeChange?.(o());
  }), fe(() => {
    e.onPreferredPharmacyChange?.(l());
  });
  const x = {
    pharmacyId: i,
    fulfillmentType: o,
    updatePreferredPharmacy: l,
    autoRoutedPharmacyId: m,
    isAutoRouted: y,
    routingConstraints: c,
    combinedRoutingConstraint: u,
    unroutablePharmacyIds: h,
    enableLocalPickup: v,
    enableSendToPatient: b,
    enableDeliveryPharmacies: $,
    mailOrderPharmacyIds: _,
    setPharmacyId: a,
    setFulfillmentType: s,
    setUpdatePreferredPharmacy: d,
    fetchLocalPharmacies: p
  };
  return g(A_.Provider, {
    value: x,
    get children() {
      return e.children;
    }
  });
}, yf = () => {
  const e = wr(A_);
  if (!e)
    throw new Error("usePharmacySelection must be used within PharmacySelectionProvider");
  return e;
}, T_ = Gr(), Are = (e) => {
  const {
    draftPrescriptions: t,
    setDraftPrescriptions: r
  } = Vs(), n = yf(), i = Kn(), [a, o] = V([]), [s, l] = V(null), [d, c] = V(null), [u, h] = V(null), [f, p] = V(!1), [m, y] = V();
  fe(() => {
    e.patientId && v(e.patientId).then(({
      pharmacies: _,
      address: x
    }) => {
      _.length > 0 && l(_[0].id), x && h(x);
    });
  }), fe(() => {
    e.patientId && e.patientId !== d() ? (r([]), y(void 0), p(!1), o([]), c(e.patientId)) : !e.patientId && d() !== null && (r([]), y(void 0), p(!1), o([]), c(null));
  }), fe(() => {
    const _ = s(), x = t();
    if (!f() && // after an alternate is chosen, stop fetching coverages for this patient
    e.enableCoverageCheck && x.length > 0)
      if (_)
        b(x, _).then((S) => {
          o(S);
        });
      else {
        const S = u();
        S && n.fetchLocalPharmacies(S).then((A) => {
          let N = null;
          N = A.find((P) => P.name.toLowerCase().includes("cvs") || P.name.toLowerCase().includes("walgreens") || P.name.toLowerCase().includes("walmart") || P.name.toLowerCase().includes("rite aid"))?.id || A[0]?.id, N && b(x, N).then((P) => {
            o(P);
          });
        });
      }
  });
  const v = async (_) => {
    try {
      const x = await i.apollo.query({
        query: I3,
        variables: {
          id: _
        }
      });
      return {
        pharmacies: x.data.patient.preferredPharmacies,
        address: x.data.patient.address
      };
    } catch (x) {
      throw rr({
        status: "error",
        header: "Error Looking Up Patient Pharmacy",
        body: x.message
      }), x;
    }
  }, b = async (_, x) => (await i.apolloClinical.mutate({
    mutation: wre,
    variables: {
      pharmacyId: x,
      prescriptions: _.map((S) => ({
        id: S.id
        // icd10codes: ['gotta get this']
      }))
    }
  })).data.generateCoverageOptions, $ = {
    // values
    coverageOptions: a,
    selectedCoverageOption: m,
    // actions
    selectOtherCoverageOption: (_) => {
      y(_), p(!0), n.setPharmacyId(_.pharmacy.id);
    }
  };
  return g(T_.Provider, {
    value: $,
    get children() {
      return e.children;
    }
  });
}, bf = () => {
  const e = wr(T_);
  if (!e)
    throw new Error("usePrescribe must be used within the PrescribeProvider");
  return e;
};
var Tre = /* @__PURE__ */ k("<div><span class=font-semibold></span> interaction with "), Ore = /* @__PURE__ */ k("<span class=font-semibold>"), Ire = /* @__PURE__ */ k('<div class="text-sm text-gray-700">'), Pre = /* @__PURE__ */ k("<div>"), Nre = /* @__PURE__ */ k('<div class="flex grid-flow-col justify-start"><div class="flex flex-col gap-2"><div class=text-sm> ');
const Dre = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), Mre = {
  MINOR: "info",
  MODERATE: "warning",
  MAJOR: "error"
}, Rre = (e, t) => t === "ALLERGEN" ? "error" : Mre[e] ?? "info", Lre = {
  PrescriptionScreeningAlertInvolvedDraftedPrescription: "(Pending Rx)",
  PrescriptionScreeningAlertInvolvedExistingPrescription: "(Existing Rx)",
  PrescriptionScreeningAlertInvolvedAllergen: "(Allergen)"
}, F6 = (e, t) => e.filter((r) => r.id !== t), Fre = (e) => Lre[e] ?? "", j6 = () => Yt("text-pretty mr-2 text-black text-base", {}), jre = (e) => g(H, {
  get when() {
    return e.screeningAlert.type === "DRUG";
  },
  get fallback() {
    return g(Ee, {
      bold: !0,
      get class() {
        return j6();
      },
      children: "Allergy found"
    });
  },
  get children() {
    var t = Tre(), r = t.firstChild;
    return r.nextSibling, E(r, () => Dre(e.screeningAlert.severity)), E(t, g(yt, {
      get each() {
        return F6(e.screeningAlert.involvedEntities, e.owningId);
      },
      children: (n, i) => [(() => {
        var a = Ore();
        return E(a, () => n.name), a;
      })(), " ", Ut(() => Fre(n.__typename)), Ut(() => i() < F6(e.screeningAlert.involvedEntities, e.owningId).length - 1 && " and ")]
    }), null), se(() => ft(t, j6())), t;
  }
}), zre = (e) => {
  const [t, r] = V(), [n, i] = V(!1), a = () => {
    i(!n());
  };
  return fe(() => {
    r(e.screeningAlert.type === "ALLERGEN");
  }), g(No, {
    iconName: "exclamationTriangle",
    get status() {
      return Rre(e.screeningAlert.severity, e.screeningAlert.type);
    },
    withBorder: !0,
    get children() {
      var o = Nre(), s = o.firstChild, l = s.firstChild;
      return l.firstChild, E(l, () => jre(e), null), E(s, g(H, {
        get when() {
          return n() || t();
        },
        get children() {
          var d = Ire();
          return E(d, () => e.screeningAlert.description), d;
        }
      }), null), E(s, g(H, {
        get when() {
          return !t();
        },
        get children() {
          var d = Pre();
          return d.$$click = () => {
            a();
          }, E(d, g(Ee, {
            bold: !0,
            class: "text-blue-600 cursor-pointer",
            size: "xs",
            get children() {
              return ["See ", Ut(() => n() ? "less" : "more")];
            }
          })), d;
        }
      }), null), o;
    }
  });
};
an(["click"]);
var Vre = /* @__PURE__ */ k('<div class="grid gap-4">');
const O_ = (e) => g(H, {
  get when() {
    return e.screeningAlerts.length > 0;
  },
  get children() {
    var t = Vre();
    return E(t, g(yt, {
      get each() {
        return e.screeningAlerts;
      },
      children: (r) => g(zre, {
        screeningAlert: r,
        get owningId() {
          return e.owningId;
        }
      })
    })), t;
  }
});
var Ure = /* @__PURE__ */ k('<div class="flex grid-flow-col justify-start"><div class="flex flex-col gap-2">'), qre = /* @__PURE__ */ k('<div class="text-sm text-gray-700"> interaction with <!> '), Bre = /* @__PURE__ */ k('<div class="text-sm text-gray-700">');
const Hre = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), Wre = {
  PrescriptionScreeningAlertInvolvedDraftedPrescription: "(Pending Rx)",
  PrescriptionScreeningAlertInvolvedExistingPrescription: "(Existing Rx)",
  PrescriptionScreeningAlertInvolvedAllergen: "(Allergen)"
}, Qre = (e) => Wre[e] ?? "", ip = (e) => e === "PrescriptionScreeningAlertInvolvedAllergen";
function Kre(e) {
  const t = /* @__PURE__ */ new Set();
  return e.filter((r) => t.has(r.id) ? !1 : (t.add(r.id), !0));
}
const Gre = (e) => g(No, {
  withoutIcon: !0,
  withBorder: !0,
  status: "suggestion",
  get children() {
    var t = Ure(), r = t.firstChild;
    return E(r, g(H, {
      get when() {
        return !ip(e.screeningAlertByEntity.entity.__typename);
      },
      get children() {
        return [g(Ee, {
          bold: !0,
          get children() {
            return e.screeningAlertByEntity.entity.name;
          }
        }), g(yt, {
          get each() {
            return e.screeningAlertByEntity.alerts;
          },
          children: (n) => g(yt, {
            get each() {
              return Kre(n.involvedEntities);
            },
            children: (i) => [g(H, {
              get when() {
                return !ip(i.__typename);
              },
              get children() {
                return g(H, {
                  get when() {
                    return i.id != e.screeningAlertByEntity.entity.id;
                  },
                  get children() {
                    var a = qre(), o = a.firstChild, s = o.nextSibling;
                    return s.nextSibling, E(a, () => Hre(n.severity), o), E(a, () => i.name, s), E(a, () => Qre(i.__typename), null), a;
                  }
                });
              }
            }), g(H, {
              get when() {
                return ip(i.__typename);
              },
              get children() {
                return g(yt, {
                  get each() {
                    return e.otherAlertsByEntity.filter((a) => a.entity.id === i.id);
                  },
                  children: (a) => g(yt, {
                    get each() {
                      return a.alerts.filter((o) => o.type === "ALLERGEN");
                    },
                    children: (o) => (() => {
                      var s = Bre();
                      return E(s, () => o.description), s;
                    })()
                  })
                });
              }
            })]
          })
        })];
      }
    })), t;
  }
});
var Zre = /* @__PURE__ */ k('<div class="grid gap-4">');
function z6(e) {
  return Object.values(e.flatMap((t) => t.involvedEntities.map((r) => ({
    entity: r,
    alert: t
  }))).reduce((t, r) => {
    const n = r.entity.id;
    return t[n] || (t[n] = {
      entity: r.entity,
      alerts: []
    }), t[n].alerts.push(r.alert), t;
  }, {}));
}
const Yre = (e) => (() => {
  var t = Zre();
  return E(t, g(yt, {
    get each() {
      return z6(e.screeningAlerts).filter((r) => r.entity.__typename != "PrescriptionScreeningAlertInvolvedAllergen");
    },
    children: (r) => g(Gre, {
      screeningAlertByEntity: r,
      get otherAlertsByEntity() {
        return z6(e.screeningAlerts);
      }
    })
  })), t;
})();
var Jre = /* @__PURE__ */ k('<div class="grid gap-6"><div class="flex flex-col gap-6"><div><div class="table bg-blue-50 text-blue-600 p-2 rounded-full mb-4"></div></div></div><div class="flex flex-col items-stretch gap-2">');
function Xre(e) {
  const t = e.filter((i) => i.type === "ALLERGEN").length, r = e.filter((i) => i.type === "DRUG").length, n = [];
  return t === 1 ? n.push("a known allergy") : t > 1 && n.push("known allergies"), r === 1 ? n.push("a known interaction") : r > 1 && n.push("known interactions"), n.join(" and ");
}
function ene(e) {
  const [t, r] = V(!0);
  let n;
  function i() {
    In("prescribe-clinical-alerting-acknowledge-alerts", e.alerts.reduce((o, s, l) => (o[l] = s.description, o), {}), n), e.onIgnoreWarningAndCreateAnyway();
  }
  function a() {
    In("prescribe-clinical-alerting-revisit-prescriptions", e.alerts.reduce((o, s, l) => (o[l] = s.description, o), {}), n), e.onRevisitPrescriptions();
  }
  return g(zs, {
    get open() {
      return t();
    },
    onClose: () => {
      r(!1), e.onRevisitPrescriptions();
    },
    get children() {
      var o = Jre(), s = o.firstChild, l = s.firstChild, d = l.firstChild, c = s.nextSibling, u = n;
      return typeof u == "function" ? Pn(u, o) : n = o, E(d, g(mt, {
        name: "exclamationCircle"
      })), E(l, g(Ee, {
        bold: !0,
        get children() {
          return ["Are you sure you want to send prescriptions with ", Ut(() => Xre(e.alerts)), "?"];
        }
      }), null), E(o, g(Yre, {
        get screeningAlerts() {
          return e.alerts;
        }
      }), c), E(c, g(xt, {
        size: "xl",
        onClick: () => {
          r(!1), i();
        },
        children: "Send order"
      }), null), E(c, g(xt, {
        variant: "secondary",
        size: "xl",
        onClick: () => {
          r(!1), a();
        },
        children: "Cancel"
      }), null), o;
    }
  });
}
var tne = /* @__PURE__ */ k('<div class="flex flex-col md:flex-row justify-between md:items-center gap-4 md:gap-1 w-full"><div class="flex flex-col text-xs"><div class=font-bold></div><div></div></div><div class="text-xs text-left md:text-right whitespace-nowrap"><span>Est. Copay: </span><span class=font-bold>'), rne = /* @__PURE__ */ k("<div>Alerts"), nne = /* @__PURE__ */ k("<ul>"), ine = /* @__PURE__ */ k('<div class="flex flex-col gap-4"><div class="flex flex-col"><div class="text-xs text-gray-500"><span>Quantity / Days Supply: </span><span class=font-bold></span></div><div class="text-xs text-gray-500"><span>Pharmacy: </span><span class=font-bold>'), ane = /* @__PURE__ */ k('<div class="text-xs text-gray-500"><span>Instructions: </span><span>'), one = /* @__PURE__ */ k('<div class="text-xs text-gray-500"><span>Refills: </span><span>'), sne = /* @__PURE__ */ k("<li class=text-xs><span class=text-gray-600>: </span><span class=text-gray-500>");
function I_(e) {
  const t = K(() => e.coverageOption.paRequired ? {
    status: "warning",
    message: "PA Required"
  } : e.coverageOption.status === "COVERED" ? {
    status: "success",
    message: "Covered by Insurance"
  } : e.coverageOption.status === "COVERED_WITH_RESTRICTIONS" ? {
    status: "warning",
    message: "Covered with Restrictions",
    subMessage: e.coverageOption.statusMessage
  } : {
    status: "error",
    message: "Not Covered by Insurance",
    subMessage: e.coverageOption.statusMessage
  }), r = K(() => e.coverageOption.alerts.filter((n) => n.text !== e.coverageOption.statusMessage));
  return (() => {
    var n = ine(), i = n.firstChild, a = i.firstChild, o = a.firstChild, s = o.nextSibling, l = a.nextSibling, d = l.firstChild, c = d.nextSibling;
    return E(s, () => `${e.coverageOption.dispenseQuantity} ${e.coverageOption.dispenseUnit} / ${e.coverageOption.daysSupply}`), E(i, g(H, {
      get when() {
        return e.prescription;
      },
      children: (u) => [(() => {
        var h = ane(), f = h.firstChild, p = f.nextSibling;
        return E(p, () => u().instructions), h;
      })(), (() => {
        var h = one(), f = h.firstChild, p = f.nextSibling;
        return E(p, () => __(u().fillsAllowed)), h;
      })()]
    }), l), E(c, () => e.coverageOption.pharmacy.name), E(n, g(No, {
      get status() {
        return t().status;
      },
      withoutIcon: !0,
      get children() {
        var u = tne(), h = u.firstChild, f = h.firstChild, p = f.nextSibling, m = h.nextSibling, y = m.firstChild, v = y.nextSibling;
        return E(f, () => t().message), E(p, () => t().subMessage), E(v, () => lne(e.coverageOption.price)), u;
      }
    }), null), E(n, g(H, {
      get when() {
        return r().length > 0;
      },
      get children() {
        return [rne(), (() => {
          var u = nne();
          return E(u, g(yt, {
            get each() {
              return r();
            },
            children: (h) => (() => {
              var f = sne(), p = f.firstChild, m = p.firstChild, y = p.nextSibling;
              return E(p, () => h.label, m), E(y, () => h.text), f;
            })()
          })), u;
        })()];
      }
    }), null), n;
  })();
}
function lne(e) {
  return e ? `$${e.toFixed(0)}` : "N/A";
}
var dne = /* @__PURE__ */ k("<div>Other Options"), cne = /* @__PURE__ */ k('<div class="flex flex-col gap-2"><div class="flex flex-col gap-2"><div class="flex flex-col gap-2"><div class=text-sm></div></div></div><div class="flex justify-end mt-2">');
function une(e) {
  return [dne(), g(yt, {
    get each() {
      return e.coverageOptions;
    },
    children: (t) => g(hne, {
      coverageOption: t,
      get handleSwapToOtherPrescription() {
        return e.handleSwapToOtherPrescription;
      }
    })
  })];
}
function hne(e) {
  const t = async () => {
    e.handleSwapToOtherPrescription(e.coverageOption);
  };
  return g(Mn, {
    class: "mb-1",
    get children() {
      var r = cne(), n = r.firstChild, i = n.firstChild, a = i.firstChild, o = n.nextSibling;
      return E(a, () => e.coverageOption.treatment.name), E(i, g(I_, {
        get coverageOption() {
          return e.coverageOption;
        }
      }), null), E(o, g(xt, {
        size: "sm",
        variant: "naked",
        "on:click": t,
        children: "Select This Option"
      })), r;
    }
  });
}
function fne(e, t) {
  return {
    id: e.id,
    doNotFillBeforeDate: e.doNotFillBeforeDate,
    dispenseAsWritten: e.dispenseAsWritten || !1,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply || 0,
    instructions: e.instructions,
    notes: e.notes || "",
    fillsAllowed: e.fillsAllowed,
    diagnoseCodes: [],
    catalogId: t,
    externalId: e.externalId || void 0,
    treatment: {
      id: e.treatment.id,
      name: e.treatment.name
    }
  };
}
var pne = /* @__PURE__ */ k("<button title=Edit>"), mne = /* @__PURE__ */ k("<button title=Delete>"), gne = /* @__PURE__ */ k('<div class="flex flex-col gap-4"><div class="flex justify-between items-center gap-4"><div class="flex flex-col items-start">'), vne = /* @__PURE__ */ k('<div class="flex items-start gap-3"> ');
function yne(e) {
  const t = K(() => e.screeningAlerts.filter((a) => a.involvedEntities.map((o) => o.id).indexOf(e.draft.treatment.id) >= 0)), r = K(() => e.routingConstraint && sX({
    prescription: e.draft,
    routingConstraint: e.routingConstraint
  })), n = K(() => e.coverageOptions.find((a) => !a.isAlternative)), i = K(() => e.coverageOptions.filter((a) => a.isAlternative));
  return g(P_, {
    get LeftChildren() {
      return [g(Ee, {
        get children() {
          return e.draft.treatment.name;
        }
      }), g(H, {
        get when() {
          return n() === void 0;
        },
        get children() {
          return g(Ee, {
            color: "gray",
            size: "sm",
            get children() {
              return sd({
                // need to use nullish coalescing here because draft types are eg `Maybe<number> | undefined`
                dispenseQuantity: e.draft?.dispenseQuantity ?? void 0,
                dispenseUnit: e.draft?.dispenseUnit ?? void 0,
                fillsAllowed: e.draft?.fillsAllowed ?? void 0,
                instructions: e.draft?.instructions ?? void 0
              });
            }
          });
        }
      })];
    },
    get RightChildren() {
      return [(() => {
        var a = pne();
        return a.$$click = () => e.handleEdit && e.handleEdit(fne(e.draft)), E(a, g(mt, {
          name: "pencilSquare",
          size: "sm",
          class: "text-gray-500 hover:text-amber-500"
        })), a;
      })(), (() => {
        var a = mne();
        return a.$$click = () => e.handleDelete && e.handleDelete(e.draft.id), E(a, g(mt, {
          name: "trash",
          size: "sm",
          class: "text-gray-500 hover:text-red-500"
        })), a;
      })()];
    },
    get BottomChildren() {
      return [g(H, {
        get when() {
          return t().length > 0;
        },
        get children() {
          return g(O_, {
            get screeningAlerts() {
              return t();
            },
            get owningId() {
              return e.draft.treatment.id;
            }
          });
        }
      }), g(H, {
        get when() {
          return r();
        },
        get children() {
          return r();
        }
      }), g(H, {
        get when() {
          return n();
        },
        children: (a) => g(I_, {
          get coverageOption() {
            return a();
          },
          get prescription() {
            return e.draft;
          }
        })
      }), g(H, {
        get when() {
          return i().length > 0;
        },
        get children() {
          return g(une, {
            get coverageOptions() {
              return i();
            },
            get handleSwapToOtherPrescription() {
              return e.handleSwapToOtherPrescription;
            }
          });
        }
      })];
    }
  });
}
const P_ = (e) => (() => {
  var t = gne(), r = t.firstChild, n = r.firstChild;
  return E(n, () => e.LeftChildren), E(r, g(H, {
    get when() {
      return e?.RightChildren;
    },
    children: (i) => (() => {
      var a = vne();
      return a.firstChild, E(a, i, null), a;
    })()
  }), null), E(t, g(H, {
    get when() {
      return e?.BottomChildren;
    },
    children: (i) => i()
  }), null), t;
})();
an(["click"]);
var bne = /* @__PURE__ */ k('<div><div aria-hidden=true class="absolute inset-0 flex items-center"><div class="w-full border-t border-gray-300">');
function wne(e) {
  const t = K(() => Yt("relative", e.class));
  return (() => {
    var r = bne();
    return se(() => ft(r, t())), r;
  })();
}
var $ne = /* @__PURE__ */ k('<div class="flex flex-col gap-4">'), kne = /* @__PURE__ */ k("<div class=space-y-3>");
function _ne(e) {
  const {
    isLoadingPrefills: t,
    draftPrescriptions: r,
    prescriptionIds: n
  } = Vs(), {
    coverageOptions: i
  } = bf(), a = K(() => tX(e.routingConstraints));
  return (() => {
    var o = kne();
    return E(o, g(H, {
      get when() {
        return t();
      },
      get children() {
        return g(yt, {
          get each() {
            return n();
          },
          children: () => g(P_, {
            get LeftChildren() {
              return [g(Ee, {
                size: "lg",
                sampleLoadingText: "Medication 100mg",
                loading: !0
              }), g(Ee, {
                size: "sm",
                sampleLoadingText: "Loading notes about the medication",
                loading: !0
              })];
            }
          })
        });
      }
    }), null), E(o, g(H, {
      get when() {
        return Ut(() => !t())() && n().length === 0;
      },
      get children() {
        return g(No, {
          status: "info",
          get children() {
            return e.enableOrder ? "Add prescription(s) before sending" : "Add prescription(s) before saving";
          }
        });
      }
    }), null), E(o, g(H, {
      get when() {
        return Ut(() => !t())() && r().length > 0;
      },
      get children() {
        var s = $ne();
        return E(s, g(yt, {
          get each() {
            return r();
          },
          children: (l, d) => [g(H, {
            get when() {
              return d() > 0;
            },
            get children() {
              return g(wne, {});
            }
          }), g(yne, {
            get screeningAlerts() {
              return e.screeningAlerts;
            },
            get routingConstraint() {
              return a().get(l.id);
            },
            draft: l,
            get coverageOptions() {
              return i().filter((c) => c.prescriptionId === l.id);
            },
            get handleEdit() {
              return e.handleEdit;
            },
            get handleDelete() {
              return e.handleDelete;
            },
            get handleSwapToOtherPrescription() {
              return e.handleSwapToOtherPrescription;
            }
          })]
        })), s;
      }
    }), null), o;
  })();
}
var zl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xne(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var N3 = { exports: {} }, N_ = { exports: {} };
(function(e) {
  (function() {
    var t = this || self;
    function r(w, C) {
      function O() {
      }
      O.prototype = C.prototype, w.Ba = C.prototype, w.prototype = new O(), w.prototype.constructor = w, w.Ha = function(U, B, ee) {
        for (var ve = Array(arguments.length - 2), vt = 2; vt < arguments.length; vt++) ve[vt - 2] = arguments[vt];
        return C.prototype[B].apply(U, ve);
      };
    }
    function n(w) {
      var C = [];
      let O = 0;
      for (var U in w) C[O++] = w[U];
      return C;
    }
    function i(w, C) {
      for (this.h = w, this.g = {}, w = 0; w < C.length; w++) {
        var O = C[w];
        this.g[O.g] = O;
      }
    }
    function a(w) {
      return w = n(w.g), w.sort(function(C, O) {
        return C.g - O.g;
      }), w;
    }
    function o(w, C) {
      switch (this.g = w, this.m = !!C.ga, this.h = C.i, this.u = C.type, this.s = !1, this.h) {
        case d:
        case c:
        case u:
        case h:
        case f:
        case l:
        case s:
          this.s = !0;
      }
      this.j = C.defaultValue;
    }
    var s = 1, l = 2, d = 3, c = 4, u = 6, h = 16, f = 18;
    function p() {
      this.h = {}, this.j = this.o().g, this.g = this.m = null;
    }
    p.prototype.has = function(w) {
      return y(this, w.g);
    }, p.prototype.get = function(w, C) {
      return b(this, w.g, C);
    }, p.prototype.set = function(w, C) {
      S(this, w.g, C);
    }, p.prototype.add = function(w, C) {
      A(this, w.g, C);
    };
    function m(w, C) {
      for (var O = a(w.o()), U = 0; U < O.length; U++) {
        var B = O[U], ee = B.g;
        if (y(C, ee)) {
          w.g && delete w.g[B.g];
          var ve = B.h == 11 || B.h == 10;
          if (B.m) {
            B = _(C, ee);
            for (var vt = 0; vt < B.length; vt++) A(w, ee, ve ? B[vt].clone() : B[vt]);
          } else B = v(C, ee), ve ? (ve = v(w, ee)) ? m(ve, B) : S(w, ee, B.clone()) : S(w, ee, B);
        }
      }
    }
    p.prototype.clone = function() {
      var w = new this.constructor();
      return w != this && (w.h = {}, w.g && (w.g = {}), m(w, this)), w;
    };
    function y(w, C) {
      return w.h[C] != null;
    }
    function v(w, C) {
      var O = w.h[C];
      if (O == null) return null;
      if (w.m) {
        if (!(C in w.g)) {
          var U = w.m, B = w.j[C];
          if (O != null) if (B.m) {
            for (var ee = [], ve = 0; ve < O.length; ve++) ee[ve] = U.h(B, O[ve]);
            O = ee;
          } else O = U.h(B, O);
          return w.g[C] = O;
        }
        return w.g[C];
      }
      return O;
    }
    function b(w, C, O) {
      var U = v(w, C);
      return w.j[C].m ? U[O || 0] : U;
    }
    function $(w, C) {
      if (y(w, C)) w = b(w, C);
      else e: {
        if (w = w.j[C], w.j === void 0) if (C = w.u, C === Boolean) w.j = !1;
        else if (C === Number) w.j = 0;
        else if (C === String) w.j = w.s ? "0" : "";
        else {
          w = new C();
          break e;
        }
        w = w.j;
      }
      return w;
    }
    function _(w, C) {
      return v(w, C) || [];
    }
    function x(w, C) {
      return w.j[C].m ? y(w, C) ? w.h[C].length : 0 : y(w, C) ? 1 : 0;
    }
    function S(w, C, O) {
      w.h[C] = O, w.g && (w.g[C] = O);
    }
    function A(w, C, O) {
      w.h[C] || (w.h[C] = []), w.h[C].push(O), w.g && delete w.g[C];
    }
    function N(w, C) {
      var O = [], U;
      for (U in C) U != 0 && O.push(new o(U, C[U]));
      return new i(w, O);
    }
    function P() {
    }
    P.prototype.g = function(w) {
      throw new w.h(), Error("Unimplemented");
    }, P.prototype.h = function(w, C) {
      if (w.h == 11 || w.h == 10) return C instanceof p ? C : this.g(w.u.prototype.o(), C);
      if (w.h == 14) return typeof C == "string" && D.test(C) && (w = Number(C), 0 < w) ? w : C;
      if (!w.s) return C;
      if (w = w.u, w === String) {
        if (typeof C == "number") return String(C);
      } else if (w === Number && typeof C == "string" && (C === "Infinity" || C === "-Infinity" || C === "NaN" || D.test(C))) return Number(C);
      return C;
    };
    var D = /^-?[0-9]+$/;
    function T() {
    }
    r(T, P), T.prototype.g = function(w, C) {
      return w = new w.h(), w.m = this, w.h = C, w.g = {}, w;
    };
    function I() {
    }
    r(I, T), I.prototype.h = function(w, C) {
      return w.h == 8 ? !!C : P.prototype.h.apply(this, arguments);
    }, I.prototype.g = function(w, C) {
      return I.Ba.g.call(this, w, C);
    };
    function j(w, C) {
      w != null && this.g.apply(this, arguments);
    }
    j.prototype.h = "", j.prototype.set = function(w) {
      this.h = "" + w;
    }, j.prototype.g = function(w, C, O) {
      if (this.h += String(w), C != null) for (let U = 1; U < arguments.length; U++) this.h += arguments[U];
      return this;
    };
    function F(w) {
      w.h = "";
    }
    j.prototype.toString = function() {
      return this.h;
    };
    function Z() {
      p.call(this);
    }
    r(Z, p);
    var te = null;
    function Y() {
      p.call(this);
    }
    r(Y, p);
    var Q = null;
    function R() {
      p.call(this);
    }
    r(R, p);
    var re = null;
    R.prototype.ia = function() {
      return b(this, 10);
    }, Z.prototype.o = function() {
      var w = te;
      return w || (te = w = N(Z, { 0: { name: "NumberFormat", na: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, i: 9, type: String }, 2: { name: "format", required: !0, i: 9, type: String }, 3: { name: "leading_digits_pattern", ga: !0, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } })), w;
    }, Z.o = Z.prototype.o, Y.prototype.o = function() {
      var w = Q;
      return w || (Q = w = N(Y, { 0: { name: "PhoneNumberDesc", na: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", ga: !0, i: 5, type: Number }, 10: { name: "possible_length_local_only", ga: !0, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } })), w;
    }, Y.o = Y.prototype.o, R.prototype.o = function() {
      var w = re;
      return w || (re = w = N(R, {
        0: { name: "PhoneMetadata", na: "i18n.phonenumbers.PhoneMetadata" },
        1: { name: "general_desc", i: 11, type: Y },
        2: { name: "fixed_line", i: 11, type: Y },
        3: { name: "mobile", i: 11, type: Y },
        4: { name: "toll_free", i: 11, type: Y },
        5: { name: "premium_rate", i: 11, type: Y },
        6: { name: "shared_cost", i: 11, type: Y },
        7: { name: "personal_number", i: 11, type: Y },
        8: { name: "voip", i: 11, type: Y },
        21: { name: "pager", i: 11, type: Y },
        25: { name: "uan", i: 11, type: Y },
        27: { name: "emergency", i: 11, type: Y },
        28: { name: "voicemail", i: 11, type: Y },
        29: { name: "short_code", i: 11, type: Y },
        30: { name: "standard_rate", i: 11, type: Y },
        31: { name: "carrier_specific", i: 11, type: Y },
        33: { name: "sms_services", i: 11, type: Y },
        24: { name: "no_international_dialling", i: 11, type: Y },
        9: { name: "id", required: !0, i: 9, type: String },
        10: { name: "country_code", i: 5, type: Number },
        11: { name: "international_prefix", i: 9, type: String },
        17: { name: "preferred_international_prefix", i: 9, type: String },
        12: { name: "national_prefix", i: 9, type: String },
        13: { name: "preferred_extn_prefix", i: 9, type: String },
        15: {
          name: "national_prefix_for_parsing",
          i: 9,
          type: String
        },
        16: { name: "national_prefix_transform_rule", i: 9, type: String },
        18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: !1, type: Boolean },
        19: { name: "number_format", ga: !0, i: 11, type: Z },
        20: { name: "intl_number_format", ga: !0, i: 11, type: Z },
        22: { name: "main_country_for_code", i: 8, defaultValue: !1, type: Boolean },
        23: { name: "leading_digits", i: 9, type: String }
      })), w;
    }, R.o = R.prototype.o;
    function he() {
      p.call(this);
    }
    r(he, p);
    var ge = null;
    he.prototype.ia = function() {
      return b(this, 1);
    };
    var ce = { Ga: 0, Fa: 1, Ea: 5, Da: 10, Ca: 20 };
    he.prototype.o = function() {
      var w = ge;
      return w || (ge = w = N(he, { 0: { name: "PhoneNumber", na: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: !0, i: 5, type: Number }, 2: { name: "national_number", required: !0, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: ce }, 7: {
        name: "preferred_domestic_carrier_code",
        i: 9,
        type: String
      } })), w;
    }, he.ctor = he, he.ctor.o = he.prototype.o;
    var W = {
      1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
      7: ["RU", "KZ"],
      20: ["EG"],
      27: ["ZA"],
      30: ["GR"],
      31: ["NL"],
      32: ["BE"],
      33: ["FR"],
      34: ["ES"],
      36: ["HU"],
      39: ["IT", "VA"],
      40: ["RO"],
      41: ["CH"],
      43: ["AT"],
      44: ["GB", "GG", "IM", "JE"],
      45: ["DK"],
      46: ["SE"],
      47: ["NO", "SJ"],
      48: ["PL"],
      49: ["DE"],
      51: ["PE"],
      52: ["MX"],
      53: ["CU"],
      54: ["AR"],
      55: ["BR"],
      56: ["CL"],
      57: ["CO"],
      58: ["VE"],
      60: ["MY"],
      61: ["AU", "CC", "CX"],
      62: ["ID"],
      63: ["PH"],
      64: ["NZ"],
      65: ["SG"],
      66: ["TH"],
      81: ["JP"],
      82: ["KR"],
      84: ["VN"],
      86: ["CN"],
      90: ["TR"],
      91: ["IN"],
      92: ["PK"],
      93: ["AF"],
      94: ["LK"],
      95: ["MM"],
      98: ["IR"],
      211: ["SS"],
      212: ["MA", "EH"],
      213: ["DZ"],
      216: ["TN"],
      218: ["LY"],
      220: ["GM"],
      221: ["SN"],
      222: ["MR"],
      223: ["ML"],
      224: ["GN"],
      225: ["CI"],
      226: ["BF"],
      227: ["NE"],
      228: ["TG"],
      229: ["BJ"],
      230: ["MU"],
      231: ["LR"],
      232: ["SL"],
      233: ["GH"],
      234: ["NG"],
      235: ["TD"],
      236: ["CF"],
      237: ["CM"],
      238: ["CV"],
      239: ["ST"],
      240: ["GQ"],
      241: ["GA"],
      242: ["CG"],
      243: ["CD"],
      244: ["AO"],
      245: ["GW"],
      246: ["IO"],
      247: ["AC"],
      248: ["SC"],
      249: ["SD"],
      250: ["RW"],
      251: ["ET"],
      252: ["SO"],
      253: ["DJ"],
      254: ["KE"],
      255: ["TZ"],
      256: ["UG"],
      257: ["BI"],
      258: ["MZ"],
      260: ["ZM"],
      261: ["MG"],
      262: ["RE", "YT"],
      263: ["ZW"],
      264: ["NA"],
      265: ["MW"],
      266: ["LS"],
      267: ["BW"],
      268: ["SZ"],
      269: ["KM"],
      290: ["SH", "TA"],
      291: ["ER"],
      297: ["AW"],
      298: ["FO"],
      299: ["GL"],
      350: ["GI"],
      351: ["PT"],
      352: ["LU"],
      353: ["IE"],
      354: ["IS"],
      355: ["AL"],
      356: ["MT"],
      357: ["CY"],
      358: ["FI", "AX"],
      359: ["BG"],
      370: ["LT"],
      371: ["LV"],
      372: ["EE"],
      373: ["MD"],
      374: ["AM"],
      375: ["BY"],
      376: ["AD"],
      377: ["MC"],
      378: ["SM"],
      380: ["UA"],
      381: ["RS"],
      382: ["ME"],
      383: ["XK"],
      385: ["HR"],
      386: ["SI"],
      387: ["BA"],
      389: ["MK"],
      420: ["CZ"],
      421: ["SK"],
      423: ["LI"],
      500: ["FK"],
      501: ["BZ"],
      502: ["GT"],
      503: ["SV"],
      504: ["HN"],
      505: ["NI"],
      506: ["CR"],
      507: ["PA"],
      508: ["PM"],
      509: ["HT"],
      590: ["GP", "BL", "MF"],
      591: ["BO"],
      592: ["GY"],
      593: ["EC"],
      594: ["GF"],
      595: ["PY"],
      596: ["MQ"],
      597: ["SR"],
      598: ["UY"],
      599: ["CW", "BQ"],
      670: ["TL"],
      672: ["NF"],
      673: ["BN"],
      674: ["NR"],
      675: ["PG"],
      676: ["TO"],
      677: ["SB"],
      678: ["VU"],
      679: ["FJ"],
      680: ["PW"],
      681: ["WF"],
      682: ["CK"],
      683: ["NU"],
      685: ["WS"],
      686: ["KI"],
      687: ["NC"],
      688: ["TV"],
      689: ["PF"],
      690: ["TK"],
      691: ["FM"],
      692: ["MH"],
      800: ["001"],
      808: ["001"],
      850: ["KP"],
      852: ["HK"],
      853: ["MO"],
      855: ["KH"],
      856: ["LA"],
      870: ["001"],
      878: ["001"],
      880: ["BD"],
      881: ["001"],
      882: ["001"],
      883: ["001"],
      886: ["TW"],
      888: ["001"],
      960: ["MV"],
      961: ["LB"],
      962: ["JO"],
      963: ["SY"],
      964: ["IQ"],
      965: ["KW"],
      966: ["SA"],
      967: ["YE"],
      968: ["OM"],
      970: ["PS"],
      971: ["AE"],
      972: ["IL"],
      973: ["BH"],
      974: ["QA"],
      975: ["BT"],
      976: ["MN"],
      977: ["NP"],
      979: ["001"],
      992: ["TJ"],
      993: ["TM"],
      994: ["AZ"],
      995: ["GE"],
      996: ["KG"],
      998: ["UZ"]
    }, oe = {
      AC: [, [
        ,
        ,
        "(?:[01589]\\d|[46])\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6]
      ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
      AD: [
        ,
        [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
        [, , "[78]\\d{5}", , , , "712345", , , [6]],
        [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
        [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
        [, , "[19]\\d{5}", , , , "912345", , , [6]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AD",
        376,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "1800\\d{4}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AE: [
        ,
        [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
        [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
        [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
        [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
        [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AE",
        971,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
        ,
        ,
        "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
        ,
        ,
        ,
        "234567890",
        ,
        ,
        ,
        [7]
      ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AG: [
        ,
        [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
          ,
          ,
          ,
          "2684601234",
          ,
          ,
          ,
          [7]
        ],
        [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
        "AG",
        1,
        "011",
        "1",
        ,
        ,
        "([457]\\d{6})$|1",
        "268$1",
        ,
        ,
        ,
        ,
        [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
        ,
        "268",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "900[1-9]\\d\\d",
        ,
        ,
        ,
        "900123",
        ,
        ,
        [6]
      ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AM: [, [
        ,
        ,
        "(?:[1-489]\\d|55|60|77)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8],
        [5, 6]
      ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["2|3[12]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AO: [
        ,
        [, , "[29]\\d{8}", , , , , , , [9]],
        [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
        [, , "9[1-59]\\d{7}", , , , "923123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AO",
        244,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AR: [
        ,
        [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
        [
          ,
          ,
          "3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "1123456789",
          ,
          ,
          [10],
          [6, 7, 8]
        ],
        [
          ,
          ,
          "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "91123456789",
          ,
          ,
          ,
          [6, 7, 8]
        ],
        [, , "800\\d{7,8}", , , , "8001234567"],
        [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AR",
        54,
        "00",
        "0",
        ,
        ,
        "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
        "9$1",
        ,
        ,
        [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{4})",
          "$1 $2-$3",
          [
            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
          ,
          "(\\d)(\\d{4})(\\d{2})(\\d{4})",
          "$2 15-$3-$4",
          [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1"
        ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
        [
          [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
          [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ]],
          [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
          [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
        ],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "810\\d{7}", , , , , , , [10]],
        [, , "810\\d{7}", , , , "8101234567", , , [10]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AT: [, [
        ,
        ,
        "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [3]
      ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
        ,
        ,
        "800\\d{6,10}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10, 11, 12, 13]
      ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
        [, "(\\d{4})", "$1", ["14"]],
        [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        [, "(\\d{6})", "$1", ["[18]"]],
        [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,10})",
        "$1 $2",
        ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AU: [
        ,
        [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "AU",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "(183[12])|0",
        ,
        "0011",
        ,
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
          ,
          "(\\d{4})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["130"]
        ]],
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
        [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
        1,
        ,
        [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AW: [, [
        ,
        ,
        "(?:[25-79]\\d\\d|800)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7]
      ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AX: [, [
        ,
        ,
        "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12]
      ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
        ,
        ,
        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
        ,
        ,
        ,
        "10112345"
      ], , , [, , , , , , , , , [-1]]],
      AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["90"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-9]"],
        "0$1"
      ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BA: [
        ,
        [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
        [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
        [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
        [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
        [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
        [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BA",
        387,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
        ,
        ,
        "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
        ,
        ,
        ,
        "2464301234",
        ,
        ,
        ,
        [7]
      ], , , [, , , , , , , , , [-1]]],
      BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
        ,
        ,
        ,
        "27111234"
      ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,7})",
        "$1-$2",
        ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
        ,
        ,
        "7879\\d{4}",
        ,
        ,
        ,
        "78791234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
      BF: [, [
        ,
        ,
        "[025-7]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BG: [
        ,
        [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
        [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
        [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
        [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
        [, , "90\\d{6}", , , , "90123456", , , [8]],
        [, , "700\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BG",
        359,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
        ,
        ,
        ,
        "17001234"
      ], [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}", , , , "36001234"], [, , "8[02369]\\d{6}", , , , "80123456"], [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
        ,
        ,
        "(?:29|[67][125-9])\\d{6}",
        ,
        ,
        ,
        "79561234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BJ: [
        ,
        [, , "[24-689]\\d{7}", , , , , , , [8]],
        [, , "2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
        [, , "(?:4[0-356]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "857[58]\\d{4}", , , , "85751234"],
        "BJ",
        229,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "81\\d{6}", , , , "81123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BL: [
        ,
        [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"],
        [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
        "BL",
        590,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|92)\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BN: [
        ,
        [, , "[2-578]\\d{6}", , , , , , , [7]],
        [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
        [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[34]\\d{5}", , , , "5345678"],
        "BN",
        673,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BO: [
        ,
        [, , "(?:[2-467]\\d\\d|8001)\\d{5}", , , , , , , [8, 9], [7]],
        [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]],
        [, , "[67]\\d{7}", , , , "71234567", , , [8]],
        [, , "8001[07]\\d{4}", , , , "800171234", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BO",
        591,
        "00(?:1\\d)?",
        "0",
        ,
        ,
        "0(1\\d)?",
        ,
        ,
        ,
        [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "8001[07]\\d{4}", , , , , , , [9]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
        ,
        ,
        "800\\d{6,7}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10]
      ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{4})(\\d{4})",
        "$1-$2",
        ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{3})(\\d{2,3})(\\d{4})",
        "$1 $2 $3",
        ["(?:[358]|90)0"],
        "0$1"
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
        ,
        ,
        ,
        "2423456789",
        ,
        ,
        ,
        [7]
      ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
      BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[2-68]|7[246]"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
        ,
        ,
        "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
        ,
        ,
        ,
        "2401234",
        ,
        ,
        [7]
      ], [, , "(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
        ,
        "(\\d{3})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
        ,
        ,
        "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
        ,
        ,
        ,
        "294911911",
        ,
        ,
        [9]
      ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
        ,
        "(\\d{4})(\\d{2})(\\d{3})",
        "$1 $2-$3",
        ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
        "8 0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
        ,
        ,
        "6[0-35-7]\\d{5}",
        ,
        ,
        ,
        "6221234",
        ,
        ,
        [7]
      ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
        ,
        ,
        ,
        "5062345678",
        ,
        ,
        [10],
        [7]
      ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678",
        ,
        ,
        [10]
      ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
      CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
        ,
        ,
        "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
        ,
        ,
        ,
        "412345678",
        ,
        ,
        [9]
      ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CD: [, [
        ,
        ,
        "[189]\\d{8}|[1-68]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9]
      ], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CF: [, [
        ,
        ,
        "(?:[27]\\d{3}|8776)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [
        ,
        ,
        "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
        ,
        ,
        ,
        "061234567"
      ], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CH: [
        ,
        [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]],
        [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]],
        [, , "7[35-9]\\d{7}", , , , "781234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "90[016]\\d{6}", , , , "900123456", , , [9]],
        [, , "84[0248]\\d{6}", , , , "840123456", , , [9]],
        [, , "878\\d{6}", , , , "878123456", , , [9]],
        [, , , , , , , , , [-1]],
        "CH",
        41,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]],
        ,
        [, , "74[0248]\\d{6}", , , , "740123456", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "5[18]\\d{7}", , , , "581234567", , , [9]],
        ,
        ,
        [
          ,
          ,
          "860\\d{9}",
          ,
          ,
          ,
          "860123456789",
          ,
          ,
          [12]
        ]
      ],
      CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CK: [, [
        ,
        ,
        "[2-578]\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5]
      ], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CL: [, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [
        ,
        ,
        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [9]
      ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [
        ,
        ,
        "600\\d{7,8}",
        ,
        ,
        ,
        "6001234567",
        ,
        ,
        [10, 11]
      ], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
        "($1)"
      ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["60|8"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]], [, , "(?:24[23]|6[25-9]\\d)\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["88"]
      ], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CN: [, [, , "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
        ,
        ,
        "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
        ,
        ,
        ,
        "1012345678",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
        ,
        ,
        "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
        ,
        ,
        ,
        "4001234567",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
        [, "(\\d{5,6})", "$1", ["10|96"]],
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
        [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ],
        [, "(\\d{4})(\\d{4})", "$1 $2", [
          "[1-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
          "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
        ]],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{5,6})", "$1 $2", [
          "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
          "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
          "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
          "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
        ], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
          "0$1",
          "$CC $1",
          1
        ],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CO: [, [, , "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", , , , , , , [10, 11], [7]], [, , "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}", , , , "6012345678", , , [10], [7]], [
        ,
        ,
        "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
        ,
        ,
        ,
        "3211234567",
        ,
        ,
        [10]
      ], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0(4(?:[14]4|56)|[579])?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [
        [, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"],
        [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"],
        [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
        ,
        ,
        ,
        "40001234",
        ,
        ,
        [8]
      ], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CU: [, [, , "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", , , , , , , [6, 7, 8, 10], [4, 5]], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [
        ,
        ,
        "(?:5\\d|63)\\d{6}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
        ,
        ,
        ,
        "2211234"
      ], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [
        ,
        ,
        "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
        ,
        ,
        ,
        "94351234"
      ], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CX: [
        ,
        [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
          ,
          ,
          ,
          "891641234",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "CX",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "([59]\\d{7})$|0",
        "8$1",
        "0011",
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CY: [
        ,
        [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]],
        [, , "2[2-6]\\d{6}", , , , "22345678"],
        [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"],
        [, , "800\\d{5}", , , , "80001234"],
        [, , "90[09]\\d{5}", , , , "90012345"],
        [, , "80[1-9]\\d{5}", , , , "80112345"],
        [, , "700\\d{5}", , , , "70012345"],
        [, , , , , , , , , [-1]],
        "CY",
        357,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:50|77)\\d{6}", , , , "77123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CZ: [, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
        [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]],
      DE: [, [
        ,
        ,
        "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3]
      ], [
        ,
        ,
        "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
        ,
        ,
        ,
        "30123456",
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3, 4]
      ], [, , "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
        [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
        [
          ,
          "(\\d{3})(\\d{3,12})",
          "$1 $2",
          ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
          "0$1"
        ],
        [
          ,
          "(\\d{4})(\\d{2,11})",
          "$1 $2",
          ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
          "0$1"
        ],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
        [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
        [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
        [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
        [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
        [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
        [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
      ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
        ,
        ,
        "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
        ,
        ,
        ,
        "177991234567",
        ,
        ,
        [12, 13]
      ]],
      DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "32123456"], [
        ,
        ,
        "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
        ,
        ,
        ,
        "32123456"
      ], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DM: [
        ,
        [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
        [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]],
        [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "DM",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "767$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "767",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      DO: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [
        ,
        ,
        "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8001|8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DZ: [
        ,
        [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
        [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
        [, , "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
        [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
        "DZ",
        213,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [
          [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]
        ],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EC: [
        ,
        [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]],
        [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]],
        [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]],
        [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]],
        "EC",
        593,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EE: [
        ,
        [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
        [
          ,
          ,
          "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
          ,
          ,
          ,
          "3212345",
          ,
          ,
          [7]
        ],
        [, , "(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
        [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"],
        [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
        [, , , , , , , , , [-1]],
        [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        "EE",
        372,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "800[2-9]\\d{3}", , , , , , , [7]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EG: [, [
        ,
        ,
        "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[89]"],
        "0$1"
      ], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EH: [
        ,
        [, , "[5-8]\\d{8}", , , , , , , [9]],
        [, , "528[89]\\d{5}", , , , "528812345"],
        [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"],
        [, , "80\\d{7}", , , , "801234567"],
        [, , "89\\d{7}", , , , "891234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"],
        "EH",
        212,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "528[89]",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ES: [, [, , "[5-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
        ,
        ,
        ,
        "810123456"
      ], [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"], [, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
        [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]],
      ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
        ,
        ,
        "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
        ,
        ,
        ,
        "111112345",
        ,
        ,
        ,
        [7]
      ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FI: [
        ,
        [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [
          ,
          ,
          "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",
          ,
          ,
          ,
          "131234567",
          ,
          ,
          [5, 6, 7, 8, 9]
        ],
        [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]],
        [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]],
        [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FI",
        358,
        "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [
          ,
          "(\\d{3})(\\d{3,7})",
          "$1 $2",
          ["[12]00|[368]|70[07-9]"],
          "0$1"
        ], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
        [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]],
        [, , , , , , , , , [-1]],
        1,
        "1[03-79]|[2-9]",
        [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
        [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FJ: [
        ,
        [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]],
        [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
        [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]],
        [, , "0800\\d{7}", , , , "08001234567", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FJ",
        679,
        "0(?:0|52)",
        ,
        ,
        ,
        ,
        ,
        "00",
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
        ,
        ,
        ,
        "3201234"
      ], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [
        ,
        ,
        "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
        ,
        ,
        ,
        "901123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FR: [, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [
        ,
        ,
        "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
        ,
        ,
        ,
        "891123456"
      ], [, , "8(?:1[01]|2[0156]|4[02]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
      GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
        ,
        ,
        "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
        ,
        ,
        ,
        "1212345678",
        ,
        ,
        [9, 10],
        [4, 5, 6, 7, 8]
      ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
        ,
        ,
        "56\\d{8}",
        ,
        ,
        ,
        "5612345678",
        ,
        ,
        [10]
      ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
        "[25]|7(?:0|6[02-9])",
        "[25]|7(?:0|6(?:[03-9]|2[356]))"
      ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GD: [
        ,
        [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
          ,
          ,
          ,
          "4732691234",
          ,
          ,
          ,
          [7]
        ],
        [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "GD",
        1,
        "011",
        "1",
        ,
        ,
        "([2-9]\\d{6})$|1",
        "473$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "473",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
        ,
        ,
        "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
        ,
        ,
        ,
        "555123456"
      ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GF: [, [
        ,
        ,
        "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "594(?:[02-49]\\d|1[0-4]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
        ,
        ,
        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
        ,
        ,
        ,
        "7640123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
        ,
        ,
        "800\\d{5}",
        ,
        ,
        ,
        "80012345",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
        ,
        ,
        "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
        ,
        ,
        ,
        "20012345"
      ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GL: [
        ,
        [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]],
        [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"],
        [, , "[245]\\d{5}", , , , "221234"],
        [, , "80\\d{4}", , , , "801234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "3[89]\\d{4}", , , , "381234"],
        "GL",
        299,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GM: [
        ,
        [, , "[2-9]\\d{6}", , , , , , , [7]],
        [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
        [, , "(?:[23679]\\d|5[0-489])\\d{5}", , , , "3012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GM",
        220,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[67]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GP: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"], "GP", 590, "00", "0", , , "0", , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[569]"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[235]"]
      ], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
        ,
        ,
        "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
        ,
        "(\\d{3})(\\d{3,4})(\\d{5})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
      GT: [
        ,
        [, , "(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]],
        [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]],
        [, , "[3-5]\\d{7}", , , , "51234567", , , [8]],
        [, , "18[01]\\d{8}", , , , "18001112222", , , [11]],
        [, , "19\\d{9}", , , , "19001112222", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GT",
        502,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
        ,
        ,
        "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
        ,
        ,
        ,
        "6713001234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([3-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GY: [
        ,
        [, , "9008\\d{3}|(?:[2-467]\\d\\d|510|862)\\d{4}", , , , , , , [7]],
        [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"],
        [, , "(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}", , , , "6091234"],
        [, , "(?:289|862)\\d{4}", , , , "2891234"],
        [, , "9008\\d{3}", , , , "9008123"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GY",
        592,
        "001",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HK: [, [
        ,
        ,
        "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 11]
      ], [, , "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-9]|1[2-9]))\\d{4}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
        ,
        ,
        ,
        "51234567",
        ,
        ,
        [8]
      ], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["9"]
      ]], , [, , "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", , , , "71123456", , , [8]], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
      HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
        ,
        ,
        "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [8]
      ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
        ,
        ,
        ,
        "12345678",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
        ,
        "(\\d)(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["1"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
      HT: [
        ,
        [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]],
        [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"],
        [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"],
        [, , "8\\d{7}", , , , "80012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"],
        "HT",
        509,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HU: [
        ,
        [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]],
        [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]],
        [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]],
        [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"],
        [, , "9[01]\\d{6}", , , , "90123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "21\\d{7}", , , , "211234567", , , [9]],
        "HU",
        36,
        "00",
        "06",
        ,
        ,
        "06",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "(?:[48]0\\d|680[29])\\d{5}"],
        [, , "38\\d{7}", , , , "381234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ID: [, [
        ,
        ,
        "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9, 10, 11, 12, 13],
        [5, 6]
      ], [
        ,
        ,
        "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
        ,
        ,
        ,
        "218350123",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
        ,
        "(\\d{3})(\\d{5,8})",
        "$1 $2",
        ["[2-79]"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
        ,
        "(\\d{2})(\\d{5,9})",
        "$1 $2",
        ["2[124]|[36]1"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 12, 13]], [
        ,
        ,
        "(?:1500|8071\\d{3})\\d{3}",
        ,
        ,
        ,
        "8071123456",
        ,
        ,
        [7, 10]
      ], , , [, , , , , , , , , [-1]]],
      IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], [
        ,
        ,
        "18[59]0\\d{6}",
        ,
        ,
        ,
        "1850123456",
        ,
        ,
        [10]
      ], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[78]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
      IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8, 11, 12],
        [7]
      ], [, , "55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2[2-9]|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
        ,
        ,
        ,
        "771234567",
        ,
        ,
        [9]
      ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}", , , , , , , [10]], [
        ,
        ,
        "1599\\d{6}",
        ,
        ,
        ,
        "1599123456",
        ,
        ,
        [10]
      ], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
      IM: [
        ,
        [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
        [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
        [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
        [, , "808162\\d{4}", , , , "8081624567"],
        [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
        [, , , , , , , , , [-1]],
        [, , "70\\d{8}", , , , "7012345678"],
        [, , "56\\d{8}", , , , "5612345678"],
        "IM",
        44,
        "00",
        "0",
        ,
        ,
        "([25-8]\\d{5})$|0",
        "1624$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "74576|(?:16|7[56])24",
        [, , , , , , , , , [-1]],
        [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
        ,
        ,
        "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
        ,
        ,
        ,
        "7410410123",
        ,
        ,
        [10],
        [6, 7, 8]
      ], [
        ,
        ,
        "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
        ,
        ,
        ,
        "8123456789",
        ,
        ,
        [10]
      ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["140"],
        ,
        ,
        1
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
        "0$1",
        ,
        1
      ], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["18"],
        ,
        ,
        1
      ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
      IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IQ: [, [
        ,
        ,
        "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IR: [
        ,
        [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
        [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
        [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "IR",
        98,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
        [
          ,
          ,
          "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
          ,
          ,
          ,
          "9601",
          ,
          ,
          [4, 5]
        ],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
        ,
        ,
        ,
        "9001234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
      IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
        ,
        ,
        ,
        "0212345678",
        ,
        ,
        [6, 7, 8, 9, 10, 11]
      ], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
        [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
        [, "(\\d{6})", "$1", ["1(?:1|92)"]],
        [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
        [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
        [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]],
        [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{5})",
          "$1 $2 $3",
          ["0[26]"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
        [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
      ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["1(?:44|[679])|[378]"]
      ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
        ,
        ,
        "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
        ,
        ,
        ,
        "7797712345"
      ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
        ,
        ,
        ,
        "5512345678"
      ], , , [, , , , , , , , , [-1]]],
      JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
        ,
        ,
        "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
        ,
        ,
        ,
        "8762101234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
        ,
        ,
        "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
        ,
        ,
        ,
        "62001234",
        ,
        ,
        [8]
      ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
        ,
        ,
        "74(?:66|77)\\d{5}",
        ,
        ,
        ,
        "746612345",
        ,
        ,
        [9]
      ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
      JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
        ,
        ,
        "[7-9]0[1-9]\\d{7}",
        ,
        ,
        ,
        "9012345678",
        ,
        ,
        [10]
      ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        ["60"],
        "0$1"
      ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
        ,
        "(\\d{4})(\\d{6})(\\d{6,7})",
        "$1-$2-$3",
        ["0"]
      ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
      KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
        ,
        ,
        "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
        ,
        ,
        ,
        "202012345",
        ,
        ,
        [7, 8, 9]
      ], [, , "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[2-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KG: [, [
        ,
        ,
        "8\\d{9}|[235-9]\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9, 10],
        [5, 6]
      ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KH: [
        ,
        [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
        [
          ,
          ,
          "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
          ,
          ,
          ,
          "23756789",
          ,
          ,
          [8, 9],
          [6, 7]
        ],
        [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
        [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
        [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "KH",
        855,
        "00[14-9]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
        ,
        ,
        "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
        ,
        ,
        ,
        "72001234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["[3478]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["8"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
        ,
        ,
        "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [5, 6, 8, 9, 10],
        [3, 4, 7]
      ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
        ,
        "(\\d{5})",
        "$1",
        ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
        "0$1"
      ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
        ,
        "(\\d{2})(\\d{5})(\\d{4})",
        "$1-$2-$3",
        ["5"],
        "0$1",
        "0$CC-$1"
      ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
        [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
        [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
        [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
      ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
      KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
        ,
        ,
        "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
        ,
        ,
        ,
        "50012345",
        ,
        ,
        [8]
      ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
        ,
        ,
        ,
        "3452221234",
        ,
        ,
        ,
        [7]
      ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
        ,
        ,
        "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
        ,
        ,
        ,
        "7123456789",
        ,
        ,
        [10],
        [5, 6, 7]
      ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
        ,
        ,
        "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
        ,
        ,
        ,
        "21212862",
        ,
        ,
        [8],
        [6]
      ], [, , "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[013-9]\\d{6}", , , , "301234567", , , [9]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LC: [
        ,
        [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
        [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
        [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "LC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-8]\\d{6})$|1",
        "758$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "758",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
        ,
        ,
        ,
        "2345678",
        ,
        ,
        [7]
      ], [, , "(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["69"],
        ,
        "$CC $1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
      LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
      LR: [, [, , "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "332(?:02|[34]\\d)\\d{4}",
        ,
        ,
        ,
        "332021234",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LT: [, [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "80[02]\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "70[05]\\d{5}", , , , "70012345"], [, , "[89]01\\d{5}", , , , "80123456"], "LT", 370, "00", "8", , , "[08]", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["52[0-7]"],
        "(8-$1)",
        ,
        1
      ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]],
      LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
        ,
        ,
        ,
        "27123456"
      ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
        ,
        "$CC $1"
      ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
        "$1 $2 $3 $4",
        ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
        ,
        "$CC $1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[269]|8[01]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LY: [
        ,
        [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
        [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
        [, , "9[1-6]\\d{7}", , , , "912345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "LY",
        218,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MC: [, [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]], [, , "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]],
        [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
        [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]],
        [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]
      ], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MD: [
        ,
        [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]],
        [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"],
        [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"],
        [, , "800\\d{5}", , , , "80012345"],
        [, , "90[056]\\d{5}", , , , "90012345"],
        [, , "808\\d{5}", , , , "80812345"],
        [, , , , , , , , , [-1]],
        [, , "3[08]\\d{6}", , , , "30123456"],
        "MD",
        373,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "803\\d{5}", , , , "80312345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [
        ,
        ,
        "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
        ,
        ,
        ,
        "30234567",
        ,
        ,
        [8],
        [6]
      ], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
      MF: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
        ,
        ,
        ,
        "590271234"
      ], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MH: [, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|45[78]|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[356])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "635\\d{4}",
        ,
        ,
        ,
        "6351234"
      ], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [
        ,
        ,
        "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
        ,
        ,
        ,
        "72345678"
      ], [, , "800\\d{5}", , , , "80012345"], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
        ,
        ,
        ,
        "20212345"
      ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MM: [
        ,
        [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
        [
          ,
          ,
          "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
          ,
          ,
          ,
          "1234567",
          ,
          ,
          [6, 7, 8, 9],
          [5]
        ],
        [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
        [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
        "MM",
        95,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{3})",
          "$1 $2 $3",
          ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]],
        ,
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
        ,
        ,
        ,
        "75123456",
        ,
        ,
        [8]
      ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
        ,
        ,
        ,
        "28212345",
        ,
        ,
        [8]
      ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
        ,
        ,
        ,
        "6702345678",
        ,
        ,
        ,
        [7]
      ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MQ: [
        ,
        [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "596(?:[03-7]\\d|10|2[7-9]|8[0-39]|9[04-9])\\d{4}", , , , "596301234"],
        [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:397[0-2]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
        "MQ",
        596,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[2-48]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
        ,
        ,
        "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
        ,
        ,
        ,
        "50037123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
      MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
        ,
        ,
        "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-2]|3[013]))\\d{5}",
        ,
        ,
        ,
        "52512345",
        ,
        ,
        [8]
      ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
        ,
        ,
        ,
        "6701234",
        ,
        ,
        [7]
      ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
      MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "1234567"
      ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MX: [
        ,
        [
          ,
          ,
          "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
          ,
          ,
          ,
          ,
          ,
          ,
          [10, 11],
          [7, 8]
        ],
        [, , "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", , , , "2001234567", , , [10], [7, 8]],
        [
          ,
          ,
          "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
          ,
          ,
          ,
          "12221234567",
          ,
          ,
          ,
          [7, 8]
        ],
        [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]],
        [, , "900\\d{7}", , , , "9001234567", , , [10]],
        [, , "300\\d{7}", , , , "3001234567", , , [10]],
        [, , "500\\d{7}", , , , "5001234567", , , [10]],
        [, , , , , , , , , [-1]],
        "MX",
        52,
        "0[09]",
        "01",
        ,
        ,
        "0(?:[12]|4[45])|1",
        ,
        "00",
        ,
        [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [
          ,
          "(\\d)(\\d{3})(\\d{3})(\\d{4})",
          "$2 $3 $4",
          ["1"],
          ,
          ,
          1
        ]],
        [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MY: [, [, , "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [
        ,
        ,
        "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
        ,
        ,
        ,
        "323856789",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
        ,
        ,
        ,
        "1546012345",
        ,
        ,
        [10]
      ], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      MZ: [, [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NA: [, [
        ,
        ,
        "[68]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9]
      ], [, , "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}", , , , "61221234"], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [
        ,
        ,
        "8701\\d{5}",
        ,
        ,
        ,
        "870123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [
        ,
        ,
        "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
        ,
        ,
        ,
        "751234"
      ], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
        ,
        ,
        ,
        "20201234"
      ], [, , "(?:23|7[047]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [
        ,
        ,
        "(?:14|3[58])\\d{4}",
        ,
        ,
        ,
        "381234",
        ,
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NG: [, [, , "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [
        ,
        ,
        "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
        ,
        ,
        ,
        "18040123",
        ,
        ,
        [7, 8],
        [5, 6]
      ], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["[7-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]],
      NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{5})",
        "$1 $2 $3",
        ["9"],
        "0$1"
      ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
      NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4[015-8]|9\\d)\\d{6}",
        ,
        ,
        ,
        "40612345",
        ,
        ,
        [8]
      ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
        ,
        "(\\d{2})(\\d{6})",
        "$1-$2",
        ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
        "0$1"
      ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NR: [, [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NU: [, [, , "(?:[47]|888\\d)\\d{3}", , , , , , , [4, 7]], [, , "[47]\\d{3}", , , , "7012", , , [4]], [, , "888[4-9]\\d{3}", , , , "8884012", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      NZ: [
        ,
        [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
        [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
        [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
        [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
        [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "70\\d{7}",
          ,
          ,
          ,
          "701234567",
          ,
          ,
          [9]
        ],
        [, , , , , , , , , [-1]],
        "NZ",
        64,
        "0(?:0|161)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      OM: [
        ,
        [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]],
        [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]],
        [, , "1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", , , , "92123456", , , [8]],
        [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"],
        [, , "900\\d{5}", , , , "90012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "OM",
        968,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
        ,
        ,
        "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
        ,
        ,
        ,
        "2001234",
        ,
        ,
        [7]
      ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PE: [, [
        ,
        ,
        "(?:[14-8]|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["80"],
        "(0$1)"
      ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PF: [
        ,
        [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
        [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
        [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "499\\d{5}", , , , "49901234", , , [8]],
        "PF",
        689,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "44\\d{4}", , , , , , , [6]],
        [, , "44\\d{4}", , , , "440123", , , [6]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[128])\\d{6}", , , , "70123456", , , [8]], [
        ,
        ,
        "180\\d{4}",
        ,
        ,
        ,
        "1801234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
        ,
        ,
        "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "232345678",
        ,
        ,
        [6, 8, 9, 10],
        [4, 5, 7]
      ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
        ,
        "(\\d{4})(\\d{4,6})",
        "$1 $2",
        ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
        "(0$1)"
      ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PK: [, [
        ,
        ,
        "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10, 11, 12],
        [5, 6, 7]
      ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-24]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
        ,
        ,
        "122\\d{6}",
        ,
        ,
        ,
        "122044444",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
        ,
        "(\\d{3})(\\d{6,7})",
        "$1 $2",
        ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
        ,
        ,
        ,
        "21111825888",
        ,
        ,
        [11, 12]
      ], , , [, , , , , , , , , [-1]]],
      PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
        ,
        ,
        "801\\d{6}",
        ,
        ,
        ,
        "801234567",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
        [, "(\\d{5})", "$1", ["19"]],
        [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]],
        [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
        [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
        [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
      ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
      PM: [
        ,
        [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]],
        [, , "(?:4[1-35-7]|5[01])\\d{4}", , , , "430123", , , [6]],
        [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "PM",
        508,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
        ,
        ,
        "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
        ,
        ,
        ,
        "22234567",
        ,
        ,
        [8],
        [7]
      ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PT: [
        ,
        [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
        [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
        [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
        [, , "80[02]\\d{6}", , , , "800123456"],
        [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
        [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
        [, , "884[0-4689]\\d{5}", , , , "884123456"],
        [, , "30\\d{7}", , , , "301234567"],
        "PT",
        351,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["2[12]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
        ,
        [, , "6222\\d{5}", , , , "622212345"],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
        ,
        ,
        [, , "600\\d{6}|6[06]9233\\d{3}", , , , "600110000"]
      ],
      PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
        ,
        ,
        "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
        ,
        ,
        ,
        "212345678",
        ,
        ,
        [7, 8, 9],
        [5, 6]
      ], [, , "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
      QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
        ,
        ,
        "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
        ,
        ,
        ,
        "44123456",
        ,
        ,
        [8]
      ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-5]))\\d{4}", , , , "262161234"], [
        ,
        ,
        "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))\\d{4}",
        ,
        ,
        ,
        "692123456"
      ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RO: [, [, , "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
        ,
        ,
        "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
        ,
        ,
        ,
        "211234567"
      ], [, , "7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[237-9]"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
      RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [
        ,
        ,
        "(?:78\\d|90[0169])\\d{3,7}",
        ,
        ,
        ,
        "90012345",
        ,
        ,
        [6, 7, 8, 9, 10]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
      RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
        ,
        ,
        "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
        ,
        ,
        ,
        "3011234567",
        ,
        ,
        [10],
        [7]
      ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
        ,
        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2-$3-$4",
        ["[349]|8(?:[02-7]|1[1-8])"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
        ,
        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
        ,
        ,
        "900\\d{6}",
        ,
        ,
        ,
        "900123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
        ,
        ,
        "579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",
        ,
        ,
        ,
        "512345678",
        ,
        ,
        [9]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "811\\d{7}",
        ,
        ,
        ,
        "8110123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]]],
      SB: [
        ,
        [, , "(?:[1-6]|[7-9]\\d\\d)\\d{4}", , , , , , , [5, 7]],
        [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]],
        [, , "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"],
        [, , "1[38]\\d{3}", , , , "18123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[12]\\d{3}", , , , "51123", , , [5]],
        "SB",
        677,
        "0[01]",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SC: [, [, , "800\\d{4}|(?:[249]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "1(?:5\\d|8[35-7])\\d{6}",
        ,
        ,
        ,
        "153123456"
      ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
        ,
        ,
        "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
        ,
        ,
        ,
        "8123456",
        ,
        ,
        [7, 8, 9]
      ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})",
        "$1-$2 $3",
        ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
        "$1-$2 $3 $4",
        ["8"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
        ,
        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["8"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
      SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
        ,
        ,
        "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
        ,
        ,
        ,
        "61234567",
        ,
        ,
        [8]
      ], [, , "8(?:08[01]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{4})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["7"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
      SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
        ,
        ,
        "[56]\\d{4}",
        ,
        ,
        ,
        "51234",
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SI: [
        ,
        [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
        [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
        [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
        [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
        [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
        "SI",
        386,
        "00|10(?:22|66|88|99)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      SK: [
        ,
        [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]],
        [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"],
        [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]],
        [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
        "SK",
        421,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", [
          "[3-5][1-8]1",
          "[3-5][1-8]1[67]"
        ], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [, , "9090\\d{3}", , , , "9090123", , , [7]],
        ,
        ,
        [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]],
        [, , "96\\d{7}", , , , "961234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
        ,
        ,
        "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
        ,
        ,
        ,
        "25123456"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "5[158]\\d{6}",
        ,
        ,
        ,
        "58001110",
        ,
        ,
        [8]
      ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
        ,
        ,
        "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
        ,
        ,
        ,
        "701234567"
      ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
        ,
        ,
        ,
        "4012345",
        ,
        ,
        [6, 7]
      ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
        ,
        "(\\d)(\\d{7})",
        "$1 $2",
        ["(?:2|90)4|[67]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1-$2-$3",
        ["56"]
      ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SV: [, [, , "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
        ,
        ,
        "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8]
      ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SX: [
        ,
        [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
          ,
          ,
          ,
          "7215425678",
          ,
          ,
          ,
          [7]
        ],
        [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "SX",
        1,
        "011",
        "1",
        ,
        ,
        "(5\\d{6})$|1",
        "721$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "721",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["9"],
        "0$1",
        ,
        1
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        "0800\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TD: [, [, , "(?:22|[69]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[0235689]|77|9\\d)\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
        ,
        ,
        "(?:7[019]|9[0-36-9])\\d{6}",
        ,
        ,
        ,
        "90112345"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
        ,
        ,
        "(?:001800\\d|1800)\\d{6}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [10, 13]
      ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TJ: [, [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]], [
        ,
        ,
        "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:4[046]|74|87))\\d{6}",
        ,
        ,
        ,
        "372123456",
        ,
        ,
        ,
        [3, 5, 6, 7]
      ], [, , "(?:41[18]|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[04]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]], [
        ,
        ,
        "80\\d{5}",
        ,
        ,
        ,
        "8012345",
        ,
        ,
        [7]
      ], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TM: [
        ,
        [, , "[1-6]\\d{7}", , , , , , , [8]],
        [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"],
        [, , "6\\d{7}", , , , "66123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "TM",
        993,
        "810",
        "8",
        ,
        ,
        "8",
        ,
        "8~10",
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
        ,
        ,
        "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
        ,
        ,
        ,
        "20123456"
      ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
        ,
        ,
        "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
        ,
        ,
        ,
        "7715123",
        ,
        ,
        [7]
      ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
        ,
        ,
        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{6,7})",
        "$1 $2 $3",
        ["80"],
        "0$1",
        ,
        1
      ]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
      TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
      TV: [, [
        ,
        ,
        "(?:2|7\\d\\d|90)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TW: [, [, , "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [8, 9]
      ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
        ,
        "(\\d)(\\d{3,4})(\\d{4})",
        "$1 $2 $3",
        ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
      TZ: [, [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}", , , , "621234567"], [, , "80[08]\\d{6}", , , , "800123456"], [
        ,
        ,
        "90\\d{7}",
        ,
        ,
        ,
        "900123456"
      ], [, , "8(?:40|6[01])\\d{6}", , , , "840123456"], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678"], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
        ,
        ,
        "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
        ,
        ,
        ,
        "311234567",
        ,
        ,
        [9],
        [5, 6, 7]
      ], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
        ,
        "(\\d{4})(\\d{5})",
        "$1 $2",
        ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
        ,
        ,
        "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
        ,
        ,
        ,
        "312345678",
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "726[01]\\d{5}|7(?:[01578]\\d|20|36|4[0-4]|6[0-5]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      US: [, [
        ,
        ,
        "[2-9]\\d{9}|3\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10],
        [7]
      ], [
        ,
        ,
        "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [
        ,
        ,
        "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [
        ,
        "(\\d{3})(\\d{4})",
        "$1-$2",
        ["[24-9]|3(?:[02-9]|1[1-9])"]
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UY: [, [, , "0004\\d{2,9}|4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
        ,
        ,
        "0004\\d{2,9}|(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",
        ,
        ,
        ,
        "8001234"
      ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UZ: [, [, , "200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
        ,
        ,
        ,
        "669050123"
      ], [
        ,
        ,
        "(?:(?:200[01]|(?:33|50|88|9[0-57-9])\\d\\d)\\d|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
        ,
        ,
        ,
        "912345678"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
        ,
        ,
        "80(?:0\\d{3}|3)\\d{3}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [6, 9]
      ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      VC: [
        ,
        [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
        [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
        [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
        [, , "900[2-9]\\d{6}", , , , "9002345678"],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ],
        [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
        "VC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "784$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "784",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VE: [
        ,
        [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
        [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
        [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
        [, , "800\\d{7}", , , , "8001234567"],
        [, , "90[01]\\d{7}", , , , "9001234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "VE",
        58,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "501\\d{7}", , , , "5010123456", , , , [7]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
        ,
        ,
        ,
        "3406421234",
        ,
        ,
        ,
        [7]
      ], [, , "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
        ,
        ,
        "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [8, 9, 10]
      ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["2[48]"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
        ,
        ,
        ,
        "1992000",
        ,
        ,
        [7, 8]
      ], , , [, , , , , , , , , [-1]]],
      VU: [
        ,
        [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
        [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
        [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
        [, , "81[18]\\d\\d", , , , "81123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
        "VU",
        678,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
      WS: [, [
        ,
        ,
        "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 10]
      ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      XK: [, [, , "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [
        8,
        9
      ]], [, , "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", , , , "28012345"], [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , , [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YE: [, [
        ,
        ,
        "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9],
        [6]
      ], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[01378]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YT: [, [
        ,
        ,
        "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
        ,
        ,
        ,
        "871234567",
        ,
        ,
        [9]
      ], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
      ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [
        ,
        ,
        "21[1-8]\\d{6}",
        ,
        ,
        ,
        "211234567",
        ,
        ,
        ,
        [6]
      ], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
        ,
        ,
        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
        ,
        ,
        ,
        "1312345",
        ,
        ,
        ,
        [3, 4]
      ], [, , "7(?:[178]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
        [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
        [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
        [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
        [
          ,
          "(\\d{2})(\\d{3,5})",
          "$1 $2",
          ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
          "0$1"
        ],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
        [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      800: [
        ,
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "001",
        800,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        1,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      881: [, [, , "[0-36-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "[0-36-9]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", , , , "3421234", , , [7, 8, 9, 10, 12]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["10|23|3(?:[15]|4[57])|4|51"]
      ], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
      883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
        ,
        ,
        ,
        "510012345"
      ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
      979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
    };
    function le() {
      this.g = {};
    }
    le.g = void 0, le.h = function() {
      return le.g ? le.g : le.g = new le();
    };
    var Fe = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, We = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "+": "+",
      "*": "*",
      "#": "#"
    }, St = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "０": "0",
      "１": "1",
      "２": "2",
      "３": "3",
      "４": "4",
      "５": "5",
      "６": "6",
      "７": "7",
      "８": "8",
      "９": "9",
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      A: "2",
      B: "2",
      C: "2",
      D: "3",
      E: "3",
      F: "3",
      G: "4",
      H: "4",
      I: "4",
      J: "5",
      K: "5",
      L: "5",
      M: "6",
      N: "6",
      O: "6",
      P: "7",
      Q: "7",
      R: "7",
      S: "7",
      T: "8",
      U: "8",
      V: "8",
      W: "9",
      X: "9",
      Y: "9",
      Z: "9"
    }, bt = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, Ct = RegExp("[+＋]+"), _t = RegExp("^[+＋]+"), G = RegExp("([0-9０-９٠-٩۰-۹])"), M = RegExp("[+＋0-9０-９٠-٩۰-۹]"), ue = /[\\\/] *x/, ie = RegExp("[^0-9０-９٠-٩۰-۹A-Za-z#]+$"), De = /(?:.*?[A-Za-z]){3}.*/, je = RegExp("^\\+([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*[0-9０-９٠-٩۰-۹]([0-9０-９٠-٩۰-۹]|[\\-\\.\\(\\)]?)*$"), He = RegExp("^([A-Za-z0-9０-９٠-٩۰-۹]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9０-９٠-٩۰-۹])*\\.?$");
    function _e(w) {
      return "([0-9０-９٠-٩۰-۹]{1," + w + "})";
    }
    function ot() {
      return ";ext=" + _e("20") + "|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + (_e("20") + "#?|[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*") + (_e("9") + "#?|[- ]+") + (_e("6") + "#|[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*") + (_e("15") + "#?|[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*") + (_e("9") + "#?");
    }
    var Nt = new RegExp("(?:" + ot() + ")$", "i"), ir = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^[+＋]*(?:[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*]*[0-9０-９٠-٩۰-۹]){3,}[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～*A-Za-z0-9０-９٠-٩۰-۹]*(?:" + ot() + ")?$", "i"), dr = /(\$\d)/, La = /^\(?\$1\)?$/;
    function ze(w) {
      return 2 > w.length ? !1 : Li(ir, w);
    }
    function Be(w) {
      return Li(De, w) ? $r(w, St) : $r(w, Fe);
    }
    function lt(w) {
      var C = Be(w.toString());
      F(w), w.g(C);
    }
    function Qt() {
      return Object.keys(oe).filter(function(w) {
        return isNaN(w);
      });
    }
    function Cr() {
      return Object.keys(oe).filter(function(w) {
        return !isNaN(w);
      }).map(function(w) {
        return parseInt(w, 10);
      });
    }
    function ar() {
      var w = Object.keys(W);
      return [...Cr(), ...w.map(function(C) {
        return parseInt(C, 10);
      })];
    }
    function $r(w, C) {
      for (var O = new j(), U, B = w.length, ee = 0; ee < B; ++ee) U = w.charAt(ee), U = C[U.toUpperCase()], U != null && O.g(U);
      return O.toString();
    }
    function Br(w) {
      return w.length == 0 || La.test(w);
    }
    function pr(w) {
      return w != null && isNaN(w) && w.toUpperCase() in oe;
    }
    function ln(w, C, O) {
      if (b(C, 2) == 0 && y(C, 5)) {
        var U = $(C, 5);
        if (0 < U.length) return U;
      }
      U = $(C, 1);
      var B = Fa(C);
      return O == 0 ? Mf(U, 0, B, "") : U in W ? (w = xn(w, U, ja(U)), C = uv(C, w, O), B = dv(B, w, O), Mf(U, O, B, C)) : B;
    }
    function xn(w, C, O) {
      return O == "001" ? Ri(w, "" + C) : Ri(w, O);
    }
    function Df(w, C) {
      var O = gn;
      if (!pr(C)) return ln(O, w, 1);
      var U = $(w, 1), B = Fa(w);
      if (!(U in W)) return B;
      if (U == 1) {
        if (C != null && W[1].includes(C.toUpperCase())) return U + " " + ln(O, w, 2);
      } else if (U == jd(O, C)) return ln(O, w, 2);
      var ee = Ri(O, C), ve = $(ee, 11);
      return C = "", y(ee, 17) ? C = $(ee, 17) : Li(bt, ve) && (C = ve), O = xn(O, U, ja(U)), B = dv(B, O, 1), w = uv(w, O, 1), 0 < C.length ? C + " " + U + " " + B + w : Mf(U, 1, B, w);
    }
    function Fa(w) {
      if (!y(w, 2)) return "";
      var C = "" + b(w, 2);
      return y(w, 4) && b(w, 4) && 0 < $(w, 8) ? Array($(w, 8) + 1).join("0") + C : C;
    }
    function Mf(w, C, O, U) {
      switch (C) {
        case 0:
          return "+" + w + O + U;
        case 1:
          return "+" + w + " " + O + U;
        case 3:
          return "tel:+" + w + "-" + O + U;
        default:
          return O + U;
      }
    }
    function dv(w, C, O) {
      e: {
        C = _(C, 20).length == 0 || O == 2 ? _(C, 19) : _(C, 20);
        for (var U, B = C.length, ee = 0; ee < B; ++ee) {
          U = C[ee];
          var ve = x(U, 3);
          if ((ve == 0 || w.search(b(U, 3, ve - 1)) == 0) && (ve = new RegExp(b(U, 1)), Li(ve, w))) {
            C = U;
            break e;
          }
        }
        C = null;
      }
      return C == null || (B = C, C = $(B, 2), U = new RegExp(b(B, 1)), $(B, 5), B = $(B, 4), w = O == 2 && B != null && 0 < B.length ? w.replace(U, C.replace(dr, B)) : w.replace(U, C), O == 3 && (w = w.replace(RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+"), ""), w = w.replace(RegExp("[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]+", "g"), "-"))), O = w, O;
    }
    function cv(w, C) {
      var O = gn;
      if (!pr(w)) return null;
      C = hv(Ri(O, w), C);
      try {
        if (y(C, 6)) {
          var U = b(C, 6);
          return Ff(O, U, w);
        }
      } catch {
      }
      return null;
    }
    function uv(w, C, O) {
      return y(w, 3) && b(w, 3).length != 0 ? O == 3 ? ";ext=" + b(w, 3) : y(C, 13) ? b(C, 13) + $(w, 3) : " ext. " + $(w, 3) : "";
    }
    function hv(w, C) {
      switch (C) {
        case 4:
          return b(w, 5);
        case 3:
          return b(w, 4);
        case 1:
          return b(w, 3);
        case 0:
        case 2:
          return b(w, 2);
        case 5:
          return b(w, 6);
        case 6:
          return b(w, 8);
        case 7:
          return b(w, 7);
        case 8:
          return b(w, 21);
        case 9:
          return b(w, 25);
        case 10:
          return b(w, 28);
        default:
          return b(w, 1);
      }
    }
    function Rf(w, C) {
      return Fn(w, b(C, 1)) ? Fn(w, b(C, 5)) ? 4 : Fn(w, b(C, 4)) ? 3 : Fn(w, b(C, 6)) ? 5 : Fn(w, b(C, 8)) ? 6 : Fn(w, b(C, 7)) ? 7 : Fn(w, b(C, 21)) ? 8 : Fn(w, b(C, 25)) ? 9 : Fn(w, b(C, 28)) ? 10 : Fn(w, b(C, 2)) ? b(C, 18) || Fn(w, b(C, 3)) ? 2 : 0 : !b(C, 18) && Fn(w, b(C, 3)) ? 1 : -1 : -1;
    }
    function Ri(w, C) {
      if (C == null) return null;
      C = C.toUpperCase();
      var O = w.g[C];
      if (O == null) {
        if (O = oe[C], O == null) return null;
        O = new I().g(R.o(), O), w.g[C] = O;
      }
      return O;
    }
    function Fn(w, C) {
      var O = w.length;
      return 0 < x(C, 9) && _(C, 9).indexOf(O) == -1 ? !1 : Li($(C, 2), w);
    }
    function fv(w) {
      var C = gn, O = s0(C, w), U = $(w, 1), B = xn(C, U, O);
      return B == null || O != "001" && U != jd(C, O) ? B = !1 : (w = Fa(w), B = Rf(w, B) != -1), B;
    }
    function s0(w, C) {
      if (C == null) return null;
      var O = $(C, 1);
      if (O = W[O], O == null) w = null;
      else if (O.length == 1) w = O[0];
      else e: {
        C = Fa(C);
        for (var U, B = O.length, ee = 0; ee < B; ee++) {
          U = O[ee];
          var ve = Ri(w, U);
          if (y(ve, 23)) {
            if (C.search(b(ve, 23)) == 0) {
              w = U;
              break e;
            }
          } else if (Rf(C, ve) != -1) {
            w = U;
            break e;
          }
        }
        w = null;
      }
      return w;
    }
    function ja(w) {
      return w = W[w], w == null ? "ZZ" : w[0];
    }
    function jd(w, C) {
      if (w = Ri(w, C), w == null) throw Error("Invalid region code: " + C);
      return $(w, 10);
    }
    function pv(w) {
      return w = mv(w), w == 0 || w == 4;
    }
    function Lf(w, C, O, U) {
      var B = hv(O, U), ee = x(B, 9) == 0 ? _(b(O, 1), 9) : _(B, 9);
      return B = _(B, 10), ee[0] == -1 ? 5 : (C = C.length, -1 < B.indexOf(C) ? 4 : (O = ee[0], O == C ? 0 : O > C ? 2 : ee[ee.length - 1] < C ? 3 : -1 < ee.indexOf(C, 1) ? 0 : 5));
    }
    function mv(w) {
      var C = gn, O = Fa(w);
      return w = $(w, 1), w in W ? (w = xn(C, w, ja(w)), Lf(C, O, w, -1)) : 1;
    }
    function gv(w, C) {
      if (w = w.toString(), w.length == 0 || w.charAt(0) == "0") return 0;
      for (var O, U = w.length, B = 1; 3 >= B && B <= U; ++B) if (O = parseInt(w.substring(0, B), 10), O in W) return C.g(w.substring(B)), O;
      return 0;
    }
    function vv(w, C, O, U, B) {
      if (C.length == 0) return 0;
      C = new j(C);
      var ee;
      O != null && (ee = b(O, 11)), ee == null && (ee = "NonMatch");
      var ve = C.toString();
      if (ve.length == 0) ee = 20;
      else if (_t.test(ve)) ve = ve.replace(_t, ""), F(C), C.g(Be(ve)), ee = 1;
      else {
        if (ve = new RegExp(ee), lt(C), ee = C.toString(), ee.search(ve) == 0) {
          ve = ee.match(ve)[0].length;
          var vt = ee.substring(ve).match(G);
          vt && vt[1] != null && 0 < vt[1].length && $r(vt[1], Fe) == "0" ? ee = !1 : (F(C), C.g(ee.substring(ve)), ee = !0);
        } else ee = !1;
        ee = ee ? 5 : 20;
      }
      if (ee != 20) {
        if (2 >= C.h.length) throw Error("Phone number too short after IDD");
        if (w = gv(
          C,
          U
        ), w != 0) return S(B, 1, w), w;
        throw Error("Invalid country calling code");
      }
      return O != null && (ee = $(O, 10), ve = "" + ee, vt = C.toString(), vt.lastIndexOf(ve, 0) == 0 && (ve = new j(vt.substring(ve.length)), vt = b(O, 1), vt = new RegExp($(vt, 2)), yv(ve, O, null), ve = ve.toString(), !Li(vt, C.toString()) && Li(vt, ve) || Lf(w, C.toString(), O, -1) == 3)) ? (U.g(ve), S(B, 1, ee), ee) : (S(B, 1, 0), 0);
    }
    function yv(w, C, O) {
      var U = w.toString(), B = U.length, ee = b(C, 15);
      if (B != 0 && ee != null && ee.length != 0) {
        var ve = new RegExp("^(?:" + ee + ")");
        if (B = ve.exec(U)) {
          ee = new RegExp($(b(C, 1), 2));
          var vt = Li(ee, U), Rr = B.length - 1;
          C = b(C, 16), C == null || C.length == 0 || B[Rr] == null || B[Rr].length == 0 ? (!vt || Li(ee, U.substring(B[0].length))) && (O != null && 0 < Rr && B[Rr] != null && O.g(B[1]), w.set(U.substring(B[0].length))) : (U = U.replace(ve, C), (!vt || Li(ee, U)) && (O != null && 0 < Rr && O.g(B[1]), w.set(U)));
        }
      }
    }
    function Ff(w, C, O) {
      if (C == null) throw Error("The string supplied did not seem to be a phone number");
      if (250 < C.length) throw Error("The string supplied is too long to be a phone number");
      var U = new j(), B = C.indexOf(";phone-context=");
      if (B === -1) B = null;
      else if (B += 15, B >= C.length) B = "";
      else {
        var ee = C.indexOf(";", B);
        B = ee !== -1 ? C.substring(B, ee) : C.substring(B);
      }
      var ve = B;
      if (ve == null ? ee = !0 : ve.length === 0 ? ee = !1 : (ee = je.exec(ve), ve = He.exec(ve), ee = ee !== null || ve !== null), !ee || (B != null ? (B.charAt(0) === "+" && U.g(B), B = C.indexOf("tel:"), U.g(C.substring(0 <= B ? B + 4 : 0, C.indexOf(";phone-context=")))) : (B = U.g, C = C ?? "", ee = C.search(M), 0 <= ee ? (C = C.substring(ee), C = C.replace(ie, ""), ee = C.search(ue), 0 <= ee && (C = C.substring(0, ee))) : C = "", B.call(U, C)), C = U.toString(), B = C.indexOf(";isub="), 0 < B && (F(U), U.g(C.substring(0, B))), !ze(U.toString()))) throw Error("The string supplied did not seem to be a phone number");
      if (C = U.toString(), !(pr(O) || C != null && 0 < C.length && _t.test(C))) throw Error("Invalid country calling code");
      C = new he();
      e: {
        if (B = U.toString(), ee = B.search(Nt), 0 <= ee && ze(B.substring(0, ee))) {
          ve = B.match(Nt);
          for (var vt = ve.length, Rr = 1; Rr < vt; ++Rr) if (ve[Rr] != null && 0 < ve[Rr].length) {
            F(U), U.g(B.substring(0, ee)), B = ve[Rr];
            break e;
          }
        }
        B = "";
      }
      0 < B.length && S(C, 3, B), ee = Ri(w, O), B = new j(), ve = 0, vt = U.toString();
      try {
        ve = vv(w, vt, ee, B, C);
      } catch (Bs) {
        if (Bs.message == "Invalid country calling code" && _t.test(vt)) {
          if (vt = vt.replace(_t, ""), ve = vv(w, vt, ee, B, C), ve == 0) throw Bs;
        } else throw Bs;
      }
      if (ve != 0 ? (U = ja(ve), U != O && (ee = xn(w, ve, U))) : (lt(U), B.g(U.toString()), O != null && (ve = $(ee, 10), S(C, 1, ve))), 2 > B.h.length || (ee != null && (O = new j(B.toString()), yv(O, ee, new j()), w = Lf(w, O.toString(), ee, -1), w != 2 && w != 4 && w != 5 && (B = O)), w = B.toString(), O = w.length, 2 > O)) throw Error("The string supplied is too short to be a phone number");
      if (17 < O) throw Error("The string supplied is too long to be a phone number");
      if (1 < w.length && w.charAt(0) == "0") {
        for (S(C, 4, !0), O = 1; O < w.length - 1 && w.charAt(O) == "0"; ) O++;
        O != 1 && S(C, 8, O);
      }
      return S(C, 2, parseInt(w, 10)), C;
    }
    le.prototype.ja = function(w) {
      var C = Ri(this, s0(this, w));
      return C == null ? !0 : (w = Fa(w), !Fn(w, b(C, 24)));
    };
    function Li(w, C) {
      return !!((w = typeof w == "string" ? C.match("^(?:" + w + ")$") : C.match(w)) && w[0].length == C.length);
    }
    function bS(w) {
      this.ka = RegExp(" "), this.la = "", this.$ = new j(), this.da = "", this.u = new j(), this.ba = new j(), this.v = !0, this.ea = this.ca = this.oa = !1, this.pa = le.h(), this.aa = 0, this.h = new j(), this.ha = !1, this.s = "", this.g = new j(), this.j = [], this.ma = w, this.wa = this.m = jf(this, this.ma);
    }
    var bv = new R();
    S(bv, 11, "NA");
    var wS = RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*\\$1[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)*$"), wv = /[- ]/;
    function jf(w, C) {
      return C = pr(C) ? jd(w.pa, C) : 0, w = Ri(w.pa, ja(C)), w ?? bv;
    }
    function $v(w) {
      for (var C = w.j.length, O = 0; O < C; ++O) {
        var U = w.j[O], B = $(U, 1);
        if (w.da == B) return !1;
        var ee = w, ve = U, vt = $(ve, 1);
        F(ee.$);
        var Rr = ee;
        ve = $(ve, 2);
        var Bs = "999999999999999".match(vt)[0];
        if (Bs.length < Rr.g.h.length ? Rr = "" : (Rr = Bs.replace(new RegExp(vt, "g"), ve), Rr = Rr.replace(RegExp("9", "g"), " ")), 0 < Rr.length ? (ee.$.g(Rr), ee = !0) : ee = !1, ee) return w.da = B, w.ha = wv.test(b(U, 4)), w.aa = 0, !0;
      }
      return w.v = !1;
    }
    function kv(w, C) {
      for (var O = [], U = C.length - 3, B = w.j.length, ee = 0; ee < B; ++ee) {
        var ve = w.j[ee];
        x(ve, 3) == 0 ? O.push(w.j[ee]) : (ve = b(ve, 3, Math.min(U, x(ve, 3) - 1)), C.search(ve) == 0 && O.push(w.j[ee]));
      }
      w.j = O;
    }
    function $S(w, C) {
      w.u.g(C);
      var O = C;
      if (G.test(O) || w.u.h.length == 1 && Ct.test(O) ? (C == "+" ? (O = C, w.ba.g(C)) : (O = Fe[C], w.ba.g(O), w.g.g(O)), C = O) : (w.v = !1, w.oa = !0), !w.v) {
        if (!w.oa) {
          if (Ev(w)) {
            if (Av(w)) return _v(w);
          } else if (0 < w.s.length && (C = w.g.toString(), F(w.g), w.g.g(w.s), w.g.g(C), C = w.h.toString(), O = C.lastIndexOf(w.s), F(w.h), w.h.g(C.substring(0, O))), w.s != Cv(w)) return w.h.g(" "), _v(w);
        }
        return w.u.toString();
      }
      switch (w.ba.h.length) {
        case 0:
        case 1:
        case 2:
          return w.u.toString();
        case 3:
          if (Ev(w)) w.ea = !0;
          else return w.s = Cv(w), zf(w);
        default:
          return w.ea ? (Av(w) && (w.ea = !1), w.h.toString() + w.g.toString()) : 0 < w.j.length ? (C = Tv(w, C), O = xv(w), 0 < O.length ? O : (kv(w, w.g.toString()), $v(w) ? Sv(w) : w.v ? l0(w, C) : w.u.toString())) : zf(w);
      }
    }
    function _v(w) {
      return w.v = !0, w.ea = !1, w.j = [], w.aa = 0, F(w.$), w.da = "", zf(w);
    }
    function xv(w) {
      for (var C = w.g.toString(), O = w.j.length, U = 0; U < O; ++U) {
        var B = w.j[U], ee = $(B, 1);
        if (new RegExp("^(?:" + ee + ")$").test(C) && (w.ha = wv.test(b(B, 4)), B = C.replace(new RegExp(ee, "g"), b(B, 2)), B = l0(w, B), $r(B, We) == w.ba)) return B;
      }
      return "";
    }
    function l0(w, C) {
      var O = w.h.h.length;
      return w.ha && 0 < O && w.h.toString().charAt(O - 1) != " " ? w.h + " " + C : w.h + C;
    }
    function zf(w) {
      var C = w.g.toString();
      if (3 <= C.length) {
        for (var O = w.ca && w.s.length == 0 && 0 < x(w.m, 20) ? _(w.m, 20) : _(w.m, 19), U = O.length, B = 0; B < U; ++B) {
          var ee = O[B];
          0 < w.s.length && Br($(ee, 4)) && !b(ee, 6) && !y(ee, 5) || (w.s.length != 0 || w.ca || Br($(ee, 4)) || b(ee, 6)) && wS.test($(ee, 2)) && w.j.push(ee);
        }
        return kv(w, C), C = xv(w), 0 < C.length ? C : $v(w) ? Sv(w) : w.u.toString();
      }
      return l0(w, C);
    }
    function Sv(w) {
      var C = w.g.toString(), O = C.length;
      if (0 < O) {
        for (var U = "", B = 0; B < O; B++) U = Tv(w, C.charAt(B));
        return w.v ? l0(w, U) : w.u.toString();
      }
      return w.h.toString();
    }
    function Cv(w) {
      var C = w.g.toString(), O = 0;
      if (w.m.ia() != 1) var U = !1;
      else U = w.g.toString(), U = U.charAt(0) == "1" && U.charAt(1) != "0" && U.charAt(1) != "1";
      return U ? (O = 1, w.h.g("1").g(" "), w.ca = !0) : y(w.m, 15) && (U = new RegExp("^(?:" + b(w.m, 15) + ")"), U = C.match(U), U != null && U[0] != null && 0 < U[0].length && (w.ca = !0, O = U[0].length, w.h.g(C.substring(0, O)))), F(w.g), w.g.g(C.substring(O)), C.substring(0, O);
    }
    function Ev(w) {
      var C = w.ba.toString(), O = new RegExp("^(?:\\+|" + b(w.m, 11) + ")");
      return O = C.match(O), O != null && O[0] != null && 0 < O[0].length ? (w.ca = !0, O = O[0].length, F(w.g), w.g.g(C.substring(O)), F(w.h), w.h.g(C.substring(0, O)), C.charAt(0) != "+" && w.h.g(" "), !0) : !1;
    }
    function Av(w) {
      if (w.g.h.length == 0) return !1;
      var C = new j(), O = gv(w.g, C);
      return O == 0 ? !1 : (F(w.g), w.g.g(C.toString()), C = ja(O), C == "001" ? w.m = Ri(w.pa, "" + O) : C != w.ma && (w.m = jf(w, C)), w.h.g("" + O).g(" "), w.s = "", !0);
    }
    function Tv(w, C) {
      var O = w.$.toString();
      if (0 <= O.substring(w.aa).search(w.ka)) {
        var U = O.search(w.ka);
        return C = O.replace(w.ka, C), F(w.$), w.$.g(C), w.aa = U, C.substring(0, w.aa + 1);
      }
      return w.j.length == 1 && (w.v = !1), w.da = "", w.u.toString();
    }
    var gn = le.h();
    function kS(w) {
      var C = gn, O = s0(C, w);
      switch (C = xn(C, $(w, 1), O), C == null ? w = -1 : (w = Fa(w), w = Rf(w, C)), w) {
        case 0:
          return "fixed-line";
        case 2:
          return "fixed-line-or-mobile";
        case 1:
          return "mobile";
        case 8:
          return "pager";
        case 7:
          return "personal-number";
        case 4:
          return "premium-rate";
        case 5:
          return "shared-cost";
        case 3:
          return "toll-free";
        case 9:
          return "uan";
        case 6:
          return "voip";
        default:
        case -1:
          return "unknown";
      }
    }
    function _S(w) {
      switch (w) {
        case "fixed-line":
          return 0;
        case "fixed-line-or-mobile":
          return 2;
        case "mobile":
          return 1;
        case "pager":
          return 8;
        case "personal-number":
          return 7;
        case "premium-rate":
          return 4;
        case "shared-cost":
          return 5;
        case "toll-free":
          return 3;
        case "uan":
          return 9;
        case "voip":
          return 6;
        default:
        case "unknown":
          return -1;
      }
    }
    function Ov(w) {
      try {
        switch (mv(w)) {
          case 0:
            return "is-possible";
          case 1:
            return "invalid-country-code";
          case 3:
            return "too-long";
          case 2:
            return "too-short";
        }
        if (pv(w)) return "is-possible";
      } catch {
      }
      return "unknown";
    }
    function xS(w, C) {
      if (w.charAt(0) !== "+" && w.slice(0, 2) !== "00") return { parsed: O, fa: U };
      try {
        var O = Ff(gn, w, C);
      } catch {
      }
      if (O) {
        var U = s0(gn, O);
        if (U != null && U !== "ZZ") return { parsed: O, fa: U };
      }
      for (C = 1; 4 > C; ++C) {
        if (U = void 0, w.length < C + 1) return { parsed: O, fa: U };
        if (U = ja(w.substring(1, C + 1)), U !== "ZZ") return { fa: U };
      }
      return { parsed: O, fa: void 0 };
    }
    var Vf;
    e: {
      try {
        Vf = /* @__PURE__ */ new WeakMap();
        break e;
      } catch {
      }
      Vf = void 0;
    }
    var d0 = Vf;
    function Ze(w, C) {
      if (!(this instanceof Ze)) return new Ze(w, C);
      var O = C?.regionCode;
      if (typeof w == "string") var U = !1;
      else try {
        fv(w), U = !0;
      } catch {
        U = !1;
      }
      let B;
      if (!U && typeof w != "string") throw Error("Invalid phone number, expected a string");
      if (!U && typeof C != "object" && typeof C < "u") throw Error(`Invalid options, expected object, got ${typeof C}. This may be because of not yet upgraded code.`);
      if (!U && O != null && typeof O != "string") throw Error(`Invalid region code, expected a string, got ${typeof O} ${O}`);
      if (U || (w = w.trim(), O && w.charAt(0) === "+" && (O = null), O && w.charAt(0) !== "+" && w.slice(0, 2) !== "00" || ({ fa: O = null, parsed: B } = xS(w, O))), this.g = { number: {}, regionCode: O, valid: !1, possible: !1 }, d0 && d0.set(this.g, this), U) this.l = w;
      else {
        if (this.l = null, this.g.number.input = w, !O) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        if (Uf(O) === 0) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        try {
          this.l = B || Ff(gn, w, O);
        } catch {
          this.g.possibility = Ov(w);
          return;
        }
      }
      this.g.number.international = ln(gn, this.l, 1), this.g.number.national = ln(gn, this.l, 2), this.g.number.e164 = ln(gn, this.l, 0), this.g.number.rfc3966 = ln(gn, this.l, 3), this.g.number.significant = Fa(this.l), this.g.canBeInternationallyDialled = gn.ja(this.l), this.g.valid = fv(this.l), this.g.possible = pv(this.l), this.g.possibility = Ov(this.l), !this.g.valid && this.g.possible && (this.g.possibility = "invalid", this.g.possible = !1), this.g.type = kS(this.l), this.g.typeIsMobile = this.sa(), this.g.typeIsFixedLine = this.ra(), this.g.countryCode = pr(O) ? jd(gn, O) : 0;
    }
    var zd = ["PhoneNumber$$module$src$index"], Fi = t;
    zd[0] in Fi || typeof Fi.execScript > "u" || Fi.execScript("var " + zd[0]);
    for (var jo; zd.length && (jo = zd.shift()); ) zd.length || Ze === void 0 ? Fi[jo] && Fi[jo] !== Object.prototype[jo] ? Fi = Fi[jo] : Fi = Fi[jo] = {} : Fi[jo] = Ze;
    function Uf(w) {
      return pr(w) ? jd(gn, w) : 0;
    }
    Ze.getCountryCodeForRegionCode = Uf, Ze.getRegionCodeForCountryCode = function(w) {
      return ja(w);
    };
    function Iv(w) {
      var C = {};
      return w.filter((O) => C.hasOwnProperty(O) ? !1 : (C[O] = 1, !0));
    }
    Ze.getSupportedRegionCodes = function() {
      return Iv(Qt());
    }, Ze.getSupportedCallingCodes = function() {
      return Iv(ar());
    }, Ze.getExample = function(w, C) {
      var O;
      return C ? O = cv(w, _S(C)) : O = cv(w, 0), new Ze(O, w).toJSON();
    }, Ze.getAsYouType = function(w) {
      return new dn(w);
    }, Ze.getNumberFrom = function(w, C) {
      try {
        e: {
          if (d0) {
            var O = d0.get(w);
            if (O) {
              var U = O;
              break e;
            }
          }
          let B;
          U = new Ze(w == null || (B = w.number) == null ? void 0 : B.e164, {});
        }
        return { valid: !0, number: Df(U.l, C) };
      } catch (B) {
        return { valid: !1, error: B };
      }
    }, Ze.prototype.toJSON = function() {
      return this.g;
    }, Ze.prototype.toJSON = Ze.prototype.toJSON, Ze.prototype.ja = function() {
      return this.g.canBeInternationallyDialled;
    }, Ze.prototype.canBeInternationallyDialled = Ze.prototype.ja, Ze.prototype.ya = function() {
      return this.g.valid;
    }, Ze.prototype.isValid = Ze.prototype.ya, Ze.prototype.xa = function() {
      return this.g.possible;
    }, Ze.prototype.isPossible = Ze.prototype.xa, Ze.prototype.getType = function() {
      return this.g.type;
    }, Ze.prototype.getType = Ze.prototype.getType, Ze.prototype.sa = function() {
      return this.g.type === "mobile" || this.g.type === "fixed-line-or-mobile";
    }, Ze.prototype.isMobile = Ze.prototype.sa, Ze.prototype.ra = function() {
      return this.g.type === "fixed-line" || this.g.type === "fixed-line-or-mobile";
    }, Ze.prototype.isFixedLine = Ze.prototype.ra, Ze.prototype.ta = function(w) {
      return this.g.number[w ?? "e164"];
    }, Ze.prototype.getNumber = Ze.prototype.ta, Ze.prototype.va = function() {
      return this.g.regionCode;
    }, Ze.prototype.getRegionCode = Ze.prototype.va, Ze.prototype.ia = function() {
      return Uf(this.g.regionCode);
    }, Ze.prototype.getCountryCode = Ze.prototype.ia;
    function dn(w) {
      this.j = w, this.h = new bS(w), this.l = this.g = "";
    }
    dn.prototype.qa = function(w) {
      this.g += w;
      var C = this.h;
      return C.la = $S(C, w), this.l = C.la;
    }, dn.prototype.addChar = dn.prototype.qa, dn.prototype.za = function() {
      return this.l;
    }, dn.prototype.number = dn.prototype.za, dn.prototype.Aa = function() {
      return this.g === "" ? this.l : this.reset(this.g.slice(0, this.g.length - 1));
    }, dn.prototype.removeChar = dn.prototype.Aa, dn.prototype.reset = function(w) {
      var C = this.h;
      if (C.la = "", F(C.u), F(C.ba), F(C.$), C.aa = 0, C.da = "", F(C.h), C.s = "", F(C.g), C.v = !0, C.oa = !1, C.ca = !1, C.ea = !1, C.j = [], C.ha = !1, C.m != C.wa && (C.m = jf(C, C.ma)), this.l = this.g = "", w) {
        C = 0;
        for (var O = w.length; C < O; ++C) this.qa(w.charAt(C));
      }
      return this.l;
    }, dn.prototype.reset = dn.prototype.reset, dn.prototype.ua = function() {
      return new Ze(this.l, { regionCode: this.j }).toJSON();
    }, dn.prototype.getPhoneNumber = dn.prototype.ua;
  }).call(
    e.exports || typeof globalThis < "u" && globalThis || typeof zl < "u" && zl || typeof window < "u" && window || typeof self < "u" && self || zl
  );
})(N_);
var Sne = N_.exports;
N3.exports;
(function(e) {
  const t = "PhoneNumber$$module$src$index";
  e.exports = Sne[t] || (typeof globalThis < "u" && globalThis || typeof zl < "u" && zl || typeof window < "u" && window || typeof self < "u" && self || zl)[t], Object.defineProperty(
    e.exports,
    "__esModule",
    {
      value: !0
    }
  ), e.exports.parsePhoneNumber = (...r) => {
    try {
      const n = e.exports(...r).toJSON();
      return !n.valid && !n.possible && (n.possible = !1, n.possibility || (n.possibility = "invalid")), n;
    } catch (n) {
      return {
        valid: !1,
        possible: !1,
        possibility: "invalid",
        error: n
      };
    }
  }, e.exports.getCountryCodeForRegionCode = e.exports.getCountryCodeForRegionCode, e.exports.getRegionCodeForCountryCode = e.exports.getRegionCodeForCountryCode, e.exports.getSupportedCallingCodes = e.exports.getSupportedCallingCodes, e.exports.getSupportedRegionCodes = e.exports.getSupportedRegionCodes, e.exports.getExample = e.exports.getExample, e.exports.getAsYouType = e.exports.getAsYouType, e.exports.getNumberFrom = e.exports.getNumberFrom;
})(N3);
var Cne = N3.exports, D_ = /* @__PURE__ */ xne(Cne);
const {
  PhoneNumber: x2e,
  AsYouType: S2e,
  getCountryCodeForRegionCode: C2e,
  getRegionCodeForCountryCode: E2e,
  getSupportedCallingCodes: A2e,
  getSupportedRegionCodes: T2e,
  getExample: O2e,
  getAsYouType: I2e,
  getNumberFrom: P2e
} = D_, Ene = (...e) => {
  try {
    const t = D_(...e).toJSON();
    return !t.valid && !t.possible && (t.possible = !1, t.possibility || (t.possibility = "invalid")), t;
  } catch (t) {
    return {
      valid: !1,
      possible: !1,
      possibility: "invalid",
      error: t
    };
  }
};
var Ane = /* @__PURE__ */ k('<tr><td class="align-top py-1 w-20"></td><td class="align-top py-1">'), Tne = /* @__PURE__ */ k('<div class="flex items-center justify-between">'), ap = /* @__PURE__ */ k("<div>"), One = /* @__PURE__ */ k('<div class="sm:grid sm:grid-cols-2 sm:gap-2"><table class=table-auto><tbody></tbody></table><table class=table-auto><tbody>'), Ine = /* @__PURE__ */ k('<div class="pt-2 mp-mask"data-dd-privacy=mask>'), Pne = /* @__PURE__ */ k("<div>N/A");
const Nne = Ge`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      name {
        full
      }
      email
      phone
      sex
      gender
      dateOfBirth
      address {
        id
        street1
        street2
        city
        state
        postalCode
      }
    }
  }
`, Ko = (e) => (() => {
  var t = Ane(), r = t.firstChild, n = r.nextSibling;
  return E(r, g(Ee, {
    size: "sm",
    color: "gray",
    get children() {
      return e.label;
    }
  })), E(n, () => e.children), t;
})();
function Dne(e) {
  const t = Kn(), [r, n] = V(void 0), i = async () => {
    const {
      data: s
    } = await t.apollo.query({
      query: Nne,
      variables: {
        id: e.patientId
      }
    });
    s?.patient && n(s?.patient);
  };
  fe(() => {
    e.patientId && i();
  });
  const a = K(() => e.address || r()?.address), o = K(() => {
    if (r()?.phone) {
      const s = Ene(r()?.phone);
      return s.valid ? s.number.national : r()?.phone;
    }
    return "";
  });
  return g(Mn, {
    addChildrenDivider: !0,
    get children() {
      return [(() => {
        var s = Tne();
        return E(s, g(Ee, {
          color: "gray",
          children: "Patient Info"
        }), null), E(s, g(H, {
          get when() {
            return e?.editPatient;
          },
          get children() {
            return g(xt, {
              variant: "secondary",
              size: "sm",
              get onClick() {
                return e?.editPatient;
              },
              children: "Edit patient"
            });
          }
        }), null), s;
      })(), (() => {
        var s = Ine();
        return E(s, g(Ee, {
          size: "lg",
          bold: !0,
          get loading() {
            return !r();
          },
          sampleLoadingText: "Sally Patient",
          get children() {
            return r()?.name.full || "N/A";
          }
        }), null), E(s, g(Ok, {
          openLabel: "Show less",
          closedLabel: "Show more",
          class: "sm:block",
          buttonClass: "mt-2 sm:hidden",
          get children() {
            var l = One(), d = l.firstChild, c = d.firstChild, u = d.nextSibling, h = u.firstChild;
            return E(c, g(Ko, {
              label: "Email",
              get children() {
                return g(Ee, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "fake@email.com",
                  get children() {
                    return r()?.email || "N/A";
                  }
                });
              }
            }), null), E(c, g(Ko, {
              label: "Phone",
              get children() {
                return g(Ee, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "555-555-5555",
                  get children() {
                    return o() || "N/A";
                  }
                });
              }
            }), null), E(c, g(Ko, {
              label: "Address",
              get children() {
                return g(H, {
                  get when() {
                    return !r() || a();
                  },
                  get fallback() {
                    return Pne();
                  },
                  get children() {
                    return [(() => {
                      var f = ap();
                      return E(f, g(Ee, {
                        size: "sm",
                        get loading() {
                          return !r();
                        },
                        sampleLoadingText: "123 Fake St",
                        get children() {
                          return a()?.street1;
                        }
                      })), f;
                    })(), g(H, {
                      get when() {
                        return !r() || a()?.street2;
                      },
                      get children() {
                        var f = ap();
                        return E(f, g(Ee, {
                          size: "sm",
                          get loading() {
                            return !r();
                          },
                          sampleLoadingText: "Apt 3",
                          get children() {
                            return a()?.street2;
                          }
                        })), f;
                      }
                    }), (() => {
                      var f = ap();
                      return E(f, g(Ee, {
                        size: "sm",
                        get loading() {
                          return !r();
                        },
                        sampleLoadingText: "Brooklyn, NY 11221",
                        get children() {
                          return [Ut(() => a()?.city), ", ", Ut(() => a()?.state), " ", Ut(() => a()?.postalCode)];
                        }
                      })), f;
                    })()];
                  }
                });
              }
            }), null), E(h, g(Ko, {
              label: "DOB",
              get children() {
                return g(Ee, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "female",
                  get children() {
                    return vf(r()?.dateOfBirth || "N/A");
                  }
                });
              }
            }), null), E(h, g(Ko, {
              label: "Weight",
              get children() {
                return g(Ee, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "150 lbs",
                  get children() {
                    return e?.weight ? `${e.weight} ${e.weightUnit}` : "N/A";
                  }
                });
              }
            }), null), E(h, g(Ko, {
              label: "Sex",
              get children() {
                return g(Ee, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "female",
                  get children() {
                    return r()?.sex || "N/A";
                  }
                });
              }
            }), null), E(h, g(Ko, {
              label: "Gender",
              get children() {
                return g(Ee, {
                  size: "sm",
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "female",
                  get children() {
                    return r()?.gender || "N/A";
                  }
                });
              }
            }), null), l;
          }
        }), null), s;
      })()];
    }
  });
}
var Mne = /* @__PURE__ */ k('<button class="text-gray-700 hover:text-gray-900 hover:bg-blue-50 rounded-md p-2 disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-gray-700 disabled:cursor-not-allowed"type=button>');
const Rne = (e) => {
  const t = it({
    size: "md"
  }, e), r = (() => {
    var n = Mne();
    return n.$$click = () => {
      e.loading || e.onClick();
    }, E(n, g(H, {
      get when() {
        return !e.loading;
      },
      get children() {
        return g(mt, {
          get name() {
            return e.iconName;
          },
          get size() {
            return t.iconSize;
          }
        });
      }
    }), null), E(n, g(H, {
      get when() {
        return e.loading;
      },
      get children() {
        return g(aa, {
          get size() {
            return t.iconSize;
          }
        });
      }
    }), null), se((i) => {
      var a = e.label, o = e.disabled;
      return a !== i.e && pt(n, "aria-label", i.e = a), o !== i.t && (n.disabled = i.t = o), i;
    }, {
      e: void 0,
      t: void 0
    }), n;
  })();
  return Ut(() => Ut(() => !!e.disabled)() ? r : g(k_, {
    get text() {
      return e.label;
    },
    children: r
  }));
};
an(["click"]);
var Lne = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-3.5">Actions'), Fne = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 col-span-3 text-center">'), jne = /* @__PURE__ */ k('<div class="grid w-full text-xs relative"><div><div class="px-4 sm:px-6 py-3.5">Medication</div><div class="px-4 sm:px-6 py-3.5 cursor-pointer flex">Written<div class=ml-1>'), zne = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 truncate"><div class="flex-col flex-1 min-w-0 whitespace-normal"><div class="text-gray-500 text-ellipsis overflow-hidden">'), Vne = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 self-center">'), Une = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 m-auto">'), op = /* @__PURE__ */ k('<div class="px-4 sm:px-6 py-4 select-none">'), qne = /* @__PURE__ */ k('<div class="text-ellipsis overflow-hidden">'), Bne = /* @__PURE__ */ k('<a class="text-ellipsis block overflow-hidden text-blue-500 underline"target=_blank>');
function Hne(e) {
  const t = Cre(), [r, n] = V(void 0), i = K(() => e.enableRefillButton), a = K(() => Yt("grid grid-cols-subgrid border-b text-xs font-semibold text-gray-900 sticky top-0 bg-white z-10", {
    "col-span-3": i(),
    "col-span-2": !i()
  })), o = async (s, l) => {
    if (r() === void 0) {
      if (n(s.id), !t)
        throw new Error("Refill requires <DraftPrescriptionsProvider>");
      try {
        await t.tryCreatePrescription({
          ...s,
          treatment: l,
          diagnoseCodes: s.diagnoses?.map((d) => d.code) || []
        }, void 0, "med_history_refill");
      } finally {
        n(void 0);
      }
    }
  };
  return (() => {
    var s = jne(), l = s.firstChild, d = l.firstChild, c = d.nextSibling, u = c.firstChild, h = u.nextSibling;
    return c.$$click = () => e.onSortOrderToggle(), E(h, g(H, {
      get when() {
        return e.sortOrder === "desc";
      },
      get children() {
        return g(mt, {
          name: "chevronDown",
          size: "sm"
        });
      }
    }), null), E(h, g(H, {
      get when() {
        return e.sortOrder === "asc";
      },
      get children() {
        return g(mt, {
          name: "chevronUp",
          size: "sm"
        });
      }
    }), null), E(l, g(H, {
      get when() {
        return e.enableRefillButton;
      },
      get children() {
        return Lne();
      }
    }), null), E(s, g(H, {
      get when() {
        return !e.isLoading && e.rowItems;
      },
      get fallback() {
        return [g(sp, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        }), g(sp, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        }), g(sp, {
          get enableRefill() {
            return e.enableRefillButton;
          }
        })];
      },
      get children() {
        return g(yt, {
          get each() {
            return e.rowItems;
          },
          children: (f) => [(() => {
            var p = zne(), m = p.firstChild, y = m.firstChild;
            return E(m, g(Qne, {
              get treatmentName() {
                return f.treatment.name;
              },
              get prescriptionId() {
                return f.prescription?.id;
              },
              get enableLinks() {
                return e.enableLinks;
              },
              get linkBaseUrl() {
                return e.baseURL;
              }
            }), y), E(y, () => hae(f.prescription)), p;
          })(), (() => {
            var p = Vne();
            return E(p, () => Wne(f)), p;
          })(), g(H, {
            get when() {
              return e.enableRefillButton;
            },
            get children() {
              var p = Une();
              return E(p, g(Rne, {
                iconName: "documentPlus",
                iconSize: "sm",
                label: "Refill",
                onClick: () => {
                  f.prescription && o(f.prescription, f.treatment);
                },
                get disabled() {
                  return !f.prescription;
                },
                get loading() {
                  return Ut(() => !!f.prescription)() && r() === f.prescription.id;
                }
              })), p;
            }
          })]
        });
      }
    }), null), E(s, g(H, {
      get when() {
        return !e.isLoading && e.rowItems && e.rowItems.length === 0;
      },
      get children() {
        var f = Fne();
        return E(f, g(Ee, {
          color: "gray",
          children: "No medication history found."
        })), f;
      }
    }), null), se((f) => {
      var p = `1fr min-content ${i() ? "min-content" : ""}`, m = a();
      return p !== f.e && ((f.e = p) != null ? s.style.setProperty("grid-template-columns", p) : s.style.removeProperty("grid-template-columns")), m !== f.t && ft(l, f.t = m), f;
    }, {
      e: void 0,
      t: void 0
    }), s;
  })();
}
const sp = (e) => [(() => {
  var t = op();
  return E(t, g(Ee, {
    get sampleLoadingText() {
      return uae(10, 25);
    },
    loading: !0
  })), t;
})(), (() => {
  var t = op();
  return E(t, g(Ee, {
    sampleLoadingText: "aaaaa",
    loading: !0
  })), t;
})(), g(H, {
  get when() {
    return e.enableRefill;
  },
  get children() {
    var t = op();
    return E(t, g(Ee, {
      sampleLoadingText: "aaa",
      loading: !0
    })), t;
  }
})];
function Wne(e) {
  return e.prescription ? vf(e.prescription?.writtenAt) || "N/A" : "External";
}
const Qne = (e) => {
  const t = K(() => e.enableLinks && !!e.prescriptionId);
  return [g(H, {
    get when() {
      return !t();
    },
    get children() {
      var r = qne();
      return E(r, () => e.treatmentName), r;
    }
  }), g(H, {
    get when() {
      return t();
    },
    get children() {
      var r = Bne();
      return E(r, () => e.treatmentName), se(() => pt(r, "href", `${e.linkBaseUrl}${e.prescriptionId}`)), r;
    }
  })];
};
an(["click"]);
var Kne = /* @__PURE__ */ k('<div class="flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4">'), Gne = /* @__PURE__ */ k('<div class="max-h-80 overflow-y-auto">');
const q0 = Ge`
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      treatmentHistory {
        active
        prescription {
          id
          writtenAt
          instructions
          notes
          fillsAllowed
          dispenseQuantity
          dispenseUnit
          dispenseAsWritten
          daysSupply
        }
        treatment {
          id
          name
        }
      }
    }
  }
`, Zne = Ge`
  mutation UpdateMedicationHistory($id: ID!, $medicationHistory: [MedHistoryInput!]!) {
    updatePatient(id: $id, medicationHistory: $medicationHistory) {
      id
    }
  }
`;
function M_(e) {
  const t = Kn(), [r, n] = V(void 0), [i, a] = V("asc"), o = K(() => `${t?.clinicalUrl}/prescriptions/`), s = K(() => ({
    variables: {
      id: e.patientId
    },
    client: t.apolloClinical,
    skip: !e.patientId,
    fetchPolicy: "network-only",
    refetchQueries: [q0]
  })), l = gh(q0, s);
  fe(() => {
    const c = l();
    if (l.loading)
      n(void 0);
    else if (c) {
      const u = Yne(c).slice().sort(Jne(i()));
      n(u);
    } else
      n([]);
  });
  const d = async (c) => {
    const u = (p) => {
      const m = {
        __typename: "PatientMedication",
        treatment: {
          __typename: "Treatment",
          ...e.newMedication
        },
        active: !1,
        prescription: null
      }, y = p.readQuery({
        query: q0,
        variables: {
          id: e.patientId
        }
      })?.patient?.treatmentHistory ?? [];
      p.writeQuery({
        query: q0,
        variables: {
          id: e.patientId
        },
        data: {
          patient: {
            __typename: "Patient",
            id: e.patientId,
            treatmentHistory: [m, ...y]
          }
        }
      });
    }, h = {
      active: !1
    };
    if (c.startsWith("dme_"))
      h.medicalEquipmentId = c;
    else if (c.startsWith("med_"))
      h.medicationId = c;
    else {
      rr({
        header: `Invalid Treatment Id ${c}`,
        body: "The treatment Id is not valid.",
        status: "error"
      }), console.error(`Invalid Treatment Id ${c}`);
      return;
    }
    await t.apollo.mutate({
      mutation: Zne,
      variables: {
        id: e.patientId,
        medicationHistory: [h]
      },
      update: u
    });
    const f = {
      treatment: e.newMedication,
      prescription: void 0
    };
    n((p) => p ? [f, ...p] : [f]), rr({
      header: "Medication Added",
      body: "Medication has been added to patients history.",
      status: "success"
    }), e.hideAddMedicationDialog?.();
  };
  return fe(() => {
    e?.newMedication?.id && d(e.newMedication.id);
  }), g(Mn, {
    addChildrenDivider: !0,
    autoPadding: !1,
    get children() {
      return [(() => {
        var c = Kne();
        return E(c, g(Ee, {
          color: "gray",
          children: "Medication History"
        }), null), E(c, g(H, {
          get when() {
            return e?.openAddMedicationDialog;
          },
          get children() {
            return g(xt, {
              variant: "secondary",
              size: "sm",
              get onClick() {
                return e?.openAddMedicationDialog;
              },
              children: "+ Add"
            });
          }
        }), null), c;
      })(), (() => {
        var c = Gne();
        return E(c, g(Hne, {
          get enableLinks() {
            return e.enableLinks;
          },
          get enableRefillButton() {
            return e.enableRefillButton;
          },
          get baseURL() {
            return o();
          },
          get rowItems() {
            return r();
          },
          get isLoading() {
            return l.loading;
          },
          get sortOrder() {
            return i();
          },
          onSortOrderToggle: () => a((u) => u === "asc" ? "desc" : "asc")
        })), c;
      })()];
    }
  });
}
const Yne = (e) => e?.patient?.treatmentHistory.map((t) => ({
  treatment: t.treatment,
  prescription: t.prescription
})), Jne = (e) => (t, r) => {
  const n = t?.prescription?.writtenAt ? new Date(t.prescription.writtenAt).getTime() : -1 / 0, i = r?.prescription?.writtenAt ? new Date(r.prescription.writtenAt).getTime() : -1 / 0;
  return e === "desc" ? n - i : i - n;
};
async function Xne(e = {}) {
  return new Promise((t, r) => {
    "geolocation" in navigator ? navigator.geolocation.getCurrentPosition(
      t,
      (n) => {
        r(n);
      },
      e
    ) : r(new Error("Geolocation not supported"));
  });
}
const eie = async (e, t) => {
  const r = {
    input: e,
    types: ["geocode"],
    componentRestrictions: { country: "us" }
  };
  return (await t.getPlacePredictions(r)).predictions.map((n) => ({
    value: n.place_id,
    label: n.description
  }));
};
var tie = /* @__PURE__ */ k("<div class=text-left><h3 class=mt-0>Set Location</h3><div class=mt-2><p class=text-sm>Enter the zipcode or address where you'd like to search for a pharmacy."), rie = /* @__PURE__ */ k('<div class="mt-5 sm:mt-6 grid grid-cols-1">'), nie = /* @__PURE__ */ k('<div class="flex items-center gap-2 py-2"><hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700 w-full"><p>OR</p><hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700 w-full">'), iie = /* @__PURE__ */ k('<p class="text-sm text-red-500 mt-2 text-center">Could not get current location');
function aie(e) {
  const [t, r] = V(""), [n, i] = V(!1), [a, o] = V(!1), [s, l] = V([]), {
    googleMapsServices: d
  } = u3(), c = async (f) => {
    if (!f) return;
    const {
      geocoder: p
    } = d();
    if (!p) return;
    o(!1);
    const m = await vh(f.label, p);
    m.length > 0 && (e.setLocation(m[0]), e.setOpen(!1));
  }, u = async () => {
    const {
      geocoder: f
    } = d();
    if (!f) throw new Error("Geocoder not loaded");
    i(!0), o(!1);
    try {
      const {
        coords: {
          latitude: p,
          longitude: m
        }
      } = await Xne({
        timeout: 5e3
      }), y = await vh({
        latitude: p,
        longitude: m
      }, f);
      y.length > 0 && e.setLocation(y[0]), e.setOpen(!1);
    } catch {
      o(!0);
    }
    i(!1);
  }, h = async () => {
    const {
      autocompleteService: f
    } = d();
    if (!f) return;
    const p = await eie(t(), f);
    l(p);
  };
  return fe(() => {
    t() && h();
  }), g(zs, {
    get open() {
      return e.open;
    },
    onClose: () => e.setOpen(!1),
    get children() {
      return [tie(), (() => {
        var f = rie();
        return E(f, g(xt, {
          variant: "tertiary",
          onClick: u,
          get iconLeft() {
            return Ut(() => !!n())() ? g(aa, {
              size: "sm"
            }) : g(mt, {
              name: "mapPin",
              size: "sm"
            });
          },
          get children() {
            return n() ? "Getting Current Location" : "Use my Current Location";
          }
        }), null), E(f, (() => {
          var p = Ut(() => !!a());
          return () => p() && iie();
        })(), null), f;
      })(), nie(), g(at, {
        label: "Enter an address or zip code",
        get children() {
          return g(_r, {
            setSelected: c,
            get children() {
              return [g(_r.Input, {
                displayValue: (f) => f?.label ?? "",
                onInput: (f) => r(f.currentTarget.value)
              }), g(H, {
                get when() {
                  return s()?.length > 0;
                },
                get children() {
                  return g(_r.Options, {
                    get children() {
                      return g(yt, {
                        get each() {
                          return s();
                        },
                        children: (f) => {
                          const p = f.value ?? f.label;
                          return g(_r.Option, {
                            key: p,
                            get value() {
                              return {
                                id: p,
                                label: f.label
                              };
                            },
                            get children() {
                              return f.label;
                            }
                          });
                        }
                      });
                    }
                  });
                }
              })];
            }
          });
        }
      })];
    }
  });
}
const lp = (e) => e.toLowerCase().split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
function R_(e) {
  if (!e) return "";
  const { city: t, postalCode: r, state: n, street1: i, street2: a } = e;
  return `${lp(i)}${a ? `, ${lp(a)}` : ""}, ${lp(
    t
  )}, ${n} ${r || ""}`;
}
function Mm(e) {
  return e.split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()).join(" ");
}
var oie = /* @__PURE__ */ k("<div class=p-4>No pharmacy matches that search"), sie = /* @__PURE__ */ k('<div class="flex gap-x-1">'), lie = /* @__PURE__ */ k('<div class="flex gap-x-1 items-center"> '), die = /* @__PURE__ */ k("<div class=text-xs>");
const cie = (e) => `${Mm(e.address?.street1 || "")}, ${Mm(e.address?.city || "")}, ${e.address?.state}`;
function L_(e) {
  return g(at, {
    get label() {
      return e.label;
    },
    get helpText() {
      return e.helpText || (e.value?.isPreferred || e.value?.isPrevious) && (() => {
        var t = sie();
        return E(t, g(H, {
          get when() {
            return e.value?.isPreferred;
          },
          get children() {
            return g(Al, {
              size: "sm",
              color: "blue",
              children: "Preferred"
            });
          }
        }), null), E(t, g(H, {
          get when() {
            return !e.value?.isPreferred && e.value?.isPrevious;
          },
          get children() {
            return g(Al, {
              size: "sm",
              color: "green",
              children: "Previous"
            });
          }
        }), null), t;
      })();
    },
    get loading() {
      return e.loading;
    },
    get children() {
      return g(_r, {
        get value() {
          return e.value;
        },
        setSelected: (t) => t && e.setValue(t),
        get children() {
          return [g(_r.Input, {
            onInput: (t) => e.onSearch?.(t.currentTarget.value),
            displayValue: (t) => t?.name ? `${t.name}, ${Mm(t.address?.street1 || "")}` : ""
          }), g(_r.Options, {
            get children() {
              return [g(H, {
                get when() {
                  return (e.options?.length || 0) > 0;
                },
                get children() {
                  return g(yt, {
                    get each() {
                      return e.options;
                    },
                    children: (t) => g(_r.Option, {
                      get key() {
                        return t.id;
                      },
                      value: t,
                      get children() {
                        return [(() => {
                          var r = lie(), n = r.firstChild;
                          return E(r, () => t.name, n), E(r, g(H, {
                            get when() {
                              return t.isPreferred;
                            },
                            get children() {
                              return g(Al, {
                                size: "sm",
                                color: "blue",
                                children: "Preferred"
                              });
                            }
                          }), null), E(r, g(H, {
                            get when() {
                              return !t.isPreferred && t.isPrevious;
                            },
                            get children() {
                              return g(Al, {
                                size: "sm",
                                color: "green",
                                children: "Previous"
                              });
                            }
                          }), null), r;
                        })(), (() => {
                          var r = die();
                          return E(r, () => cie(t)), r;
                        })()];
                      }
                    })
                  });
                }
              }), g(H, {
                get when() {
                  return e.options?.length === 0;
                },
                get children() {
                  return oie();
                }
              })];
            }
          })];
        }
      });
    }
  });
}
var uie = /* @__PURE__ */ k("<div class=mt-4>"), hie = /* @__PURE__ */ k("<div>"), fie = /* @__PURE__ */ k('<button type=button aria-label="Set a location"class="text-left truncate text-blue-600 font-semibold text-sm flex items-center">'), pie = /* @__PURE__ */ k('<div class="w-full flex flex-col sm:flex-row sm:items-center mb-2"><label class="whitespace-nowrap mr-1">Showing near:');
const F_ = Ge`
  query GetLastOrder($id: ID!) {
    orders(filter: { patientId: $id }, first: 1) {
      createdAt
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`;
function j_(e) {
  const t = Kn(), {
    googleMapsServices: r
  } = u3(), [n, i] = V(e.initialValue), [a, o] = V(""), [s, l] = V(null), [d, c] = V(null), [u, h] = V([]), [f, p] = V(!1), [m, y] = V(!1), [v, b] = V(!1), [$, _] = V(null), [x, S] = V("");
  async function A() {
    const {
      data: j
    } = await t.apollo.query({
      query: E_,
      variables: {
        location: {
          latitude: s()?.latitude,
          longitude: s()?.longitude
        }
      }
    });
    j?.pharmacies?.length > 0 && c(j.pharmacies.map((F) => ({
      ...F,
      isPreferred: !1
    }))), p(!1);
  }
  async function N(j) {
    y(!0);
    try {
      const {
        data: F
      } = await t.apollo.query({
        query: I3,
        variables: {
          id: j
        }
      }), {
        data: Z
      } = await t.apollo.query({
        query: F_,
        variables: {
          id: j
        }
      }), te = F?.patient?.address;
      if (te) {
        const Y = R_(te);
        await I(Y);
      }
      F?.patient?.preferredPharmacies?.length > 0 && h(F?.patient?.preferredPharmacies.map((Y) => ({
        ...Y,
        isPreferred: !0
      }))), Z?.orders?.length > 0 && _(Z?.orders?.[0]?.pharmacy?.id);
    } catch (F) {
      console.error("Error fetching preferred and previous pharmacies:", F);
    } finally {
      y(!1);
    }
  }
  const P = K(() => {
    const j = d() || [];
    return u().filter((F) => j.some((Z) => Z.id === F.id));
  }), D = K(() => {
    const j = d() || [], F = P(), Z = $(), te = [...F, ...j].reduce((Y, Q) => {
      if (!Y[Q.id]) {
        const R = Z === Q.id;
        Y[Q.id] = {
          ...Q,
          isPrevious: R
        };
      }
      return Y;
    }, {});
    return Object.values(te);
  });
  fe(() => {
    s()?.latitude && s()?.longitude && (c(null), p(!0), A());
  });
  const T = K(() => D() === null || D()?.length === 0 ? [] : a() === "" ? D() : D()?.filter((j) => j.name.toLowerCase().includes(a().toLowerCase())) || []);
  fe(() => {
    n()?.id && (o(""), e?.setPharmacy?.(n()));
  });
  async function I(j) {
    const {
      geocoder: F
    } = r();
    if (!F) throw new Error("Geocoder not loaded");
    const Z = await vh(j || "", F);
    Z.length > 0 && l(Z[0]);
  }
  return fe(() => {
    e?.patientId && N(e?.patientId);
  }), fe(() => {
    const j = e?.address;
    if (j && j !== x()) {
      p(!0);
      const F = setTimeout(() => {
        S(j), I(j);
      }, 500);
      sr(() => clearTimeout(F));
    }
  }), fe(() => {
    const j = !n()?.id, F = P()?.length > 0, Z = D()?.[0];
    j && F && Z && i(Z);
  }), (() => {
    var j = hie();
    return E(j, g(aie, {
      setLocation: l,
      get open() {
        return v();
      },
      setOpen: b
    }), null), E(j, g(L_, {
      get value() {
        return Ut(() => !!n()?.id)() ? n() : void 0;
      },
      setValue: i,
      get options() {
        return T();
      },
      onSearch: o,
      get loading() {
        return f();
      },
      get label() {
        return (() => {
          var F = pie();
          return F.firstChild, E(F, g(H, {
            get when() {
              return !m();
            },
            get fallback() {
              return g(aa, {
                size: "sm"
              });
            },
            get children() {
              var Z = fie();
              return Z.$$click = () => b(!0), E(Z, g(mt, {
                name: "mapPin",
                size: "sm",
                class: "inline-block mr-1"
              }), null), E(Z, () => s()?.address || "Set a location", null), Z;
            }
          }), null), F;
        })();
      }
    }), null), E(j, g(H, {
      get when() {
        return Ut(() => !!(!e?.hidePreferred && !f() && !m() && n()))() && !n()?.isPreferred;
      },
      get children() {
        var F = uie();
        return E(F, g(im, {
          id: "set-preferred-pharmacy",
          mainText: "Set as preferred pharmacy",
          checked: !1,
          onChange: (Z) => e?.setPreferred?.(Z)
        })), F;
      }
    }), null), j;
  })();
}
an(["click"]);
var Es = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, z_ = {}, D3 = {};
Object.defineProperty(D3, "__esModule", { value: !0 });
var mie = (function() {
  function e() {
    var t = this;
    this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(r, n) {
      var i = t.locked.get(r);
      i === void 0 ? n === void 0 ? t.locked.set(r, []) : t.locked.set(r, [n]) : n !== void 0 && (i.unshift(n), t.locked.set(r, i));
    }, this.isLocked = function(r) {
      return t.locked.has(r);
    }, this.lock = function(r) {
      return new Promise((function(n, i) {
        t.isLocked(r) ? t.addToLocked(r, n) : (t.addToLocked(r), n());
      }));
    }, this.unlock = function(r) {
      var n = t.locked.get(r);
      if (n !== void 0 && n.length !== 0) {
        var i = n.pop();
        t.locked.set(r, n), i !== void 0 && setTimeout(i, 0);
      } else t.locked.delete(r);
    };
  }
  return e.getInstance = function() {
    return e.instance === void 0 && (e.instance = new e()), e.instance;
  }, e;
})();
D3.default = function() {
  return mie.getInstance();
};
var bi = Es && Es.__awaiter || function(e, t, r, n) {
  return new (r || (r = Promise))((function(i, a) {
    function o(d) {
      try {
        l(n.next(d));
      } catch (c) {
        a(c);
      }
    }
    function s(d) {
      try {
        l(n.throw(d));
      } catch (c) {
        a(c);
      }
    }
    function l(d) {
      d.done ? i(d.value) : new r((function(c) {
        c(d.value);
      })).then(o, s);
    }
    l((n = n.apply(e, t || [])).next());
  }));
}, wi = Es && Es.__generator || function(e, t) {
  var r, n, i, a, o = { label: 0, sent: function() {
    if (1 & i[0]) throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(d) {
      return (function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; o; ) try {
          if (r = 1, n && (i = 2 & c[0] ? n.return : c[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, c[1])).done) return i;
          switch (n = 0, i && (c = [2 & c[0], i.value]), c[0]) {
            case 0:
            case 1:
              i = c;
              break;
            case 4:
              return o.label++, { value: c[1], done: !1 };
            case 5:
              o.label++, n = c[1], c = [0];
              continue;
            case 7:
              c = o.ops.pop(), o.trys.pop();
              continue;
            default:
              if (i = o.trys, !((i = i.length > 0 && i[i.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                o = 0;
                continue;
              }
              if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
                o.label = c[1];
                break;
              }
              if (c[0] === 6 && o.label < i[1]) {
                o.label = i[1], i = c;
                break;
              }
              if (i && o.label < i[2]) {
                o.label = i[2], o.ops.push(c);
                break;
              }
              i[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          c = t.call(e, o);
        } catch (u) {
          c = [6, u], n = 0;
        } finally {
          r = i = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      })([l, d]);
    };
  }
}, ic = Es;
Object.defineProperty(z_, "__esModule", { value: !0 });
var Js = D3, B0 = { key: function(e) {
  return bi(ic, void 0, void 0, (function() {
    return wi(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, getItem: function(e) {
  return bi(ic, void 0, void 0, (function() {
    return wi(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, clear: function() {
  return bi(ic, void 0, void 0, (function() {
    return wi(this, (function(e) {
      return [2, window.localStorage.clear()];
    }));
  }));
}, removeItem: function(e) {
  return bi(ic, void 0, void 0, (function() {
    return wi(this, (function(t) {
      throw new Error("Unsupported");
    }));
  }));
}, setItem: function(e, t) {
  return bi(ic, void 0, void 0, (function() {
    return wi(this, (function(r) {
      throw new Error("Unsupported");
    }));
  }));
}, keySync: function(e) {
  return window.localStorage.key(e);
}, getItemSync: function(e) {
  return window.localStorage.getItem(e);
}, clearSync: function() {
  return window.localStorage.clear();
}, removeItemSync: function(e) {
  return window.localStorage.removeItem(e);
}, setItemSync: function(e, t) {
  return window.localStorage.setItem(e, t);
} };
function dp(e) {
  return new Promise((function(t) {
    return setTimeout(t, e);
  }));
}
function cp(e) {
  for (var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", r = "", n = 0; n < e; n++)
    r += t[Math.floor(Math.random() * t.length)];
  return r;
}
var gie = (function() {
  function e(t) {
    this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + cp(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, e.waiters === void 0 && (e.waiters = []);
  }
  return e.prototype.acquireLock = function(t, r) {
    return r === void 0 && (r = 5e3), bi(this, void 0, void 0, (function() {
      var n, i, a, o, s, l, d;
      return wi(this, (function(c) {
        switch (c.label) {
          case 0:
            n = Date.now() + cp(4), i = Date.now() + r, a = "browser-tabs-lock-key-" + t, o = this.storageHandler === void 0 ? B0 : this.storageHandler, c.label = 1;
          case 1:
            return Date.now() < i ? [4, dp(30)] : [3, 8];
          case 2:
            return c.sent(), o.getItemSync(a) !== null ? [3, 5] : (s = this.id + "-" + t + "-" + n, [4, dp(Math.floor(25 * Math.random()))]);
          case 3:
            return c.sent(), o.setItemSync(a, JSON.stringify({ id: this.id, iat: n, timeoutKey: s, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, dp(30)];
          case 4:
            return c.sent(), (l = o.getItemSync(a)) !== null && (d = JSON.parse(l)).id === this.id && d.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(a, n), [2, !0]) : [3, 7];
          case 5:
            return e.lockCorrector(this.storageHandler === void 0 ? B0 : this.storageHandler), [4, this.waitForSomethingToChange(i)];
          case 6:
            c.sent(), c.label = 7;
          case 7:
            return n = Date.now() + cp(4), [3, 1];
          case 8:
            return [2, !1];
        }
      }));
    }));
  }, e.prototype.refreshLockWhileAcquired = function(t, r) {
    return bi(this, void 0, void 0, (function() {
      var n = this;
      return wi(this, (function(i) {
        return setTimeout((function() {
          return bi(n, void 0, void 0, (function() {
            var a, o, s;
            return wi(this, (function(l) {
              switch (l.label) {
                case 0:
                  return [4, Js.default().lock(r)];
                case 1:
                  return l.sent(), this.acquiredIatSet.has(r) ? (a = this.storageHandler === void 0 ? B0 : this.storageHandler, (o = a.getItemSync(t)) === null ? (Js.default().unlock(r), [2]) : ((s = JSON.parse(o)).timeRefreshed = Date.now(), a.setItemSync(t, JSON.stringify(s)), Js.default().unlock(r), this.refreshLockWhileAcquired(t, r), [2])) : (Js.default().unlock(r), [2]);
              }
            }));
          }));
        }), 1e3), [2];
      }));
    }));
  }, e.prototype.waitForSomethingToChange = function(t) {
    return bi(this, void 0, void 0, (function() {
      return wi(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, new Promise((function(n) {
              var i = !1, a = Date.now(), o = !1;
              function s() {
                if (o || (window.removeEventListener("storage", s), e.removeFromWaiting(s), clearTimeout(l), o = !0), !i) {
                  i = !0;
                  var d = 50 - (Date.now() - a);
                  d > 0 ? setTimeout(n, d) : n(null);
                }
              }
              window.addEventListener("storage", s), e.addToWaiting(s);
              var l = setTimeout(s, Math.max(0, t - Date.now()));
            }))];
          case 1:
            return r.sent(), [2];
        }
      }));
    }));
  }, e.addToWaiting = function(t) {
    this.removeFromWaiting(t), e.waiters !== void 0 && e.waiters.push(t);
  }, e.removeFromWaiting = function(t) {
    e.waiters !== void 0 && (e.waiters = e.waiters.filter((function(r) {
      return r !== t;
    })));
  }, e.notifyWaiters = function() {
    e.waiters !== void 0 && e.waiters.slice().forEach((function(t) {
      return t();
    }));
  }, e.prototype.releaseLock = function(t) {
    return bi(this, void 0, void 0, (function() {
      return wi(this, (function(r) {
        switch (r.label) {
          case 0:
            return [4, this.releaseLock__private__(t)];
          case 1:
            return [2, r.sent()];
        }
      }));
    }));
  }, e.prototype.releaseLock__private__ = function(t) {
    return bi(this, void 0, void 0, (function() {
      var r, n, i, a;
      return wi(this, (function(o) {
        switch (o.label) {
          case 0:
            return r = this.storageHandler === void 0 ? B0 : this.storageHandler, n = "browser-tabs-lock-key-" + t, (i = r.getItemSync(n)) === null ? [2] : (a = JSON.parse(i)).id !== this.id ? [3, 2] : [4, Js.default().lock(a.iat)];
          case 1:
            o.sent(), this.acquiredIatSet.delete(a.iat), r.removeItemSync(n), Js.default().unlock(a.iat), e.notifyWaiters(), o.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, e.lockCorrector = function(t) {
    for (var r = Date.now() - 5e3, n = t, i = [], a = 0; ; ) {
      var o = n.keySync(a);
      if (o === null) break;
      i.push(o), a++;
    }
    for (var s = !1, l = 0; l < i.length; l++) {
      var d = i[l];
      if (d.includes("browser-tabs-lock-key")) {
        var c = n.getItemSync(d);
        if (c !== null) {
          var u = JSON.parse(c);
          (u.timeRefreshed === void 0 && u.timeAcquired < r || u.timeRefreshed !== void 0 && u.timeRefreshed < r) && (n.removeItemSync(d), s = !0);
        }
      }
    }
    s && e.notifyWaiters();
  }, e.waiters = void 0, e;
})();
z_.default = gie;
new TextEncoder();
new TextDecoder();
var V6 = Es && Es.__assign || function() {
  return V6 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, V6.apply(this, arguments);
}, U6;
(function(e) {
  e.Code = "code", e.ConnectCode = "connect_code";
})(U6 || (U6 = {}));
var q6;
(function(e) {
  e.Bearer = "Bearer", e.DPoP = "DPoP";
})(q6 || (q6 = {}));
function gt(e, t, r) {
  return (t = (function(n) {
    var i = (function(a, o) {
      if (typeof a != "object" || !a) return a;
      var s = a[Symbol.toPrimitive];
      if (s !== void 0) {
        var l = s.call(a, o);
        if (typeof l != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(a);
    })(n, "string");
    return typeof i == "symbol" ? i : i + "";
  })(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var H0, up;
typeof navigator > "u" || (H0 = navigator.userAgent) === null || H0 === void 0 || (up = H0.startsWith) === null || up === void 0 || up.call(H0, "Mozilla/5.0 ");
new TextEncoder();
new TextDecoder();
new TextEncoder();
new TextDecoder();
class kn extends Error {
  constructor(t, r) {
    var n;
    super(t, r), gt(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}
gt(kn, "code", "ERR_JOSE_GENERIC");
class vie extends kn {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), gt(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), gt(this, "claim", void 0), gt(this, "reason", void 0), gt(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
}
gt(vie, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
class yie extends kn {
  constructor(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unspecified", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unspecified";
    super(t, { cause: { claim: n, reason: i, payload: r } }), gt(this, "code", "ERR_JWT_EXPIRED"), gt(this, "claim", void 0), gt(this, "reason", void 0), gt(this, "payload", void 0), this.claim = n, this.reason = i, this.payload = r;
  }
}
gt(yie, "code", "ERR_JWT_EXPIRED");
class bie extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
  }
}
gt(bie, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
class wie extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
gt(wie, "code", "ERR_JOSE_NOT_SUPPORTED");
gt(class extends kn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), gt(this, "code", "ERR_JWE_DECRYPTION_FAILED");
  }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
gt(class extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JWE_INVALID");
  }
}, "code", "ERR_JWE_INVALID");
class $ie extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JWS_INVALID");
  }
}
gt($ie, "code", "ERR_JWS_INVALID");
class kie extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JWT_INVALID");
  }
}
gt(kie, "code", "ERR_JWT_INVALID");
gt(class extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JWK_INVALID");
  }
}, "code", "ERR_JWK_INVALID");
class _ie extends kn {
  constructor() {
    super(...arguments), gt(this, "code", "ERR_JWKS_INVALID");
  }
}
gt(_ie, "code", "ERR_JWKS_INVALID");
class xie extends kn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), gt(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
  }
}
gt(xie, "code", "ERR_JWKS_NO_MATCHING_KEY");
class Sie extends kn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), gt(this, Symbol.asyncIterator, void 0), gt(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
  }
}
gt(Sie, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
class Cie extends kn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), gt(this, "code", "ERR_JWKS_TIMEOUT");
  }
}
gt(Cie, "code", "ERR_JWKS_TIMEOUT");
class Eie extends kn {
  constructor() {
    super(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), gt(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
  }
}
gt(Eie, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
var W0, hp;
typeof navigator > "u" || (W0 = navigator.userAgent) === null || W0 === void 0 || (hp = W0.startsWith) === null || hp === void 0 || hp.call(W0, "Mozilla/5.0 ");
new TextDecoder();
var Q0, fp;
typeof navigator > "u" || (Q0 = navigator.userAgent) === null || Q0 === void 0 || (fp = Q0.startsWith) === null || fp === void 0 || fp.call(Q0, "Mozilla/5.0 ");
Object.freeze(/* @__PURE__ */ new Set(["grant_type", "client_id", "client_secret", "client_assertion", "client_assertion_type", "subject_token", "subject_token_type", "requested_token_type", "actor_token", "actor_token_type", "audience", "aud", "resource", "resources", "resource_indicator", "scope", "connection", "login_hint", "organization", "assertion"]));
Ge`
  fragment OrganizationFields on Organization {
    id
    name
  }
`;
const Aie = Ge`
  fragment PatientFields on Patient {
    id
    externalId
    name {
      full
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      id
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`;
Ge`
  fragment AllergenFields on Allergen {
    id
    name
    rxcui
  }
`;
Ge`
  fragment CatalogFields on Catalog {
    id
    name
  }
`;
Ge`
  fragment MedicationFields on Medication {
    id
    name
    form
    schedule
    controlled
  }
`;
Ge`
  fragment SearchMedicationFields on SearchMedication {
    id
    name
  }
`;
Ge`
  fragment MedicalEquipmentFields on MedicalEquipment {
    id
    name
  }
`;
Ge`
  fragment CatalogTreatmentFields on Catalog {
    treatments {
      id
      name
    }
  }
`;
Ge`
  fragment DispenseUnitFields on DispenseUnit {
    name
  }
`;
const Tie = Ge`
  fragment FillPrescriptionFields on Fill {
    id
    state
    requestedAt
    filledAt
    order {
      id
      createdAt
      state
      fulfillment {
        state
      }
      pharmacy {
        id
        name
        address {
          street1
          street2
          city
          state
          postalCode
        }
      }
    }
  }
`;
Ge`
  ${Tie}
  fragment PrescriptionFields on Prescription {
    id
    externalId
    fills {
      ...FillPrescriptionFields
    }
    prescriber {
      id
      name {
        full
      }
    }
    patient {
      id
      name {
        full
      }
    }
    state
    treatment {
      id
      name
    }
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    fillsAllowed
    fillsRemaining
    daysSupply
    instructions
    notes
    effectiveDate
    doNotFillBeforeDate
    expirationDate
    writtenAt
  }
`;
const Oie = Ge`
  fragment FillFields on Fill {
    id
    prescription {
      id
    }
    treatment {
      name
    }
    state
    requestedAt
    filledAt
  }
`;
Ge`
  ${Aie}
  ${Oie}
  fragment OrderFields on Order {
    id
    externalId
    state
    fills {
      ...FillFields
    }
    patient {
      ...PatientFields
    }
    pharmacy {
      id
      name
      phone
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
    }
    createdAt
  }
`;
Ge`
  fragment WebhookFields on WebhookConfig {
    id
    name
    filters
    url
  }
`;
Ge`
  fragment ClientFields on Client {
    id
    name
    secret
    appType
  }
`;
Ge`
  fragment PharmacyFields on Pharmacy {
    id
    NPI
    NCPDP
    name
    fulfillmentTypes
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
  }
`;
Ge`
  fragment PrescriptionTemplateFields on PrescriptionTemplate {
    id
    daysSupply
    dispenseAsWritten
    dispenseQuantity
    dispenseUnit
    instructions
    notes
    fillsAllowed
    treatment {
      id
      name
    }
    isPrivate
  }
`;
var Rm;
(function(e) {
  e.Drug = "DRUG", e.Package = "PACKAGE", e.Product = "PRODUCT";
})(Rm || (Rm = {}));
var Lm;
(function(e) {
  e.Icd10 = "ICD10";
})(Lm || (Lm = {}));
var Fm;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(Fm || (Fm = {}));
var jm;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(jm || (jm = {}));
var zm;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(zm || (zm = {}));
var Vm;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED", e.Routing = "ROUTING";
})(Vm || (Vm = {}));
var Um;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(Um || (Um = {}));
var qm;
(function(e) {
  e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED";
})(qm || (qm = {}));
var Bm;
(function(e) {
  e.I = "I", e.Ii = "II", e.Iii = "III", e.Iv = "IV", e.V = "V";
})(Bm || (Bm = {}));
var Hm;
(function(e) {
  e.Concept = "CONCEPT", e.Form = "FORM", e.Route = "ROUTE", e.Strength = "STRENGTH";
})(Hm || (Hm = {}));
var Wm;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(Wm || (Wm = {}));
const B6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ConceptType() {
    return Rm;
  },
  get DiagnosisType() {
    return Lm;
  },
  get FillState() {
    return Fm;
  },
  get FulfillmentType() {
    return jm;
  },
  get MedicationType() {
    return zm;
  },
  get OrderState() {
    return Vm;
  },
  get OrgType() {
    return Um;
  },
  get PrescriptionState() {
    return qm;
  },
  get ScheduleType() {
    return Bm;
  },
  get SearchMedicationType() {
    return Hm;
  },
  get SexType() {
    return Wm;
  }
}, Symbol.toStringTag, { value: "Module" }));
var H6;
(function(e) {
  e.Coupon = "coupon", e.Discount = "discount", e.Insurance = "insurance";
})(H6 || (H6 = {}));
var W6;
(function(e) {
  e.Admin = "admin", e.Group = "group", e.Photon = "photon", e.Provider = "provider";
})(W6 || (W6 = {}));
var Q6;
(function(e) {
  e.Covered = "COVERED", e.CoveredWithRestrictions = "COVERED_WITH_RESTRICTIONS", e.NotCovered = "NOT_COVERED";
})(Q6 || (Q6 = {}));
var K6;
(function(e) {
  e.Canceled = "CANCELED", e.New = "NEW", e.Scheduled = "SCHEDULED", e.Sent = "SENT";
})(K6 || (K6 = {}));
var G6;
(function(e) {
  e.MailOrder = "MAIL_ORDER", e.PickUp = "PICK_UP";
})(G6 || (G6 = {}));
var Z6;
(function(e) {
  e.Otc = "OTC", e.Rx = "RX";
})(Z6 || (Z6 = {}));
var Y6;
(function(e) {
  e.Canceled = "CANCELED", e.Completed = "COMPLETED", e.Error = "ERROR", e.Pending = "PENDING", e.Placed = "PLACED";
})(Y6 || (Y6 = {}));
var J6;
(function(e) {
  e.Pharmacy = "PHARMACY", e.Prescriber = "PRESCRIBER";
})(J6 || (J6 = {}));
var X6;
(function(e) {
  e.Major = "MAJOR", e.Minor = "MINOR", e.Moderate = "MODERATE";
})(X6 || (X6 = {}));
var e7;
(function(e) {
  e.Allergen = "ALLERGEN", e.Drug = "DRUG";
})(e7 || (e7 = {}));
var t7;
(function(e) {
  e.Active = "ACTIVE", e.Canceled = "CANCELED", e.Depleted = "DEPLETED", e.Draft = "DRAFT", e.Expired = "EXPIRED";
})(t7 || (t7 = {}));
var r7;
(function(e) {
  e.Exclude = "EXCLUDE", e.Include = "INCLUDE", e.NoAdvice = "NO_ADVICE", e.NoRouting = "NO_ROUTING";
})(r7 || (r7 = {}));
var n7;
(function(e) {
  e.Female = "FEMALE", e.Male = "MALE", e.Unknown = "UNKNOWN";
})(n7 || (n7 = {}));
const Iie = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "SupervisorCard" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Supervisor" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "npi" } }] } }] }, Pie = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateSupervisorMutation" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "firstName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lastName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "npi" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createSupervisor" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "firstName" }, value: { kind: "Variable", name: { kind: "Name", value: "firstName" } } }, { kind: "ObjectField", name: { kind: "Name", value: "lastName" }, value: { kind: "Variable", name: { kind: "Name", value: "lastName" } } }, { kind: "ObjectField", name: { kind: "Name", value: "npi" }, value: { kind: "Variable", name: { kind: "Name", value: "npi" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SupervisorCard" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "SupervisorCard" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Supervisor" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "npi" } }] } }] }, Nie = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, Die = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SearchTreatmentOptionsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "TreatmentFilter" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "treatments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] }, Mie = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "MeUserQuery" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "me" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "state" } }] } }] } }] } }] }, Rie = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SupervisorCardQuery" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "supervisors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SupervisorCard" } }] } }, { kind: "Field", name: { kind: "Name", value: "mostRecentSupervisor" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "SupervisorCard" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Supervisor" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "npi" } }] } }] }, Lie = {
  "\n  fragment SupervisorCard on Supervisor {\n    id\n    firstName\n    lastName\n    npi\n  }\n": Iie,
  "\n  mutation CreateSupervisorMutation($firstName: String!, $lastName: String!, $npi: String!) {\n    createSupervisor(input: { firstName: $firstName, lastName: $lastName, npi: $npi }) {\n      ...SupervisorCard\n    }\n  }\n": Pie,
  "\n  query SearchTreatments($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      id\n      name\n    }\n  }\n": Nie,
  "\n  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {\n    treatments(filter: $filter) {\n      __typename\n      id\n      name\n    }\n  }\n": Die,
  "\n  query MeUserQuery {\n    me {\n      name {\n        title\n      }\n      address {\n        state\n      }\n    }\n  }\n": Mie,
  "\n  query SupervisorCardQuery {\n    supervisors {\n      ...SupervisorCard\n    }\n    mostRecentSupervisor {\n      id\n    }\n  }\n": Rie
};
function t0(e) {
  var t;
  return (t = Lie[e]) !== null && t !== void 0 ? t : {};
}
t0(`
  query SearchTreatments($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      id
      name
    }
  }
`);
t0(`
  query SearchTreatmentOptionsQuery($filter: TreatmentFilter!) {
    treatments(filter: $filter) {
      __typename
      id
      name
    }
  }
`);
t0(`
  query MeUserQuery {
    me {
      name {
        title
      }
      address {
        state
      }
    }
  }
`);
t0(`
  query SupervisorCardQuery {
    supervisors {
      ...SupervisorCard
    }
    mostRecentSupervisor {
      id
    }
  }
`);
t0(`
  mutation CreateSupervisorMutation($firstName: String!, $lastName: String!, $npi: String!) {
    createSupervisor(input: { firstName: $firstName, lastName: $lastName, npi: $npi }) {
      ...SupervisorCard
    }
  }
`);
var Fie = /* @__PURE__ */ k('<div class="rounded-full bg-slate-100 h-5 w-5 mr-1">'), jie = /* @__PURE__ */ k("<div class=pt-4>"), zie = /* @__PURE__ */ k('<div><div class="flex justify-between items-center"><div><label class=sr-only></label><input type=radio class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600 sr-only">'), Vie = /* @__PURE__ */ k("<div>"), Uie = /* @__PURE__ */ k("<fieldset><legend class=sr-only></legend><div class=space-y-3>");
const V_ = Gr([{
  selected: "",
  options: [],
  fieldsetLabel: ""
}, {
  addOption: () => {
  },
  setSelected: () => {
  }
}]);
function qie(e) {
  const [t, r] = js({
    selected: e.initSelected,
    options: [],
    fieldsetLabel: e.label
  }), n = [t, {
    addOption(i) {
      r("options", [...t.options, i]);
    },
    setSelected(i, a) {
      a || (r("selected", i), e?.setSelected && e.setSelected(i));
    }
  }];
  return fe(() => {
    e.value && r("selected", e.value);
  }), fe(() => {
    e.contextRef && e.contextRef(n);
  }), g(V_.Provider, {
    value: n,
    get children() {
      return e.children;
    }
  });
}
function U_() {
  return wr(V_);
}
function Bie(e) {
  const [t, r] = U_();
  lr(() => {
    r.addOption(e.value);
  });
  const n = K(() => t.selected === e.value);
  return (() => {
    var i = Vie();
    return i.$$click = () => r.setSelected(e.value, e.disabled), E(i, g(Mn, {
      get selected() {
        return n();
      },
      get disabled() {
        return e.disabled;
      },
      get children() {
        var a = zie(), o = a.firstChild, s = o.firstChild, l = s.firstChild, d = l.nextSibling;
        return E(o, () => e.children, s), E(s, g(H, {
          get when() {
            return n();
          },
          get children() {
            return g(mt, {
              name: "checkCircle",
              class: "text-blue-600"
            });
          }
        }), l), E(s, g(H, {
          get when() {
            return !n() && !e.disabled;
          },
          get children() {
            return Fie();
          }
        }), l), E(l, () => e.label), E(a, g(H, {
          get when() {
            return e.alert;
          },
          get children() {
            var c = jie();
            return E(c, () => e.alert), c;
          }
        }), null), se((c) => {
          var u = e.value, h = t.fieldsetLabel, f = e.value, p = e.disabled;
          return u !== c.e && pt(l, "for", c.e = u), h !== c.t && pt(d, "name", c.t = h), f !== c.a && pt(d, "id", c.a = f), p !== c.o && (d.disabled = c.o = p), c;
        }, {
          e: void 0,
          t: void 0,
          a: void 0,
          o: void 0
        }), se(() => d.value = e.value), se(() => d.checked = n()), a;
      }
    })), se(() => ft(i, e.disabled ? "" : "cursor-pointer")), i;
  })();
}
function Hie(e) {
  const [, t] = U_();
  return lr(() => {
    e.initSelected && t.setSelected(e.initSelected);
  }), (() => {
    var r = Uie(), n = r.firstChild, i = n.nextSibling;
    return E(n, () => e.label), E(i, () => e.children), r;
  })();
}
function _u(e) {
  return g(qie, it(e, {
    get children() {
      return g(Hie, it(e, {
        get children() {
          return e.children;
        }
      }));
    }
  }));
}
_u.Option = Bie;
an(["click"]);
var Wie = /* @__PURE__ */ k('<div class="border-b border-gray-200"><nav class="-mb-px flex space-x-4 sm:space-x-6 md:space-x-8"aria-label=Tabs>'), Qie = /* @__PURE__ */ k("<div>");
function Kie(e) {
  const t = "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer", r = "border-blue-500 text-blue-600 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium";
  return (() => {
    var n = Wie(), i = n.firstChild;
    return E(i, g(yt, {
      get each() {
        return e.tabs;
      },
      children: (a) => {
        const o = K(() => a === e.activeTab);
        return (() => {
          var s = Qie();
          return s.$$click = () => e.setActiveTab(a), E(s, a), se((l) => {
            var d = o() ? r : t, c = o() ? "page" : void 0;
            return d !== l.e && ft(s, l.e = d), c !== l.t && pt(s, "aria-current", l.t = c), l;
          }, {
            e: void 0,
            t: void 0
          }), s;
        })();
      }
    })), n;
  })();
}
an(["click"]);
var Gie = /* @__PURE__ */ k("<span>, "), Zie = /* @__PURE__ */ k('<div class="flex flex-col items-start">');
const Yie = Ge`
  query GetPharmacy($id: ID!) {
    pharmacy(id: $id) {
      id
      name
      address {
        street1
        city
        state
      }
    }
  }
`;
function Jie(e) {
  const t = Kn(), [r, n] = V(null);
  async function i() {
    const {
      data: a
    } = await t.apollo.query({
      query: Yie,
      variables: {
        id: e.pharmacyId
      }
    });
    a?.pharmacy && n(a.pharmacy);
  }
  return lr(() => {
    i();
  }), (() => {
    var a = Zie();
    return E(a, g(Ee, {
      get loading() {
        return !r();
      },
      sampleLoadingText: "Loading Name",
      get children() {
        return r()?.name;
      }
    }), null), E(a, g(Ee, {
      get loading() {
        return !r();
      },
      color: "gray",
      size: "sm",
      sampleLoadingText: "Cityville, ST",
      get children() {
        var o = Gie(), s = o.firstChild;
        return E(o, () => r()?.address?.city, s), E(o, () => r()?.address?.state, null), o;
      }
    }), null), a;
  })();
}
var Xie = /* @__PURE__ */ k("<div class=mt-4><div>"), eae = /* @__PURE__ */ k("<div><div>");
const ac = {
  patientWillSelect: {
    badgeColor: "purple",
    badgeText: "Patient Will Select",
    text: "Patient will select a pharmacy after you send the prescription(s)."
  },
  recentPharmacy: {
    badgeColor: "yellow",
    badgeText: "Recent Pharmacy",
    text: "This patient selected this pharmacy in the last 8 hours. After you send this order, the patient can change the pharmacy."
  },
  preferredPharmacy: {
    badgeColor: "blue",
    badgeText: "Preferred Pharmacy",
    text: "The patient can update their preferred pharmacy selection for 15 minutes. Otherwise, we'll send it to their preferred pharmacy on file."
  },
  coverageOptionPharmacy: {
    badgeColor: "gray",
    badgeText: "Selected Pharmacy",
    text: "The selected option was for this pharmacy."
  }
};
function tae(e) {
  const t = Kn(), {
    selectedCoverageOption: r
  } = bf(), {
    pharmacyId: n
  } = yf(), [i, a] = V(ac.patientWillSelect), [o, s] = V(void 0), l = K(() => ({
    variables: {
      id: e.patientId
    },
    client: t.apollo
  })), d = gh(I3, l), c = gh(F_, l), u = K(() => !c.loading && !d.loading), h = K(() => {
    const f = c()?.orders?.[0];
    if (f) {
      const p = /* @__PURE__ */ new Date(), m = new Date(p.getTime() - 480 * 60 * 1e3);
      if (new Date(f.createdAt) > m)
        return f;
    }
  });
  return fe(() => {
    if (u()) {
      const f = d()?.patient?.preferredPharmacies, p = h()?.pharmacy;
      if ((f?.length ?? 0) > 0) {
        if (a(ac.preferredPharmacy), f && f.length > 0) {
          const m = f[0], y = {
            ...m,
            address: {
              country: "",
              postalCode: "",
              ...m.address
            }
          };
          s(y);
        }
      } else p ? (a(ac.recentPharmacy), s(p)) : a(ac.patientWillSelect);
    } else
      s(void 0);
  }), fe(() => {
    const f = r(), p = n();
    f && p && f.pharmacy.id === p && (a(ac.coverageOptionPharmacy), t.clinical.pharmacy.getPharmacy({
      id: p
    }).then((m) => {
      s(m.data.pharmacy);
    }));
  }), g(H, {
    get when() {
      return u();
    },
    get fallback() {
      return g(aa, {
        size: "sm"
      });
    },
    get children() {
      var f = Xie(), p = f.firstChild;
      return E(p, g(Al, {
        get color() {
          return i().badgeColor;
        },
        get children() {
          return i().badgeText;
        }
      })), E(f, g(Ee, {
        size: "sm",
        class: "py-4",
        get children() {
          return i().text;
        }
      }), null), E(f, g(H, {
        get when() {
          return o();
        },
        children: (m) => g(Mn, {
          variant: "gray",
          get children() {
            var y = eae(), v = y.firstChild;
            return E(y, g(Ee, {
              size: "sm",
              bold: !0,
              get children() {
                return m().name;
              }
            }), v), E(v, g(Ee, {
              size: "sm",
              get children() {
                return R_(m().address);
              }
            })), y;
          }
        })
      }), null), f;
    }
  });
}
var rae = /* @__PURE__ */ k("<div class=mb-2><label>Search home delivery options");
function nae(e) {
  const t = Kn(), [r, n] = V(!1), [i, a] = V(""), [o, s] = V(), l = K(() => {
    const c = o();
    return c && c.length === 0;
  }), d = K(() => {
    const c = i(), u = c ? new RegExp(c, "i") : null, h = (p) => !u || u.test(p.name), f = (p) => ({
      ...p,
      isPreferred: !1,
      isPrevious: !1
    });
    return o()?.filter(h).map(f);
  });
  return fe(() => {
    async function c() {
      n(!0);
      try {
        const {
          data: u
        } = await t.apolloClinical.query({
          query: kre,
          variables: {
            offset: 0,
            limit: 40,
            fulfillmentType: "MAIL_ORDER",
            integrated: !1
          }
        });
        s(u.pharmacies);
      } catch (u) {
        console.error("Failed to load mail order pharmacy options", u);
      } finally {
        n(!1);
      }
    }
    c();
  }), fe(() => {
    e.selected || a("");
  }), Ut(() => Ut(() => !!l())() ? null : g(L_, {
    get label() {
      return rae();
    },
    get options() {
      return d();
    },
    onSearch: a,
    get value() {
      return e.selected;
    },
    get setValue() {
      return e.selectPharmacy;
    },
    get loading() {
      return r();
    }
  }));
}
var pp = /* @__PURE__ */ k("<div>"), iae = /* @__PURE__ */ k("<div class=space-y-4>"), aae = /* @__PURE__ */ k("<div><div class=pt-4>"), oae = /* @__PURE__ */ k("<div>Please select a patient."), sae = /* @__PURE__ */ k("<div class=space-y-2><label>Choose a partner pharmacy");
const i7 = [{
  name: "Send to Patient",
  fulfillmentType: "SEND_TO_PATIENT"
  /* sendToPatient */
}, {
  name: "Local Pickup",
  fulfillmentType: B6.FulfillmentType.PickUp
}, {
  name: "Mail Order",
  fulfillmentType: B6.FulfillmentType.MailOrder
}], a7 = (e) => e === "SEND_TO_PATIENT" ? void 0 : e;
function lae(e) {
  const {
    selectedCoverageOption: t
  } = bf(), r = yf(), n = () => r.unroutablePharmacyIds(), {
    dispatchAnalyticsTrackEvent: i
  } = Ma(), a = K(() => !!e.address?.trim()), [o, s] = V(), [l, d] = V(), [c, u] = V(), [h, f] = V([]), [p, m] = V(
    "Send to Patient"
    /* sendToPatient */
  ), y = K(() => r.mailOrderPharmacyIds()?.filter((_) => !n().has(_))), v = K(() => y()?.[0]);
  let b;
  fe(() => {
    const _ = l();
    _ && n().has(_) && b[1].setSelected(v() || "");
  }), lr(() => {
    f([...r.enableSendToPatient() ? [
      "Send to Patient"
      /* sendToPatient */
    ] : [], ...r.enableLocalPickup() ? [
      "Local Pickup"
      /* localPickup */
    ] : [], ...r.enableDeliveryPharmacies() ? [
      "Mail Order"
      /* mailOrder */
    ] : []]);
    const _ = i7.find((x) => x.name === h()[0])?.fulfillmentType;
    r.setFulfillmentType(a7(_)), m(h()[0]);
  }), fe(() => {
    const _ = t(), x = Qe(() => r.pharmacyId());
    _ && x === _.pharmacy.id && m(h()[0]);
  });
  const $ = (_) => {
    m(_), h().includes(_) || f([...h(), _]);
    const x = i7.find((S) => S.name === _)?.fulfillmentType;
    r.setFulfillmentType(a7(x)), i("fieldInteraction", {
      name: "Field Interaction",
      formName: "select_pharmacy",
      tabSelected: _,
      hasPreferredPharmacy: e.hasPreferredPharmacy ?? !1
    }), _ === "Local Pickup" && o() ? r.setPharmacyId(o()) : _ === "Mail Order" && l() ? r.setPharmacyId(l()) : r.setPharmacyId(t()?.pharmacy.id);
  };
  return (() => {
    var _ = aae(), x = _.firstChild;
    return E(_, g(Kie, {
      get tabs() {
        return h();
      },
      get activeTab() {
        return p();
      },
      setActiveTab: $
    }), x), E(x, g(H, {
      get when() {
        return h().includes(
          "Send to Patient"
          /* sendToPatient */
        );
      },
      get children() {
        var S = pp();
        return E(S, g(H, {
          get when() {
            return (e?.patientIds?.length || 0) > 0;
          },
          get fallback() {
            return oae();
          },
          get children() {
            return g(tae, {
              get patientId() {
                return e.patientIds[0];
              }
            });
          }
        })), se(() => ft(S, p() !== "Send to Patient" ? "hidden" : "")), S;
      }
    }), null), E(x, g(H, {
      get when() {
        return h().includes(
          "Local Pickup"
          /* localPickup */
        );
      },
      get children() {
        var S = pp();
        return E(S, g(H, {
          get when() {
            return a();
          },
          get fallback() {
            return g(du, {
              type: "warning",
              header: "Address required",
              message: "Please add a patient address to select a pharmacy."
            });
          },
          get children() {
            return g(j_, {
              get address() {
                return e?.address || "";
              },
              get patientId() {
                return e?.patientIds?.[0];
              },
              setPharmacy: (A) => {
                s(A.id), p() === "Local Pickup" && r.setPharmacyId(A.id);
              },
              setPreferred: (A) => {
                r.setUpdatePreferredPharmacy(A), i("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "select_pharmacy",
                  tabSelected: "Local Pickup",
                  hasPreferredPharmacy: e.hasPreferredPharmacy ?? !1,
                  setAsPreferred: A
                });
              }
            });
          }
        })), se(() => ft(S, p() !== "Local Pickup" ? "hidden" : "")), S;
      }
    }), null), E(x, g(H, {
      get when() {
        return h().includes(
          "Mail Order"
          /* mailOrder */
        );
      },
      get children() {
        var S = pp();
        return E(S, g(H, {
          get when() {
            return a();
          },
          get fallback() {
            return g(du, {
              type: "warning",
              header: "Address required",
              message: "Please add a patient address to select a pharmacy."
            });
          },
          get children() {
            var A = iae();
            return E(A, g(nae, {
              get selected() {
                return c();
              },
              selectPharmacy: (N) => {
                u(N), d(N.id), p() === "Mail Order" && r.setPharmacyId(N.id);
              }
            }), null), E(A, (() => {
              var N = Ut(() => (r.mailOrderPharmacyIds()?.length ?? 0) > 0);
              return () => N() && (() => {
                var P = sae();
                return P.firstChild, E(P, g(_u, {
                  label: "Pharmacies",
                  get value() {
                    return l();
                  },
                  setSelected: (D) => {
                    u(void 0), d(D), p() === "Mail Order" && r.setPharmacyId(D);
                  },
                  contextRef: (D) => b = D,
                  get children() {
                    return g(yt, {
                      get each() {
                        return r.mailOrderPharmacyIds() || [];
                      },
                      children: (D) => g(_u.Option, {
                        value: D,
                        get disabled() {
                          return n().has(D);
                        },
                        get alert() {
                          return Ut(() => !!n().has(D))() && g(lX, {});
                        },
                        get children() {
                          return g(Jie, {
                            pharmacyId: D
                          });
                        }
                      })
                    });
                  }
                }), null), P;
              })();
            })(), null), A;
          }
        })), se(() => ft(S, p() !== "Mail Order" ? "hidden" : "")), S;
      }
    }), null), _;
  })();
}
const dae = (e) => g(WQ, {
  get containerStyle() {
    return {
      "margin-top": `${e?.buffer || 0}px`
    };
  }
});
function cae(e) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function uae(e = 5, t = 10) {
  const r = Math.floor(Math.random() * (t - e + 1)) + e;
  return cae(r);
}
function hae(e) {
  let t = "N/A", r = "", n = "N/A", i = "N/A", a = "N/A";
  return e && (t = e.dispenseQuantity.toString(), e.dispenseQuantity > 0 && (r = ` ${e.dispenseUnit}`), e.daysSupply && (n = e.daysSupply.toString()), e.fillsAllowed ? i = (e.fillsAllowed - 1).toString() : i = "0", e.instructions && (a = e.instructions)), `QTY: ${t}${r} | Days Supply: ${n} | Refills: ${i} | Sig: ${a}`;
}
var fae = /* @__PURE__ */ k('<div class="flex justify-center w-full">'), pae = /* @__PURE__ */ k('<div class="text-red-700 font-bold flex space-x-2 items-center justify-center"><span>An error occurred. Please refresh and try again'), mae = /* @__PURE__ */ k("<div class=w-full>"), gae = /* @__PURE__ */ k('<div class="flex flex-col space-y-5"><div class="bg-[#FFFAEB] flex text-[#DC6803] py-2 font-semibold items-center text-sm">Required before writing prescriptions</div><div class=space-y-3><p class=text-base>By selecting <span class=font-bold>Agree</span>, you approve any prescriptions you create and send via Photon Health, Inc and that you are a practitioner authorized to prescribe and licensed in the relevant state. This signature image will not be used for any other purposes.</p></div><div class="flex justify-end space-x-4">');
const q_ = Ge`
  query GetCurrentUserSignatureAttestationStatus {
    me {
      signatureAttestationStatus {
        ... on NeedsSignatureAttestation {
          version
          content
        }
        ... on CompletedSignatureAttestation {
          agreedAt
          version
        }
        ... on NotApplicableSignatureAttestation {
          reason
        }
      }
    }
  }
`, vae = Ge`
  mutation AgreeToSignatureAttestation($version: String!) {
    agreeToSignatureAttestation(version: $version)
  }
`, yae = async (e) => await e.query({
  query: q_,
  fetchPolicy: "cache-first"
}), bae = (e) => async (t) => await e.mutate({
  mutation: vae,
  variables: {
    version: t
  },
  refetchQueries: ["GetCurrentUserSignatureAttestationStatus"],
  awaitRefetchQueries: !0,
  update: (r, {
    data: n
  }) => {
    n?.agreeToSignatureAttestation && r.writeQuery({
      query: q_,
      data: {
        me: {
          signatureAttestationStatus: {
            __typename: "CompletedSignatureAttestation",
            agreedAt: /* @__PURE__ */ new Date(),
            version: t
          }
        }
      }
    });
  }
}), wae = (e) => {
  const {
    dispatchSignatureAttestationAgreed: t,
    dispatchSignatureAttestationCanceled: r,
    dispatchAttestationResolved: n,
    dispatchAnalyticsTrackEvent: i
  } = Ma(), [a, o] = V({
    status: "LOADING"
  }), [s, l] = V(!1), d = async () => {
    const u = await yae(e.client);
    u.error || u.errors ? o({
      status: "ERROR",
      errors: [...u.errors?.map((h) => h.message) ?? [], ...u.error ? [u.error.message] : []]
    }) : u.data?.me?.signatureAttestationStatus ? u.data?.me?.signatureAttestationStatus?.__typename === "CompletedSignatureAttestation" || u.data?.me?.signatureAttestationStatus?.__typename === "NotApplicableSignatureAttestation" ? o({
      status: "COMPLETE"
    }) : o({
      status: "NEEDS ATTESTATION",
      version: u.data.me.signatureAttestationStatus.version
    }) : o({
      status: "ERROR",
      errors: ["Could not get user data. Please refresh and try again"]
    });
  };
  fe(() => {
    a().status === "COMPLETE" && (t(), n());
  }), fe(() => {
    const u = a();
    u.status === "NEEDS ATTESTATION" && i("pageViewed", {
      name: "Signature Attestation Page Viewed",
      attestationVersion: u.version
    });
  }), fe(() => {
    d();
  });
  const c = async () => {
    if (s())
      return;
    const u = a();
    if (u.status === "NEEDS ATTESTATION") {
      i("ctaClicked", {
        name: "Signature Attestation Agreed",
        buttonText: "I Agree",
        attestationVersion: u.version
      }), l(!0);
      const h = await bae(e.client)(u.version);
      h.data?.agreeToSignatureAttestation ? (l(!1), o({
        status: "COMPLETE"
      })) : (h.error || h.errors) && (l(!1), o({
        status: "ERROR",
        errors: [...h.errors?.map((f) => f.message) ?? [], ...h.error ? [h.error.message] : []]
      }));
    }
  };
  return g(Fh, {
    get children() {
      return [g(ri, {
        get when() {
          return a().status === "LOADING";
        },
        get children() {
          var u = fae();
          return E(u, g(aa, {
            color: "green"
          })), u;
        }
      }), g(ri, {
        get when() {
          return a().status === "COMPLETE";
        },
        get children() {
          return e.children;
        }
      }), g(ri, {
        get when() {
          return a().status === "ERROR";
        },
        get children() {
          var u = pae(), h = u.firstChild;
          return E(u, g(mt, {
            name: "exclamationCircle"
          }), h), u;
        }
      }), g(ri, {
        get when() {
          return a().status === "NEEDS ATTESTATION";
        },
        get children() {
          var u = mae();
          return E(u, g($ae, {
            onAgree: c,
            onCancel: () => {
              i("ctaClicked", {
                name: "Signature Attestation Canceled",
                buttonText: "Cancel"
              }), r();
            },
            get disabled() {
              return s();
            }
          })), u;
        }
      })];
    }
  });
}, $ae = (e) => g(Mn, {
  get children() {
    var t = gae(), r = t.firstChild, n = r.firstChild, i = r.nextSibling, a = i.firstChild, o = i.nextSibling;
    return E(r, g(mt, {
      name: "informationCircle",
      class: "mx-2"
    }), n), E(i, g(Ee, {
      bold: !0,
      size: "xl",
      children: "Prescriber Signature Attestation"
    }), a), E(i, g(Ee, {
      class: "block",
      children: "Photon Health, Inc. attaches your signature image to the digital signature and timestamp associated with an authorized digital prescription; or digital prescription reproduced as a hard copy facsimile."
    }), a), E(i, g(Ee, {
      class: "block",
      children: "In order to send prescriptions via the Photon application, you must be personally logged-in at the time of prescribe to approve the prescription to be created."
    }), a), E(o, g(xt, {
      variant: "secondary",
      get onClick() {
        return e.onCancel;
      },
      get disabled() {
        return e.disabled;
      },
      children: "Cancel"
    }), null), E(o, g(xt, {
      variant: "primary",
      get onClick() {
        return e.onAgree;
      },
      get disabled() {
        return e.disabled;
      },
      children: "Agree"
    }), null), t;
  }
});
function Qm(e) {
  this.message = e;
}
Qm.prototype = new Error(), Qm.prototype.name = "InvalidCharacterError";
var o7 = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new Qm("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, a = 0, o = ""; n = t.charAt(a++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function kae(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return (function(r) {
      return decodeURIComponent(o7(r).replace(/(.)/g, (function(n, i) {
        var a = i.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      })));
    })(t);
  } catch {
    return o7(t);
  }
}
function yh(e) {
  this.message = e;
}
function _ae(e, t) {
  if (typeof e != "string") throw new yh("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(kae(e.split(".")[r]));
  } catch (n) {
    throw new yh("Invalid token specified: " + n.message);
  }
}
yh.prototype = new Error(), yh.prototype.name = "InvalidTokenError";
const xae = (e) => {
  e?.returnTo ? window.location.replace(e?.returnTo) : window.history.pushState(null, window.document.title, window.location.pathname);
}, Sae = Ge`
  fragment CatalogTreatmentsFieldsComponentFragment on Catalog {
    treatments {
      id
      name
    }
    templates {
      id
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
    }
  }
`, Cae = {
  CatalogTreatmentsFieldsComponentFragment: Sae
};
class Eae {
  sdk;
  setStore;
  store;
  authentication;
  getSDK;
  clinical;
  autoLogin;
  constructor(t, r = !1) {
    this.sdk = t, this.autoLogin = r;
    const [n, i] = js({
      authentication: {
        isAuthenticated: !1,
        isInOrg: !1,
        permissions: [],
        isLoading: !0,
        error: void 0,
        user: void 0
      },
      catalog: {
        isLoading: !1,
        treatments: [],
        templates: []
      },
      catalogs: {
        isLoading: !1,
        catalogs: []
      },
      dispenseUnits: {
        isLoading: !1,
        dispenseUnits: new Array()
      },
      patients: {
        isLoading: !1,
        patients: [],
        finished: !1
      },
      patient: {
        isLoading: !1,
        patient: void 0
      },
      prescription: {
        isLoading: !1,
        errors: [],
        error: void 0,
        data: void 0
      }
    });
    this.setStore = i, this.store = n, this.authentication = {
      state: n.authentication,
      handleRedirect: async (a) => {
        try {
          const o = await this.sdk.authentication.handleRedirect(a);
          xae(o?.appState), await this.authentication.checkSession();
        } catch (o) {
          const s = new URLSearchParams(window.location.search).get("error_description");
          o.message.includes("must be an organization id") ? this.setStore("authentication", {
            ...this.store.authentication,
            error: "The provided organization id is invalid or does not exist"
          }) : s?.includes("is not part of the org") ? this.setStore("authentication", {
            ...this.store.authentication,
            error: "User is not authorized",
            isLoading: !1
          }) : this.setStore("authentication", {
            ...this.store.authentication,
            error: o.message
          });
        }
      },
      checkSession: this.checkSession.bind(this),
      login: this.login.bind(this),
      logout: this.logout.bind(this)
    }, this.getSDK = this._getSDK.bind(this), this.clinical = {
      catalog: {
        state: n.catalog,
        getCatalog: this.getCatalog.bind(this)
      },
      catalogs: {
        state: n.catalogs,
        getCatalogs: this.getCatalogs.bind(this)
      },
      dispenseUnits: {
        state: n.dispenseUnits,
        getDispenseUnits: this.getDispenseUnits.bind(this)
      },
      patients: {
        state: n.patients,
        getPatients: this.getPatients.bind(this)
      },
      patient: {
        state: n.patient,
        getPatient: this.getPatient.bind(this)
      },
      prescription: {
        state: n.prescription,
        createPrescription: this.createPrescription.bind(this)
      }
    };
  }
  _getSDK() {
    return this.sdk;
  }
  async checkSession() {
    try {
      await this.sdk.authentication.checkSession();
      const t = await this.sdk.authentication.isAuthenticated();
      this.setStore("authentication", {
        ...this.store.authentication,
        isAuthenticated: t
      });
      const r = await this.sdk.authentication.getUser(), n = !!this.sdk?.organization && !!r?.org_id;
      let i = [];
      if (this.autoLogin || t)
        try {
          const o = await this.sdk.authentication.getAccessToken();
          i = _ae(o)?.permissions || [];
        } catch {
          i = [];
        }
      const a = t && n && this.sdk.organization === r.org_id;
      this.setStore("authentication", {
        ...this.store.authentication,
        user: r,
        isLoading: !1,
        isInOrg: a,
        permissions: i || []
      });
    } catch {
      this.setStore("authentication", {
        ...this.store.authentication,
        isLoading: !1
      });
    }
  }
  async login(t = {}) {
    await this.sdk.authentication.login(t), await this.checkSession();
  }
  async logout(t = {}) {
    await this.sdk.authentication.logout(t), this.setStore("authentication", {
      ...this.store.authentication,
      isAuthenticated: !1,
      isInOrg: !1,
      permissions: [],
      user: void 0
    });
  }
  async getPatients(t) {
    t || (t = {}), this.setStore("patients", {
      ...this.store.patients,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.patient.getPatients(t);
    this.setStore("patients", {
      ...this.store.patients,
      isLoading: !1,
      patients: t.clear ? r.patients : this.store.patients.patients.concat(r.patients),
      finished: r.patients.length == 0
    });
  }
  async getPatient(t) {
    this.setStore("patient", {
      ...this.store.patient,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.patient.getPatient(t);
    return this.setStore("patient", {
      ...this.store.patient,
      isLoading: !1,
      patient: r.patient
    }), r.patient;
  }
  async getCatalog(t) {
    this.setStore("catalog", {
      ...this.store.catalog,
      isLoading: !0
    });
    const { data: r } = await this.sdk.clinical.catalog.getCatalog({
      id: t.id,
      fragment: Cae
    });
    this.setStore("catalog", {
      ...this.store.catalog,
      isLoading: !1,
      treatments: r.catalog.treatments.map((n) => n) || [],
      templates: r.catalog.templates.map((n) => n) || []
    });
  }
  async getCatalogs() {
    this.setStore("catalogs", {
      ...this.store.catalogs,
      isLoading: !0
    });
    const { data: t } = await this.sdk.clinical.catalog.getCatalogs();
    this.setStore("catalogs", {
      ...this.store.catalogs,
      isLoading: !1,
      catalogs: t.catalogs
    });
  }
  async getDispenseUnits() {
    this.setStore("dispenseUnits", {
      ...this.store.dispenseUnits,
      isLoading: !0
    });
    const { data: t } = await this.sdk.clinical.prescription.getDispenseUnits();
    this.setStore("dispenseUnits", {
      ...this.store.dispenseUnits,
      isLoading: !1,
      dispenseUnits: t.dispenseUnits.map((r, n) => ({
        id: String(n),
        ...r
      }))
    });
  }
  async createPrescription(t) {
    this.setStore("prescription", {
      ...this.store.prescription,
      isLoading: !0
    });
    const r = this.sdk.clinical.prescription.createPrescription({});
    try {
      const { data: n, errors: i } = await r({
        variables: t,
        refetchQueries: [],
        awaitRefetchQueries: !1
      });
      return i && i.length > 0 && this.setStore("prescription", {
        ...this.store.prescription,
        errors: [...i]
      }), n?.createPrescription && this.setStore("prescription", {
        ...this.store.prescription,
        data: n.createPrescription
      }), this.setStore("prescription", {
        ...this.store.prescription,
        isLoading: !1
      }), {
        data: n,
        errors: i
      };
    } catch (n) {
      return this.setStore("prescription", {
        ...this.store.prescription,
        error: n,
        isLoading: !1
      }), {
        data: null,
        errors: []
      };
    }
  }
}
const Aae = (e, t) => {
  let r;
  const n = () => clearTimeout(r);
  return Ve() && sr(n), Object.assign((...i) => {
    r !== void 0 && n(), r = setTimeout(() => e(...i), t);
  }, { clear: n });
};
var Tae = /* @__PURE__ */ k('<div class="w-full flex justify-between items-center gap-x-2"><span class="min-w-0 whitespace-normal"></span><span>');
const Oae = (e) => {
  const t = K(() => e.selectedPatient ? [e.selectedPatient, ...e.patients.filter((n) => n.id !== e.selectedPatient.id)] : e.patients), r = Aae((n) => {
    e.onSearch(n);
  }, 250);
  return g(_r, {
    get value() {
      return e.selectedPatient;
    },
    setSelected: (n) => n && e.onSelect(n),
    onOpen: () => {
      e.patients.length === 0 && e.onInitialFetch();
    },
    get children() {
      return [g(_r.Input, {
        get loading() {
          return e.loading;
        },
        placeholder: "Select patient...",
        onInput: (n) => r(n.currentTarget.value),
        displayValue: (n) => n.name?.full || ""
      }), g(H, {
        get when() {
          return t().length > 0;
        },
        get fallback() {
          return g(_r.Options, {
            get children() {
              return g(_r.Option, {
                key: "empty",
                value: {
                  id: "empty"
                },
                disabled: !0,
                get children() {
                  return e.loading ? "Loading..." : "No patients found";
                }
              });
            }
          });
        },
        get children() {
          return g(_r.Options, {
            get children() {
              return g(yt, {
                get each() {
                  return t();
                },
                children: (n) => g(_r.Option, {
                  get key() {
                    return n.id;
                  },
                  value: n,
                  render: Iae
                })
              });
            }
          });
        }
      })];
    }
  });
}, Iae = (e) => (() => {
  var t = Tae(), r = t.firstChild, n = r.nextSibling;
  return E(r, () => e.value.name.full), E(n, () => vf(e.value.dateOfBirth)), se(() => ft(n, Yt("shrink-0", e.active ? "text-white" : "text-gray-500"))), t;
})(), Pae = (e, t, r) => {
  const n = r(e, t);
  return sr(() => clearInterval(n));
}, B_ = "%[a-f0-9]{2}", s7 = new RegExp("(" + B_ + ")|([^%]+?)", "gi"), l7 = new RegExp("(" + B_ + ")+", "gi");
function Km(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], Km(r), Km(n));
}
function Nae(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(s7) || [];
    for (let r = 1; r < t.length; r++)
      e = Km(t, r).join(""), t = e.match(s7) || [];
    return e;
  }
}
function Dae(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = l7.exec(e);
  for (; r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const i = Nae(r[0]);
      i !== r[0] && (t[r[0]] = i);
    }
    r = l7.exec(e);
  }
  t["%C2"] = "�";
  const n = Object.keys(t);
  for (const i of n)
    e = e.replace(new RegExp(i, "g"), t[i]);
  return e;
}
function Mae(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return Dae(e);
  }
}
function Rae(e, t) {
  const r = {};
  if (Array.isArray(t))
    for (const n of t) {
      const i = Object.getOwnPropertyDescriptor(e, n);
      i?.enumerable && Object.defineProperty(r, n, i);
    }
  else
    for (const n of Reflect.ownKeys(e)) {
      const i = Object.getOwnPropertyDescriptor(e, n);
      if (i.enumerable) {
        const a = e[n];
        t(n, a, e) && Object.defineProperty(r, n, i);
      }
    }
  return r;
}
function H_(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const r = e.indexOf(t);
  return r === -1 ? [] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}
const Lae = (e) => e == null, Fae = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), Gm = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function jae(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (r, n) => {
        const i = r.length;
        return n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [Ar(t, e), "[", i, "]"].join("")
        ] : [
          ...r,
          [Ar(t, e), "[", Ar(i, e), "]=", Ar(n, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Ar(t, e), "[]"].join("")
      ] : [
        ...r,
        [Ar(t, e), "[]=", Ar(n, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Ar(t, e), ":list="].join("")
      ] : [
        ...r,
        [Ar(t, e), ":list=", Ar(n, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? n : (i = i === null ? "" : i, n.length === 0 ? [[Ar(r, e), t, Ar(i, e)].join("")] : [[n, Ar(i, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        Ar(t, e)
      ] : [
        ...r,
        [Ar(t, e), "=", Ar(n, e)].join("")
      ];
  }
}
function zae(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (r, n, i) => {
        if (t = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !t) {
          i[r] = n;
          return;
        }
        i[r] === void 0 && (i[r] = {}), i[r][t[1]] = n;
      };
    case "bracket":
      return (r, n, i) => {
        if (t = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !t) {
          i[r] = n;
          return;
        }
        if (i[r] === void 0) {
          i[r] = [n];
          return;
        }
        i[r] = [...i[r], n];
      };
    case "colon-list-separator":
      return (r, n, i) => {
        if (t = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !t) {
          i[r] = n;
          return;
        }
        if (i[r] === void 0) {
          i[r] = [n];
          return;
        }
        i[r] = [...i[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, i) => {
        const o = typeof n == "string" && n.includes(e.arrayFormatSeparator) ? n.split(e.arrayFormatSeparator).map((s) => fs(s, e)) : n === null ? n : fs(n, e);
        i[r] = o;
      };
    case "bracket-separator":
      return (r, n, i) => {
        const a = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !a) {
          i[r] = n && fs(n, e);
          return;
        }
        const o = n === null ? [] : fs(n, e).split(e.arrayFormatSeparator);
        if (i[r] === void 0) {
          i[r] = o;
          return;
        }
        i[r] = [...i[r], ...o];
      };
    default:
      return (r, n, i) => {
        if (i[r] === void 0) {
          i[r] = n;
          return;
        }
        i[r] = [...[i[r]].flat(), n];
      };
  }
}
function W_(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function Ar(e, t) {
  return t.encode ? t.strict ? Fae(e) : encodeURIComponent(e) : e;
}
function fs(e, t) {
  return t.decode ? Mae(e) : e;
}
function Q_(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? Q_(Object.keys(e)).sort((t, r) => Number(t) - Number(r)).map((t) => e[t]) : e;
}
function K_(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function Vae(e) {
  let t = "";
  const r = e.indexOf("#");
  return r !== -1 && (t = e.slice(r)), t;
}
function d7(e, t, r) {
  return r === "string" && typeof e == "string" ? e : typeof r == "function" && typeof e == "string" ? r(e) : r === "boolean" && e === null ? !0 : r === "boolean" && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : r === "boolean" && e !== null && (e.toLowerCase() === "1" || e.toLowerCase() === "0") ? e.toLowerCase() === "1" : r === "string[]" && t.arrayFormat !== "none" && typeof e == "string" ? [e] : r === "number[]" && t.arrayFormat !== "none" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? [Number(e)] : r === "number" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : e;
}
function M3(e) {
  e = K_(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function R3(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...t
  }, W_(t.arrayFormatSeparator);
  const r = zae(t), n = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return n;
  for (const i of e.split("&")) {
    if (i === "")
      continue;
    const a = t.decode ? i.replaceAll("+", " ") : i;
    let [o, s] = H_(a, "=");
    o === void 0 && (o = a), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : fs(s, t), r(fs(o, t), s, n);
  }
  for (const [i, a] of Object.entries(n))
    if (typeof a == "object" && a !== null && t.types[i] !== "string")
      for (const [o, s] of Object.entries(a)) {
        const l = t.types[i], d = typeof l == "function" ? l : l ? l.replace("[]", "") : void 0;
        a[o] = d7(s, t, d);
      }
    else typeof a == "object" && a !== null && t.types[i] === "string" ? n[i] = Object.values(a).join(t.arrayFormatSeparator) : n[i] = d7(a, t, t.types[i]);
  return t.sort === !1 ? n : (t.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce((i, a) => {
    const o = n[a];
    return i[a] = o && typeof o == "object" && !Array.isArray(o) ? Q_(o) : o, i;
  }, /* @__PURE__ */ Object.create(null));
}
function G_(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, W_(t.arrayFormatSeparator);
  const r = (o) => t.skipNull && Lae(e[o]) || t.skipEmptyString && e[o] === "", n = jae(t), i = {};
  for (const [o, s] of Object.entries(e))
    r(o) || (i[o] = s);
  const a = Object.keys(i);
  return t.sort !== !1 && a.sort(t.sort), a.map((o) => {
    let s = e[o];
    if (t.replacer && (s = t.replacer(o, s), s === void 0) || s === void 0)
      return "";
    if (s === null)
      return Ar(o, t);
    if (Array.isArray(s)) {
      if (s.length === 0 && t.arrayFormat === "bracket-separator")
        return Ar(o, t) + "[]";
      let l = s;
      return t.replacer && (l = s.map(
        (d, c) => t.replacer(`${o}[${c}]`, d)
      ).filter((d) => d !== void 0)), l.reduce(n(o), []).join("&");
    }
    return Ar(o, t) + "=" + Ar(s, t);
  }).filter((o) => o.length > 0).join("&");
}
function Z_(e, t) {
  t = {
    decode: !0,
    ...t
  };
  let [r, n] = H_(e, "#");
  return r === void 0 && (r = e), {
    url: r?.split("?")?.[0] ?? "",
    query: R3(M3(e), t),
    ...t && t.parseFragmentIdentifier && n ? { fragmentIdentifier: fs(n, t) } : {}
  };
}
function Y_(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [Gm]: !0,
    ...t
  };
  const r = K_(e.url).split("?")[0] || "", n = M3(e.url), i = {
    ...R3(n, { sort: !1, ...t }),
    ...e.query
  };
  let a = G_(i, t);
  a &&= `?${a}`;
  let o = Vae(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const s = new URL(r);
    s.hash = e.fragmentIdentifier, o = t[Gm] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${r}${a}${o}`;
}
function J_(e, t, r) {
  r = {
    parseFragmentIdentifier: !0,
    [Gm]: !1,
    ...r
  };
  const { url: n, query: i, fragmentIdentifier: a } = Z_(e, r);
  return Y_({
    url: n,
    query: Rae(i, t),
    fragmentIdentifier: a
  }, r);
}
function Uae(e, t, r) {
  const n = Array.isArray(t) ? (i) => !t.includes(i) : (i, a) => !t(i, a);
  return J_(e, n, r);
}
const X_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: Uae,
  extract: M3,
  parse: R3,
  parseUrl: Z_,
  pick: J_,
  stringify: G_,
  stringifyUrl: Y_
}, Symbol.toStringTag, { value: "Module" })), qae = (e = window.location.search) => {
  if (!e)
    return !1;
  const t = X_.parse(e);
  return "state" in t && "photon" in t && ("code" in t || "error" in t);
}, Bae = (e) => /^\d{5}(-\d{4})?$/.test(e);
function Zm(e, t) {
  return e.every((r) => t.includes(r));
}
const Hae = "0.20.9", Wae = {
  version: Hae
};
var Qae = /* @__PURE__ */ ae("<slot>"), Kae = /* @__PURE__ */ ae("<div>");
const Gae = Wae?.version, Zae = (e) => {
  let t;
  const r = e.redirectUri ? e.redirectUri : window.location.origin, n = X_.stringifyUrl({
    url: r,
    query: {
      photon: !0
    }
  }), i = new BP({
    env: e.env,
    domain: e.domain,
    audience: e.audience,
    connection: e.connection,
    uri: e.uri,
    clientId: e.id,
    redirectURI: n,
    organization: e.org,
    developmentMode: e.developmentMode
  }, Gae), a = new Eae(i, e.autoLogin);
  e.developmentMode && console.info("[PhotonClient]: Development mode enabled");
  const [o] = V(a), s = async () => {
    await o()?.authentication.handleRedirect(), e.redirectPath && window.location.replace(e.redirectPath);
  }, l = async () => {
    await o()?.authentication.checkSession(), Pae(async () => {
      await o()?.authentication.checkSession();
    }, 6e4, setInterval);
  };
  return fe(() => {
    qae() && o() ? s() : o() && l();
  }), fe(() => {
    if (!o()?.authentication.state.isLoading) {
      if (!o()?.authentication.state.isAuthenticated && e.autoLogin) {
        const d = {
          appState: {}
        };
        e.redirectPath && (d.appState.returnTo = e.redirectPath), o()?.authentication.login(d);
      } else if (
        // If `externalUserId` is set, then we check if it matches the logged in user
        // If it doesn't match then logout and then immediately log back in if possible
        e.externalUserId != null && // Note that we check the last piece of the `sub` which is the id from the auth provider
        // We do an exact match on this last section because ids are not guaranteed to not be substrings of the other
        o().authentication.state.user?.sub?.split("|").reverse()[0] !== e.externalUserId
      ) {
        o()?.authentication.logout();
        const d = {
          appState: {}
        };
        e.redirectPath && (d.appState.returnTo = e.redirectPath), o()?.authentication.login(d);
      }
    }
  }), fe(() => {
    const d = o()?.authentication.state.isAuthenticated, c = o()?.authentication.state.isLoading;
    e.emitUserToken && d && !c && i.authentication.getAccessToken().then((u) => {
      t?.dispatchEvent(new CustomEvent("photon-user-token", {
        composed: !0,
        bubbles: !0,
        detail: {
          token: u
        }
      }));
    });
  }), (() => {
    var d = Kae(), c = t;
    return typeof c == "function" ? Zt(c, d) : t = d, L(d, g(sk.Provider, {
      get value() {
        return o();
      },
      get children() {
        return g(AK, {
          get children() {
            return g(TQ, {
              client: i,
              get children() {
                var u = Qae();
                return u._$owner = Ve(), u;
              }
            });
          }
        });
      }
    })), d;
  })();
};
Dn("photon-client", {
  domain: {
    attribute: "domain",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  id: {
    attribute: "id",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  redirectUri: {
    attribute: "redirect-uri",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  org: {
    attribute: "org",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  audience: {
    attribute: "audience",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  connection: {
    attribute: "connection",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  uri: {
    attribute: "uri",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  developmentMode: {
    attribute: "dev-mode",
    value: !1,
    reflect: !0,
    notify: !1,
    parse: !0
  },
  errorMessage: {
    attribute: "error-message",
    value: "Oh snap! There was an error loading. Please contact your site's administrator",
    reflect: !1,
    notify: !1,
    parse: !1
  },
  autoLogin: {
    attribute: "auto-login",
    value: !1,
    reflect: !1,
    notify: !1,
    parse: !0
  },
  env: {
    attribute: "env",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  },
  externalUserId: {
    attribute: "user-id",
    value: void 0,
    reflect: !0,
    notify: !0,
    parse: !1
  },
  emitUserToken: {
    attribute: "emit-user-token",
    value: !1,
    reflect: !1,
    notify: !1,
    parse: !0
  }
}, Zae);
const Gn = '*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media(min-width:475px){.container{max-width:475px}}@media(min-width:640px){.container{max-width:640px}}@media(min-width:768px){.container{max-width:768px}}@media(min-width:1024px){.container{max-width:1024px}}@media(min-width:1280px){.container{max-width:1280px}}@media(min-width:1536px){.container{max-width:1536px}}.visible{visibility:visible}.invisible{visibility:hidden}.fixed{position:fixed}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.left-0{left:0}.top-0{top:0}.z-2000{z-index:2000}.z-50{z-index:50}.m-0{margin:0}.m-3{margin:.75rem}.my-1{margin-top:.25rem;margin-bottom:.25rem}.\\!mt-8{margin-top:2rem!important}.mb-1{margin-bottom:.25rem}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-1{margin-left:.25rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-6{margin-top:1.5rem}.mt-8{margin-top:2rem}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-10{height:2.5rem}.h-11{height:2.75rem}.h-\\[21px\\]{height:21px}.h-\\[28px\\]{height:28px}.h-fit{height:-moz-fit-content;height:fit-content}.h-full{height:100%}.w-11{width:2.75rem}.w-\\[44px\\]{width:44px}.w-full{width:100%}.w-screen{width:100vw}.min-w-0{min-width:0px}.min-w-\\[40\\%\\]{min-width:40%}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.cursor-not-allowed{cursor:not-allowed}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-8{gap:2rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * (1 - var(--tw-space-x-reverse)))}.self-start{align-self:flex-start}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.overscroll-contain{overscroll-behavior:contain}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.overflow-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-lg{border-radius:.5rem}.border{border-width:1px}.border-2{border-width:2px}.border-none{border-style:none}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229,231,235,var(--tw-border-opacity))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity))}.bg-\\[\\#F9FAFB\\]{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(21,112,239,var(--tw-bg-opacity))}.bg-photon-blue{--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254,226,226,var(--tw-bg-opacity))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255,255,255,var(--tw-bg-opacity))}.p-0{padding:0}.p-4{padding:1rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-2{padding-bottom:.5rem}.pb-4{padding-bottom:1rem}.pl-1{padding-left:.25rem}.pl-2{padding-left:.5rem}.pl-5{padding-left:1.25rem}.pl-\\[19\\.75px\\]{padding-left:19.75px}.pr-2{padding-right:.5rem}.pr-5{padding-right:1.25rem}.pt-1{padding-top:.25rem}.pt-3{padding-top:.75rem}.pt-4{padding-top:1rem}.text-center{text-align:center}.font-sans{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-extrabold{font-weight:800}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.italic{font-style:italic}.leading-snug{line-height:1.375}.text-black{--tw-text-opacity: 1;color:rgb(0,0,0,var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.text-red-700{--tw-text-opacity: 1;color:rgb(185,28,28,var(--tw-text-opacity))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100,116,139,var(--tw-text-opacity))}.text-teal-600{--tw-text-opacity: 1;color:rgb(13,148,136,var(--tw-text-opacity))}.text-white{--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.opacity-50{opacity:.5}.shadow-card{--tw-shadow: 0px 0px 1px rgba(48, 49, 51, .05),0px 2px 4px rgba(48, 49, 51, .1);--tw-shadow-colored: 0px 0px 1px var(--tw-shadow-color), 0px 2px 4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:bg-blue-700:hover{--tw-bg-opacity: 1;background-color:rgb(24,73,169,var(--tw-bg-opacity))}.hover\\:bg-photon-blue-dark:hover{--tw-bg-opacity: 1;background-color:rgb(43,108,176,var(--tw-bg-opacity))}.hover\\:text-gray-600:hover{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.hover\\:underline:hover{text-decoration-line:underline}.disabled\\:bg-gray-500:disabled{--tw-bg-opacity: 1;background-color:rgb(107,114,128,var(--tw-bg-opacity))}@media(min-width:475px){.xs\\:mx-auto{margin-left:auto;margin-right:auto}.xs\\:\\!w-auto{width:auto!important}.xs\\:w-fit{width:-moz-fit-content;width:fit-content}.xs\\:flex-row{flex-direction:row}.xs\\:flex-row-reverse{flex-direction:row-reverse}.xs\\:justify-start{justify-content:flex-start}.xs\\:text-base{font-size:1rem;line-height:1.5rem}}@media(min-width:640px){.sm\\:inline{display:inline}.sm\\:grid{display:grid}.sm\\:h-12{height:3rem}.sm\\:w-\\[600px\\]{width:600px}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:gap-4{gap:1rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}}@media(min-width:768px){.md\\:\\!mt-8{margin-top:2rem!important}.md\\:\\!block{display:block!important}.md\\:flex{display:flex}.md\\:\\!hidden{display:none!important}.md\\:px-4{padding-left:1rem;padding-right:1rem}.md\\:px-8{padding-left:2rem;padding-right:2rem}.md\\:py-3{padding-top:.75rem;padding-bottom:.75rem}.md\\:text-3xl{font-size:1.875rem;line-height:2.25rem}.md\\:text-xl{font-size:1.25rem;line-height:1.75rem}}';
var Yae = /* @__PURE__ */ ae("<style>"), Jae = /* @__PURE__ */ ae('<button class="w-full disabled:bg-gray-500 bg-photon-blue hover:bg-blue-700 text-white h-10 px-4 rounded-lg font-sans hover:bg-photon-blue-dark transition ease-in-out delay-50">');
const Xae = (e) => {
  const t = Rn();
  return fe(() => {
    t || console.error("[photon-auth-button] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), [(() => {
    var r = Yae();
    return L(r, Gn), r;
  })(), t ? (() => {
    var r = Jae();
    return r.$$click = async () => {
      const n = {
        appState: {}
      };
      e.redirectPath && (n.appState.returnTo = e.redirectPath), t.authentication.state.isAuthenticated ? await t.authentication.logout() : await t.authentication.login(n);
    }, L(r, () => t.authentication.state.isAuthenticated ? "Log out" : "Log in"), se(() => r.disabled = t.authentication.state.isLoading), r;
  })() : null];
};
Dn("photon-auth-button", {
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, Xae);
Rs(["click"]);
var eoe = /* @__PURE__ */ ae("<style>"), toe = /* @__PURE__ */ ae(`<div class="flex flex-col w-screen max-w-sm"><svg viewBox="0 0 305 62.61"xmlns=http://www.w3.org/2000/svg class="h-[28px] pl-[19.75px]"><g fill=#273D52><path d="M0 54.1169H6.81375V35.7722H18.0826C29.5481 35.7722 34.3963 30.3343 34.3963 18.7378V17.4275C34.3963 5.76548 29.417 0.655167 18.0826 0.655167H0V54.1169ZM6.81375 30.1377V6.28961H18.2792C24.7653 6.28961 27.386 8.9758 27.386 16.0516V20.0481C27.386 27.1895 24.7653 30.1377 18.2792 30.1377H6.81375Z"></path><path d="M70.9593 54.1169H77.773V0.655167H70.9593V24.4378H50.8456V0.655167H44.0319V54.1169H50.8456V30.3343H70.9593V54.1169Z"></path><path d="M107.146 54.772C119.528 54.772 125.687 46.5169 125.687 34.9205V19.7861C125.687 8.25511 119.528 0 107.146 0C94.6974 0 88.5388 8.25511 88.5388 19.7861V34.9205C88.5388 46.5169 94.6974 54.772 107.146 54.772ZM95.5491 35.9687V18.8033C95.5491 10.7448 99.4801 5.89651 107.146 5.89651C114.745 5.89651 118.677 10.7448 118.677 18.8033V35.9687C118.677 44.0928 114.745 48.8755 107.146 48.8755C99.4801 48.8755 95.5491 44.0928 95.5491 35.9687Z"></path><path d="M144.295 54.1169H151.109V6.48616H164.54V0.655167H130.864V6.48616H144.295V54.1169Z"></path><path d="M188.299 54.772C200.682 54.772 206.841 46.5169 206.841 34.9205V19.7861C206.841 8.25511 200.682 0 188.299 0C175.851 0 169.693 8.25511 169.693 19.7861V34.9205C169.693 46.5169 175.851 54.772 188.299 54.772ZM176.703 35.9687V18.8033C176.703 10.7448 180.634 5.89651 188.299 5.89651C195.899 5.89651 199.83 10.7448 199.83 18.8033V35.9687C199.83 44.0928 195.899 48.8755 188.299 48.8755C180.634 48.8755 176.703 44.0928 176.703 35.9687Z"></path><path d="M217.6 54.1169H224.021V14.3482L245.576 54.1169H252.608L248.058 45.1084L245.641 40.4239L224.086 0.655167H217.6V54.1169Z"></path></g><g fill=#B35724><circle cx=249.798 cy=5.202 r=5.202></circle></g></svg><h1 class="font-medium text-3xl text-center font-sans mt-6 mb-3">Log in to your account</h1><p class="text-gray-500 font-sans text-center mb-8">Don't have an account? <a href=mailto:support@photon.health class="text-teal-600 hover:underline hover:cursor-pointer font-sans font-light">Contact Support</a></p><photon-auth-button>`, !0, !1, !1);
const roe = (e) => {
  const t = Rn();
  return fe(() => {
    t || console.error("[photon-login] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), [(() => {
    var r = eoe();
    return L(r, Gn), r;
  })(), (() => {
    var r = toe(), n = r.firstChild, i = n.nextSibling, a = i.nextSibling, o = a.nextSibling;
    return o._$owner = Ve(), se(() => o.redirectPath = e.redirectPath), r;
  })()];
};
Dn("photon-login", {
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, roe);
const k1 = globalThis, L3 = k1.ShadowRoot && (k1.ShadyCSS === void 0 || k1.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, F3 = /* @__PURE__ */ Symbol(), c7 = /* @__PURE__ */ new WeakMap();
let ex = class {
  constructor(t, r, n) {
    if (this._$cssResult$ = !0, n !== F3) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = r;
  }
  get styleSheet() {
    let t = this.o;
    const r = this.t;
    if (L3 && t === void 0) {
      const n = r !== void 0 && r.length === 1;
      n && (t = c7.get(r)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && c7.set(r, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const noe = (e) => new ex(typeof e == "string" ? e : e + "", void 0, F3), Ln = (e, ...t) => {
  const r = e.length === 1 ? e[0] : t.reduce((n, i, a) => n + ((o) => {
    if (o._$cssResult$ === !0) return o.cssText;
    if (typeof o == "number") return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + e[a + 1], e[0]);
  return new ex(r, e, F3);
}, ioe = (e, t) => {
  if (L3) e.adoptedStyleSheets = t.map((r) => r instanceof CSSStyleSheet ? r : r.styleSheet);
  else for (const r of t) {
    const n = document.createElement("style"), i = k1.litNonce;
    i !== void 0 && n.setAttribute("nonce", i), n.textContent = r.cssText, e.appendChild(n);
  }
}, u7 = L3 ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let r = "";
  for (const n of t.cssRules) r += n.cssText;
  return noe(r);
})(e) : e;
const { is: aoe, defineProperty: ooe, getOwnPropertyDescriptor: soe, getOwnPropertyNames: loe, getOwnPropertySymbols: doe, getPrototypeOf: coe } = Object, wf = globalThis, h7 = wf.trustedTypes, uoe = h7 ? h7.emptyScript : "", hoe = wf.reactiveElementPolyfillSupport, Vc = (e, t) => e, ld = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? uoe : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let r = e;
  switch (t) {
    case Boolean:
      r = e !== null;
      break;
    case Number:
      r = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        r = JSON.parse(e);
      } catch {
        r = null;
      }
  }
  return r;
} }, j3 = (e, t) => !aoe(e, t), f7 = { attribute: !0, type: String, converter: ld, reflect: !1, useDefault: !1, hasChanged: j3 };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), wf.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
let hl = class extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ??= []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, r = f7) {
    if (r.state && (r.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((r = Object.create(r)).wrapped = !0), this.elementProperties.set(t, r), !r.noAccessor) {
      const n = /* @__PURE__ */ Symbol(), i = this.getPropertyDescriptor(t, n, r);
      i !== void 0 && ooe(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, r, n) {
    const { get: i, set: a } = soe(this.prototype, t) ?? { get() {
      return this[r];
    }, set(o) {
      this[r] = o;
    } };
    return { get: i, set(o) {
      const s = i?.call(this);
      a?.call(this, o), this.requestUpdate(t, s, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? f7;
  }
  static _$Ei() {
    if (this.hasOwnProperty(Vc("elementProperties"))) return;
    const t = coe(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(Vc("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Vc("properties"))) {
      const r = this.properties, n = [...loe(r), ...doe(r)];
      for (const i of n) this.createProperty(i, r[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const r = litPropertyMetadata.get(t);
      if (r !== void 0) for (const [n, i] of r) this.elementProperties.set(n, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [r, n] of this.elementProperties) {
      const i = this._$Eu(r, n);
      i !== void 0 && this._$Eh.set(i, r);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const r = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const i of n) r.unshift(u7(i));
    } else t !== void 0 && r.push(u7(t));
    return r;
  }
  static _$Eu(t, r) {
    const n = r.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t) => t(this));
  }
  addController(t) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && t.hostConnected?.();
  }
  removeController(t) {
    this._$EO?.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), r = this.constructor.elementProperties;
    for (const n of r.keys()) this.hasOwnProperty(n) && (t.set(n, this[n]), delete this[n]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return ioe(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t) => t.hostConnected?.());
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t) => t.hostDisconnected?.());
  }
  attributeChangedCallback(t, r, n) {
    this._$AK(t, n);
  }
  _$ET(t, r) {
    const n = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, n);
    if (i !== void 0 && n.reflect === !0) {
      const a = (n.converter?.toAttribute !== void 0 ? n.converter : ld).toAttribute(r, n.type);
      this._$Em = t, a == null ? this.removeAttribute(i) : this.setAttribute(i, a), this._$Em = null;
    }
  }
  _$AK(t, r) {
    const n = this.constructor, i = n._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const a = n.getPropertyOptions(i), o = typeof a.converter == "function" ? { fromAttribute: a.converter } : a.converter?.fromAttribute !== void 0 ? a.converter : ld;
      this._$Em = i;
      const s = o.fromAttribute(r, a.type);
      this[i] = s ?? this._$Ej?.get(i) ?? s, this._$Em = null;
    }
  }
  requestUpdate(t, r, n, i = !1, a) {
    if (t !== void 0) {
      const o = this.constructor;
      if (i === !1 && (a = this[t]), n ??= o.getPropertyOptions(t), !((n.hasChanged ?? j3)(a, r) || n.useDefault && n.reflect && a === this._$Ej?.get(t) && !this.hasAttribute(o._$Eu(t, n)))) return;
      this.C(t, r, n);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, r, { useDefault: n, reflect: i, wrapped: a }, o) {
    n && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, o ?? r ?? this[t]), a !== !0 || o !== void 0) || (this._$AL.has(t) || (this.hasUpdated || n || (r = void 0), this._$AL.set(t, r)), i === !0 && this._$Em !== t && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (r) {
      Promise.reject(r);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [i, a] of this._$Ep) this[i] = a;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [i, a] of n) {
        const { wrapped: o } = a, s = this[i];
        o !== !0 || this._$AL.has(i) || s === void 0 || this.C(i, void 0, a, s);
      }
    }
    let t = !1;
    const r = this._$AL;
    try {
      t = this.shouldUpdate(r), t ? (this.willUpdate(r), this._$EO?.forEach((n) => n.hostUpdate?.()), this.update(r)) : this._$EM();
    } catch (n) {
      throw t = !1, this._$EM(), n;
    }
    t && this._$AE(r);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    this._$EO?.forEach((r) => r.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq &&= this._$Eq.forEach((r) => this._$ET(r, this[r])), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
hl.elementStyles = [], hl.shadowRootOptions = { mode: "open" }, hl[Vc("elementProperties")] = /* @__PURE__ */ new Map(), hl[Vc("finalized")] = /* @__PURE__ */ new Map(), hoe?.({ ReactiveElement: hl }), (wf.reactiveElementVersions ??= []).push("2.1.2");
const z3 = globalThis, p7 = (e) => e, bh = z3.trustedTypes, m7 = bh ? bh.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, tx = "$lit$", no = `lit$${Math.random().toFixed(9).slice(2)}$`, rx = "?" + no, foe = `<${rx}>`, As = document, xu = () => As.createComment(""), Su = (e) => e === null || typeof e != "object" && typeof e != "function", V3 = Array.isArray, poe = (e) => V3(e) || typeof e?.[Symbol.iterator] == "function", mp = `[ 	
\f\r]`, oc = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, g7 = /-->/g, v7 = />/g, Go = RegExp(`>|${mp}(?:([^\\s"'>=/]+)(${mp}*=${mp}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), y7 = /'/g, b7 = /"/g, nx = /^(?:script|style|textarea|title)$/i, moe = (e) => (t, ...r) => ({ _$litType$: e, strings: t, values: r }), hr = moe(1), _i = /* @__PURE__ */ Symbol.for("lit-noChange"), gr = /* @__PURE__ */ Symbol.for("lit-nothing"), w7 = /* @__PURE__ */ new WeakMap(), ps = As.createTreeWalker(As, 129);
function ix(e, t) {
  if (!V3(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return m7 !== void 0 ? m7.createHTML(t) : t;
}
const goe = (e, t) => {
  const r = e.length - 1, n = [];
  let i, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = oc;
  for (let s = 0; s < r; s++) {
    const l = e[s];
    let d, c, u = -1, h = 0;
    for (; h < l.length && (o.lastIndex = h, c = o.exec(l), c !== null); ) h = o.lastIndex, o === oc ? c[1] === "!--" ? o = g7 : c[1] !== void 0 ? o = v7 : c[2] !== void 0 ? (nx.test(c[2]) && (i = RegExp("</" + c[2], "g")), o = Go) : c[3] !== void 0 && (o = Go) : o === Go ? c[0] === ">" ? (o = i ?? oc, u = -1) : c[1] === void 0 ? u = -2 : (u = o.lastIndex - c[2].length, d = c[1], o = c[3] === void 0 ? Go : c[3] === '"' ? b7 : y7) : o === b7 || o === y7 ? o = Go : o === g7 || o === v7 ? o = oc : (o = Go, i = void 0);
    const f = o === Go && e[s + 1].startsWith("/>") ? " " : "";
    a += o === oc ? l + foe : u >= 0 ? (n.push(d), l.slice(0, u) + tx + l.slice(u) + no + f) : l + no + (u === -2 ? s : f);
  }
  return [ix(e, a + (e[r] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), n];
};
class Cu {
  constructor({ strings: t, _$litType$: r }, n) {
    let i;
    this.parts = [];
    let a = 0, o = 0;
    const s = t.length - 1, l = this.parts, [d, c] = goe(t, r);
    if (this.el = Cu.createElement(d, n), ps.currentNode = this.el.content, r === 2 || r === 3) {
      const u = this.el.content.firstChild;
      u.replaceWith(...u.childNodes);
    }
    for (; (i = ps.nextNode()) !== null && l.length < s; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const u of i.getAttributeNames()) if (u.endsWith(tx)) {
          const h = c[o++], f = i.getAttribute(u).split(no), p = /([.?@])?(.*)/.exec(h);
          l.push({ type: 1, index: a, name: p[2], strings: f, ctor: p[1] === "." ? yoe : p[1] === "?" ? boe : p[1] === "@" ? woe : $f }), i.removeAttribute(u);
        } else u.startsWith(no) && (l.push({ type: 6, index: a }), i.removeAttribute(u));
        if (nx.test(i.tagName)) {
          const u = i.textContent.split(no), h = u.length - 1;
          if (h > 0) {
            i.textContent = bh ? bh.emptyScript : "";
            for (let f = 0; f < h; f++) i.append(u[f], xu()), ps.nextNode(), l.push({ type: 2, index: ++a });
            i.append(u[h], xu());
          }
        }
      } else if (i.nodeType === 8) if (i.data === rx) l.push({ type: 2, index: a });
      else {
        let u = -1;
        for (; (u = i.data.indexOf(no, u + 1)) !== -1; ) l.push({ type: 7, index: a }), u += no.length - 1;
      }
      a++;
    }
  }
  static createElement(t, r) {
    const n = As.createElement("template");
    return n.innerHTML = t, n;
  }
}
function dd(e, t, r = e, n) {
  if (t === _i) return t;
  let i = n !== void 0 ? r._$Co?.[n] : r._$Cl;
  const a = Su(t) ? void 0 : t._$litDirective$;
  return i?.constructor !== a && (i?._$AO?.(!1), a === void 0 ? i = void 0 : (i = new a(e), i._$AT(e, r, n)), n !== void 0 ? (r._$Co ??= [])[n] = i : r._$Cl = i), i !== void 0 && (t = dd(e, i._$AS(e, t.values), i, n)), t;
}
class voe {
  constructor(t, r) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = r;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: r }, parts: n } = this._$AD, i = (t?.creationScope ?? As).importNode(r, !0);
    ps.currentNode = i;
    let a = ps.nextNode(), o = 0, s = 0, l = n[0];
    for (; l !== void 0; ) {
      if (o === l.index) {
        let d;
        l.type === 2 ? d = new r0(a, a.nextSibling, this, t) : l.type === 1 ? d = new l.ctor(a, l.name, l.strings, this, t) : l.type === 6 && (d = new $oe(a, this, t)), this._$AV.push(d), l = n[++s];
      }
      o !== l?.index && (a = ps.nextNode(), o++);
    }
    return ps.currentNode = As, i;
  }
  p(t) {
    let r = 0;
    for (const n of this._$AV) n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, r), r += n.strings.length - 2) : n._$AI(t[r])), r++;
  }
}
class r0 {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t, r, n, i) {
    this.type = 2, this._$AH = gr, this._$AN = void 0, this._$AA = t, this._$AB = r, this._$AM = n, this.options = i, this._$Cv = i?.isConnected ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const r = this._$AM;
    return r !== void 0 && t?.nodeType === 11 && (t = r.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, r = this) {
    t = dd(this, t, r), Su(t) ? t === gr || t == null || t === "" ? (this._$AH !== gr && this._$AR(), this._$AH = gr) : t !== this._$AH && t !== _i && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : poe(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== gr && Su(this._$AH) ? this._$AA.nextSibling.data = t : this.T(As.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    const { values: r, _$litType$: n } = t, i = typeof n == "number" ? this._$AC(t) : (n.el === void 0 && (n.el = Cu.createElement(ix(n.h, n.h[0]), this.options)), n);
    if (this._$AH?._$AD === i) this._$AH.p(r);
    else {
      const a = new voe(i, this), o = a.u(this.options);
      a.p(r), this.T(o), this._$AH = a;
    }
  }
  _$AC(t) {
    let r = w7.get(t.strings);
    return r === void 0 && w7.set(t.strings, r = new Cu(t)), r;
  }
  k(t) {
    V3(this._$AH) || (this._$AH = [], this._$AR());
    const r = this._$AH;
    let n, i = 0;
    for (const a of t) i === r.length ? r.push(n = new r0(this.O(xu()), this.O(xu()), this, this.options)) : n = r[i], n._$AI(a), i++;
    i < r.length && (this._$AR(n && n._$AB.nextSibling, i), r.length = i);
  }
  _$AR(t = this._$AA.nextSibling, r) {
    for (this._$AP?.(!1, !0, r); t !== this._$AB; ) {
      const n = p7(t).nextSibling;
      p7(t).remove(), t = n;
    }
  }
  setConnected(t) {
    this._$AM === void 0 && (this._$Cv = t, this._$AP?.(t));
  }
}
class $f {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, r, n, i, a) {
    this.type = 1, this._$AH = gr, this._$AN = void 0, this.element = t, this.name = r, this._$AM = i, this.options = a, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = gr;
  }
  _$AI(t, r = this, n, i) {
    const a = this.strings;
    let o = !1;
    if (a === void 0) t = dd(this, t, r, 0), o = !Su(t) || t !== this._$AH && t !== _i, o && (this._$AH = t);
    else {
      const s = t;
      let l, d;
      for (t = a[0], l = 0; l < a.length - 1; l++) d = dd(this, s[n + l], r, l), d === _i && (d = this._$AH[l]), o ||= !Su(d) || d !== this._$AH[l], d === gr ? t = gr : t !== gr && (t += (d ?? "") + a[l + 1]), this._$AH[l] = d;
    }
    o && !i && this.j(t);
  }
  j(t) {
    t === gr ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class yoe extends $f {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === gr ? void 0 : t;
  }
}
class boe extends $f {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== gr);
  }
}
class woe extends $f {
  constructor(t, r, n, i, a) {
    super(t, r, n, i, a), this.type = 5;
  }
  _$AI(t, r = this) {
    if ((t = dd(this, t, r, 0) ?? gr) === _i) return;
    const n = this._$AH, i = t === gr && n !== gr || t.capture !== n.capture || t.once !== n.once || t.passive !== n.passive, a = t !== gr && (n === gr || i);
    i && this.element.removeEventListener(this.name, this, n), a && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class $oe {
  constructor(t, r, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = r, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    dd(this, t);
  }
}
const koe = z3.litHtmlPolyfillSupport;
koe?.(Cu, r0), (z3.litHtmlVersions ??= []).push("3.3.2");
const _oe = (e, t, r) => {
  const n = r?.renderBefore ?? t;
  let i = n._$litPart$;
  if (i === void 0) {
    const a = r?.renderBefore ?? null;
    n._$litPart$ = i = new r0(t.insertBefore(xu(), a), a, void 0, r ?? {});
  }
  return i._$AI(e), i;
};
const U3 = globalThis;
let Uc = class extends hl {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t.firstChild, t;
  }
  update(t) {
    const r = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = _oe(r, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return _i;
  }
};
Uc._$litElement$ = !0, Uc.finalized = !0, U3.litElementHydrateSupport?.({ LitElement: Uc });
const xoe = U3.litElementPolyfillSupport;
xoe?.({ LitElement: Uc });
(U3.litElementVersions ??= []).push("4.2.2");
var Soe = Ln`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`;
const Ym = /* @__PURE__ */ new Set(), Tl = /* @__PURE__ */ new Map();
let cs, q3 = "ltr", B3 = "en";
const ax = typeof MutationObserver < "u" && typeof document < "u" && typeof document.documentElement < "u";
if (ax) {
  const e = new MutationObserver(sx);
  q3 = document.documentElement.dir || "ltr", B3 = document.documentElement.lang || navigator.language, e.observe(document.documentElement, {
    attributes: !0,
    attributeFilter: ["dir", "lang"]
  });
}
function ox(...e) {
  e.map((t) => {
    const r = t.$code.toLowerCase();
    Tl.has(r) ? Tl.set(r, Object.assign(Object.assign({}, Tl.get(r)), t)) : Tl.set(r, t), cs || (cs = t);
  }), sx();
}
function sx() {
  ax && (q3 = document.documentElement.dir || "ltr", B3 = document.documentElement.lang || navigator.language), [...Ym.keys()].map((e) => {
    typeof e.requestUpdate == "function" && e.requestUpdate();
  });
}
let Coe = class {
  constructor(t) {
    this.host = t, this.host.addController(this);
  }
  hostConnected() {
    Ym.add(this.host);
  }
  hostDisconnected() {
    Ym.delete(this.host);
  }
  dir() {
    return `${this.host.dir || q3}`.toLowerCase();
  }
  lang() {
    return `${this.host.lang || B3}`.toLowerCase();
  }
  getTranslationData(t) {
    var r, n;
    const i = new Intl.Locale(t.replace(/_/g, "-")), a = i?.language.toLowerCase(), o = (n = (r = i?.region) === null || r === void 0 ? void 0 : r.toLowerCase()) !== null && n !== void 0 ? n : "", s = Tl.get(`${a}-${o}`), l = Tl.get(a);
    return { locale: i, language: a, region: o, primary: s, secondary: l };
  }
  exists(t, r) {
    var n;
    const { primary: i, secondary: a } = this.getTranslationData((n = r.lang) !== null && n !== void 0 ? n : this.lang());
    return r = Object.assign({ includeFallback: !1 }, r), !!(i && i[t] || a && a[t] || r.includeFallback && cs && cs[t]);
  }
  term(t, ...r) {
    const { primary: n, secondary: i } = this.getTranslationData(this.lang());
    let a;
    if (n && n[t])
      a = n[t];
    else if (i && i[t])
      a = i[t];
    else if (cs && cs[t])
      a = cs[t];
    else
      return console.error(`No translation found for: ${String(t)}`), String(t);
    return typeof a == "function" ? a(...r) : a;
  }
  date(t, r) {
    return t = new Date(t), new Intl.DateTimeFormat(this.lang(), r).format(t);
  }
  number(t, r) {
    return t = Number(t), isNaN(t) ? "" : new Intl.NumberFormat(this.lang(), r).format(t);
  }
  relativeTime(t, r, n) {
    return new Intl.RelativeTimeFormat(this.lang(), n).format(t, r);
  }
};
var lx = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  carousel: "Carousel",
  clearEntry: "Clear entry",
  close: "Close",
  copied: "Copied",
  copy: "Copy",
  currentValue: "Current value",
  error: "Error",
  goToSlide: (e, t) => `Go to slide ${e} of ${t}`,
  hidePassword: "Hide password",
  loading: "Loading",
  nextSlide: "Next slide",
  numOptionsSelected: (e) => e === 0 ? "No options selected" : e === 1 ? "1 option selected" : `${e} options selected`,
  previousSlide: "Previous slide",
  progress: "Progress",
  remove: "Remove",
  resize: "Resize",
  scrollToEnd: "Scroll to end",
  scrollToStart: "Scroll to start",
  selectAColorFromTheScreen: "Select a color from the screen",
  showPassword: "Show password",
  slideNum: (e) => `Slide ${e}`,
  toggleColorFormat: "Toggle color format"
};
ox(lx);
var Eoe = lx, Do = class extends Coe {
};
ox(Eoe);
var oi = Ln`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`, dx = Object.defineProperty, Aoe = Object.defineProperties, Toe = Object.getOwnPropertyDescriptor, Ooe = Object.getOwnPropertyDescriptors, $7 = Object.getOwnPropertySymbols, Ioe = Object.prototype.hasOwnProperty, Poe = Object.prototype.propertyIsEnumerable, gp = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), H3 = (e) => {
  throw TypeError(e);
}, k7 = (e, t, r) => t in e ? dx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Us = (e, t) => {
  for (var r in t || (t = {}))
    Ioe.call(t, r) && k7(e, r, t[r]);
  if ($7)
    for (var r of $7(t))
      Poe.call(t, r) && k7(e, r, t[r]);
  return e;
}, kf = (e, t) => Aoe(e, Ooe(t)), q = (e, t, r, n) => {
  for (var i = n > 1 ? void 0 : n ? Toe(t, r) : t, a = e.length - 1, o; a >= 0; a--)
    (o = e[a]) && (i = (n ? o(t, r, i) : o(i)) || i);
  return n && i && dx(t, r, i), i;
}, cx = (e, t, r) => t.has(e) || H3("Cannot " + r), Noe = (e, t, r) => (cx(e, t, "read from private field"), t.get(e)), Doe = (e, t, r) => t.has(e) ? H3("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Moe = (e, t, r, n) => (cx(e, t, "write to private field"), t.set(e, r), r), Roe = function(e, t) {
  this[0] = e, this[1] = t;
}, Loe = (e) => {
  var t = e[gp("asyncIterator")], r = !1, n, i = {};
  return t == null ? (t = e[gp("iterator")](), n = (a) => i[a] = (o) => t[a](o)) : (t = t.call(e), n = (a) => i[a] = (o) => {
    if (r) {
      if (r = !1, a === "throw") throw o;
      return o;
    }
    return r = !0, {
      done: !1,
      value: new Roe(new Promise((s) => {
        var l = t[a](o);
        l instanceof Object || H3("Object expected"), s(l);
      }), 1)
    };
  }), i[gp("iterator")] = () => i, n("next"), "throw" in t ? n("throw") : i.throw = (a) => {
    throw a;
  }, "return" in t && n("return"), i;
};
const Foe = { attribute: !0, type: String, converter: ld, reflect: !1, hasChanged: j3 }, joe = (e = Foe, t, r) => {
  const { kind: n, metadata: i } = r;
  let a = globalThis.litPropertyMetadata.get(i);
  if (a === void 0 && globalThis.litPropertyMetadata.set(i, a = /* @__PURE__ */ new Map()), n === "setter" && ((e = Object.create(e)).wrapped = !0), a.set(r.name, e), n === "accessor") {
    const { name: o } = r;
    return { set(s) {
      const l = t.get.call(this);
      t.set.call(this, s), this.requestUpdate(o, l, e, !0, s);
    }, init(s) {
      return s !== void 0 && this.C(o, void 0, e, s), s;
    } };
  }
  if (n === "setter") {
    const { name: o } = r;
    return function(s) {
      const l = this[o];
      t.call(this, s), this.requestUpdate(o, l, e, !0, s);
    };
  }
  throw Error("Unsupported decorator location: " + n);
};
function de(e) {
  return (t, r) => typeof r == "object" ? joe(e, t, r) : ((n, i, a) => {
    const o = i.hasOwnProperty(a);
    return i.constructor.createProperty(a, n), o ? Object.getOwnPropertyDescriptor(i, a) : void 0;
  })(e, t, r);
}
function n0(e) {
  return de({ ...e, state: !0, attribute: !1 });
}
const zoe = (e, t, r) => (r.configurable = !0, r.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, r), r);
function qr(e, t) {
  return (r, n, i) => {
    const a = (o) => o.renderRoot?.querySelector(e) ?? null;
    return zoe(r, n, { get() {
      return a(this);
    } });
  };
}
var _1, fn = class extends Uc {
  constructor() {
    super(), Doe(this, _1, !1), this.initialReflectedProperties = /* @__PURE__ */ new Map(), Object.entries(this.constructor.dependencies).forEach(([e, t]) => {
      this.constructor.define(e, t);
    });
  }
  emit(e, t) {
    const r = new CustomEvent(e, Us({
      bubbles: !0,
      cancelable: !1,
      composed: !0,
      detail: {}
    }, t));
    return this.dispatchEvent(r), r;
  }
  /* eslint-enable */
  static define(e, t = this, r = {}) {
    const n = customElements.get(e);
    if (!n) {
      try {
        customElements.define(e, t, r);
      } catch {
        customElements.define(e, class extends t {
        }, r);
      }
      return;
    }
    let i = " (unknown version)", a = i;
    "version" in t && t.version && (i = " v" + t.version), "version" in n && n.version && (a = " v" + n.version), !(i && a && i === a) && console.warn(
      `Attempted to register <${e}>${i}, but <${e}>${a} has already been registered.`
    );
  }
  attributeChangedCallback(e, t, r) {
    Noe(this, _1) || (this.constructor.elementProperties.forEach(
      (n, i) => {
        n.reflect && this[i] != null && this.initialReflectedProperties.set(i, this[i]);
      }
    ), Moe(this, _1, !0)), super.attributeChangedCallback(e, t, r);
  }
  willUpdate(e) {
    super.willUpdate(e), this.initialReflectedProperties.forEach((t, r) => {
      e.has(r) && this[r] == null && (this[r] = t);
    });
  }
};
_1 = /* @__PURE__ */ new WeakMap();
fn.version = "2.20.1";
fn.dependencies = {};
q([
  de()
], fn.prototype, "dir", 2);
q([
  de()
], fn.prototype, "lang", 2);
var W3 = class extends fn {
  constructor() {
    super(...arguments), this.localize = new Do(this);
  }
  render() {
    return hr`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
  }
};
W3.styles = [oi, Soe];
W3.define("sl-spinner");
var Jm = "";
function Ii(e) {
  Jm = e;
}
function Voe(e = "") {
  if (!Jm) {
    const t = [...document.getElementsByTagName("script")], r = t.find((n) => n.hasAttribute("data-shoelace"));
    if (r)
      Ii(r.getAttribute("data-shoelace"));
    else {
      const n = t.find((a) => /shoelace(\.min)?\.js($|\?)/.test(a.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(a.src));
      let i = "";
      n && (i = n.getAttribute("src")), Ii(i.split("/").slice(0, -1).join("/"));
    }
  }
  return Jm.replace(/\/$/, "") + (e ? `/${e.replace(/^\//, "")}` : "");
}
const Mo = ':root,:host,.sl-theme-light{color-scheme:light;--sl-color-gray-50: hsl(0 0% 97.5%);--sl-color-gray-100: hsl(240 4.8% 95.9%);--sl-color-gray-200: hsl(240 5.9% 90%);--sl-color-gray-300: hsl(240 4.9% 83.9%);--sl-color-gray-400: hsl(240 5% 64.9%);--sl-color-gray-500: hsl(240 3.8% 46.1%);--sl-color-gray-600: hsl(240 5.2% 33.9%);--sl-color-gray-700: hsl(240 5.3% 26.1%);--sl-color-gray-800: hsl(240 3.7% 15.9%);--sl-color-gray-900: hsl(240 5.9% 10%);--sl-color-gray-950: hsl(240 7.3% 8%);--sl-color-red-50: hsl(0 85.7% 97.3%);--sl-color-red-100: hsl(0 93.3% 94.1%);--sl-color-red-200: hsl(0 96.3% 89.4%);--sl-color-red-300: hsl(0 93.5% 81.8%);--sl-color-red-400: hsl(0 90.6% 70.8%);--sl-color-red-500: hsl(0 84.2% 60.2%);--sl-color-red-600: hsl(0 72.2% 50.6%);--sl-color-red-700: hsl(0 73.7% 41.8%);--sl-color-red-800: hsl(0 70% 35.3%);--sl-color-red-900: hsl(0 62.8% 30.6%);--sl-color-red-950: hsl(0 60% 19.6%);--sl-color-orange-50: hsl(33.3 100% 96.5%);--sl-color-orange-100: hsl(34.3 100% 91.8%);--sl-color-orange-200: hsl(32.1 97.7% 83.1%);--sl-color-orange-300: hsl(30.7 97.2% 72.4%);--sl-color-orange-400: hsl(27 96% 61%);--sl-color-orange-500: hsl(24.6 95% 53.1%);--sl-color-orange-600: hsl(20.5 90.2% 48.2%);--sl-color-orange-700: hsl(17.5 88.3% 40.4%);--sl-color-orange-800: hsl(15 79.1% 33.7%);--sl-color-orange-900: hsl(15.3 74.6% 27.8%);--sl-color-orange-950: hsl(15.2 69.1% 19%);--sl-color-amber-50: hsl(48 100% 96.1%);--sl-color-amber-100: hsl(48 96.5% 88.8%);--sl-color-amber-200: hsl(48 96.6% 76.7%);--sl-color-amber-300: hsl(45.9 96.7% 64.5%);--sl-color-amber-400: hsl(43.3 96.4% 56.3%);--sl-color-amber-500: hsl(37.7 92.1% 50.2%);--sl-color-amber-600: hsl(32.1 94.6% 43.7%);--sl-color-amber-700: hsl(26 90.5% 37.1%);--sl-color-amber-800: hsl(22.7 82.5% 31.4%);--sl-color-amber-900: hsl(21.7 77.8% 26.5%);--sl-color-amber-950: hsl(22.9 74.1% 16.7%);--sl-color-yellow-50: hsl(54.5 91.7% 95.3%);--sl-color-yellow-100: hsl(54.9 96.7% 88%);--sl-color-yellow-200: hsl(52.8 98.3% 76.9%);--sl-color-yellow-300: hsl(50.4 97.8% 63.5%);--sl-color-yellow-400: hsl(47.9 95.8% 53.1%);--sl-color-yellow-500: hsl(45.4 93.4% 47.5%);--sl-color-yellow-600: hsl(40.6 96.1% 40.4%);--sl-color-yellow-700: hsl(35.5 91.7% 32.9%);--sl-color-yellow-800: hsl(31.8 81% 28.8%);--sl-color-yellow-900: hsl(28.4 72.5% 25.7%);--sl-color-yellow-950: hsl(33.1 69% 13.9%);--sl-color-lime-50: hsl(78.3 92% 95.1%);--sl-color-lime-100: hsl(79.6 89.1% 89.2%);--sl-color-lime-200: hsl(80.9 88.5% 79.6%);--sl-color-lime-300: hsl(82 84.5% 67.1%);--sl-color-lime-400: hsl(82.7 78% 55.5%);--sl-color-lime-500: hsl(83.7 80.5% 44.3%);--sl-color-lime-600: hsl(84.8 85.2% 34.5%);--sl-color-lime-700: hsl(85.9 78.4% 27.3%);--sl-color-lime-800: hsl(86.3 69% 22.7%);--sl-color-lime-900: hsl(87.6 61.2% 20.2%);--sl-color-lime-950: hsl(86.5 60.6% 13.9%);--sl-color-green-50: hsl(138.5 76.5% 96.7%);--sl-color-green-100: hsl(140.6 84.2% 92.5%);--sl-color-green-200: hsl(141 78.9% 85.1%);--sl-color-green-300: hsl(141.7 76.6% 73.1%);--sl-color-green-400: hsl(141.9 69.2% 58%);--sl-color-green-500: hsl(142.1 70.6% 45.3%);--sl-color-green-600: hsl(142.1 76.2% 36.3%);--sl-color-green-700: hsl(142.4 71.8% 29.2%);--sl-color-green-800: hsl(142.8 64.2% 24.1%);--sl-color-green-900: hsl(143.8 61.2% 20.2%);--sl-color-green-950: hsl(144.3 60.7% 12%);--sl-color-emerald-50: hsl(151.8 81% 95.9%);--sl-color-emerald-100: hsl(149.3 80.4% 90%);--sl-color-emerald-200: hsl(152.4 76% 80.4%);--sl-color-emerald-300: hsl(156.2 71.6% 66.9%);--sl-color-emerald-400: hsl(158.1 64.4% 51.6%);--sl-color-emerald-500: hsl(160.1 84.1% 39.4%);--sl-color-emerald-600: hsl(161.4 93.5% 30.4%);--sl-color-emerald-700: hsl(162.9 93.5% 24.3%);--sl-color-emerald-800: hsl(163.1 88.1% 19.8%);--sl-color-emerald-900: hsl(164.2 85.7% 16.5%);--sl-color-emerald-950: hsl(164.3 87.5% 9.4%);--sl-color-teal-50: hsl(166.2 76.5% 96.7%);--sl-color-teal-100: hsl(167.2 85.5% 89.2%);--sl-color-teal-200: hsl(168.4 83.8% 78.2%);--sl-color-teal-300: hsl(170.6 76.9% 64.3%);--sl-color-teal-400: hsl(172.5 66% 50.4%);--sl-color-teal-500: hsl(173.4 80.4% 40%);--sl-color-teal-600: hsl(174.7 83.9% 31.6%);--sl-color-teal-700: hsl(175.3 77.4% 26.1%);--sl-color-teal-800: hsl(176.1 69.4% 21.8%);--sl-color-teal-900: hsl(175.9 60.8% 19%);--sl-color-teal-950: hsl(176.5 58.6% 11.4%);--sl-color-cyan-50: hsl(183.2 100% 96.3%);--sl-color-cyan-100: hsl(185.1 95.9% 90.4%);--sl-color-cyan-200: hsl(186.2 93.5% 81.8%);--sl-color-cyan-300: hsl(187 92.4% 69%);--sl-color-cyan-400: hsl(187.9 85.7% 53.3%);--sl-color-cyan-500: hsl(188.7 94.5% 42.7%);--sl-color-cyan-600: hsl(191.6 91.4% 36.5%);--sl-color-cyan-700: hsl(192.9 82.3% 31%);--sl-color-cyan-800: hsl(194.4 69.6% 27.1%);--sl-color-cyan-900: hsl(196.4 63.6% 23.7%);--sl-color-cyan-950: hsl(196.8 61% 16.1%);--sl-color-sky-50: hsl(204 100% 97.1%);--sl-color-sky-100: hsl(204 93.8% 93.7%);--sl-color-sky-200: hsl(200.6 94.4% 86.1%);--sl-color-sky-300: hsl(199.4 95.5% 73.9%);--sl-color-sky-400: hsl(198.4 93.2% 59.6%);--sl-color-sky-500: hsl(198.6 88.7% 48.4%);--sl-color-sky-600: hsl(200.4 98% 39.4%);--sl-color-sky-700: hsl(201.3 96.3% 32.2%);--sl-color-sky-800: hsl(201 90% 27.5%);--sl-color-sky-900: hsl(202 80.3% 23.9%);--sl-color-sky-950: hsl(202.3 73.8% 16.5%);--sl-color-blue-50: hsl(213.8 100% 96.9%);--sl-color-blue-100: hsl(214.3 94.6% 92.7%);--sl-color-blue-200: hsl(213.3 96.9% 87.3%);--sl-color-blue-300: hsl(211.7 96.4% 78.4%);--sl-color-blue-400: hsl(213.1 93.9% 67.8%);--sl-color-blue-500: hsl(217.2 91.2% 59.8%);--sl-color-blue-600: hsl(221.2 83.2% 53.3%);--sl-color-blue-700: hsl(224.3 76.3% 48%);--sl-color-blue-800: hsl(225.9 70.7% 40.2%);--sl-color-blue-900: hsl(224.4 64.3% 32.9%);--sl-color-blue-950: hsl(226.2 55.3% 18.4%);--sl-color-indigo-50: hsl(225.9 100% 96.7%);--sl-color-indigo-100: hsl(226.5 100% 93.9%);--sl-color-indigo-200: hsl(228 96.5% 88.8%);--sl-color-indigo-300: hsl(229.7 93.5% 81.8%);--sl-color-indigo-400: hsl(234.5 89.5% 73.9%);--sl-color-indigo-500: hsl(238.7 83.5% 66.7%);--sl-color-indigo-600: hsl(243.4 75.4% 58.6%);--sl-color-indigo-700: hsl(244.5 57.9% 50.6%);--sl-color-indigo-800: hsl(243.7 54.5% 41.4%);--sl-color-indigo-900: hsl(242.2 47.4% 34.3%);--sl-color-indigo-950: hsl(243.5 43.6% 22.9%);--sl-color-violet-50: hsl(250 100% 97.6%);--sl-color-violet-100: hsl(251.4 91.3% 95.5%);--sl-color-violet-200: hsl(250.5 95.2% 91.8%);--sl-color-violet-300: hsl(252.5 94.7% 85.1%);--sl-color-violet-400: hsl(255.1 91.7% 76.3%);--sl-color-violet-500: hsl(258.3 89.5% 66.3%);--sl-color-violet-600: hsl(262.1 83.3% 57.8%);--sl-color-violet-700: hsl(263.4 70% 50.4%);--sl-color-violet-800: hsl(263.4 69.3% 42.2%);--sl-color-violet-900: hsl(263.5 67.4% 34.9%);--sl-color-violet-950: hsl(265.1 61.5% 21.4%);--sl-color-purple-50: hsl(270 100% 98%);--sl-color-purple-100: hsl(268.7 100% 95.5%);--sl-color-purple-200: hsl(268.6 100% 91.8%);--sl-color-purple-300: hsl(269.2 97.4% 85.1%);--sl-color-purple-400: hsl(270 95.2% 75.3%);--sl-color-purple-500: hsl(270.7 91% 65.1%);--sl-color-purple-600: hsl(271.5 81.3% 55.9%);--sl-color-purple-700: hsl(272.1 71.7% 47.1%);--sl-color-purple-800: hsl(272.9 67.2% 39.4%);--sl-color-purple-900: hsl(273.6 65.6% 32%);--sl-color-purple-950: hsl(276 59.5% 16.5%);--sl-color-fuchsia-50: hsl(289.1 100% 97.8%);--sl-color-fuchsia-100: hsl(287 100% 95.5%);--sl-color-fuchsia-200: hsl(288.3 95.8% 90.6%);--sl-color-fuchsia-300: hsl(291.1 93.1% 82.9%);--sl-color-fuchsia-400: hsl(292 91.4% 72.5%);--sl-color-fuchsia-500: hsl(292.2 84.1% 60.6%);--sl-color-fuchsia-600: hsl(293.4 69.5% 48.8%);--sl-color-fuchsia-700: hsl(294.7 72.4% 39.8%);--sl-color-fuchsia-800: hsl(295.4 70.2% 32.9%);--sl-color-fuchsia-900: hsl(296.7 63.6% 28%);--sl-color-fuchsia-950: hsl(297.1 56.8% 14.5%);--sl-color-pink-50: hsl(327.3 73.3% 97.1%);--sl-color-pink-100: hsl(325.7 77.8% 94.7%);--sl-color-pink-200: hsl(325.9 84.6% 89.8%);--sl-color-pink-300: hsl(327.4 87.1% 81.8%);--sl-color-pink-400: hsl(328.6 85.5% 70.2%);--sl-color-pink-500: hsl(330.4 81.2% 60.4%);--sl-color-pink-600: hsl(333.3 71.4% 50.6%);--sl-color-pink-700: hsl(335.1 77.6% 42%);--sl-color-pink-800: hsl(335.8 74.4% 35.3%);--sl-color-pink-900: hsl(335.9 69% 30.4%);--sl-color-pink-950: hsl(336.2 65.4% 15.9%);--sl-color-rose-50: hsl(355.7 100% 97.3%);--sl-color-rose-100: hsl(355.6 100% 94.7%);--sl-color-rose-200: hsl(352.7 96.1% 90%);--sl-color-rose-300: hsl(352.6 95.7% 81.8%);--sl-color-rose-400: hsl(351.3 94.5% 71.4%);--sl-color-rose-500: hsl(349.7 89.2% 60.2%);--sl-color-rose-600: hsl(346.8 77.2% 49.8%);--sl-color-rose-700: hsl(345.3 82.7% 40.8%);--sl-color-rose-800: hsl(343.4 79.7% 34.7%);--sl-color-rose-900: hsl(341.5 75.5% 30.4%);--sl-color-rose-950: hsl(341.3 70.1% 17.1%);--sl-color-primary-50: var(--sl-color-sky-50);--sl-color-primary-100: var(--sl-color-sky-100);--sl-color-primary-200: var(--sl-color-sky-200);--sl-color-primary-300: var(--sl-color-sky-300);--sl-color-primary-400: var(--sl-color-sky-400);--sl-color-primary-500: var(--sl-color-sky-500);--sl-color-primary-600: var(--sl-color-sky-600);--sl-color-primary-700: var(--sl-color-sky-700);--sl-color-primary-800: var(--sl-color-sky-800);--sl-color-primary-900: var(--sl-color-sky-900);--sl-color-primary-950: var(--sl-color-sky-950);--sl-color-success-50: var(--sl-color-green-50);--sl-color-success-100: var(--sl-color-green-100);--sl-color-success-200: var(--sl-color-green-200);--sl-color-success-300: var(--sl-color-green-300);--sl-color-success-400: var(--sl-color-green-400);--sl-color-success-500: var(--sl-color-green-500);--sl-color-success-600: var(--sl-color-green-600);--sl-color-success-700: var(--sl-color-green-700);--sl-color-success-800: var(--sl-color-green-800);--sl-color-success-900: var(--sl-color-green-900);--sl-color-success-950: var(--sl-color-green-950);--sl-color-warning-50: var(--sl-color-amber-50);--sl-color-warning-100: var(--sl-color-amber-100);--sl-color-warning-200: var(--sl-color-amber-200);--sl-color-warning-300: var(--sl-color-amber-300);--sl-color-warning-400: var(--sl-color-amber-400);--sl-color-warning-500: var(--sl-color-amber-500);--sl-color-warning-600: var(--sl-color-amber-600);--sl-color-warning-700: var(--sl-color-amber-700);--sl-color-warning-800: var(--sl-color-amber-800);--sl-color-warning-900: var(--sl-color-amber-900);--sl-color-warning-950: var(--sl-color-amber-950);--sl-color-danger-50: var(--sl-color-red-50);--sl-color-danger-100: var(--sl-color-red-100);--sl-color-danger-200: var(--sl-color-red-200);--sl-color-danger-300: var(--sl-color-red-300);--sl-color-danger-400: var(--sl-color-red-400);--sl-color-danger-500: var(--sl-color-red-500);--sl-color-danger-600: var(--sl-color-red-600);--sl-color-danger-700: var(--sl-color-red-700);--sl-color-danger-800: var(--sl-color-red-800);--sl-color-danger-900: var(--sl-color-red-900);--sl-color-danger-950: var(--sl-color-red-950);--sl-color-neutral-50: var(--sl-color-gray-50);--sl-color-neutral-100: var(--sl-color-gray-100);--sl-color-neutral-200: var(--sl-color-gray-200);--sl-color-neutral-300: var(--sl-color-gray-300);--sl-color-neutral-400: var(--sl-color-gray-400);--sl-color-neutral-500: var(--sl-color-gray-500);--sl-color-neutral-600: var(--sl-color-gray-600);--sl-color-neutral-700: var(--sl-color-gray-700);--sl-color-neutral-800: var(--sl-color-gray-800);--sl-color-neutral-900: var(--sl-color-gray-900);--sl-color-neutral-950: var(--sl-color-gray-950);--sl-color-neutral-0: hsl(0, 0%, 100%);--sl-color-neutral-1000: hsl(0, 0%, 0%);--sl-border-radius-small: .1875rem;--sl-border-radius-medium: .25rem;--sl-border-radius-large: .5rem;--sl-border-radius-x-large: 1rem;--sl-border-radius-circle: 50%;--sl-border-radius-pill: 9999px;--sl-shadow-x-small: 0 1px 2px hsl(240 3.8% 46.1% / 6%);--sl-shadow-small: 0 1px 2px hsl(240 3.8% 46.1% / 12%);--sl-shadow-medium: 0 2px 4px hsl(240 3.8% 46.1% / 12%);--sl-shadow-large: 0 2px 8px hsl(240 3.8% 46.1% / 12%);--sl-shadow-x-large: 0 4px 16px hsl(240 3.8% 46.1% / 12%);--sl-spacing-3x-small: .125rem;--sl-spacing-2x-small: .25rem;--sl-spacing-x-small: .5rem;--sl-spacing-small: .75rem;--sl-spacing-medium: 1rem;--sl-spacing-large: 1.25rem;--sl-spacing-x-large: 1.75rem;--sl-spacing-2x-large: 2.25rem;--sl-spacing-3x-large: 3rem;--sl-spacing-4x-large: 4.5rem;--sl-transition-x-slow: 1s;--sl-transition-slow: .5s;--sl-transition-medium: .25s;--sl-transition-fast: .15s;--sl-transition-x-fast: 50ms;--sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;--sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";--sl-font-serif: Georgia, "Times New Roman", serif;--sl-font-size-2x-small: .625rem;--sl-font-size-x-small: .75rem;--sl-font-size-small: .875rem;--sl-font-size-medium: 1rem;--sl-font-size-large: 1.25rem;--sl-font-size-x-large: 1.5rem;--sl-font-size-2x-large: 2.25rem;--sl-font-size-3x-large: 3rem;--sl-font-size-4x-large: 4.5rem;--sl-font-weight-light: 300;--sl-font-weight-normal: 400;--sl-font-weight-semibold: 500;--sl-font-weight-bold: 700;--sl-letter-spacing-denser: -.03em;--sl-letter-spacing-dense: -.015em;--sl-letter-spacing-normal: normal;--sl-letter-spacing-loose: .075em;--sl-letter-spacing-looser: .15em;--sl-line-height-denser: 1;--sl-line-height-dense: 1.4;--sl-line-height-normal: 1.8;--sl-line-height-loose: 2.2;--sl-line-height-looser: 2.6;--sl-focus-ring-color: var(--sl-color-primary-600);--sl-focus-ring-style: solid;--sl-focus-ring-width: 3px;--sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-focus-ring-color);--sl-focus-ring-offset: 1px;--sl-button-font-size-small: var(--sl-font-size-x-small);--sl-button-font-size-medium: var(--sl-font-size-small);--sl-button-font-size-large: var(--sl-font-size-medium);--sl-input-height-small: 1.875rem;--sl-input-height-medium: 2.5rem;--sl-input-height-large: 3.125rem;--sl-input-background-color: var(--sl-color-neutral-0);--sl-input-background-color-hover: var(--sl-input-background-color);--sl-input-background-color-focus: var(--sl-input-background-color);--sl-input-background-color-disabled: var(--sl-color-neutral-100);--sl-input-border-color: var(--sl-color-neutral-300);--sl-input-border-color-hover: var(--sl-color-neutral-400);--sl-input-border-color-focus: var(--sl-color-primary-500);--sl-input-border-color-disabled: var(--sl-color-neutral-300);--sl-input-border-width: 1px;--sl-input-required-content: "*";--sl-input-required-content-offset: -2px;--sl-input-required-content-color: var(--sl-input-label-color);--sl-input-border-radius-small: var(--sl-border-radius-medium);--sl-input-border-radius-medium: var(--sl-border-radius-medium);--sl-input-border-radius-large: var(--sl-border-radius-medium);--sl-input-font-family: var(--sl-font-sans);--sl-input-font-weight: var(--sl-font-weight-normal);--sl-input-font-size-small: var(--sl-font-size-small);--sl-input-font-size-medium: var(--sl-font-size-medium);--sl-input-font-size-large: var(--sl-font-size-large);--sl-input-letter-spacing: var(--sl-letter-spacing-normal);--sl-input-color: var(--sl-color-neutral-700);--sl-input-color-hover: var(--sl-color-neutral-700);--sl-input-color-focus: var(--sl-color-neutral-700);--sl-input-color-disabled: var(--sl-color-neutral-900);--sl-input-icon-color: var(--sl-color-neutral-500);--sl-input-icon-color-hover: var(--sl-color-neutral-600);--sl-input-icon-color-focus: var(--sl-color-neutral-600);--sl-input-placeholder-color: var(--sl-color-neutral-500);--sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);--sl-input-spacing-small: var(--sl-spacing-small);--sl-input-spacing-medium: var(--sl-spacing-medium);--sl-input-spacing-large: var(--sl-spacing-large);--sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);--sl-input-focus-ring-offset: 0;--sl-input-filled-background-color: var(--sl-color-neutral-100);--sl-input-filled-background-color-hover: var(--sl-color-neutral-100);--sl-input-filled-background-color-focus: var(--sl-color-neutral-100);--sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);--sl-input-filled-color: var(--sl-color-neutral-800);--sl-input-filled-color-hover: var(--sl-color-neutral-800);--sl-input-filled-color-focus: var(--sl-color-neutral-700);--sl-input-filled-color-disabled: var(--sl-color-neutral-800);--sl-input-label-font-size-small: var(--sl-font-size-small);--sl-input-label-font-size-medium: var(--sl-font-size-medium);--sl-input-label-font-size-large: var(--sl-font-size-large);--sl-input-label-color: inherit;--sl-input-help-text-font-size-small: var(--sl-font-size-x-small);--sl-input-help-text-font-size-medium: var(--sl-font-size-small);--sl-input-help-text-font-size-large: var(--sl-font-size-medium);--sl-input-help-text-color: var(--sl-color-neutral-500);--sl-toggle-size-small: .875rem;--sl-toggle-size-medium: 1.125rem;--sl-toggle-size-large: 1.375rem;--sl-overlay-background-color: hsl(240 3.8% 46.1% / 33%);--sl-panel-background-color: var(--sl-color-neutral-0);--sl-panel-border-color: var(--sl-color-neutral-200);--sl-panel-border-width: 1px;--sl-tooltip-border-radius: var(--sl-border-radius-medium);--sl-tooltip-background-color: var(--sl-color-neutral-800);--sl-tooltip-color: var(--sl-color-neutral-0);--sl-tooltip-font-family: var(--sl-font-sans);--sl-tooltip-font-weight: var(--sl-font-weight-normal);--sl-tooltip-font-size: var(--sl-font-size-small);--sl-tooltip-line-height: var(--sl-line-height-dense);--sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);--sl-tooltip-arrow-size: 6px;--sl-z-index-drawer: 700;--sl-z-index-dialog: 800;--sl-z-index-dropdown: 900;--sl-z-index-toast: 950;--sl-z-index-tooltip: 1000}@supports (scrollbar-gutter: stable){.sl-scroll-lock{scrollbar-gutter:var(--sl-scroll-lock-gutter)!important}.sl-scroll-lock body{overflow:hidden!important}}@supports not (scrollbar-gutter: stable){.sl-scroll-lock body{padding-right:var(--sl-scroll-lock-size)!important;overflow:hidden!important}}.sl-toast-stack{position:fixed;top:0;inset-inline-end:0;z-index:var(--sl-z-index-toast);width:28rem;max-width:100%;max-height:100%;overflow:auto}.sl-toast-stack sl-alert{margin:var(--sl-spacing-medium)}.sl-toast-stack sl-alert::part(base){box-shadow:var(--sl-shadow-large)}', Ro = ':host,.sl-theme-dark{color-scheme:dark;--sl-color-gray-50: hsl(240 5.1% 15%);--sl-color-gray-100: hsl(240 5.7% 18.2%);--sl-color-gray-200: hsl(240 4.6% 22%);--sl-color-gray-300: hsl(240 5% 27.6%);--sl-color-gray-400: hsl(240 5% 35.5%);--sl-color-gray-500: hsl(240 3.7% 44%);--sl-color-gray-600: hsl(240 5.3% 58%);--sl-color-gray-700: hsl(240 5.6% 73%);--sl-color-gray-800: hsl(240 7.3% 84%);--sl-color-gray-900: hsl(240 9.1% 91.8%);--sl-color-gray-950: hsl(0 0% 95%);--sl-color-red-50: hsl(0 56% 23.9%);--sl-color-red-100: hsl(.6 60% 33.9%);--sl-color-red-200: hsl(.9 67.2% 37.1%);--sl-color-red-300: hsl(1.1 71.3% 43.7%);--sl-color-red-400: hsl(1 76% 52.5%);--sl-color-red-500: hsl(.7 89.6% 57.2%);--sl-color-red-600: hsl(0 98.6% 67.9%);--sl-color-red-700: hsl(0 100% 72.3%);--sl-color-red-800: hsl(0 100% 85.6%);--sl-color-red-900: hsl(0 100% 90.3%);--sl-color-red-950: hsl(0 100% 95.9%);--sl-color-orange-50: hsl(15 64.2% 23.3%);--sl-color-orange-100: hsl(15.1 70.9% 31.1%);--sl-color-orange-200: hsl(15.3 75.7% 35.5%);--sl-color-orange-300: hsl(17.1 83.5% 42.7%);--sl-color-orange-400: hsl(20.1 88% 50.8%);--sl-color-orange-500: hsl(24.3 100% 50.5%);--sl-color-orange-600: hsl(27.2 100% 57.7%);--sl-color-orange-700: hsl(31.3 100% 68.7%);--sl-color-orange-800: hsl(33.8 100% 79.3%);--sl-color-orange-900: hsl(38.9 100% 87.7%);--sl-color-orange-950: hsl(46.2 100% 95%);--sl-color-amber-50: hsl(21.9 66.3% 21.1%);--sl-color-amber-100: hsl(21.5 73.6% 29.7%);--sl-color-amber-200: hsl(22.3 77.6% 33.3%);--sl-color-amber-300: hsl(25.4 84.2% 39.6%);--sl-color-amber-400: hsl(31.4 87.4% 46.7%);--sl-color-amber-500: hsl(37 96.6% 48.3%);--sl-color-amber-600: hsl(43.3 100% 53.4%);--sl-color-amber-700: hsl(46.5 100% 61.1%);--sl-color-amber-800: hsl(49.3 100% 73%);--sl-color-amber-900: hsl(51.8 100% 85%);--sl-color-amber-950: hsl(60 100% 94.6%);--sl-color-yellow-50: hsl(32.5 60% 18.2%);--sl-color-yellow-100: hsl(28.1 68.6% 29%);--sl-color-yellow-200: hsl(31.3 75.8% 30.8%);--sl-color-yellow-300: hsl(34.7 84.4% 35.3%);--sl-color-yellow-400: hsl(40.1 87.3% 43.3%);--sl-color-yellow-500: hsl(44.7 88% 46%);--sl-color-yellow-600: hsl(47.7 100% 50.9%);--sl-color-yellow-700: hsl(51.3 100% 59.9%);--sl-color-yellow-800: hsl(54.6 100% 73%);--sl-color-yellow-900: hsl(58.9 100% 84.2%);--sl-color-yellow-950: hsl(60 100% 94%);--sl-color-lime-50: hsl(86.5 54.4% 18%);--sl-color-lime-100: hsl(87.6 56.8% 23.3%);--sl-color-lime-200: hsl(85.8 63.2% 24.5%);--sl-color-lime-300: hsl(86.1 72% 29.4%);--sl-color-lime-400: hsl(85.5 76.8% 37.3%);--sl-color-lime-500: hsl(84.3 74.2% 42.1%);--sl-color-lime-600: hsl(82.8 81.5% 52.6%);--sl-color-lime-700: hsl(82 89.9% 64%);--sl-color-lime-800: hsl(80.9 97.9% 76.6%);--sl-color-lime-900: hsl(77.9 100% 85.8%);--sl-color-lime-950: hsl(69.5 100% 93.8%);--sl-color-green-50: hsl(144.3 53.6% 16%);--sl-color-green-100: hsl(143.2 55.4% 23.5%);--sl-color-green-200: hsl(141.5 58.2% 26.3%);--sl-color-green-300: hsl(140.8 64.2% 31.8%);--sl-color-green-400: hsl(140.3 68% 39.2%);--sl-color-green-500: hsl(141.1 64.9% 43%);--sl-color-green-600: hsl(141.6 72.4% 55.2%);--sl-color-green-700: hsl(141.7 82.7% 70.1%);--sl-color-green-800: hsl(141 90.9% 82.1%);--sl-color-green-900: hsl(142 100% 89.1%);--sl-color-green-950: hsl(144 100% 95.5%);--sl-color-emerald-50: hsl(164.3 75% 13.5%);--sl-color-emerald-100: hsl(163.5 72.6% 20.1%);--sl-color-emerald-200: hsl(162.1 73.7% 22.4%);--sl-color-emerald-300: hsl(161.3 77.3% 27.6%);--sl-color-emerald-400: hsl(159.6 77.1% 34.3%);--sl-color-emerald-500: hsl(159.1 73.5% 37.9%);--sl-color-emerald-600: hsl(157.8 66.8% 48.9%);--sl-color-emerald-700: hsl(156.2 76.1% 63.8%);--sl-color-emerald-800: hsl(152.4 84.4% 77.4%);--sl-color-emerald-900: hsl(149.3 100% 87%);--sl-color-emerald-950: hsl(158.6 100% 94.8%);--sl-color-teal-50: hsl(176.5 51.5% 15.4%);--sl-color-teal-100: hsl(175.9 54.7% 22.3%);--sl-color-teal-200: hsl(175.9 60.7% 23.9%);--sl-color-teal-300: hsl(174.5 67.3% 28.8%);--sl-color-teal-400: hsl(174.4 71.9% 34.9%);--sl-color-teal-500: hsl(173.1 71% 38.3%);--sl-color-teal-600: hsl(172.3 68.2% 48.1%);--sl-color-teal-700: hsl(170.5 81.3% 61.5%);--sl-color-teal-800: hsl(168.4 92.1% 75.2%);--sl-color-teal-900: hsl(168.3 100% 86%);--sl-color-teal-950: hsl(180 100% 95.5%);--sl-color-cyan-50: hsl(197.1 53.8% 20.3%);--sl-color-cyan-100: hsl(196.8 57.3% 27.2%);--sl-color-cyan-200: hsl(195.3 62.7% 29.4%);--sl-color-cyan-300: hsl(193.5 71.3% 34.1%);--sl-color-cyan-400: hsl(192.5 76.8% 40.6%);--sl-color-cyan-500: hsl(189.4 78.6% 42.6%);--sl-color-cyan-600: hsl(188.2 89.1% 51.7%);--sl-color-cyan-700: hsl(187 98.6% 66.2%);--sl-color-cyan-800: hsl(184.9 100% 78.3%);--sl-color-cyan-900: hsl(180 100% 86.6%);--sl-color-cyan-950: hsl(180 100% 94.8%);--sl-color-sky-50: hsl(203 63.8% 20.9%);--sl-color-sky-100: hsl(203.4 70.4% 28%);--sl-color-sky-200: hsl(202.7 75.8% 30.8%);--sl-color-sky-300: hsl(203.1 80.4% 36.1%);--sl-color-sky-400: hsl(202.1 80.5% 44.3%);--sl-color-sky-500: hsl(199.7 85.9% 47.7%);--sl-color-sky-600: hsl(198.7 97.9% 57.2%);--sl-color-sky-700: hsl(198.7 100% 70.5%);--sl-color-sky-800: hsl(198.8 100% 82.5%);--sl-color-sky-900: hsl(198.5 100% 89.9%);--sl-color-sky-950: hsl(186 100% 95.5%);--sl-color-blue-50: hsl(227.1 49.5% 22.7%);--sl-color-blue-100: hsl(225.8 58.9% 36.8%);--sl-color-blue-200: hsl(227.7 64.4% 42.9%);--sl-color-blue-300: hsl(226.1 72.7% 51.2%);--sl-color-blue-400: hsl(222.6 86.5% 56.3%);--sl-color-blue-500: hsl(217.8 95.8% 57.4%);--sl-color-blue-600: hsl(213.3 100% 65%);--sl-color-blue-700: hsl(210.9 100% 74.8%);--sl-color-blue-800: hsl(211.5 100% 83.4%);--sl-color-blue-900: hsl(211 100% 88.9%);--sl-color-blue-950: hsl(201.8 100% 95.3%);--sl-color-indigo-50: hsl(243.5 40.8% 27%);--sl-color-indigo-100: hsl(242.9 45.7% 37.6%);--sl-color-indigo-200: hsl(244.7 52.7% 43.1%);--sl-color-indigo-300: hsl(245.3 60.5% 52.4%);--sl-color-indigo-400: hsl(244.1 79.2% 60.4%);--sl-color-indigo-500: hsl(239.6 88.7% 63.8%);--sl-color-indigo-600: hsl(234.5 96.7% 70.9%);--sl-color-indigo-700: hsl(229.4 100% 78.3%);--sl-color-indigo-800: hsl(227.1 100% 85%);--sl-color-indigo-900: hsl(223.8 100% 89.9%);--sl-color-indigo-950: hsl(220 100% 95.1%);--sl-color-violet-50: hsl(265.1 57.3% 25.4%);--sl-color-violet-100: hsl(263.5 63.8% 39.4%);--sl-color-violet-200: hsl(263.4 66.2% 44.1%);--sl-color-violet-300: hsl(263.7 72.8% 52.4%);--sl-color-violet-400: hsl(262.5 87.3% 59.8%);--sl-color-violet-500: hsl(258.3 95.1% 63.2%);--sl-color-violet-600: hsl(255.1 100% 67.2%);--sl-color-violet-700: hsl(253 100% 81.5%);--sl-color-violet-800: hsl(251.7 100% 87.9%);--sl-color-violet-900: hsl(254.1 100% 91.7%);--sl-color-violet-950: hsl(257.1 100% 96.1%);--sl-color-purple-50: hsl(276 54.3% 20.5%);--sl-color-purple-100: hsl(273.6 61.8% 35.4%);--sl-color-purple-200: hsl(272.9 64% 41.4%);--sl-color-purple-300: hsl(271.9 68.1% 49.2%);--sl-color-purple-400: hsl(271.5 85.1% 57.8%);--sl-color-purple-500: hsl(270.7 96.4% 62.1%);--sl-color-purple-600: hsl(270.5 100% 71.9%);--sl-color-purple-700: hsl(270.9 100% 81.3%);--sl-color-purple-800: hsl(272.4 100% 87.7%);--sl-color-purple-900: hsl(276.7 100% 91.5%);--sl-color-purple-950: hsl(300 100% 96.5%);--sl-color-fuchsia-50: hsl(297.1 51.2% 18.6%);--sl-color-fuchsia-100: hsl(296.7 59.5% 31.5%);--sl-color-fuchsia-200: hsl(295.4 65.4% 35.1%);--sl-color-fuchsia-300: hsl(294.6 67.4% 42.2%);--sl-color-fuchsia-400: hsl(293.3 68.7% 51.2%);--sl-color-fuchsia-500: hsl(292.1 88.4% 57.7%);--sl-color-fuchsia-600: hsl(292 98.5% 59.5%);--sl-color-fuchsia-700: hsl(292.4 100% 79.5%);--sl-color-fuchsia-800: hsl(292.9 100% 86.8%);--sl-color-fuchsia-900: hsl(300 100% 91.5%);--sl-color-fuchsia-950: hsl(300 100% 96.3%);--sl-color-pink-50: hsl(336.2 59.6% 20%);--sl-color-pink-100: hsl(336.8 63.9% 34%);--sl-color-pink-200: hsl(336.8 68.7% 37.6%);--sl-color-pink-300: hsl(336.1 71.8% 44.5%);--sl-color-pink-400: hsl(333.9 74.9% 53.1%);--sl-color-pink-500: hsl(330.7 86.3% 57.7%);--sl-color-pink-600: hsl(328.6 91.5% 67.2%);--sl-color-pink-700: hsl(327.4 97.6% 78.7%);--sl-color-pink-800: hsl(325.1 100% 86.6%);--sl-color-pink-900: hsl(322.1 100% 91.3%);--sl-color-pink-950: hsl(315 100% 95.9%);--sl-color-rose-50: hsl(342.3 62.9% 21.5%);--sl-color-rose-100: hsl(342.8 68.9% 34.2%);--sl-color-rose-200: hsl(344.8 72.6% 37.3%);--sl-color-rose-300: hsl(346.9 75.8% 43.7%);--sl-color-rose-400: hsl(348.2 80.1% 52.7%);--sl-color-rose-500: hsl(350.4 94.8% 57.5%);--sl-color-rose-600: hsl(351.2 100% 58.1%);--sl-color-rose-700: hsl(352.3 100% 78.1%);--sl-color-rose-800: hsl(352 100% 86.2%);--sl-color-rose-900: hsl(354.5 100% 90.7%);--sl-color-rose-950: hsl(353.3 100% 95.7%);--sl-color-primary-50: var(--sl-color-sky-50);--sl-color-primary-100: var(--sl-color-sky-100);--sl-color-primary-200: var(--sl-color-sky-200);--sl-color-primary-300: var(--sl-color-sky-300);--sl-color-primary-400: var(--sl-color-sky-400);--sl-color-primary-500: var(--sl-color-sky-500);--sl-color-primary-600: var(--sl-color-sky-600);--sl-color-primary-700: var(--sl-color-sky-700);--sl-color-primary-800: var(--sl-color-sky-800);--sl-color-primary-900: var(--sl-color-sky-900);--sl-color-primary-950: var(--sl-color-sky-950);--sl-color-success-50: var(--sl-color-green-50);--sl-color-success-100: var(--sl-color-green-100);--sl-color-success-200: var(--sl-color-green-200);--sl-color-success-300: var(--sl-color-green-300);--sl-color-success-400: var(--sl-color-green-400);--sl-color-success-500: var(--sl-color-green-500);--sl-color-success-600: var(--sl-color-green-600);--sl-color-success-700: var(--sl-color-green-700);--sl-color-success-800: var(--sl-color-green-800);--sl-color-success-900: var(--sl-color-green-900);--sl-color-success-950: var(--sl-color-green-950);--sl-color-warning-50: var(--sl-color-amber-50);--sl-color-warning-100: var(--sl-color-amber-100);--sl-color-warning-200: var(--sl-color-amber-200);--sl-color-warning-300: var(--sl-color-amber-300);--sl-color-warning-400: var(--sl-color-amber-400);--sl-color-warning-500: var(--sl-color-amber-500);--sl-color-warning-600: var(--sl-color-amber-600);--sl-color-warning-700: var(--sl-color-amber-700);--sl-color-warning-800: var(--sl-color-amber-800);--sl-color-warning-900: var(--sl-color-amber-900);--sl-color-warning-950: var(--sl-color-amber-950);--sl-color-danger-50: var(--sl-color-red-50);--sl-color-danger-100: var(--sl-color-red-100);--sl-color-danger-200: var(--sl-color-red-200);--sl-color-danger-300: var(--sl-color-red-300);--sl-color-danger-400: var(--sl-color-red-400);--sl-color-danger-500: var(--sl-color-red-500);--sl-color-danger-600: var(--sl-color-red-600);--sl-color-danger-700: var(--sl-color-red-700);--sl-color-danger-800: var(--sl-color-red-800);--sl-color-danger-900: var(--sl-color-red-900);--sl-color-danger-950: var(--sl-color-red-950);--sl-color-neutral-50: var(--sl-color-gray-50);--sl-color-neutral-100: var(--sl-color-gray-100);--sl-color-neutral-200: var(--sl-color-gray-200);--sl-color-neutral-300: var(--sl-color-gray-300);--sl-color-neutral-400: var(--sl-color-gray-400);--sl-color-neutral-500: var(--sl-color-gray-500);--sl-color-neutral-600: var(--sl-color-gray-600);--sl-color-neutral-700: var(--sl-color-gray-700);--sl-color-neutral-800: var(--sl-color-gray-800);--sl-color-neutral-900: var(--sl-color-gray-900);--sl-color-neutral-950: var(--sl-color-gray-950);--sl-color-neutral-0: hsl(240, 5.9%, 11%);--sl-color-neutral-1000: hsl(0, 0%, 100%);--sl-border-radius-small: .1875rem;--sl-border-radius-medium: .25rem;--sl-border-radius-large: .5rem;--sl-border-radius-x-large: 1rem;--sl-border-radius-circle: 50%;--sl-border-radius-pill: 9999px;--sl-shadow-x-small: 0 1px 2px rgb(0 0 0 / 18%);--sl-shadow-small: 0 1px 2px rgb(0 0 0 / 24%);--sl-shadow-medium: 0 2px 4px rgb(0 0 0 / 24%);--sl-shadow-large: 0 2px 8px rgb(0 0 0 / 24%);--sl-shadow-x-large: 0 4px 16px rgb(0 0 0 / 24%);--sl-spacing-3x-small: .125rem;--sl-spacing-2x-small: .25rem;--sl-spacing-x-small: .5rem;--sl-spacing-small: .75rem;--sl-spacing-medium: 1rem;--sl-spacing-large: 1.25rem;--sl-spacing-x-large: 1.75rem;--sl-spacing-2x-large: 2.25rem;--sl-spacing-3x-large: 3rem;--sl-spacing-4x-large: 4.5rem;--sl-transition-x-slow: 1s;--sl-transition-slow: .5s;--sl-transition-medium: .25s;--sl-transition-fast: .15s;--sl-transition-x-fast: 50ms;--sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;--sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";--sl-font-serif: Georgia, "Times New Roman", serif;--sl-font-size-2x-small: .625rem;--sl-font-size-x-small: .75rem;--sl-font-size-small: .875rem;--sl-font-size-medium: 1rem;--sl-font-size-large: 1.25rem;--sl-font-size-x-large: 1.5rem;--sl-font-size-2x-large: 2.25rem;--sl-font-size-3x-large: 3rem;--sl-font-size-4x-large: 4.5rem;--sl-font-weight-light: 300;--sl-font-weight-normal: 400;--sl-font-weight-semibold: 500;--sl-font-weight-bold: 700;--sl-letter-spacing-denser: -.03em;--sl-letter-spacing-dense: -.015em;--sl-letter-spacing-normal: normal;--sl-letter-spacing-loose: .075em;--sl-letter-spacing-looser: .15em;--sl-line-height-denser: 1;--sl-line-height-dense: 1.4;--sl-line-height-normal: 1.8;--sl-line-height-loose: 2.2;--sl-line-height-looser: 2.6;--sl-focus-ring-color: var(--sl-color-primary-700);--sl-focus-ring-style: solid;--sl-focus-ring-width: 3px;--sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-focus-ring-color);--sl-focus-ring-offset: 1px;--sl-button-font-size-small: var(--sl-font-size-x-small);--sl-button-font-size-medium: var(--sl-font-size-small);--sl-button-font-size-large: var(--sl-font-size-medium);--sl-input-height-small: 1.875rem;--sl-input-height-medium: 2.5rem;--sl-input-height-large: 3.125rem;--sl-input-background-color: var(--sl-color-neutral-0);--sl-input-background-color-hover: var(--sl-input-background-color);--sl-input-background-color-focus: var(--sl-input-background-color);--sl-input-background-color-disabled: var(--sl-color-neutral-100);--sl-input-border-color: var(--sl-color-neutral-400);--sl-input-border-color-hover: var(--sl-color-neutral-500);--sl-input-border-color-focus: var(--sl-color-primary-600);--sl-input-border-color-disabled: var(--sl-color-neutral-400);--sl-input-border-width: 1px;--sl-input-required-content: "*";--sl-input-required-content-offset: -2px;--sl-input-required-content-color: var(--sl-input-label-color);--sl-input-border-radius-small: var(--sl-border-radius-medium);--sl-input-border-radius-medium: var(--sl-border-radius-medium);--sl-input-border-radius-large: var(--sl-border-radius-medium);--sl-input-font-family: var(--sl-font-sans);--sl-input-font-weight: var(--sl-font-weight-normal);--sl-input-font-size-small: var(--sl-font-size-small);--sl-input-font-size-medium: var(--sl-font-size-medium);--sl-input-font-size-large: var(--sl-font-size-large);--sl-input-letter-spacing: var(--sl-letter-spacing-normal);--sl-input-color: var(--sl-color-neutral-700);--sl-input-color-hover: var(--sl-color-neutral-700);--sl-input-color-focus: var(--sl-color-neutral-700);--sl-input-color-disabled: var(--sl-color-neutral-900);--sl-input-icon-color: var(--sl-color-neutral-500);--sl-input-icon-color-hover: var(--sl-color-neutral-600);--sl-input-icon-color-focus: var(--sl-color-neutral-600);--sl-input-placeholder-color: var(--sl-color-neutral-500);--sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);--sl-input-spacing-small: var(--sl-spacing-small);--sl-input-spacing-medium: var(--sl-spacing-medium);--sl-input-spacing-large: var(--sl-spacing-large);--sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);--sl-input-focus-ring-offset: 0;--sl-input-filled-background-color: var(--sl-color-neutral-100);--sl-input-filled-background-color-hover: var(--sl-color-neutral-100);--sl-input-filled-background-color-focus: var(--sl-color-neutral-100);--sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);--sl-input-filled-color: var(--sl-color-neutral-800);--sl-input-filled-color-hover: var(--sl-color-neutral-800);--sl-input-filled-color-focus: var(--sl-color-neutral-700);--sl-input-filled-color-disabled: var(--sl-color-neutral-800);--sl-input-label-font-size-small: var(--sl-font-size-small);--sl-input-label-font-size-medium: var(--sl-font-size-medium);--sl-input-label-font-size-large: var(--sl-font-size-large);--sl-input-label-color: inherit;--sl-input-help-text-font-size-small: var(--sl-font-size-x-small);--sl-input-help-text-font-size-medium: var(--sl-font-size-small);--sl-input-help-text-font-size-large: var(--sl-font-size-medium);--sl-input-help-text-color: var(--sl-color-neutral-600);--sl-toggle-size-small: .875rem;--sl-toggle-size-medium: 1.125rem;--sl-toggle-size-large: 1.375rem;--sl-overlay-background-color: hsl(0 0% 0% / 43%);--sl-panel-background-color: var(--sl-color-neutral-50);--sl-panel-border-color: var(--sl-color-neutral-200);--sl-panel-border-width: 1px;--sl-tooltip-border-radius: var(--sl-border-radius-medium);--sl-tooltip-background-color: var(--sl-color-neutral-800);--sl-tooltip-color: var(--sl-color-neutral-0);--sl-tooltip-font-family: var(--sl-font-sans);--sl-tooltip-font-weight: var(--sl-font-weight-normal);--sl-tooltip-font-size: var(--sl-font-size-small);--sl-tooltip-line-height: var(--sl-line-height-dense);--sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);--sl-tooltip-arrow-size: 6px;--sl-z-index-drawer: 700;--sl-z-index-dialog: 800;--sl-z-index-dropdown: 900;--sl-z-index-toast: 950;--sl-z-index-tooltip: 1000}@supports (scrollbar-gutter: stable){.sl-scroll-lock{scrollbar-gutter:var(--sl-scroll-lock-gutter)!important}.sl-scroll-lock body{overflow:hidden!important}}@supports not (scrollbar-gutter: stable){.sl-scroll-lock body{padding-right:var(--sl-scroll-lock-size)!important;overflow:hidden!important}}.sl-toast-stack{position:fixed;top:0;inset-inline-end:0;z-index:var(--sl-z-index-toast);width:28rem;max-width:100%;max-height:100%;overflow:auto}.sl-toast-stack sl-alert{margin:var(--sl-spacing-medium)}.sl-toast-stack sl-alert::part(base){box-shadow:var(--sl-shadow-large)}';
var vp = /* @__PURE__ */ ae("<style>"), Uoe = /* @__PURE__ */ ae("<slot>"), qoe = /* @__PURE__ */ ae("<photon-login>", !0, !1, !1), Boe = /* @__PURE__ */ ae('<div class="w-full flex justify-center"><sl-spinner>', !0, !1, !1);
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Hoe = (e) => {
  const t = Rn(), [r, n] = V(!1), [i, a] = V(!0);
  return fe(() => {
    t || console.error("[photon-auth-wrapper] No valid PhotonClient instance was provided. Please ensure you are wrapping the element in a photon-client element");
  }), fe(() => {
    if (t?.authentication.state.isLoading)
      a(!0);
    else {
      if (a(!1), !t?.authentication.state.isAuthenticated && e.autoLogin) {
        const o = {
          appState: {}
        };
        e.redirectPath && (o.appState.returnTo = e.redirectPath), t?.authentication.login(o);
      }
      n(t?.authentication.state.isAuthenticated || !1);
    }
  }), [(() => {
    var o = vp();
    return L(o, Gn), o;
  })(), (() => {
    var o = vp();
    return L(o, Ro), o;
  })(), (() => {
    var o = vp();
    return L(o, Mo), o;
  })(), g(H, {
    get when() {
      return t && r();
    },
    get children() {
      var o = Uoe();
      return o._$owner = Ve(), o;
    }
  }), g(H, {
    get when() {
      return t && !r() && !i() && !e.autoLogin;
    },
    get children() {
      var o = qoe();
      return o._$owner = Ve(), se(() => o.redirectPath = e.redirectPath), o;
    }
  }), g(H, {
    get when() {
      return t && i() && !e.hideLoader;
    },
    get children() {
      var o = Boe(), s = o.firstChild;
      return s.style.setProperty("font-size", "3rem"), s._$owner = Ve(), o;
    }
  })];
};
Dn("photon-auth-wrapper", {
  autoLogin: !1,
  hideLoader: !1,
  redirectPath: {
    attribute: "redirect-path",
    value: void 0,
    reflect: !1,
    notify: !1,
    parse: !1
  }
}, Hoe);
const Xm = /* @__PURE__ */ Symbol("store-raw"), Vl = /* @__PURE__ */ Symbol("store-node"), fa = /* @__PURE__ */ Symbol("store-has"), ux = /* @__PURE__ */ Symbol("store-self");
function hx(e) {
  let t = e[Qr];
  if (!t && (Object.defineProperty(e, Qr, {
    value: t = new Proxy(e, Koe)
  }), !Array.isArray(e))) {
    const r = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, a = r.length; i < a; i++) {
      const o = r[i];
      n[o].get && Object.defineProperty(e, o, {
        enumerable: n[o].enumerable,
        get: n[o].get.bind(t)
      });
    }
  }
  return t;
}
function Co(e) {
  let t;
  return e != null && typeof e == "object" && (e[Qr] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function cd(e, t = /* @__PURE__ */ new Set()) {
  let r, n, i, a;
  if (r = e != null && e[Xm]) return r;
  if (!Co(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      i = e[o], (n = cd(i, t)) !== i && (e[o] = n);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, d = o.length; l < d; l++)
      a = o[l], !s[a].get && (i = e[a], (n = cd(i, t)) !== i && (e[a] = n));
  }
  return e;
}
function wh(e, t) {
  let r = e[t];
  return r || Object.defineProperty(e, t, {
    value: r = /* @__PURE__ */ Object.create(null)
  }), r;
}
function Eu(e, t, r) {
  if (e[t]) return e[t];
  const [n, i] = V(r, {
    equals: !1,
    internal: !0
  });
  return n.$ = i, e[t] = n;
}
function Woe(e, t) {
  const r = Reflect.getOwnPropertyDescriptor(e, t);
  return !r || r.get || !r.configurable || t === Qr || t === Vl || (delete r.value, delete r.writable, r.get = () => e[Qr][t]), r;
}
function fx(e) {
  Ql() && Eu(wh(e, Vl), ux)();
}
function Qoe(e) {
  return fx(e), Reflect.ownKeys(e);
}
const Koe = {
  get(e, t, r) {
    if (t === Xm) return e;
    if (t === Qr) return r;
    if (t === Bc)
      return fx(e), r;
    const n = wh(e, Vl), i = n[t];
    let a = i ? i() : e[t];
    if (t === Vl || t === fa || t === "__proto__") return a;
    if (!i) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      Ql() && (typeof a != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (a = Eu(n, t, a)());
    }
    return Co(a) ? hx(a) : a;
  },
  has(e, t) {
    return t === Xm || t === Qr || t === Bc || t === Vl || t === fa || t === "__proto__" ? !0 : (Ql() && Eu(wh(e, fa), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: Qoe,
  getOwnPropertyDescriptor: Woe
};
function ti(e, t, r, n = !1) {
  if (!n && e[t] === r) return;
  const i = e[t], a = e.length;
  r === void 0 ? (delete e[t], e[fa] && e[fa][t] && i !== void 0 && e[fa][t].$()) : (e[t] = r, e[fa] && e[fa][t] && i === void 0 && e[fa][t].$());
  let o = wh(e, Vl), s;
  if ((s = Eu(o, t, i)) && s.$(() => r), Array.isArray(e) && e.length !== a) {
    for (let l = e.length; l < a; l++) (s = o[l]) && s.$();
    (s = Eu(o, "length", a)) && s.$(e.length);
  }
  (s = o[ux]) && s.$();
}
function px(e, t) {
  const r = Object.keys(t);
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    ti(e, i, t[i]);
  }
}
function Goe(e, t) {
  if (typeof t == "function" && (t = t(e)), t = cd(t), Array.isArray(t)) {
    if (e === t) return;
    let r = 0, n = t.length;
    for (; r < n; r++) {
      const i = t[r];
      e[r] !== i && ti(e, r, i);
    }
    ti(e, "length", n);
  } else px(e, t);
}
function Sc(e, t, r = []) {
  let n, i = e;
  if (t.length > 1) {
    n = t.shift();
    const o = typeof n, s = Array.isArray(e);
    if (Array.isArray(n)) {
      for (let l = 0; l < n.length; l++)
        Sc(e, [n[l]].concat(t), r);
      return;
    } else if (s && o === "function") {
      for (let l = 0; l < e.length; l++)
        n(e[l], l) && Sc(e, [l].concat(t), r);
      return;
    } else if (s && o === "object") {
      const {
        from: l = 0,
        to: d = e.length - 1,
        by: c = 1
      } = n;
      for (let u = l; u <= d; u += c)
        Sc(e, [u].concat(t), r);
      return;
    } else if (t.length > 1) {
      Sc(e[n], t, [n].concat(r));
      return;
    }
    i = e[n], r = [n].concat(r);
  }
  let a = t[0];
  typeof a == "function" && (a = a(i, r), a === i) || n === void 0 && a == null || (a = cd(a), n === void 0 || Co(i) && Co(a) && !Array.isArray(a) ? px(i, a) : ti(e, n, a));
}
function _f(...[e, t]) {
  const r = cd(e || {}), n = Array.isArray(r), i = hx(r);
  function a(...o) {
    A1(() => {
      n && o.length === 1 ? Goe(r, o[0]) : Sc(r, o);
    });
  }
  return [i, a];
}
const eg = /* @__PURE__ */ Symbol("store-root");
function fl(e, t, r, n, i) {
  const a = t[r];
  if (e === a) return;
  const o = Array.isArray(e);
  if (r !== eg && (!Co(e) || !Co(a) || o !== Array.isArray(a) || i && e[i] !== a[i])) {
    ti(t, r, e);
    return;
  }
  if (o) {
    if (e.length && a.length && (!n || i && e[0] && e[0][i] != null)) {
      let d, c, u, h, f, p, m, y;
      for (u = 0, h = Math.min(a.length, e.length); u < h && (a[u] === e[u] || i && a[u] && e[u] && a[u][i] && a[u][i] === e[u][i]); u++)
        fl(e[u], a, u, n, i);
      const v = new Array(e.length), b = /* @__PURE__ */ new Map();
      for (h = a.length - 1, f = e.length - 1; h >= u && f >= u && (a[h] === e[f] || i && a[h] && e[f] && a[h][i] && a[h][i] === e[f][i]); h--, f--)
        v[f] = a[h];
      if (u > f || u > h) {
        for (c = u; c <= f; c++) ti(a, c, e[c]);
        for (; c < e.length; c++)
          ti(a, c, v[c]), fl(e[c], a, c, n, i);
        a.length > e.length && ti(a, "length", e.length);
        return;
      }
      for (m = new Array(f + 1), c = f; c >= u; c--)
        p = e[c], y = i && p ? p[i] : p, d = b.get(y), m[c] = d === void 0 ? -1 : d, b.set(y, c);
      for (d = u; d <= h; d++)
        p = a[d], y = i && p ? p[i] : p, c = b.get(y), c !== void 0 && c !== -1 && (v[c] = a[d], c = m[c], b.set(y, c));
      for (c = u; c < e.length; c++)
        c in v ? (ti(a, c, v[c]), fl(e[c], a, c, n, i)) : ti(a, c, e[c]);
    } else
      for (let d = 0, c = e.length; d < c; d++)
        fl(e[d], a, d, n, i);
    a.length > e.length && ti(a, "length", e.length);
    return;
  }
  const s = Object.keys(e);
  for (let d = 0, c = s.length; d < c; d++)
    fl(e[s[d]], a, s[d], n, i);
  const l = Object.keys(a);
  for (let d = 0, c = l.length; d < c; d++)
    e[l[d]] === void 0 && ti(a, l[d], void 0);
}
function Zoe(e, t = {}) {
  const {
    merge: r,
    key: n = "id"
  } = t, i = cd(e);
  return (a) => {
    if (!Co(a) || !Co(i)) return i;
    const o = fl(i, {
      [eg]: a
    }, eg, r, n);
    return o === void 0 ? a : o;
  };
}
class Yoe extends TypeError {
  constructor(t, r) {
    let n;
    const { message: i, explanation: a, ...o } = t, { path: s } = t, l = s.length === 0 ? i : `At path: ${s.join(".")} -- ${i}`;
    super(a ?? l), a != null && (this.cause = l), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => n ?? (n = [t, ...r()]);
  }
}
function Joe(e) {
  return Ul(e) && typeof e[Symbol.iterator] == "function";
}
function Ul(e) {
  return typeof e == "object" && e != null;
}
function Ts(e) {
  return typeof e == "symbol" ? e.toString() : typeof e == "string" ? JSON.stringify(e) : `${e}`;
}
function Xoe(e) {
  const { done: t, value: r } = e.next();
  return t ? void 0 : r;
}
function ese(e, t, r, n) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
  const { path: i, branch: a } = t, { type: o } = r, { refinement: s, message: l = `Expected a value of type \`${o}\`${s ? ` with refinement \`${s}\`` : ""}, but received: \`${Ts(n)}\`` } = e;
  return {
    value: n,
    type: o,
    refinement: s,
    key: i[i.length - 1],
    path: i,
    branch: a,
    ...e,
    message: l
  };
}
function* tg(e, t, r, n) {
  Joe(e) || (e = [e]);
  for (const i of e) {
    const a = ese(i, t, r, n);
    a && (yield a);
  }
}
function* Q3(e, t, r = {}) {
  const { path: n = [], branch: i = [e], coerce: a = !1, mask: o = !1 } = r, s = { path: n, branch: i };
  if (a && (e = t.coercer(e, s), o && t.type !== "type" && Ul(t.schema) && Ul(e) && !Array.isArray(e)))
    for (const d in e)
      t.schema[d] === void 0 && delete e[d];
  let l = "valid";
  for (const d of t.validator(e, s))
    d.explanation = r.message, l = "not_valid", yield [d, void 0];
  for (let [d, c, u] of t.entries(e, s)) {
    const h = Q3(c, u, {
      path: d === void 0 ? n : [...n, d],
      branch: d === void 0 ? i : [...i, c],
      coerce: a,
      mask: o,
      message: r.message
    });
    for (const f of h)
      f[0] ? (l = f[0].refinement != null ? "not_refined" : "not_valid", yield [f[0], void 0]) : a && (c = f[1], d === void 0 ? e = c : e instanceof Map ? e.set(d, c) : e instanceof Set ? e.add(c) : Ul(e) && (c !== void 0 || d in e) && (e[d] = c));
  }
  if (l !== "not_valid")
    for (const d of t.refiner(e, s))
      d.explanation = r.message, l = "not_refined", yield [d, void 0];
  l === "valid" && (yield [void 0, e]);
}
class qs {
  constructor(t) {
    const { type: r, schema: n, validator: i, refiner: a, coercer: o = (l) => l, entries: s = function* () {
    } } = t;
    this.type = r, this.schema = n, this.entries = s, this.coercer = o, i ? this.validator = (l, d) => {
      const c = i(l, d);
      return tg(c, d, this, l);
    } : this.validator = () => [], a ? this.refiner = (l, d) => {
      const c = a(l, d);
      return tg(c, d, this, l);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t, r) {
    return mx(t, this, r);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t, r) {
    return tse(t, this, r);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return gx(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t, r) {
    return rse(t, this, r);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, r = {}) {
    return i0(t, this, r);
  }
}
function mx(e, t, r) {
  const n = i0(e, t, { message: r });
  if (n[0])
    throw n[0];
}
function tse(e, t, r) {
  const n = i0(e, t, { coerce: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function rse(e, t, r) {
  const n = i0(e, t, { coerce: !0, mask: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function gx(e, t) {
  return !i0(e, t)[0];
}
function i0(e, t, r = {}) {
  const n = Q3(e, t, r), i = Xoe(n);
  return i[0] ? [new Yoe(i[0], function* () {
    for (const o of n)
      o[0] && (yield o[0]);
  }), void 0] : [void 0, i[1]];
}
function Nd(e, t) {
  return new qs({ type: e, schema: null, validator: t });
}
function xf() {
  return Nd("any", () => !0);
}
function nse(e) {
  const t = {}, r = e.map((n) => Ts(n)).join();
  for (const n of e)
    t[n] = n;
  return new qs({
    type: "enums",
    schema: t,
    validator(n) {
      return e.includes(n) || `Expected one of \`${r}\`, but received: ${Ts(n)}`;
    }
  });
}
function ise(e) {
  return new qs({
    type: "intersection",
    schema: null,
    *entries(t, r) {
      for (const n of e)
        yield* n.entries(t, r);
    },
    *validator(t, r) {
      for (const n of e)
        yield* n.validator(t, r);
    },
    *refiner(t, r) {
      for (const n of e)
        yield* n.refiner(t, r);
    }
  });
}
function K0() {
  return Nd("number", (e) => typeof e == "number" && !isNaN(e) || `Expected a number, but received: ${Ts(e)}`);
}
function ase(e) {
  return new qs({
    ...e,
    validator: (t, r) => t === void 0 || e.validator(t, r),
    refiner: (t, r) => t === void 0 || e.refiner(t, r)
  });
}
function K3(e, t) {
  return new qs({
    type: "record",
    schema: null,
    *entries(r) {
      if (Ul(r))
        for (const n in r) {
          const i = r[n];
          yield [n, n, e], yield [n, i, t];
        }
    },
    validator(r) {
      return Ul(r) || `Expected an object, but received: ${Ts(r)}`;
    }
  });
}
function jn() {
  return Nd("string", (e) => typeof e == "string" || `Expected a string, but received: ${Ts(e)}`);
}
function ose(e) {
  const t = e.map((r) => r.type).join(" | ");
  return new qs({
    type: "union",
    schema: null,
    coercer(r) {
      for (const n of e) {
        const [i, a] = n.validate(r, { coerce: !0 });
        if (!i)
          return a;
      }
      return r;
    },
    validator(r, n) {
      const i = [];
      for (const a of e) {
        const [...o] = Q3(r, a, n), [s] = o;
        if (s[0])
          for (const [l] of o)
            l && i.push(l);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${t}\`, but received: ${Ts(r)}`,
        ...i
      ];
    }
  });
}
function sse(e) {
  return e instanceof Map || e instanceof Set ? e.size : e.length;
}
function lse(e, t, r = {}) {
  const { exclusive: n } = r;
  return Lo(e, "max", (i) => n ? i < t : i <= t || `Expected a ${e.type} less than ${n ? "" : "or equal to "}${t} but received \`${i}\``);
}
function yp(e, t, r = {}) {
  const { exclusive: n } = r;
  return Lo(e, "min", (i) => n ? i > t : i >= t || `Expected a ${e.type} greater than ${n ? "" : "or equal to "}${t} but received \`${i}\``);
}
function dse(e) {
  return Lo(e, "nonempty", (t) => sse(t) > 0 || `Expected a nonempty ${e.type} but received an empty one`);
}
function Xs(e, t, r = t) {
  const n = `Expected a ${e.type}`, i = t === r ? `of \`${t}\`` : `between \`${t}\` and \`${r}\``;
  return Lo(e, "size", (a) => {
    if (typeof a == "number" || a instanceof Date)
      return t <= a && a <= r || `${n} ${i} but received \`${a}\``;
    if (a instanceof Map || a instanceof Set) {
      const { size: o } = a;
      return t <= o && o <= r || `${n} with a size ${i} but received one with a size of \`${o}\``;
    } else {
      const { length: o } = a;
      return t <= o && o <= r || `${n} with a length ${i} but received one with a length of \`${o}\``;
    }
  });
}
function Lo(e, t, r) {
  return new qs({
    ...e,
    *refiner(n, i) {
      yield* e.refiner(n, i);
      const a = r(n, i), o = tg(a, i, e, n);
      for (const s of o)
        yield { ...s, refinement: t };
    }
  });
}
const vx = (e) => {
  const t = {};
  if (e) {
    const h = {};
    for (const f of Object.keys(e))
      h[f] = {
        value: e[f],
        error: void 0
      };
    e = h;
  }
  const [r, n] = _f(e || {}), i = ({ key: h, value: f }) => {
    n(h, {
      value: f,
      error: void 0
    });
  }, a = (h) => {
    let f = 0;
    for (const p in r)
      h.includes(p) && r[p]?.error && (f += 1);
    return f > 0;
  }, o = (h) => {
    let f = [];
    for (const p in r)
      h.includes(p) && r[p]?.error && (f = [...f, { key: p, error: r[p]?.error ?? "" }]);
    return f;
  }, s = (h) => {
    for (const f of h)
      n(f, void 0);
  };
  return {
    store: r,
    actions: {
      updateFormValue: i,
      clearKeys: s,
      registerValidator: ({ key: h, validator: f }) => {
        if (h in t) {
          t[h] = [...t[h], f];
          return;
        }
        t[h] = [f];
      },
      unRegisterValidator: (h) => {
        delete t[h];
      },
      validate: (h) => {
        Object.entries(r).filter(([f]) => h ? h.includes(f) : !0).forEach(([f, p]) => {
          t[f] && t[f].forEach((m) => {
            try {
              mx(p?.value, m);
            } catch (y) {
              for (const v of y.failures())
                n(f, {
                  value: p?.value,
                  error: v.message
                });
            }
          });
        });
      },
      hasErrors: a,
      getErrors: o,
      reset: () => {
        const h = Object.keys(r);
        s(h);
        const f = Object.keys(t);
        for (const p of f)
          delete t[p];
      }
    }
  };
};
var yx = (e) => {
  var t;
  const { activeElement: r } = document;
  r && e.contains(r) && ((t = document.activeElement) == null || t.blur());
}, cse = Ln`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`, use = {
  name: "default",
  resolver: (e) => Voe(`assets/icons/${e}.svg`)
}, hse = use, _7 = {
  caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
  check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
  "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
  "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
  "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
  copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
  eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
  "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
  eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
  "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
  indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
  "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
  "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
  "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
  radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
  "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
  "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
  "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
}, fse = {
  name: "system",
  resolver: (e) => e in _7 ? `data:image/svg+xml,${encodeURIComponent(_7[e])}` : ""
}, pse = fse, mse = [hse, pse], rg = [];
function gse(e) {
  rg.push(e);
}
function vse(e) {
  rg = rg.filter((t) => t !== e);
}
function x7(e) {
  return mse.find((t) => t.name === e);
}
var yse = Ln`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;
function on(e, t) {
  const r = Us({
    waitUntilFirstUpdate: !1
  }, t);
  return (n, i) => {
    const { update: a } = n, o = Array.isArray(e) ? e : [e];
    n.update = function(s) {
      o.forEach((l) => {
        const d = l;
        if (s.has(d)) {
          const c = s.get(d), u = this[d];
          c !== u && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[i](c, u);
        }
      }), a.call(this, s);
    };
  };
}
const bse = (e, t) => e?._$litType$ !== void 0, bx = (e) => e.strings === void 0, wse = {}, $se = (e, t = wse) => e._$AH = t;
var sc = /* @__PURE__ */ Symbol(), G0 = /* @__PURE__ */ Symbol(), bp, wp = /* @__PURE__ */ new Map(), si = class extends fn {
  constructor() {
    super(...arguments), this.initialRender = !1, this.svg = null, this.label = "", this.library = "default";
  }
  /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */
  async resolveIcon(e, t) {
    var r;
    let n;
    if (t?.spriteSheet)
      return this.svg = hr`<svg part="svg">
        <use part="use" href="${e}"></use>
      </svg>`, this.svg;
    try {
      if (n = await fetch(e, { mode: "cors" }), !n.ok) return n.status === 410 ? sc : G0;
    } catch {
      return G0;
    }
    try {
      const i = document.createElement("div");
      i.innerHTML = await n.text();
      const a = i.firstElementChild;
      if (((r = a?.tagName) == null ? void 0 : r.toLowerCase()) !== "svg") return sc;
      bp || (bp = new DOMParser());
      const s = bp.parseFromString(a.outerHTML, "text/html").body.querySelector("svg");
      return s ? (s.part.add("svg"), document.adoptNode(s)) : sc;
    } catch {
      return sc;
    }
  }
  connectedCallback() {
    super.connectedCallback(), gse(this);
  }
  firstUpdated() {
    this.initialRender = !0, this.setIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), vse(this);
  }
  getIconSource() {
    const e = x7(this.library);
    return this.name && e ? {
      url: e.resolver(this.name),
      fromLibrary: !0
    } : {
      url: this.src,
      fromLibrary: !1
    };
  }
  handleLabelChange() {
    typeof this.label == "string" && this.label.length > 0 ? (this.setAttribute("role", "img"), this.setAttribute("aria-label", this.label), this.removeAttribute("aria-hidden")) : (this.removeAttribute("role"), this.removeAttribute("aria-label"), this.setAttribute("aria-hidden", "true"));
  }
  async setIcon() {
    var e;
    const { url: t, fromLibrary: r } = this.getIconSource(), n = r ? x7(this.library) : void 0;
    if (!t) {
      this.svg = null;
      return;
    }
    let i = wp.get(t);
    if (i || (i = this.resolveIcon(t, n), wp.set(t, i)), !this.initialRender)
      return;
    const a = await i;
    if (a === G0 && wp.delete(t), t === this.getIconSource().url) {
      if (bse(a)) {
        if (this.svg = a, n) {
          await this.updateComplete;
          const o = this.shadowRoot.querySelector("[part='svg']");
          typeof n.mutator == "function" && o && n.mutator(o);
        }
        return;
      }
      switch (a) {
        case G0:
        case sc:
          this.svg = null, this.emit("sl-error");
          break;
        default:
          this.svg = a.cloneNode(!0), (e = n?.mutator) == null || e.call(n, this.svg), this.emit("sl-load");
      }
    }
  }
  render() {
    return this.svg;
  }
};
si.styles = [oi, yse];
q([
  n0()
], si.prototype, "svg", 2);
q([
  de({ reflect: !0 })
], si.prototype, "name", 2);
q([
  de()
], si.prototype, "src", 2);
q([
  de()
], si.prototype, "label", 2);
q([
  de({ reflect: !0 })
], si.prototype, "library", 2);
q([
  on("label")
], si.prototype, "handleLabelChange", 1);
q([
  on(["name", "src", "library"])
], si.prototype, "setIcon", 1);
const to = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4 }, G3 = (e) => (...t) => ({ _$litDirective$: e, values: t });
let Z3 = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, r, n) {
    this._$Ct = t, this._$AM = r, this._$Ci = n;
  }
  _$AS(t, r) {
    return this.update(t, r);
  }
  update(t, r) {
    return this.render(...r);
  }
};
const Wn = G3(class extends Z3 {
  constructor(e) {
    if (super(e), e.type !== to.ATTRIBUTE || e.name !== "class" || e.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
  }
  update(e, [t]) {
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((n) => n !== "")));
      for (const n in t) t[n] && !this.nt?.has(n) && this.st.add(n);
      return this.render(t);
    }
    const r = e.element.classList;
    for (const n of this.st) n in t || (r.remove(n), this.st.delete(n));
    for (const n in t) {
      const i = !!t[n];
      i === this.st.has(n) || this.nt?.has(n) || (i ? (r.add(n), this.st.add(n)) : (r.remove(n), this.st.delete(n)));
    }
    return _i;
  }
});
const wx = /* @__PURE__ */ Symbol.for(""), kse = (e) => {
  if (e?.r === wx) return e?._$litStatic$;
}, S7 = (e, ...t) => ({ _$litStatic$: t.reduce((r, n, i) => r + ((a) => {
  if (a._$litStatic$ !== void 0) return a._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${a}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(n) + e[i + 1], e[0]), r: wx }), C7 = /* @__PURE__ */ new Map(), _se = (e) => (t, ...r) => {
  const n = r.length;
  let i, a;
  const o = [], s = [];
  let l, d = 0, c = !1;
  for (; d < n; ) {
    for (l = t[d]; d < n && (a = r[d], (i = kse(a)) !== void 0); ) l += i + t[++d], c = !0;
    d !== n && s.push(a), o.push(l), d++;
  }
  if (d === n && o.push(t[n]), c) {
    const u = o.join("$$lit$$");
    (t = C7.get(u)) === void 0 && (o.raw = o, C7.set(u, t = o)), r = s;
  }
  return e(t, ...r);
}, xse = _se(hr);
const Kt = (e) => e ?? gr;
var _n = class extends fn {
  constructor() {
    super(...arguments), this.hasFocus = !1, this.label = "", this.disabled = !1;
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleClick(e) {
    this.disabled && (e.preventDefault(), e.stopPropagation());
  }
  /** Simulates a click on the icon button. */
  click() {
    this.button.click();
  }
  /** Sets focus on the icon button. */
  focus(e) {
    this.button.focus(e);
  }
  /** Removes focus from the icon button. */
  blur() {
    this.button.blur();
  }
  render() {
    const e = !!this.href, t = e ? S7`a` : S7`button`;
    return xse`
      <${t}
        part="base"
        class=${Wn({
      "icon-button": !0,
      "icon-button--disabled": !e && this.disabled,
      "icon-button--focused": this.hasFocus
    })}
        ?disabled=${Kt(e ? void 0 : this.disabled)}
        type=${Kt(e ? void 0 : "button")}
        href=${Kt(e ? this.href : void 0)}
        target=${Kt(e ? this.target : void 0)}
        download=${Kt(e ? this.download : void 0)}
        rel=${Kt(e && this.target ? "noreferrer noopener" : void 0)}
        role=${Kt(e ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${Kt(this.name)}
          library=${Kt(this.library)}
          src=${Kt(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${t}>
    `;
  }
};
_n.styles = [oi, cse];
_n.dependencies = { "sl-icon": si };
q([
  qr(".icon-button")
], _n.prototype, "button", 2);
q([
  n0()
], _n.prototype, "hasFocus", 2);
q([
  de()
], _n.prototype, "name", 2);
q([
  de()
], _n.prototype, "library", 2);
q([
  de()
], _n.prototype, "src", 2);
q([
  de()
], _n.prototype, "href", 2);
q([
  de()
], _n.prototype, "target", 2);
q([
  de()
], _n.prototype, "download", 2);
q([
  de()
], _n.prototype, "label", 2);
q([
  de({ type: Boolean, reflect: !0 })
], _n.prototype, "disabled", 2);
var $x = /* @__PURE__ */ new Map(), Sse = /* @__PURE__ */ new WeakMap();
function Cse(e) {
  return e ?? { keyframes: [], options: { duration: 0 } };
}
function E7(e, t) {
  return t.toLowerCase() === "rtl" ? {
    keyframes: e.rtlKeyframes || e.keyframes,
    options: e.options
  } : e;
}
function Mi(e, t) {
  $x.set(e, Cse(t));
}
function $i(e, t, r) {
  const n = Sse.get(e);
  if (n?.[t])
    return E7(n[t], r.dir);
  const i = $x.get(t);
  return i ? E7(i, r.dir) : {
    keyframes: [],
    options: { duration: 0 }
  };
}
function Eo(e, t) {
  return new Promise((r) => {
    function n(i) {
      i.target === e && (e.removeEventListener(t, n), r());
    }
    e.addEventListener(t, n);
  });
}
function ki(e, t, r) {
  return new Promise((n) => {
    if (r?.duration === 1 / 0)
      throw new Error("Promise-based animations must be finite.");
    const i = e.animate(t, kf(Us({}, r), {
      duration: Ese() ? 0 : r.duration
    }));
    i.addEventListener("cancel", n, { once: !0 }), i.addEventListener("finish", n, { once: !0 });
  });
}
function A7(e) {
  return e = e.toString().toLowerCase(), e.indexOf("ms") > -1 ? parseFloat(e) : e.indexOf("s") > -1 ? parseFloat(e) * 1e3 : parseFloat(e);
}
function Ese() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Wi(e) {
  return Promise.all(
    e.getAnimations().map((t) => new Promise((r) => {
      t.cancel(), requestAnimationFrame(r);
    }))
  );
}
var a0 = class {
  constructor(e, ...t) {
    this.slotNames = [], this.handleSlotChange = (r) => {
      const n = r.target;
      (this.slotNames.includes("[default]") && !n.name || n.name && this.slotNames.includes(n.name)) && this.host.requestUpdate();
    }, (this.host = e).addController(this), this.slotNames = t;
  }
  hasDefaultSlot() {
    return [...this.host.childNodes].some((e) => {
      if (e.nodeType === e.TEXT_NODE && e.textContent.trim() !== "")
        return !0;
      if (e.nodeType === e.ELEMENT_NODE) {
        const t = e;
        if (t.tagName.toLowerCase() === "sl-visually-hidden")
          return !1;
        if (!t.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(e) {
    return this.host.querySelector(`:scope > [slot="${e}"]`) !== null;
  }
  test(e) {
    return e === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(e);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
  }
};
function Ase(e) {
  if (!e)
    return "";
  const t = e.assignedNodes({ flatten: !0 });
  let r = "";
  return [...t].forEach((n) => {
    n.nodeType === Node.TEXT_NODE && (r += n.textContent);
  }), r;
}
var Tse = Ln`
  :host {
    display: contents;

    /* For better DX, we'll reset the margin here so the base part can inherit it */
    margin: 0;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-top-width: calc(var(--sl-panel-border-width) * 3);
    border-radius: var(--sl-border-radius-medium);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-normal);
    line-height: 1.6;
    color: var(--sl-color-neutral-700);
    margin: inherit;
    overflow: hidden;
  }

  .alert:not(.alert--has-icon) .alert__icon,
  .alert:not(.alert--closable) .alert__close-button {
    display: none;
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-large);
    padding-inline-start: var(--sl-spacing-large);
  }

  .alert--has-countdown {
    border-bottom: none;
  }

  .alert--primary {
    border-top-color: var(--sl-color-primary-600);
  }

  .alert--primary .alert__icon {
    color: var(--sl-color-primary-600);
  }

  .alert--success {
    border-top-color: var(--sl-color-success-600);
  }

  .alert--success .alert__icon {
    color: var(--sl-color-success-600);
  }

  .alert--neutral {
    border-top-color: var(--sl-color-neutral-600);
  }

  .alert--neutral .alert__icon {
    color: var(--sl-color-neutral-600);
  }

  .alert--warning {
    border-top-color: var(--sl-color-warning-600);
  }

  .alert--warning .alert__icon {
    color: var(--sl-color-warning-600);
  }

  .alert--danger {
    border-top-color: var(--sl-color-danger-600);
  }

  .alert--danger .alert__icon {
    color: var(--sl-color-danger-600);
  }

  .alert__message {
    flex: 1 1 auto;
    display: block;
    padding: var(--sl-spacing-large);
    overflow: hidden;
  }

  .alert__close-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
    margin-inline-end: var(--sl-spacing-medium);
    align-self: center;
  }

  .alert__countdown {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(var(--sl-panel-border-width) * 3);
    background-color: var(--sl-panel-border-color);
    display: flex;
  }

  .alert__countdown--ltr {
    justify-content: flex-end;
  }

  .alert__countdown .alert__countdown-elapsed {
    height: 100%;
    width: 0;
  }

  .alert--primary .alert__countdown-elapsed {
    background-color: var(--sl-color-primary-600);
  }

  .alert--success .alert__countdown-elapsed {
    background-color: var(--sl-color-success-600);
  }

  .alert--neutral .alert__countdown-elapsed {
    background-color: var(--sl-color-neutral-600);
  }

  .alert--warning .alert__countdown-elapsed {
    background-color: var(--sl-color-warning-600);
  }

  .alert--danger .alert__countdown-elapsed {
    background-color: var(--sl-color-danger-600);
  }

  .alert__timer {
    display: none;
  }
`, Zn = class rs extends fn {
  constructor() {
    super(...arguments), this.hasSlotController = new a0(this, "icon", "suffix"), this.localize = new Do(this), this.open = !1, this.closable = !1, this.variant = "primary", this.duration = 1 / 0, this.remainingTime = this.duration;
  }
  static get toastStack() {
    return this.currentToastStack || (this.currentToastStack = Object.assign(document.createElement("div"), {
      className: "sl-toast-stack"
    })), this.currentToastStack;
  }
  firstUpdated() {
    this.base.hidden = !this.open;
  }
  restartAutoHide() {
    this.handleCountdownChange(), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval), this.open && this.duration < 1 / 0 && (this.autoHideTimeout = window.setTimeout(() => this.hide(), this.duration), this.remainingTime = this.duration, this.remainingTimeInterval = window.setInterval(() => {
      this.remainingTime -= 100;
    }, 100));
  }
  pauseAutoHide() {
    var t;
    (t = this.countdownAnimation) == null || t.pause(), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval);
  }
  resumeAutoHide() {
    var t;
    this.duration < 1 / 0 && (this.autoHideTimeout = window.setTimeout(() => this.hide(), this.remainingTime), this.remainingTimeInterval = window.setInterval(() => {
      this.remainingTime -= 100;
    }, 100), (t = this.countdownAnimation) == null || t.play());
  }
  handleCountdownChange() {
    if (this.open && this.duration < 1 / 0 && this.countdown) {
      const { countdownElement: t } = this, r = "100%", n = "0";
      this.countdownAnimation = t.animate([{ width: r }, { width: n }], {
        duration: this.duration,
        easing: "linear"
      });
    }
  }
  handleCloseClick() {
    this.hide();
  }
  async handleOpenChange() {
    if (this.open) {
      this.emit("sl-show"), this.duration < 1 / 0 && this.restartAutoHide(), await Wi(this.base), this.base.hidden = !1;
      const { keyframes: t, options: r } = $i(this, "alert.show", { dir: this.localize.dir() });
      await ki(this.base, t, r), this.emit("sl-after-show");
    } else {
      yx(this), this.emit("sl-hide"), clearTimeout(this.autoHideTimeout), clearInterval(this.remainingTimeInterval), await Wi(this.base);
      const { keyframes: t, options: r } = $i(this, "alert.hide", { dir: this.localize.dir() });
      await ki(this.base, t, r), this.base.hidden = !0, this.emit("sl-after-hide");
    }
  }
  handleDurationChange() {
    this.restartAutoHide();
  }
  /** Shows the alert. */
  async show() {
    if (!this.open)
      return this.open = !0, Eo(this, "sl-after-show");
  }
  /** Hides the alert */
  async hide() {
    if (this.open)
      return this.open = !1, Eo(this, "sl-after-hide");
  }
  /**
   * Displays the alert as a toast notification. This will move the alert out of its position in the DOM and, when
   * dismissed, it will be removed from the DOM completely. By storing a reference to the alert, you can reuse it by
   * calling this method again. The returned promise will resolve after the alert is hidden.
   */
  async toast() {
    return new Promise((t) => {
      this.handleCountdownChange(), rs.toastStack.parentElement === null && document.body.append(rs.toastStack), rs.toastStack.appendChild(this), requestAnimationFrame(() => {
        this.clientWidth, this.show();
      }), this.addEventListener(
        "sl-after-hide",
        () => {
          rs.toastStack.removeChild(this), t(), rs.toastStack.querySelector("sl-alert") === null && rs.toastStack.remove();
        },
        { once: !0 }
      );
    });
  }
  render() {
    return hr`
      <div
        part="base"
        class=${Wn({
      alert: !0,
      "alert--open": this.open,
      "alert--closable": this.closable,
      "alert--has-countdown": !!this.countdown,
      "alert--has-icon": this.hasSlotController.test("icon"),
      "alert--primary": this.variant === "primary",
      "alert--success": this.variant === "success",
      "alert--neutral": this.variant === "neutral",
      "alert--warning": this.variant === "warning",
      "alert--danger": this.variant === "danger"
    })}
        role="alert"
        aria-hidden=${this.open ? "false" : "true"}
        @mouseenter=${this.pauseAutoHide}
        @mouseleave=${this.resumeAutoHide}
      >
        <div part="icon" class="alert__icon">
          <slot name="icon"></slot>
        </div>

        <div part="message" class="alert__message" aria-live="polite">
          <slot></slot>
        </div>

        ${this.closable ? hr`
              <sl-icon-button
                part="close-button"
                exportparts="base:close-button__base"
                class="alert__close-button"
                name="x-lg"
                library="system"
                label=${this.localize.term("close")}
                @click=${this.handleCloseClick}
              ></sl-icon-button>
            ` : ""}

        <div role="timer" class="alert__timer">${this.remainingTime}</div>

        ${this.countdown ? hr`
              <div
                class=${Wn({
      alert__countdown: !0,
      "alert__countdown--ltr": this.countdown === "ltr"
    })}
              >
                <div class="alert__countdown-elapsed"></div>
              </div>
            ` : ""}
      </div>
    `;
  }
};
Zn.styles = [oi, Tse];
Zn.dependencies = { "sl-icon-button": _n };
q([
  qr('[part~="base"]')
], Zn.prototype, "base", 2);
q([
  qr(".alert__countdown-elapsed")
], Zn.prototype, "countdownElement", 2);
q([
  de({ type: Boolean, reflect: !0 })
], Zn.prototype, "open", 2);
q([
  de({ type: Boolean, reflect: !0 })
], Zn.prototype, "closable", 2);
q([
  de({ reflect: !0 })
], Zn.prototype, "variant", 2);
q([
  de({ type: Number })
], Zn.prototype, "duration", 2);
q([
  de({ type: String, reflect: !0 })
], Zn.prototype, "countdown", 2);
q([
  n0()
], Zn.prototype, "remainingTime", 2);
q([
  on("open", { waitUntilFirstUpdate: !0 })
], Zn.prototype, "handleOpenChange", 1);
q([
  on("duration")
], Zn.prototype, "handleDurationChange", 1);
var Ose = Zn;
Mi("alert.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 250, easing: "ease" }
});
Mi("alert.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 250, easing: "ease" }
});
Ose.define("sl-alert");
var Ise = /* @__PURE__ */ ae('<div class="w-full flex justify-center">');
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
function $p(e) {
  return g(du, {
    type: "error",
    header: "Unauthorized",
    get message() {
      return e.message;
    }
  });
}
const kx = (e) => {
  const t = it({
    permissions: []
  }, e), r = Rn(), [n, i] = V(r?.authentication.state.isLoading || !1), [a, o] = V(r?.authentication.state.isAuthenticated || !1), [s, l] = V(r?.authentication.state.isInOrg || !1), [d, c] = V(Zm(t.permissions, r?.authentication.state.permissions || []));
  fe(() => {
    i(r?.authentication.state.isLoading || !1);
  }), fe(() => {
    o(r?.authentication.state.isAuthenticated || !1);
  }), fe(() => {
    l(r?.authentication.state.isInOrg || !1);
  }), fe(() => {
    c(Zm(t.permissions, r?.authentication.state.permissions || []));
  });
  const u = K(() => a() && s() && d());
  return g(H, {
    get when() {
      return r && !n();
    },
    get children() {
      return g(H, {
        get when() {
          return u();
        },
        get fallback() {
          return g(H, {
            get when() {
              return !a();
            },
            get fallback() {
              return g(H, {
                get when() {
                  return !s();
                },
                get fallback() {
                  return g($p, {
                    message: "You are not authorized to prescribe"
                  });
                },
                get children() {
                  return g($p, {
                    message: "You tried logging in with an account not associated with any organizations. Please check your email for an invite, or ask your administrator for assistance."
                  });
                }
              });
            },
            get children() {
              return g(H, {
                get when() {
                  return r?.autoLogin;
                },
                get fallback() {
                  return g($p, {
                    message: "You are not signed in"
                  });
                },
                get children() {
                  var h = Ise();
                  return L(h, g(aa, {
                    color: "green"
                  })), h;
                }
              });
            }
          });
        },
        get children() {
          return t.children;
        }
      });
    }
  });
};
function Ta(e) {
  "@babel/helpers - typeof";
  return Ta = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ta(e);
}
function Nn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function nr(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ur(e) {
  nr(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Ta(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Pse(e, t) {
  nr(2, arguments);
  var r = Ur(e).getTime(), n = Nn(t);
  return new Date(r + n);
}
var Nse = {};
function Dd() {
  return Nse;
}
function _x(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function T7(e) {
  nr(1, arguments);
  var t = Ur(e);
  return t.setHours(0, 0, 0, 0), t;
}
var Dse = 6e4, xx = 36e5, Mse = 1e3;
function Rse(e, t) {
  nr(2, arguments);
  var r = T7(e), n = T7(t);
  return r.getTime() === n.getTime();
}
function Lse(e) {
  return nr(1, arguments), e instanceof Date || Ta(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Fse(e) {
  if (nr(1, arguments), !Lse(e) && typeof e != "number")
    return !1;
  var t = Ur(e);
  return !isNaN(Number(t));
}
function jse(e, t) {
  return nr(2, arguments), Ur(e).getTime() - Ur(t).getTime();
}
var O7 = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, zse = "trunc";
function Vse(e) {
  return e ? O7[e] : O7[zse];
}
function Use(e, t, r) {
  nr(2, arguments);
  var n = jse(e, t) / xx;
  return Vse(void 0)(n);
}
function Sx(e, t) {
  nr(2, arguments);
  var r = Nn(t);
  return Pse(e, -r);
}
var qse = 864e5;
function Bse(e) {
  nr(1, arguments);
  var t = Ur(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / qse) + 1;
}
function ud(e) {
  nr(1, arguments);
  var t = 1, r = Ur(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function Cx(e) {
  nr(1, arguments);
  var t = Ur(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = ud(n), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = ud(a);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Hse(e) {
  nr(1, arguments);
  var t = Cx(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = ud(r);
  return n;
}
var Wse = 6048e5;
function Ex(e) {
  nr(1, arguments);
  var t = Ur(e), r = ud(t).getTime() - Hse(t).getTime();
  return Math.round(r / Wse) + 1;
}
function Os(e, t) {
  var r, n, i, a, o, s, l, d;
  nr(1, arguments);
  var c = Dd(), u = Nn((r = (n = (i = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : c.weekStartsOn) !== null && n !== void 0 ? n : (l = c.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Ur(e), f = h.getUTCDay(), p = (f < u ? 7 : 0) + f - u;
  return h.setUTCDate(h.getUTCDate() - p), h.setUTCHours(0, 0, 0, 0), h;
}
function Y3(e, t) {
  var r, n, i, a, o, s, l, d;
  nr(1, arguments);
  var c = Ur(e), u = c.getUTCFullYear(), h = Dd(), f = Nn((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = h.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(u + 1, 0, f), p.setUTCHours(0, 0, 0, 0);
  var m = Os(p, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(u, 0, f), y.setUTCHours(0, 0, 0, 0);
  var v = Os(y, t);
  return c.getTime() >= m.getTime() ? u + 1 : c.getTime() >= v.getTime() ? u : u - 1;
}
function Qse(e, t) {
  var r, n, i, a, o, s, l, d;
  nr(1, arguments);
  var c = Dd(), u = Nn((r = (n = (i = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = c.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), h = Y3(e, t), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(h, 0, u), f.setUTCHours(0, 0, 0, 0);
  var p = Os(f, t);
  return p;
}
var Kse = 6048e5;
function Ax(e, t) {
  nr(1, arguments);
  var r = Ur(e), n = Os(r, t).getTime() - Qse(r, t).getTime();
  return Math.round(n / Kse) + 1;
}
function qt(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var Ha = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
    return qt(r === "yy" ? i % 100 : i, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : qt(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return qt(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return qt(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return qt(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return qt(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return qt(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, n - 3));
    return qt(a, r.length);
  }
}, el = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Gse = {
  // Era
  G: function(t, r, n) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return n.era(i, {
          width: "narrow"
        });
      default:
        return n.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Ha.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, i) {
    var a = Y3(t, i), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      var s = o % 100;
      return qt(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : qt(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = Cx(t);
    return qt(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return qt(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return qt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return qt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Ha.M(t, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return qt(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, i) {
    var a = Ax(t, i);
    return r === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : qt(a, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var i = Ex(t);
    return r === "Io" ? n.ordinalNumber(i, {
      unit: "week"
    }) : qt(i, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ha.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var i = Bse(t);
    return r === "Do" ? n.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : qt(i, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var i = t.getUTCDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return qt(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return qt(o, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return qt(a, r.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      // Tue
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = el.noon : i === 0 ? a = el.midnight : a = i / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = el.evening : i >= 12 ? a = el.afternoon : i >= 4 ? a = el.morning : a = el.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Ha.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ha.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var i = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : qt(i, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), r === "ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : qt(i, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ha.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ha.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return Ha.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return P7(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ns(o);
      // Hours and minutes with `:` delimiter
      default:
        return ns(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return P7(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ns(o);
      // Hours and minutes with `:` delimiter
      default:
        return ns(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + I7(o, ":");
      default:
        return "GMT" + ns(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + I7(o, ":");
      default:
        return "GMT" + ns(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return qt(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, i) {
    var a = i._originalDate || t, o = a.getTime();
    return qt(o, r.length);
  }
};
function I7(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), a = n % 60;
  if (a === 0)
    return r + String(i);
  var o = t;
  return r + String(i) + o + qt(a, 2);
}
function P7(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + qt(Math.abs(e) / 60, 2);
  }
  return ns(e, t);
}
function ns(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), a = qt(Math.floor(i / 60), 2), o = qt(i % 60, 2);
  return n + a + r + o;
}
var N7 = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    default:
      return r.date({
        width: "full"
      });
  }
}, Tx = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    default:
      return r.time({
        width: "full"
      });
  }
}, Zse = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], i = n[1], a = n[2];
  if (!a)
    return N7(t, r);
  var o;
  switch (i) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", N7(i, r)).replace("{{time}}", Tx(a, r));
}, ng = {
  p: Tx,
  P: Zse
}, Yse = ["D", "DD"], Jse = ["YY", "YYYY"];
function Ox(e) {
  return Yse.indexOf(e) !== -1;
}
function Ix(e) {
  return Jse.indexOf(e) !== -1;
}
function $h(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Xse = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ele = function(t, r, n) {
  var i, a = Xse[t];
  return typeof a == "string" ? i = a : r === 1 ? i = a.one : i = a.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function kp(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var tle = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, rle = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, nle = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ile = {
  date: kp({
    formats: tle,
    defaultWidth: "full"
  }),
  time: kp({
    formats: rle,
    defaultWidth: "full"
  }),
  dateTime: kp({
    formats: nle,
    defaultWidth: "full"
  })
}, ale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ole = function(t, r, n, i) {
  return ale[t];
};
function lc(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
var sle = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, lle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, dle = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, cle = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, ule = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, hle = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, fle = function(t, r) {
  var n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ple = {
  ordinalNumber: fle,
  era: lc({
    values: sle,
    defaultWidth: "wide"
  }),
  quarter: lc({
    values: lle,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: lc({
    values: dle,
    defaultWidth: "wide"
  }),
  day: lc({
    values: cle,
    defaultWidth: "wide"
  }),
  dayPeriod: lc({
    values: ule,
    defaultWidth: "wide",
    formattingValues: hle,
    defaultFormattingWidth: "wide"
  })
};
function dc(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? gle(s, function(u) {
      return u.test(o);
    }) : mle(s, function(u) {
      return u.test(o);
    }), d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = r.valueCallback ? r.valueCallback(d) : d;
    var c = t.slice(o.length);
    return {
      value: d,
      rest: c
    };
  };
}
function mle(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function gle(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function vle(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var i = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var yle = /^(\d+)(th|st|nd|rd)?/i, ble = /\d+/i, wle = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, $le = {
  any: [/^b/i, /^(a|c)/i]
}, kle = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, _le = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xle = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Sle = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Cle = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ele = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ale = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Tle = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ole = {
  ordinalNumber: vle({
    matchPattern: yle,
    parsePattern: ble,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: dc({
    matchPatterns: wle,
    defaultMatchWidth: "wide",
    parsePatterns: $le,
    defaultParseWidth: "any"
  }),
  quarter: dc({
    matchPatterns: kle,
    defaultMatchWidth: "wide",
    parsePatterns: _le,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: dc({
    matchPatterns: xle,
    defaultMatchWidth: "wide",
    parsePatterns: Sle,
    defaultParseWidth: "any"
  }),
  day: dc({
    matchPatterns: Cle,
    defaultMatchWidth: "wide",
    parsePatterns: Ele,
    defaultParseWidth: "any"
  }),
  dayPeriod: dc({
    matchPatterns: Ale,
    defaultMatchWidth: "any",
    parsePatterns: Tle,
    defaultParseWidth: "any"
  })
}, Px = {
  code: "en-US",
  formatDistance: ele,
  formatLong: ile,
  formatRelative: ole,
  localize: ple,
  match: Ole,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Ile = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ple = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Nle = /^'([^]*?)'?$/, Dle = /''/g, Mle = /[a-zA-Z]/;
function Rle(e, t, r) {
  var n, i, a, o, s, l, d, c, u, h, f, p, m, y;
  nr(2, arguments);
  var v = String(t), b = Dd(), $ = (n = (i = void 0) !== null && i !== void 0 ? i : b.locale) !== null && n !== void 0 ? n : Px, _ = Nn((a = (o = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : b.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = b.locale) === null || d === void 0 || (c = d.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(_ >= 1 && _ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var x = Nn((u = (h = (f = (p = void 0) !== null && p !== void 0 ? p : void 0) !== null && f !== void 0 ? f : b.weekStartsOn) !== null && h !== void 0 ? h : (m = b.locale) === null || m === void 0 || (y = m.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && u !== void 0 ? u : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!$.localize)
    throw new RangeError("locale must contain localize property");
  if (!$.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var S = Ur(e);
  if (!Fse(S))
    throw new RangeError("Invalid time value");
  var A = _x(S), N = Sx(S, A), P = {
    firstWeekContainsDate: _,
    weekStartsOn: x,
    locale: $,
    _originalDate: S
  }, D = v.match(Ple).map(function(T) {
    var I = T[0];
    if (I === "p" || I === "P") {
      var j = ng[I];
      return j(T, $.formatLong);
    }
    return T;
  }).join("").match(Ile).map(function(T) {
    if (T === "''")
      return "'";
    var I = T[0];
    if (I === "'")
      return Lle(T);
    var j = Gse[I];
    if (j)
      return Ix(T) && $h(T, t, String(e)), Ox(T) && $h(T, t, String(e)), j(N, T, $.localize, P);
    if (I.match(Mle))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + I + "`");
    return T;
  }).join("");
  return D;
}
function Lle(e) {
  var t = e.match(Nle);
  return t ? t[1].replace(Dle, "'") : e;
}
function Fle(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function D7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function jle(e, t) {
  if (e) {
    if (typeof e == "string") return D7(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? D7(e, t) : void 0;
  }
}
function M7(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = jle(e)) || t) {
      r && (e = r);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(d) {
          throw d;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var d = r.next();
      return o = d.done, d;
    },
    e: function(d) {
      s = !0, a = d;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function Oe(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ig(e, t) {
  return ig = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, ig(e, t);
}
function Ot(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ig(e, t);
}
function kh(e) {
  return kh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, kh(e);
}
function Nx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Nx = function() {
    return !!e;
  })();
}
function zle(e, t) {
  if (t && (Ta(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Oe(e);
}
function It(e) {
  var t = Nx();
  return function() {
    var r, n = kh(e);
    if (t) {
      var i = kh(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return zle(this, r);
  };
}
function $t(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Vle(e, t) {
  if (Ta(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ta(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Dx(e) {
  var t = Vle(e, "string");
  return Ta(t) == "symbol" ? t : t + "";
}
function Ule(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dx(n.key), n);
  }
}
function kt(e, t, r) {
  return t && Ule(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function xe(e, t, r) {
  return (t = Dx(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var qle = 10, Mx = /* @__PURE__ */ (function() {
  function e() {
    $t(this, e), xe(this, "priority", void 0), xe(this, "subPriority", 0);
  }
  return kt(e, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), e;
})(), Ble = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r(n, i, a, o, s) {
    var l;
    return $t(this, r), l = t.call(this), l.value = n, l.validateValue = i, l.setValue = a, l.priority = o, s && (l.subPriority = s), l;
  }
  return kt(r, [{
    key: "validate",
    value: function(i, a) {
      return this.validateValue(i, this.value, a);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return this.setValue(i, a, this.value, o);
    }
  }]), r;
})(Mx), Hle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", qle), xe(Oe(n), "subPriority", -1), n;
  }
  return kt(r, [{
    key: "set",
    value: function(i, a) {
      if (a.timestampIsSet)
        return i;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
    }
  }]), r;
})(Mx), Lt = /* @__PURE__ */ (function() {
  function e() {
    $t(this, e), xe(this, "incompatibleTokens", void 0), xe(this, "priority", void 0), xe(this, "subPriority", void 0);
  }
  return kt(e, [{
    key: "run",
    value: function(r, n, i, a) {
      var o = this.parse(r, n, i, a);
      return o ? {
        setter: new Ble(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, i) {
      return !0;
    }
  }]), e;
})(), Wle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 140), xe(Oe(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return o.era(i, {
            width: "narrow"
          });
        default:
          return o.era(i, {
            width: "wide"
          }) || o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.era = o, i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), xr = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ui = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Sr(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function fr(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function qi(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, i = r[2] ? parseInt(r[2], 10) : 0, a = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (i * xx + a * Dse + o * Mse),
    rest: t.slice(r[0].length)
  };
}
function Rx(e) {
  return fr(xr.anyDigitsSigned, e);
}
function br(e, t) {
  switch (e) {
    case 1:
      return fr(xr.singleDigit, t);
    case 2:
      return fr(xr.twoDigits, t);
    case 3:
      return fr(xr.threeDigits, t);
    case 4:
      return fr(xr.fourDigits, t);
    default:
      return fr(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function _h(e, t) {
  switch (e) {
    case 1:
      return fr(xr.singleDigitSigned, t);
    case 2:
      return fr(xr.twoDigitsSigned, t);
    case 3:
      return fr(xr.threeDigitsSigned, t);
    case 4:
      return fr(xr.fourDigitsSigned, t);
    default:
      return fr(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function J3(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function Lx(e, t) {
  var r = t > 0, n = r ? t : 1 - t, i;
  if (n <= 50)
    i = e || 100;
  else {
    var a = n + 50, o = Math.floor(a / 100) * 100, s = e >= a % 100;
    i = e + o - (s ? 100 : 0);
  }
  return r ? i : 1 - i;
}
function Fx(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Qle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 130), xe(Oe(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Sr(br(4, i), s);
        case "yo":
          return Sr(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return Sr(br(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = Lx(o.year, s);
        return i.setUTCFullYear(l, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
      }
      var d = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(d, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), Kle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 130), xe(Oe(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Sr(br(4, i), s);
        case "Yo":
          return Sr(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return Sr(br(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      var l = Y3(i, s);
      if (o.isTwoDigitYear) {
        var d = Lx(o.year, l);
        return i.setUTCFullYear(d, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), Os(i, s);
      }
      var c = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(c, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), Os(i, s);
    }
  }]), r;
})(Lt), Gle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 130), xe(Oe(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a) {
      return _h(a === "R" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), ud(s);
    }
  }]), r;
})(Lt), Zle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 130), xe(Oe(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a) {
      return _h(a === "u" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), Yle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 120), xe(Oe(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return br(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.quarter(i, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), Jle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 120), xe(Oe(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return br(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return o.quarter(i, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), Xle = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), xe(Oe(n), "priority", 110), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "M":
          return Sr(fr(xr.month, i), s);
        // 01, 02, ..., 12
        case "MM":
          return Sr(br(2, i), s);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return Sr(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "MMM":
          return o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.month(i, {
            width: "wide",
            context: "formatting"
          }) || o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), ede = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 110), xe(Oe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "L":
          return Sr(fr(xr.month, i), s);
        // 01, 02, ..., 12
        case "LL":
          return Sr(br(2, i), s);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return Sr(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "LLL":
          return o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return o.month(i, {
            width: "wide",
            context: "standalone"
          }) || o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt);
function tde(e, t, r) {
  nr(2, arguments);
  var n = Ur(e), i = Nn(t), a = Ax(n, r) - i;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var rde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 100), xe(Oe(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "w":
          return fr(xr.week, i);
        case "wo":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return Os(tde(i, o, s), s);
    }
  }]), r;
})(Lt);
function nde(e, t) {
  nr(2, arguments);
  var r = Ur(e), n = Nn(t), i = Ex(r) - n;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var ide = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 100), xe(Oe(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "I":
          return fr(xr.week, i);
        case "Io":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return ud(nde(i, o));
    }
  }]), r;
})(Lt), ade = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ode = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], sde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 90), xe(Oe(n), "subPriority", 1), xe(Oe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "d":
          return fr(xr.date, i);
        case "do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = Fx(o), l = i.getUTCMonth();
      return s ? a >= 1 && a <= ode[l] : a >= 1 && a <= ade[l];
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCDate(o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), lde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 90), xe(Oe(n), "subpriority", 1), xe(Oe(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return fr(xr.dayOfYear, i);
        case "Do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = Fx(o);
      return s ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(0, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt);
function X3(e, t, r) {
  var n, i, a, o, s, l, d, c;
  nr(2, arguments);
  var u = Dd(), h = Nn((n = (i = (a = (o = r?.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && i !== void 0 ? i : (d = u.locale) === null || d === void 0 || (c = d.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ur(e), p = Nn(t), m = f.getUTCDay(), y = p % 7, v = (y + 7) % 7, b = (v < h ? 7 : 0) + p - m;
  return f.setUTCDate(f.getUTCDate() + b), f;
}
var dde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 90), xe(Oe(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = X3(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), cde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 90), xe(Oe(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o, s) {
      var l = function(c) {
        var u = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + u;
      };
      switch (a) {
        // 3
        case "e":
        case "ee":
          return Sr(br(a.length, i), l);
        // 3rd
        case "eo":
          return Sr(o.ordinalNumber(i, {
            unit: "day"
          }), l);
        // Tue
        case "eee":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = X3(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), ude = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 90), xe(Oe(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o, s) {
      var l = function(c) {
        var u = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + u;
      };
      switch (a) {
        // 3
        case "c":
        case "cc":
          return Sr(br(a.length, i), l);
        // 3rd
        case "co":
          return Sr(o.ordinalNumber(i, {
            unit: "day"
          }), l);
        // Tue
        case "ccc":
          return o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return o.day(i, {
            width: "wide",
            context: "standalone"
          }) || o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = X3(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt);
function hde(e, t) {
  nr(2, arguments);
  var r = Nn(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, i = Ur(e), a = i.getUTCDay(), o = r % 7, s = (o + 7) % 7, l = (s < n ? 7 : 0) + r - a;
  return i.setUTCDate(i.getUTCDate() + l), i;
}
var fde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 90), xe(Oe(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d === 0 ? 7 : d;
      };
      switch (a) {
        // 2
        case "i":
        case "ii":
          return br(a.length, i);
        // 2nd
        case "io":
          return o.ordinalNumber(i, {
            unit: "day"
          });
        // Tue
        case "iii":
          return Sr(o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // T
        case "iiiii":
          return Sr(o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tu
        case "iiiiii":
          return Sr(o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        default:
          return Sr(o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i = hde(i, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), r;
})(Lt), pde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 80), xe(Oe(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(J3(o), 0, 0, 0), i;
    }
  }]), r;
})(Lt), mde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 80), xe(Oe(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(J3(o), 0, 0, 0), i;
    }
  }]), r;
})(Lt), gde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 80), xe(Oe(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(J3(o), 0, 0, 0), i;
    }
  }]), r;
})(Lt), vde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 70), xe(Oe(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "h":
          return fr(xr.hour12h, i);
        case "ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
})(Lt), yde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 70), xe(Oe(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "H":
          return fr(xr.hour23h, i);
        case "Ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
})(Lt), bde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 70), xe(Oe(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "K":
          return fr(xr.hour11h, i);
        case "Ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), r;
})(Lt), wde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 70), xe(Oe(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "k":
          return fr(xr.hour24h, i);
        case "ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = o <= 24 ? o % 24 : o;
      return i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), r;
})(Lt), $de = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 60), xe(Oe(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "m":
          return fr(xr.minute, i);
        case "mo":
          return o.ordinalNumber(i, {
            unit: "minute"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMinutes(o, 0, 0), i;
    }
  }]), r;
})(Lt), kde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 50), xe(Oe(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "s":
          return fr(xr.second, i);
        case "so":
          return o.ordinalNumber(i, {
            unit: "second"
          });
        default:
          return br(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCSeconds(o, 0), i;
    }
  }]), r;
})(Lt), _de = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 30), xe(Oe(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -a.length + 3));
      };
      return Sr(br(a.length, i), o);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMilliseconds(o), i;
    }
  }]), r;
})(Lt), xde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 10), xe(Oe(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "X":
          return qi(Ui.basicOptionalMinutes, i);
        case "XX":
          return qi(Ui.basic, i);
        case "XXXX":
          return qi(Ui.basicOptionalSeconds, i);
        case "XXXXX":
          return qi(Ui.extendedOptionalSeconds, i);
        default:
          return qi(Ui.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), r;
})(Lt), Sde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 10), xe(Oe(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "x":
          return qi(Ui.basicOptionalMinutes, i);
        case "xx":
          return qi(Ui.basic, i);
        case "xxxx":
          return qi(Ui.basicOptionalSeconds, i);
        case "xxxxx":
          return qi(Ui.extendedOptionalSeconds, i);
        default:
          return qi(Ui.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), r;
})(Lt), Cde = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 40), xe(Oe(n), "incompatibleTokens", "*"), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i) {
      return Rx(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
})(Lt), Ede = /* @__PURE__ */ (function(e) {
  Ot(r, e);
  var t = It(r);
  function r() {
    var n;
    $t(this, r);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(a)), xe(Oe(n), "priority", 20), xe(Oe(n), "incompatibleTokens", "*"), n;
  }
  return kt(r, [{
    key: "parse",
    value: function(i) {
      return Rx(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
})(Lt), Ade = {
  G: new Wle(),
  y: new Qle(),
  Y: new Kle(),
  R: new Gle(),
  u: new Zle(),
  Q: new Yle(),
  q: new Jle(),
  M: new Xle(),
  L: new ede(),
  w: new rde(),
  I: new ide(),
  d: new sde(),
  D: new lde(),
  E: new dde(),
  e: new cde(),
  c: new ude(),
  i: new fde(),
  a: new pde(),
  b: new mde(),
  B: new gde(),
  h: new vde(),
  H: new yde(),
  K: new bde(),
  k: new wde(),
  m: new $de(),
  s: new kde(),
  S: new _de(),
  X: new xde(),
  x: new Sde(),
  t: new Cde(),
  T: new Ede()
}, Tde = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ode = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ide = /^'([^]*?)'?$/, Pde = /''/g, Nde = /\S/, Dde = /[a-zA-Z]/;
function Mde(e, t, r, n) {
  var i, a, o, s, l, d, c, u, h, f, p, m, y, v;
  nr(3, arguments);
  var b = String(e), $ = String(t), _ = Dd(), x = (i = (a = void 0) !== null && a !== void 0 ? a : _.locale) !== null && i !== void 0 ? i : Px;
  if (!x.match)
    throw new RangeError("locale must contain match property");
  var S = Nn((o = (s = (l = (d = void 0) !== null && d !== void 0 ? d : void 0) !== null && l !== void 0 ? l : _.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = _.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var A = Nn((h = (f = (p = (m = void 0) !== null && m !== void 0 ? m : void 0) !== null && p !== void 0 ? p : _.weekStartsOn) !== null && f !== void 0 ? f : (y = _.locale) === null || y === void 0 || (v = y.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(A >= 0 && A <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if ($ === "")
    return b === "" ? Ur(r) : /* @__PURE__ */ new Date(NaN);
  var N = {
    firstWeekContainsDate: S,
    weekStartsOn: A,
    locale: x
  }, P = [new Hle()], D = $.match(Ode).map(function(W) {
    var oe = W[0];
    if (oe in ng) {
      var le = ng[oe];
      return le(W, x.formatLong);
    }
    return W;
  }).join("").match(Tde), T = [], I = M7(D), j;
  try {
    var F = function() {
      var oe = j.value;
      !(n != null && n.useAdditionalWeekYearTokens) && Ix(oe) && $h(oe, $, e), !(n != null && n.useAdditionalDayOfYearTokens) && Ox(oe) && $h(oe, $, e);
      var le = oe[0], Fe = Ade[le];
      if (Fe) {
        var We = Fe.incompatibleTokens;
        if (Array.isArray(We)) {
          var St = T.find(function(Ct) {
            return We.includes(Ct.token) || Ct.token === le;
          });
          if (St)
            throw new RangeError("The format string mustn't contain `".concat(St.fullToken, "` and `").concat(oe, "` at the same time"));
        } else if (Fe.incompatibleTokens === "*" && T.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(oe, "` and any other token at the same time"));
        T.push({
          token: le,
          fullToken: oe
        });
        var bt = Fe.run(b, oe, x.match, N);
        if (!bt)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        P.push(bt.setter), b = bt.rest;
      } else {
        if (le.match(Dde))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + le + "`");
        if (oe === "''" ? oe = "'" : le === "'" && (oe = Rde(oe)), b.indexOf(oe) === 0)
          b = b.slice(oe.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (I.s(); !(j = I.n()).done; ) {
      var Z = F();
      if (Ta(Z) === "object") return Z.v;
    }
  } catch (W) {
    I.e(W);
  } finally {
    I.f();
  }
  if (b.length > 0 && Nde.test(b))
    return /* @__PURE__ */ new Date(NaN);
  var te = P.map(function(W) {
    return W.priority;
  }).sort(function(W, oe) {
    return oe - W;
  }).filter(function(W, oe, le) {
    return le.indexOf(W) === oe;
  }).map(function(W) {
    return P.filter(function(oe) {
      return oe.priority === W;
    }).sort(function(oe, le) {
      return le.subPriority - oe.subPriority;
    });
  }).map(function(W) {
    return W[0];
  }), Y = Ur(r);
  if (isNaN(Y.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Q = Sx(Y, _x(Y)), R = {}, re = M7(te), he;
  try {
    for (re.s(); !(he = re.n()).done; ) {
      var ge = he.value;
      if (!ge.validate(Q, N))
        return /* @__PURE__ */ new Date(NaN);
      var ce = ge.set(Q, R, N);
      Array.isArray(ce) ? (Q = ce[0], Fle(R, ce[1])) : Q = ce;
    }
  } catch (W) {
    re.e(W);
  } finally {
    re.f();
  }
  return Q;
}
function Rde(e) {
  return e.match(Ide)[1].replace(Pde, "'");
}
function Lde(e) {
  return nr(1, arguments), Rse(e, Date.now());
}
const x1 = (e, t) => {
  e.updateFormValue({
    key: "treatment",
    value: void 0
  }), e.updateFormValue({
    key: "dispenseAsWritten",
    value: !1
  }), e.updateFormValue({
    key: "dispenseQuantity",
    value: void 0
  }), e.updateFormValue({
    key: "dispenseUnit",
    value: void 0
  }), e.updateFormValue({
    key: "daysSupply",
    value: void 0
  }), e.updateFormValue({
    key: "refills",
    value: void 0
  }), e.updateFormValue({
    key: "instructions",
    value: ""
  }), e.updateFormValue({
    key: "notes",
    value: t?.notes ?? ""
  }), e.updateFormValue({
    key: "addToTemplates",
    value: !1
  });
}, jx = (e, t) => {
  if (e.updateFormValue({
    key: "treatment",
    value: t.treatment
  }), t.dispenseAsWritten && e.updateFormValue({
    key: "dispenseAsWritten",
    value: t.dispenseAsWritten
  }), t.dispenseQuantity && e.updateFormValue({
    key: "dispenseQuantity",
    value: Number(t.dispenseQuantity)
  }), t.dispenseUnit && e.updateFormValue({
    key: "dispenseUnit",
    value: t.dispenseUnit
  }), t.daysSupply && e.updateFormValue({
    key: "daysSupply",
    value: Number(t.daysSupply)
  }), t.fillsAllowed !== void 0 && t.fillsAllowed !== null) {
    const r = Number(t.fillsAllowed);
    e.updateFormValue({
      key: "refills",
      value: r > 0 ? r - 1 : 0
    });
  }
  t.instructions && e.updateFormValue({
    key: "instructions",
    value: t.instructions
  }), t.notes && e.updateFormValue({
    key: "notes",
    value: t.notes
  }), t.doNotFillBeforeDate && e.updateFormValue({
    key: "doNotFillBeforeDate",
    value: t.doNotFillBeforeDate
  });
}, Fr = (e, t) => Nd("message", (r) => gx(r, e) ? !0 : t), Fde = Nd("NotFutureDate", (e) => {
  const t = new Date(e);
  return t instanceof Date ? t <= /* @__PURE__ */ new Date() : !1;
}), jde = (e, t = (r) => Mde(r, $_, /* @__PURE__ */ new Date())) => Nd("afterDate", function(n) {
  return Use(t(n), e) >= 0 || Lde(t(n));
}), zde = () => Lo(jn(), "zipString", (e) => /^\d{5}(-\d{4})?$/.test(e)), Vde = () => Lo(jn(), "email", (e) => e.length === 0 ? !0 : /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(e)), Ude = () => Lo(xf(), "empty", (e) => e === null || e == null);
var qde = /* @__PURE__ */ ae('<div class="flex-1 mt-2">'), Bde = /* @__PURE__ */ ae('<div class="flex flex-col gap-1"><photon-medication-search label="Search for Treatment"></photon-medication-search><div class=mt-2></div><div class="sm:grid sm:grid-cols-2 sm:gap-4 mt-2"><div class="flex items-start gap-1"><div class=flex-1></div></div></div><div class="sm:grid sm:grid-cols-2 sm:gap-4"></div><div class="flex flex-col xs:flex-row mt-4"><div class="flex flex-grow justify-end">', !0, !1, !1);
const R7 = {
  treatment: Fr(K3(jn(), xf()), "Please select a treatment"),
  dispenseQuantity: Fr(yp(K0(), 0, {
    exclusive: !0
  }), "Quantity must be positive"),
  dispenseUnit: Fr(Lo(jn(), "nonEmptyString", (e) => e.trim().length > 0), "Please select a dispensing unit"),
  daysSupply: Fr(yp(K0(), 0), "Days Supply must be at least 0"),
  refills: Fr(ise([yp(K0(), 0), lse(K0(), 11)]), "Refills must be 0 to 11"),
  instructions: Fr(dse(jn()), "Please enter instructions for the patient"),
  doNotFillBeforeDate: Fr(ase(jde(/* @__PURE__ */ new Date())), "Please choose a date that isn't in the past")
}, Hde = (e) => {
  const {
    tryCreatePrescription: t
  } = Vs(), {
    dispatchOrderError: r,
    dispatchAnalyticsTrackEvent: n
  } = Ma(), [i, a] = V(void 0), [o, s] = V(!1), [l, d] = V(""), [c, u] = V(!1);
  lr(() => {
    for (const [f, p] of Object.entries(R7))
      e.actions.registerValidator({
        key: f,
        validator: p
      });
    x1(e.actions, e?.prefillNotes ? {
      notes: e.prefillNotes
    } : void 0);
  });
  const h = async () => {
    u(!0);
    const f = Object.keys(R7);
    if (e.actions.validate(f), e.actions.hasErrors(f)) {
      u(!1), rr({
        status: "error",
        body: "Some items in the form are incomplete, please check for errors"
      });
      return;
    }
    const m = {
      doNotFillBeforeDate: e.store.doNotFillBeforeDate?.value,
      treatment: {
        id: e.store.treatment.value.id,
        name: e.store.treatment.value.name
      },
      dispenseAsWritten: e.store.dispenseAsWritten.value,
      dispenseQuantity: e.store.dispenseQuantity.value,
      dispenseUnit: e.store.dispenseUnit.value,
      daysSupply: e.store.daysSupply.value,
      instructions: e.store.instructions.value,
      notes: e.store.notes.value,
      fillsAllowed: e.store.refills.value + 1,
      // TODO: set this from template-overrides. can we stop using the props.store, with this param as a starting point?
      diagnoseCodes: []
    };
    let y = null;
    try {
      const v = {
        addToTemplates: e.store.addToTemplates?.value ?? !1,
        templateName: e.store.templateName?.value,
        catalogId: e.store.catalogId?.value,
        showSuccessToast: !0
      };
      y = await t(m, v);
    } catch (v) {
      r([v]);
    } finally {
      u(!1);
    }
    y && (e.screenDraftedPrescriptions(), e.actions.clearKeys(["treatment", "dispenseAsWritten", "dispenseQuantity", "dispenseUnit", "daysSupply", "refills", "instructions", "notes", "templateName", "addToTemplates", "doNotFillBeforeDate"]), a(void 0), x1(e.actions, e.prefillNotes ? {
      notes: e.prefillNotes
    } : void 0), d(""));
  };
  return fe(() => {
    e.store.treatment?.value && d(e.store.treatment.value.name);
  }), g(Mn, {
    addChildrenDivider: !0,
    get children() {
      return [g(Ee, {
        color: "gray",
        children: "Add Prescription"
      }), (() => {
        var f = Bde(), p = f.firstChild, m = p.nextSibling, y = m.nextSibling, v = y.firstChild, b = v.firstChild, $ = y.nextSibling, _ = $.nextSibling, x = _.firstChild;
        return Ue(p, "photon-search-text-changed", (S) => d(S.detail.text)), Ue(p, "photon-treatment-unselected", () => {
          x1(e.actions, e?.prefillNotes ? {
            notes: e.prefillNotes
          } : void 0), e.draftedPrescriptionChanged();
        }), Ue(p, "photon-treatment-selected", (S) => {
          S.detail.data.__typename === "PrescriptionTemplate" ? jx(e.actions, {
            ...S.detail.data,
            notes: [S.detail.data?.notes, e.prefillNotes].filter((A) => A).join(`

`)
          }) : e.actions.updateFormValue({
            key: "treatment",
            value: S.detail.data
          }), n("fieldInteraction", {
            name: "Field Interaction",
            formName: "add_prescription_form",
            fieldName: "treatment",
            hasValue: !0,
            isOptional: !1
          }), S.detail.catalogId && e.actions.updateFormValue({
            key: "catalogId",
            value: S.detail.catalogId
          }), e.draftedPrescriptionChanged();
        }), p._$owner = Ve(), L(f, g(
          O_,
          {
            get screeningAlerts() {
              return e.screeningAlerts.filter((S) => S.involvedEntities.map((A) => A.id).indexOf(e.store.treatment?.value?.id) >= 0);
            },
            get owningId() {
              return e.store.treatment?.value?.id;
            }
          }
        ), m), L(m, g(im, {
          mainText: "Dispense as written",
          tooltip: "This prescription will be filled generically unless this box is checked",
          showOptionalSubtext: !0,
          get checked() {
            return e.store.dispenseAsWritten?.value || !1;
          },
          onChange: (S) => {
            e.actions.updateFormValue({
              key: "dispenseAsWritten",
              value: S
            }), n("fieldInteraction", {
              name: "Field Interaction",
              formName: "add_prescription_form",
              fieldName: "dispenseAsWritten",
              hasValue: S,
              isOptional: !0
            });
          }
        })), b.style.setProperty("width", "100px"), L(b, g(at, {
          label: "Quantity",
          required: !0,
          get error() {
            return e.store.dispenseQuantity?.error;
          },
          get children() {
            return g(Dt, {
              type: "number",
              inputMode: "decimal",
              get value() {
                return e.store.dispenseQuantity?.value ?? void 0;
              },
              min: 0,
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "dispenseQuantity",
                  value: Number(S.currentTarget.value)
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "dispenseQuantity",
                  hasValue: !!S.currentTarget.value,
                  isOptional: !1
                });
              }
            });
          }
        })), L(v, g(at, {
          label: " ",
          get children() {
            return g(xt, {
              variant: "secondary",
              class: "w-11 h-11 sm:h-12",
              onClick: () => s(!0),
              get children() {
                return g(mt, {
                  name: "calculator",
                  size: "sm"
                });
              }
            });
          }
        }), null), L(y, g(at, {
          label: "Dispense Unit",
          required: !0,
          get error() {
            return e.store.dispenseUnit?.error;
          },
          get children() {
            return g(_K, {
              get value() {
                return e.store.dispenseUnit?.value ?? void 0;
              },
              onChange: (S) => {
                e.actions.updateFormValue({
                  key: "dispenseUnit",
                  value: S.currentTarget.value
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "dispenseUnit",
                  hasValue: !!S.currentTarget.value,
                  isOptional: !1
                });
              }
            });
          }
        }), null), L(f, g(zJ, {
          get open() {
            return o();
          },
          onClose: () => s(!1),
          get medicationName() {
            return e.store.treatment?.value?.name;
          },
          get weight() {
            return e.weight;
          },
          get weightUnit() {
            return e.weightUnit;
          },
          setAutocompleteValues: ({
            liquidDose: S,
            totalLiquid: A,
            unit: N,
            days: P
          }) => {
            e.actions.updateFormValue({
              key: "daysSupply",
              value: Number(P)
            }), e.actions.updateFormValue({
              key: "dispenseQuantity",
              value: Number(A)
            }), e.actions.updateFormValue({
              key: "instructions",
              value: `${S} ${N} ${e.store.instructions?.value}`
            }), N === "mL" && e.actions.updateFormValue({
              key: "dispenseUnit",
              value: "Milliliter"
            });
          }
        }), $), L($, g(at, {
          label: "Days Supply",
          required: !0,
          get error() {
            return e.store.daysSupply?.error;
          },
          get children() {
            return g(Dt, {
              type: "number",
              inputMode: "numeric",
              get value() {
                return e.store.daysSupply?.value ?? void 0;
              },
              min: 0,
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "daysSupply",
                  value: Number(S.currentTarget.value)
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "daysSupply",
                  hasValue: !!S.currentTarget.value,
                  isOptional: !0
                });
              }
            });
          }
        }), null), L($, g(at, {
          label: "Refills",
          required: !0,
          get error() {
            return e.store.refills?.error;
          },
          get children() {
            return g(Dt, {
              type: "number",
              inputMode: "numeric",
              get value() {
                return e.store.refills?.value ?? void 0;
              },
              min: 0,
              max: 11,
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "refills",
                  value: Number(S.currentTarget.value)
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "refills",
                  hasValue: !!S.currentTarget.value,
                  isOptional: !0
                });
              }
            });
          }
        }), null), L(f, g(at, {
          label: "Patient Instructions (SIG)",
          required: !0,
          get error() {
            return e.store.instructions?.error;
          },
          get children() {
            return g(Pm, {
              placeholder: "Enter patient instructions",
              get value() {
                return e.store.instructions?.value;
              },
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "instructions",
                  value: S
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "instructions",
                  hasValue: !!S,
                  isOptional: !1
                });
              }
            });
          }
        }), _), L(f, g(at, {
          label: "Pharmacy Note",
          showOptionalSubtext: !0,
          get children() {
            return g(Pm, {
              placeholder: "Enter pharmacy note",
              get value() {
                return e.store.notes?.value;
              },
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "notes",
                  value: S
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "pharmacy_notes",
                  hasValue: !!S,
                  isOptional: !0
                });
              }
            });
          }
        }), _), L(f, g(at, {
          label: "Do Not Fill Before",
          showOptionalSubtext: !0,
          get error() {
            return e.store.doNotFillBeforeDate?.error;
          },
          get children() {
            return g(Dt, {
              type: "date",
              get value() {
                return e.store.doNotFillBeforeDate?.value;
              },
              get min() {
                return Rle(/* @__PURE__ */ new Date(), $_);
              },
              onInput: (S) => {
                e.actions.updateFormValue({
                  key: "doNotFillBeforeDate",
                  value: S.currentTarget.value || void 0
                });
              },
              onBlur: (S) => {
                n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "doNotFillBeforeDate",
                  hasValue: !!S.currentTarget.value,
                  isOptional: !0
                });
              }
            });
          }
        }), _), L(_, g(H, {
          get when() {
            return !e.hideAddToTemplates;
          },
          get children() {
            return g(im, {
              mainText: "Add To Personal Templates",
              showOptionalSubtext: !0,
              get checked() {
                return e.store.addToTemplates?.value || !1;
              },
              onChange: (S) => {
                e.actions.updateFormValue({
                  key: "addToTemplates",
                  value: S
                }), n("fieldInteraction", {
                  name: "Field Interaction",
                  formName: "add_prescription_form",
                  fieldName: "addToTemplates",
                  hasValue: S,
                  isOptional: !0
                });
              }
            });
          }
        }), x), L(_, g(H, {
          get when() {
            return e.store.addToTemplates?.value ?? !1;
          },
          get children() {
            var S = qde();
            return L(S, g(at, {
              label: "Template Name",
              get error() {
                return e.store.templateName?.error;
              },
              get children() {
                return g(Dt, {
                  get value() {
                    return e.store.templateName?.value ?? "";
                  },
                  onInput: (A) => e.actions.updateFormValue({
                    key: "templateName",
                    value: A.currentTarget.value
                  })
                });
              }
            })), S;
          }
        }), x), L(x, g(xt, {
          class: "w-full xs:!w-auto h-fit mt-6",
          size: "lg",
          onClick: () => {
            c() || h();
          },
          get loading() {
            return c();
          },
          variant: "primary",
          color: "blue",
          children: "Add to drafts"
        })), se((S) => {
          var A = e.catalogId, N = e.allowOffCatalogSearch, P = e.store.treatment?.value ?? void 0, D = e.store.treatment?.error ?? !1, T = e.store.treatment?.error, I = i(), j = l(), F = e.disableList;
          return A !== S.e && (p.catalogId = S.e = A), N !== S.t && (p.allowOffCatalogSearch = S.t = N), P !== S.a && (p.selected = S.a = P), D !== S.o && (p.invalid = S.o = D), T !== S.i && (p.helpText = S.i = T), I !== S.n && (p.offCatalogOption = S.n = I), j !== S.s && (p.searchText = S.s = j), F !== S.h && (p.disableList = S.h = F), S;
        }, {
          e: void 0,
          t: void 0,
          a: void 0,
          o: void 0,
          i: void 0,
          n: void 0,
          s: void 0,
          h: void 0
        }), f;
      })()];
    }
  });
};
var Wde = Ln`
  :host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --arrow-size: var(--sl-tooltip-arrow-size);
    --arrow-color: var(--sl-tooltip-background-color);
  }

  .tooltip::part(popup) {
    z-index: var(--sl-z-index-tooltip);
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--sl-tooltip-border-radius);
    background-color: var(--sl-tooltip-background-color);
    font-family: var(--sl-tooltip-font-family);
    font-size: var(--sl-tooltip-font-size);
    font-weight: var(--sl-tooltip-font-weight);
    line-height: var(--sl-tooltip-line-height);
    text-align: start;
    white-space: normal;
    color: var(--sl-tooltip-color);
    padding: var(--sl-tooltip-padding);
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }
`, Qde = Ln`
  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge--visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }
`;
const Ao = Math.min, zn = Math.max, xh = Math.round, Z0 = Math.floor, Gi = (e) => ({
  x: e,
  y: e
}), Kde = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ag(e, t, r) {
  return zn(e, Ao(t, r));
}
function Md(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function To(e) {
  return e.split("-")[0];
}
function Rd(e) {
  return e.split("-")[1];
}
function zx(e) {
  return e === "x" ? "y" : "x";
}
function ev(e) {
  return e === "y" ? "height" : "width";
}
function ba(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function tv(e) {
  return zx(ba(e));
}
function Gde(e, t, r) {
  r === void 0 && (r = !1);
  const n = Rd(e), i = tv(e), a = ev(i);
  let o = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = Sh(o)), [o, Sh(o)];
}
function Zde(e) {
  const t = Sh(e);
  return [og(e), t, og(t)];
}
function og(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const L7 = ["left", "right"], F7 = ["right", "left"], Yde = ["top", "bottom"], Jde = ["bottom", "top"];
function Xde(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? F7 : L7 : t ? L7 : F7;
    case "left":
    case "right":
      return t ? Yde : Jde;
    default:
      return [];
  }
}
function ece(e, t, r, n) {
  const i = Rd(e);
  let a = Xde(To(e), r === "start", n);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(og)))), a;
}
function Sh(e) {
  const t = To(e);
  return Kde[t] + e.slice(t.length);
}
function tce(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vx(e) {
  return typeof e != "number" ? tce(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ch(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: i
  } = e;
  return {
    width: n,
    height: i,
    top: r,
    left: t,
    right: t + n,
    bottom: r + i,
    x: t,
    y: r
  };
}
function j7(e, t, r) {
  let {
    reference: n,
    floating: i
  } = e;
  const a = ba(t), o = tv(t), s = ev(o), l = To(t), d = a === "y", c = n.x + n.width / 2 - i.width / 2, u = n.y + n.height / 2 - i.height / 2, h = n[s] / 2 - i[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: c,
        y: n.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      f = {
        x: n.x - i.width,
        y: u
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (Rd(t)) {
    case "start":
      f[o] -= h * (r && d ? -1 : 1);
      break;
    case "end":
      f[o] += h * (r && d ? -1 : 1);
      break;
  }
  return f;
}
async function rce(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = Md(t, e), p = Vx(f), y = s[h ? u === "floating" ? "reference" : "floating" : u], v = Ch(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(y))) == null || r ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), b = u === "floating" ? {
    x: n,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, $ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), _ = await (a.isElement == null ? void 0 : a.isElement($)) ? await (a.getScale == null ? void 0 : a.getScale($)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Ch(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: $,
    strategy: l
  }) : b);
  return {
    top: (v.top - x.top + p.top) / _.y,
    bottom: (x.bottom - v.bottom + p.bottom) / _.y,
    left: (v.left - x.left + p.left) / _.x,
    right: (x.right - v.right + p.right) / _.x
  };
}
const nce = 50, ice = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = r, s = o.detectOverflow ? o : {
    ...o,
    detectOverflow: rce
  }, l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let d = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: c,
    y: u
  } = j7(d, n, l), h = n, f = 0;
  const p = {};
  for (let m = 0; m < a.length; m++) {
    const y = a[m];
    if (!y)
      continue;
    const {
      name: v,
      fn: b
    } = y, {
      x: $,
      y: _,
      data: x,
      reset: S
    } = await b({
      x: c,
      y: u,
      initialPlacement: n,
      placement: h,
      strategy: i,
      middlewareData: p,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = $ ?? c, u = _ ?? u, p[v] = {
      ...p[v],
      ...x
    }, S && f < nce && (f++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (d = S.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : S.rects), {
      x: c,
      y: u
    } = j7(d, h, l)), m = -1);
  }
  return {
    x: c,
    y: u,
    placement: h,
    strategy: i,
    middlewareData: p
  };
}, ace = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: d,
      padding: c = 0
    } = Md(e, t) || {};
    if (d == null)
      return {};
    const u = Vx(c), h = {
      x: r,
      y: n
    }, f = tv(i), p = ev(f), m = await o.getDimensions(d), y = f === "y", v = y ? "top" : "left", b = y ? "bottom" : "right", $ = y ? "clientHeight" : "clientWidth", _ = a.reference[p] + a.reference[f] - h[f] - a.floating[p], x = h[f] - a.reference[f], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(d));
    let A = S ? S[$] : 0;
    (!A || !await (o.isElement == null ? void 0 : o.isElement(S))) && (A = s.floating[$] || a.floating[p]);
    const N = _ / 2 - x / 2, P = A / 2 - m[p] / 2 - 1, D = Ao(u[v], P), T = Ao(u[b], P), I = D, j = A - m[p] - T, F = A / 2 - m[p] / 2 + N, Z = ag(I, F, j), te = !l.arrow && Rd(i) != null && F !== Z && a.reference[p] / 2 - (F < I ? D : T) - m[p] / 2 < 0, Y = te ? F < I ? F - I : F - j : 0;
    return {
      [f]: h[f] + Y,
      data: {
        [f]: Z,
        centerOffset: F - Z - Y,
        ...te && {
          alignmentOffset: Y
        }
      },
      reset: te
    };
  }
}), oce = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...y
      } = Md(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const v = To(i), b = ba(s), $ = To(s) === s, _ = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), x = h || ($ || !m ? [Sh(s)] : Zde(s)), S = p !== "none";
      !h && S && x.push(...ece(s, m, p, _));
      const A = [s, ...x], N = await l.detectOverflow(t, y), P = [];
      let D = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && P.push(N[v]), u) {
        const F = Gde(i, o, _);
        P.push(N[F[0]], N[F[1]]);
      }
      if (D = [...D, {
        placement: i,
        overflows: P
      }], !P.every((F) => F <= 0)) {
        var T, I;
        const F = (((T = a.flip) == null ? void 0 : T.index) || 0) + 1, Z = A[F];
        if (Z && (!(u === "alignment" ? b !== ba(Z) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((Q) => ba(Q.placement) === b ? Q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: F,
              overflows: D
            },
            reset: {
              placement: Z
            }
          };
        let te = (I = D.filter((Y) => Y.overflows[0] <= 0).sort((Y, Q) => Y.overflows[1] - Q.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!te)
          switch (f) {
            case "bestFit": {
              var j;
              const Y = (j = D.filter((Q) => {
                if (S) {
                  const R = ba(Q.placement);
                  return R === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  R === "y";
                }
                return !0;
              }).map((Q) => [Q.placement, Q.overflows.filter((R) => R > 0).reduce((R, re) => R + re, 0)]).sort((Q, R) => Q[1] - R[1])[0]) == null ? void 0 : j[0];
              Y && (te = Y);
              break;
            }
            case "initialPlacement":
              te = s;
              break;
          }
        if (i !== te)
          return {
            reset: {
              placement: te
            }
          };
      }
      return {};
    }
  };
}, sce = /* @__PURE__ */ new Set(["left", "top"]);
async function lce(e, t) {
  const {
    placement: r,
    platform: n,
    elements: i
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = To(r), s = Rd(r), l = ba(r) === "y", d = sce.has(o) ? -1 : 1, c = a && l ? -1 : 1, u = Md(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: p
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof p == "number" && (f = s === "end" ? p * -1 : p), l ? {
    x: f * c,
    y: h * d
  } : {
    x: h * d,
    y: f * c
  };
}
const dce = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, l = await lce(t, e);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, cce = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i,
        platform: a
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: b,
              y: $
            } = v;
            return {
              x: b,
              y: $
            };
          }
        },
        ...d
      } = Md(e, t), c = {
        x: r,
        y: n
      }, u = await a.detectOverflow(t, d), h = ba(To(i)), f = zx(h);
      let p = c[f], m = c[h];
      if (o) {
        const v = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", $ = p + u[v], _ = p - u[b];
        p = ag($, p, _);
      }
      if (s) {
        const v = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", $ = m + u[v], _ = m - u[b];
        m = ag($, m, _);
      }
      const y = l.fn({
        ...t,
        [f]: p,
        [h]: m
      });
      return {
        ...y,
        data: {
          x: y.x - r,
          y: y.y - n,
          enabled: {
            [f]: o,
            [h]: s
          }
        }
      };
    }
  };
}, uce = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...d
      } = Md(e, t), c = await o.detectOverflow(t, d), u = To(i), h = Rd(i), f = ba(i) === "y", {
        width: p,
        height: m
      } = a.floating;
      let y, v;
      u === "top" || u === "bottom" ? (y = u, v = h === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (v = u, y = h === "end" ? "top" : "bottom");
      const b = m - c.top - c.bottom, $ = p - c.left - c.right, _ = Ao(m - c[y], b), x = Ao(p - c[v], $), S = !t.middlewareData.shift;
      let A = _, N = x;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (N = $), (n = t.middlewareData.shift) != null && n.enabled.y && (A = b), S && !h) {
        const D = zn(c.left, 0), T = zn(c.right, 0), I = zn(c.top, 0), j = zn(c.bottom, 0);
        f ? N = p - 2 * (D !== 0 || T !== 0 ? D + T : zn(c.left, c.right)) : A = m - 2 * (I !== 0 || j !== 0 ? I + j : zn(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: N,
        availableHeight: A
      });
      const P = await o.getDimensions(s.floating);
      return p !== P.width || m !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Sf() {
  return typeof window < "u";
}
function Ld(e) {
  return Ux(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Bn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function oa(e) {
  var t;
  return (t = (Ux(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ux(e) {
  return Sf() ? e instanceof Node || e instanceof Bn(e).Node : !1;
}
function Pi(e) {
  return Sf() ? e instanceof Element || e instanceof Bn(e).Element : !1;
}
function Ra(e) {
  return Sf() ? e instanceof HTMLElement || e instanceof Bn(e).HTMLElement : !1;
}
function z7(e) {
  return !Sf() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Bn(e).ShadowRoot;
}
function o0(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: i
  } = Ni(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && i !== "inline" && i !== "contents";
}
function hce(e) {
  return /^(table|td|th)$/.test(Ld(e));
}
function Cf(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const fce = /transform|translate|scale|rotate|perspective|filter/, pce = /paint|layout|strict|content/, Zo = (e) => !!e && e !== "none";
let _p;
function Ef(e) {
  const t = Pi(e) ? Ni(e) : e;
  return Zo(t.transform) || Zo(t.translate) || Zo(t.scale) || Zo(t.rotate) || Zo(t.perspective) || !rv() && (Zo(t.backdropFilter) || Zo(t.filter)) || fce.test(t.willChange || "") || pce.test(t.contain || "");
}
function mce(e) {
  let t = Oo(e);
  for (; Ra(t) && !hd(t); ) {
    if (Ef(t))
      return t;
    if (Cf(t))
      return null;
    t = Oo(t);
  }
  return null;
}
function rv() {
  return _p == null && (_p = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), _p;
}
function hd(e) {
  return /^(html|body|#document)$/.test(Ld(e));
}
function Ni(e) {
  return Bn(e).getComputedStyle(e);
}
function Af(e) {
  return Pi(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Oo(e) {
  if (Ld(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    z7(e) && e.host || // Fallback.
    oa(e)
  );
  return z7(t) ? t.host : t;
}
function qx(e) {
  const t = Oo(e);
  return hd(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ra(t) && o0(t) ? t : qx(t);
}
function Au(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = qx(e), a = i === ((n = e.ownerDocument) == null ? void 0 : n.body), o = Bn(i);
  if (a) {
    const s = sg(o);
    return t.concat(o, o.visualViewport || [], o0(i) ? i : [], s && r ? Au(s) : []);
  } else
    return t.concat(i, Au(i, [], r));
}
function sg(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Bx(e) {
  const t = Ni(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const i = Ra(e), a = i ? e.offsetWidth : r, o = i ? e.offsetHeight : n, s = xh(r) !== a || xh(n) !== o;
  return s && (r = a, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function nv(e) {
  return Pi(e) ? e : e.contextElement;
}
function ql(e) {
  const t = nv(e);
  if (!Ra(t))
    return Gi(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: i,
    $: a
  } = Bx(t);
  let o = (a ? xh(r.width) : r.width) / n, s = (a ? xh(r.height) : r.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const gce = /* @__PURE__ */ Gi(0);
function Hx(e) {
  const t = Bn(e);
  return !rv() || !t.visualViewport ? gce : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function vce(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Bn(e) ? !1 : t;
}
function Is(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), a = nv(e);
  let o = Gi(1);
  t && (n ? Pi(n) && (o = ql(n)) : o = ql(e));
  const s = vce(a, r, n) ? Hx(a) : Gi(0);
  let l = (i.left + s.x) / o.x, d = (i.top + s.y) / o.y, c = i.width / o.x, u = i.height / o.y;
  if (a) {
    const h = Bn(a), f = n && Pi(n) ? Bn(n) : n;
    let p = h, m = sg(p);
    for (; m && n && f !== p; ) {
      const y = ql(m), v = m.getBoundingClientRect(), b = Ni(m), $ = v.left + (m.clientLeft + parseFloat(b.paddingLeft)) * y.x, _ = v.top + (m.clientTop + parseFloat(b.paddingTop)) * y.y;
      l *= y.x, d *= y.y, c *= y.x, u *= y.y, l += $, d += _, p = Bn(m), m = sg(p);
    }
  }
  return Ch({
    width: c,
    height: u,
    x: l,
    y: d
  });
}
function Tf(e, t) {
  const r = Af(e).scrollLeft;
  return t ? t.left + r : Is(oa(e)).left + r;
}
function Wx(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - Tf(e, r), i = r.top + t.scrollTop;
  return {
    x: n,
    y: i
  };
}
function yce(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: i
  } = e;
  const a = i === "fixed", o = oa(n), s = t ? Cf(t.floating) : !1;
  if (n === o || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Gi(1);
  const c = Gi(0), u = Ra(n);
  if ((u || !u && !a) && ((Ld(n) !== "body" || o0(o)) && (l = Af(n)), u)) {
    const f = Is(n);
    d = ql(n), c.x = f.x + n.clientLeft, c.y = f.y + n.clientTop;
  }
  const h = o && !u && !a ? Wx(o, l) : Gi(0);
  return {
    width: r.width * d.x,
    height: r.height * d.y,
    x: r.x * d.x - l.scrollLeft * d.x + c.x + h.x,
    y: r.y * d.y - l.scrollTop * d.y + c.y + h.y
  };
}
function bce(e) {
  return Array.from(e.getClientRects());
}
function wce(e) {
  const t = oa(e), r = Af(e), n = e.ownerDocument.body, i = zn(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = zn(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Tf(e);
  const s = -r.scrollTop;
  return Ni(n).direction === "rtl" && (o += zn(t.clientWidth, n.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
const V7 = 25;
function $ce(e, t) {
  const r = Bn(e), n = oa(e), i = r.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const c = rv();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  const d = Tf(n);
  if (d <= 0) {
    const c = n.ownerDocument, u = c.body, h = getComputedStyle(u), f = c.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, p = Math.abs(n.clientWidth - u.clientWidth - f);
    p <= V7 && (a -= p);
  } else d <= V7 && (a += d);
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function kce(e, t) {
  const r = Is(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, a = Ra(e) ? ql(e) : Gi(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, l = i * a.x, d = n * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: d
  };
}
function U7(e, t, r) {
  let n;
  if (t === "viewport")
    n = $ce(e, r);
  else if (t === "document")
    n = wce(oa(e));
  else if (Pi(t))
    n = kce(t, r);
  else {
    const i = Hx(e);
    n = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Ch(n);
}
function Qx(e, t) {
  const r = Oo(e);
  return r === t || !Pi(r) || hd(r) ? !1 : Ni(r).position === "fixed" || Qx(r, t);
}
function _ce(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Au(e, [], !1).filter((s) => Pi(s) && Ld(s) !== "body"), i = null;
  const a = Ni(e).position === "fixed";
  let o = a ? Oo(e) : e;
  for (; Pi(o) && !hd(o); ) {
    const s = Ni(o), l = Ef(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && (i.position === "absolute" || i.position === "fixed") || o0(o) && !l && Qx(e, o)) ? n = n.filter((c) => c !== o) : i = s, o = Oo(o);
  }
  return t.set(e, n), n;
}
function xce(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: i
  } = e;
  const o = [...r === "clippingAncestors" ? Cf(t) ? [] : _ce(t, this._c) : [].concat(r), n], s = U7(t, o[0], i);
  let l = s.top, d = s.right, c = s.bottom, u = s.left;
  for (let h = 1; h < o.length; h++) {
    const f = U7(t, o[h], i);
    l = zn(f.top, l), d = Ao(f.right, d), c = Ao(f.bottom, c), u = zn(f.left, u);
  }
  return {
    width: d - u,
    height: c - l,
    x: u,
    y: l
  };
}
function Sce(e) {
  const {
    width: t,
    height: r
  } = Bx(e);
  return {
    width: t,
    height: r
  };
}
function Cce(e, t, r) {
  const n = Ra(t), i = oa(t), a = r === "fixed", o = Is(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Gi(0);
  function d() {
    l.x = Tf(i);
  }
  if (n || !n && !a)
    if ((Ld(t) !== "body" || o0(i)) && (s = Af(t)), n) {
      const f = Is(t, !0, a, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else i && d();
  a && !n && i && d();
  const c = i && !n && !a ? Wx(i, s) : Gi(0), u = o.left + s.scrollLeft - l.x - c.x, h = o.top + s.scrollTop - l.y - c.y;
  return {
    x: u,
    y: h,
    width: o.width,
    height: o.height
  };
}
function xp(e) {
  return Ni(e).position === "static";
}
function q7(e, t) {
  if (!Ra(e) || Ni(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return oa(e) === r && (r = r.ownerDocument.body), r;
}
function Kx(e, t) {
  const r = Bn(e);
  if (Cf(e))
    return r;
  if (!Ra(e)) {
    let i = Oo(e);
    for (; i && !hd(i); ) {
      if (Pi(i) && !xp(i))
        return i;
      i = Oo(i);
    }
    return r;
  }
  let n = q7(e, t);
  for (; n && hce(n) && xp(n); )
    n = q7(n, t);
  return n && hd(n) && xp(n) && !Ef(n) ? r : n || mce(e) || r;
}
const Ece = async function(e) {
  const t = this.getOffsetParent || Kx, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: Cce(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Ace(e) {
  return Ni(e).direction === "rtl";
}
const S1 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yce,
  getDocumentElement: oa,
  getClippingRect: xce,
  getOffsetParent: Kx,
  getElementRects: Ece,
  getClientRects: bce,
  getDimensions: Sce,
  getScale: ql,
  isElement: Pi,
  isRTL: Ace
};
function Gx(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Tce(e, t) {
  let r = null, n;
  const i = oa(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const d = e.getBoundingClientRect(), {
      left: c,
      top: u,
      width: h,
      height: f
    } = d;
    if (s || t(), !h || !f)
      return;
    const p = Z0(u), m = Z0(i.clientWidth - (c + h)), y = Z0(i.clientHeight - (u + f)), v = Z0(c), $ = {
      rootMargin: -p + "px " + -m + "px " + -y + "px " + -v + "px",
      threshold: zn(0, Ao(1, l)) || 1
    };
    let _ = !0;
    function x(S) {
      const A = S[0].intersectionRatio;
      if (A !== l) {
        if (!_)
          return o();
        A ? o(!1, A) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !Gx(d, e.getBoundingClientRect()) && o(), _ = !1;
    }
    try {
      r = new IntersectionObserver(x, {
        ...$,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(x, $);
    }
    r.observe(e);
  }
  return o(!0), a;
}
function Oce(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, d = nv(e), c = i || a ? [...d ? Au(d) : [], ...t ? Au(t) : []] : [];
  c.forEach((v) => {
    i && v.addEventListener("scroll", r, {
      passive: !0
    }), a && v.addEventListener("resize", r);
  });
  const u = d && s ? Tce(d, r) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === d && f && t && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var $;
      ($ = f) == null || $.observe(t);
    })), r();
  }), d && !l && f.observe(d), t && f.observe(t));
  let p, m = l ? Is(e) : null;
  l && y();
  function y() {
    const v = Is(e);
    m && !Gx(m, v) && r(), m = v, p = requestAnimationFrame(y);
  }
  return r(), () => {
    var v;
    c.forEach((b) => {
      i && b.removeEventListener("scroll", r), a && b.removeEventListener("resize", r);
    }), u?.(), (v = f) == null || v.disconnect(), f = null, l && cancelAnimationFrame(p);
  };
}
const Ice = dce, Pce = cce, Nce = oce, B7 = uce, Dce = ace, Mce = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: S1,
    ...r
  }, a = {
    ...i.platform,
    _c: n
  };
  return ice(e, t, {
    ...i,
    platform: a
  });
};
function Rce(e) {
  return Lce(e);
}
function Sp(e) {
  return e.assignedSlot ? e.assignedSlot : e.parentNode instanceof ShadowRoot ? e.parentNode.host : e.parentNode;
}
function Lce(e) {
  for (let t = e; t; t = Sp(t))
    if (t instanceof Element && getComputedStyle(t).display === "none")
      return null;
  for (let t = Sp(e); t; t = Sp(t)) {
    if (!(t instanceof Element))
      continue;
    const r = getComputedStyle(t);
    if (r.display !== "contents" && (r.position !== "static" || Ef(r) || t.tagName === "BODY"))
      return t;
  }
  return null;
}
function Fce(e) {
  return e !== null && typeof e == "object" && "getBoundingClientRect" in e && ("contextElement" in e ? e.contextElement instanceof Element : !0);
}
var Wt = class extends fn {
  constructor() {
    super(...arguments), this.localize = new Do(this), this.active = !1, this.placement = "top", this.strategy = "absolute", this.distance = 0, this.skidding = 0, this.arrow = !1, this.arrowPlacement = "anchor", this.arrowPadding = 10, this.flip = !1, this.flipFallbackPlacements = "", this.flipFallbackStrategy = "best-fit", this.flipPadding = 0, this.shift = !1, this.shiftPadding = 0, this.autoSizePadding = 0, this.hoverBridge = !1, this.updateHoverBridge = () => {
      if (this.hoverBridge && this.anchorEl) {
        const e = this.anchorEl.getBoundingClientRect(), t = this.popup.getBoundingClientRect(), r = this.placement.includes("top") || this.placement.includes("bottom");
        let n = 0, i = 0, a = 0, o = 0, s = 0, l = 0, d = 0, c = 0;
        r ? e.top < t.top ? (n = e.left, i = e.bottom, a = e.right, o = e.bottom, s = t.left, l = t.top, d = t.right, c = t.top) : (n = t.left, i = t.bottom, a = t.right, o = t.bottom, s = e.left, l = e.top, d = e.right, c = e.top) : e.left < t.left ? (n = e.right, i = e.top, a = t.left, o = t.top, s = e.right, l = e.bottom, d = t.left, c = t.bottom) : (n = t.right, i = t.top, a = e.left, o = e.top, s = t.right, l = t.bottom, d = e.left, c = e.bottom), this.style.setProperty("--hover-bridge-top-left-x", `${n}px`), this.style.setProperty("--hover-bridge-top-left-y", `${i}px`), this.style.setProperty("--hover-bridge-top-right-x", `${a}px`), this.style.setProperty("--hover-bridge-top-right-y", `${o}px`), this.style.setProperty("--hover-bridge-bottom-left-x", `${s}px`), this.style.setProperty("--hover-bridge-bottom-left-y", `${l}px`), this.style.setProperty("--hover-bridge-bottom-right-x", `${d}px`), this.style.setProperty("--hover-bridge-bottom-right-y", `${c}px`);
      }
    };
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.start();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.stop();
  }
  async updated(e) {
    super.updated(e), e.has("active") && (this.active ? this.start() : this.stop()), e.has("anchor") && this.handleAnchorChange(), this.active && (await this.updateComplete, this.reposition());
  }
  async handleAnchorChange() {
    if (await this.stop(), this.anchor && typeof this.anchor == "string") {
      const e = this.getRootNode();
      this.anchorEl = e.getElementById(this.anchor);
    } else this.anchor instanceof Element || Fce(this.anchor) ? this.anchorEl = this.anchor : this.anchorEl = this.querySelector('[slot="anchor"]');
    this.anchorEl instanceof HTMLSlotElement && (this.anchorEl = this.anchorEl.assignedElements({ flatten: !0 })[0]), this.anchorEl && this.active && this.start();
  }
  start() {
    !this.anchorEl || !this.active || (this.cleanup = Oce(this.anchorEl, this.popup, () => {
      this.reposition();
    }));
  }
  async stop() {
    return new Promise((e) => {
      this.cleanup ? (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement"), this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height"), requestAnimationFrame(() => e())) : e();
    });
  }
  /** Forces the popup to recalculate and reposition itself. */
  reposition() {
    if (!this.active || !this.anchorEl)
      return;
    const e = [
      // The offset middleware goes first
      Ice({ mainAxis: this.distance, crossAxis: this.skidding })
    ];
    this.sync ? e.push(
      B7({
        apply: ({ rects: r }) => {
          const n = this.sync === "width" || this.sync === "both", i = this.sync === "height" || this.sync === "both";
          this.popup.style.width = n ? `${r.reference.width}px` : "", this.popup.style.height = i ? `${r.reference.height}px` : "";
        }
      })
    ) : (this.popup.style.width = "", this.popup.style.height = ""), this.flip && e.push(
      Nce({
        boundary: this.flipBoundary,
        // @ts-expect-error - We're converting a string attribute to an array here
        fallbackPlacements: this.flipFallbackPlacements,
        fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
        padding: this.flipPadding
      })
    ), this.shift && e.push(
      Pce({
        boundary: this.shiftBoundary,
        padding: this.shiftPadding
      })
    ), this.autoSize ? e.push(
      B7({
        boundary: this.autoSizeBoundary,
        padding: this.autoSizePadding,
        apply: ({ availableWidth: r, availableHeight: n }) => {
          this.autoSize === "vertical" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-height", `${n}px`) : this.style.removeProperty("--auto-size-available-height"), this.autoSize === "horizontal" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-width", `${r}px`) : this.style.removeProperty("--auto-size-available-width");
        }
      })
    ) : (this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height")), this.arrow && e.push(
      Dce({
        element: this.arrowEl,
        padding: this.arrowPadding
      })
    );
    const t = this.strategy === "absolute" ? (r) => S1.getOffsetParent(r, Rce) : S1.getOffsetParent;
    Mce(this.anchorEl, this.popup, {
      placement: this.placement,
      middleware: e,
      strategy: this.strategy,
      platform: kf(Us({}, S1), {
        getOffsetParent: t
      })
    }).then(({ x: r, y: n, middlewareData: i, placement: a }) => {
      const o = this.localize.dir() === "rtl", s = { top: "bottom", right: "left", bottom: "top", left: "right" }[a.split("-")[0]];
      if (this.setAttribute("data-current-placement", a), Object.assign(this.popup.style, {
        left: `${r}px`,
        top: `${n}px`
      }), this.arrow) {
        const l = i.arrow.x, d = i.arrow.y;
        let c = "", u = "", h = "", f = "";
        if (this.arrowPlacement === "start") {
          const p = typeof l == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          c = typeof d == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "", u = o ? p : "", f = o ? "" : p;
        } else if (this.arrowPlacement === "end") {
          const p = typeof l == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          u = o ? "" : p, f = o ? p : "", h = typeof d == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
        } else this.arrowPlacement === "center" ? (f = typeof l == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "", c = typeof d == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "") : (f = typeof l == "number" ? `${l}px` : "", c = typeof d == "number" ? `${d}px` : "");
        Object.assign(this.arrowEl.style, {
          top: c,
          right: u,
          bottom: h,
          left: f,
          [s]: "calc(var(--arrow-size-diagonal) * -1)"
        });
      }
    }), requestAnimationFrame(() => this.updateHoverBridge()), this.emit("sl-reposition");
  }
  render() {
    return hr`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${Wn({
      "popup-hover-bridge": !0,
      "popup-hover-bridge--visible": this.hoverBridge && this.active
    })}
      ></span>

      <div
        part="popup"
        class=${Wn({
      popup: !0,
      "popup--active": this.active,
      "popup--fixed": this.strategy === "fixed",
      "popup--has-arrow": this.arrow
    })}
      >
        <slot></slot>
        ${this.arrow ? hr`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
  }
};
Wt.styles = [oi, Qde];
q([
  qr(".popup")
], Wt.prototype, "popup", 2);
q([
  qr(".popup__arrow")
], Wt.prototype, "arrowEl", 2);
q([
  de()
], Wt.prototype, "anchor", 2);
q([
  de({ type: Boolean, reflect: !0 })
], Wt.prototype, "active", 2);
q([
  de({ reflect: !0 })
], Wt.prototype, "placement", 2);
q([
  de({ reflect: !0 })
], Wt.prototype, "strategy", 2);
q([
  de({ type: Number })
], Wt.prototype, "distance", 2);
q([
  de({ type: Number })
], Wt.prototype, "skidding", 2);
q([
  de({ type: Boolean })
], Wt.prototype, "arrow", 2);
q([
  de({ attribute: "arrow-placement" })
], Wt.prototype, "arrowPlacement", 2);
q([
  de({ attribute: "arrow-padding", type: Number })
], Wt.prototype, "arrowPadding", 2);
q([
  de({ type: Boolean })
], Wt.prototype, "flip", 2);
q([
  de({
    attribute: "flip-fallback-placements",
    converter: {
      fromAttribute: (e) => e.split(" ").map((t) => t.trim()).filter((t) => t !== ""),
      toAttribute: (e) => e.join(" ")
    }
  })
], Wt.prototype, "flipFallbackPlacements", 2);
q([
  de({ attribute: "flip-fallback-strategy" })
], Wt.prototype, "flipFallbackStrategy", 2);
q([
  de({ type: Object })
], Wt.prototype, "flipBoundary", 2);
q([
  de({ attribute: "flip-padding", type: Number })
], Wt.prototype, "flipPadding", 2);
q([
  de({ type: Boolean })
], Wt.prototype, "shift", 2);
q([
  de({ type: Object })
], Wt.prototype, "shiftBoundary", 2);
q([
  de({ attribute: "shift-padding", type: Number })
], Wt.prototype, "shiftPadding", 2);
q([
  de({ attribute: "auto-size" })
], Wt.prototype, "autoSize", 2);
q([
  de()
], Wt.prototype, "sync", 2);
q([
  de({ type: Object })
], Wt.prototype, "autoSizeBoundary", 2);
q([
  de({ attribute: "auto-size-padding", type: Number })
], Wt.prototype, "autoSizePadding", 2);
q([
  de({ attribute: "hover-bridge", type: Boolean })
], Wt.prototype, "hoverBridge", 2);
var sn = class extends fn {
  constructor() {
    super(), this.localize = new Do(this), this.content = "", this.placement = "top", this.disabled = !1, this.distance = 8, this.open = !1, this.skidding = 0, this.trigger = "hover focus", this.hoist = !1, this.handleBlur = () => {
      this.hasTrigger("focus") && this.hide();
    }, this.handleClick = () => {
      this.hasTrigger("click") && (this.open ? this.hide() : this.show());
    }, this.handleFocus = () => {
      this.hasTrigger("focus") && this.show();
    }, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && (e.stopPropagation(), this.hide());
    }, this.handleMouseOver = () => {
      if (this.hasTrigger("hover")) {
        const e = A7(getComputedStyle(this).getPropertyValue("--show-delay"));
        clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.show(), e);
      }
    }, this.handleMouseOut = () => {
      if (this.hasTrigger("hover")) {
        const e = A7(getComputedStyle(this).getPropertyValue("--hide-delay"));
        clearTimeout(this.hoverTimeout), this.hoverTimeout = window.setTimeout(() => this.hide(), e);
      }
    }, this.addEventListener("blur", this.handleBlur, !0), this.addEventListener("focus", this.handleFocus, !0), this.addEventListener("click", this.handleClick), this.addEventListener("mouseover", this.handleMouseOver), this.addEventListener("mouseout", this.handleMouseOut);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this.closeWatcher) == null || e.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  firstUpdated() {
    this.body.hidden = !this.open, this.open && (this.popup.active = !0, this.popup.reposition());
  }
  hasTrigger(e) {
    return this.trigger.split(" ").includes(e);
  }
  async handleOpenChange() {
    var e, t;
    if (this.open) {
      if (this.disabled)
        return;
      this.emit("sl-show"), "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => {
        this.hide();
      }) : document.addEventListener("keydown", this.handleDocumentKeyDown), await Wi(this.body), this.body.hidden = !1, this.popup.active = !0;
      const { keyframes: r, options: n } = $i(this, "tooltip.show", { dir: this.localize.dir() });
      await ki(this.popup.popup, r, n), this.popup.reposition(), this.emit("sl-after-show");
    } else {
      this.emit("sl-hide"), (t = this.closeWatcher) == null || t.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown), await Wi(this.body);
      const { keyframes: r, options: n } = $i(this, "tooltip.hide", { dir: this.localize.dir() });
      await ki(this.popup.popup, r, n), this.popup.active = !1, this.body.hidden = !0, this.emit("sl-after-hide");
    }
  }
  async handleOptionsChange() {
    this.hasUpdated && (await this.updateComplete, this.popup.reposition());
  }
  handleDisabledChange() {
    this.disabled && this.open && this.hide();
  }
  /** Shows the tooltip. */
  async show() {
    if (!this.open)
      return this.open = !0, Eo(this, "sl-after-show");
  }
  /** Hides the tooltip */
  async hide() {
    if (this.open)
      return this.open = !1, Eo(this, "sl-after-hide");
  }
  //
  // NOTE: Tooltip is a bit unique in that we're using aria-live instead of aria-labelledby to trick screen readers into
  // announcing the content. It works really well, but it violates an accessibility rule. We're also adding the
  // aria-describedby attribute to a slot, which is required by <sl-popup> to correctly locate the first assigned
  // element, otherwise positioning is incorrect.
  //
  render() {
    return hr`
      <sl-popup
        part="base"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${Wn({
      tooltip: !0,
      "tooltip--open": this.open
    })}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        arrow
        hover-bridge
      >
        ${""}
        <slot slot="anchor" aria-describedby="tooltip"></slot>

        ${""}
        <div part="body" id="tooltip" class="tooltip__body" role="tooltip" aria-live=${this.open ? "polite" : "off"}>
          <slot name="content">${this.content}</slot>
        </div>
      </sl-popup>
    `;
  }
};
sn.styles = [oi, Wde];
sn.dependencies = { "sl-popup": Wt };
q([
  qr("slot:not([name])")
], sn.prototype, "defaultSlot", 2);
q([
  qr(".tooltip__body")
], sn.prototype, "body", 2);
q([
  qr("sl-popup")
], sn.prototype, "popup", 2);
q([
  de()
], sn.prototype, "content", 2);
q([
  de()
], sn.prototype, "placement", 2);
q([
  de({ type: Boolean, reflect: !0 })
], sn.prototype, "disabled", 2);
q([
  de({ type: Number })
], sn.prototype, "distance", 2);
q([
  de({ type: Boolean, reflect: !0 })
], sn.prototype, "open", 2);
q([
  de({ type: Number })
], sn.prototype, "skidding", 2);
q([
  de()
], sn.prototype, "trigger", 2);
q([
  de({ type: Boolean })
], sn.prototype, "hoist", 2);
q([
  on("open", { waitUntilFirstUpdate: !0 })
], sn.prototype, "handleOpenChange", 1);
q([
  on(["content", "distance", "hoist", "placement", "skidding"])
], sn.prototype, "handleOptionsChange", 1);
q([
  on("disabled")
], sn.prototype, "handleDisabledChange", 1);
Mi("tooltip.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 150, easing: "ease" }
});
Mi("tooltip.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 150, easing: "ease" }
});
sn.define("sl-tooltip");
si.define("sl-icon");
var Cp = /* @__PURE__ */ ae("<style>"), jce = /* @__PURE__ */ ae("<sl-tooltip><sl-icon name=info-circle>", !0, !1, !1);
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const zce = (e) => {
  const t = it({
    placement: "top",
    maxWidth: "200px"
  }, e);
  return [(() => {
    var r = Cp();
    return L(r, Gn), r;
  })(), (() => {
    var r = Cp();
    return L(r, Ro), r;
  })(), (() => {
    var r = Cp();
    return L(r, Mo), r;
  })(), (() => {
    var r = jce(), n = r.firstChild;
    return r._$owner = Ve(), n._$owner = Ve(), se((i) => {
      var a = t.tip, o = t.placement, s = t.maxWidth;
      return a !== i.e && (r.content = i.e = a), o !== i.t && (r.placement = i.t = o), s !== i.a && ((i.a = s) != null ? r.style.setProperty("--max-width", s) : r.style.removeProperty("--max-width")), i;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), r;
  })()];
};
var Vce = /* @__PURE__ */ ae('<div class="flex items-center space-x-2 text-slate-500">'), Uce = /* @__PURE__ */ ae("<div>"), qce = /* @__PURE__ */ ae('<div><photon-dialog label="Overwrite in progress prescription?"confirm-text="Yes, Overwrite"cancel-text="No, Cancel"><p class="font-sans text-lg xs:text-base">You are editing a prescription that has not been added. This will be overwritten if you edit another prescription.</p></photon-dialog><photon-dialog label="Delete pending prescription?"confirm-text="Yes, Delete"cancel-text="No, Cancel"><p class="font-sans text-lg xs:text-base">Deleting this prescription will remove it from your pending prescriptions. This action cannot be undone.', !0, !1, !1);
const Bce = (e) => {
  const {
    dispatchDraftPrescriptionDeleted: t,
    dispatchAnalyticsTrackEvent: r
  } = Ma(), [n, i] = V(!1), [a, o] = V(!1), [s, l] = V(), [d, c] = V(void 0), [u, h] = V(), {
    selectOtherCoverageOption: f
  } = bf(), {
    draftPrescriptions: p,
    prescriptionIds: m,
    deletePrescription: y,
    isLoadingPrefills: v
  } = Vs(), b = () => {
    const P = d();
    P && P.treatment && (jx(e.actions, P), e.actions.updateFormValue({
      key: "catalogId",
      value: P.catalogId
    }), P.id && y(P.id), e.prescriptionRef?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    }), e.handleDraftPrescriptionsChange());
  }, $ = (P, D) => {
    c(P), e.store.treatment.value ? (o(!0), l(D)) : (e.setIsEditing(!0), b(), D?.(), t(), r("ctaClicked", {
      name: "Draft Prescription Edited"
    }));
  }, _ = (P) => {
    $(Hce(P), () => {
      f(P);
    });
  }, x = () => {
    b(), o(!1), c(void 0), s()?.(), l(void 0), t(), r("ctaClicked", {
      name: "Draft Prescription Edited"
    });
  }, S = () => {
    o(!1), c(void 0), l(void 0);
  }, A = () => {
    const P = u();
    if (P) {
      const D = p().find((T) => T.id === P);
      y(P), t(D), r("ctaClicked", {
        name: "Draft Prescription Deleted"
      });
    }
    i(!1), h(void 0), m().length === 0 && e.setIsEditing(!0), e.handleDraftPrescriptionsChange();
  }, N = () => {
    i(!1), h(void 0);
  };
  return (() => {
    var P = qce(), D = P.firstChild, T = D.nextSibling;
    return Ue(D, "photon-dialog-alt", S), Ue(D, "photon-dialog-canceled", S), Ue(D, "photon-dialog-confirmed", x), D._$owner = Ve(), Ue(T, "photon-dialog-alt", N), Ue(T, "photon-dialog-canceled", N), Ue(T, "photon-dialog-confirmed", A), T._$owner = Ve(), L(P, g(Mn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var I = Vce();
          return L(I, g(Ee, {
            color: "gray",
            class: "pr-2",
            children: "Draft Prescriptions"
          }), null), L(I, g(zce, {
            maxWidth: "300px",
            tip: "Each prescription will include the prescriber's digital signature and the date it was written when the order is sent to the pharmacy."
          }), null), I;
        })(), (() => {
          var I = Uce();
          return L(I, g(_ne, {
            handleDelete: (j) => {
              i(!0), h(j);
            },
            handleEdit: (j) => {
              $(j);
            },
            handleSwapToOtherPrescription: _,
            get screeningAlerts() {
              return e.screeningAlerts;
            },
            get routingConstraints() {
              return e.routingConstraints;
            },
            get enableOrder() {
              return e.enableOrder;
            }
          }), null), L(I, g(H, {
            get when() {
              return At(() => !!e.onAddAnotherClick)() && !v();
            },
            get children() {
              return g(xt, {
                variant: "secondary",
                class: "w-full xs:w-fit mt-5",
                size: "lg",
                get onClick() {
                  return e.onAddAnotherClick;
                },
                children: "Add another"
              });
            }
          }), null), I;
        })()];
      }
    }), null), se((I) => {
      var j = a(), F = n();
      return j !== I.e && (D.open = I.e = j), F !== I.t && (T.open = I.t = F), I;
    }, {
      e: void 0,
      t: void 0
    }), P;
  })();
};
function Hce(e) {
  return {
    // re-using the prescriptionId (via coverageOption.prescriptionId) of the original Prescription
    // so that the edit flow will remove it from the list of prescriptions
    id: e.prescriptionId,
    doNotFillBeforeDate: void 0,
    dispenseAsWritten: !1,
    dispenseQuantity: e.dispenseQuantity,
    dispenseUnit: e.dispenseUnit,
    daysSupply: e.daysSupply,
    instructions: "",
    notes: "",
    fillsAllowed: void 0,
    diagnoseCodes: [],
    externalId: void 0,
    catalogId: void 0,
    treatment: {
      id: e.treatment.id,
      name: e.treatment.name
    }
  };
}
const Fo = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}input:where([type=text]),input:where(:not([type])),input:where([type=email]),input:where([type=url]),input:where([type=password]),input:where([type=number]),input:where([type=date]),input:where([type=datetime-local]),input:where([type=month]),input:where([type=search]),input:where([type=tel]),input:where([type=time]),input:where([type=week]),select:where([multiple]),textarea,select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-width:1px;border-radius:0;padding:.5rem .75rem;font-size:1rem;line-height:1.5rem;--tw-shadow: 0 0 #0000}input:where([type=text]):focus,input:where(:not([type])):focus,input:where([type=email]):focus,input:where([type=url]):focus,input:where([type=password]):focus,input:where([type=number]):focus,input:where([type=date]):focus,input:where([type=datetime-local]):focus,input:where([type=month]):focus,input:where([type=search]):focus,input:where([type=tel]):focus,input:where([type=time]):focus,input:where([type=week]):focus,select:where([multiple]):focus,textarea:focus,select:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: #175CD3;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);border-color:#175cd3}input::-moz-placeholder,textarea::-moz-placeholder{color:#6b7280;opacity:1}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}select{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact;print-color-adjust:exact}select:where([multiple]),select:where([size]:not([size="1"])){background-image:initial;background-position:initial;background-repeat:unset;background-size:initial;padding-right:.75rem;-webkit-print-color-adjust:unset;print-color-adjust:unset}input:where([type=checkbox]),input:where([type=radio]){-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:inline-block;vertical-align:middle;background-origin:border-box;-webkit-user-select:none;-moz-user-select:none;user-select:none;flex-shrink:0;height:1rem;width:1rem;color:#175cd3;background-color:#fff;border-color:#6b7280;border-width:1px;--tw-shadow: 0 0 #0000}input:where([type=checkbox]){border-radius:0}input:where([type=radio]){border-radius:100%}input:where([type=checkbox]):focus,input:where([type=radio]):focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 2px;--tw-ring-offset-color: #fff;--tw-ring-color: #175CD3;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}input:where([type=checkbox]):checked,input:where([type=radio]):checked{border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}input:where([type=checkbox]):checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")}@media(forced-colors:active){input:where([type=checkbox]):checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}input:where([type=radio]):checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e")}@media(forced-colors:active){input:where([type=radio]):checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}input:where([type=checkbox]):checked:hover,input:where([type=checkbox]):checked:focus,input:where([type=radio]):checked:hover,input:where([type=radio]):checked:focus{border-color:transparent;background-color:currentColor}input:where([type=checkbox]):indeterminate{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e");border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}@media(forced-colors:active){input:where([type=checkbox]):indeterminate{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}input:where([type=checkbox]):indeterminate:hover,input:where([type=checkbox]):indeterminate:focus{border-color:transparent;background-color:currentColor}input:where([type=file]){background:unset;border-color:inherit;border-width:0;border-radius:0;padding:0;font-size:unset;line-height:inherit}input:where([type=file]):focus{outline:1px solid ButtonText;outline:1px auto -webkit-focus-ring-color}h1,h2,h3,h4,h5,h6,p,div,li,a,ul,input{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-weight:400;line-height:1.625}body,html{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}h1,h2,h3,h4,h5,h6,label{font-weight:500;line-height:1.25}h1{font-size:1.875rem;line-height:2.25rem;margin-top:.5rem;margin-bottom:.5rem}h2{font-size:1.5rem;line-height:2rem;margin-top:.5rem;margin-bottom:.5rem}h3{font-size:1.25rem;line-height:1.75rem;margin-top:.25rem;margin-bottom:.25rem}h4{font-size:1.125rem;line-height:1.75rem;margin-top:.25rem;margin-bottom:.25rem}h5{font-size:1rem;line-height:1.5rem;margin-top:.25rem;margin-bottom:.25rem}h6,label{font-size:.875rem;line-height:1.25rem;margin-top:.25rem;margin-bottom:.25rem}p{margin-top:.5rem;margin-bottom:.5rem}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(21 112 239 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media(min-width:640px){.container{max-width:640px}}@media(min-width:768px){.container{max-width:768px}}@media(min-width:1024px){.container{max-width:1024px}}@media(min-width:1280px){.container{max-width:1280px}}@media(min-width:1536px){.container{max-width:1536px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.invisible{visibility:hidden}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.inset-y-0{top:0;bottom:0}.-bottom-8{bottom:-2rem}.bottom-full{bottom:100%}.left-0{left:0}.right-0{right:0}.right-8{right:2rem}.top-0{top:0}.top-full{top:100%}.isolate{isolation:isolate}.z-10{z-index:10}.z-100{z-index:100}.z-20{z-index:20}.z-50{z-index:50}.col-span-2{grid-column:span 2/span 2}.col-span-3{grid-column:span 3/span 3}.m-0{margin:0}.m-auto{margin:auto}.-mx-4{margin-left:-1rem;margin-right:-1rem}.-my-2{margin-top:-.5rem;margin-bottom:-.5rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.mx-auto{margin-left:auto;margin-right:auto}.my-8{margin-top:2rem;margin-bottom:2rem}.my-px{margin-top:1px;margin-bottom:1px}.-mb-px{margin-bottom:-1px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:.25rem}.mb-10{margin-bottom:2.5rem}.mb-2{margin-bottom:.5rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-0{margin-left:0}.ml-0\\.5{margin-left:.125rem}.ml-1{margin-left:.25rem}.ml-2{margin-left:.5rem}.ml-3{margin-left:.75rem}.ml-auto{margin-left:auto}.mr-1{margin-right:.25rem}.mr-2{margin-right:.5rem}.mr-4{margin-right:1rem}.mt-0{margin-top:0}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-3{margin-top:.75rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-8{margin-top:2rem}.box-border{box-sizing:border-box}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.flow-root{display:flow-root}.grid{display:grid}.contents{display:contents}.hidden{display:none}.h-10{height:2.5rem}.h-12{height:3rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-px{height:1px}.max-h-60{max-height:15rem}.max-h-80{max-height:20rem}.min-h-full{min-height:100%}.w-10{width:2.5rem}.w-12{width:3rem}.w-20{width:5rem}.w-4{width:1rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-8{width:2rem}.w-96{width:24rem}.w-full{width:100%}.w-max{width:-moz-max-content;width:max-content}.min-w-0{min-width:0px}.min-w-full{min-width:100%}.max-w-lg{max-width:32rem}.max-w-md{max-width:28rem}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-auto{flex:1 1 auto}.flex-shrink-0,.shrink-0{flex-shrink:0}.grow{flex-grow:1}.table-auto{table-layout:auto}.table-fixed{table-layout:fixed}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-help{cursor:help}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.touch-pan-y{--tw-pan-y: pan-y;touch-action:var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom)}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize-none{resize:none}.resize-y{resize:vertical}.resize{resize:both}.grid-flow-col{grid-auto-flow:column}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-subgrid{grid-template-columns:subgrid}.flex-col{flex-direction:column}.place-items-start{place-items:start}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-stretch{align-items:stretch}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-6{gap:1.5rem}.gap-8{gap:2rem}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.gap-x-3{-moz-column-gap:.75rem;column-gap:.75rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-y-10{row-gap:2.5rem}.gap-y-4{row-gap:1rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * (1 - var(--tw-space-x-reverse)))}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * (1 - var(--tw-space-x-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.75rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(.75rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.space-y-5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.25rem * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.25rem * var(--tw-space-y-reverse))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * (1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-gray-200>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(229,231,235,var(--tw-divide-opacity))}.divide-gray-300>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(209,213,219,var(--tw-divide-opacity))}.self-center{align-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.text-pretty{text-wrap:pretty}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-xl{border-radius:.75rem}.rounded-r-md{border-top-right-radius:.375rem;border-bottom-right-radius:.375rem}.border{border-width:1px}.border-0{border-width:0px}.border-2{border-width:2px}.border-b{border-bottom-width:1px}.border-b-2{border-bottom-width:2px}.border-t{border-top-width:1px}.border-solid{border-style:solid}.border-blue-200{--tw-border-opacity: 1;border-color:rgb(132,202,255,var(--tw-border-opacity))}.border-blue-300{--tw-border-opacity: 1;border-color:rgb(83,177,253,var(--tw-border-opacity))}.border-blue-400{--tw-border-opacity: 1;border-color:rgb(46,144,250,var(--tw-border-opacity))}.border-blue-500{--tw-border-opacity: 1;border-color:rgb(21,112,239,var(--tw-border-opacity))}.border-blue-600{--tw-border-opacity: 1;border-color:rgb(23,92,211,var(--tw-border-opacity))}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229,231,235,var(--tw-border-opacity))}.border-gray-300{--tw-border-opacity: 1;border-color:rgb(209,213,219,var(--tw-border-opacity))}.border-green-200{--tw-border-opacity: 1;border-color:rgb(187,247,208,var(--tw-border-opacity))}.border-green-300{--tw-border-opacity: 1;border-color:rgb(134,239,172,var(--tw-border-opacity))}.border-green-400{--tw-border-opacity: 1;border-color:rgb(74,222,128,var(--tw-border-opacity))}.border-green-600{--tw-border-opacity: 1;border-color:rgb(22,163,74,var(--tw-border-opacity))}.border-indigo-300{--tw-border-opacity: 1;border-color:rgb(165,180,252,var(--tw-border-opacity))}.border-pink-300{--tw-border-opacity: 1;border-color:rgb(249,168,212,var(--tw-border-opacity))}.border-purple-300{--tw-border-opacity: 1;border-color:rgb(216,180,254,var(--tw-border-opacity))}.border-red-200{--tw-border-opacity: 1;border-color:rgb(254,202,202,var(--tw-border-opacity))}.border-red-300{--tw-border-opacity: 1;border-color:rgb(252,165,165,var(--tw-border-opacity))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity))}.border-red-600{--tw-border-opacity: 1;border-color:rgb(220,38,38,var(--tw-border-opacity))}.border-slate-600{--tw-border-opacity: 1;border-color:rgb(71,85,105,var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-yellow-200{--tw-border-opacity: 1;border-color:rgb(254,240,138,var(--tw-border-opacity))}.border-yellow-300{--tw-border-opacity: 1;border-color:rgb(253,224,71,var(--tw-border-opacity))}.border-yellow-600{--tw-border-opacity: 1;border-color:rgb(202,138,4,var(--tw-border-opacity))}.bg-\\[\\#FFFAEB\\]{--tw-bg-opacity: 1;background-color:rgb(255,250,235,var(--tw-bg-opacity))}.bg-blue-100{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.bg-blue-50{--tw-bg-opacity: 1;background-color:rgb(209,233,255,var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(21,112,239,var(--tw-bg-opacity))}.bg-blue-600{--tw-bg-opacity: 1;background-color:rgb(23,92,211,var(--tw-bg-opacity))}.bg-gray-100{--tw-bg-opacity: 1;background-color:rgb(243,244,246,var(--tw-bg-opacity))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.bg-gray-500{--tw-bg-opacity: 1;background-color:rgb(107,114,128,var(--tw-bg-opacity))}.bg-gray-900{--tw-bg-opacity: 1;background-color:rgb(17,24,39,var(--tw-bg-opacity))}.bg-green-100{--tw-bg-opacity: 1;background-color:rgb(220,252,231,var(--tw-bg-opacity))}.bg-green-50{--tw-bg-opacity: 1;background-color:rgb(240,253,244,var(--tw-bg-opacity))}.bg-indigo-100{--tw-bg-opacity: 1;background-color:rgb(224,231,255,var(--tw-bg-opacity))}.bg-pink-100{--tw-bg-opacity: 1;background-color:rgb(252,231,243,var(--tw-bg-opacity))}.bg-purple-100{--tw-bg-opacity: 1;background-color:rgb(243,232,255,var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254,226,226,var(--tw-bg-opacity))}.bg-red-50{--tw-bg-opacity: 1;background-color:rgb(254,242,242,var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity: 1;background-color:rgb(239,68,68,var(--tw-bg-opacity))}.bg-slate-100{--tw-bg-opacity: 1;background-color:rgb(241,245,249,var(--tw-bg-opacity))}.bg-slate-50{--tw-bg-opacity: 1;background-color:rgb(248,250,252,var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255,255,255,var(--tw-bg-opacity))}.bg-yellow-100{--tw-bg-opacity: 1;background-color:rgb(254,249,195,var(--tw-bg-opacity))}.bg-yellow-50{--tw-bg-opacity: 1;background-color:rgb(254,252,232,var(--tw-bg-opacity))}.bg-opacity-75{--tw-bg-opacity: .75}.fill-blue-500{fill:#1570ef}.fill-green-500{fill:#22c55e}.p-0{padding:0}.p-2{padding:.5rem}.p-4{padding:1rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-3\\.5{padding-left:.875rem;padding-right:.875rem}.px-4{padding-left:1rem;padding-right:1rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-2\\.5{padding-top:.625rem;padding-bottom:.625rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-3\\.5{padding-top:.875rem;padding-bottom:.875rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-1{padding-bottom:.25rem}.pl-10{padding-left:2.5rem}.pl-3{padding-left:.75rem}.pr-2{padding-right:.5rem}.pr-3{padding-right:.75rem}.pr-4{padding-right:1rem}.pt-2{padding-top:.5rem}.pt-4{padding-top:1rem}.text-left{text-align:left}.text-center{text-align:center}.text-end{text-align:end}.align-top{vertical-align:top}.align-middle{vertical-align:middle}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-sm\\/6{font-size:.875rem;line-height:1.5rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.italic{font-style:italic}.leading-6{line-height:1.5rem}.leading-none{line-height:1}.leading-snug{line-height:1.375}.text-\\[\\#DC6803\\]{--tw-text-opacity: 1;color:rgb(220,104,3,var(--tw-text-opacity))}.text-black{--tw-text-opacity: 1;color:rgb(0,0,0,var(--tw-text-opacity))}.text-blue-500{--tw-text-opacity: 1;color:rgb(21,112,239,var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.text-blue-700{--tw-text-opacity: 1;color:rgb(24,73,169,var(--tw-text-opacity))}.text-blue-800{--tw-text-opacity: 1;color:rgb(25,65,133,var(--tw-text-opacity))}.text-blue-900{--tw-text-opacity: 1;color:rgb(16,42,86,var(--tw-text-opacity))}.text-current{color:currentColor}.text-gray-200{--tw-text-opacity: 1;color:rgb(229,231,235,var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.text-gray-50{--tw-text-opacity: 1;color:rgb(249,250,251,var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.text-gray-900{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}.text-green-500{--tw-text-opacity: 1;color:rgb(34,197,94,var(--tw-text-opacity))}.text-green-600{--tw-text-opacity: 1;color:rgb(22,163,74,var(--tw-text-opacity))}.text-green-700{--tw-text-opacity: 1;color:rgb(21,128,61,var(--tw-text-opacity))}.text-green-800{--tw-text-opacity: 1;color:rgb(22,101,52,var(--tw-text-opacity))}.text-indigo-700{--tw-text-opacity: 1;color:rgb(67,56,202,var(--tw-text-opacity))}.text-pink-700{--tw-text-opacity: 1;color:rgb(190,24,93,var(--tw-text-opacity))}.text-purple-700{--tw-text-opacity: 1;color:rgb(126,34,206,var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.text-red-600{--tw-text-opacity: 1;color:rgb(220,38,38,var(--tw-text-opacity))}.text-red-700{--tw-text-opacity: 1;color:rgb(185,28,28,var(--tw-text-opacity))}.text-red-800{--tw-text-opacity: 1;color:rgb(153,27,27,var(--tw-text-opacity))}.text-slate-500{--tw-text-opacity: 1;color:rgb(100,116,139,var(--tw-text-opacity))}.text-slate-600{--tw-text-opacity: 1;color:rgb(71,85,105,var(--tw-text-opacity))}.text-transparent{color:transparent}.text-white{--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.text-yellow-600{--tw-text-opacity: 1;color:rgb(202,138,4,var(--tw-text-opacity))}.text-yellow-800{--tw-text-opacity: 1;color:rgb(133,77,14,var(--tw-text-opacity))}.underline{text-decoration-line:underline}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-35{opacity:.35}.opacity-50{opacity:.5}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)),var(--tw-shadow)}.ring-1{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.ring-2{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.ring-inset{--tw-ring-inset: inset}.ring-black{--tw-ring-opacity: 1;--tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity))}.ring-blue-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(83 177 253 / var(--tw-ring-opacity))}.ring-gray-200{--tw-ring-opacity: 1;--tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity))}.ring-gray-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity))}.ring-gray-900\\/5{--tw-ring-color: rgb(17 24 39 / .05)}.ring-red-300{--tw-ring-opacity: 1;--tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity))}.ring-sky-500\\/40{--tw-ring-color: rgb(14 165 233 / .4)}.ring-opacity-5{--tw-ring-opacity: .05}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-100{transition-duration:.1s}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.theme-photon,[data-theme=photon]{--twc-primaryText: 210 20% 98%;--twc-primary500: 238.70000000000005 83.5% 66.7%;--twc-primary600: 243.39999999999998 75.4% 58.6%;--twc-secondaryText: 220.89999999999998 39.3% 11%;--twc-secondary50: 225.89999999999998 100% 96.7%;--twc-secondary100: 226.5 100% 93.9%}.theme-weekend,[data-theme=weekend]{--twc-primaryText: 210 20% 98%;--twc-primary500: 198.60000000000002 88.7% 48.4%;--twc-primary600: 200.39999999999998 98% 39.4%;--twc-secondaryText: 220.89999999999998 39.3% 11%;--twc-secondary50: 204 100% 97.1%;--twc-secondary100: 204 93.8% 93.7%}.\\[overflow-wrap\\:anywhere\\]{overflow-wrap:anywhere}@keyframes animateEnter{0%{transform:translate3d(0,-20%,0) scale(.8);opacity:.5}to{transform:translateZ(0) scale(1);opacity:1}}@keyframes animateLeave{0%{transform:translateZ(-1px) scale(1);opacity:1}to{transform:translate3d(0,-20%,-1px) scale(.8);opacity:0}}.animate-enter{animation:animateEnter .2s cubic-bezier(.21,1.02,.73,1) forwards}.animate-leave{animation:animateLeave .2s cubic-bezier(.06,.71,.55,1) forwards}.placeholder\\:text-gray-400::-moz-placeholder{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.placeholder\\:text-gray-400::placeholder{--tw-text-opacity: 1;color:rgb(156,163,175,var(--tw-text-opacity))}.placeholder\\:text-red-300::-moz-placeholder{--tw-text-opacity: 1;color:rgb(252,165,165,var(--tw-text-opacity))}.placeholder\\:text-red-300::placeholder{--tw-text-opacity: 1;color:rgb(252,165,165,var(--tw-text-opacity))}.even\\:bg-gray-50:nth-child(2n){--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.hover\\:border-gray-300:hover{--tw-border-opacity: 1;border-color:rgb(209,213,219,var(--tw-border-opacity))}.hover\\:bg-blue-100:hover{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.hover\\:bg-blue-50:hover{--tw-bg-opacity: 1;background-color:rgb(209,233,255,var(--tw-bg-opacity))}.hover\\:bg-blue-600:hover{--tw-bg-opacity: 1;background-color:rgb(23,92,211,var(--tw-bg-opacity))}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249,250,251,var(--tw-bg-opacity))}.hover\\:bg-red-600:hover{--tw-bg-opacity: 1;background-color:rgb(220,38,38,var(--tw-bg-opacity))}.hover\\:text-amber-500:hover{--tw-text-opacity: 1;color:rgb(245,158,11,var(--tw-text-opacity))}.hover\\:text-blue-500:hover{--tw-text-opacity: 1;color:rgb(21,112,239,var(--tw-text-opacity))}.hover\\:text-gray-500:hover{--tw-text-opacity: 1;color:rgb(107,114,128,var(--tw-text-opacity))}.hover\\:text-gray-600:hover{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.hover\\:text-gray-900:hover{--tw-text-opacity: 1;color:rgb(17,24,39,var(--tw-text-opacity))}.hover\\:text-red-500:hover{--tw-text-opacity: 1;color:rgb(239,68,68,var(--tw-text-opacity))}.hover\\:ring-gray-400:hover{--tw-ring-opacity: 1;--tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:outline-0:focus{outline-width:0px}.focus\\:ring-1:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 rgba(0, 0, 0, 0))}.focus\\:ring-inset:focus{--tw-ring-inset: inset}.focus\\:ring-blue-300:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(83 177 253 / var(--tw-ring-opacity))}.focus\\:ring-blue-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(21 112 239 / var(--tw-ring-opacity))}.focus\\:ring-blue-600:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(23 92 211 / var(--tw-ring-opacity))}.focus\\:ring-gray-300:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity))}.focus\\:ring-red-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity))}.focus\\:ring-sky-500\\/40:focus{--tw-ring-color: rgb(14 165 233 / .4)}.focus\\:ring-offset-2:focus{--tw-ring-offset-width: 2px}.focus-visible\\:outline:focus-visible{outline-style:solid}.focus-visible\\:outline-2:focus-visible{outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.active\\:bg-gray-100:active{--tw-bg-opacity: 1;background-color:rgb(243,244,246,var(--tw-bg-opacity))}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:hover\\:bg-transparent:hover:disabled{background-color:transparent}.disabled\\:hover\\:text-gray-700:hover:disabled{--tw-text-opacity: 1;color:rgb(55,65,81,var(--tw-text-opacity))}.group:hover .group-hover\\:bg-blue-100{--tw-bg-opacity: 1;background-color:rgb(178,221,255,var(--tw-bg-opacity))}.group:hover .group-hover\\:text-blue-600{--tw-text-opacity: 1;color:rgb(23,92,211,var(--tw-text-opacity))}.group:hover .group-hover\\:text-blue-900{--tw-text-opacity: 1;color:rgb(16,42,86,var(--tw-text-opacity))}.group:hover .group-hover\\:opacity-100{opacity:1}@media(min-width:640px){.sm\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.sm\\:my-8{margin-top:2rem;margin-bottom:2rem}.sm\\:mt-5{margin-top:1.25rem}.sm\\:mt-6{margin-top:1.5rem}.sm\\:block{display:block}.sm\\:grid{display:grid}.sm\\:hidden{display:none}.sm\\:w-auto{width:auto}.sm\\:max-w-lg{max-width:32rem}.sm\\:max-w-md{max-width:28rem}.sm\\:max-w-sm{max-width:24rem}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:items-center{align-items:center}.sm\\:gap-2{gap:.5rem}.sm\\:gap-4{gap:1rem}.sm\\:space-x-6>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1.5rem * var(--tw-space-x-reverse));margin-left:calc(1.5rem * (1 - var(--tw-space-x-reverse)))}.sm\\:p-0{padding:0}.sm\\:p-6{padding:1.5rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}.sm\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:py-4{padding-top:1rem;padding-bottom:1rem}.sm\\:pr-6{padding-right:1.5rem}.sm\\:pt-6{padding-top:1.5rem}.sm\\:text-base{font-size:1rem;line-height:1.5rem}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:leading-6{line-height:1.5rem}}@media(min-width:768px){.md\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:items-center{align-items:center}.md\\:gap-1{gap:.25rem}.md\\:space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(2rem * var(--tw-space-x-reverse));margin-left:calc(2rem * (1 - var(--tw-space-x-reverse)))}.md\\:text-right{text-align:right}}@media(min-width:1024px){.lg\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.lg\\:px-8{padding-left:2rem;padding-right:2rem}}@media(prefers-color-scheme:dark){.dark\\:bg-gray-700{--tw-bg-opacity: 1;background-color:rgb(55,65,81,var(--tw-bg-opacity))}.dark\\:text-gray-600{--tw-text-opacity: 1;color:rgb(75,85,99,var(--tw-text-opacity))}}`;
var Wce = /* @__PURE__ */ ae('<div class="flex items-center justify-between">'), Qce = /* @__PURE__ */ ae("<div><style>");
const Kce = (e) => e ? !!(e.street1?.trim() && e.city?.trim() && e.state?.trim() && e.postalCode?.trim()) : !1, Gce = (e) => {
  const t = K(() => e.store.patient?.value ? [e.store.patient?.value?.id] : []), r = K(() => {
    const n = e.store.address?.value ?? e.store.patient?.value?.address;
    return Kce(n) ? `${n.street1} ${n.street2 || ""} ${n.city}, ${n.state} ${n.postalCode}` : "";
  });
  return (() => {
    var n = Qce(), i = n.firstChild;
    return L(i, Fo), L(n, g(Mn, {
      addChildrenDivider: !0,
      get children() {
        return [(() => {
          var a = Wce();
          return L(a, g(Ee, {
            color: "gray",
            children: "Select Pharmacy"
          })), a;
        })(), g(lae, {
          get patientIds() {
            return t();
          },
          get address() {
            return r();
          },
          get hasPreferredPharmacy() {
            return !!e.store.patient?.value?.preferredPharmacies?.length;
          }
        })];
      }
    }), null), n;
  })();
}, H7 = Ie`
  fragment PatientOrderFields on Patient {
    id
    externalId
    name {
      full
      first
      middle
      last
      title
    }
    dateOfBirth
    sex
    gender
    email
    phone
    address {
      id
      name {
        full
      }
      city
      country
      postalCode
      state
      street1
      street2
    }
    preferredPharmacies {
      id
      name
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
      phone
    }
  }
`, Zce = () => {
  const [e, t] = _f({
    patients: {
      data: [],
      errors: [],
      isLoading: !1,
      finished: !1
    },
    selectedPatient: {
      data: void 0,
      errors: [],
      isLoading: !1
    }
  }), r = async (s, l) => {
    t("selectedPatient", {
      ...e.selectedPatient,
      isLoading: !0
    });
    const { data: d, errors: c } = await s.clinical.patient.getPatient({
      id: l,
      fragment: {
        PatientOrderFields: H7
      }
    });
    t("selectedPatient", {
      ...e.selectedPatient,
      isLoading: !1,
      data: d.patient,
      errors: c
    });
  }, n = async (s, l) => {
    l || (l = {}), t("patients", {
      ...e.patients,
      isLoading: !0
    });
    const { data: d, errors: c } = await s.clinical.patient.getPatients({
      first: l.first,
      name: l.name,
      fragment: {
        PatientOrderFields: H7
      }
    });
    return t("patients", {
      ...e.patients,
      isLoading: !1,
      errors: c,
      data: d.patients,
      finished: d.patients.length === 0
    }), (!c || c.length === 0) && d.patients.length > 0 ? () => i(s, {
      ...l,
      after: d.patients?.at(-1).id
    }) : void 0;
  }, i = async (s, l) => {
    t("patients", {
      ...e.patients,
      isLoading: !0
    });
    const { data: d, errors: c } = await s.clinical.patient.getPatients(l);
    return t("patients", {
      ...e.patients,
      isLoading: !1,
      errors: c,
      data: [...e.patients.data, ...d.patients],
      finished: d.patients.length === 0
    }), (!c || c.length === 0) && d.patients.length > 0 ? () => i(s, {
      ...l,
      after: d.patients?.at(-1).id
    }) : void 0;
  };
  return {
    store: e,
    actions: {
      getPatients: n,
      getSelectedPatient: r,
      clearSelectedPatient: async () => {
        t("selectedPatient", {
          ...e.selectedPatient,
          data: void 0
        });
      },
      reset: async () => {
        t("patients", {
          data: [],
          errors: [],
          isLoading: !1,
          finished: !1
        }), t("selectedPatient", {
          data: void 0,
          errors: [],
          isLoading: !1
        });
      }
    }
  };
}, Of = Zce();
var Yce = /* @__PURE__ */ ae('<div class="flex items-center justify-between">'), Jce = /* @__PURE__ */ ae("<div><photon-patient-dialog>", !0, !1, !1), Xce = /* @__PURE__ */ ae("<div><photon-add-medication-history-dialog>", !0, !1, !1), eue = /* @__PURE__ */ ae('<div class="flex flex-col gap-8">');
const tue = (e) => e ? !!(e.street1?.trim() && e.city?.trim() && e.state?.trim() && e.postalCode?.trim()) : !1, rue = Fr(K3(jn(), xf()), "Please select a patient..."), nue = Fr(K3(jn(), xf()), "Please enter an address for patient..."), iue = (e) => {
  const {
    dispatchAnalyticsTrackEvent: t
  } = Ma(), [r, n] = V(), [i, a] = V(!1), [o, s] = V(!1), {
    actions: l,
    store: d
  } = Of, [c, u] = V(!1);
  lr(() => {
    e.actions.registerValidator({
      key: "patient",
      validator: rue
    }), e.enableOrder && e.actions.registerValidator({
      key: "address",
      validator: nue
    }), e?.patientId && l.getSelectedPatient(e.client.getSDK(), e.patientId);
  });
  const h = (b, {
    trackInteraction: $ = !0
  } = {}) => {
    e.actions.updateFormValue({
      key: "patient",
      value: b
    }), $ && t("fieldInteraction", {
      name: "Field Interaction",
      formName: "add_prescription_form",
      patientId: b.id
    }), e.enableOrder && !e.address && e.actions.updateFormValue({
      key: "address",
      value: b.address
    });
  };
  fe(() => {
    d?.selectedPatient?.data && e?.patientId && h(d?.selectedPatient?.data, {
      trackInteraction: !1
    });
  });
  const f = K(
    // prefer the passed-in patientId if it exists
    () => e?.patientId || e.store.patient?.value?.id
  ), p = K(() => c() ? "" : f() ?? ""), m = K(() => {
    const b = e.store.address?.value || e.store.patient?.value?.address;
    return tue(b);
  }), y = K(() => !!e.store.patient?.value?.preferredPharmacies?.length), v = K(() => !e.store.patient?.value?.id || !e.enableOrder ? !1 : e.optionalPatientAddress ? y() && !m() : !m());
  return (() => {
    var b = eue();
    return L(b, g(H, {
      get when() {
        return !e?.patientId;
      },
      get children() {
        return g(Mn, {
          addChildrenDivider: !0,
          get children() {
            return [(() => {
              var $ = Yce();
              return L($, g(Ee, {
                color: "gray",
                get children() {
                  return e?.patientId ? "Patient" : "Select Patient";
                }
              })), $;
            })(), g(Oae, {
              get selectedPatient() {
                return d.selectedPatient.data;
              },
              get patients() {
                return d.patients.data;
              },
              get loading() {
                return d.patients.isLoading || d.selectedPatient.isLoading;
              },
              onInitialFetch: () => l.getPatients(e.client.getSDK()),
              onSearch: ($) => l.getPatients(e.client.getSDK(), $ ? {
                name: $
              } : void 0),
              onSelect: ($) => {
                l.getSelectedPatient(e.client.getSDK(), $.id), h($);
              }
            })];
          }
        });
      }
    }), null), L(b, g(H, {
      get when() {
        return p() && !e.hidePatientCard;
      },
      get children() {
        var $ = Jce(), _ = $.firstChild;
        return L($, g(Dne, {
          get patientId() {
            return p();
          },
          get weight() {
            return e?.weight;
          },
          get weightUnit() {
            return e?.weightUnit;
          },
          get editPatient() {
            return e?.enableOrder && !v() ? () => {
              t("ctaClicked", {
                name: "Patient Edited"
              }), a(!0);
            } : void 0;
          },
          get address() {
            return e?.address || e.store.patient?.value?.address;
          }
        }), _), Ue(_, "photon-patient-closed", () => {
          a(!1);
        }), Ue(_, "photon-patient-updated", () => {
          u(!0), l.getSelectedPatient(e.client.getSDK(), e.store.patient.value.id), setTimeout(() => {
            u(!1), a(!1);
          }, 100);
        }), _.hideCreatePrescription = !0, _._$owner = Ve(), se((x) => {
          var S = i(), A = p(), N = e.optionalPatientAddress;
          return S !== x.e && (_.open = x.e = S), A !== x.t && (_.patientId = x.t = A), N !== x.a && (_.optionalPatientAddress = x.a = N), x;
        }, {
          e: void 0,
          t: void 0,
          a: void 0
        }), $;
      }
    }), null), L(b, g(H, {
      get when() {
        return At(() => !!e.enableMedHistory)() && p();
      },
      get children() {
        var $ = Xce(), _ = $.firstChild;
        return L($, g(M_, {
          get patientId() {
            return p();
          },
          get newMedication() {
            return r();
          },
          get enableLinks() {
            return e.enableMedHistoryLinks ?? !1;
          },
          get enableRefillButton() {
            return e.enableMedHistoryRefillButton ?? !1;
          },
          openAddMedicationDialog: () => s(!0),
          hideAddMedicationDialog: () => s(!1)
        }), _), Ue(_, "photon-medication-closed", () => {
          s(!1);
        }), Ue(_, "photon-medication-selected", (x) => {
          n(x.detail.medication), t("ctaClicked", {
            name: "Added To Medication History"
          });
        }), _._$owner = Ve(), se(() => _.open = o()), $;
      }
    }), null), L(b, g(H, {
      get when() {
        return v();
      },
      get children() {
        return g(ok, {
          get patientId() {
            return p();
          },
          setAddress: ($) => {
            e.actions.updateFormValue({
              key: "address",
              value: $
            }), e.actions.updateFormValue({
              key: "patient",
              value: {
                ...e.store.patient.value,
                address: $
              }
            });
          }
        });
      }
    }), null), b;
  })();
};
var aue = /* @__PURE__ */ ae("<span>, "), oue = /* @__PURE__ */ ae('<div class="flex flex-col items-start">'), sue = /* @__PURE__ */ ae('<photon-card><div class="flex flex-col gap-3"><div class="flex flex-row"><p class="font-sans text-l font-medium flex-grow">Selected Pharmacy', !0, !1, !1);
const lue = (e) => {
  const t = Rn(), [r, n] = V(null), i = async (a) => {
    if (a && t) {
      const {
        data: o
      } = await t.getSDK().clinical.pharmacy.getPharmacy({
        id: a
      });
      n(o.pharmacy);
    }
  };
  return fe(() => {
    e.pharmacyId && i(e.pharmacyId);
  }), (() => {
    var a = sue(), o = a.firstChild;
    return o.firstChild, a._$owner = Ve(), L(o, g(H, {
      get when() {
        return r();
      },
      get children() {
        return g(_u, {
          label: "Pharmacies",
          get initSelected() {
            return e?.pharmacyId || "";
          },
          get children() {
            return g(_u.Option, {
              get value() {
                return e?.pharmacyId || "";
              },
              get children() {
                var s = oue();
                return L(s, g(Ee, {
                  get loading() {
                    return !r();
                  },
                  sampleLoadingText: "Loading Name",
                  get children() {
                    return r()?.name;
                  }
                }), null), L(s, g(Ee, {
                  get loading() {
                    return !r();
                  },
                  color: "gray",
                  size: "sm",
                  sampleLoadingText: "Cityville, ST",
                  get children() {
                    var l = aue(), d = l.firstChild;
                    return L(l, () => r()?.address?.city, d), L(l, () => r()?.address?.state, null), l;
                  }
                }), null), s;
              }
            });
          }
        });
      }
    }), null), a;
  })();
}, due = (e, t = "lb") => `Patient weight: ${e} ${t}`;
var Zx = /* @__PURE__ */ ((e) => (e.Draft = "DRAFT", e.Active = "ACTIVE", e.Depleted = "DEPLETED", e.Expired = "EXPIRED", e.Canceled = "CANCELED", e))(Zx || {}), Rt;
(function(e) {
  e.assertEqual = (i) => {
  };
  function t(i) {
  }
  e.assertIs = t;
  function r(i) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, e.getValidEnumValues = (i) => {
    const a = e.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(a) {
    return i[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, e.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && Number.isFinite(i) && Math.floor(i) === i;
  function n(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(Rt || (Rt = {}));
var W7;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(W7 || (W7 = {}));
const Ne = Rt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ro = (e) => {
  switch (typeof e) {
    case "undefined":
      return Ne.undefined;
    case "string":
      return Ne.string;
    case "number":
      return Number.isNaN(e) ? Ne.nan : Ne.number;
    case "boolean":
      return Ne.boolean;
    case "function":
      return Ne.function;
    case "bigint":
      return Ne.bigint;
    case "symbol":
      return Ne.symbol;
    case "object":
      return Array.isArray(e) ? Ne.array : e === null ? Ne.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Ne.promise : typeof Map < "u" && e instanceof Map ? Ne.map : typeof Set < "u" && e instanceof Set ? Ne.set : typeof Date < "u" && e instanceof Date ? Ne.date : Ne.object;
    default:
      return Ne.unknown;
  }
}, me = Rt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Oa extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(a) {
      return a.message;
    }, n = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const d = o.path[l];
            l === o.path.length - 1 ? (s[d] = s[d] || { _errors: [] }, s[d]._errors.push(r(o))) : s[d] = s[d] || { _errors: [] }, s = s[d], l++;
          }
        }
    };
    return i(this), n;
  }
  static assert(t) {
    if (!(t instanceof Oa))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Rt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      if (i.path.length > 0) {
        const a = i.path[0];
        r[a] = r[a] || [], r[a].push(t(i));
      } else
        n.push(t(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Oa.create = (e) => new Oa(e);
const lg = (e, t) => {
  let r;
  switch (e.code) {
    case me.invalid_type:
      e.received === Ne.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case me.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, Rt.jsonStringifyReplacer)}`;
      break;
    case me.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Rt.joinValues(e.keys, ", ")}`;
      break;
    case me.invalid_union:
      r = "Invalid input";
      break;
    case me.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Rt.joinValues(e.options)}`;
      break;
    case me.invalid_enum_value:
      r = `Invalid enum value. Expected ${Rt.joinValues(e.options)}, received '${e.received}'`;
      break;
    case me.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case me.invalid_return_type:
      r = "Invalid function return type";
      break;
    case me.invalid_date:
      r = "Invalid date";
      break;
    case me.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : Rt.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case me.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case me.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case me.custom:
      r = "Invalid input";
      break;
    case me.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case me.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case me.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, Rt.assertNever(e);
  }
  return { message: r };
};
let cue = lg;
function uue() {
  return cue;
}
const hue = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: i } = e, a = [...r, ...i.path || []], o = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let s = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    s = d(o, { data: t, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: s
  };
};
function Ce(e, t) {
  const r = uue(), n = hue({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === lg ? void 0 : lg
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(n);
}
class Qn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return et;
      i.status === "dirty" && t.dirty(), n.push(i.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const i of r) {
      const a = await i.key, o = await i.value;
      n.push({
        key: a,
        value: o
      });
    }
    return Qn.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const i of r) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return et;
      a.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (n[a.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const et = Object.freeze({
  status: "aborted"
}), Cc = (e) => ({ status: "dirty", value: e }), li = (e) => ({ status: "valid", value: e }), Q7 = (e) => e.status === "aborted", K7 = (e) => e.status === "dirty", fd = (e) => e.status === "valid", Eh = (e) => typeof Promise < "u" && e instanceof Promise;
var Re;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(Re || (Re = {}));
class Io {
  constructor(t, r, n, i) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const G7 = (e, t) => {
  if (fd(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Oa(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function ht(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: i } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (o, s) => {
    const { message: l } = e;
    return o.code === "invalid_enum_value" ? { message: l ?? s.defaultError } : typeof s.data > "u" ? { message: l ?? n ?? s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: l ?? r ?? s.defaultError };
  }, description: i };
}
class Pt {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ro(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: ro(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Qn(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ro(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Eh(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: r?.async ?? !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ro(t)
    }, i = this._parseSync({ data: t, path: n.path, parent: n });
    return G7(n, i);
  }
  "~validate"(t) {
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ro(t)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: t, path: [], parent: r });
        return fd(n) ? {
          value: n.value
        } : {
          issues: r.common.issues
        };
      } catch (n) {
        n?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((n) => fd(n) ? {
      value: n.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ro(t)
    }, i = this._parse({ data: t, path: n.path, parent: n }), a = await (Eh(i) ? i : Promise.resolve(i));
    return G7(n, a);
  }
  refine(t, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, a) => {
      const o = t(i), s = () => a.addIssue({
        code: me.custom,
        ...n(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, i) => t(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(t) {
    return new gd({
      schema: this,
      typeName: rt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return po.create(this, this._def);
  }
  nullable() {
    return vd.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Zi.create(this);
  }
  promise() {
    return Ih.create(this, this._def);
  }
  or(t) {
    return Th.create([this, t], this._def);
  }
  and(t) {
    return Oh.create(this, t, this._def);
  }
  transform(t) {
    return new gd({
      ...ht(this._def),
      schema: this,
      typeName: rt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new cg({
      ...ht(this._def),
      innerType: this,
      defaultValue: r,
      typeName: rt.ZodDefault
    });
  }
  brand() {
    return new Mue({
      typeName: rt.ZodBranded,
      type: this,
      ...ht(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new ug({
      ...ht(this._def),
      innerType: this,
      catchValue: r,
      typeName: rt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return iv.create(this, t);
  }
  readonly() {
    return hg.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const fue = /^c[^\s-]{8,}$/i, pue = /^[0-9a-z]+$/, mue = /^[0-9A-HJKMNP-TV-Z]{26}$/i, gue = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, vue = /^[a-z0-9_-]{21}$/i, yue = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, bue = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, wue = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, $ue = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ep;
const kue = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, _ue = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, xue = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Sue = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Cue = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Eue = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Yx = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Aue = new RegExp(`^${Yx}$`);
function Jx(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function Tue(e) {
  return new RegExp(`^${Jx(e)}$`);
}
function Oue(e) {
  let t = `${Yx}T${Jx(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Iue(e, t) {
  return !!((t === "v4" || !t) && kue.test(e) || (t === "v6" || !t) && xue.test(e));
}
function Pue(e, t) {
  if (!yue.test(e))
    return !1;
  try {
    const [r] = e.split(".");
    if (!r)
      return !1;
    const n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), i = JSON.parse(atob(n));
    return !(typeof i != "object" || i === null || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
  } catch {
    return !1;
  }
}
function Nue(e, t) {
  return !!((t === "v4" || !t) && _ue.test(e) || (t === "v6" || !t) && Sue.test(e));
}
class wa extends Pt {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Ne.string) {
      const a = this._getOrReturnCtx(t);
      return Ce(a, {
        code: me.invalid_type,
        expected: Ne.string,
        received: a.parsedType
      }), et;
    }
    const n = new Qn();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        t.data.length < a.value && (i = this._getOrReturnCtx(t, i), Ce(i, {
          code: me.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        t.data.length > a.value && (i = this._getOrReturnCtx(t, i), Ce(i, {
          code: me.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const o = t.data.length > a.value, s = t.data.length < a.value;
        (o || s) && (i = this._getOrReturnCtx(t, i), o ? Ce(i, {
          code: me.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : s && Ce(i, {
          code: me.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        wue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "email",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Ep || (Ep = new RegExp($ue, "u")), Ep.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "emoji",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        gue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "uuid",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        vue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "nanoid",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        fue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "cuid",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        pue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "cuid2",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        mue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
          validation: "ulid",
          code: me.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(t.data);
        } catch {
          i = this._getOrReturnCtx(t, i), Ce(i, {
            validation: "url",
            code: me.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "regex",
        code: me.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? t.data = t.data.trim() : a.kind === "includes" ? t.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : a.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : a.kind === "startsWith" ? t.data.startsWith(a.value) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? t.data.endsWith(a.value) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? Oue(a).test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? Aue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? Tue(a).test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? bue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "duration",
        code: me.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? Iue(t.data, a.version) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "ip",
        code: me.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "jwt" ? Pue(t.data, a.alg) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "jwt",
        code: me.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "cidr" ? Nue(t.data, a.version) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "cidr",
        code: me.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? Cue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "base64",
        code: me.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64url" ? Eue.test(t.data) || (i = this._getOrReturnCtx(t, i), Ce(i, {
        validation: "base64url",
        code: me.invalid_string,
        message: a.message
      }), n.dirty()) : Rt.assertNever(a);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((i) => t.test(i), {
      validation: r,
      code: me.invalid_string,
      ...Re.errToObj(n)
    });
  }
  _addCheck(t) {
    return new wa({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Re.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Re.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Re.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Re.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Re.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Re.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Re.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Re.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Re.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Re.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Re.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Re.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Re.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: t?.offset ?? !1,
      local: t?.local ?? !1,
      ...Re.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...Re.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Re.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Re.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r?.position,
      ...Re.errToObj(r?.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Re.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Re.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Re.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Re.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Re.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Re.errToObj(t));
  }
  trim() {
    return new wa({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new wa({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new wa({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
wa.create = (e) => new wa({
  checks: [],
  typeName: rt.ZodString,
  coerce: e?.coerce ?? !1,
  ...ht(e)
});
function Due(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, i = r > n ? r : n, a = Number.parseInt(e.toFixed(i).replace(".", "")), o = Number.parseInt(t.toFixed(i).replace(".", ""));
  return a % o / 10 ** i;
}
class Ps extends Pt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Ne.number) {
      const a = this._getOrReturnCtx(t);
      return Ce(a, {
        code: me.invalid_type,
        expected: Ne.number,
        received: a.parsedType
      }), et;
    }
    let n;
    const i = new Qn();
    for (const a of this._def.checks)
      a.kind === "int" ? Rt.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? Due(t.data, a.value) !== 0 && (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.not_finite,
        message: a.message
      }), i.dirty()) : Rt.assertNever(a);
    return { status: i.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Re.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Re.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Re.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Re.toString(r));
  }
  setLimit(t, r, n, i) {
    return new Ps({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Re.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ps({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Re.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Re.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Re.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Re.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Re.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Re.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Re.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Re.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Re.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Rt.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Ps.create = (e) => new Ps({
  checks: [],
  typeName: rt.ZodNumber,
  coerce: e?.coerce || !1,
  ...ht(e)
});
class Ns extends Pt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Ne.bigint)
      return this._getInvalidInput(t);
    let n;
    const i = new Qn();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? t.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), Ce(n, {
        code: me.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : Rt.assertNever(a);
    return { status: i.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return Ce(r, {
      code: me.invalid_type,
      expected: Ne.bigint,
      received: r.parsedType
    }), et;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Re.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Re.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Re.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Re.toString(r));
  }
  setLimit(t, r, n, i) {
    return new Ns({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: Re.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ns({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Re.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Re.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Re.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Re.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Re.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Ns.create = (e) => new Ns({
  checks: [],
  typeName: rt.ZodBigInt,
  coerce: e?.coerce ?? !1,
  ...ht(e)
});
class Ah extends Pt {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Ne.boolean) {
      const n = this._getOrReturnCtx(t);
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.boolean,
        received: n.parsedType
      }), et;
    }
    return li(t.data);
  }
}
Ah.create = (e) => new Ah({
  typeName: rt.ZodBoolean,
  coerce: e?.coerce || !1,
  ...ht(e)
});
class pd extends Pt {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Ne.date) {
      const a = this._getOrReturnCtx(t);
      return Ce(a, {
        code: me.invalid_type,
        expected: Ne.date,
        received: a.parsedType
      }), et;
    }
    if (Number.isNaN(t.data.getTime())) {
      const a = this._getOrReturnCtx(t);
      return Ce(a, {
        code: me.invalid_date
      }), et;
    }
    const n = new Qn();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? t.data.getTime() < a.value && (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? t.data.getTime() > a.value && (i = this._getOrReturnCtx(t, i), Ce(i, {
        code: me.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : Rt.assertNever(a);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new pd({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Re.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Re.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
pd.create = (e) => new pd({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: rt.ZodDate,
  ...ht(e)
});
class Z7 extends Pt {
  _parse(t) {
    if (this._getType(t) !== Ne.symbol) {
      const n = this._getOrReturnCtx(t);
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.symbol,
        received: n.parsedType
      }), et;
    }
    return li(t.data);
  }
}
Z7.create = (e) => new Z7({
  typeName: rt.ZodSymbol,
  ...ht(e)
});
class Y7 extends Pt {
  _parse(t) {
    if (this._getType(t) !== Ne.undefined) {
      const n = this._getOrReturnCtx(t);
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.undefined,
        received: n.parsedType
      }), et;
    }
    return li(t.data);
  }
}
Y7.create = (e) => new Y7({
  typeName: rt.ZodUndefined,
  ...ht(e)
});
class J7 extends Pt {
  _parse(t) {
    if (this._getType(t) !== Ne.null) {
      const n = this._getOrReturnCtx(t);
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.null,
        received: n.parsedType
      }), et;
    }
    return li(t.data);
  }
}
J7.create = (e) => new J7({
  typeName: rt.ZodNull,
  ...ht(e)
});
class X7 extends Pt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return li(t.data);
  }
}
X7.create = (e) => new X7({
  typeName: rt.ZodAny,
  ...ht(e)
});
class e8 extends Pt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return li(t.data);
  }
}
e8.create = (e) => new e8({
  typeName: rt.ZodUnknown,
  ...ht(e)
});
class Po extends Pt {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return Ce(r, {
      code: me.invalid_type,
      expected: Ne.never,
      received: r.parsedType
    }), et;
  }
}
Po.create = (e) => new Po({
  typeName: rt.ZodNever,
  ...ht(e)
});
class t8 extends Pt {
  _parse(t) {
    if (this._getType(t) !== Ne.undefined) {
      const n = this._getOrReturnCtx(t);
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.void,
        received: n.parsedType
      }), et;
    }
    return li(t.data);
  }
}
t8.create = (e) => new t8({
  typeName: rt.ZodVoid,
  ...ht(e)
});
class Zi extends Pt {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), i = this._def;
    if (r.parsedType !== Ne.array)
      return Ce(r, {
        code: me.invalid_type,
        expected: Ne.array,
        received: r.parsedType
      }), et;
    if (i.exactLength !== null) {
      const o = r.data.length > i.exactLength.value, s = r.data.length < i.exactLength.value;
      (o || s) && (Ce(r, {
        code: o ? me.too_big : me.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (Ce(r, {
      code: me.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (Ce(r, {
      code: me.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => i.type._parseAsync(new Io(r, o, r.path, s)))).then((o) => Qn.mergeArray(n, o));
    const a = [...r.data].map((o, s) => i.type._parseSync(new Io(r, o, r.path, s)));
    return Qn.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Zi({
      ...this._def,
      minLength: { value: t, message: Re.toString(r) }
    });
  }
  max(t, r) {
    return new Zi({
      ...this._def,
      maxLength: { value: t, message: Re.toString(r) }
    });
  }
  length(t, r) {
    return new Zi({
      ...this._def,
      exactLength: { value: t, message: Re.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Zi.create = (e, t) => new Zi({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: rt.ZodArray,
  ...ht(t)
});
function pl(e) {
  if (e instanceof Nr) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = po.create(pl(n));
    }
    return new Nr({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Zi ? new Zi({
    ...e._def,
    type: pl(e.element)
  }) : e instanceof po ? po.create(pl(e.unwrap())) : e instanceof vd ? vd.create(pl(e.unwrap())) : e instanceof Ds ? Ds.create(e.items.map((t) => pl(t))) : e;
}
class Nr extends Pt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = Rt.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== Ne.object) {
      const d = this._getOrReturnCtx(t);
      return Ce(d, {
        code: me.invalid_type,
        expected: Ne.object,
        received: d.parsedType
      }), et;
    }
    const { status: n, ctx: i } = this._processInputParams(t), { shape: a, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Po && this._def.unknownKeys === "strip"))
      for (const d in i.data)
        o.includes(d) || s.push(d);
    const l = [];
    for (const d of o) {
      const c = a[d], u = i.data[d];
      l.push({
        key: { status: "valid", value: d },
        value: c._parse(new Io(i, u, i.path, d)),
        alwaysSet: d in i.data
      });
    }
    if (this._def.catchall instanceof Po) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const c of s)
          l.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: i.data[c] }
          });
      else if (d === "strict")
        s.length > 0 && (Ce(i, {
          code: me.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const c of s) {
        const u = i.data[c];
        l.push({
          key: { status: "valid", value: c },
          value: d._parse(
            new Io(i, u, i.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const c of l) {
        const u = await c.key, h = await c.value;
        d.push({
          key: u,
          value: h,
          alwaysSet: c.alwaysSet
        });
      }
      return d;
    }).then((d) => Qn.mergeObjectSync(n, d)) : Qn.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Re.errToObj, new Nr({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          const i = this._def.errorMap?.(r, n).message ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: Re.errToObj(t).message ?? i
          } : {
            message: i
          };
        }
      } : {}
    });
  }
  strip() {
    return new Nr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Nr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Nr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Nr({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: rt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Nr({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of Rt.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new Nr({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of Rt.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new Nr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return pl(this);
  }
  partial(t) {
    const r = {};
    for (const n of Rt.objectKeys(this.shape)) {
      const i = this.shape[n];
      t && !t[n] ? r[n] = i : r[n] = i.optional();
    }
    return new Nr({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of Rt.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof po; )
          a = a._def.innerType;
        r[n] = a;
      }
    return new Nr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Xx(Rt.objectKeys(this.shape));
  }
}
Nr.create = (e, t) => new Nr({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Po.create(),
  typeName: rt.ZodObject,
  ...ht(t)
});
Nr.strictCreate = (e, t) => new Nr({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Po.create(),
  typeName: rt.ZodObject,
  ...ht(t)
});
Nr.lazycreate = (e, t) => new Nr({
  shape: e,
  unknownKeys: "strip",
  catchall: Po.create(),
  typeName: rt.ZodObject,
  ...ht(t)
});
class Th extends Pt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new Oa(s.ctx.common.issues));
      return Ce(r, {
        code: me.invalid_union,
        unionErrors: o
      }), et;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, c = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !a && (a = { result: c, ctx: d }), d.common.issues.length && o.push(d.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((l) => new Oa(l));
      return Ce(r, {
        code: me.invalid_union,
        unionErrors: s
      }), et;
    }
  }
  get options() {
    return this._def.options;
  }
}
Th.create = (e, t) => new Th({
  options: e,
  typeName: rt.ZodUnion,
  ...ht(t)
});
function dg(e, t) {
  const r = ro(e), n = ro(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Ne.object && n === Ne.object) {
    const i = Rt.objectKeys(t), a = Rt.objectKeys(e).filter((s) => i.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of a) {
      const l = dg(e[s], t[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === Ne.array && n === Ne.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], s = t[a], l = dg(o, s);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return r === Ne.date && n === Ne.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Oh extends Pt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = (a, o) => {
      if (Q7(a) || Q7(o))
        return et;
      const s = dg(a.value, o.value);
      return s.valid ? ((K7(a) || K7(o)) && r.dirty(), { status: r.value, value: s.data }) : (Ce(n, {
        code: me.invalid_intersection_types
      }), et);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Oh.create = (e, t, r) => new Oh({
  left: e,
  right: t,
  typeName: rt.ZodIntersection,
  ...ht(r)
});
class Ds extends Pt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ne.array)
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.array,
        received: n.parsedType
      }), et;
    if (n.data.length < this._def.items.length)
      return Ce(n, {
        code: me.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), et;
    !this._def.rest && n.data.length > this._def.items.length && (Ce(n, {
      code: me.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Io(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(a).then((o) => Qn.mergeArray(r, o)) : Qn.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Ds({
      ...this._def,
      rest: t
    });
  }
}
Ds.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ds({
    items: e,
    typeName: rt.ZodTuple,
    rest: null,
    ...ht(t)
  });
};
class r8 extends Pt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ne.map)
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.map,
        received: n.parsedType
      }), et;
    const i = this._def.keyType, a = this._def.valueType, o = [...n.data.entries()].map(([s, l], d) => ({
      key: i._parse(new Io(n, s, n.path, [d, "key"])),
      value: a._parse(new Io(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const d = await l.key, c = await l.value;
          if (d.status === "aborted" || c.status === "aborted")
            return et;
          (d.status === "dirty" || c.status === "dirty") && r.dirty(), s.set(d.value, c.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const d = l.key, c = l.value;
        if (d.status === "aborted" || c.status === "aborted")
          return et;
        (d.status === "dirty" || c.status === "dirty") && r.dirty(), s.set(d.value, c.value);
      }
      return { status: r.value, value: s };
    }
  }
}
r8.create = (e, t, r) => new r8({
  valueType: t,
  keyType: e,
  typeName: rt.ZodMap,
  ...ht(r)
});
class Tu extends Pt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ne.set)
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.set,
        received: n.parsedType
      }), et;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (Ce(n, {
      code: me.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (Ce(n, {
      code: me.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function o(l) {
      const d = /* @__PURE__ */ new Set();
      for (const c of l) {
        if (c.status === "aborted")
          return et;
        c.status === "dirty" && r.dirty(), d.add(c.value);
      }
      return { status: r.value, value: d };
    }
    const s = [...n.data.values()].map((l, d) => a._parse(new Io(n, l, n.path, d)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(t, r) {
    return new Tu({
      ...this._def,
      minSize: { value: t, message: Re.toString(r) }
    });
  }
  max(t, r) {
    return new Tu({
      ...this._def,
      maxSize: { value: t, message: Re.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Tu.create = (e, t) => new Tu({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: rt.ZodSet,
  ...ht(t)
});
class n8 extends Pt {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
n8.create = (e, t) => new n8({
  getter: e,
  typeName: rt.ZodLazy,
  ...ht(t)
});
class i8 extends Pt {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return Ce(r, {
        received: r.data,
        code: me.invalid_literal,
        expected: this._def.value
      }), et;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
i8.create = (e, t) => new i8({
  value: e,
  typeName: rt.ZodLiteral,
  ...ht(t)
});
function Xx(e, t) {
  return new md({
    values: e,
    typeName: rt.ZodEnum,
    ...ht(t)
  });
}
class md extends Pt {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return Ce(r, {
        expected: Rt.joinValues(n),
        received: r.parsedType,
        code: me.invalid_type
      }), et;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return Ce(r, {
        received: r.data,
        code: me.invalid_enum_value,
        options: n
      }), et;
    }
    return li(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return md.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return md.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
md.create = Xx;
class a8 extends Pt {
  _parse(t) {
    const r = Rt.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== Ne.string && n.parsedType !== Ne.number) {
      const i = Rt.objectValues(r);
      return Ce(n, {
        expected: Rt.joinValues(i),
        received: n.parsedType,
        code: me.invalid_type
      }), et;
    }
    if (this._cache || (this._cache = new Set(Rt.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const i = Rt.objectValues(r);
      return Ce(n, {
        received: n.data,
        code: me.invalid_enum_value,
        options: i
      }), et;
    }
    return li(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
a8.create = (e, t) => new a8({
  values: e,
  typeName: rt.ZodNativeEnum,
  ...ht(t)
});
class Ih extends Pt {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ne.promise && r.common.async === !1)
      return Ce(r, {
        code: me.invalid_type,
        expected: Ne.promise,
        received: r.parsedType
      }), et;
    const n = r.parsedType === Ne.promise ? r.data : Promise.resolve(r.data);
    return li(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Ih.create = (e, t) => new Ih({
  type: e,
  typeName: rt.ZodPromise,
  ...ht(t)
});
class gd extends Pt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === rt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), i = this._def.effect || null, a = {
      addIssue: (o) => {
        Ce(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return et;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? et : l.status === "dirty" || r.value === "dirty" ? Cc(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return et;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? et : s.status === "dirty" || r.value === "dirty" ? Cc(s.value) : s;
      }
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const l = i.refinement(s, a);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? et : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? et : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!fd(o))
          return et;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => fd(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({
          status: r.value,
          value: s
        })) : et);
    Rt.assertNever(i);
  }
}
gd.create = (e, t, r) => new gd({
  schema: e,
  typeName: rt.ZodEffects,
  effect: t,
  ...ht(r)
});
gd.createWithPreprocess = (e, t, r) => new gd({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: rt.ZodEffects,
  ...ht(r)
});
class po extends Pt {
  _parse(t) {
    return this._getType(t) === Ne.undefined ? li(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
po.create = (e, t) => new po({
  innerType: e,
  typeName: rt.ZodOptional,
  ...ht(t)
});
class vd extends Pt {
  _parse(t) {
    return this._getType(t) === Ne.null ? li(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
vd.create = (e, t) => new vd({
  innerType: e,
  typeName: rt.ZodNullable,
  ...ht(t)
});
class cg extends Pt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === Ne.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
cg.create = (e, t) => new cg({
  innerType: e,
  typeName: rt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ht(t)
});
class ug extends Pt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Eh(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Oa(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Oa(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ug.create = (e, t) => new ug({
  innerType: e,
  typeName: rt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ht(t)
});
class o8 extends Pt {
  _parse(t) {
    if (this._getType(t) !== Ne.nan) {
      const n = this._getOrReturnCtx(t);
      return Ce(n, {
        code: me.invalid_type,
        expected: Ne.nan,
        received: n.parsedType
      }), et;
    }
    return { status: "valid", value: t.data };
  }
}
o8.create = (e) => new o8({
  typeName: rt.ZodNaN,
  ...ht(e)
});
class Mue extends Pt {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class iv extends Pt {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? et : a.status === "dirty" ? (r.dirty(), Cc(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? et : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new iv({
      in: t,
      out: r,
      typeName: rt.ZodPipeline
    });
  }
}
class hg extends Pt {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (i) => (fd(i) && (i.value = Object.freeze(i.value)), i);
    return Eh(r) ? r.then((i) => n(i)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
hg.create = (e, t) => new hg({
  innerType: e,
  typeName: rt.ZodReadonly,
  ...ht(t)
});
var rt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(rt || (rt = {}));
const s8 = wa.create;
Ps.create;
Ns.create;
Ah.create;
pd.create;
Po.create;
Zi.create;
const Rue = Nr.create;
Th.create;
Oh.create;
Ds.create;
md.create;
Ih.create;
po.create;
vd.create;
const Lue = {
  string: ((e) => wa.create({ ...e, coerce: !0 })),
  number: ((e) => Ps.create({ ...e, coerce: !0 })),
  boolean: ((e) => Ah.create({
    ...e,
    coerce: !0
  })),
  bigint: ((e) => Ns.create({ ...e, coerce: !0 })),
  date: ((e) => pd.create({ ...e, coerce: !0 }))
};
function Fue(e, ...t) {
  const r = e.subscribe(...t);
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
function pa(e) {
  let t;
  return Fue(e, (r) => t = r)(), t;
}
class jue extends Error {
  constructor(t, r) {
    super(t), this.name = "FelteSubmitError", this.response = r;
  }
}
function zue(e, t) {
  return Object.keys(e).some((n) => t(e[n]));
}
function If(e, t) {
  return Object.keys(e || {}).reduce((n, i) => Object.assign(Object.assign({}, n), { [i]: t(e[i]) }), {});
}
function ct(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function En(e) {
  return Object.keys(e || {}).reduce((t, r) => Object.assign(Object.assign({}, t), { [r]: ct(e[r]) ? En(e[r]) : Array.isArray(e[r]) ? [...e[r]] : e[r] }), {});
}
function Vue(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Uue(e) {
  return function(t) {
    if (ct(t)) {
      const r = Tn(t, e);
      return Vue(r, ["key"]);
    }
    return e;
  };
}
function Tn(e, t) {
  return If(e, (r) => ct(r) ? Tn(r, t) : Array.isArray(r) ? r.map(Uue(t)) : t);
}
function mo(...e) {
  const t = e.pop(), r = e.shift();
  if (typeof r == "string")
    return r;
  const n = En(r);
  if (e.length === 0)
    return n;
  for (const i of e) {
    if (!i)
      continue;
    if (typeof i == "string")
      return i;
    let a = t(n, i);
    if (typeof a < "u")
      return a;
    const o = Array.from(new Set(Object.keys(n).concat(Object.keys(i))));
    for (const s of o)
      if (a = t(n[s], i[s]), typeof a < "u")
        n[s] = a;
      else if (ct(i[s]) && ct(n[s]))
        n[s] = mo(n[s], i[s], t);
      else if (Array.isArray(i[s]))
        n[s] = i[s].map((l, d) => {
          if (!ct(l))
            return l;
          const c = Array.isArray(n[s]) ? n[s][d] : n[s];
          return mo(c, l, t);
        });
      else if (ct(i[s])) {
        const l = Tn(En(i[s]), void 0);
        n[s] = mo(l, i[s], t);
      } else typeof i[s] < "u" && (n[s] = i[s]);
  }
  return n;
}
function que(e, t) {
  if (!(ct(e) && ct(t))) {
    if (Array.isArray(t)) {
      if (t.some(ct))
        return;
      const r = Array.isArray(e) ? e : [];
      return t.map((n, i) => {
        var a;
        return (a = r[i]) !== null && a !== void 0 ? a : n;
      });
    }
    if (typeof e < "u")
      return e;
  }
}
function l8(...e) {
  return mo(...e, que);
}
function eS(...e) {
  return mo(...e, () => {
  });
}
function Yi(e, t, r) {
  const n = (a) => String.prototype.split.call(t, a).filter(Boolean).reduce((o, s) => o != null ? o[s] : o, e), i = n(/[,[\]]+?/) || n(/[,[\].]+?/);
  return i === void 0 || i === e ? r : i;
}
function Fd(e, t, r) {
  e && (e = En(e)), ct(e) || (e = {});
  const n = Array.isArray(t) ? t : t.match(/[^.[\]]+/g) || [], i = n[n.length - 1];
  if (!i)
    return e;
  let a = e;
  for (let o = 0; o < n.length - 1; o++) {
    const s = n[o];
    if (!a[s] || !ct(a[s]) && !Array.isArray(a[s])) {
      const l = n[o + 1];
      isNaN(Number(l)) ? a[s] = {} : a[s] = [];
    }
    a = a[s];
  }
  return a[i] = r(a[i]), e;
}
function Xt(e, t, r) {
  return Fd(e, t, () => r);
}
function Ec(e, t) {
  if (!e || Object(e) !== e)
    return;
  typeof e < "u" && (e = En(e));
  const r = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g) || [], n = r.length === 1 ? e : Yi(e, r.slice(0, -1).join("."));
  return Array.isArray(n) ? n.splice(Number(r[r.length - 1]), 1) : n == null || delete n[r[r.length - 1]], e;
}
function Ou(e, t) {
  return zue(e, (r) => ct(r) ? Ou(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t(r) : r.some((n) => ct(n) ? Ou(n, t) : t(n)) : t(r));
}
function Bl(e) {
  return e?.nodeName === "INPUT";
}
function Bue(e) {
  return e?.nodeName === "TEXTAREA";
}
function Hl(e) {
  return e?.nodeName === "SELECT";
}
function Pf(e) {
  return e?.nodeName === "FIELDSET";
}
function en(e) {
  return Bl(e) || Bue(e) || Hl(e);
}
function d8(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function Xr(e, t) {
  return t ?? (en(e) ? e.name : "");
}
function Ap(e) {
  let t = e;
  for (; t && t.nodeName !== "FORM"; ) {
    if (t.hasAttribute("data-felte-ignore"))
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function c8(e, t) {
  return !ct(e) || !t ? e : typeof t == "string" ? Yi(e, t) : t(e);
}
function Hue(e, t) {
  if (!(ct(e) || ct(t))) {
    if (e === null || e === "")
      return t;
    if (t === null || t === "" || !t)
      return e;
    if (!(!e || !t)) {
      if (Array.isArray(e)) {
        if (!Array.isArray(t))
          return [...e, t];
        const r = [], n = Math.max(t.length, e.length);
        for (let i = 0; i < n; i++) {
          let a = e[i], o = t[i];
          !ct(a) && !ct(o) ? (Array.isArray(a) || (a = [a]), Array.isArray(o) || (o = [o]), r.push(...a, ...o)) : r.push(ml([a ?? {}, o ?? {}]));
        }
        return r.filter(Boolean);
      }
      return Array.isArray(t) || (t = [t]), [e, ...t].reduce((r, n) => r.concat(n), []).filter(Boolean);
    }
  }
}
function ml(e) {
  return mo(...e, Hue);
}
function Wue(e, t) {
  return t ? (Array.isArray(t) ? t : [t]).map((n) => n(e)) : [];
}
function fg(e, t) {
  return t ? Array.isArray(t) ? t.reduce((r, n) => n(r), e) : t(e) : e;
}
function tS(e = 8) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}
function pg(e, t) {
  if (e === t)
    return !0;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((r, n) => pg(r, t[n]));
  if (ct(e) && ct(t)) {
    const r = Object.keys(e), n = Object.keys(t);
    return r.length !== n.length ? !1 : r.every((i) => pg(e[i], t[i]));
  }
  return !1;
}
function Ph(e, t, { onInit: r, onEnd: n } = {}) {
  let i;
  return (...a) => {
    i || r?.(), i && clearTimeout(i), i = setTimeout(() => {
      e.apply(this, a), i = void 0, n?.();
    }, t);
  };
}
function mg(e) {
  if (en(e))
    return [e];
  if (e.childElementCount === 0)
    return [];
  const t = /* @__PURE__ */ new Set();
  for (const r of e.children) {
    if (en(r) && t.add(r), Pf(r))
      for (const n of r.elements)
        en(n) && t.add(n);
    r.childElementCount > 0 && mg(r).forEach((n) => t.add(n));
  }
  return Array.from(t);
}
function rS(e) {
  for (const t of e.elements)
    !en(t) && !Pf(t) || e.hasAttribute("data-felte-keep-on-remove") && !t.hasAttribute("data-felte-keep-on-remove") && (t.dataset.felteKeepOnRemove = e.dataset.felteKeepOnRemove);
}
function nS(e) {
  return e.type.match(/^(number|range)$/) ? e.value ? +e.value : null : e.value;
}
function u8(e) {
  var t;
  let r = {}, n = {};
  for (const i of e.elements) {
    if (Pf(i) && rS(i), !en(i) || !i.name)
      continue;
    const a = Xr(i);
    if (Bl(i)) {
      if (i.type === "checkbox") {
        if (typeof Yi(r, a) > "u") {
          if (Array.from(e.querySelectorAll(`[name="${i.name}"]`)).filter((l) => en(l) ? a === Xr(l) : !1).length === 1) {
            r = Xt(r, a, i.checked), n = Xt(n, a, !1);
            continue;
          }
          r = Xt(r, a, i.checked ? [i.value] : []), n = Xt(n, a, !1);
          continue;
        }
        Array.isArray(Yi(r, a)) && i.checked && (r = Fd(r, a, (s) => [
          ...s,
          i.value
        ]));
        continue;
      }
      if (i.type === "radio") {
        if (Yi(r, a))
          continue;
        r = Xt(r, a, i.checked ? i.value : void 0), n = Xt(n, a, !1);
        continue;
      }
      if (i.type === "file") {
        r = Xt(r, a, i.multiple ? Array.from(i.files || []) : (t = i.files) === null || t === void 0 ? void 0 : t[0]), n = Xt(n, a, !1);
        continue;
      }
    } else if (Hl(i)) {
      if (!i.multiple)
        r = Xt(r, a, i.value);
      else {
        const l = Array.from(i.selectedOptions).map((d) => d.value);
        r = Xt(r, a, l);
      }
      n = Xt(n, a, !1);
      continue;
    }
    const o = nS(i);
    r = Xt(r, a, o), n = Xt(n, a, !1);
  }
  return { defaultData: r, defaultTouched: n };
}
function Que(e, t) {
  var r;
  if (!en(e))
    return;
  const n = t;
  if (Bl(e)) {
    if (e.type === "checkbox") {
      const i = n;
      if (typeof i > "u" || typeof i == "boolean") {
        e.checked = !!i;
        return;
      }
      Array.isArray(i) && (i.includes(e.value) ? e.checked = !0 : e.checked = !1);
      return;
    }
    if (e.type === "radio") {
      const i = n;
      e.value === i ? e.checked = !0 : e.checked = !1;
      return;
    }
    if (e.type === "file") {
      if (t instanceof FileList)
        e.files = t;
      else if (t instanceof File && typeof DataTransfer < "u") {
        const i = new DataTransfer();
        i.items.add(t), e.files = i.files;
      } else if (typeof DataTransfer < "u" && Array.isArray(t) && t.some((i) => i instanceof File)) {
        const i = new DataTransfer();
        for (const a of t)
          a instanceof File && i.items.add(a);
        e.files = i.files;
      } else (!t || Array.isArray(t) && !t.length) && (e.files = null, e.value = "");
      return;
    }
  } else if (Hl(e)) {
    if (e.multiple) {
      if (Array.isArray(n)) {
        e.value = String((r = n[0]) !== null && r !== void 0 ? r : "");
        const a = n.map((o) => String(o));
        for (const o of e.options)
          a.includes(o.value) ? o.selected = !0 : o.selected = !1;
      }
    } else {
      e.value = String(n ?? "");
      for (const a of e.options)
        a.value === String(n) ? a.selected = !0 : a.selected = !1;
    }
    return;
  }
  e.value = String(n ?? "");
}
function Y0(e, t) {
  for (const r of e.elements) {
    if (Pf(r) && rS(r), !en(r) || !r.name)
      continue;
    const n = Xr(r);
    Que(r, Yi(t, n));
  }
}
function iS(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function ma(e, t) {
  return If(e, (r) => ct(r) ? ma(r, t) : Array.isArray(r) ? r.length === 0 || r.every((n) => typeof n == "string") ? t : r.map((n) => {
    const i = ma(n, t);
    return iS(i, ["key"]);
  }) : t);
}
function Ms(e) {
  return e ? If(e, (t) => ct(t) ? Ms(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!ct(r))
      return r;
    const n = Ms(r);
    return n.key || (n.key = tS()), n;
  }) : t) : {};
}
function Wl(e) {
  return e ? If(e, (t) => ct(t) ? Wl(t) : Array.isArray(t) ? t.length === 0 || t.every((r) => typeof r == "string") ? t : t.map((r) => {
    if (!ct(r))
      return r;
    const n = Wl(r);
    return iS(n, ["key"]);
  }) : t) : {};
}
function Kue() {
  class e extends CustomEvent {
    constructor(i) {
      super("feltesuccess", { detail: i });
    }
  }
  class t extends CustomEvent {
    constructor(i) {
      super("felteerror", { detail: i, cancelable: !0 });
    }
    setErrors(i) {
      this.preventDefault(), this.errors = i;
    }
  }
  class r extends Event {
    constructor() {
      super("feltesubmit", { cancelable: !0 });
    }
    handleSubmit(i) {
      this.onSubmit = i;
    }
    handleError(i) {
      this.onError = i;
    }
    handleSuccess(i) {
      this.onSuccess = i;
    }
  }
  return {
    createErrorEvent: (n) => new t(n),
    createSubmitEvent: () => new r(),
    createSuccessEvent: (n) => new e(n)
  };
}
function Gue(e) {
  if (e)
    return async function() {
      let r = new FormData(e);
      const n = new URL(e.action), i = e.method.toLowerCase() === "get" ? "get" : n.searchParams.get("_method") || e.method;
      let a = e.enctype;
      e.querySelector('input[type="file"]') && (a = "multipart/form-data"), (i === "get" || a === "application/x-www-form-urlencoded") && (r = new URLSearchParams(r));
      let o;
      i === "get" ? (r.forEach((l, d) => {
        n.searchParams.append(d, l);
      }), o = { method: i, headers: { Accept: "application/json" } }) : o = {
        method: i,
        body: r,
        headers: Object.assign(Object.assign({}, a !== "multipart/form-data" && {
          "Content-Type": a
        }), { Accept: "application/json" })
      };
      const s = await window.fetch(n.toString(), o);
      if (s.ok)
        return s;
      throw new jue("An error occurred while submitting the form", s);
    };
}
function J0(e, t, r, n) {
  return Fd(e, t, (i) => (typeof i < "u" && !Array.isArray(i) || (i || (i = []), typeof n > "u" ? i.push(r) : i.splice(n, 0, r)), i));
}
function Zue(e, t, r, n) {
  return Fd(e, t, (i) => (!i || !Array.isArray(i) || ([i[r], i[n]] = [i[n], i[r]]), i));
}
function Yue(e, t, r, n) {
  return Fd(e, t, (i) => (!i || !Array.isArray(i) || i.splice(n, 0, i.splice(r, 1)[0]), i));
}
function h8(e) {
  return typeof e == "function";
}
function Wa(e) {
  return (r, n) => {
    if (typeof r == "string") {
      const i = r;
      e((a) => {
        const o = h8(n) ? n(Yi(a, i)) : n;
        return Xt(a, i, o);
      });
    } else
      e((i) => h8(r) ? r(i) : r);
  };
}
function Jue({ stores: e, config: t, validateErrors: r, validateWarnings: n, _getCurrentExtenders: i }) {
  var a;
  let o, s = Ms((a = t.initialValues) !== null && a !== void 0 ? a : {});
  const { data: l, touched: d, errors: c, warnings: u, isDirty: h, isSubmitting: f, interacted: p } = e, m = Wa(l.update), y = Wa(d.update), v = Wa(c.update), b = Wa(u.update);
  function $(R) {
    m((re) => {
      const he = R(re);
      return o && Y0(o, he), he;
    });
  }
  const _ = (R, re, he) => {
    Wa($)(R, re), typeof R == "string" && he && y(R, !0);
  };
  function x(R, re, he) {
    const ge = ct(re) ? ma(re, !1) : !1, ce = ct(ge) ? Tn(ge, []) : [];
    re = ct(re) ? Object.assign(Object.assign({}, re), { key: tS() }) : re, c.update((W) => J0(W, R, ce, he)), u.update((W) => J0(W, R, ce, he)), d.update((W) => J0(W, R, ge, he)), l.update((W) => {
      const oe = J0(W, R, re, he);
      return setTimeout(() => o && Y0(o, oe)), oe;
    });
  }
  function S(R) {
    c.update(R), u.update(R), d.update(R), l.update((re) => {
      const he = R(re);
      return setTimeout(() => o && Y0(o, he)), he;
    });
  }
  function A(R) {
    S((re) => Ec(re, R));
  }
  function N(R, re, he) {
    S((ge) => Zue(ge, R, re, he));
  }
  function P(R, re, he) {
    S((ge) => Yue(ge, R, re, he));
  }
  function D(R) {
    const re = Yi(s, R), he = ct(re) ? ma(re, !1) : !1, ge = ct(he) ? Tn(he, []) : [];
    l.update((ce) => {
      const W = Xt(ce, R, re);
      return o && Y0(o, W), W;
    }), d.update((ce) => Xt(ce, R, he)), c.update((ce) => Xt(ce, R, ge)), u.update((ce) => Xt(ce, R, ge));
  }
  const T = Wa(f.update), I = Wa(h.update), j = Wa(p.update);
  async function F() {
    const R = pa(l);
    d.set(ma(R, !0)), p.set(null);
    const re = await r(R);
    return await n(R), re;
  }
  function Z() {
    _(En(s)), y((R) => Tn(R, !1)), p.set(null), h.set(!1);
  }
  function te(R) {
    return async function(he) {
      var ge, ce, W, oe, le, Fe, We;
      const { createErrorEvent: St, createSubmitEvent: bt, createSuccessEvent: Ct } = Kue(), _t = bt();
      o?.dispatchEvent(_t);
      const G = (ce = (ge = _t.onError) !== null && ge !== void 0 ? ge : R?.onError) !== null && ce !== void 0 ? ce : t.onError, M = (oe = (W = _t.onSuccess) !== null && W !== void 0 ? W : R?.onSuccess) !== null && oe !== void 0 ? oe : t.onSuccess, ue = (We = (Fe = (le = _t.onSubmit) !== null && le !== void 0 ? le : R?.onSubmit) !== null && Fe !== void 0 ? Fe : t.onSubmit) !== null && We !== void 0 ? We : Gue(o);
      if (!ue || (he?.preventDefault(), _t.defaultPrevented))
        return;
      f.set(!0), p.set(null);
      const ie = Wl(pa(l)), De = await r(ie, R?.validate), je = await n(ie, R?.warn);
      if (je && u.set(eS(Tn(ie, []), je)), d.set(ma(ie, !0)), De && (d.set(ma(De, !0)), Ou(De, (ot) => Array.isArray(ot) ? ot.length >= 1 : !!ot))) {
        await new Promise((ot) => setTimeout(ot)), i().forEach((ot) => {
          var Nt;
          return (Nt = ot.onSubmitError) === null || Nt === void 0 ? void 0 : Nt.call(ot, {
            data: ie,
            errors: De
          });
        }), f.set(!1);
        return;
      }
      const He = {
        event: he,
        setFields: _,
        setData: m,
        setTouched: y,
        setErrors: v,
        setWarnings: b,
        unsetField: A,
        addField: x,
        resetField: D,
        reset: Z,
        setInitialValues: Y.setInitialValues,
        moveField: P,
        swapFields: N,
        form: o,
        controls: o && Array.from(o.elements).filter(en),
        config: Object.assign(Object.assign({}, t), R)
      };
      try {
        const _e = await ue(ie, He);
        o?.dispatchEvent(Ct(Object.assign({ response: _e }, He))), await M?.(_e, He);
      } catch (_e) {
        const ot = St(Object.assign({ error: _e }, He));
        if (o?.dispatchEvent(ot), !G && !ot.defaultPrevented)
          throw _e;
        if (!G && !ot.errors)
          return;
        const Nt = ot.errors || await G?.(_e, He);
        Nt && (d.set(ma(Nt, !0)), c.set(Nt), await new Promise((ir) => setTimeout(ir)), i().forEach((ir) => {
          var dr;
          return (dr = ir.onSubmitError) === null || dr === void 0 ? void 0 : dr.call(ir, {
            data: ie,
            errors: pa(c)
          });
        }));
      } finally {
        f.set(!1);
      }
    };
  }
  const Y = {
    setData: m,
    setFields: _,
    setTouched: y,
    setErrors: v,
    setWarnings: b,
    setIsSubmitting: T,
    setIsDirty: I,
    setInteracted: j,
    validate: F,
    reset: Z,
    unsetField: A,
    resetField: D,
    addField: x,
    swapFields: N,
    moveField: P,
    createSubmitHandler: te,
    handleSubmit: te(),
    setInitialValues: (R) => {
      s = Ms(R);
    }
  };
  return {
    public: Y,
    private: {
      _setFormNode(R) {
        o = R;
      },
      _getInitialValues: () => s
    }
  };
}
function Xue({ helpers: e, stores: t, config: r, extender: n, createSubmitHandler: i, handleSubmit: a, _setFormNode: o, _getInitialValues: s, _setCurrentExtenders: l, _getCurrentExtenders: d }) {
  const { setFields: c, setTouched: u, reset: h, setInitialValues: f } = e, { addValidator: p, addTransformer: m, validate: y } = e, { data: v, errors: b, warnings: $, touched: _, isSubmitting: x, isDirty: S, interacted: A, isValid: N, isValidating: P } = t;
  function D(T) {
    T.requestSubmit || (T.requestSubmit = a);
    function I(G) {
      return function(M) {
        return M({
          form: T,
          stage: G,
          controls: Array.from(T.elements).filter(en),
          data: v,
          errors: b,
          warnings: $,
          touched: _,
          isValid: N,
          isValidating: P,
          isSubmitting: x,
          isDirty: S,
          interacted: A,
          config: r,
          addValidator: p,
          addTransformer: m,
          setFields: c,
          validate: y,
          reset: h,
          createSubmitHandler: i,
          handleSubmit: a
        });
      };
    }
    l(n.map(I("MOUNT"))), T.noValidate = !!r.validate;
    const { defaultData: j, defaultTouched: F } = u8(T);
    o(T), f(eS(En(j), s())), c(s()), _.set(F);
    function Z(G) {
      const M = Xr(G), ue = Array.from(T.querySelectorAll(`[name="${G.name}"]`)).filter((ie) => en(ie) ? M === Xr(ie) : !1);
      if (ue.length !== 0)
        return ue.length === 1 ? v.update((ie) => Xt(ie, Xr(G), G.checked)) : v.update((ie) => Xt(ie, Xr(G), ue.filter(Bl).filter((De) => De.checked).map((De) => De.value)));
    }
    function te(G) {
      const M = T.querySelectorAll(`[name="${G.name}"]`), ue = Array.from(M).find((ie) => Bl(ie) && ie.checked);
      v.update((ie) => Xt(ie, Xr(G), ue?.value));
    }
    function Y(G) {
      var M;
      const ue = Array.from((M = G.files) !== null && M !== void 0 ? M : []);
      v.update((ie) => Xt(ie, Xr(G), G.multiple ? ue : ue[0]));
    }
    function Q(G) {
      if (!G.multiple)
        v.update((M) => Xt(M, Xr(G), G.value));
      else {
        const M = Array.from(G.selectedOptions).map((ue) => ue.value);
        v.update((ue) => Xt(ue, Xr(G), M));
      }
    }
    function R(G) {
      const M = G.target;
      if (!M || !en(M) || Hl(M) || Ap(M) || ["checkbox", "radio", "file"].includes(M.type) || !M.name)
        return;
      S.set(!0);
      const ue = nS(M);
      A.set(M.name), v.update((ie) => Xt(ie, Xr(M), ue));
    }
    function re(G) {
      const M = G.target;
      if (!(!M || !en(M) || Ap(M)) && M.name)
        if (u(Xr(M), !0), A.set(M.name), (Hl(M) || ["checkbox", "radio", "file", "hidden"].includes(M.type)) && S.set(!0), M.type === "hidden" && v.update((ue) => Xt(ue, Xr(M), M.value)), Hl(M))
          Q(M);
        else if (Bl(M))
          M.type === "checkbox" ? Z(M) : M.type === "radio" ? te(M) : M.type === "file" && Y(M);
        else return;
    }
    function he(G) {
      const M = G.target;
      !M || !en(M) || Ap(M) || M.name && (u(Xr(M), !0), A.set(M.name));
    }
    function ge(G) {
      G.preventDefault(), h();
    }
    const ce = { childList: !0, subtree: !0 };
    function W(G) {
      let M = pa(v), ue = pa(_), ie = pa(b), De = pa($);
      for (const je of G.reverse()) {
        if (je.hasAttribute("data-felte-keep-on-remove") && je.dataset.felteKeepOnRemove !== "false")
          continue;
        const He = /.*(\[[0-9]+\]|\.[0-9]+)\.[^.]+$/;
        let _e = Xr(je);
        const ot = pa(_);
        if (He.test(_e)) {
          const ir = _e.split(".").slice(0, -1).join("."), dr = Yi(ot, ir);
          ct(dr) && Object.keys(dr).length <= 1 && (_e = ir);
        }
        M = Ec(M, _e), ue = Ec(ue, _e), ie = Ec(ie, _e), De = Ec(De, _e);
      }
      v.set(M), _.set(ue), b.set(ie), $.set(De);
    }
    const oe = Ph(() => {
      d().forEach((ue) => {
        var ie;
        return (ie = ue.destroy) === null || ie === void 0 ? void 0 : ie.call(ue);
      }), l(n.map(I("UPDATE")));
      const { defaultData: G, defaultTouched: M } = u8(T);
      v.update((ue) => l8(ue, G)), _.update((ue) => l8(ue, M)), e.setFields(pa(v));
    }, 0);
    let le = [];
    const Fe = Ph(() => {
      d().forEach((G) => {
        var M;
        return (M = G.destroy) === null || M === void 0 ? void 0 : M.call(G);
      }), l(n.map(I("UPDATE"))), W(le), le = [];
    }, 0);
    function We(G) {
      Array.from(G.addedNodes).some((ue) => d8(ue) ? en(ue) ? !0 : mg(ue).length > 0 : !1) && oe();
    }
    function St(G) {
      for (const M of G.removedNodes) {
        if (!d8(M))
          continue;
        const ue = mg(M);
        ue.length !== 0 && (le.push(...ue), Fe());
      }
    }
    function bt(G) {
      for (const M of G)
        M.type === "childList" && (M.addedNodes.length > 0 && We(M), M.removedNodes.length > 0 && St(M));
    }
    const Ct = new MutationObserver(bt);
    Ct.observe(T, ce), T.addEventListener("input", R), T.addEventListener("change", re), T.addEventListener("focusout", he), T.addEventListener("submit", a), T.addEventListener("reset", ge);
    const _t = b.subscribe((G) => {
      for (const M of T.elements) {
        if (!en(M) || !M.name)
          continue;
        const ue = Yi(G, Xr(M)), ie = Array.isArray(ue) ? ue.join(`
`) : typeof ue == "string" ? ue : void 0;
        ie !== M.dataset.felteValidationMessage && (ie ? (M.dataset.felteValidationMessage = ie, M.setAttribute("aria-invalid", "true")) : (delete M.dataset.felteValidationMessage, M.removeAttribute("aria-invalid")));
      }
    });
    return {
      destroy() {
        Ct.disconnect(), T.removeEventListener("input", R), T.removeEventListener("change", re), T.removeEventListener("focusout", he), T.removeEventListener("submit", a), T.removeEventListener("reset", ge), _t(), d().forEach((G) => {
          var M;
          return (M = G.destroy) === null || M === void 0 ? void 0 : M.call(G);
        });
      }
    };
  }
  return { form: D };
}
function e0e(e) {
  const t = { aborted: !1, priority: e };
  return {
    signal: t,
    abort() {
      t.aborted = !0;
    }
  };
}
function t0e(e, t) {
  if (ct(e))
    return !t || ct(t) && Object.keys(t).length === 0 ? Tn(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(ct))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : n && a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? e ? t : null : e && t ? [t] : null;
}
function r0e(e, t) {
  if (ct(e))
    return !t || ct(t) && Object.keys(t).length === 0 ? Tn(e, null) : void 0;
  if (Array.isArray(e)) {
    if (e.some(ct))
      return;
    const r = Array.isArray(t) ? t : [];
    return e.map((n, i) => {
      const a = r[i];
      return Array.isArray(a) && a.length === 0 ? null : a || null;
    });
  }
  return Array.isArray(t) && t.length === 0 ? null : Array.isArray(t) ? t : t ? [t] : null;
}
function n0e([e, t]) {
  return mo(t, e, t0e);
}
function i0e([e, t]) {
  return mo(t, e, r0e);
}
function a0e(e) {
  return function(r, n, i) {
    const a = Array.isArray(r) ? r : [r], o = new Array(a.length), s = e(i), l = s.set, d = s.subscribe;
    let c;
    function u() {
      c = a.map((f, p) => f.subscribe((m) => {
        o[p] = m, l(n(o));
      }));
    }
    function h() {
      c?.forEach((f) => f());
    }
    return s.subscribe = function(p) {
      const m = d(p);
      return () => {
        m();
      };
    }, [s, u, h];
  };
}
function o0e(e, t) {
  var r, n, i, a, o, s, l, d, c;
  const u = a0e(e), h = t.initialValues = t.initialValues ? Ms(fg(En(t.initialValues), t.transform)) : {}, f = ma(Wl(h), !1), p = e(f), m = e(0), [y, v, b] = u([p, m], ([ze, Be]) => Ou(ze, (Qt) => !!Qt) && Be >= 1, !1);
  delete y.set, delete y.update;
  function $(ze) {
    let Be;
    return async function(Qt, Cr, ar, $r = !1) {
      if (!ar || !Qt)
        return;
      let Br = Cr && Object.keys(Cr).length > 0 ? Cr : Tn(Qt, []);
      const pr = e0e($r);
      if ((!Be?.signal.priority || $r) && (Be?.abort(), Be = pr), Be.signal.priority && !$r)
        return;
      m.update((xn) => xn + 1);
      const ln = Wue(Wl(Qt), ar);
      return ln.forEach(async (xn) => {
        const Df = await xn;
        pr.signal.aborted || (Br = ml([Br, Df]), ze.set(Br));
      }), await Promise.all(ln), Be = void 0, m.update((xn) => xn - 1), Br;
    };
  }
  let _ = Tn(f, []);
  const x = e(h), S = Tn(f, []), A = e(S), N = e(En(S)), [P, D, T] = u([
    A,
    N
  ], ml, En(S)), I = Tn(f, []), j = e(I), F = e(En(I)), [Z, te, Y] = u([
    j,
    F
  ], ml, En(I)), [Q, R, re] = u([P, p], n0e, En(S)), [he, ge, ce] = u([Z, p], i0e, En(I));
  let W = !1;
  const [oe, le, Fe] = u(P, ([ze]) => {
    var Be;
    return W ? !Ou(ze, (lt) => Array.isArray(lt) ? lt.length >= 1 : !!lt) : (W = !0, !t.validate && !(!((Be = t.debounced) === null || Be === void 0) && Be.validate));
  }, !t.validate && !(!((r = t.debounced) === null || r === void 0) && r.validate));
  delete oe.set, delete oe.update;
  const We = e(!1), St = e(!1), bt = e(null), Ct = $(A), _t = $(j), G = $(N), M = $(F), ue = Ph(G, (o = (i = (n = t.debounced) === null || n === void 0 ? void 0 : n.validateTimeout) !== null && i !== void 0 ? i : (a = t.debounced) === null || a === void 0 ? void 0 : a.timeout) !== null && o !== void 0 ? o : 300, {
    onInit: () => {
      m.update((ze) => ze + 1);
    },
    onEnd: () => {
      m.update((ze) => ze - 1);
    }
  }), ie = Ph(M, (c = (l = (s = t.debounced) === null || s === void 0 ? void 0 : s.warnTimeout) !== null && l !== void 0 ? l : (d = t.debounced) === null || d === void 0 ? void 0 : d.timeout) !== null && c !== void 0 ? c : 300);
  async function De(ze, Be) {
    var lt;
    const Qt = Ct(ze, _, Be ?? t.validate, !0);
    if (Be)
      return Qt;
    const Cr = G(ze, _, (lt = t.debounced) === null || lt === void 0 ? void 0 : lt.validate, !0);
    return ml(await Promise.all([Qt, Cr]));
  }
  async function je(ze, Be) {
    var lt;
    const Qt = _t(ze, _, Be ?? t.warn, !0);
    if (Be)
      return Qt;
    const Cr = M(ze, _, (lt = t.debounced) === null || lt === void 0 ? void 0 : lt.warn, !0);
    return ml(await Promise.all([Qt, Cr]));
  }
  let He = S, _e = I;
  function ot() {
    const ze = x.subscribe((ar) => {
      var $r, Br;
      const pr = Wl(ar);
      Ct(pr, _, t.validate), _t(pr, _, t.warn), ue(pr, _, ($r = t.debounced) === null || $r === void 0 ? void 0 : $r.validate), ie(pr, _, (Br = t.debounced) === null || Br === void 0 ? void 0 : Br.warn);
    }), Be = p.subscribe((ar) => {
      _ = Tn(ar, []);
    }), lt = P.subscribe((ar) => {
      He = ar;
    }), Qt = Z.subscribe((ar) => {
      _e = ar;
    });
    D(), le(), te(), R(), ge(), v();
    function Cr() {
      ze(), re(), T(), Y(), ce(), Fe(), b(), Be(), lt(), Qt();
    }
    return Cr;
  }
  function Nt(ze) {
    A.set(ze(He)), N.set({});
  }
  function ir(ze) {
    j.set(ze(_e)), F.set({});
  }
  function dr(ze) {
    Nt(() => ze);
  }
  function La(ze) {
    ir(() => ze);
  }
  return Q.set = dr, Q.update = Nt, he.set = La, he.update = ir, {
    data: x,
    errors: Q,
    warnings: he,
    touched: p,
    isValid: oe,
    isSubmitting: We,
    isDirty: St,
    isValidating: y,
    interacted: bt,
    validateErrors: De,
    validateWarnings: je,
    cleanup: t.preventStoreStart ? () => {
    } : ot(),
    start: ot
  };
}
function s0e(e, t) {
  var r, n;
  (r = e.extend) !== null && r !== void 0 || (e.extend = []), (n = e.debounced) !== null && n !== void 0 || (e.debounced = {}), e.validate && !Array.isArray(e.validate) && (e.validate = [e.validate]), e.debounced.validate && !Array.isArray(e.debounced.validate) && (e.debounced.validate = [e.debounced.validate]), e.transform && !Array.isArray(e.transform) && (e.transform = [e.transform]), e.warn && !Array.isArray(e.warn) && (e.warn = [e.warn]), e.debounced.warn && !Array.isArray(e.debounced.warn) && (e.debounced.warn = [e.debounced.warn]);
  function i(te, { debounced: Y, level: Q } = {
    debounced: !1,
    level: "error"
  }) {
    var R;
    const re = Q === "error" ? "validate" : "warn";
    (R = e.debounced) !== null && R !== void 0 || (e.debounced = {});
    const he = Y ? e.debounced : e;
    he[re] ? he[re] = [
      ...he[re],
      te
    ] : he[re] = [te];
  }
  function a(te) {
    e.transform ? e.transform = [
      ...e.transform,
      te
    ] : e.transform = [te];
  }
  const o = Array.isArray(e.extend) ? e.extend : [e.extend];
  let s = [];
  const l = () => s, d = (te) => {
    s = te;
  }, { isSubmitting: c, isValidating: u, data: h, errors: f, warnings: p, touched: m, isValid: y, isDirty: v, cleanup: b, start: $, validateErrors: _, validateWarnings: x, interacted: S } = o0e(t.storeFactory, e), A = h.update, N = h.set, P = (te) => A((Y) => Ms(fg(te(Y), e.transform))), D = (te) => N(Ms(fg(te, e.transform)));
  h.update = P, h.set = D;
  const T = Jue({
    config: e,
    validateErrors: _,
    validateWarnings: x,
    _getCurrentExtenders: l,
    stores: {
      data: h,
      errors: f,
      warnings: p,
      touched: m,
      isSubmitting: c,
      isDirty: v,
      interacted: S
    }
  }), { createSubmitHandler: I, handleSubmit: j } = T.public;
  s = o.map((te) => te({
    stage: "SETUP",
    errors: f,
    warnings: p,
    touched: m,
    data: h,
    isDirty: v,
    isValid: y,
    isValidating: u,
    isSubmitting: c,
    interacted: S,
    config: e,
    addValidator: i,
    addTransformer: a,
    setFields: T.public.setFields,
    reset: T.public.reset,
    validate: T.public.validate,
    handleSubmit: j,
    createSubmitHandler: I
  }));
  const F = Object.assign({
    config: e,
    stores: {
      data: h,
      touched: m,
      errors: f,
      warnings: p,
      isSubmitting: c,
      isValidating: u,
      isValid: y,
      isDirty: v,
      interacted: S
    },
    createSubmitHandler: I,
    handleSubmit: j,
    helpers: Object.assign(Object.assign({}, T.public), {
      addTransformer: a,
      addValidator: i
    }),
    extender: o,
    _getCurrentExtenders: l,
    _setCurrentExtenders: d
  }, T.private), { form: Z } = Xue(F);
  return Object.assign({
    data: h,
    errors: f,
    warnings: p,
    touched: m,
    isValid: y,
    isSubmitting: c,
    isValidating: u,
    isDirty: v,
    interacted: S,
    form: Z,
    cleanup: b,
    startStores: $
  }, T.public);
}
function l0e(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function d0e(e) {
  const t = {}, r = {};
  function n(i) {
    if (!i)
      return e();
    if (!t[i.toString()]) {
      const o = V(c8(Qe(e), i));
      r[i.toString()] = o, t[i.toString()] = i;
    }
    const [a] = r[i.toString()];
    return a();
  }
  return fe(() => {
    const i = e(), a = Object.keys(t);
    for (const o of a) {
      const s = t[o], l = c8(i, s), [d, c] = r[s.toString()];
      pg(l, Qe(d)) || c(l);
    }
  }), n;
}
function c0e(e) {
  return function(r) {
    return so((n) => (fe(() => r(e())), n));
  };
}
const u0e = (e) => {
  const [t, r] = V(e);
  function n(s) {
    r(() => s);
  }
  function i(s) {
    r(s);
  }
  const a = d0e(t), o = c0e(t);
  return a.subscribe = o, a.set = n, a.update = i, a;
};
function h0e(e) {
  const t = s0e(e ?? {}, {
    storeFactory: u0e
  }), { form: r, cleanup: n, startStores: i, data: a, errors: o, warnings: s, touched: l } = t, d = l0e(t, ["form", "cleanup", "startStores", "data", "errors", "warnings", "touched"]);
  let c = null;
  const u = () => c?.(), [h, f] = V(null);
  fe(() => {
    const m = h();
    m && (u(), c = r(m).destroy);
  });
  const p = (m) => (f(m), {
    destroy: u
  });
  return sr(u), sr(n), Object.assign(Object.assign({}, d), { data: a, errors: o, warnings: s, touched: l, form: p });
}
function f0e(e) {
  function t(r) {
    return r.issues.reduce((n, i) => i.path ? Fd(n, i.path.join("."), (a) => !a || !Array.isArray(a) ? [i.message] : [...a, i.message]) : n, {});
  }
  return async function(n) {
    try {
      await e.parseAsync(n);
    } catch (i) {
      return t(i);
    }
  };
}
function p0e({ schema: e, level: t = "error" }) {
  return function(n) {
    if (n.stage !== "SETUP")
      return {};
    const i = f0e(e);
    return n.addValidator(i, { level: t }), {};
  };
}
var m0e = /* @__PURE__ */ ae("<div>"), g0e = /* @__PURE__ */ ae('<form><div class="flex justify-end">');
const f8 = (e) => [...e].sort((t, r) => t.lastName.localeCompare(r.lastName) || t.firstName.localeCompare(r.firstName)), Tp = (e) => e?.id ? `${e.firstName} ${e.lastName}, ${e.npi}` : "Select a supervisor", v0e = (e) => {
  const t = Rn(), [r, n] = V([]), [i, a] = V([]), [o, s] = V(!1), l = K(() => r().find((u) => u.id === e.store.supervisorId?.value)), d = (u) => {
    const h = u.toLowerCase();
    return h ? r().filter((p) => Tp(p).toLowerCase().includes(h)) : r();
  };
  lr(async () => {
    const {
      data: {
        supervisors: u,
        mostRecentSupervisor: h
      }
    } = await t.sdk.apolloClinical.query({
      query: VP,
      // This query takes no variables so nothing indicates to the
      // client-side cache when to refetch the data
      fetchPolicy: "network-only"
    }), f = f8(u.filter((p) => !!p));
    n(f), a(f), h && (e.actions.updateFormValue({
      key: "supervisorId",
      value: h.id
    }), s(!0));
  });
  const c = (u) => {
    n((h) => f8([...h, u])), e.actions.updateFormValue({
      key: "supervisorId",
      value: u.id
    });
  };
  return g(Mn, {
    addChildrenDivider: !0,
    class: "pb-2",
    get children() {
      return [g(Ee, {
        color: "gray",
        children: "Supervising Physician"
      }), (() => {
        var u = m0e();
        return L(u, g(H, {
          get when() {
            return !o();
          },
          get children() {
            return g(Ee, {
              size: "sm",
              color: "black",
              class: "pb-2",
              children: "Some pharmacies require supervising physician information for this prescription. Adding it here can help avoid callbacks and delays."
            });
          }
        }), null), L(u, g(H, {
          get when() {
            return r().length > 0;
          },
          get children() {
            return g(at, {
              label: "Supervisor",
              showOptionalSubtext: !0,
              get children() {
                return g(_r, {
                  get value() {
                    return l();
                  },
                  setSelected: (h) => {
                    e.actions.updateFormValue({
                      key: "supervisorId",
                      value: h?.id || void 0
                    }), a(r());
                  },
                  get children() {
                    return [g(_r.Input, {
                      onInput: (h) => a(d(h.currentTarget.value || "")),
                      displayValue: (h) => Tp(h),
                      showClear: !0
                    }), g(_r.Options, {
                      get children() {
                        return g(yt, {
                          get each() {
                            return i();
                          },
                          children: (h) => g(_r.Option, {
                            get key() {
                              return h.id;
                            },
                            value: h,
                            get children() {
                              return Tp(h);
                            }
                          })
                        });
                      }
                    })];
                  }
                });
              }
            });
          }
        }), null), L(u, g(b0e, {
          get hasSupervisors() {
            return r().length > 0;
          },
          onCreated: c
        }), null), u;
      })()];
    }
  });
}, y0e = Rue({
  firstName: s8({
    required_error: "First name is required"
  }).min(1, "First name is required"),
  lastName: s8({
    required_error: "Last name is required"
  }).min(1, "Last name is required"),
  npi: Lue.string({
    required_error: "NPI is required"
  }).regex(/^[0-9]{10}$/, "Enter a valid 10-digit NPI")
}), b0e = (e) => {
  const t = Rn(), r = va(), [n, i] = V(!1), [a, o] = V(!1), {
    form: s,
    errors: l,
    validate: d,
    isValid: c,
    reset: u
  } = h0e({
    onSubmit: async (h) => {
      i(!0);
      try {
        if (d(), !c())
          throw new Error();
        const {
          data: f
        } = await t.sdk.apolloClinical.mutate({
          mutation: UP,
          variables: {
            firstName: h.firstName,
            lastName: h.lastName,
            npi: String(h.npi)
          }
        });
        f?.createSupervisor && (e.onCreated(f.createSupervisor), o(!1), u());
      } catch {
        rr({
          header: "Error creating new supervisor",
          body: "Please try again.",
          status: "error"
        });
      } finally {
        i(!1);
      }
    },
    extend: p0e({
      schema: y0e
    })
  });
  return g(Ok, {
    closedLabel: "Add new",
    openLabel: "Cancel",
    get alwaysOpen() {
      return !e.hasSupervisors;
    },
    get isOpen() {
      return a();
    },
    onOpenChange: (h) => {
      o(h), h || u();
    },
    get children() {
      var h = g0e(), f = h.firstChild;
      return Zt(s, h), Wc(h, "id", r), L(h, g(at, {
        label: "First Name",
        get error() {
          return l().firstName?.[0];
        },
        get children() {
          return g(Dt, {
            name: "firstName"
          });
        }
      }), f), L(h, g(at, {
        label: "Last Name",
        get error() {
          return l().lastName?.[0];
        },
        get children() {
          return g(Dt, {
            name: "lastName"
          });
        }
      }), f), L(h, g(at, {
        label: "NPI",
        get error() {
          return l().npi?.[0];
        },
        get children() {
          return g(Dt, {
            name: "npi",
            type: "number",
            inputMode: "numeric"
          });
        }
      }), f), L(f, g(xt, {
        type: "submit",
        form: r,
        variant: "secondary",
        get disabled() {
          return n();
        },
        get loading() {
          return n();
        },
        children: "Add supervisor"
      })), h;
    }
  });
};
var w0e = /* @__PURE__ */ ae('<div class="w-full flex justify-center">'), $0e = /* @__PURE__ */ ae("<div>"), k0e = /* @__PURE__ */ ae('<div class="m-3 gap-4">'), _0e = /* @__PURE__ */ ae('<div class="flex flex-row justify-end">'), x0e = /* @__PURE__ */ ae('<div><div><div class="flex flex-col gap-8">'), S0e = /* @__PURE__ */ ae("<div>No errors...");
const C0e = (e) => e ? !!(e.street1?.trim() && e.city?.trim() && e.state?.trim() && e.postalCode?.trim()) : !1, aS = (e) => e === Q1.FulfillmentType.PickUp || e === Q1.FulfillmentType.MailOrder, E0e = (e, t) => aS(e) && !t, A0e = Ie`
  query ScreenDraftedPrescriptionsQuery(
    $draftedPrescriptions: [DraftedPrescriptionInput!]!
    $patientId: ID!
  ) {
    prescriptionScreen(draftedPrescriptions: $draftedPrescriptions, patientId: $patientId) {
      alerts {
        type
        description
        involvedEntities {
          id
          name
          __typename
        }
        severity
      }
    }
  }
`, T0e = ({
  title: e,
  state: t
}) => !!e && !!t && ["NP", "PA"].includes(e) && ["CA", "FL", "GA", "MI", "MO", "NC", "OK", "SC", "TN", "TX", "VA"].includes(t.toUpperCase());
function O0e(e) {
  let t, r;
  const {
    draftPrescriptions: n,
    prescriptionIds: i,
    tryUpdatePrescriptionStates: a,
    isLoadingPrefills: o
  } = Vs(), s = yf(), {
    dispatchFormValidate: l,
    dispatchPrescriptionsCreated: d,
    dispatchPrescriptionsError: c,
    dispatchOrderCreated: u,
    dispatchOrderError: h,
    dispatchClinicalAlertAcknowledge: f,
    dispatchClinicalAlertCancel: p,
    dispatchAnalyticsTrackEvent: m
  } = Ma(), [y, v] = V(!1), b = Rn(), [$, _] = V(e.initialShowForm), [x, S] = V([]), [A, N] = V(!0), [P, D] = V(b?.authentication.state.isAuthenticated || !1), [, T] = Pd(), [I, j] = V([]), [F, Z] = V(!1), te = K(() => {
    const ie = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address;
    return C0e(ie);
  }), Y = K(() => !!e.formStore?.patient?.value?.preferredPharmacies?.length), Q = K(() => !e.optionalPatientAddress || !e.enableOrder ? !1 : aS(s.fulfillmentType()) && !te()), [R, re] = V(!1);
  let he = "";
  e.additionalNotes && (he = `${e.additionalNotes}

`), e.weight && (he = `${he}${due(e.weight, e?.weightUnit)}`), lr(async () => {
    e.address && e.formActions.updateFormValue({
      key: "address",
      value: e.address
    }), t.addEventListener("photon-ticket-created-duplicate", () => {
      x1(e.formActions, he ? {
        notes: he
      } : void 0), s.setFulfillmentType(void 0), s.setPharmacyId(void 0), s.setUpdatePreferredPharmacy(!1);
    });
    const {
      data: {
        me: ie
      }
    } = await b.sdk.apolloClinical.query({
      query: zP
    }), De = T0e({
      title: ie.name?.title || void 0,
      state: ie.address?.state || void 0
    });
    v(De);
  }), fe(() => {
    !b?.authentication.state.isAuthenticated && !b?.authentication.state.isLoading && !b?.authentication.state.error && b?.autoLogin && b?.authentication.login({
      appState: {
        returnTo: window.location.pathname
      }
    });
  }), fe(() => {
    N(b?.authentication.state.isLoading || !1);
  }), fe(() => {
    D(b?.authentication.state.isAuthenticated || !1);
  });
  const ge = K(() => Zm(["write:prescription"], b?.authentication.state.permissions || [])), ce = K(() => {
    const ie = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address;
    return ie && ie.street1;
  }), W = K(() => (e.formStore?.address?.value ?? e.formStore?.patient?.value?.address)?.id), oe = K(() => {
    const ie = e.formStore?.address?.value ?? e.formStore?.patient?.value?.address ?? {}, {
      __typename: De,
      name: je,
      ...He
    } = ie;
    return {
      street2: "",
      country: "US",
      ...He
    };
  }), le = (ie) => {
    const De = /* @__PURE__ */ new Set();
    return ie.filter((je) => {
      const He = je.treatment.id;
      return De.has(He) ? !1 : (De.add(He), !0);
    });
  }, Fe = async () => {
    const ie = e.formStore.treatment?.value?.id, De = n().map(I0e);
    ie && De.push({
      treatment: {
        id: ie
      }
    });
    const je = le(De), {
      data: He
    } = await M.query({
      query: A0e,
      variables: {
        patientId: e.formStore.patient?.value.id,
        draftedPrescriptions: je
      }
    });
    j(He?.prescriptionScreen?.alerts ?? []);
  };
  fe(() => {
    n().length > 0 && Fe();
  });
  const We = () => {
    re(!0);
  }, St = () => T.setIsCombineDialogOpen(!0, () => bt(), W(), oe()), bt = async () => {
    if (A())
      return;
    if (S([]), Z(!1), !ge())
      return rr({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    if (e.enableOrder && E0e(s.fulfillmentType(), te())) {
      N(!1), rr({
        status: "error",
        header: "Address required",
        body: "Please add a patient address to place a local pickup or mail order."
      }), S([{
        key: "address",
        error: "Please enter an address for patient..."
      }]);
      return;
    }
    const De = e.enableOrder && (!e.optionalPatientAddress || Y()) ? ["patient", "address"] : ["patient"];
    e.formActions.validate(De);
    const je = e.formActions.getErrors(De);
    je.length === 0 ? (N(!0), e.formActions.updateFormValue({
      key: "errors",
      value: []
    }), e.enableOrder ? await _t() : await Ct(), d(n())) : (S(je), h(je), N(!1), rr({
      status: "error",
      header: "Error Creating Order",
      body: "Please check your order details"
    }));
  }, Ct = async () => {
    try {
      await a(i(), Zx.Active), m("ctaClicked", {
        name: "Prescriptions Activated",
        buttonText: "Send",
        prescriptionCount: n().length
      });
    } catch (ie) {
      c([ie]);
    }
    N(!1);
  }, _t = async () => {
    const ie = b.getSDK().clinical.order.createOrder({}), De = b.getSDK().clinical.patient.removePatientPreferredPharmacy({}), je = b.getSDK().clinical.patient.updatePatient({});
    try {
      const He = s.pharmacyId();
      if (s.updatePreferredPharmacy() && He && s.fulfillmentType() === "PICK_UP") {
        const dr = e.formStore.patient?.value;
        dr?.preferredPharmacies && dr?.preferredPharmacies?.length > 0 && De({
          variables: {
            patientId: dr.id,
            pharmacyId: dr.preferredPharmacies[0].id
          },
          awaitRefetchQueries: !1
        }), je({
          variables: {
            id: dr.id,
            preferredPharmacies: [He]
          },
          awaitRefetchQueries: !1
        });
      }
      let _e = s.autoRoutedPharmacyId();
      He && (_e = He), _e || (_e = "");
      const ot = y() && e.formStore.supervisorId?.value ? e.formStore.supervisorId.value : void 0, {
        data: Nt,
        errors: ir
      } = await ie({
        variables: {
          ...e.externalOrderId ? {
            externalId: e.externalOrderId
          } : {},
          ...e.groupId ? {
            groupId: e.groupId
          } : {},
          patientId: e.formStore.patient?.value.id,
          pharmacyId: _e,
          fulfillmentType: s.fulfillmentType() || "",
          ...W() ? {
            addressId: W()
          } : ce() ? {
            address: oe()
          } : {},
          fills: i().map((dr) => ({
            prescriptionId: dr
          })),
          supervisorId: ot
        },
        refetchQueries: [],
        awaitRefetchQueries: !1
      });
      if (N(!1), ir) {
        h(ir);
        return;
      }
      u(Nt.createOrder), m("ctaClicked", {
        name: "Order Sent",
        buttonText: "Send",
        orderId: Nt.createOrder.id,
        prescriptionCount: n().length,
        fulfillmentType: s.fulfillmentType() || "SEND_TO_PATIENT",
        hasPreferredPharmacy: Y(),
        setAsPreferred: s.updatePreferredPharmacy(),
        pharmacyId: _e || null,
        isCombinedOrder: !1
      });
    } catch (He) {
      h([He]), N(!1), rr({
        status: "error",
        header: "Error Creating Order",
        body: He?.message
      });
    }
  }, G = () => I().length > 0 && F() === !1 ? We() : e.enableCombineAndDuplicate && T.hasRoutingOrder() ? St() : bt();
  fe(() => {
    e.triggerSubmit && Qe(() => G());
  }), fe(() => {
    l(!!(n().length > 0 && e.formStore.patient?.value), e.formStore);
  });
  const M = b.sdk.apolloClinical, ue = K(() => !e.patientId || e.patientId === e.formStore.patient?.value?.id || e.patientId === e.formStore.patient?.value?.externalId);
  return (() => {
    var ie = x0e(), De = ie.firstChild, je = De.firstChild, He = t;
    return typeof He == "function" ? Zt(He, ie) : t = ie, L(ie, g(H, {
      get when() {
        return At(() => !!(R() && I().length > 0))() && !F();
      },
      get children() {
        return g(ene, {
          get alerts() {
            return I();
          },
          get isOpen() {
            return R();
          },
          onIgnoreWarningAndCreateAnyway: () => {
            N(!1), Z(!0), re(!1), G(), f(I()), m("ctaClicked", {
              name: "Screening Alert Acknowledged",
              screeningAlertCount: I().length,
              buttonText: "Send"
            });
          },
          onRevisitPrescriptions: () => {
            N(!1), re(!1), p(I()), m("ctaClicked", {
              name: "Screening Alert Canceled",
              screeningAlertCount: I().length,
              buttonText: "Cancel"
            });
          }
        });
      }
    }), De), L(ie, g(H, {
      get when() {
        return e.enableCombineAndDuplicate;
      },
      get children() {
        return [g(ya.DuplicateDialog, {}), g(ya.CombineDialog, {}), g(ya.IssueDialog, {})];
      }
    }), De), L(De, g(dae, {
      get buffer() {
        return e?.toastBuffer || 0;
      }
    }), je), L(je, g(H, {
      get when() {
        return At(() => !!(!b || A()))() && !P();
      },
      get children() {
        var _e = w0e();
        return L(_e, g(aa, {
          color: "green"
        })), _e;
      }
    }), null), L(je, g(kx, {
      permissions: ["read:patient"],
      get children() {
        return g(wae, {
          client: M,
          get children() {
            return [g(H, {
              get when() {
                return !ge();
              },
              get children() {
                return g(du, {
                  type: "warning",
                  header: "You do not have permission to prescribe",
                  message: "You have access to see the form but you will not be able to submit any prescriptions."
                });
              }
            }), g(iue, {
              get actions() {
                return e.formActions;
              },
              get store() {
                return e.formStore;
              },
              get patientId() {
                return e.patientId;
              },
              client: b,
              get enableOrder() {
                return e.enableOrder;
              },
              get address() {
                return e.address;
              },
              get weight() {
                return e.weight;
              },
              get weightUnit() {
                return e.weightUnit;
              },
              get enableMedHistory() {
                return e.enableMedHistory;
              },
              get enableMedHistoryLinks() {
                return e.enableMedHistoryLinks ?? !1;
              },
              get enableMedHistoryRefillButton() {
                return e.enableMedHistoryRefillButton ?? !1;
              },
              get hidePatientCard() {
                return e.hidePatientCard;
              },
              get optionalPatientAddress() {
                return e.optionalPatientAddress;
              }
            }), g(H, {
              get when() {
                return (
                  // if patientId is passed in, we need to ensure it matches the patient id in our store
                  // so we are not referencing stale data
                  At(() => !!ue())() && // if orders are enabled, we need a patient's address (unless address is optional)
                  (e.formStore.patient?.value?.address || // if orders are disabled, we need only a patient id
                  e.formStore.patient?.value?.id && !e.enableOrder || // optionalpatientaddress skips address requirement unless a preferred pharmacy is set
                  e.formStore.patient?.value?.id && e.optionalPatientAddress && !Y())
                );
              },
              get children() {
                return [g(H, {
                  get when() {
                    return e.enableCombineAndDuplicate;
                  },
                  get children() {
                    return g(ya.Card, {});
                  }
                }), g(H, {
                  get when() {
                    return $();
                  },
                  get children() {
                    var _e = $0e(), ot = r;
                    return typeof ot == "function" ? Zt(ot, _e) : r = _e, L(_e, g(Hde, {
                      get hideAddToTemplates() {
                        return e.hideTemplates;
                      },
                      get actions() {
                        return e.formActions;
                      },
                      get store() {
                        return e.formStore;
                      },
                      get weight() {
                        return e.weight;
                      },
                      get weightUnit() {
                        return e.weightUnit;
                      },
                      prefillNotes: he,
                      get enableCombineAndDuplicate() {
                        return e.enableCombineAndDuplicate;
                      },
                      screenDraftedPrescriptions: function() {
                        Fe();
                      },
                      draftedPrescriptionChanged: function() {
                        Fe();
                      },
                      get screeningAlerts() {
                        return I();
                      },
                      get catalogId() {
                        return e.catalogId;
                      },
                      get allowOffCatalogSearch() {
                        return e.allowOffCatalogSearch;
                      },
                      get disableList() {
                        return e.disableList;
                      }
                    })), _e;
                  }
                }), g(Bce, {
                  prescriptionRef: r,
                  get actions() {
                    return e.formActions;
                  },
                  get store() {
                    return e.formStore;
                  },
                  setIsEditing: () => _(!0),
                  handleDraftPrescriptionsChange: function() {
                    Fe();
                  },
                  get screeningAlerts() {
                    return I();
                  },
                  get routingConstraints() {
                    return s.routingConstraints();
                  },
                  get enableOrder() {
                    return e.enableOrder;
                  },
                  get onAddAnotherClick() {
                    return $() ? void 0 : () => _(!0);
                  }
                }), g(H, {
                  get when() {
                    return At(() => !!e.enableOrder)() && y();
                  },
                  get children() {
                    return g(v0e, {
                      get actions() {
                        return e.formActions;
                      },
                      get store() {
                        return e.formStore;
                      }
                    });
                  }
                }), g(H, {
                  get when() {
                    return At(() => !!e.enableOrder)() && !s.isAutoRouted();
                  },
                  get children() {
                    return g(Gce, {
                      get store() {
                        return e.formStore;
                      }
                    });
                  }
                }), g(H, {
                  get when() {
                    return Q() && e.formStore.patient?.value?.id;
                  },
                  get children() {
                    return g(ok, {
                      get patientId() {
                        return e.formStore.patient?.value?.id;
                      },
                      showRequiredBanner: !1,
                      openStateDropdownUpward: !0,
                      setAddress: (_e) => {
                        e.formActions.updateFormValue({
                          key: "address",
                          value: _e
                        }), e.formActions.updateFormValue({
                          key: "patient",
                          value: {
                            ...e.formStore.patient.value,
                            address: _e
                          }
                        });
                      }
                    });
                  }
                }), g(H, {
                  get when() {
                    return At(() => !!e.enableOrder)() && s.isAutoRouted();
                  },
                  get children() {
                    return g(lue, {
                      get pharmacyId() {
                        return s.autoRoutedPharmacyId();
                      }
                    });
                  }
                }), g(H, {
                  get when() {
                    return !e.hideSubmit;
                  },
                  get children() {
                    return [g(H, {
                      get when() {
                        return x().length > 0 && e.enableOrder;
                      },
                      get children() {
                        var _e = k0e();
                        return L(_e, g(yt, {
                          get each() {
                            return x();
                          },
                          get fallback() {
                            return S0e();
                          },
                          children: ({
                            key: ot,
                            error: Nt
                          }) => g(du, {
                            type: "warning",
                            header: `Error with ${ot}`,
                            message: Nt
                          })
                        })), _e;
                      }
                    }), (() => {
                      var _e = _0e();
                      return L(_e, g(xt, {
                        get loading() {
                          return o() || A();
                        },
                        onClick: G,
                        children: "Send"
                      })), _e;
                    })()];
                  }
                })];
              }
            })];
          }
        });
      }
    }), null), ie;
  })();
}
const I0e = (e) => ({
  dispenseAsWritten: e.dispenseAsWritten || void 0,
  dispenseQuantity: e.dispenseQuantity,
  dispenseUnit: e.dispenseUnit,
  fillsAllowed: e.fillsAllowed,
  daysSupply: e.daysSupply || void 0,
  instructions: e.instructions,
  notes: e.notes || void 0,
  // TODO: is effectiveDate needed to screen prescription?
  effectiveDate: e.effectiveDate,
  treatment: {
    id: e.treatment.id
  }
}), P0e = ".remove-icon-button::part(base):hover,.remove-icon-button::part(base):focus{--tw-text-opacity: 1;color:rgb(248,113,113,var(--tw-text-opacity))}.edit-icon-button::part(base):hover,.edit-icon-button::part(base):focus{--tw-text-opacity: 1;color:rgb(234,179,8,var(--tw-text-opacity))}.enable-switch{--width: 60px;--height: 32px;--thumb-size: 26px;--sl-color-primary-600: #22c55e}";
_n.define("sl-icon-button");
var N0e = Ln`
  :host {
    display: inline-block;
  }

  :host([size='small']) {
    --height: var(--sl-toggle-size-small);
    --thumb-size: calc(var(--sl-toggle-size-small) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-small);
  }

  :host([size='medium']) {
    --height: var(--sl-toggle-size-medium);
    --thumb-size: calc(var(--sl-toggle-size-medium) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-medium);
  }

  :host([size='large']) {
    --height: var(--sl-toggle-size-large);
    --thumb-size: calc(var(--sl-toggle-size-large) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-large);
  }

  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-input-font-family);
    font-size: inherit;
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--sl-color-neutral-400);
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    border-radius: var(--height);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color;
  }

  .switch__control .switch__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: 50%;
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    translate: calc((var(--width) - var(--height)) / -2);
    transition:
      var(--sl-transition-fast) translate ease,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) box-shadow;
  }

  .switch__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-400);
  }

  /* Focus */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked */
  .switch--checked .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch--checked .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Checked + hover */
  .switch.switch--checked:not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
  }

  /* Checked + focus */
  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__label {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .switch__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  @media (forced-colors: active) {
    .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb,
    .switch--checked .switch__control .switch__thumb {
      background-color: ButtonText;
    }
  }
`, oS = (e = "value") => (t, r) => {
  const n = t.constructor, i = n.prototype.attributeChangedCallback;
  n.prototype.attributeChangedCallback = function(a, o, s) {
    var l;
    const d = n.getPropertyOptions(e), c = typeof d.attribute == "string" ? d.attribute : e;
    if (a === c) {
      const u = d.converter || ld, f = (typeof u == "function" ? u : (l = u?.fromAttribute) != null ? l : ld.fromAttribute)(s, d.type);
      this[e] !== f && (this[r] = f);
    }
    i.call(this, a, o, s);
  };
}, sS = Ln`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`, cc = /* @__PURE__ */ new WeakMap(), uc = /* @__PURE__ */ new WeakMap(), hc = /* @__PURE__ */ new WeakMap(), Op = /* @__PURE__ */ new WeakSet(), X0 = /* @__PURE__ */ new WeakMap(), lS = class {
  constructor(e, t) {
    this.handleFormData = (r) => {
      const n = this.options.disabled(this.host), i = this.options.name(this.host), a = this.options.value(this.host), o = this.host.tagName.toLowerCase() === "sl-button";
      this.host.isConnected && !n && !o && typeof i == "string" && i.length > 0 && typeof a < "u" && (Array.isArray(a) ? a.forEach((s) => {
        r.formData.append(i, s.toString());
      }) : r.formData.append(i, a.toString()));
    }, this.handleFormSubmit = (r) => {
      var n;
      const i = this.options.disabled(this.host), a = this.options.reportValidity;
      this.form && !this.form.noValidate && ((n = cc.get(this.form)) == null || n.forEach((o) => {
        this.setUserInteracted(o, !0);
      })), this.form && !this.form.noValidate && !i && !a(this.host) && (r.preventDefault(), r.stopImmediatePropagation());
    }, this.handleFormReset = () => {
      this.options.setValue(this.host, this.options.defaultValue(this.host)), this.setUserInteracted(this.host, !1), X0.set(this.host, []);
    }, this.handleInteraction = (r) => {
      const n = X0.get(this.host);
      n.includes(r.type) || n.push(r.type), n.length === this.options.assumeInteractionOn.length && this.setUserInteracted(this.host, !0);
    }, this.checkFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const r = this.form.querySelectorAll("*");
        for (const n of r)
          if (typeof n.checkValidity == "function" && !n.checkValidity())
            return !1;
      }
      return !0;
    }, this.reportFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const r = this.form.querySelectorAll("*");
        for (const n of r)
          if (typeof n.reportValidity == "function" && !n.reportValidity())
            return !1;
      }
      return !0;
    }, (this.host = e).addController(this), this.options = Us({
      form: (r) => {
        const n = r.form;
        if (n) {
          const a = r.getRootNode().querySelector(`#${n}`);
          if (a)
            return a;
        }
        return r.closest("form");
      },
      name: (r) => r.name,
      value: (r) => r.value,
      defaultValue: (r) => r.defaultValue,
      disabled: (r) => {
        var n;
        return (n = r.disabled) != null ? n : !1;
      },
      reportValidity: (r) => typeof r.reportValidity == "function" ? r.reportValidity() : !0,
      checkValidity: (r) => typeof r.checkValidity == "function" ? r.checkValidity() : !0,
      setValue: (r, n) => r.value = n,
      assumeInteractionOn: ["sl-input"]
    }, t);
  }
  hostConnected() {
    const e = this.options.form(this.host);
    e && this.attachForm(e), X0.set(this.host, []), this.options.assumeInteractionOn.forEach((t) => {
      this.host.addEventListener(t, this.handleInteraction);
    });
  }
  hostDisconnected() {
    this.detachForm(), X0.delete(this.host), this.options.assumeInteractionOn.forEach((e) => {
      this.host.removeEventListener(e, this.handleInteraction);
    });
  }
  hostUpdated() {
    const e = this.options.form(this.host);
    e || this.detachForm(), e && this.form !== e && (this.detachForm(), this.attachForm(e)), this.host.hasUpdated && this.setValidity(this.host.validity.valid);
  }
  attachForm(e) {
    e ? (this.form = e, cc.has(this.form) ? cc.get(this.form).add(this.host) : cc.set(this.form, /* @__PURE__ */ new Set([this.host])), this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit), this.form.addEventListener("reset", this.handleFormReset), uc.has(this.form) || (uc.set(this.form, this.form.reportValidity), this.form.reportValidity = () => this.reportFormValidity()), hc.has(this.form) || (hc.set(this.form, this.form.checkValidity), this.form.checkValidity = () => this.checkFormValidity())) : this.form = void 0;
  }
  detachForm() {
    if (!this.form) return;
    const e = cc.get(this.form);
    e && (e.delete(this.host), e.size <= 0 && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form.removeEventListener("reset", this.handleFormReset), uc.has(this.form) && (this.form.reportValidity = uc.get(this.form), uc.delete(this.form)), hc.has(this.form) && (this.form.checkValidity = hc.get(this.form), hc.delete(this.form)), this.form = void 0));
  }
  setUserInteracted(e, t) {
    t ? Op.add(e) : Op.delete(e), e.requestUpdate();
  }
  doAction(e, t) {
    if (this.form) {
      const r = document.createElement("button");
      r.type = e, r.style.position = "absolute", r.style.width = "0", r.style.height = "0", r.style.clipPath = "inset(50%)", r.style.overflow = "hidden", r.style.whiteSpace = "nowrap", t && (r.name = t.name, r.value = t.value, ["formaction", "formenctype", "formmethod", "formnovalidate", "formtarget"].forEach((n) => {
        t.hasAttribute(n) && r.setAttribute(n, t.getAttribute(n));
      })), this.form.append(r), r.click(), r.remove();
    }
  }
  /** Returns the associated `<form>` element, if one exists. */
  getForm() {
    var e;
    return (e = this.form) != null ? e : null;
  }
  /** Resets the form, restoring all the control to their default value */
  reset(e) {
    this.doAction("reset", e);
  }
  /** Submits the form, triggering validation and form data injection. */
  submit(e) {
    this.doAction("submit", e);
  }
  /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */
  setValidity(e) {
    const t = this.host, r = !!Op.has(t), n = !!t.required;
    t.toggleAttribute("data-required", n), t.toggleAttribute("data-optional", !n), t.toggleAttribute("data-invalid", !e), t.toggleAttribute("data-valid", e), t.toggleAttribute("data-user-invalid", !e && r), t.toggleAttribute("data-user-valid", e && r);
  }
  /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */
  updateValidity() {
    const e = this.host;
    this.setValidity(e.validity.valid);
  }
  /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */
  emitInvalidEvent(e) {
    const t = new CustomEvent("sl-invalid", {
      bubbles: !1,
      composed: !1,
      cancelable: !0,
      detail: {}
    });
    e || t.preventDefault(), this.host.dispatchEvent(t) || e?.preventDefault();
  }
}, dS = Object.freeze({
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: !0,
  valueMissing: !1
});
Object.freeze(kf(Us({}, dS), {
  valid: !1,
  valueMissing: !0
}));
Object.freeze(kf(Us({}, dS), {
  valid: !1,
  customError: !0
}));
const cS = G3(class extends Z3 {
  constructor(e) {
    if (super(e), e.type !== to.PROPERTY && e.type !== to.ATTRIBUTE && e.type !== to.BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
    if (!bx(e)) throw Error("`live` bindings can only contain a single expression");
  }
  render(e) {
    return e;
  }
  update(e, [t]) {
    if (t === _i || t === gr) return t;
    const r = e.element, n = e.name;
    if (e.type === to.PROPERTY) {
      if (t === r[n]) return _i;
    } else if (e.type === to.BOOLEAN_ATTRIBUTE) {
      if (!!t === r.hasAttribute(n)) return _i;
    } else if (e.type === to.ATTRIBUTE && r.getAttribute(n) === t + "") return _i;
    return $se(e), t;
  }
});
var pn = class extends fn {
  constructor() {
    super(...arguments), this.formControlController = new lS(this, {
      value: (e) => e.checked ? e.value || "on" : void 0,
      defaultValue: (e) => e.defaultChecked,
      setValue: (e, t) => e.checked = t
    }), this.hasSlotController = new a0(this, "help-text"), this.hasFocus = !1, this.title = "", this.name = "", this.size = "medium", this.disabled = !1, this.checked = !1, this.defaultChecked = !1, this.form = "", this.required = !1, this.helpText = "";
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleInput() {
    this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleClick() {
    this.checked = !this.checked, this.emit("sl-change");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleKeyDown(e) {
    e.key === "ArrowLeft" && (e.preventDefault(), this.checked = !1, this.emit("sl-change"), this.emit("sl-input")), e.key === "ArrowRight" && (e.preventDefault(), this.checked = !0, this.emit("sl-change"), this.emit("sl-input"));
  }
  handleCheckedChange() {
    this.input.checked = this.checked, this.formControlController.updateValidity();
  }
  handleDisabledChange() {
    this.formControlController.setValidity(!0);
  }
  /** Simulates a click on the switch. */
  click() {
    this.input.click();
  }
  /** Sets focus on the switch. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the switch. */
  blur() {
    this.input.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("help-text"), t = this.helpText ? !0 : !!e;
    return hr`
      <div
        class=${Wn({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-help-text": t
    })}
      >
        <label
          part="base"
          class=${Wn({
      switch: !0,
      "switch--checked": this.checked,
      "switch--disabled": this.disabled,
      "switch--focused": this.hasFocus,
      "switch--small": this.size === "small",
      "switch--medium": this.size === "medium",
      "switch--large": this.size === "large"
    })}
        >
          <input
            class="switch__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${Kt(this.value)}
            .checked=${cS(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            role="switch"
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
            @keydown=${this.handleKeyDown}
          />

          <span part="control" class="switch__control">
            <span part="thumb" class="switch__thumb"></span>
          </span>

          <div part="label" class="switch__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${t ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
pn.styles = [oi, sS, N0e];
q([
  qr('input[type="checkbox"]')
], pn.prototype, "input", 2);
q([
  n0()
], pn.prototype, "hasFocus", 2);
q([
  de()
], pn.prototype, "title", 2);
q([
  de()
], pn.prototype, "name", 2);
q([
  de()
], pn.prototype, "value", 2);
q([
  de({ reflect: !0 })
], pn.prototype, "size", 2);
q([
  de({ type: Boolean, reflect: !0 })
], pn.prototype, "disabled", 2);
q([
  de({ type: Boolean, reflect: !0 })
], pn.prototype, "checked", 2);
q([
  oS("checked")
], pn.prototype, "defaultChecked", 2);
q([
  de({ reflect: !0 })
], pn.prototype, "form", 2);
q([
  de({ type: Boolean, reflect: !0 })
], pn.prototype, "required", 2);
q([
  de({ attribute: "help-text" })
], pn.prototype, "helpText", 2);
q([
  on("checked", { waitUntilFirstUpdate: !0 })
], pn.prototype, "handleCheckedChange", 1);
q([
  on("disabled", { waitUntilFirstUpdate: !0 })
], pn.prototype, "handleDisabledChange", 1);
pn.define("sl-switch");
var fc = /* @__PURE__ */ ae("<style>");
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const D0e = (e) => {
  const {
    actions: t
  } = Of, {
    store: r,
    actions: n
  } = vx({
    dispenseAsWritten: !1,
    patient: void 0,
    treatment: void 0,
    pharmacy: void 0,
    errors: [],
    address: void 0,
    supervisorId: void 0
  });
  return sr(() => {
    t.clearSelectedPatient(), n.reset();
  }), g(uX, {
    get children() {
      return g(ya, {
        get patientId() {
          return r.patient?.value?.id;
        },
        get children() {
          return g(Sre, {
            get patientId() {
              return r.patient?.value?.id;
            },
            get templateIdsPrefill() {
              return e.templateIds?.split(",").map((i) => i.trim()) || [];
            },
            get templateOverrides() {
              return e.templateOverrides || {};
            },
            get prescriptionIdsPrefill() {
              return e.prescriptionIds?.split(",").map((i) => i.trim()) || [];
            },
            get enableCombineAndDuplicate() {
              return e.enableCombineAndDuplicate;
            },
            get children() {
              return g(Ere, {
                get pharmacyIdProp() {
                  return e.pharmacyId;
                },
                get enableLocalPickup() {
                  return e.enableLocalPickup;
                },
                get enableSendToPatient() {
                  return e.enableSendToPatient;
                },
                get enableDeliveryPharmacies() {
                  return e.enableDeliveryPharmacies;
                },
                get mailOrderIds() {
                  return e.mailOrderIds;
                },
                onFulfillmentTypeChange: (i) => {
                  n.updateFormValue({
                    key: "fulfillmentType",
                    value: i || ""
                  });
                },
                onPreferredPharmacyChange: (i) => {
                  n.updateFormValue({
                    key: "updatePreferredPharmacy",
                    value: i
                  });
                },
                get children() {
                  return g(Are, {
                    get patientId() {
                      return r.patient?.value?.id;
                    },
                    get enableCoverageCheck() {
                      return e.enableCoverageCheck;
                    },
                    get children() {
                      return [(() => {
                        var i = fc();
                        return L(i, Gn), i;
                      })(), (() => {
                        var i = fc();
                        return L(i, Ro), i;
                      })(), (() => {
                        var i = fc();
                        return L(i, Mo), i;
                      })(), (() => {
                        var i = fc();
                        return L(i, P0e), i;
                      })(), (() => {
                        var i = fc();
                        return L(i, Fo), i;
                      })(), g(O0e, {
                        get patientId() {
                          return e.patientId;
                        },
                        get hideSubmit() {
                          return e.hideSubmit;
                        },
                        get hideTemplates() {
                          return e.hideTemplates;
                        },
                        get hidePatientCard() {
                          return e.hidePatientCard;
                        },
                        get enableOrder() {
                          return e.enableOrder;
                        },
                        get enableMedHistory() {
                          return e.enableMedHistory;
                        },
                        get enableMedHistoryLinks() {
                          return e.enableMedHistoryLinks;
                        },
                        get enableMedHistoryRefillButton() {
                          return e.enableMedHistoryRefillButton;
                        },
                        get enableCombineAndDuplicate() {
                          return e.enableCombineAndDuplicate;
                        },
                        get optionalPatientAddress() {
                          return e.optionalPatientAddress;
                        },
                        get address() {
                          return e.address;
                        },
                        get weight() {
                          return e.weight;
                        },
                        get weightUnit() {
                          return e.weightUnit;
                        },
                        get additionalNotes() {
                          return e.additionalNotes;
                        },
                        get triggerSubmit() {
                          return e.triggerSubmit;
                        },
                        get toastBuffer() {
                          return e.toastBuffer;
                        },
                        formStore: r,
                        formActions: n,
                        get externalOrderId() {
                          return e.externalOrderId;
                        },
                        get catalogId() {
                          return e.catalogId;
                        },
                        get allowOffCatalogSearch() {
                          return e.allowOffCatalogSearch;
                        },
                        get disableList() {
                          return e.disableList;
                        },
                        get groupId() {
                          return e.groupId;
                        },
                        get initialShowForm() {
                          return !e.templateIds && !e.prescriptionIds;
                        }
                      })];
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  });
};
Dn("photon-prescribe-workflow", {
  patientId: void 0,
  templateIds: void 0,
  templateOverrides: void 0,
  prescriptionIds: void 0,
  hideSubmit: !1,
  hideTemplates: !1,
  hidePatientCard: !1,
  enableOrder: !1,
  enableLocalPickup: !1,
  enableSendToPatient: !1,
  enableDeliveryPharmacies: !0,
  enableCombineAndDuplicate: !1,
  enableMedHistory: !1,
  enableMedHistoryRefillButton: !1,
  enableMedHistoryLinks: !1,
  optionalPatientAddress: !1,
  mailOrderIds: void 0,
  pharmacyId: void 0,
  address: void 0,
  weight: void 0,
  weightUnit: "lbs",
  additionalNotes: void 0,
  triggerSubmit: !1,
  toastBuffer: 0,
  externalOrderId: void 0,
  catalogId: void 0,
  allowOffCatalogSearch: !0,
  enableCoverageCheck: !1,
  disableList: void 0,
  groupId: void 0
}, D0e);
var M0e = /* @__PURE__ */ ae('<p class="font-sans text-l font-medium mb-2">'), R0e = /* @__PURE__ */ ae("<sl-icon-button class=self-start>", !0, !1, !1), L0e = /* @__PURE__ */ ae("<style>"), F0e = /* @__PURE__ */ ae('<div class="rounded-lg bg-white p-4 shadow-card border border-gray-200">'), j0e = /* @__PURE__ */ ae('<div class="flex flex-row justify-between">'), z0e = /* @__PURE__ */ ae("<slot>");
const V0e = (e) => {
  const [t, r] = V(!0);
  let n = null, i = null;
  return e.title && (n = (() => {
    var a = M0e();
    return L(a, () => e.title), a;
  })()), e.collapsable && (i = (() => {
    var a = R0e();
    return Ue(a, "click", () => {
      r(!t());
    }), a._$owner = Ve(), se(() => a.name = t() ? "chevron-right" : "chevron-down"), a;
  })()), [(() => {
    var a = L0e();
    return L(a, Gn), a;
  })(), (() => {
    var a = F0e();
    return L(a, n || i ? (() => {
      var o = j0e();
      return L(o, n, null), L(o, i, null), o;
    })() : null, null), L(a, (() => {
      var o = At(() => !!(e.collapsable && t()));
      return () => o() ? null : (() => {
        var s = z0e();
        return s._$owner = Ve(), s;
      })();
    })(), null), se((o) => {
      var s = !!e.invalid, l = !!e.invalid;
      return s !== o.e && a.classList.toggle("border-red-400", o.e = s), l !== o.t && a.classList.toggle("border-2", o.t = l), o;
    }, {
      e: void 0,
      t: void 0
    }), a;
  })()];
};
Dn("photon-card", {
  invalid: !1,
  title: null,
  collapsable: !1
}, V0e);
function* av(e = document.activeElement) {
  e != null && (yield e, "shadowRoot" in e && e.shadowRoot && e.shadowRoot.mode !== "closed" && (yield* Loe(av(e.shadowRoot.activeElement))));
}
function uS() {
  return [...av()].pop();
}
var p8 = /* @__PURE__ */ new WeakMap();
function hS(e) {
  let t = p8.get(e);
  return t || (t = window.getComputedStyle(e, null), p8.set(e, t)), t;
}
function U0e(e) {
  if (typeof e.checkVisibility == "function")
    return e.checkVisibility({ checkOpacity: !1, checkVisibilityCSS: !0 });
  const t = hS(e);
  return t.visibility !== "hidden" && t.display !== "none";
}
function q0e(e) {
  const t = hS(e), { overflowY: r, overflowX: n } = t;
  return r === "scroll" || n === "scroll" ? !0 : r !== "auto" || n !== "auto" ? !1 : e.scrollHeight > e.clientHeight && r === "auto" || e.scrollWidth > e.clientWidth && n === "auto";
}
function B0e(e) {
  const t = e.tagName.toLowerCase(), r = Number(e.getAttribute("tabindex"));
  if (e.hasAttribute("tabindex") && (isNaN(r) || r <= -1) || e.hasAttribute("disabled") || e.closest("[inert]"))
    return !1;
  if (t === "input" && e.getAttribute("type") === "radio") {
    const a = e.getRootNode(), o = `input[type='radio'][name="${e.getAttribute("name")}"]`, s = a.querySelector(`${o}:checked`);
    return s ? s === e : a.querySelector(o) === e;
  }
  return U0e(e) ? (t === "audio" || t === "video") && e.hasAttribute("controls") || e.hasAttribute("tabindex") || e.hasAttribute("contenteditable") && e.getAttribute("contenteditable") !== "false" || [
    "button",
    "input",
    "select",
    "textarea",
    "a",
    "audio",
    "video",
    "summary",
    "iframe"
  ].includes(t) ? !0 : q0e(e) : !1;
}
function H0e(e) {
  var t, r;
  const n = gg(e), i = (t = n[0]) != null ? t : null, a = (r = n[n.length - 1]) != null ? r : null;
  return { start: i, end: a };
}
function W0e(e, t) {
  var r;
  return ((r = e.getRootNode({ composed: !0 })) == null ? void 0 : r.host) !== t;
}
function gg(e) {
  const t = /* @__PURE__ */ new WeakMap(), r = [];
  function n(i) {
    if (i instanceof Element) {
      if (i.hasAttribute("inert") || i.closest("[inert]") || t.has(i))
        return;
      t.set(i, !0), !r.includes(i) && B0e(i) && r.push(i), i instanceof HTMLSlotElement && W0e(i, e) && i.assignedElements({ flatten: !0 }).forEach((a) => {
        n(a);
      }), i.shadowRoot !== null && i.shadowRoot.mode === "open" && n(i.shadowRoot);
    }
    for (const a of i.children)
      n(a);
  }
  return n(e), r.sort((i, a) => {
    const o = Number(i.getAttribute("tabindex")) || 0;
    return (Number(a.getAttribute("tabindex")) || 0) - o;
  });
}
var pc = [], Q0e = class {
  constructor(e) {
    this.tabDirection = "forward", this.handleFocusIn = () => {
      this.isActive() && this.checkFocus();
    }, this.handleKeyDown = (t) => {
      var r;
      if (t.key !== "Tab" || this.isExternalActivated || !this.isActive()) return;
      const n = uS();
      if (this.previousFocus = n, this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus))
        return;
      t.shiftKey ? this.tabDirection = "backward" : this.tabDirection = "forward";
      const i = gg(this.element);
      let a = i.findIndex((s) => s === n);
      this.previousFocus = this.currentFocus;
      const o = this.tabDirection === "forward" ? 1 : -1;
      for (; ; ) {
        a + o >= i.length ? a = 0 : a + o < 0 ? a = i.length - 1 : a += o, this.previousFocus = this.currentFocus;
        const s = (
          /** @type {HTMLElement} */
          i[a]
        );
        if (this.tabDirection === "backward" && this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus) || s && this.possiblyHasTabbableChildren(s))
          return;
        t.preventDefault(), this.currentFocus = s, (r = this.currentFocus) == null || r.focus({ preventScroll: !1 });
        const l = [...av()];
        if (l.includes(this.currentFocus) || !l.includes(this.previousFocus))
          break;
      }
      setTimeout(() => this.checkFocus());
    }, this.handleKeyUp = () => {
      this.tabDirection = "forward";
    }, this.element = e, this.elementsWithTabbableControls = ["iframe"];
  }
  /** Activates focus trapping. */
  activate() {
    pc.push(this.element), document.addEventListener("focusin", this.handleFocusIn), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  /** Deactivates focus trapping. */
  deactivate() {
    pc = pc.filter((e) => e !== this.element), this.currentFocus = null, document.removeEventListener("focusin", this.handleFocusIn), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
  }
  /** Determines if this modal element is currently active or not. */
  isActive() {
    return pc[pc.length - 1] === this.element;
  }
  /** Activates external modal behavior and temporarily disables focus trapping. */
  activateExternal() {
    this.isExternalActivated = !0;
  }
  /** Deactivates external modal behavior and re-enables focus trapping. */
  deactivateExternal() {
    this.isExternalActivated = !1;
  }
  checkFocus() {
    if (this.isActive() && !this.isExternalActivated) {
      const e = gg(this.element);
      if (!this.element.matches(":focus-within")) {
        const t = e[0], r = e[e.length - 1], n = this.tabDirection === "forward" ? t : r;
        typeof n?.focus == "function" && (this.currentFocus = n, n.focus({ preventScroll: !1 }));
      }
    }
  }
  possiblyHasTabbableChildren(e) {
    return this.elementsWithTabbableControls.includes(e.tagName.toLowerCase()) || e.hasAttribute("controls");
  }
}, vg = /* @__PURE__ */ new Set();
function K0e() {
  const e = document.documentElement.clientWidth;
  return Math.abs(window.innerWidth - e);
}
function G0e() {
  const e = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
  return isNaN(e) || !e ? 0 : e;
}
function m8(e) {
  if (vg.add(e), !document.documentElement.classList.contains("sl-scroll-lock")) {
    const t = K0e() + G0e();
    let r = getComputedStyle(document.documentElement).scrollbarGutter;
    (!r || r === "auto") && (r = "stable"), t < 2 && (r = ""), document.documentElement.style.setProperty("--sl-scroll-lock-gutter", r), document.documentElement.classList.add("sl-scroll-lock"), document.documentElement.style.setProperty("--sl-scroll-lock-size", `${t}px`);
  }
}
function g8(e) {
  vg.delete(e), vg.size === 0 && (document.documentElement.classList.remove("sl-scroll-lock"), document.documentElement.style.removeProperty("--sl-scroll-lock-size"));
}
var Z0e = Ln`
  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`, sa = class extends fn {
  constructor() {
    super(...arguments), this.hasSlotController = new a0(this, "footer"), this.localize = new Do(this), this.modal = new Q0e(this), this.open = !1, this.label = "", this.noHeader = !1, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && this.modal.isActive() && this.open && (e.stopPropagation(), this.requestClose("keyboard"));
    };
  }
  firstUpdated() {
    this.dialog.hidden = !this.open, this.open && (this.addOpenListeners(), this.modal.activate(), m8(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.modal.deactivate(), g8(this), this.removeOpenListeners();
  }
  requestClose(e) {
    if (this.emit("sl-request-close", {
      cancelable: !0,
      detail: { source: e }
    }).defaultPrevented) {
      const r = $i(this, "dialog.denyClose", { dir: this.localize.dir() });
      ki(this.panel, r.keyframes, r.options);
      return;
    }
    this.hide();
  }
  addOpenListeners() {
    var e;
    "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => this.requestClose("keyboard")) : document.addEventListener("keydown", this.handleDocumentKeyDown);
  }
  removeOpenListeners() {
    var e;
    (e = this.closeWatcher) == null || e.destroy(), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  async handleOpenChange() {
    if (this.open) {
      this.emit("sl-show"), this.addOpenListeners(), this.originalTrigger = document.activeElement, this.modal.activate(), m8(this);
      const e = this.querySelector("[autofocus]");
      e && e.removeAttribute("autofocus"), await Promise.all([Wi(this.dialog), Wi(this.overlay)]), this.dialog.hidden = !1, requestAnimationFrame(() => {
        this.emit("sl-initial-focus", { cancelable: !0 }).defaultPrevented || (e ? e.focus({ preventScroll: !0 }) : this.panel.focus({ preventScroll: !0 })), e && e.setAttribute("autofocus", "");
      });
      const t = $i(this, "dialog.show", { dir: this.localize.dir() }), r = $i(this, "dialog.overlay.show", { dir: this.localize.dir() });
      await Promise.all([
        ki(this.panel, t.keyframes, t.options),
        ki(this.overlay, r.keyframes, r.options)
      ]), this.emit("sl-after-show");
    } else {
      yx(this), this.emit("sl-hide"), this.removeOpenListeners(), this.modal.deactivate(), await Promise.all([Wi(this.dialog), Wi(this.overlay)]);
      const e = $i(this, "dialog.hide", { dir: this.localize.dir() }), t = $i(this, "dialog.overlay.hide", { dir: this.localize.dir() });
      await Promise.all([
        ki(this.overlay, t.keyframes, t.options).then(() => {
          this.overlay.hidden = !0;
        }),
        ki(this.panel, e.keyframes, e.options).then(() => {
          this.panel.hidden = !0;
        })
      ]), this.dialog.hidden = !0, this.overlay.hidden = !1, this.panel.hidden = !1, g8(this);
      const r = this.originalTrigger;
      typeof r?.focus == "function" && setTimeout(() => r.focus()), this.emit("sl-after-hide");
    }
  }
  /** Shows the dialog. */
  async show() {
    if (!this.open)
      return this.open = !0, Eo(this, "sl-after-show");
  }
  /** Hides the dialog */
  async hide() {
    if (this.open)
      return this.open = !1, Eo(this, "sl-after-hide");
  }
  render() {
    return hr`
      <div
        part="base"
        class=${Wn({
      dialog: !0,
      "dialog--open": this.open,
      "dialog--has-footer": this.hasSlotController.test("footer")
    })}
      >
        <div part="overlay" class="dialog__overlay" @click=${() => this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${Kt(this.noHeader ? this.label : void 0)}
          aria-labelledby=${Kt(this.noHeader ? void 0 : "title")}
          tabindex="-1"
        >
          ${this.noHeader ? "" : hr`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : "\uFEFF"} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${() => this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              `}
          ${""}
          <div part="body" class="dialog__body" tabindex="-1"><slot></slot></div>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
  }
};
sa.styles = [oi, Z0e];
sa.dependencies = {
  "sl-icon-button": _n
};
q([
  qr(".dialog")
], sa.prototype, "dialog", 2);
q([
  qr(".dialog__panel")
], sa.prototype, "panel", 2);
q([
  qr(".dialog__overlay")
], sa.prototype, "overlay", 2);
q([
  de({ type: Boolean, reflect: !0 })
], sa.prototype, "open", 2);
q([
  de({ reflect: !0 })
], sa.prototype, "label", 2);
q([
  de({ attribute: "no-header", type: Boolean, reflect: !0 })
], sa.prototype, "noHeader", 2);
q([
  on("open", { waitUntilFirstUpdate: !0 })
], sa.prototype, "handleOpenChange", 1);
Mi("dialog.show", {
  keyframes: [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 250, easing: "ease" }
});
Mi("dialog.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ],
  options: { duration: 250, easing: "ease" }
});
Mi("dialog.denyClose", {
  keyframes: [{ scale: 1 }, { scale: 1.02 }, { scale: 1 }],
  options: { duration: 250 }
});
Mi("dialog.overlay.show", {
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  options: { duration: 250 }
});
Mi("dialog.overlay.hide", {
  keyframes: [{ opacity: 1 }, { opacity: 0 }],
  options: { duration: 250 }
});
sa.define("sl-dialog");
const Y0e = '.dialog::part(overlay){background-color:#0000007a}.dialog::part(body){padding-bottom:.25rem}.dialog::part(footer){padding-top:0}.hideFooter::part(footer){display:none}.showHeader::part(body){padding-top:0}.dialog::part(title){font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-weight:500}';
var mc = /* @__PURE__ */ ae("<style>"), J0e = /* @__PURE__ */ ae('<slot name=label><p class="text-xl font-sans font-medium">'), X0e = /* @__PURE__ */ ae('<sl-dialog class=dialog><div><slot></slot></div><div class="flex flex-col xs:flex-row justify-end gap-2"slot=footer>', !0, !1, !1);
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const e1e = (e) => {
  let t;
  const r = (n) => {
    const i = new CustomEvent(n, {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(i);
  };
  return [(() => {
    var n = mc();
    return L(n, Fo), n;
  })(), (() => {
    var n = mc();
    return L(n, Gn), n;
  })(), (() => {
    var n = mc();
    return L(n, Ro), n;
  })(), (() => {
    var n = mc();
    return L(n, Mo), n;
  })(), (() => {
    var n = mc();
    return L(n, Y0e), n;
  })(), (() => {
    var n = X0e(), i = n.firstChild, a = i.firstChild, o = i.nextSibling;
    Ue(n, "sl-request-close", (l) => {
      l.detail.source === "overlay" && !e.overlayClose || l.detail.source === "keyboard" ? l.preventDefault() : r("photon-dialog-canceled");
    });
    var s = t;
    return typeof s == "function" ? Zt(s, n) : t = n, n._$owner = Ve(), L(n, g(H, {
      get when() {
        return !e.header;
      },
      get children() {
        var l = J0e(), d = l.firstChild;
        return l._$owner = Ve(), L(d, () => e.label), l;
      }
    }), i), a._$owner = Ve(), L(o, g(xt, {
      variant: "secondary",
      get disabled() {
        return e.disableButtons || e.loading;
      },
      onClick: () => {
        r("photon-dialog-alt");
      },
      get children() {
        return e.cancelText;
      }
    }), null), L(o, g(xt, {
      get disabled() {
        return e.disableButtons || e.disableSubmit;
      },
      get loading() {
        return e.loading;
      },
      onClick: () => {
        r("photon-dialog-confirmed");
      },
      get children() {
        return e.confirmText;
      }
    }), null), se((l) => {
      var d = !!e.hideFooter, c = !!e.header, u = `--width: ${e.width};`, h = e.label, f = e.open, p = !e.header, m = `font-sans ${e.header ? "pb-4" : "py-4"}`, y = !!e.hideFooter;
      return d !== l.e && n.classList.toggle("hideFooter", l.e = d), c !== l.t && n.classList.toggle("showHeader", l.t = c), l.a = N8(n, u, l.a), h !== l.o && (n.label = l.o = h), f !== l.i && (n.open = l.i = f), p !== l.n && (n.noHeader = l.n = p), m !== l.s && ka(i, l.s = m), y !== l.h && o.classList.toggle("hidden", l.h = y), l;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0
    }), n;
  })()];
};
Dn("photon-dialog", {
  label: void 0,
  header: !0,
  open: !1,
  confirmText: "Yes, Cancel",
  cancelText: "No, Keep Editing",
  disableButtons: !1,
  loading: !1,
  hideFooter: !1,
  disableSubmit: !1,
  width: "500px",
  overlayClose: !1
}, e1e);
var t1e = /* @__PURE__ */ ae('<span class="text-gray-500 text-sm font-normal"> (optional)'), r1e = /* @__PURE__ */ ae('<p class="font-sans text-lg mt-4 md:!mt-8"role=heading aria-level=3>Address'), n1e = /* @__PURE__ */ ae('<div class="flex gap-4"><div class="flex-grow min-w-[40%]"></div><div class="flex-grow min-w-[40%]">'), i1e = /* @__PURE__ */ ae('<div class="w-full flex justify-center">'), a1e = /* @__PURE__ */ ae('<div><p class="font-sans text-lg flex-grow"role=heading aria-level=2>Patient info</p><div class="flex flex-col"></div><button class="mb-4 mt-8 flex items-center md:!hidden"aria-controls=optional-fields-section><span class="font-sans text-lg"></span></button><div id=optional-fields-section><p class="font-sans text-sm m-0 mt-6">Preferred pharmacy'), o1e = /* @__PURE__ */ ae('<div class="flex flex-col gap-8">'), s1e = /* @__PURE__ */ ae('<div class="w-full h-full relative"><style></style><style>');
const l1e = (e, t) => {
  const r = e.selectedPatient.data?.address;
  return t.address_zip?.value && Bae(t.address_zip?.value) && t.address_zip?.value != r?.postalCode ? t.address_zip?.value : r ? `${r.street1} ${r.street2 ?? ""} ${r.city}, ${r.state} ${r.postalCode}` : "";
}, d1e = (e) => {
  let t;
  const r = Rn(), [n, i] = V(!1), {
    store: a,
    actions: o
  } = Of, {
    store: s,
    actions: l
  } = vx({
    firstName: void 0,
    lastName: void 0,
    dateOfBirth: void 0,
    phone: void 0,
    gender: void 0,
    sex: void 0,
    email: void 0,
    address_street1: void 0,
    address_street2: void 0,
    address_city: void 0,
    address_state: void 0,
    address_zip: void 0,
    preferredPharmacy: void 0
  });
  l.registerValidator({
    key: "firstName",
    validator: Fr(Xs(jn(), 1, 1 / 0), "Please enter a first name.")
  }), l.registerValidator({
    key: "lastName",
    validator: Fr(Xs(jn(), 1, 1 / 0), "Please enter a last name.")
  }), l.registerValidator({
    key: "dateOfBirth",
    validator: Fr(Fde, "Please enter a valid date of birth.")
  }), l.registerValidator({
    key: "sex",
    validator: Fr(nse(Ck.map((m) => m.value)), "Please enter Sex at Birth.")
  }), l.registerValidator({
    key: "phone",
    validator: Fr(Xs(jn(), 12), "Please enter a valid mobile number.")
  }), l.registerValidator({
    key: "email",
    validator: Fr(ose([Vde(), Ude()]), "Please enter a valid email.")
  }), l.registerValidator({
    key: "address_street1",
    validator: Fr(Xs(jn(), 1, 1 / 0), "Please enter a valid Street 1.")
  }), l.registerValidator({
    key: "address_city",
    validator: Fr(Xs(jn(), 1, 1 / 0), "Please enter a valid City.")
  }), l.registerValidator({
    key: "address_state",
    validator: Fr(Xs(jn(), 2, 2), "Please enter a valid State.")
  }), l.registerValidator({
    key: "address_zip",
    validator: Fr(zde(), "Please enter a valid zip code.")
  }), lr(() => {
    e.patientId ? o.getSelectedPatient(r.getSDK(), e.patientId) : o.clearSelectedPatient();
  });
  const d = (m) => {
    const y = new CustomEvent("photon-form-updated", {
      composed: !0,
      bubbles: !0,
      detail: {
        form: m,
        actions: l,
        selected: a,
        optionalPatientAddress: e.optionalPatientAddress,
        reset: () => {
          l.reset(), o.reset();
        }
      }
    });
    t?.dispatchEvent(y);
  };
  fe(() => {
    a.selectedPatient.data && (l.updateFormValue({
      key: "firstName",
      value: a.selectedPatient.data.name.first
    }), l.updateFormValue({
      key: "lastName",
      value: a.selectedPatient.data.name.last
    }), l.updateFormValue({
      key: "dateOfBirth",
      value: a.selectedPatient.data.dateOfBirth
    }), l.updateFormValue({
      key: "phone",
      value: a.selectedPatient.data.phone
    }), l.updateFormValue({
      key: "gender",
      value: a.selectedPatient.data.gender
    }), l.updateFormValue({
      key: "sex",
      value: a.selectedPatient.data.sex
    }), l.updateFormValue({
      key: "email",
      value: a.selectedPatient.data.email
    }), l.updateFormValue({
      key: "address_street1",
      value: a.selectedPatient.data.address?.street1
    }), l.updateFormValue({
      key: "address_street2",
      value: a.selectedPatient.data.address?.street2
    }), l.updateFormValue({
      key: "address_city",
      value: a.selectedPatient.data.address?.city
    }), l.updateFormValue({
      key: "address_state",
      value: a.selectedPatient.data.address?.state
    }), l.updateFormValue({
      key: "address_zip",
      value: a.selectedPatient.data.address?.postalCode
    }), l.updateFormValue({
      key: "preferredPharmacy",
      value: a.selectedPatient.data.preferredPharmacies?.[0]?.id
    }));
  });
  const c = K(() => !!(s.address_street1?.value || s.address_street2?.value || s.address_city?.value || s.address_state?.value || s.address_zip?.value));
  fe(() => {
    d(s);
  }), sr(() => {
    o.clearSelectedPatient(), l.reset();
  });
  const u = K(() => {
    const m = a.selectedPatient.data?.preferredPharmacies?.[0];
    if (!m) return;
    const y = m.address;
    return {
      ...m,
      address: y,
      isPrevious: !0,
      isPreferred: !0
    };
  }), h = e.patientId ? "update_patient_form" : "new_patient_form", f = (m, y, v = !1) => {
    Fc("fieldInteraction", {
      name: "Field Interaction",
      formName: h,
      fieldName: m,
      hasValue: y,
      isOptional: v
    }, t);
  }, p = () => {
    const m = K(() => !e.optionalPatientAddress || c());
    return [(() => {
      var y = r1e();
      return y.firstChild, L(y, g(H, {
        get when() {
          return At(() => !!e.optionalPatientAddress)() && !c();
        },
        get children() {
          return t1e();
        }
      }), null), y;
    })(), g(at, {
      label: "Street 1",
      get error() {
        return s.address_street1?.error;
      },
      get required() {
        return m();
      },
      get children() {
        return g(NK, {
          get value() {
            return s.address_street1?.value ?? a.selectedPatient.data?.address?.street1;
          },
          onInput: (y) => {
            l.updateFormValue({
              key: "address_street1",
              value: y.currentTarget.value
            });
          },
          onBlur: (y) => f("address_street1", !!y.currentTarget.value, !0),
          onAddressSelect: (y) => {
            l.updateFormValue({
              key: "address_street1",
              value: y.street1
            }), l.updateFormValue({
              key: "address_street2",
              value: y.street2
            }), l.updateFormValue({
              key: "address_city",
              value: y.city
            }), l.updateFormValue({
              key: "address_state",
              value: y.state
            }), l.updateFormValue({
              key: "address_zip",
              value: y.postalCode
            });
          }
        });
      }
    }), g(at, {
      label: "Street 2",
      get error() {
        return s.address_street2?.error;
      },
      get children() {
        return g(Dt, {
          get value() {
            return s.address_street2?.value ?? a.selectedPatient.data?.address?.street2;
          },
          onInput: (y) => {
            l.updateFormValue({
              key: "address_street2",
              value: y.currentTarget.value
            });
          },
          onBlur: (y) => f("address_street2", !!y.currentTarget.value, !0)
        });
      }
    }), g(at, {
      label: "City",
      get error() {
        return s.address_city?.error;
      },
      get required() {
        return m();
      },
      get children() {
        return g(Dt, {
          get value() {
            return s.address_city?.value ?? a.selectedPatient.data?.address?.city;
          },
          onInput: (y) => {
            l.updateFormValue({
              key: "address_city",
              value: y.currentTarget.value
            });
          },
          onBlur: (y) => f("address_city", !!y.currentTarget.value, !0)
        });
      }
    }), (() => {
      var y = n1e(), v = y.firstChild, b = v.nextSibling;
      return L(v, g(at, {
        label: "State",
        get error() {
          return s.address_state?.error;
        },
        get required() {
          return m();
        },
        get children() {
          return g(FK, {
            get value() {
              return s.address_state?.value ?? a.selectedPatient.data?.address?.state;
            },
            onChange: ($) => {
              l.updateFormValue({
                key: "address_state",
                value: $.currentTarget.value
              });
            },
            onBlur: ($) => f("address_state", !!$.currentTarget.value, !0)
          });
        }
      })), L(b, g(at, {
        label: "Zip code",
        get error() {
          return s.address_zip?.error;
        },
        get required() {
          return m();
        },
        get children() {
          return g(Dt, {
            get value() {
              return s.address_zip?.value ?? a.selectedPatient.data?.address?.postalCode;
            },
            onInput: ($) => {
              l.updateFormValue({
                key: "address_zip",
                value: $.currentTarget.value
              });
            },
            onBlur: ($) => f("address_zip", !!$.currentTarget.value, !0)
          });
        }
      })), y;
    })()];
  };
  return (() => {
    var m = s1e(), y = m.firstChild, v = y.nextSibling, b = t;
    return typeof b == "function" ? Zt(b, m) : t = m, L(y, Gn), L(v, Fo), L(m, g(H, {
      get when() {
        return a.selectedPatient.isLoading;
      },
      get children() {
        var $ = i1e();
        return L($, g(aa, {
          color: "green"
        })), $;
      }
    }), null), L(m, g(H, {
      get when() {
        return !a.selectedPatient.isLoading;
      },
      get children() {
        return g(kx, {
          permissions: ["write:patient"],
          get children() {
            var $ = o1e();
            return L($, g(Mn, {
              get children() {
                var _ = a1e(), x = _.firstChild, S = x.nextSibling, A = S.nextSibling, N = A.firstChild, P = A.nextSibling, D = P.firstChild;
                return L(S, g(at, {
                  label: "First name",
                  get error() {
                    return s.firstName?.error;
                  },
                  required: !0,
                  get children() {
                    return g(Dt, {
                      get value() {
                        return s.firstName?.value ?? a.selectedPatient.data?.name.first;
                      },
                      onInput: (T) => {
                        l.updateFormValue({
                          key: "firstName",
                          value: T.currentTarget.value
                        });
                      },
                      onBlur: (T) => f("firstName", !!T.currentTarget.value)
                    });
                  }
                }), null), L(S, g(at, {
                  label: "Last name",
                  get error() {
                    return s.lastName?.error;
                  },
                  required: !0,
                  get children() {
                    return g(Dt, {
                      get value() {
                        return s.lastName?.value ?? a.selectedPatient.data?.name.last;
                      },
                      onInput: (T) => {
                        l.updateFormValue({
                          key: "lastName",
                          value: T.currentTarget.value
                        });
                      },
                      onBlur: (T) => f("lastName", !!T.currentTarget.value)
                    });
                  }
                }), null), L(S, g(at, {
                  label: "Date of birth",
                  get error() {
                    return s.dateOfBirth?.error;
                  },
                  required: !0,
                  get children() {
                    return g(DK, {
                      get value() {
                        return s.dateOfBirth?.value ?? a.selectedPatient.data?.dateOfBirth;
                      },
                      onDateChange: (T) => {
                        l.updateFormValue({
                          key: "dateOfBirth",
                          value: T
                        });
                      },
                      onBlur: (T) => f("dateOfBirth", !!T.currentTarget.value)
                    });
                  }
                }), null), L(S, g(at, {
                  label: "Mobile number",
                  get error() {
                    return s.phone?.error;
                  },
                  required: !0,
                  get children() {
                    return g(tJ, {
                      get value() {
                        return s.phone?.value ?? a.selectedPatient.data?.phone;
                      },
                      onPhoneChange: (T) => {
                        l.updateFormValue({
                          key: "phone",
                          value: T
                        });
                      },
                      onBlur: (T) => f("phone", !!T.currentTarget.value)
                    });
                  }
                }), null), L(S, g(at, {
                  label: "Sex at birth",
                  get error() {
                    return s.sex?.error;
                  },
                  required: !0,
                  get children() {
                    return g(aJ, {
                      get value() {
                        return s.sex?.value ?? a.selectedPatient.data?.sex;
                      },
                      onChange: (T) => l.updateFormValue({
                        key: "sex",
                        value: T.currentTarget.value
                      }),
                      onBlur: () => f("sex", !!s.sex?.value)
                    });
                  }
                }), null), L(_, g(H, {
                  get when() {
                    return !e.optionalPatientAddress;
                  },
                  get children() {
                    return g(p, {});
                  }
                }), A), A.$$click = () => i((T) => !T), L(N, () => n() ? "Hide optional fields" : "Show optional fields"), L(A, g(mt, {
                  get name() {
                    return n() ? "chevronUp" : "chevronDown";
                  },
                  size: "md",
                  class: "inline-block ml-1 mt-1"
                }), null), L(P, g(H, {
                  get when() {
                    return e.optionalPatientAddress;
                  },
                  get children() {
                    return g(p, {});
                  }
                }), D), L(P, g(at, {
                  label: "Gender",
                  get error() {
                    return s.gender?.error;
                  },
                  get children() {
                    return g(dJ, {
                      get value() {
                        return s.gender?.value ?? a.selectedPatient.data?.gender;
                      },
                      onChange: (T) => l.updateFormValue({
                        key: "gender",
                        value: T.currentTarget.value
                      }),
                      onBlur: () => f("gender", !!s.gender?.value, !0)
                    });
                  }
                }), D), L(P, g(at, {
                  label: "Email",
                  get error() {
                    return s.email?.error;
                  },
                  get children() {
                    return g(Dt, {
                      type: "email",
                      get value() {
                        return s.email?.value ?? a.selectedPatient.data?.email;
                      },
                      onInput: (T) => {
                        l.updateFormValue({
                          key: "email",
                          value: T.currentTarget.value
                        });
                      },
                      onBlur: (T) => f("email", !!T.currentTarget.value, !0)
                    });
                  }
                }), D), L(P, g(j_, {
                  get address() {
                    return l1e(a, s);
                  },
                  setPharmacy: (T) => {
                    l.updateFormValue({
                      key: "preferredPharmacy",
                      value: T.id
                    });
                  },
                  get patientId() {
                    return e.patientId;
                  },
                  get initialValue() {
                    return u();
                  },
                  hidePreferred: !0
                }), null), se((T) => {
                  var I = n(), j = `mb-4 ${n() ? "block" : "hidden md:!block"}`;
                  return I !== T.e && Wc(A, "aria-expanded", T.e = I), j !== T.t && ka(P, T.t = j), T;
                }, {
                  e: void 0,
                  t: void 0
                }), _;
              }
            })), $;
          }
        });
      }
    }), null), m;
  })();
};
Dn("photon-patient-form", {
  patientId: "",
  optionalPatientAddress: !1
}, d1e);
Rs(["click"]);
var c1e = /* @__PURE__ */ ae('<div class="text-black text-xl md:text-3xl">'), u1e = /* @__PURE__ */ ae("<sl-icon class=flex-shrink-0>", !0, !1, !1), h1e = /* @__PURE__ */ ae('<footer class="flex-shrink-0 bg-white shadow-card px-4 py-4 md:px-8"><div class="flex flex-col xs:flex-row-reverse xs:justify-start gap-2 items-center w-full sm:w-[600px] xs:mx-auto sm:px-4">'), f1e = /* @__PURE__ */ ae('<div class="z-50 fixed inset-0 flex flex-col bg-[#F9FAFB]"><style></style><photon-dialog confirm-text="Yes, Close"cancel-text="Keep Editing"><p class="font-sans text-lg xs:text-base"></p></photon-dialog><header class="flex-shrink-0 flex items-center px-4 py-2 md:px-8 md:py-3 bg-white shadow-card"><div class="flex items-center"></div><div class="flex-1 flex justify-center items-center min-w-0 px-2"><p class="ml-1 font-sans text-lg md:text-xl font-medium truncate"></p></div><div class="flex items-center w-[44px]"></div></header><main class="flex-1 overflow-y-auto overscroll-contain"><div class="px-4 pt-4 pb-4 md:px-4 w-full sm:w-[600px] xs:mx-auto">', !0, !1, !1);
const fS = (e) => {
  const t = it({
    closeTitle: "Lose unsaved changes?",
    closeBody: "You will not be able to recover unsaved changes.",
    checkShouldWarn: () => !1
  }, e);
  let r;
  const [n, i] = V(!1), a = () => {
    i(!1), t.onClosed();
  }, o = () => i(!1);
  return (() => {
    var s = f1e(), l = s.firstChild, d = l.nextSibling, c = d.firstChild, u = d.nextSibling, h = u.firstChild, f = h.nextSibling, p = f.firstChild, m = u.nextSibling, y = m.firstChild, v = r;
    return typeof v == "function" ? Zt(v, s) : r = s, L(l, Gn), Ue(d, "photon-dialog-alt", o), Ue(d, "photon-dialog-canceled", o), Ue(d, "photon-dialog-confirmed", a), d._$owner = Ve(), L(c, () => t.closeBody), L(h, g(xt, {
      variant: "naked",
      size: "sm",
      onClick: () => {
        t.checkShouldWarn() ? i(!0) : t.onClosed();
      },
      get children() {
        var b = c1e();
        return L(b, g(mt, {
          name: "xMark"
        })), b;
      }
    })), L(f, g(H, {
      get when() {
        return t.titleIconName;
      },
      get children() {
        var b = u1e();
        return b._$owner = Ve(), se(() => b.name = t.titleIconName), b;
      }
    }), p), L(p, () => t.title), m.style.setProperty("-webkit-overflow-scrolling", "touch"), L(y, () => t.form), L(s, g(H, {
      get when() {
        return t.footer;
      },
      get children() {
        var b = h1e(), $ = b.firstChild;
        return L($, () => t.footer), b;
      }
    }), null), se((b) => {
      var $ = t.closeTitle, _ = n();
      return $ !== b.e && (d.label = b.e = $), _ !== b.t && (d.open = b.t = _), b;
    }, {
      e: void 0,
      t: void 0
    }), s;
  })();
};
var p1e = /* @__PURE__ */ ae("<style>"), m1e = /* @__PURE__ */ ae("<div>"), g1e = /* @__PURE__ */ ae('<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"role=alert><span class="block sm:inline">'), v1e = /* @__PURE__ */ ae("<photon-patient-form slot=form>", !0, !1, !1);
const y1e = Ie`
  fragment PatientFields on Patient {
    id
  }
`, b1e = (e) => {
  let t;
  const r = Rn(), [n, i] = V(!1), [a, o] = V(!1), [s, l] = V(void 0), [d, c] = V(void 0), [u, h] = V(void 0), [f, p] = V(void 0), [m, y] = V(!1), [v, b] = V(!1);
  lr(async () => {
    try {
      const {
        data: A
      } = await r.sdk.clinical.patient.getPatients({
        fragment: {
          PatientFields: y1e
        }
      });
      b(A && A.patients.length > 0);
    } catch (A) {
      console.log(A);
    }
  });
  const $ = (A, N = !1) => {
    const P = new CustomEvent("photon-patient-updated", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: A,
        didClickCreatePatientAndPrescription: N
      }
    });
    t?.dispatchEvent(P);
  }, _ = (A, N = !1) => {
    const P = new CustomEvent("photon-patient-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: A,
        createPrescription: N
      }
    });
    t?.dispatchEvent(P);
  }, x = () => {
    const A = new CustomEvent("photon-patient-closed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(A);
  };
  fe(() => {
    e.open && Fc("pageViewed", {
      name: e.patientId ? "Update Patient Page Viewed" : "New Patient Page Viewed"
    }, t);
  });
  const S = async (A, N, P, D = !1) => {
    p(void 0), o(D), i(!0);
    const T = ["firstName", "lastName", "dateOfBirth", "phone", "sex", "email"], I = ["address_street1", "address_city", "address_state", "address_zip"], j = !e.optionalPatientAddress || m(), F = j ? [...T, ...I] : T;
    if (N.validate(F), N.hasErrors(F))
      return i(!1), !0;
    A.preferredPharmacy.value && P.selectedPatient.data?.preferredPharmacies && P.selectedPatient.data?.preferredPharmacies.length !== 0 && !P.selectedPatient.data?.preferredPharmacies?.map((Y) => Y?.id).filter((Y) => Y !== null).includes(A.preferredPharmacy.value) && await r.getSDK().clinical.patient.removePatientPreferredPharmacy({})({
      variables: {
        patientId: e.patientId,
        pharmacyId: P.selectedPatient.data?.preferredPharmacies[0].id
      },
      awaitRefetchQueries: !1
    });
    const Z = j, te = {
      ...e?.patientId ? {
        id: e.patientId
      } : {},
      name: {
        first: A.firstName.value,
        last: A.lastName.value
      },
      gender: A.gender.value,
      email: A.email.value ? A.email.value : void 0,
      phone: A.phone.value,
      dateOfBirth: A.dateOfBirth.value,
      sex: A.sex.value,
      address: Z ? {
        street1: A.address_street1.value,
        street2: A.address_street2.value,
        city: A.address_city.value,
        state: A.address_state.value,
        postalCode: A.address_zip.value,
        country: "US"
      } : void 0,
      preferredPharmacies: A.preferredPharmacy.value ? [A.preferredPharmacy.value] : []
    };
    try {
      if (e?.patientId)
        await r.getSDK().clinical.patient.updatePatient({})({
          variables: te,
          awaitRefetchQueries: !1
        }), $(e.patientId, D), Fc("ctaClicked", {
          name: "Patient Updated",
          buttonText: D ? "Update and Start Prescription" : "Update",
          patientId: e.patientId,
          didClickCreatePatientAndPrescription: D,
          fields: a6(A, i6)
        }, t);
      else {
        const R = (await r.getSDK().clinical.patient.createPatient({})({
          variables: te,
          awaitRefetchQueries: !1
        }))?.data?.createPatient?.id || "";
        _(R, D), Fc("ctaClicked", {
          name: "Patient Created",
          buttonText: D ? "Create and Start Prescription" : "Create",
          patientId: R,
          didClickCreatePatientAndPrescription: D,
          fields: a6(A, i6)
        }, t);
      }
      i(!1), N.resetStores(), e.open = !1;
    } catch (Y) {
      i(!1), p(Y?.message || "An error occurred while saving the patient.");
    }
  };
  return (() => {
    var A = m1e(), N = t;
    return typeof N == "function" ? Zt(N, A) : t = A, L(A, g(H, {
      get when() {
        return e.open;
      },
      get children() {
        return g(iC, {
          get mount() {
            return document.body;
          },
          useShadow: !0,
          get children() {
            return [(() => {
              var P = p1e();
              return L(P, Fo), P;
            })(), g(fS, {
              onClosed: () => {
                x(), u().resetStores(), e.open = !1;
              },
              get title() {
                return e?.patientId ? "Edit patient" : "New patient";
              },
              get titleIconName() {
                return e?.patientId ? "pencil-square" : "person-plus";
              },
              get footer() {
                return [g(H, {
                  get when() {
                    return !e?.hideCreatePrescription;
                  },
                  get children() {
                    return g(xt, {
                      class: "w-full xs:w-fit",
                      size: "lg",
                      get disabled() {
                        return n();
                      },
                      get loading() {
                        return At(() => !!n())() && a();
                      },
                      onClick: () => S(s(), u(), d(), !0),
                      get children() {
                        return [At(() => e?.patientId ? "Save" : "Create"), " and start prescription"];
                      }
                    });
                  }
                }), g(H, {
                  get when() {
                    return !!v() || !!e?.hideCreatePrescription;
                  },
                  get children() {
                    return g(xt, {
                      class: "w-full xs:w-fit",
                      size: "lg",
                      get variant() {
                        return e?.hideCreatePrescription ? "primary" : "secondary";
                      },
                      get disabled() {
                        return n();
                      },
                      get loading() {
                        return At(() => !!n())() && !a();
                      },
                      onClick: () => S(s(), u(), d(), !1),
                      get children() {
                        return e?.patientId ? "Save" : "Create";
                      }
                    });
                  }
                })];
              },
              get form() {
                return [g(H, {
                  get when() {
                    return f();
                  },
                  get children() {
                    var P = g1e(), D = P.firstChild;
                    return L(D, f), P;
                  }
                }), (() => {
                  var P = v1e();
                  return Ue(P, "photon-form-updated", (D) => {
                    l(D.detail.form), h(Object.assign({}, D.detail.actions, {
                      resetStores: D.detail.reset
                    })), c(D.detail.selected);
                    const T = D.detail.form;
                    y(!!(T.address_street1?.value || T.address_street2?.value || T.address_city?.value || T.address_state?.value || T.address_zip?.value));
                  }), P._$owner = Ve(), se((D) => {
                    var T = e.patientId, I = e.optionalPatientAddress;
                    return T !== D.e && (P.patientId = D.e = T), I !== D.t && (P.optionalPatientAddress = D.t = I), D;
                  }, {
                    e: void 0,
                    t: void 0
                  }), P;
                })()];
              }
            })];
          }
        });
      }
    })), A;
  })();
};
Dn("photon-patient-dialog", {
  patientId: "",
  hideCreatePrescription: !1,
  open: !1,
  optionalPatientAddress: !1
}, b1e);
var w1e = /* @__PURE__ */ ae("<photon-patient-dialog>", !0, !1, !1);
const $1e = (e) => (console.warn("photon-update-patient-dialog will be deprecated soon. Please use photon-patient-dialog instead."), (() => {
  var t = w1e();
  return t._$owner = Ve(), se((r) => {
    var n = e.patientId, i = e.open;
    return n !== r.e && (t.patientId = r.e = n), i !== r.t && (t.open = r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})());
Dn("photon-update-patient-dialog", {
  patientId: "",
  open: !1
}, $1e);
const Nf = (e, t) => {
  let r;
  const n = () => clearTimeout(r);
  return Ve() && sr(n), Object.assign((...a) => {
    r !== void 0 && n(), r = setTimeout(() => e(...a), t);
  }, { clear: n });
};
var k1e = Ln`
  :host {
    display: inline-block;
  }

  .dropdown::part(popup) {
    z-index: var(--sl-z-index-dropdown);
  }

  .dropdown[data-current-placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .dropdown[data-current-placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .dropdown[data-current-placement^='left']::part(popup) {
    transform-origin: right;
  }

  .dropdown[data-current-placement^='right']::part(popup) {
    transform-origin: left;
  }

  .dropdown__trigger {
    display: block;
  }

  .dropdown__panel {
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    box-shadow: var(--sl-shadow-large);
    border-radius: var(--sl-border-radius-medium);
    pointer-events: none;
  }

  .dropdown--open .dropdown__panel {
    display: block;
    pointer-events: all;
  }

  /* When users slot a menu, make sure it conforms to the popup's auto-size */
  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`, mn = class extends fn {
  constructor() {
    super(...arguments), this.localize = new Do(this), this.open = !1, this.placement = "bottom-start", this.disabled = !1, this.stayOpenOnSelect = !1, this.distance = 0, this.skidding = 0, this.hoist = !1, this.sync = void 0, this.handleKeyDown = (e) => {
      this.open && e.key === "Escape" && (e.stopPropagation(), this.hide(), this.focusOnTrigger());
    }, this.handleDocumentKeyDown = (e) => {
      var t;
      if (e.key === "Escape" && this.open && !this.closeWatcher) {
        e.stopPropagation(), this.focusOnTrigger(), this.hide();
        return;
      }
      if (e.key === "Tab") {
        if (this.open && ((t = document.activeElement) == null ? void 0 : t.tagName.toLowerCase()) === "sl-menu-item") {
          e.preventDefault(), this.hide(), this.focusOnTrigger();
          return;
        }
        const r = (n, i) => {
          if (!n) return null;
          const a = n.closest(i);
          if (a) return a;
          const o = n.getRootNode();
          return o instanceof ShadowRoot ? r(o.host, i) : null;
        };
        setTimeout(() => {
          var n;
          const i = ((n = this.containingElement) == null ? void 0 : n.getRootNode()) instanceof ShadowRoot ? uS() : document.activeElement;
          (!this.containingElement || r(i, this.containingElement.tagName.toLowerCase()) !== this.containingElement) && this.hide();
        });
      }
    }, this.handleDocumentMouseDown = (e) => {
      const t = e.composedPath();
      this.containingElement && !t.includes(this.containingElement) && this.hide();
    }, this.handlePanelSelect = (e) => {
      const t = e.target;
      !this.stayOpenOnSelect && t.tagName.toLowerCase() === "sl-menu" && (this.hide(), this.focusOnTrigger());
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.containingElement || (this.containingElement = this);
  }
  firstUpdated() {
    this.panel.hidden = !this.open, this.open && (this.addOpenListeners(), this.popup.active = !0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeOpenListeners(), this.hide();
  }
  focusOnTrigger() {
    const e = this.trigger.assignedElements({ flatten: !0 })[0];
    typeof e?.focus == "function" && e.focus();
  }
  getMenu() {
    return this.panel.assignedElements({ flatten: !0 }).find((e) => e.tagName.toLowerCase() === "sl-menu");
  }
  handleTriggerClick() {
    this.open ? this.hide() : (this.show(), this.focusOnTrigger());
  }
  async handleTriggerKeyDown(e) {
    if ([" ", "Enter"].includes(e.key)) {
      e.preventDefault(), this.handleTriggerClick();
      return;
    }
    const t = this.getMenu();
    if (t) {
      const r = t.getAllItems(), n = r[0], i = r[r.length - 1];
      ["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key) && (e.preventDefault(), this.open || (this.show(), await this.updateComplete), r.length > 0 && this.updateComplete.then(() => {
        (e.key === "ArrowDown" || e.key === "Home") && (t.setCurrentItem(n), n.focus()), (e.key === "ArrowUp" || e.key === "End") && (t.setCurrentItem(i), i.focus());
      }));
    }
  }
  handleTriggerKeyUp(e) {
    e.key === " " && e.preventDefault();
  }
  handleTriggerSlotChange() {
    this.updateAccessibleTrigger();
  }
  //
  // Slotted triggers can be arbitrary content, but we need to link them to the dropdown panel with `aria-haspopup` and
  // `aria-expanded`. These must be applied to the "accessible trigger" (the tabbable portion of the trigger element
  // that gets slotted in) so screen readers will understand them. The accessible trigger could be the slotted element,
  // a child of the slotted element, or an element in the slotted element's shadow root.
  //
  // For example, the accessible trigger of an <sl-button> is a <button> located inside its shadow root.
  //
  // To determine this, we assume the first tabbable element in the trigger slot is the "accessible trigger."
  //
  updateAccessibleTrigger() {
    const t = this.trigger.assignedElements({ flatten: !0 }).find((n) => H0e(n).start);
    let r;
    if (t) {
      switch (t.tagName.toLowerCase()) {
        // Shoelace buttons have to update the internal button so it's announced correctly by screen readers
        case "sl-button":
        case "sl-icon-button":
          r = t.button;
          break;
        default:
          r = t;
      }
      r.setAttribute("aria-haspopup", "true"), r.setAttribute("aria-expanded", this.open ? "true" : "false");
    }
  }
  /** Shows the dropdown panel. */
  async show() {
    if (!this.open)
      return this.open = !0, Eo(this, "sl-after-show");
  }
  /** Hides the dropdown panel */
  async hide() {
    if (this.open)
      return this.open = !1, Eo(this, "sl-after-hide");
  }
  /**
   * Instructs the dropdown menu to reposition. Useful when the position or size of the trigger changes when the menu
   * is activated.
   */
  reposition() {
    this.popup.reposition();
  }
  addOpenListeners() {
    var e;
    this.panel.addEventListener("sl-select", this.handlePanelSelect), "CloseWatcher" in window ? ((e = this.closeWatcher) == null || e.destroy(), this.closeWatcher = new CloseWatcher(), this.closeWatcher.onclose = () => {
      this.hide(), this.focusOnTrigger();
    }) : this.panel.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keydown", this.handleDocumentKeyDown), document.addEventListener("mousedown", this.handleDocumentMouseDown);
  }
  removeOpenListeners() {
    var e;
    this.panel && (this.panel.removeEventListener("sl-select", this.handlePanelSelect), this.panel.removeEventListener("keydown", this.handleKeyDown)), document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("mousedown", this.handleDocumentMouseDown), (e = this.closeWatcher) == null || e.destroy();
  }
  async handleOpenChange() {
    if (this.disabled) {
      this.open = !1;
      return;
    }
    if (this.updateAccessibleTrigger(), this.open) {
      this.emit("sl-show"), this.addOpenListeners(), await Wi(this), this.panel.hidden = !1, this.popup.active = !0;
      const { keyframes: e, options: t } = $i(this, "dropdown.show", { dir: this.localize.dir() });
      await ki(this.popup.popup, e, t), this.emit("sl-after-show");
    } else {
      this.emit("sl-hide"), this.removeOpenListeners(), await Wi(this);
      const { keyframes: e, options: t } = $i(this, "dropdown.hide", { dir: this.localize.dir() });
      await ki(this.popup.popup, e, t), this.panel.hidden = !0, this.popup.active = !1, this.emit("sl-after-hide");
    }
  }
  render() {
    return hr`
      <sl-popup
        part="base"
        exportparts="popup:base__popup"
        id="dropdown"
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        auto-size="vertical"
        auto-size-padding="10"
        sync=${Kt(this.sync ? this.sync : void 0)}
        class=${Wn({
      dropdown: !0,
      "dropdown--open": this.open
    })}
      >
        <slot
          name="trigger"
          slot="anchor"
          part="trigger"
          class="dropdown__trigger"
          @click=${this.handleTriggerClick}
          @keydown=${this.handleTriggerKeyDown}
          @keyup=${this.handleTriggerKeyUp}
          @slotchange=${this.handleTriggerSlotChange}
        ></slot>

        <div aria-hidden=${this.open ? "false" : "true"} aria-labelledby="dropdown">
          <slot part="panel" class="dropdown__panel"></slot>
        </div>
      </sl-popup>
    `;
  }
};
mn.styles = [oi, k1e];
mn.dependencies = { "sl-popup": Wt };
q([
  qr(".dropdown")
], mn.prototype, "popup", 2);
q([
  qr(".dropdown__trigger")
], mn.prototype, "trigger", 2);
q([
  qr(".dropdown__panel")
], mn.prototype, "panel", 2);
q([
  de({ type: Boolean, reflect: !0 })
], mn.prototype, "open", 2);
q([
  de({ reflect: !0 })
], mn.prototype, "placement", 2);
q([
  de({ type: Boolean, reflect: !0 })
], mn.prototype, "disabled", 2);
q([
  de({ attribute: "stay-open-on-select", type: Boolean, reflect: !0 })
], mn.prototype, "stayOpenOnSelect", 2);
q([
  de({ attribute: !1 })
], mn.prototype, "containingElement", 2);
q([
  de({ type: Number })
], mn.prototype, "distance", 2);
q([
  de({ type: Number })
], mn.prototype, "skidding", 2);
q([
  de({ type: Boolean })
], mn.prototype, "hoist", 2);
q([
  de({ reflect: !0 })
], mn.prototype, "sync", 2);
q([
  on("open", { waitUntilFirstUpdate: !0 })
], mn.prototype, "handleOpenChange", 1);
Mi("dropdown.show", {
  keyframes: [
    { opacity: 0, scale: 0.9 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 100, easing: "ease" }
});
Mi("dropdown.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.9 }
  ],
  options: { duration: 100, easing: "ease" }
});
mn.define("sl-dropdown");
var _1e = Ln`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`, st = class extends fn {
  constructor() {
    super(...arguments), this.formControlController = new lS(this, {
      assumeInteractionOn: ["sl-blur", "sl-input"]
    }), this.hasSlotController = new a0(this, "help-text", "label"), this.localize = new Do(this), this.hasFocus = !1, this.title = "", this.__numberInput = Object.assign(document.createElement("input"), { type: "number" }), this.__dateInput = Object.assign(document.createElement("input"), { type: "date" }), this.type = "text", this.name = "", this.value = "", this.defaultValue = "", this.size = "medium", this.filled = !1, this.pill = !1, this.label = "", this.helpText = "", this.clearable = !1, this.disabled = !1, this.placeholder = "", this.readonly = !1, this.passwordToggle = !1, this.passwordVisible = !1, this.noSpinButtons = !1, this.form = "", this.required = !1, this.spellcheck = !0;
  }
  //
  // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
  // can be set before the component is rendered.
  //
  /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */
  get valueAsDate() {
    var e;
    return this.__dateInput.type = this.type, this.__dateInput.value = this.value, ((e = this.input) == null ? void 0 : e.valueAsDate) || this.__dateInput.valueAsDate;
  }
  set valueAsDate(e) {
    this.__dateInput.type = this.type, this.__dateInput.valueAsDate = e, this.value = this.__dateInput.value;
  }
  /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */
  get valueAsNumber() {
    var e;
    return this.__numberInput.value = this.value, ((e = this.input) == null ? void 0 : e.valueAsNumber) || this.__numberInput.valueAsNumber;
  }
  set valueAsNumber(e) {
    this.__numberInput.valueAsNumber = e, this.value = this.__numberInput.value;
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleChange() {
    this.value = this.input.value, this.emit("sl-change");
  }
  handleClearClick(e) {
    e.preventDefault(), this.value !== "" && (this.value = "", this.emit("sl-clear"), this.emit("sl-input"), this.emit("sl-change")), this.input.focus();
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleInput() {
    this.value = this.input.value, this.formControlController.updateValidity(), this.emit("sl-input");
  }
  handleInvalid(e) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(e);
  }
  handleKeyDown(e) {
    const t = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
    e.key === "Enter" && !t && setTimeout(() => {
      !e.defaultPrevented && !e.isComposing && this.formControlController.submit();
    });
  }
  handlePasswordToggle() {
    this.passwordVisible = !this.passwordVisible;
  }
  handleDisabledChange() {
    this.formControlController.setValidity(this.disabled);
  }
  handleStepChange() {
    this.input.step = String(this.step), this.formControlController.updateValidity();
  }
  async handleValueChange() {
    await this.updateComplete, this.formControlController.updateValidity();
  }
  /** Sets focus on the input. */
  focus(e) {
    this.input.focus(e);
  }
  /** Removes focus from the input. */
  blur() {
    this.input.blur();
  }
  /** Selects all the text in the input. */
  select() {
    this.input.select();
  }
  /** Sets the start and end positions of the text selection (0-based). */
  setSelectionRange(e, t, r = "none") {
    this.input.setSelectionRange(e, t, r);
  }
  /** Replaces a range of text with a new string. */
  setRangeText(e, t, r, n = "preserve") {
    const i = t ?? this.input.selectionStart, a = r ?? this.input.selectionEnd;
    this.input.setRangeText(e, i, a, n), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */
  showPicker() {
    "showPicker" in HTMLInputElement.prototype && this.input.showPicker();
  }
  /** Increments the value of a numeric input type by the value of the step attribute. */
  stepUp() {
    this.input.stepUp(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Decrements the value of a numeric input type by the value of the step attribute. */
  stepDown() {
    this.input.stepDown(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.formControlController.updateValidity();
  }
  render() {
    const e = this.hasSlotController.test("label"), t = this.hasSlotController.test("help-text"), r = this.label ? !0 : !!e, n = this.helpText ? !0 : !!t, a = this.clearable && !this.disabled && !this.readonly && (typeof this.value == "number" || this.value.length > 0);
    return hr`
      <div
        part="form-control"
        class=${Wn({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-label": r,
      "form-control--has-help-text": n
    })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${r ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${Wn({
      input: !0,
      // Sizes
      "input--small": this.size === "small",
      "input--medium": this.size === "medium",
      "input--large": this.size === "large",
      // States
      "input--pill": this.pill,
      "input--standard": !this.filled,
      "input--filled": this.filled,
      "input--disabled": this.disabled,
      "input--focused": this.hasFocus,
      "input--empty": !this.value,
      "input--no-spin-buttons": this.noSpinButtons
    })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${Kt(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${Kt(this.placeholder)}
              minlength=${Kt(this.minlength)}
              maxlength=${Kt(this.maxlength)}
              min=${Kt(this.min)}
              max=${Kt(this.max)}
              step=${Kt(this.step)}
              .value=${cS(this.value)}
              autocapitalize=${Kt(this.autocapitalize)}
              autocomplete=${Kt(this.autocomplete)}
              autocorrect=${Kt(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${Kt(this.pattern)}
              enterkeyhint=${Kt(this.enterkeyhint)}
              inputmode=${Kt(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${a ? hr`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? hr`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? hr`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : hr`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${n ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
st.styles = [oi, sS, _1e];
st.dependencies = { "sl-icon": si };
q([
  qr(".input__control")
], st.prototype, "input", 2);
q([
  n0()
], st.prototype, "hasFocus", 2);
q([
  de()
], st.prototype, "title", 2);
q([
  de({ reflect: !0 })
], st.prototype, "type", 2);
q([
  de()
], st.prototype, "name", 2);
q([
  de()
], st.prototype, "value", 2);
q([
  oS()
], st.prototype, "defaultValue", 2);
q([
  de({ reflect: !0 })
], st.prototype, "size", 2);
q([
  de({ type: Boolean, reflect: !0 })
], st.prototype, "filled", 2);
q([
  de({ type: Boolean, reflect: !0 })
], st.prototype, "pill", 2);
q([
  de()
], st.prototype, "label", 2);
q([
  de({ attribute: "help-text" })
], st.prototype, "helpText", 2);
q([
  de({ type: Boolean })
], st.prototype, "clearable", 2);
q([
  de({ type: Boolean, reflect: !0 })
], st.prototype, "disabled", 2);
q([
  de()
], st.prototype, "placeholder", 2);
q([
  de({ type: Boolean, reflect: !0 })
], st.prototype, "readonly", 2);
q([
  de({ attribute: "password-toggle", type: Boolean })
], st.prototype, "passwordToggle", 2);
q([
  de({ attribute: "password-visible", type: Boolean })
], st.prototype, "passwordVisible", 2);
q([
  de({ attribute: "no-spin-buttons", type: Boolean })
], st.prototype, "noSpinButtons", 2);
q([
  de({ reflect: !0 })
], st.prototype, "form", 2);
q([
  de({ type: Boolean, reflect: !0 })
], st.prototype, "required", 2);
q([
  de()
], st.prototype, "pattern", 2);
q([
  de({ type: Number })
], st.prototype, "minlength", 2);
q([
  de({ type: Number })
], st.prototype, "maxlength", 2);
q([
  de()
], st.prototype, "min", 2);
q([
  de()
], st.prototype, "max", 2);
q([
  de()
], st.prototype, "step", 2);
q([
  de()
], st.prototype, "autocapitalize", 2);
q([
  de()
], st.prototype, "autocorrect", 2);
q([
  de()
], st.prototype, "autocomplete", 2);
q([
  de({ type: Boolean })
], st.prototype, "autofocus", 2);
q([
  de()
], st.prototype, "enterkeyhint", 2);
q([
  de({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (e) => !(!e || e === "false"),
      toAttribute: (e) => e ? "true" : "false"
    }
  })
], st.prototype, "spellcheck", 2);
q([
  de()
], st.prototype, "inputmode", 2);
q([
  on("disabled", { waitUntilFirstUpdate: !0 })
], st.prototype, "handleDisabledChange", 1);
q([
  on("step", { waitUntilFirstUpdate: !0 })
], st.prototype, "handleStepChange", 1);
q([
  on("value", { waitUntilFirstUpdate: !0 })
], st.prototype, "handleValueChange", 1);
st.define("sl-input");
var x1e = Ln`
  :host {
    --submenu-offset: -2px;

    display: block;
  }

  :host([inert]) {
    display: none;
  }

  .menu-item {
    position: relative;
    display: flex;
    align-items: stretch;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-2x-small) var(--sl-spacing-2x-small);
    transition: var(--sl-transition-fast) fill;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    cursor: pointer;
  }

  .menu-item.menu-item--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .menu-item.menu-item--loading {
    outline: none;
    cursor: wait;
  }

  .menu-item.menu-item--loading *:not(sl-spinner) {
    opacity: 0.5;
  }

  .menu-item--loading sl-spinner {
    --indicator-color: currentColor;
    --track-width: 1px;
    position: absolute;
    font-size: 0.75em;
    top: calc(50% - 0.5em);
    left: 0.65rem;
    opacity: 1;
  }

  .menu-item .menu-item__label {
    flex: 1 1 auto;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .menu-item .menu-item__prefix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .menu-item .menu-item__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /* Safe triangle */
  .menu-item--submenu-expanded::after {
    content: '';
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--safe-triangle-cursor-x, 0) var(--safe-triangle-cursor-y, 0),
      var(--safe-triangle-submenu-start-x, 0) var(--safe-triangle-submenu-start-y, 0),
      var(--safe-triangle-submenu-end-x, 0) var(--safe-triangle-submenu-end-y, 0)
    );
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host(:hover:not([aria-disabled='true'], :focus-visible)) .menu-item,
  .menu-item--submenu-expanded {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  :host(:focus-visible) .menu-item {
    outline: none;
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .menu-item .menu-item__check,
  .menu-item .menu-item__chevron {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5em;
    visibility: hidden;
  }

  .menu-item--checked .menu-item__check,
  .menu-item--has-submenu .menu-item__chevron {
    visibility: visible;
  }

  /* Add elevation and z-index to submenus */
  sl-popup::part(popup) {
    box-shadow: var(--sl-shadow-large);
    z-index: var(--sl-z-index-dropdown);
    margin-left: var(--submenu-offset);
  }

  .menu-item--rtl sl-popup::part(popup) {
    margin-left: calc(-1 * var(--submenu-offset));
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .menu-item,
    :host(:focus-visible) .menu-item {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }

  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`;
const qc = (e, t) => {
  const r = e._$AN;
  if (r === void 0) return !1;
  for (const n of r) n._$AO?.(t, !1), qc(n, t);
  return !0;
}, Nh = (e) => {
  let t, r;
  do {
    if ((t = e._$AM) === void 0) break;
    r = t._$AN, r.delete(e), e = t;
  } while (r?.size === 0);
}, pS = (e) => {
  for (let t; t = e._$AM; e = t) {
    let r = t._$AN;
    if (r === void 0) t._$AN = r = /* @__PURE__ */ new Set();
    else if (r.has(e)) break;
    r.add(e), E1e(t);
  }
};
function S1e(e) {
  this._$AN !== void 0 ? (Nh(this), this._$AM = e, pS(this)) : this._$AM = e;
}
function C1e(e, t = !1, r = 0) {
  const n = this._$AH, i = this._$AN;
  if (i !== void 0 && i.size !== 0) if (t) if (Array.isArray(n)) for (let a = r; a < n.length; a++) qc(n[a], !1), Nh(n[a]);
  else n != null && (qc(n, !1), Nh(n));
  else qc(this, e);
}
const E1e = (e) => {
  e.type == to.CHILD && (e._$AP ??= C1e, e._$AQ ??= S1e);
};
class A1e extends Z3 {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, r, n) {
    super._$AT(t, r, n), pS(this), this.isConnected = t._$AU;
  }
  _$AO(t, r = !0) {
    t !== this.isConnected && (this.isConnected = t, t ? this.reconnected?.() : this.disconnected?.()), r && (qc(this, t), Nh(this));
  }
  setValue(t) {
    if (bx(this._$Ct)) this._$Ct._$AI(t, this);
    else {
      const r = [...this._$Ct._$AH];
      r[this._$Ci] = t, this._$Ct._$AI(r, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
const T1e = () => new O1e();
class O1e {
}
const Ip = /* @__PURE__ */ new WeakMap(), I1e = G3(class extends A1e {
  render(e) {
    return gr;
  }
  update(e, [t]) {
    const r = t !== this.G;
    return r && this.G !== void 0 && this.rt(void 0), (r || this.lt !== this.ct) && (this.G = t, this.ht = e.options?.host, this.rt(this.ct = e.element)), gr;
  }
  rt(e) {
    if (this.isConnected || (e = void 0), typeof this.G == "function") {
      const t = this.ht ?? globalThis;
      let r = Ip.get(t);
      r === void 0 && (r = /* @__PURE__ */ new WeakMap(), Ip.set(t, r)), r.get(this.G) !== void 0 && this.G.call(this.ht, void 0), r.set(this.G, e), e !== void 0 && this.G.call(this.ht, e);
    } else this.G.value = e;
  }
  get lt() {
    return typeof this.G == "function" ? Ip.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
var P1e = class {
  constructor(e, t) {
    this.popupRef = T1e(), this.enableSubmenuTimer = -1, this.isConnected = !1, this.isPopupConnected = !1, this.skidding = 0, this.submenuOpenDelay = 100, this.handleMouseMove = (r) => {
      this.host.style.setProperty("--safe-triangle-cursor-x", `${r.clientX}px`), this.host.style.setProperty("--safe-triangle-cursor-y", `${r.clientY}px`);
    }, this.handleMouseOver = () => {
      this.hasSlotController.test("submenu") && this.enableSubmenu();
    }, this.handleKeyDown = (r) => {
      switch (r.key) {
        case "Escape":
        case "Tab":
          this.disableSubmenu();
          break;
        case "ArrowLeft":
          r.target !== this.host && (r.preventDefault(), r.stopPropagation(), this.host.focus(), this.disableSubmenu());
          break;
        case "ArrowRight":
        case "Enter":
        case " ":
          this.handleSubmenuEntry(r);
          break;
      }
    }, this.handleClick = (r) => {
      var n;
      r.target === this.host ? (r.preventDefault(), r.stopPropagation()) : r.target instanceof Element && (r.target.tagName === "sl-menu-item" || (n = r.target.role) != null && n.startsWith("menuitem")) && this.disableSubmenu();
    }, this.handleFocusOut = (r) => {
      r.relatedTarget && r.relatedTarget instanceof Element && this.host.contains(r.relatedTarget) || this.disableSubmenu();
    }, this.handlePopupMouseover = (r) => {
      r.stopPropagation();
    }, this.handlePopupReposition = () => {
      const r = this.host.renderRoot.querySelector("slot[name='submenu']"), n = r?.assignedElements({ flatten: !0 }).filter((d) => d.localName === "sl-menu")[0], i = getComputedStyle(this.host).direction === "rtl";
      if (!n)
        return;
      const { left: a, top: o, width: s, height: l } = n.getBoundingClientRect();
      this.host.style.setProperty("--safe-triangle-submenu-start-x", `${i ? a + s : a}px`), this.host.style.setProperty("--safe-triangle-submenu-start-y", `${o}px`), this.host.style.setProperty("--safe-triangle-submenu-end-x", `${i ? a + s : a}px`), this.host.style.setProperty("--safe-triangle-submenu-end-y", `${o + l}px`);
    }, (this.host = e).addController(this), this.hasSlotController = t;
  }
  hostConnected() {
    this.hasSlotController.test("submenu") && !this.host.disabled && this.addListeners();
  }
  hostDisconnected() {
    this.removeListeners();
  }
  hostUpdated() {
    this.hasSlotController.test("submenu") && !this.host.disabled ? (this.addListeners(), this.updateSkidding()) : this.removeListeners();
  }
  addListeners() {
    this.isConnected || (this.host.addEventListener("mousemove", this.handleMouseMove), this.host.addEventListener("mouseover", this.handleMouseOver), this.host.addEventListener("keydown", this.handleKeyDown), this.host.addEventListener("click", this.handleClick), this.host.addEventListener("focusout", this.handleFocusOut), this.isConnected = !0), this.isPopupConnected || this.popupRef.value && (this.popupRef.value.addEventListener("mouseover", this.handlePopupMouseover), this.popupRef.value.addEventListener("sl-reposition", this.handlePopupReposition), this.isPopupConnected = !0);
  }
  removeListeners() {
    this.isConnected && (this.host.removeEventListener("mousemove", this.handleMouseMove), this.host.removeEventListener("mouseover", this.handleMouseOver), this.host.removeEventListener("keydown", this.handleKeyDown), this.host.removeEventListener("click", this.handleClick), this.host.removeEventListener("focusout", this.handleFocusOut), this.isConnected = !1), this.isPopupConnected && this.popupRef.value && (this.popupRef.value.removeEventListener("mouseover", this.handlePopupMouseover), this.popupRef.value.removeEventListener("sl-reposition", this.handlePopupReposition), this.isPopupConnected = !1);
  }
  handleSubmenuEntry(e) {
    const t = this.host.renderRoot.querySelector("slot[name='submenu']");
    if (!t) {
      console.error("Cannot activate a submenu if no corresponding menuitem can be found.", this);
      return;
    }
    let r = null;
    for (const n of t.assignedElements())
      if (r = n.querySelectorAll("sl-menu-item, [role^='menuitem']"), r.length !== 0)
        break;
    if (!(!r || r.length === 0)) {
      r[0].setAttribute("tabindex", "0");
      for (let n = 1; n !== r.length; ++n)
        r[n].setAttribute("tabindex", "-1");
      this.popupRef.value && (e.preventDefault(), e.stopPropagation(), this.popupRef.value.active ? r[0] instanceof HTMLElement && r[0].focus() : (this.enableSubmenu(!1), this.host.updateComplete.then(() => {
        r[0] instanceof HTMLElement && r[0].focus();
      }), this.host.requestUpdate()));
    }
  }
  setSubmenuState(e) {
    this.popupRef.value && this.popupRef.value.active !== e && (this.popupRef.value.active = e, this.host.requestUpdate());
  }
  // Shows the submenu. Supports disabling the opening delay, e.g. for keyboard events that want to set the focus to the
  // newly opened menu.
  enableSubmenu(e = !0) {
    e ? (window.clearTimeout(this.enableSubmenuTimer), this.enableSubmenuTimer = window.setTimeout(() => {
      this.setSubmenuState(!0);
    }, this.submenuOpenDelay)) : this.setSubmenuState(!0);
  }
  disableSubmenu() {
    window.clearTimeout(this.enableSubmenuTimer), this.setSubmenuState(!1);
  }
  // Calculate the space the top of a menu takes-up, for aligning the popup menu-item with the activating element.
  updateSkidding() {
    var e;
    if (!((e = this.host.parentElement) != null && e.computedStyleMap))
      return;
    const t = this.host.parentElement.computedStyleMap(), n = ["padding-top", "border-top-width", "margin-top"].reduce((i, a) => {
      var o;
      const s = (o = t.get(a)) != null ? o : new CSSUnitValue(0, "px"), d = (s instanceof CSSUnitValue ? s : new CSSUnitValue(0, "px")).to("px");
      return i - d.value;
    }, 0);
    this.skidding = n;
  }
  isExpanded() {
    return this.popupRef.value ? this.popupRef.value.active : !1;
  }
  renderSubmenu() {
    const e = getComputedStyle(this.host).direction === "rtl";
    return this.isConnected ? hr`
      <sl-popup
        ${I1e(this.popupRef)}
        placement=${e ? "left-start" : "right-start"}
        anchor="anchor"
        flip
        flip-fallback-strategy="best-fit"
        skidding="${this.skidding}"
        strategy="fixed"
        auto-size="vertical"
        auto-size-padding="10"
      >
        <slot name="submenu"></slot>
      </sl-popup>
    ` : hr` <slot name="submenu" hidden></slot> `;
  }
}, Yn = class extends fn {
  constructor() {
    super(...arguments), this.localize = new Do(this), this.type = "normal", this.checked = !1, this.value = "", this.loading = !1, this.disabled = !1, this.hasSlotController = new a0(this, "submenu"), this.submenuController = new P1e(this, this.hasSlotController), this.handleHostClick = (e) => {
      this.disabled && (e.preventDefault(), e.stopImmediatePropagation());
    }, this.handleMouseOver = (e) => {
      this.focus(), e.stopPropagation();
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", this.handleHostClick), this.addEventListener("mouseover", this.handleMouseOver);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this.handleHostClick), this.removeEventListener("mouseover", this.handleMouseOver);
  }
  handleDefaultSlotChange() {
    const e = this.getTextLabel();
    if (typeof this.cachedTextLabel > "u") {
      this.cachedTextLabel = e;
      return;
    }
    e !== this.cachedTextLabel && (this.cachedTextLabel = e, this.emit("slotchange", { bubbles: !0, composed: !1, cancelable: !1 }));
  }
  handleCheckedChange() {
    if (this.checked && this.type !== "checkbox") {
      this.checked = !1, console.error('The checked attribute can only be used on menu items with type="checkbox"', this);
      return;
    }
    this.type === "checkbox" ? this.setAttribute("aria-checked", this.checked ? "true" : "false") : this.removeAttribute("aria-checked");
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  handleTypeChange() {
    this.type === "checkbox" ? (this.setAttribute("role", "menuitemcheckbox"), this.setAttribute("aria-checked", this.checked ? "true" : "false")) : (this.setAttribute("role", "menuitem"), this.removeAttribute("aria-checked"));
  }
  /** Returns a text label based on the contents of the menu item's default slot. */
  getTextLabel() {
    return Ase(this.defaultSlot);
  }
  isSubmenu() {
    return this.hasSlotController.test("submenu");
  }
  render() {
    const e = this.localize.dir() === "rtl", t = this.submenuController.isExpanded();
    return hr`
      <div
        id="anchor"
        part="base"
        class=${Wn({
      "menu-item": !0,
      "menu-item--rtl": e,
      "menu-item--checked": this.checked,
      "menu-item--disabled": this.disabled,
      "menu-item--loading": this.loading,
      "menu-item--has-submenu": this.isSubmenu(),
      "menu-item--submenu-expanded": t
    })}
        ?aria-haspopup="${this.isSubmenu()}"
        ?aria-expanded="${!!t}"
      >
        <span part="checked-icon" class="menu-item__check">
          <sl-icon name="check" library="system" aria-hidden="true"></sl-icon>
        </span>

        <slot name="prefix" part="prefix" class="menu-item__prefix"></slot>

        <slot part="label" class="menu-item__label" @slotchange=${this.handleDefaultSlotChange}></slot>

        <slot name="suffix" part="suffix" class="menu-item__suffix"></slot>

        <span part="submenu-icon" class="menu-item__chevron">
          <sl-icon name=${e ? "chevron-left" : "chevron-right"} library="system" aria-hidden="true"></sl-icon>
        </span>

        ${this.submenuController.renderSubmenu()}
        ${this.loading ? hr` <sl-spinner part="spinner" exportparts="base:spinner__base"></sl-spinner> ` : ""}
      </div>
    `;
  }
};
Yn.styles = [oi, x1e];
Yn.dependencies = {
  "sl-icon": si,
  "sl-popup": Wt,
  "sl-spinner": W3
};
q([
  qr("slot:not([name])")
], Yn.prototype, "defaultSlot", 2);
q([
  qr(".menu-item")
], Yn.prototype, "menuItem", 2);
q([
  de()
], Yn.prototype, "type", 2);
q([
  de({ type: Boolean, reflect: !0 })
], Yn.prototype, "checked", 2);
q([
  de()
], Yn.prototype, "value", 2);
q([
  de({ type: Boolean, reflect: !0 })
], Yn.prototype, "loading", 2);
q([
  de({ type: Boolean, reflect: !0 })
], Yn.prototype, "disabled", 2);
q([
  on("checked")
], Yn.prototype, "handleCheckedChange", 1);
q([
  on("disabled")
], Yn.prototype, "handleDisabledChange", 1);
q([
  on("type")
], Yn.prototype, "handleTypeChange", 1);
Yn.define("sl-menu-item");
var N1e = Ln`
  :host {
    display: block;
    position: relative;
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding: var(--sl-spacing-x-small) 0;
    overflow: auto;
    overscroll-behavior: none;
  }

  ::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }
`, ov = class extends fn {
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "menu");
  }
  handleClick(e) {
    const t = ["menuitem", "menuitemcheckbox"], r = e.composedPath(), n = r.find((s) => {
      var l;
      return t.includes(((l = s?.getAttribute) == null ? void 0 : l.call(s, "role")) || "");
    });
    if (!n || r.find((s) => {
      var l;
      return ((l = s?.getAttribute) == null ? void 0 : l.call(s, "role")) === "menu";
    }) !== this) return;
    const o = n;
    o.type === "checkbox" && (o.checked = !o.checked), this.emit("sl-select", { detail: { item: o } });
  }
  handleKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      const t = this.getCurrentItem();
      e.preventDefault(), e.stopPropagation(), t?.click();
    } else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) {
      const t = this.getAllItems(), r = this.getCurrentItem();
      let n = r ? t.indexOf(r) : 0;
      t.length > 0 && (e.preventDefault(), e.stopPropagation(), e.key === "ArrowDown" ? n++ : e.key === "ArrowUp" ? n-- : e.key === "Home" ? n = 0 : e.key === "End" && (n = t.length - 1), n < 0 && (n = t.length - 1), n > t.length - 1 && (n = 0), this.setCurrentItem(t[n]), t[n].focus());
    }
  }
  handleMouseDown(e) {
    const t = e.target;
    this.isMenuItem(t) && this.setCurrentItem(t);
  }
  handleSlotChange() {
    const e = this.getAllItems();
    e.length > 0 && this.setCurrentItem(e[0]);
  }
  isMenuItem(e) {
    var t;
    return e.tagName.toLowerCase() === "sl-menu-item" || ["menuitem", "menuitemcheckbox", "menuitemradio"].includes((t = e.getAttribute("role")) != null ? t : "");
  }
  /** @internal Gets all slotted menu items, ignoring dividers, headers, and other elements. */
  getAllItems() {
    return [...this.defaultSlot.assignedElements({ flatten: !0 })].filter((e) => !(e.inert || !this.isMenuItem(e)));
  }
  /**
   * @internal Gets the current menu item, which is the menu item that has `tabindex="0"` within the roving tab index.
   * The menu item may or may not have focus, but for keyboard interaction purposes it's considered the "active" item.
   */
  getCurrentItem() {
    return this.getAllItems().find((e) => e.getAttribute("tabindex") === "0");
  }
  /**
   * @internal Sets the current menu item to the specified element. This sets `tabindex="0"` on the target element and
   * `tabindex="-1"` to all other items. This method must be called prior to setting focus on a menu item.
   */
  setCurrentItem(e) {
    this.getAllItems().forEach((r) => {
      r.setAttribute("tabindex", r === e ? "0" : "-1");
    });
  }
  render() {
    return hr`
      <slot
        @slotchange=${this.handleSlotChange}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      ></slot>
    `;
  }
};
ov.styles = [oi, N1e];
q([
  qr("slot")
], ov.prototype, "defaultSlot", 2);
ov.define("sl-menu");
const D1e = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group{background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:500}.treatment-option::part(checked-icon){display:none;width:0px}.full-screen-close-btn::part(base){padding:0}.treatment-search::part(input){padding-right:0}.treatment-search::part(input)::-moz-placeholder{--tw-text-opacity: 1;color:rgb(209,213,219,var(--tw-text-opacity))}.treatment-search::part(input)::placeholder{--tw-text-opacity: 1;color:rgb(209,213,219,var(--tw-text-opacity))}.dropdown::part(panel){box-shadow:none}.dropdown-container{height:100vh;height:100dvh;max-height:100dvh}.dropdown-container-list-items{-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-y}";
function tl(e, t, r) {
  let n = r.initialDeps ?? [], i, a = !0;
  function o() {
    var s, l, d;
    let c;
    r.key && ((s = r.debug) != null && s.call(r)) && (c = Date.now());
    const u = e();
    if (!(u.length !== n.length || u.some((p, m) => n[m] !== p)))
      return i;
    n = u;
    let f;
    if (r.key && ((l = r.debug) != null && l.call(r)) && (f = Date.now()), i = t(...u), r.key && ((d = r.debug) != null && d.call(r))) {
      const p = Math.round((Date.now() - c) * 100) / 100, m = Math.round((Date.now() - f) * 100) / 100, y = m / 16, v = (b, $) => {
        for (b = String(b); b.length < $; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${v(m, 5)} /${v(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * y, 120)
        )}deg 100% 31%);`,
        r?.key
      );
    }
    return r?.onChange && !(a && r.skipInitialOnChange) && r.onChange(i), a = !1, i;
  }
  return o.updateDeps = (s) => {
    n = s;
  }, o;
}
function v8(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const M1e = (e, t) => Math.abs(e - t) < 1.01, R1e = (e, t, r) => {
  let n;
  return function(...i) {
    e.clearTimeout(n), n = e.setTimeout(() => t.apply(this, i), r);
  };
}, y8 = (e) => {
  const { offsetWidth: t, offsetHeight: r } = e;
  return { width: t, height: r };
}, L1e = (e) => e, F1e = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), n = [];
  for (let i = t; i <= r; i++)
    n.push(i);
  return n;
}, j1e = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  const i = (o) => {
    const { width: s, height: l } = o;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (i(y8(r)), !n.ResizeObserver)
    return () => {
    };
  const a = new n.ResizeObserver((o) => {
    const s = () => {
      const l = o[0];
      if (l?.borderBoxSize) {
        const d = l.borderBoxSize[0];
        if (d) {
          i({ width: d.inlineSize, height: d.blockSize });
          return;
        }
      }
      i(y8(r));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
  });
  return a.observe(r, { box: "border-box" }), () => {
    a.unobserve(r);
  };
}, b8 = {
  passive: !0
}, w8 = typeof window > "u" ? !0 : "onscrollend" in window, z1e = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  let i = 0;
  const a = e.options.useScrollendEvent && w8 ? () => {
  } : R1e(
    n,
    () => {
      t(i, !1);
    },
    e.options.isScrollingResetDelay
  ), o = (c) => () => {
    const { horizontal: u, isRtl: h } = e.options;
    i = u ? r.scrollLeft * (h && -1 || 1) : r.scrollTop, a(), t(i, c);
  }, s = o(!0), l = o(!1);
  r.addEventListener("scroll", s, b8);
  const d = e.options.useScrollendEvent && w8;
  return d && r.addEventListener("scrollend", l, b8), () => {
    r.removeEventListener("scroll", s), d && r.removeEventListener("scrollend", l);
  };
}, V1e = (e, t, r) => {
  if (t?.borderBoxSize) {
    const n = t.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[r.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, U1e = (e, {
  adjustments: t = 0,
  behavior: r
}, n) => {
  var i, a;
  const o = e + t;
  (a = (i = n.scrollElement) == null ? void 0 : i.scrollTo) == null || a.call(i, {
    [n.options.horizontal ? "left" : "top"]: o,
    behavior: r
  });
};
class q1e {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollState = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.now = () => {
      var r, n, i;
      return ((i = (n = (r = this.targetWindow) == null ? void 0 : r.performance) == null ? void 0 : n.now) == null ? void 0 : i.call(n)) ?? Date.now();
    }, this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((a) => {
          const o = () => {
            this._measureElement(a.target, a);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(o) : o();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = n()) == null || i.disconnect(), r = null;
        },
        observe: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, i]) => {
        typeof i > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: L1e,
        rangeExtractor: F1e,
        onChange: () => {
        },
        measureElement: V1e,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, i;
      (i = (n = this.options).onChange) == null || i.call(n, this, r);
    }, this.maybeNotify = tl(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: !1,
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.rafId != null && this.targetWindow && (this.targetWindow.cancelAnimationFrame(this.rafId), this.rafId = null), this.scrollState = null, this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, a) => {
            this.scrollAdjustments = 0, this.scrollDirection = a ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = a, this.scrollState && this.scheduleScrollReconcile(), this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.rafId = null, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (let o = n - 1; o >= 0; o--) {
        const s = r[o];
        if (i.has(s.lane))
          continue;
        const l = a.get(
          s.lane
        );
        if (l == null || s.end > l.end ? a.set(s.lane, s) : s.end < l.end && i.set(s.lane, !0), i.size === this.options.lanes)
          break;
      }
      return a.size === this.options.lanes ? Array.from(a.values()).sort((o, s) => o.end === s.end ? o.index - s.index : o.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = tl(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (r, n, i, a, o, s) => (this.prevLanes !== void 0 && this.prevLanes !== s && (this.lanesChangedFlag = !0), this.prevLanes = s, this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: i,
        getItemKey: a,
        enabled: o,
        lanes: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = tl(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: i, getItemKey: a, enabled: o, lanes: s }, l) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > r)
          for (const h of this.laneAssignments.keys())
            h >= r && this.laneAssignments.delete(h);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((h) => {
          this.itemSizeCache.set(h.key, h.size);
        }));
        const d = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === r && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, d), u = new Array(s).fill(
          void 0
        );
        for (let h = 0; h < d; h++) {
          const f = c[h];
          f && (u[f.lane] = h);
        }
        for (let h = d; h < r; h++) {
          const f = a(h), p = this.laneAssignments.get(h);
          let m, y;
          if (p !== void 0 && this.options.lanes > 1) {
            m = p;
            const _ = u[m], x = _ !== void 0 ? c[_] : void 0;
            y = x ? x.end + this.options.gap : n + i;
          } else {
            const _ = this.options.lanes === 1 ? c[h - 1] : this.getFurthestMeasurement(c, h);
            y = _ ? _.end + this.options.gap : n + i, m = _ ? _.lane : h % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(h, m);
          }
          const v = l.get(f), b = typeof v == "number" ? v : this.options.estimateSize(h), $ = y + b;
          c[h] = {
            index: h,
            start: y,
            size: b,
            end: $,
            key: f,
            lane: m
          }, u[m] = h;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.calculateRange = tl(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (r, n, i, a) => this.range = r.length > 0 && n > 0 ? B1e({
        measurements: r,
        outerSize: n,
        scrollOffset: i,
        lanes: a
      }) : null,
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = tl(
      () => {
        let r = null, n = null;
        const i = this.calculateRange();
        return i && (r = i.startIndex, n = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, r, n]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          r,
          n
        ];
      },
      (r, n, i, a, o) => a === null || o === null ? [] : r({
        startIndex: a,
        endIndex: o,
        overscan: n,
        count: i
      }),
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, i = r.getAttribute(n);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this.shouldMeasureDuringScroll = (r) => {
      var n;
      if (!this.scrollState || this.scrollState.behavior !== "smooth")
        return !0;
      const i = this.scrollState.index ?? ((n = this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)) == null ? void 0 : n.index);
      if (i !== void 0 && this.range) {
        const a = Math.max(
          this.options.overscan,
          Math.ceil((this.range.endIndex - this.range.startIndex) / 2)
        ), o = Math.max(0, i - a), s = Math.min(
          this.options.count - 1,
          i + a
        );
        return r >= o && r <= s;
      }
      return !0;
    }, this._measureElement = (r, n) => {
      if (!r.isConnected) {
        this.observer.unobserve(r);
        return;
      }
      const i = this.indexFromElement(r), a = this.measurementsCache[i];
      if (!a)
        return;
      const o = a.key, s = this.elementsCache.get(o);
      s !== r && (s && this.observer.unobserve(s), this.observer.observe(r), this.elementsCache.set(o, r)), this.shouldMeasureDuringScroll(i) && this.resizeItem(i, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      var i;
      const a = this.measurementsCache[r];
      if (!a)
        return;
      const o = this.itemSizeCache.get(a.key) ?? a.size, s = n - o;
      s !== 0 && (((i = this.scrollState) == null ? void 0 : i.behavior) !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(a, s, this) : a.start < this.getScrollOffset() + this.scrollAdjustments) && this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      }), this.pendingMeasuredCacheIndexes.push(a.index), this.itemSizeCache = new Map(this.itemSizeCache.set(a.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, i) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = tl(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (r, n) => {
        const i = [];
        for (let a = 0, o = r.length; a < o; a++) {
          const s = r[a], l = n[s];
          i.push(l);
        }
        return i;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return v8(
          n[mS(
            0,
            n.length - 1,
            (i) => v8(n[i]).start,
            r
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const r = this.scrollElement.document.documentElement;
        return this.options.horizontal ? r.scrollWidth - this.scrollElement.innerWidth : r.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (r, n, i = 0) => {
      if (!this.scrollElement) return 0;
      const a = this.getSize(), o = this.getScrollOffset();
      n === "auto" && (n = r >= o + a ? "end" : "start"), n === "center" ? r += (i - a) / 2 : n === "end" && (r -= a);
      const s = this.getMaxScrollOffset();
      return Math.max(Math.min(s, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const i = this.getSize(), a = this.getScrollOffset(), o = this.measurementsCache[r];
      if (!o) return;
      if (n === "auto")
        if (o.end >= a + i - this.options.scrollPaddingEnd)
          n = "end";
        else if (o.start <= a + this.options.scrollPaddingStart)
          n = "start";
        else
          return [a, n];
      if (n === "end" && r === this.options.count - 1)
        return [this.getMaxScrollOffset(), n];
      const s = n === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(s, n, o.size),
        n
      ];
    }, this.scrollToOffset = (r, { align: n = "start", behavior: i = "auto" } = {}) => {
      const a = this.getOffsetForAlignment(r, n), o = this.now();
      this.scrollState = {
        index: null,
        align: n,
        behavior: i,
        startedAt: o,
        lastTargetOffset: a,
        stableFrames: 0
      }, this._scrollToOffset(a, { adjustments: void 0, behavior: i }), this.scheduleScrollReconcile();
    }, this.scrollToIndex = (r, {
      align: n = "auto",
      behavior: i = "auto"
    } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const a = this.getOffsetForIndex(r, n);
      if (!a)
        return;
      const [o, s] = a, l = this.now();
      this.scrollState = {
        index: r,
        align: s,
        behavior: i,
        startedAt: l,
        lastTargetOffset: o,
        stableFrames: 0
      }, this._scrollToOffset(o, { adjustments: void 0, behavior: i }), this.scheduleScrollReconcile();
    }, this.scrollBy = (r, { behavior: n = "auto" } = {}) => {
      const i = this.getScrollOffset() + r, a = this.now();
      this.scrollState = {
        index: null,
        align: "start",
        behavior: n,
        startedAt: a,
        lastTargetOffset: i,
        stableFrames: 0
      }, this._scrollToOffset(i, { adjustments: void 0, behavior: n }), this.scheduleScrollReconcile();
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let i;
      if (n.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0;
      else {
        const a = Array(this.options.lanes).fill(null);
        let o = n.length - 1;
        for (; o >= 0 && a.some((s) => s === null); ) {
          const s = n[o];
          a[s.lane] === null && (a[s.lane] = s.end), o--;
        }
        i = Math.max(...a.filter((s) => s !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: i
    }) => {
      this.options.scrollToFn(r, { behavior: i, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
  scheduleScrollReconcile() {
    if (!this.targetWindow) {
      this.scrollState = null;
      return;
    }
    this.rafId == null && (this.rafId = this.targetWindow.requestAnimationFrame(() => {
      this.rafId = null, this.reconcileScroll();
    }));
  }
  reconcileScroll() {
    if (!this.scrollState || !this.scrollElement) return;
    if (this.now() - this.scrollState.startedAt > 5e3) {
      this.scrollState = null;
      return;
    }
    const n = this.scrollState.index != null ? this.getOffsetForIndex(this.scrollState.index, this.scrollState.align) : void 0, i = n ? n[0] : this.scrollState.lastTargetOffset, a = 1, o = i !== this.scrollState.lastTargetOffset;
    if (!o && M1e(i, this.getScrollOffset())) {
      if (this.scrollState.stableFrames++, this.scrollState.stableFrames >= a) {
        this.scrollState = null;
        return;
      }
    } else
      this.scrollState.stableFrames = 0, o && (this.scrollState.lastTargetOffset = i, this.scrollState.behavior = "auto", this._scrollToOffset(i, {
        adjustments: void 0,
        behavior: "auto"
      }));
    this.scheduleScrollReconcile();
  }
}
const mS = (e, t, r, n) => {
  for (; e <= t; ) {
    const i = (e + t) / 2 | 0, a = r(i);
    if (a < n)
      e = i + 1;
    else if (a > n)
      t = i - 1;
    else
      return i;
  }
  return e > 0 ? e - 1 : 0;
};
function B1e({
  measurements: e,
  outerSize: t,
  scrollOffset: r,
  lanes: n
}) {
  const i = e.length - 1, a = (l) => e[l].start;
  if (e.length <= n)
    return {
      startIndex: 0,
      endIndex: i
    };
  let o = mS(
    0,
    i,
    a,
    r
  ), s = o;
  if (n === 1)
    for (; s < i && e[s].end < r + t; )
      s++;
  else if (n > 1) {
    const l = Array(n).fill(0);
    for (; s < i && l.some((c) => c < r + t); ) {
      const c = e[s];
      l[c.lane] = c.end, s++;
    }
    const d = Array(n).fill(r + t);
    for (; o >= 0 && d.some((c) => c >= r); ) {
      const c = e[o];
      d[c.lane] = c.start, o--;
    }
    o = Math.max(0, o - o % n), s = Math.min(i, s + (n - 1 - s % n));
  }
  return { startIndex: o, endIndex: s };
}
function H1e(e) {
  const t = it(e), r = new q1e(t), [n, i] = _f(r.getVirtualItems()), [a, o] = V(r.getTotalSize()), s = {
    get(d, c) {
      switch (c) {
        case "getVirtualItems":
          return () => n;
        case "getTotalSize":
          return () => a();
        default:
          return Reflect.get(d, c);
      }
    }
  }, l = new Proxy(r, s);
  return l.setOptions(t), lr(() => {
    const d = l._didMount();
    l._willUpdate(), sr(d);
  }), bg(() => {
    l.setOptions(it(t, e, {
      onChange: (d, c) => {
        var u;
        d._willUpdate(), i(Zoe(d.getVirtualItems(), {
          key: "index"
        })), o(d.getTotalSize()), (u = e.onChange) == null || u.call(e, d, c);
      }
    })), l.measure();
  }), l;
}
function sv(e) {
  return H1e(it({
    observeElementRect: j1e,
    observeElementOffset: z1e,
    scrollToFn: U1e
  }, e));
}
var W1e = /* @__PURE__ */ ae('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), Q1e = /* @__PURE__ */ ae('<div><style></style><style></style><style></style><style></style><div class="dropdown-container fixed top-0 left-0 w-full bg-white overflow-hidden z-2000 flex flex-col"><div class="flex items-center pb-2 pl-5 pr-5 pt-3 flex-shrink-0"><div class="flex items-center"><sl-icon-button name=x label="Close medication search"class=full-screen-close-btn></sl-icon-button></div></div><div class=flex-shrink-0><sl-input slot=trigger clearable autocomplete=off size=medium class="treatment-search input mb-2 px-4"><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div></sl-input></div><div class="w-full flex-1 overflow-y-auto .dropdown-container-list-items">', !0, !1, !1), K1e = /* @__PURE__ */ ae('<div class="md:flex flex-1 justify-center items-center pl-2"><div class="flex items-center space-x-2"><p class="text-gray-700 text-sm font-sans inline font-medium">'), G1e = /* @__PURE__ */ ae('<p class="pl-1 text-red-400">*'), Z1e = /* @__PURE__ */ ae('<p class="text-gray-400 text-xs pl-2 font-sans">Optional'), Y1e = /* @__PURE__ */ ae("<div class=px-4><p class=text-gray-400>Loading..."), J1e = /* @__PURE__ */ ae("<div class=px-4><p class=text-gray-400>No treatments found"), X1e = /* @__PURE__ */ ae('<div class="group uppercase px-4">'), ehe = /* @__PURE__ */ ae("<div class=treatment-option>"), the = /* @__PURE__ */ ae('<p class="text-center text-gray-400 italic px-3">Loading...'), rhe = /* @__PURE__ */ ae('<p class="text-center text-gray-400 italic px-3">Nothing more to load'), nhe = /* @__PURE__ */ ae('<div class="px-4 py-1">');
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const ihe = (e) => {
  let t, r, n;
  e.actionRef && (e.actionRef.clear = () => {
    n.value = "", i(""), s();
  });
  const i = Nf(async (c) => {
    e.onSearchChange && await e.onSearchChange(c);
  }, 500), a = (c) => {
    if (c)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, o = (c) => {
    const u = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: c
      }
    });
    t?.dispatchEvent(u);
  }, s = () => {
    const c = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(c);
  };
  lr(() => {
    n && (n.addEventListener("keydown", (c) => {
      (c.code == "Space" || c.key == " ") && c.stopImmediatePropagation();
    }), setTimeout(() => {
      n.focus();
    }, 100));
  }), fe(() => {
    if (e.open) {
      const c = window.scrollY;
      document.body.style.position = "fixed", document.body.style.top = `-${c}px`, document.body.style.width = "100%", document.body.style.overflow = "hidden", sr(() => {
        const u = document.body.style.top;
        document.body.style.position = "", document.body.style.top = "", document.body.style.width = "", document.body.style.overflow = "", window.scrollTo(0, parseInt(u || "0") * -1);
      });
    }
  });
  const l = K(() => e.groups ? e.groups.map((c) => {
    const u = e.data.map((h, f) => ({
      data: h,
      allItemsIdx: f
    })).filter((h) => c.filter(h.data));
    return u.length > 0 ? [{
      title: c.label
    }, ...u] : [];
  }).flat() : e.data.map((c, u) => ({
    data: c,
    allItemsIdx: u
  }))), d = K(() => sv({
    count: l().length,
    getScrollElement: () => r ?? null,
    estimateSize: () => 42,
    overscan: 100
  }));
  return (() => {
    var c = Q1e(), u = c.firstChild, h = u.nextSibling, f = h.nextSibling, p = f.nextSibling, m = p.nextSibling, y = m.firstChild, v = y.firstChild, b = v.firstChild, $ = y.nextSibling, _ = $.firstChild, x = _.firstChild, S = x.nextSibling, A = S.firstChild, N = $.nextSibling, P = t;
    typeof P == "function" ? Zt(P, c) : t = c, L(u, Gn), L(h, Ro), L(f, Mo), L(p, D1e), m.$$touchstart = (I) => I.stopPropagation(), m.$$touchmove = (I) => I.stopPropagation(), y.style.setProperty("touch-action", "none"), v.style.setProperty("font-size", "26px"), Ue(b, "click", () => {
      e.onClose && e.onClose();
    }), b.style.setProperty("padding", "0px"), b._$owner = Ve(), L(y, (() => {
      var I = At(() => !!e.label);
      return () => I() ? (() => {
        var j = K1e(), F = j.firstChild, Z = F.firstChild;
        return L(Z, () => e.label), j;
      })() : null;
    })(), null), L(y, (() => {
      var I = At(() => !!e.required);
      return () => I() ? G1e() : null;
    })(), null), L(y, (() => {
      var I = At(() => !!e.optional);
      return () => I() ? Z1e() : null;
    })(), null), $.$$touchstart = (I) => I.stopPropagation(), $.$$touchmove = (I) => I.stopPropagation(), $.style.setProperty("touch-action", "none"), Ue(_, "sl-clear", () => {
      n.value = "", i(""), s();
    }), Ue(_, "input", (I) => {
      i(I.target.value);
    });
    var D = n;
    typeof D == "function" ? Zt(D, _) : n = _, _.style.setProperty("border-radius", "0px"), _.style.setProperty("border", "0px"), _._$owner = Ve(), L(x, () => a(e.invalid ?? !1)), A._$owner = Ve(), L(_, g(H, {
      get when() {
        return e.clearable;
      },
      get children() {
        var I = W1e(), j = I.firstChild;
        return Ue(j, "click", (F) => {
          F.stopImmediatePropagation(), n.value = "", i(""), s();
        }), j._$owner = Ve(), se(() => I.classList.toggle("hidden", !!(e.isLoading || !e.selectedData))), I;
      }
    }), null);
    var T = r;
    return typeof T == "function" ? Zt(T, N) : r = N, L(N, g(yt, {
      get each() {
        return d().getVirtualItems();
      },
      get fallback() {
        return g(ahe, {
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (I) => {
        const j = I.index > l().length - 1, F = l()[I.index], Z = e.selectedData, te = !j && !!Z && "id" in Z && "data" in F && Z.id === F.data.id, Y = "title" in F ? ohe : she, Q = "title" in F ? {
          item: F
        } : {
          item: I,
          isLoader: j,
          isSelected: te,
          index: I.index,
          hasMore: e.hasMore,
          showOverflow: e.showOverflow,
          onClick: () => {
            j || (n.value = "", i(""), o(F.data));
          }
        };
        return g(oC, it({
          component: Y
        }, Q, {
          get children() {
            return At(() => "data" in F)() && e.displayAccessor(F.data, !0);
          }
        }));
      }
    })), se((I) => {
      var j = e.placeholder, F = e.disabled ?? !1, Z = !!(e.invalid ?? !1), te = !!(e.disabled ?? !1), Y = e.required, Q = !!e.forceLabelSize, R = !e.isLoading;
      return j !== I.e && (_.placeholder = I.e = j), F !== I.t && (_.disabled = I.t = F), Z !== I.a && _.classList.toggle("invalid", I.a = Z), te !== I.o && _.classList.toggle("disabled", I.o = te), Y !== I.i && (_.required = I.i = Y), Q !== I.n && x.classList.toggle("h-[21px]", I.n = Q), R !== I.s && S.classList.toggle("hidden", I.s = R), I;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0
    }), se(() => _.value = e.searchText), c;
  })();
}, ahe = (e) => g(H, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return J1e();
  },
  get children() {
    return Y1e();
  }
}), ohe = (e) => (() => {
  var t = X1e();
  return t.style.setProperty("position", "sticky"), t.style.setProperty("top", "0px"), t.style.setProperty("z-index", "10"), L(t, () => e.item.title), t;
})(), she = (e) => (() => {
  var t = ehe();
  return t.$$click = () => e.onClick(), L(t, (() => {
    var r = At(() => !!e.isLoader);
    return () => r() ? At(() => !!e.hasMore)() ? the() : rhe() : (() => {
      var n = nhe();
      return L(n, () => e.children), n;
    })();
  })()), se((r) => {
    var n = !!e.isSelected, i = !!e.isSelected;
    return n !== r.e && t.classList.toggle("bg-blue-500", r.e = n), i !== r.t && t.classList.toggle("text-white", r.t = i), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
Rs(["touchmove", "touchstart", "click"]);
const lhe = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.input::part(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group::part(base){background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:600}.dropdown::part(panel){border-radius:var(--photon-border-radius, .5rem)}.dropdown-container{border-radius:var(--photon-border-radius, .5rem)}.group::part(checked-icon){display:none;width:0px}.group::part(label){padding-left:12px;padding-right:12px}.treatment-option::part(checked-icon){display:none;width:0px}";
var dhe = /* @__PURE__ */ ae('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), che = /* @__PURE__ */ ae('<div><style></style><style></style><style></style><style></style><sl-dropdown class="dropdown relative"hoist><sl-input clearable slot=trigger autocomplete=off size=medium class=input><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div><div slot=suffix class=flex><sl-icon></sl-icon></div></sl-input><div class="border border-gray-200 dropdown-container overflow-hidden relative"><div class="bg-white overflow-x-hidden overflow-y-auto relative"><div>', !0, !1, !1), uhe = /* @__PURE__ */ ae('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm font-sans">'), hhe = /* @__PURE__ */ ae('<p class="pl-1 text-red-400">*'), fhe = /* @__PURE__ */ ae('<p class="text-gray-400 text-xs pl-2 font-sans">Optional'), phe = /* @__PURE__ */ ae('<sl-menu-item><p class="text-center text-gray-400 italic">Loading...', !0, !1, !1), mhe = /* @__PURE__ */ ae("<sl-menu-item>", !0, !1, !1), ghe = /* @__PURE__ */ ae('<sl-menu-item class="group uppercase">', !0, !1, !1), vhe = /* @__PURE__ */ ae("<sl-menu-item class=treatment-option>", !0, !1, !1), yhe = /* @__PURE__ */ ae('<p class="text-center text-gray-400 italic">Loading...'), bhe = /* @__PURE__ */ ae('<p class="text-center text-gray-400 italic">Nothing more to load'), whe = /* @__PURE__ */ ae('<p class="break-words px-3">');
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const $he = (e) => {
  let t, r, n, i, a;
  e.actionRef && (e.actionRef.clear = () => {
    d(void 0), u(-1), i.value = "", p(""), b();
  });
  const [o, s] = V(!1), [l, d] = V(void 0), [c, u] = V(-1), [h, f] = V(), p = Nf(async (x) => {
    e.onSearchChange && await e.onSearchChange(x);
  }, 250), m = new IntersectionObserver(async (x) => {
    x?.at(-1)?.isIntersecting && e.hasMore && e.fetchMore && await e.fetchMore();
  });
  fe(() => {
    e.data.length === 0 && d(void 0);
  }), fe(() => {
    h() && m.observe(h());
  });
  const y = (x) => {
    if (x)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, v = (x) => {
    const S = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: x
      }
    });
    t?.dispatchEvent(S);
  }, b = () => {
    const x = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(x);
  };
  fe(() => {
    e.selectedData && d(e.selectedData), e.selectedData === void 0 && d(void 0);
  }), lr(() => {
    i && i.addEventListener("keydown", (x) => {
      (x.code == "Space" || x.key == " ") && x.stopImmediatePropagation();
    });
  });
  const $ = K(() => e.groups ? e.groups.map((x) => {
    const S = e.data.map((A, N) => ({
      data: A,
      allItemsIdx: N
    })).filter((A) => x.filter(A.data));
    return S.length > 0 ? [{
      title: x.label
    }, ...S] : [];
  }).flat() : e.data.map((x, S) => ({
    data: x,
    allItemsIdx: S
  }))), _ = K(() => sv({
    count: $().length,
    getScrollElement: () => n ?? null,
    estimateSize: () => 36.8,
    overscan: 100
  }));
  return (() => {
    var x = che(), S = x.firstChild, A = S.nextSibling, N = A.nextSibling, P = N.nextSibling, D = P.nextSibling, T = D.firstChild, I = T.firstChild, j = I.nextSibling, F = j.firstChild, Z = j.nextSibling, te = Z.firstChild, Y = T.nextSibling, Q = Y.firstChild, R = Q.firstChild, re = t;
    typeof re == "function" ? Zt(re, x) : t = x, L(S, Gn), L(A, Ro), L(N, Mo), L(P, lhe), L(x, (() => {
      var oe = At(() => !!e.label);
      return () => oe() ? (() => {
        var le = uhe(), Fe = le.firstChild;
        return L(Fe, () => e.label), L(le, (() => {
          var We = At(() => !!e.required);
          return () => We() ? hhe() : null;
        })(), null), L(le, (() => {
          var We = At(() => !!e.optional);
          return () => We() ? fhe() : null;
        })(), null), le;
      })() : null;
    })(), D), Ue(D, "sl-show", async () => {
      s(!0), e.onOpen && await e.onOpen();
    }), Ue(D, "sl-hide", async () => {
      l() || (i.value = "", e.onHide && await e.onHide()), s(!1);
    });
    var he = r;
    typeof he == "function" ? Zt(he, D) : r = D, D.style.setProperty("width", "100%"), D._$owner = Ve(), Ue(T, "sl-clear", () => {
      d(void 0), u(-1), i.value = "", p(""), b();
    }), Ue(T, "sl-focus", (oe) => {
      e.onInputFocus ? (e.onInputFocus(), oe.stopImmediatePropagation()) : (r.children[1].style.width = `${i.clientWidth}px`, c() > 0 && _().scrollToIndex(c()));
    }), Ue(T, "sl-input", (oe) => {
      o() || r.show(), p(oe.target.value);
    });
    var ge = i;
    typeof ge == "function" ? Zt(ge, T) : i = T, T._$owner = Ve(), L(I, () => y(e.invalid ?? !1)), F._$owner = Ve(), L(T, g(H, {
      get when() {
        return e.clearable;
      },
      get children() {
        var oe = dhe(), le = oe.firstChild;
        return Ue(le, "click", (Fe) => {
          Fe.stopImmediatePropagation(), d(void 0), u(-1), i.value = "", p(""), b(), r.hide();
        }), le._$owner = Ve(), se(() => oe.classList.toggle("hidden", !!(e.isLoading || l() == null))), oe;
      }
    }), Z), te._$owner = Ve(), Y.style.setProperty("width", "518px");
    var ce = a;
    typeof ce == "function" ? Zt(ce, Q) : a = Q, Q.style.setProperty("max-height", "500px"), Q.style.setProperty("min-height", "37px"), Q.style.setProperty("width", "100%"), Q.style.setProperty("display", "flex"), Q.style.setProperty("flex-direction", "column"), Q.style.setProperty("justify-content", "start");
    var W = n;
    return typeof W == "function" ? Zt(W, R) : n = R, R.style.setProperty("width", "100%"), L(R, g(yt, {
      get each() {
        return _().getVirtualItems();
      },
      get fallback() {
        return g(khe, {
          get noDataMsg() {
            return e.noDataMsg;
          },
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (oe) => {
        const le = oe.index > $().length - 1, Fe = $()[oe.index], We = l(), St = !le && !!We && "id" in We && "data" in Fe && We.id === Fe.data.id;
        return g(Fh, {
          get children() {
            return [g(ri, {
              get when() {
                return "title" in Fe;
              },
              get children() {
                return g(_he, {
                  item: Fe
                });
              }
            }), g(ri, {
              get when() {
                return "data" in Fe;
              },
              get children() {
                return g(xhe, {
                  item: oe,
                  isLoader: le,
                  isSelected: St,
                  get index() {
                    return oe.index;
                  },
                  get hasMore() {
                    return e.hasMore;
                  },
                  get showOverflow() {
                    return e.showOverflow;
                  },
                  onClick: () => {
                    le || (d(Fe.data), u(Fe.allItemsIdx), v(Fe.data), r.hide());
                  },
                  setLastIndex: f,
                  get children() {
                    return e.displayAccessor(Fe.data, !0);
                  }
                });
              }
            })];
          }
        });
      }
    })), se((oe) => {
      var le = e.forceLabelSize && !e.invalid ? -20 : e.invalid ? -18 : 0, Fe = e.disabled ?? !1, We = e.placeholder ?? void 0, St = e.disabled ?? !1, bt = !!(e.invalid ?? !1), Ct = !!(e.disabled ?? !1), _t = !l() && i.value === "", G = e.required, M = !!e.forceLabelSize, ue = !e.isLoading, ie = !!e.isLoading, De = o() ? "chevron-up" : "chevron-down", je = `${_().getTotalSize()}px`;
      return le !== oe.e && (D.distance = oe.e = le), Fe !== oe.t && (D.disabled = oe.t = Fe), We !== oe.a && (T.placeholder = oe.a = We), St !== oe.o && (T.disabled = oe.o = St), bt !== oe.i && T.classList.toggle("invalid", oe.i = bt), Ct !== oe.n && T.classList.toggle("disabled", oe.n = Ct), _t !== oe.s && T.classList.toggle("placeholder", oe.s = _t), G !== oe.h && (T.required = oe.h = G), M !== oe.r && I.classList.toggle("h-[21px]", oe.r = M), ue !== oe.d && j.classList.toggle("hidden", oe.d = ue), ie !== oe.l && Z.classList.toggle("hidden", oe.l = ie), De !== oe.u && (te.name = oe.u = De), je !== oe.c && ((oe.c = je) != null ? R.style.setProperty("height", je) : R.style.removeProperty("height")), oe;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0,
      r: void 0,
      d: void 0,
      l: void 0,
      u: void 0,
      c: void 0
    }), se(() => T.value = e.searchText), x;
  })();
}, khe = (e) => g(H, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return (() => {
      var t = mhe();
      return t._$owner = Ve(), L(t, () => e.noDataMsg ? e.noDataMsg : "No data found"), t;
    })();
  },
  get children() {
    var t = phe();
    return t._$owner = Ve(), t;
  }
}), _he = (e) => (() => {
  var t = ghe();
  return t._$owner = Ve(), L(t, () => e.item.title), t;
})(), xhe = (e) => (() => {
  var t = vhe();
  return Zt((r) => {
    e.isLoader && e.index > 0 && e.setLastIndex(r);
  }, t), t.$$click = () => e.onClick(), t.style.setProperty("width", "100%"), t.style.setProperty("white-space", "normal"), t._$owner = Ve(), L(t, (() => {
    var r = At(() => !!e.isLoader);
    return () => r() ? At(() => !!e.hasMore)() ? yhe() : bhe() : (() => {
      var n = whe();
      return L(n, () => e.children), se((i) => {
        var a = !e.showOverflow, o = !e.showOverflow, s = !e.showOverflow, l = !!e.showOverflow;
        return a !== i.e && n.classList.toggle("overflow-hidden", i.e = a), o !== i.t && n.classList.toggle("overflow-ellipsis", i.t = o), s !== i.a && n.classList.toggle("whitespace-nowrap", i.a = s), l !== i.o && n.classList.toggle("whitespace-normal", i.o = l), i;
      }, {
        e: void 0,
        t: void 0,
        a: void 0,
        o: void 0
      }), n;
    })();
  })()), se((r) => {
    var n = !!e.isSelected, i = `${e.item.size}px`;
    return n !== r.e && t.classList.toggle("selected", r.e = n), i !== r.t && ((r.t = i) != null ? t.style.setProperty("min-height", i) : t.style.removeProperty("min-height")), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
Rs(["click"]);
const She = ".invalid::part(base){--tw-border-opacity: 1;border-color:rgb(248,113,113,var(--tw-border-opacity));border-width:2px}.input::part(base){border-radius:var(--photon-border-radius, .5rem)}.input::part(base):hover{cursor:pointer}.input::part(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.input{--sl-input-required-content-color: #f87171;--sl-input-label-font-size-medium: .875rem;--sl-input-label-color: #374151}.input::part(form-control-label){padding-bottom:.5rem}.disabled::part(base):hover{cursor:not-allowed}.selected::part(base){--tw-bg-opacity: 1;background-color:rgb(49,130,206,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(255,255,255,var(--tw-text-opacity))}.default::part(base):hover{--tw-bg-opacity: 1;background-color:rgb(229,231,235,var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity))}.default::part(label){width:100%;overflow:hidden}.group-member::part(base){padding-left:1rem;font-weight:500}.group::part(base){background:#d1e9ff;padding-top:.25rem;padding-bottom:.25rem;--tw-text-opacity: 1;color:rgb(31,41,55,var(--tw-text-opacity));font-size:.75rem;font-weight:600}.dropdown::part(panel){border-radius:var(--photon-border-radius, .5rem)}.dropdown-container{border-radius:var(--photon-border-radius, .5rem)}";
var Che = /* @__PURE__ */ ae('<div slot=suffix class=flex><sl-icon class="text-gray-400 hover:text-gray-600"name=x-circle-fill>', !0, !1, !1), Ehe = /* @__PURE__ */ ae('<div><style></style><style></style><style></style><style></style><sl-dropdown class="dropdown relative"hoist><sl-input slot=trigger autocomplete=off size=medium class=input><p slot=help-text class="text-red-400 pt-1 font-sans"></p><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div><div slot=suffix class=flex><sl-icon></sl-icon></div></sl-input><div class="border border-gray-200 dropdown-container overflow-hidden relative"><div class="bg-white overflow-x-hidden overflow-y-auto relative"><div>', !0, !1, !1), Ahe = /* @__PURE__ */ ae('<sl-menu-item><p class="text-center text-gray-400 italic">Loading...', !0, !1, !1), gS = /* @__PURE__ */ ae("<sl-menu-item>", !0, !1, !1), The = /* @__PURE__ */ ae("<sl-menu-item class=group>", !0, !1, !1), Ohe = /* @__PURE__ */ ae('<p class="text-center text-gray-400 italic">Loading...'), Ihe = /* @__PURE__ */ ae('<p class="text-center text-gray-400 italic">Nothing more to load'), Phe = /* @__PURE__ */ ae("<p>");
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const Nhe = (e) => {
  let t, r, n, i, a;
  e.actionRef && (e.actionRef.clear = () => {
    d(void 0), u(-1), i.value = "", p(""), b();
  });
  const [o, s] = V(!1), [l, d] = V(void 0), [c, u] = V(-1), [h, f] = V(), p = Nf(async (S) => {
    e.onSearchChange && await e.onSearchChange(S);
  }, 250), m = new IntersectionObserver(async (S) => {
    S?.at(-1)?.isIntersecting && e.hasMore && e.fetchMore && await e.fetchMore();
  });
  fe(() => {
    e.data.length === 0 && d(void 0);
  }), fe(() => {
    h() && m.observe(h());
  });
  const y = (S) => {
    if (S)
      return e.helpText ? e.helpText : e.required ? "Please select data..." : void 0;
  }, v = (S) => {
    const A = new CustomEvent("photon-data-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        data: S
      }
    });
    t?.dispatchEvent(A);
  }, b = () => {
    const S = new CustomEvent("photon-data-unselected", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(S);
  };
  fe(() => {
    e.selectedData && d(e.selectedData), e.selectedData === void 0 && d(void 0);
  }), lr(() => {
    i && i.addEventListener("keydown", (S) => {
      (S.code == "Space" || S.key == " ") && S.stopImmediatePropagation();
    });
  });
  const $ = K(() => {
    const S = l();
    return S ? e.displayAccessor(S, !1) : e.placeholder ?? "Select data...";
  }), _ = K(() => e.groups ? e.groups.map((S) => {
    const A = e.data.map((N, P) => ({
      data: N,
      allItemsIdx: P
    })).filter((N) => S.filter(N.data));
    return A.length > 0 ? [{
      title: S.label
    }, ...A] : [];
  }).flat() : e.data.map((S, A) => ({
    data: S,
    allItemsIdx: A
  }))), x = K(() => sv({
    count: _().length,
    getScrollElement: () => n ?? null,
    estimateSize: () => 36.8,
    overscan: 100
  }));
  return (() => {
    var S = Ehe(), A = S.firstChild, N = A.nextSibling, P = N.nextSibling, D = P.nextSibling, T = D.nextSibling, I = T.firstChild, j = I.firstChild, F = j.nextSibling, Z = F.firstChild, te = F.nextSibling, Y = te.firstChild, Q = I.nextSibling, R = Q.firstChild, re = R.firstChild, he = t;
    typeof he == "function" ? Zt(he, S) : t = S, L(A, Gn), L(N, Ro), L(P, Mo), L(D, She), Ue(T, "sl-show", async () => {
      s(!0), e.onOpen && await e.onOpen();
    }), Ue(T, "sl-hide", async () => {
      l() || (i.value = "", e.onHide && await e.onHide()), s(!1);
    });
    var ge = r;
    typeof ge == "function" ? Zt(ge, T) : r = T, T.style.setProperty("width", "100%"), T._$owner = Ve(), Ue(I, "sl-focus", (le) => {
      e.onInputFocus ? (e.onInputFocus(), le.stopImmediatePropagation()) : (r.children[1].style.width = `${i.clientWidth}px`, c() > 0 && x().scrollToIndex(c()));
    }), Ue(I, "click", async (le) => {
      le.preventDefault();
    }), Ue(I, "sl-input", (le) => {
      o() || r.show(), p(le.target.value);
    });
    var ce = i;
    typeof ce == "function" ? Zt(ce, I) : i = I, I._$owner = Ve(), L(j, () => y(e.invalid ?? !1)), Z._$owner = Ve(), L(I, g(H, {
      get when() {
        return e.clearable;
      },
      get children() {
        var le = Che(), Fe = le.firstChild;
        return Ue(Fe, "click", (We) => {
          We.stopImmediatePropagation(), d(void 0), u(-1), i.value = "", p(""), b(), r.hide();
        }), Fe._$owner = Ve(), se(() => le.classList.toggle("hidden", !!(e.isLoading || l() == null))), le;
      }
    }), te), Y._$owner = Ve();
    var W = a;
    typeof W == "function" ? Zt(W, R) : a = R, R.style.setProperty("max-height", "200px"), R.style.setProperty("min-height", "37px"), R.style.setProperty("width", "100%"), R.style.setProperty("display", "flex"), R.style.setProperty("flex-direction", "column"), R.style.setProperty("justify-content", "start");
    var oe = n;
    return typeof oe == "function" ? Zt(oe, re) : n = re, re.style.setProperty("width", "100%"), L(re, g(yt, {
      get each() {
        return x().getVirtualItems();
      },
      get fallback() {
        return g(Dhe, {
          get noDataMsg() {
            return e.noDataMsg;
          },
          get isLoading() {
            return e.isLoading;
          }
        });
      },
      children: (le) => {
        const Fe = le.index > _().length - 1, We = _()[le.index], St = l(), bt = !Fe && !!St && "id" in St && "data" in We && St.id === We.data.id;
        return g(Fh, {
          get children() {
            return [g(ri, {
              get when() {
                return "title" in We;
              },
              get children() {
                return g(Mhe, {
                  item: We
                });
              }
            }), g(ri, {
              get when() {
                return "data" in We;
              },
              get children() {
                return g(Rhe, {
                  item: le,
                  isLoader: Fe,
                  isSelected: bt,
                  get index() {
                    return le.index;
                  },
                  get hasMore() {
                    return e.hasMore;
                  },
                  get showOverflow() {
                    return e.showOverflow;
                  },
                  onClick: () => {
                    Fe || (d(We.data), u(We.allItemsIdx), i.value = "", p(""), v(We.data), r.hide());
                  },
                  setLastIndex: f,
                  get children() {
                    return e.displayAccessor(We.data, !0);
                  }
                });
              }
            })];
          }
        });
      }
    })), se((le) => {
      var Fe = e.forceLabelSize && !e.invalid ? -20 : e.invalid ? -18 : 0, We = e.disabled ?? !1, St = e.label, bt = $(), Ct = e.disabled ?? !1, _t = !!(e.invalid ?? !1), G = !!(e.disabled ?? !1), M = !l() && i.value === "", ue = e.required, ie = !!e.forceLabelSize, De = !e.isLoading, je = !!e.isLoading, He = o() ? "chevron-up" : "chevron-down", _e = `${x().getTotalSize()}px`;
      return Fe !== le.e && (T.distance = le.e = Fe), We !== le.t && (T.disabled = le.t = We), St !== le.a && (I.label = le.a = St), bt !== le.o && (I.placeholder = le.o = bt), Ct !== le.i && (I.disabled = le.i = Ct), _t !== le.n && I.classList.toggle("invalid", le.n = _t), G !== le.s && I.classList.toggle("disabled", le.s = G), M !== le.h && I.classList.toggle("placeholder", le.h = M), ue !== le.r && (I.required = le.r = ue), ie !== le.d && j.classList.toggle("h-[21px]", le.d = ie), De !== le.l && F.classList.toggle("hidden", le.l = De), je !== le.u && te.classList.toggle("hidden", le.u = je), He !== le.c && (Y.name = le.c = He), _e !== le.w && ((le.w = _e) != null ? re.style.setProperty("height", _e) : re.style.removeProperty("height")), le;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0,
      s: void 0,
      h: void 0,
      r: void 0,
      d: void 0,
      l: void 0,
      u: void 0,
      c: void 0,
      w: void 0
    }), S;
  })();
}, Dhe = (e) => g(H, {
  get when() {
    return e.isLoading;
  },
  get fallback() {
    return (() => {
      var t = gS();
      return t._$owner = Ve(), L(t, () => e.noDataMsg ? e.noDataMsg : "No data found"), t;
    })();
  },
  get children() {
    var t = Ahe();
    return t._$owner = Ve(), t;
  }
}), Mhe = (e) => (() => {
  var t = The();
  return t._$owner = Ve(), L(t, () => e.item.title), t;
})(), Rhe = (e) => (() => {
  var t = gS();
  return Zt((r) => {
    e.isLoader && e.index > 0 && e.setLastIndex(r);
  }, t), t.$$click = () => e.onClick(), t.style.setProperty("width", "100%"), t._$owner = Ve(), L(t, (() => {
    var r = At(() => !!e.isLoader);
    return () => r() ? At(() => !!e.hasMore)() ? Ohe() : Ihe() : (() => {
      var n = Phe();
      return L(n, () => e.children), se((i) => {
        var a = !e.showOverflow, o = !e.showOverflow, s = !e.showOverflow, l = !!e.showOverflow;
        return a !== i.e && n.classList.toggle("overflow-hidden", i.e = a), o !== i.t && n.classList.toggle("overflow-ellipsis", i.t = o), s !== i.a && n.classList.toggle("whitespace-nowrap", i.a = s), l !== i.o && n.classList.toggle("whitespace-normal", i.o = l), i;
      }, {
        e: void 0,
        t: void 0,
        a: void 0,
        o: void 0
      }), n;
    })();
  })()), se((r) => {
    var n = e.isSelected ? "selected default" : "default", i = `${e.item.size}px`;
    return n !== r.e && ka(t, r.e = n), i !== r.t && ((r.t = i) != null ? t.style.setProperty("min-height", i) : t.style.removeProperty("min-height")), r;
  }, {
    e: void 0,
    t: void 0
  }), t;
})();
Rs(["click"]);
const Lhe = Ie`
  fragment CatalogFields on Catalog {
    id
  }
`, Fhe = { CatalogFields: Lhe }, jhe = Ie`
  fragment CatalogTreatmentsFields on Catalog {
    id
    treatments {
      id
      name
    }
    templates {
      id
      name
      daysSupply
      dispenseAsWritten
      dispenseQuantity
      dispenseUnit
      instructions
      notes
      fillsAllowed
      treatment {
        id
        name
      }
      isPrivate
    }
  }
`, zhe = { CatalogTreatmentsFields: jhe }, Vhe = () => {
  const [e, t] = _f({
    catalogs: {
      data: [],
      errors: [],
      isLoading: !1
    },
    catalog: {
      data: void 0,
      errors: [],
      isLoading: !1
    }
  });
  return {
    store: e,
    actions: {
      getCatalogs: async (i) => {
        t("catalogs", {
          ...e.catalogs,
          isLoading: !0
        });
        const { data: a, errors: o } = await i.clinical.catalog.getCatalogs({
          fragment: Fhe
        });
        t("catalogs", {
          ...e.catalogs,
          isLoading: !1,
          data: a.catalogs,
          errors: o
        });
      },
      getCatalog: async (i, a) => {
        t("catalog", {
          ...e.catalog,
          isLoading: !0
        });
        const { data: o, errors: s } = await i.clinical.catalog.getCatalog({
          id: a,
          fragment: zhe
        });
        t("catalog", {
          ...e.catalog,
          isLoading: !1,
          data: o.catalog,
          errors: s
        });
      }
    }
  };
}, vS = Vhe();
var Uhe = /* @__PURE__ */ ae("<strong class=font-extrabold>"), qhe = /* @__PURE__ */ ae("<div><p>"), yS = /* @__PURE__ */ ae('<p class="text-xs text-red-500 mt-1 italic">'), Bhe = /* @__PURE__ */ ae("<div><div></div><div> <!>, <!> <!> supply, <!> <!>, "), Hhe = /* @__PURE__ */ ae("<span class=text-blue-600>(<!>): "), Whe = /* @__PURE__ */ ae("<div>");
function Qhe(e) {
  return !e || e.length === 0 ? {} : e.reduce((t, r) => {
    if (!r.treatmentIds) return t;
    for (const n of r.treatmentIds)
      t[n] = r.reason;
    return t;
  }, {});
}
function $8(e, t) {
  return e ? e in t ? {
    disabled: !0,
    disableReason: t[e]
  } : {
    disabled: !1
  } : {
    disabled: !1
  };
}
function lv(e, t, r) {
  const n = new CustomEvent(t, {
    composed: !0,
    bubbles: !0,
    detail: r
  });
  e?.dispatchEvent(n);
}
function Khe(e, t, r) {
  lv(e, "photon-treatment-selected", {
    data: t,
    catalogId: r
  });
}
function Ghe(e) {
  lv(e, "photon-treatment-unselected");
}
function Jn(e, t) {
  lv(e, "photon-search-text-changed", {
    text: t
  });
}
const Zhe = async (e, t) => await e.query({
  query: jP,
  variables: {
    filter: {
      term: t
    }
  },
  fetchPolicy: "no-cache"
});
async function Yhe(e, t) {
  return (await Zhe(e, t))?.data?.treatments?.map((n) => ({
    ...n,
    isOffCatalog: !0
  })) ?? [];
}
function Jhe(e, t, r) {
  const {
    store: n
  } = vS;
  if (!n.catalog.data) return [];
  const i = [...e.offCatalogOption ? [e.offCatalogOption] : [], ...n.catalog.data ? n.catalog.data.templates.map((o) => o) : [], ...n.catalog.data ? n.catalog.data.treatments.map((o) => o) : [], ...r], a = t.toLowerCase().split(/\s+/);
  return a.length === 0 ? i : i.filter((o) => {
    const s = "treatment" in o ? `${o?.name?.toLowerCase() || ""} ${o.treatment.name.toLowerCase()} ` : o.name.toLowerCase();
    return a.every((l) => s.includes(l));
  });
}
const Dh = (e, t) => {
  const i = ((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))(t).split(" ").filter((s) => s.length > 0), a = new RegExp(`(${i.join("|")})`, "gi");
  return e.split(a).map((s) => i.some((l) => l.toLowerCase() === s?.toLowerCase()) ? (() => {
    var l = Uhe();
    return L(l, s), l;
  })() : s);
};
function Xhe(e, t, r, n = !1, i) {
  return t ? (() => {
    var a = qhe(), o = a.firstChild;
    return ka(a, `my-1 ${n ? "opacity-50 cursor-not-allowed" : ""}`), ka(o, `text-sm whitespace-normal leading-snug ${n ? "text-gray-500" : ""}`), L(o, () => Dh(e.name, r)), L(a, n && i && (() => {
      var s = yS();
      return L(s, i), s;
    })(), null), a;
  })() : e.name || "";
}
function efe(e, t, r, n = !1, i) {
  if (t) {
    const a = e.fillsAllowed ? e.fillsAllowed - 1 : 0;
    return (() => {
      var o = Bhe(), s = o.firstChild, l = s.nextSibling, d = l.firstChild, c = d.nextSibling, u = c.nextSibling, h = u.nextSibling, f = h.nextSibling, p = f.nextSibling, m = p.nextSibling, y = m.nextSibling, v = y.nextSibling, b = v.nextSibling;
      return b.nextSibling, ka(o, `my-1 ${n ? "opacity-50 cursor-not-allowed" : ""}`), ka(s, `text-sm whitespace-normal font-medium mb-1 ${n ? "text-gray-500" : ""}`), L(s, (() => {
        var $ = At(() => !!e.name);
        return () => $() ? (() => {
          var _ = Hhe(), x = _.firstChild, S = x.nextSibling;
          return S.nextSibling, L(_, () => Dh(e.name, r), S), _;
        })() : "";
      })(), null), L(s, () => Dh(e.treatment.name, r), null), ka(l, `text-xs truncate ${n ? "text-gray-400" : "text-gray-500"}`), L(l, () => e.dispenseQuantity, d), L(l, () => e.dispenseUnit, c), L(l, () => e.daysSupply, h), L(l, () => e.daysSupply === 1 ? "day" : "days", p), L(l, a, y), L(l, a === 1 ? "refill" : "refills", b), L(l, () => e.instructions, null), L(o, n && i && (() => {
        var $ = yS();
        return L($, i), $;
      })(), null), o;
    })();
  }
  return e.treatment.name;
}
function Pp(e) {
  return [{
    label: "Off Catalog",
    filter: (t) => t && typeof t == "object" && e.offCatalogOption && t.id === e.offCatalogOption.id
  }, {
    label: "Personal Templates",
    filter: (t) => t && typeof t == "object" && "treatment" in t && t.isPrivate
  }, {
    label: "Organization Templates",
    filter: (t) => t && typeof t == "object" && "treatment" in t && !t.isPrivate
  }, {
    label: "Organization Catalog",
    filter: (t) => t && typeof t == "object" && "name" in t && !("treatment" in t) && !("isOffCatalog" in t)
  }, {
    label: "All Treatments",
    filter: (t) => t && typeof t == "object" && !("treatment" in t) && "isOffCatalog" in t
  }];
}
const tfe = (e) => {
  let t;
  const r = Rn(), {
    store: n,
    actions: i
  } = vS, [a, o] = V([]), [s, l] = V(!1), [d, c] = V(!1), u = K(() => Qhe(e.disableList));
  lr(async () => {
    e.catalogId ? await i.getCatalog(r.getSDK(), e.catalogId) : (await i.getCatalogs(r.getSDK()), n.catalogs.data && n.catalogs.data.length > 0 && await i.getCatalog(r.getSDK(), n.catalogs.data[0].id));
  }), fe(() => {
    n.catalog.data && h(e.searchText);
  });
  const h = async (m) => {
    l(!0);
    const y = m?.length >= 3 && // 3 min chars for smaller responses
    e.allowOffCatalogSearch ? await Yhe(r.sdk.apolloClinical, m) : (
      // Set treatment options to empty array if search term is empty
      []
    ), v = Jhe(e, e.searchText, y);
    o(v), l(!1);
  }, f = (m, y) => {
    const v = "treatment" in m ? m.treatment.id : m.id, {
      disabled: b,
      disableReason: $
    } = $8(v, u());
    return m && "__typename" in m && m.__typename == "PrescriptionTemplate" ? efe(m, y, e.searchText, b, $) : Xhe(m, y, e.searchText, b, $);
  }, p = window.innerWidth < 768;
  return (() => {
    var m = Whe();
    Ue(m, "photon-data-unselected", () => {
      Ghe(t), Jn(t, "");
    }), Ue(m, "photon-data-selected", (v) => {
      c(!1);
      const b = v.detail.data;
      let $;
      if ("treatment" in b ? $ = b.treatment.id : "id" in b && ($ = b.id), $) {
        const {
          disabled: _
        } = $8($, u());
        if (_)
          return;
      }
      Khe(t, b, n.catalog.data?.id || ""), "treatment" in b ? Jn(t, b.treatment.name) : Jn(t, b.name);
    });
    var y = t;
    return typeof y == "function" ? Zt(y, m) : t = m, L(m, g(H, {
      get when() {
        return d();
      },
      get children() {
        return g(ihe, {
          get data() {
            return a();
          },
          get groups() {
            return Pp(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading || s();
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          get searchText() {
            return e.searchText;
          },
          onSearchChange: (v) => {
            Jn(t, v);
          },
          onHide: () => Jn(t, ""),
          get helpText() {
            return e.helpText;
          },
          get open() {
            return d();
          },
          onClose: () => {
            c(!1), Jn(t, "");
          }
        });
      }
    }), null), L(m, g(H, {
      get when() {
        return p && !d();
      },
      get children() {
        return g(Nhe, {
          get data() {
            return a();
          },
          get groups() {
            return Pp(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading;
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          onSearchChange: (v) => Jn(t, v),
          onHide: () => Jn(t, ""),
          get helpText() {
            return e.helpText;
          },
          onInputFocus: () => {
            c(!0), e.selected?.name && Jn(t, e.selected.name);
          }
        });
      }
    }), null), L(m, g(H, {
      when: !p,
      get children() {
        return g($he, {
          get data() {
            return a();
          },
          get groups() {
            return Pp(e);
          },
          get label() {
            return e.label;
          },
          get disabled() {
            return e.disabled;
          },
          get required() {
            return e.required ?? !1;
          },
          placeholder: "Type medication",
          get invalid() {
            return e.invalid ?? !1;
          },
          get isLoading() {
            return n.catalogs.isLoading || n.catalog.isLoading || s();
          },
          hasMore: !1,
          get selectedData() {
            return e.selected ?? e.offCatalogOption;
          },
          displayAccessor: f,
          get searchText() {
            return e.searchText;
          },
          onSearchChange: (v) => {
            Jn(t, v);
          },
          onHide: () => Jn(t, ""),
          get helpText() {
            return e.helpText;
          },
          onInputFocus: () => {
            e.selected?.name && Jn(t, e.selected.name);
          }
        });
      }
    }), null), m;
  })();
};
Dn("photon-medication-search", {
  label: void 0,
  required: !1,
  invalid: !1,
  helpText: void 0,
  catalogId: void 0,
  allowOffCatalogSearch: !0,
  disabled: !1,
  formName: void 0,
  selected: void 0,
  offCatalogOption: void 0,
  searchText: "",
  disableList: void 0
}, tfe);
const rfe = ".dropdown::part(panel){width:480px}@media(max-width:768px){.dropdown::part(panel){max-width:100vw;width:100vw}}";
var nfe = /* @__PURE__ */ ae('<p class="text-lg font-semibold mt-0 mb-4">Add Medication History'), ife = /* @__PURE__ */ ae('<div class="flex items-center pb-2"><p class="text-gray-700 text-sm font-sans">Search for Treatment'), afe = /* @__PURE__ */ ae('<sl-dropdown class="w-full p-0 dropdown"><sl-input placeholder="Type medication name"autocomplete=off class="border border-none p-0"size=medium clearable slot=trigger><div slot=suffix class=flex><sl-spinner slot=suffix></sl-spinner></div></sl-input><sl-menu>', !0, !1, !1), ofe = /* @__PURE__ */ ae('<div class="mt-5 flex gap-4 justify-end">'), sfe = /* @__PURE__ */ ae("<div><style></style><style></style><style></style><style></style><style>"), lfe = /* @__PURE__ */ ae("<sl-menu-item disabled>Type at least 3 characters", !0, !1, !1), dfe = /* @__PURE__ */ ae("<sl-menu-item>", !0, !1, !1), cfe = /* @__PURE__ */ ae("<sl-menu-item disabled>No results found", !0, !1, !1);
Ii("https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.4.0/dist/");
const ufe = (e) => {
  let t;
  const r = Rn(), [n, i] = V(!1), [a, o] = V(!1), [s, l] = V(""), [d, c] = V([]), [u, h] = V(void 0), f = Nf(async ($) => {
    if (!$ || $.length < 3) {
      c([]);
      return;
    }
    try {
      i(!0);
      const {
        data: _
      } = await r.sdk.apolloClinical.query({
        query: FP,
        variables: {
          filter: {
            term: $
          }
        },
        fetchPolicy: "no-cache"
      });
      c(_.treatments || []);
    } catch (_) {
      console.error("Search error:", _);
    } finally {
      i(!1);
    }
  }, 300);
  fe(() => {
    f(s());
  });
  const p = () => {
    const $ = new CustomEvent("photon-medication-selected", {
      composed: !0,
      bubbles: !0,
      detail: {
        medication: u()
      }
    });
    t?.dispatchEvent($);
  }, m = () => {
    const $ = new CustomEvent("photon-medication-closed", {
      composed: !0,
      bubbles: !0
    });
    t?.dispatchEvent($);
  }, y = async () => {
    o(!0), p();
  };
  fe(() => {
    e.open || (o(!1), l(""));
  });
  const v = () => {
    m();
  }, b = ($) => {
    h($), l($.name);
  };
  return (() => {
    var $ = sfe(), _ = $.firstChild, x = _.nextSibling, S = x.nextSibling, A = S.nextSibling, N = A.nextSibling, P = t;
    return typeof P == "function" ? Zt(P, $) : t = $, L(_, Fo), L(x, Gn), L(S, Ro), L(A, Mo), L(N, rfe), L($, g(zs, {
      get open() {
        return e.open;
      },
      onClose: v,
      size: "lg",
      position: "center",
      get children() {
        return [nfe(), ife(), (() => {
          var D = afe(), T = D.firstChild, I = T.firstChild, j = I.firstChild, F = T.nextSibling;
          return D._$owner = Ve(), Ue(T, "keydown", (Z) => {
            (Z.code === "Space" || Z.key === " ") && (Z.preventDefault(), Z.stopPropagation(), l(s() + " "));
          }), Ue(T, "sl-input", (Z) => {
            l(Z.target.value);
          }), T._$owner = Ve(), j._$owner = Ve(), F._$owner = Ve(), L(F, (() => {
            var Z = At(() => s()?.length < 3);
            return () => Z() ? (() => {
              var te = lfe();
              return te._$owner = Ve(), te;
            })() : At(() => d().length > 0)() ? d().map((te) => (() => {
              var Y = dfe();
              return Y.$$click = () => b(te), Y._$owner = Ve(), L(Y, () => Dh(te.name, s())), Y;
            })()) : (() => {
              var te = cfe();
              return te._$owner = Ve(), te;
            })();
          })()), se(() => I.classList.toggle("hidden", !n())), se(() => T.value = s()), D;
        })(), (() => {
          var D = ofe();
          return L(D, g(xt, {
            variant: "secondary",
            onClick: v,
            children: "Cancel"
          }), null), L(D, g(xt, {
            onClick: y,
            get disabled() {
              return !u() || a();
            },
            get loading() {
              return a();
            },
            children: "Select Medication"
          }), null), D;
        })()];
      }
    }), null), $;
  })();
};
Dn("photon-add-medication-history-dialog", {
  open: {
    value: !1,
    reflect: !0,
    notify: !1,
    attribute: "open",
    parse: !0
  }
}, ufe);
Rs(["click"]);
var hfe = /* @__PURE__ */ ae("<div><style>");
const ffe = (e) => (() => {
  var t = hfe(), r = t.firstChild;
  return L(r, Fo), L(t, g(M_, {
    get patientId() {
      return e.patientId;
    },
    enableLinks: !1,
    enableRefillButton: !1
  }), null), t;
})();
Dn("photon-med-history", {
  patientId: ""
}, ffe);
function yg(e) {
  this.message = e;
}
yg.prototype = new Error(), yg.prototype.name = "InvalidCharacterError";
var k8 = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new yg("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, a = 0, o = ""; n = t.charAt(a++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function pfe(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return (function(r) {
      return decodeURIComponent(k8(r).replace(/(.)/g, (function(n, i) {
        var a = i.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      })));
    })(t);
  } catch {
    return k8(t);
  }
}
function Mh(e) {
  this.message = e;
}
function mfe(e, t) {
  if (typeof e != "string") throw new Mh("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(pfe(e.split(".")[r]));
  } catch (n) {
    throw new Mh("Invalid token specified: " + n.message);
  }
}
Mh.prototype = new Error(), Mh.prototype.name = "InvalidTokenError";
var gfe = /* @__PURE__ */ ae(`<div><style></style><photon-dialog label="Lose Unsaved Prescription?"confirm-text="Yes, Continue"cancel-text="Keep Editing"width=500px><p class="font-sans text-lg xs:text-base">You have a prescription "<!>" that hasn't been added. Please add it or continue.</p></photon-dialog><photon-dialog label="Save prescriptions without an order?"confirm-text="Save and create order"cancel-text="Yes, save only"width=500px><p class="font-sans text-lg xs:text-base">You're about to save prescriptions without creating a pharmacy order. You can create an order now, or at a later date.`, !0, !1, !1), vfe = /* @__PURE__ */ ae('<div class="w-full h-full bg-[#F9FAFB]"><photon-prescribe-workflow hide-submit=true>', !0, !1, !1);
const yfe = (e) => e().addToTemplates && e().addToTemplates.value != !1 || e().daysSupply?.value || e().dispenseAsWritten && e().dispenseAsWritten?.value != !1 || e().dispenseQuantity?.value || e().dispenseUnit?.value || e().doNotFillBeforeDate?.value || e().instructions?.value || e().notes?.value || e().refills?.value || e().treatment?.value, bfe = (e) => !!e?.id, wfe = (e) => e === Q1.FulfillmentType.PickUp || e === Q1.FulfillmentType.MailOrder, $fe = (e, t) => wfe(e) && !bfe(t), kfe = (e) => {
  let t;
  const r = Rn(), [n, i] = V(!1), [a, o] = V(!1), [s, l] = V(), [d, c] = V(!1), [u, h] = V(!1), [f, p] = V(!1), [m, y] = V(!1), {
    actions: v
  } = Of, [b, $] = V(!1), [_, x] = V(0);
  lr(async () => {
    const F = await r.getSDK().authentication.getAccessToken();
    mfe(F).permissions?.includes("write:prescription") && o(!0);
  });
  const S = (F, Z, te) => {
    const Y = new CustomEvent("photon-prescriptions-created", {
      composed: !0,
      bubbles: !0,
      detail: {
        patientId: te,
        prescriptionIds: Z,
        createOrder: F
      }
    });
    t?.dispatchEvent(Y);
  }, A = () => {
    const F = new CustomEvent("photon-prescriptions-closed", {
      composed: !0,
      bubbles: !0,
      detail: {}
    });
    t?.dispatchEvent(F);
  }, N = () => {
    const F = s()?.fulfillmentType?.value, Z = s()?.address?.value ?? s()?.patient?.value?.address;
    if ($fe(F, Z))
      return y(!1), rr({
        status: "error",
        header: "Address required",
        body: "Please add a patient address to place a local pickup or mail order."
      });
    h(!0), y(!0);
  }, P = () => {
    c(!1), N();
  }, D = () => c(!1), T = () => {
    if (!n())
      return rr({
        status: "info",
        body: "You need to add prescription(s) before sending."
      });
    if (!a())
      return rr({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    if (s()?.treatment?.value?.name)
      return c(!0);
    N();
  }, I = () => {
    if (!n())
      return rr({
        status: "info",
        body: "You need to add prescription(s) before sending."
      });
    if (!a())
      return rr({
        status: "error",
        header: "Unauthorized",
        body: "You do not have permission to prescribe"
      });
    p(!0);
  }, j = K(() => !b() || _() < 1);
  return (() => {
    var F = gfe(), Z = F.firstChild, te = Z.nextSibling, Y = te.firstChild, Q = Y.firstChild, R = Q.nextSibling;
    R.nextSibling;
    var re = te.nextSibling, he = t;
    return typeof he == "function" ? Zt(he, F) : t = F, L(Z, Fo), Ue(te, "photon-dialog-alt", D), Ue(te, "photon-dialog-canceled", D), Ue(te, "photon-dialog-confirmed", P), te._$owner = Ve(), L(Y, () => s()?.treatment?.value?.name, R), Ue(re, "photon-dialog-alt", () => {
      p(!1), y(!0);
    }), Ue(re, "photon-dialog-canceled", () => {
      p(!1);
    }), Ue(re, "photon-dialog-confirmed", () => {
      p(!1), N();
    }), re._$owner = Ve(), L(F, g(fS, {
      closeTitle: "Lose unsaved prescriptions?",
      closeBody: "You will not be able to recover unsaved prescriptions.",
      onClosed: () => {
        A(), v.clearSelectedPatient();
      },
      checkShouldWarn: () => yfe(s),
      title: "New prescriptions",
      titleIconName: "prescription",
      get footer() {
        return At(() => !!j())() ? null : At(() => !!e.enableOrder)() ? g(xt, {
          class: "w-full xs:w-fit",
          size: "lg",
          get loading() {
            return m();
          },
          onClick: T,
          children: "Send"
        }) : [g(xt, {
          class: "w-full xs:w-fit",
          size: "lg",
          get loading() {
            return At(() => !!m())() && u();
          },
          onClick: T,
          children: "Save and create order"
        }), g(xt, {
          class: "w-full xs:w-fit",
          size: "lg",
          variant: "secondary",
          get loading() {
            return At(() => !!m())() && !u();
          },
          onClick: I,
          children: "Save prescriptions"
        })];
      },
      get form() {
        return (() => {
          var ge = vfe(), ce = ge.firstChild;
          return Ue(ce, "photon-clinical-alert-cancel", (W) => {
            W.stopPropagation(), y(!1);
          }), Ue(ce, "photon-signature-attestation-canceled", () => {
            A(), v.clearSelectedPatient();
          }), Ue(ce, "photon-signature-attestation-agreed", () => {
            $(!0);
          }), Ue(ce, "photon-order-combine-error", (W) => {
            W.stopPropagation(), y(!1);
          }), Ue(ce, "photon-order-error", (W) => {
            W.stopPropagation(), y(!1);
          }), Ue(ce, "photon-prescriptions-created", (W) => {
            W.stopPropagation(), e.enableOrder || S(u(), W.detail.prescriptions.map((oe) => oe.id), s()?.patient?.value?.id);
          }), Ue(ce, "photon-draft-prescription-deleted", () => {
            x((W) => Math.max(0, W - 1));
          }), Ue(ce, "photon-draft-prescription-created", () => {
            x((W) => W + 1);
          }), Ue(ce, "photon-form-validate", (W) => {
            i(W.detail.canSubmit), l(W.detail.form);
          }), ce.setTriggerSubmit = y, ce._$owner = Ve(), se((W) => {
            var oe = e.hideTemplates, le = m(), Fe = e.patientId, We = e.templateIds, St = e.prescriptionIds, bt = e.weight, Ct = e.weightUnit, _t = e.externalOrderId, G = e.additionalNotes, M = e.enableMedHistory, ue = e.enableMedHistoryLinks, ie = e.enableMedHistoryRefillButton, De = e.enableOrder, je = e.enableLocalPickup, He = e.enableSendToPatient, _e = e.enableCombineAndDuplicate, ot = e.enableDeliveryPharmacies, Nt = e.enableCoverageCheck, ir = e.optionalPatientAddress, dr = e.pharmacyId, La = e.mailOrderIds, ze = m(), Be = e?.toastBuffer || 0;
            return oe !== W.e && (ce.hideTemplates = W.e = oe), le !== W.t && (ce.loading = W.t = le), Fe !== W.a && (ce.patientId = W.a = Fe), We !== W.o && (ce.templateIds = W.o = We), St !== W.i && (ce.prescriptionIds = W.i = St), bt !== W.n && (ce.weight = W.n = bt), Ct !== W.s && (ce.weightUnit = W.s = Ct), _t !== W.h && (ce.externalOrderId = W.h = _t), G !== W.r && (ce.additionalNotes = W.r = G), M !== W.d && (ce.enableMedHistory = W.d = M), ue !== W.l && (ce.enableMedHistoryLinks = W.l = ue), ie !== W.u && (ce.enableMedHistoryRefillButton = W.u = ie), De !== W.c && (ce.enableOrder = W.c = De), je !== W.w && (ce.enableLocalPickup = W.w = je), He !== W.m && (ce.enableSendToPatient = W.m = He), _e !== W.f && (ce.enableCombineAndDuplicate = W.f = _e), ot !== W.y && (ce.enableDeliveryPharmacies = W.y = ot), Nt !== W.g && (ce.enableCoverageCheck = W.g = Nt), ir !== W.p && (ce.optionalPatientAddress = W.p = ir), dr !== W.b && (ce.pharmacyId = W.b = dr), La !== W.T && (ce.mailOrderIds = W.T = La), ze !== W.A && (ce.triggerSubmit = W.A = ze), Be !== W.O && (ce.toastBuffer = W.O = Be), W;
          }, {
            e: void 0,
            t: void 0,
            a: void 0,
            o: void 0,
            i: void 0,
            n: void 0,
            s: void 0,
            h: void 0,
            r: void 0,
            d: void 0,
            l: void 0,
            u: void 0,
            c: void 0,
            w: void 0,
            m: void 0,
            f: void 0,
            y: void 0,
            g: void 0,
            p: void 0,
            b: void 0,
            T: void 0,
            A: void 0,
            O: void 0
          }), ge;
        })();
      }
    }), null), se((ge) => {
      var ce = d(), W = f();
      return ce !== ge.e && (te.open = ge.e = ce), W !== ge.t && (re.open = ge.t = W), ge;
    }, {
      e: void 0,
      t: void 0
    }), F;
  })();
};
Dn("photon-multirx-form-wrapper", {
  hideTemplates: !1,
  patientId: void 0,
  pharmacyId: void 0,
  templateIds: void 0,
  prescriptionIds: void 0,
  weight: void 0,
  weightUnit: "lbs",
  additionalNotes: void 0,
  enableLocalPickup: !1,
  enableSendToPatient: !1,
  enableDeliveryPharmacies: !0,
  enableMedHistory: !1,
  enableMedHistoryLinks: !1,
  enableMedHistoryRefillButton: !1,
  enableCombineAndDuplicate: !1,
  enableCoverageCheck: !1,
  mailOrderIds: void 0,
  enableOrder: !1,
  toastBuffer: 0,
  externalOrderId: void 0,
  optionalPatientAddress: !1
}, kfe);
